(function () {
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
var $parcel$global =
typeof globalThis !== 'undefined'
  ? globalThis
  : typeof self !== 'undefined'
  ? self
  : typeof window !== 'undefined'
  ? window
  : typeof global !== 'undefined'
  ? global
  : {};
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire94c2"];
if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire94c2"] = parcelRequire;
}
parcelRequire.register("cNQM9", function(module, exports) {
//! moment.js
//! version : 2.29.4
//! authors : Tim Wood, Iskren Chernev, Moment.js contributors
//! license : MIT
//! momentjs.com
(function(global, factory) {
    module.exports = factory();
})(this, function() {
    "use strict";
    var hookCallback;
    function hooks() {
        return hookCallback.apply(null, arguments);
    }
    // This is done to register the method called with moment()
    // without creating circular dependencies.
    function setHookCallback(callback) {
        hookCallback = callback;
    }
    function isArray(input) {
        return input instanceof Array || Object.prototype.toString.call(input) === "[object Array]";
    }
    function isObject(input) {
        // IE8 will treat undefined and null as object if it wasn't for
        // input != null
        return input != null && Object.prototype.toString.call(input) === "[object Object]";
    }
    function hasOwnProp(a, b) {
        return Object.prototype.hasOwnProperty.call(a, b);
    }
    function isObjectEmpty(obj) {
        if (Object.getOwnPropertyNames) return Object.getOwnPropertyNames(obj).length === 0;
        else {
            var k;
            for(k in obj){
                if (hasOwnProp(obj, k)) return false;
            }
            return true;
        }
    }
    function isUndefined(input) {
        return input === void 0;
    }
    function isNumber(input) {
        return typeof input === "number" || Object.prototype.toString.call(input) === "[object Number]";
    }
    function isDate(input) {
        return input instanceof Date || Object.prototype.toString.call(input) === "[object Date]";
    }
    function map(arr, fn) {
        var res = [], i, arrLen = arr.length;
        for(i = 0; i < arrLen; ++i)res.push(fn(arr[i], i));
        return res;
    }
    function extend(a, b) {
        for(var i in b)if (hasOwnProp(b, i)) a[i] = b[i];
        if (hasOwnProp(b, "toString")) a.toString = b.toString;
        if (hasOwnProp(b, "valueOf")) a.valueOf = b.valueOf;
        return a;
    }
    function createUTC(input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, true).utc();
    }
    function defaultParsingFlags() {
        // We need to deep clone this object.
        return {
            empty: false,
            unusedTokens: [],
            unusedInput: [],
            overflow: -2,
            charsLeftOver: 0,
            nullInput: false,
            invalidEra: null,
            invalidMonth: null,
            invalidFormat: false,
            userInvalidated: false,
            iso: false,
            parsedDateParts: [],
            era: null,
            meridiem: null,
            rfc2822: false,
            weekdayMismatch: false
        };
    }
    function getParsingFlags(m) {
        if (m._pf == null) m._pf = defaultParsingFlags();
        return m._pf;
    }
    var some;
    if (Array.prototype.some) some = Array.prototype.some;
    else some = function(fun) {
        var t = Object(this), len = t.length >>> 0, i;
        for(i = 0; i < len; i++){
            if (i in t && fun.call(this, t[i], i, t)) return true;
        }
        return false;
    };
    function isValid(m) {
        if (m._isValid == null) {
            var flags = getParsingFlags(m), parsedParts = some.call(flags.parsedDateParts, function(i) {
                return i != null;
            }), isNowValid = !isNaN(m._d.getTime()) && flags.overflow < 0 && !flags.empty && !flags.invalidEra && !flags.invalidMonth && !flags.invalidWeekday && !flags.weekdayMismatch && !flags.nullInput && !flags.invalidFormat && !flags.userInvalidated && (!flags.meridiem || flags.meridiem && parsedParts);
            if (m._strict) isNowValid = isNowValid && flags.charsLeftOver === 0 && flags.unusedTokens.length === 0 && flags.bigHour === undefined;
            if (Object.isFrozen == null || !Object.isFrozen(m)) m._isValid = isNowValid;
            else return isNowValid;
        }
        return m._isValid;
    }
    function createInvalid(flags) {
        var m = createUTC(NaN);
        if (flags != null) extend(getParsingFlags(m), flags);
        else getParsingFlags(m).userInvalidated = true;
        return m;
    }
    // Plugins that add properties should also add the key here (null value),
    // so we can properly clone ourselves.
    var momentProperties = hooks.momentProperties = [], updateInProgress = false;
    function copyConfig(to, from) {
        var i, prop, val, momentPropertiesLen = momentProperties.length;
        if (!isUndefined(from._isAMomentObject)) to._isAMomentObject = from._isAMomentObject;
        if (!isUndefined(from._i)) to._i = from._i;
        if (!isUndefined(from._f)) to._f = from._f;
        if (!isUndefined(from._l)) to._l = from._l;
        if (!isUndefined(from._strict)) to._strict = from._strict;
        if (!isUndefined(from._tzm)) to._tzm = from._tzm;
        if (!isUndefined(from._isUTC)) to._isUTC = from._isUTC;
        if (!isUndefined(from._offset)) to._offset = from._offset;
        if (!isUndefined(from._pf)) to._pf = getParsingFlags(from);
        if (!isUndefined(from._locale)) to._locale = from._locale;
        if (momentPropertiesLen > 0) for(i = 0; i < momentPropertiesLen; i++){
            prop = momentProperties[i];
            val = from[prop];
            if (!isUndefined(val)) to[prop] = val;
        }
        return to;
    }
    // Moment prototype object
    function Moment(config) {
        copyConfig(this, config);
        this._d = new Date(config._d != null ? config._d.getTime() : NaN);
        if (!this.isValid()) this._d = new Date(NaN);
        // Prevent infinite loop in case updateOffset creates new moment
        // objects.
        if (updateInProgress === false) {
            updateInProgress = true;
            hooks.updateOffset(this);
            updateInProgress = false;
        }
    }
    function isMoment(obj) {
        return obj instanceof Moment || obj != null && obj._isAMomentObject != null;
    }
    function warn(msg) {
        if (hooks.suppressDeprecationWarnings === false && typeof console !== "undefined" && console.warn) console.warn("Deprecation warning: " + msg);
    }
    function deprecate(msg, fn) {
        var firstTime = true;
        return extend(function() {
            if (hooks.deprecationHandler != null) hooks.deprecationHandler(null, msg);
            if (firstTime) {
                var args = [], arg, i, key, argLen = arguments.length;
                for(i = 0; i < argLen; i++){
                    arg = "";
                    if (typeof arguments[i] === "object") {
                        arg += "\n[" + i + "] ";
                        for(key in arguments[0])if (hasOwnProp(arguments[0], key)) arg += key + ": " + arguments[0][key] + ", ";
                        arg = arg.slice(0, -2); // Remove trailing comma and space
                    } else arg = arguments[i];
                    args.push(arg);
                }
                warn(msg + "\nArguments: " + Array.prototype.slice.call(args).join("") + "\n" + new Error().stack);
                firstTime = false;
            }
            return fn.apply(this, arguments);
        }, fn);
    }
    var deprecations = {};
    function deprecateSimple(name, msg) {
        if (hooks.deprecationHandler != null) hooks.deprecationHandler(name, msg);
        if (!deprecations[name]) {
            warn(msg);
            deprecations[name] = true;
        }
    }
    hooks.suppressDeprecationWarnings = false;
    hooks.deprecationHandler = null;
    function isFunction(input) {
        return typeof Function !== "undefined" && input instanceof Function || Object.prototype.toString.call(input) === "[object Function]";
    }
    function set(config) {
        var prop, i;
        for(i in config)if (hasOwnProp(config, i)) {
            prop = config[i];
            if (isFunction(prop)) this[i] = prop;
            else this["_" + i] = prop;
        }
        this._config = config;
        // Lenient ordinal parsing accepts just a number in addition to
        // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
        // TODO: Remove "ordinalParse" fallback in next major release.
        this._dayOfMonthOrdinalParseLenient = new RegExp((this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) + "|" + /\d{1,2}/.source);
    }
    function mergeConfigs(parentConfig, childConfig) {
        var res = extend({}, parentConfig), prop;
        for(prop in childConfig)if (hasOwnProp(childConfig, prop)) {
            if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
                res[prop] = {};
                extend(res[prop], parentConfig[prop]);
                extend(res[prop], childConfig[prop]);
            } else if (childConfig[prop] != null) res[prop] = childConfig[prop];
            else delete res[prop];
        }
        for(prop in parentConfig)if (hasOwnProp(parentConfig, prop) && !hasOwnProp(childConfig, prop) && isObject(parentConfig[prop])) // make sure changes to properties don't modify parent config
        res[prop] = extend({}, res[prop]);
        return res;
    }
    function Locale(config) {
        if (config != null) this.set(config);
    }
    var keys;
    if (Object.keys) keys = Object.keys;
    else keys = function(obj) {
        var i, res = [];
        for(i in obj)if (hasOwnProp(obj, i)) res.push(i);
        return res;
    };
    var defaultCalendar = {
        sameDay: "[Today at] LT",
        nextDay: "[Tomorrow at] LT",
        nextWeek: "dddd [at] LT",
        lastDay: "[Yesterday at] LT",
        lastWeek: "[Last] dddd [at] LT",
        sameElse: "L"
    };
    function calendar(key, mom, now) {
        var output = this._calendar[key] || this._calendar["sameElse"];
        return isFunction(output) ? output.call(mom, now) : output;
    }
    function zeroFill(number, targetLength, forceSign) {
        var absNumber = "" + Math.abs(number), zerosToFill = targetLength - absNumber.length, sign = number >= 0;
        return (sign ? forceSign ? "+" : "" : "-") + Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) + absNumber;
    }
    var formattingTokens = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|N{1,5}|YYYYYY|YYYYY|YYYY|YY|y{2,4}|yo?|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g, localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g, formatFunctions = {}, formatTokenFunctions = {};
    // token:    'M'
    // padded:   ['MM', 2]
    // ordinal:  'Mo'
    // callback: function () { this.month() + 1 }
    function addFormatToken(token, padded, ordinal, callback) {
        var func = callback;
        if (typeof callback === "string") func = function() {
            return this[callback]();
        };
        if (token) formatTokenFunctions[token] = func;
        if (padded) formatTokenFunctions[padded[0]] = function() {
            return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
        };
        if (ordinal) formatTokenFunctions[ordinal] = function() {
            return this.localeData().ordinal(func.apply(this, arguments), token);
        };
    }
    function removeFormattingTokens(input) {
        if (input.match(/\[[\s\S]/)) return input.replace(/^\[|\]$/g, "");
        return input.replace(/\\/g, "");
    }
    function makeFormatFunction(format) {
        var array = format.match(formattingTokens), i, length;
        for(i = 0, length = array.length; i < length; i++)if (formatTokenFunctions[array[i]]) array[i] = formatTokenFunctions[array[i]];
        else array[i] = removeFormattingTokens(array[i]);
        return function(mom) {
            var output = "", i;
            for(i = 0; i < length; i++)output += isFunction(array[i]) ? array[i].call(mom, format) : array[i];
            return output;
        };
    }
    // format date using native date object
    function formatMoment(m, format) {
        if (!m.isValid()) return m.localeData().invalidDate();
        format = expandFormat(format, m.localeData());
        formatFunctions[format] = formatFunctions[format] || makeFormatFunction(format);
        return formatFunctions[format](m);
    }
    function expandFormat(format, locale) {
        var i = 5;
        function replaceLongDateFormatTokens(input) {
            return locale.longDateFormat(input) || input;
        }
        localFormattingTokens.lastIndex = 0;
        while(i >= 0 && localFormattingTokens.test(format)){
            format = format.replace(localFormattingTokens, replaceLongDateFormatTokens);
            localFormattingTokens.lastIndex = 0;
            i -= 1;
        }
        return format;
    }
    var defaultLongDateFormat = {
        LTS: "h:mm:ss A",
        LT: "h:mm A",
        L: "MM/DD/YYYY",
        LL: "MMMM D, YYYY",
        LLL: "MMMM D, YYYY h:mm A",
        LLLL: "dddd, MMMM D, YYYY h:mm A"
    };
    function longDateFormat(key) {
        var format = this._longDateFormat[key], formatUpper = this._longDateFormat[key.toUpperCase()];
        if (format || !formatUpper) return format;
        this._longDateFormat[key] = formatUpper.match(formattingTokens).map(function(tok) {
            if (tok === "MMMM" || tok === "MM" || tok === "DD" || tok === "dddd") return tok.slice(1);
            return tok;
        }).join("");
        return this._longDateFormat[key];
    }
    var defaultInvalidDate = "Invalid date";
    function invalidDate() {
        return this._invalidDate;
    }
    var defaultOrdinal = "%d", defaultDayOfMonthOrdinalParse = /\d{1,2}/;
    function ordinal(number) {
        return this._ordinal.replace("%d", number);
    }
    var defaultRelativeTime = {
        future: "in %s",
        past: "%s ago",
        s: "a few seconds",
        ss: "%d seconds",
        m: "a minute",
        mm: "%d minutes",
        h: "an hour",
        hh: "%d hours",
        d: "a day",
        dd: "%d days",
        w: "a week",
        ww: "%d weeks",
        M: "a month",
        MM: "%d months",
        y: "a year",
        yy: "%d years"
    };
    function relativeTime(number, withoutSuffix, string, isFuture) {
        var output = this._relativeTime[string];
        return isFunction(output) ? output(number, withoutSuffix, string, isFuture) : output.replace(/%d/i, number);
    }
    function pastFuture(diff, output) {
        var format = this._relativeTime[diff > 0 ? "future" : "past"];
        return isFunction(format) ? format(output) : format.replace(/%s/i, output);
    }
    var aliases = {};
    function addUnitAlias(unit, shorthand) {
        var lowerCase = unit.toLowerCase();
        aliases[lowerCase] = aliases[lowerCase + "s"] = aliases[shorthand] = unit;
    }
    function normalizeUnits(units) {
        return typeof units === "string" ? aliases[units] || aliases[units.toLowerCase()] : undefined;
    }
    function normalizeObjectUnits(inputObject) {
        var normalizedInput = {}, normalizedProp, prop;
        for(prop in inputObject)if (hasOwnProp(inputObject, prop)) {
            normalizedProp = normalizeUnits(prop);
            if (normalizedProp) normalizedInput[normalizedProp] = inputObject[prop];
        }
        return normalizedInput;
    }
    var priorities = {};
    function addUnitPriority(unit, priority) {
        priorities[unit] = priority;
    }
    function getPrioritizedUnits(unitsObj) {
        var units = [], u;
        for(u in unitsObj)if (hasOwnProp(unitsObj, u)) units.push({
            unit: u,
            priority: priorities[u]
        });
        units.sort(function(a, b) {
            return a.priority - b.priority;
        });
        return units;
    }
    function isLeapYear(year) {
        return year % 4 === 0 && year % 100 !== 0 || year % 400 === 0;
    }
    function absFloor(number) {
        if (number < 0) // -0 -> 0
        return Math.ceil(number) || 0;
        else return Math.floor(number);
    }
    function toInt(argumentForCoercion) {
        var coercedNumber = +argumentForCoercion, value = 0;
        if (coercedNumber !== 0 && isFinite(coercedNumber)) value = absFloor(coercedNumber);
        return value;
    }
    function makeGetSet(unit, keepTime) {
        return function(value) {
            if (value != null) {
                set$1(this, unit, value);
                hooks.updateOffset(this, keepTime);
                return this;
            } else return get(this, unit);
        };
    }
    function get(mom, unit) {
        return mom.isValid() ? mom._d["get" + (mom._isUTC ? "UTC" : "") + unit]() : NaN;
    }
    function set$1(mom, unit, value) {
        if (mom.isValid() && !isNaN(value)) {
            if (unit === "FullYear" && isLeapYear(mom.year()) && mom.month() === 1 && mom.date() === 29) {
                value = toInt(value);
                mom._d["set" + (mom._isUTC ? "UTC" : "") + unit](value, mom.month(), daysInMonth(value, mom.month()));
            } else mom._d["set" + (mom._isUTC ? "UTC" : "") + unit](value);
        }
    }
    // MOMENTS
    function stringGet(units) {
        units = normalizeUnits(units);
        if (isFunction(this[units])) return this[units]();
        return this;
    }
    function stringSet(units, value) {
        if (typeof units === "object") {
            units = normalizeObjectUnits(units);
            var prioritized = getPrioritizedUnits(units), i, prioritizedLen = prioritized.length;
            for(i = 0; i < prioritizedLen; i++)this[prioritized[i].unit](units[prioritized[i].unit]);
        } else {
            units = normalizeUnits(units);
            if (isFunction(this[units])) return this[units](value);
        }
        return this;
    }
    var match1 = /\d/, match2 = /\d\d/, match3 = /\d{3}/, match4 = /\d{4}/, match6 = /[+-]?\d{6}/, match1to2 = /\d\d?/, match3to4 = /\d\d\d\d?/, match5to6 = /\d\d\d\d\d\d?/, match1to3 = /\d{1,3}/, match1to4 = /\d{1,4}/, match1to6 = /[+-]?\d{1,6}/, matchUnsigned = /\d+/, matchSigned = /[+-]?\d+/, matchOffset = /Z|[+-]\d\d:?\d\d/gi, matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi, matchTimestamp = /[+-]?\d+(\.\d{1,3})?/, // any word (or two) characters or numbers including two/three word month in arabic.
    // includes scottish gaelic two word and hyphenated months
    matchWord = /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i, regexes;
    regexes = {};
    function addRegexToken(token, regex, strictRegex) {
        regexes[token] = isFunction(regex) ? regex : function(isStrict, localeData) {
            return isStrict && strictRegex ? strictRegex : regex;
        };
    }
    function getParseRegexForToken(token, config) {
        if (!hasOwnProp(regexes, token)) return new RegExp(unescapeFormat(token));
        return regexes[token](config._strict, config._locale);
    }
    // Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
    function unescapeFormat(s) {
        return regexEscape(s.replace("\\", "").replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function(matched, p1, p2, p3, p4) {
            return p1 || p2 || p3 || p4;
        }));
    }
    function regexEscape(s) {
        return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, "\\$&");
    }
    var tokens = {};
    function addParseToken(token, callback) {
        var i, func = callback, tokenLen;
        if (typeof token === "string") token = [
            token
        ];
        if (isNumber(callback)) func = function(input, array) {
            array[callback] = toInt(input);
        };
        tokenLen = token.length;
        for(i = 0; i < tokenLen; i++)tokens[token[i]] = func;
    }
    function addWeekParseToken(token, callback) {
        addParseToken(token, function(input, array, config, token) {
            config._w = config._w || {};
            callback(input, config._w, config, token);
        });
    }
    function addTimeToArrayFromToken(token, input, config) {
        if (input != null && hasOwnProp(tokens, token)) tokens[token](input, config._a, config, token);
    }
    var YEAR = 0, MONTH = 1, DATE = 2, HOUR = 3, MINUTE = 4, SECOND = 5, MILLISECOND = 6, WEEK = 7, WEEKDAY = 8;
    function mod(n, x) {
        return (n % x + x) % x;
    }
    var indexOf;
    if (Array.prototype.indexOf) indexOf = Array.prototype.indexOf;
    else indexOf = function(o) {
        // I know
        var i;
        for(i = 0; i < this.length; ++i){
            if (this[i] === o) return i;
        }
        return -1;
    };
    function daysInMonth(year, month) {
        if (isNaN(year) || isNaN(month)) return NaN;
        var modMonth = mod(month, 12);
        year += (month - modMonth) / 12;
        return modMonth === 1 ? isLeapYear(year) ? 29 : 28 : 31 - modMonth % 7 % 2;
    }
    // FORMATTING
    addFormatToken("M", [
        "MM",
        2
    ], "Mo", function() {
        return this.month() + 1;
    });
    addFormatToken("MMM", 0, 0, function(format) {
        return this.localeData().monthsShort(this, format);
    });
    addFormatToken("MMMM", 0, 0, function(format) {
        return this.localeData().months(this, format);
    });
    // ALIASES
    addUnitAlias("month", "M");
    // PRIORITY
    addUnitPriority("month", 8);
    // PARSING
    addRegexToken("M", match1to2);
    addRegexToken("MM", match1to2, match2);
    addRegexToken("MMM", function(isStrict, locale) {
        return locale.monthsShortRegex(isStrict);
    });
    addRegexToken("MMMM", function(isStrict, locale) {
        return locale.monthsRegex(isStrict);
    });
    addParseToken([
        "M",
        "MM"
    ], function(input, array) {
        array[MONTH] = toInt(input) - 1;
    });
    addParseToken([
        "MMM",
        "MMMM"
    ], function(input, array, config, token) {
        var month = config._locale.monthsParse(input, token, config._strict);
        // if we didn't find a month name, mark the date as invalid.
        if (month != null) array[MONTH] = month;
        else getParsingFlags(config).invalidMonth = input;
    });
    // LOCALES
    var defaultLocaleMonths = "January_February_March_April_May_June_July_August_September_October_November_December".split("_"), defaultLocaleMonthsShort = "Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec".split("_"), MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/, defaultMonthsShortRegex = matchWord, defaultMonthsRegex = matchWord;
    function localeMonths(m, format) {
        if (!m) return isArray(this._months) ? this._months : this._months["standalone"];
        return isArray(this._months) ? this._months[m.month()] : this._months[(this._months.isFormat || MONTHS_IN_FORMAT).test(format) ? "format" : "standalone"][m.month()];
    }
    function localeMonthsShort(m, format) {
        if (!m) return isArray(this._monthsShort) ? this._monthsShort : this._monthsShort["standalone"];
        return isArray(this._monthsShort) ? this._monthsShort[m.month()] : this._monthsShort[MONTHS_IN_FORMAT.test(format) ? "format" : "standalone"][m.month()];
    }
    function handleStrictParse(monthName, format, strict) {
        var i, ii, mom, llc = monthName.toLocaleLowerCase();
        if (!this._monthsParse) {
            // this is not used
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
            for(i = 0; i < 12; ++i){
                mom = createUTC([
                    2000,
                    i
                ]);
                this._shortMonthsParse[i] = this.monthsShort(mom, "").toLocaleLowerCase();
                this._longMonthsParse[i] = this.months(mom, "").toLocaleLowerCase();
            }
        }
        if (strict) {
            if (format === "MMM") {
                ii = indexOf.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else if (format === "MMM") {
            ii = indexOf.call(this._shortMonthsParse, llc);
            if (ii !== -1) return ii;
            ii = indexOf.call(this._longMonthsParse, llc);
            return ii !== -1 ? ii : null;
        } else {
            ii = indexOf.call(this._longMonthsParse, llc);
            if (ii !== -1) return ii;
            ii = indexOf.call(this._shortMonthsParse, llc);
            return ii !== -1 ? ii : null;
        }
    }
    function localeMonthsParse(monthName, format, strict) {
        var i, mom, regex;
        if (this._monthsParseExact) return handleStrictParse.call(this, monthName, format, strict);
        if (!this._monthsParse) {
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
        }
        // TODO: add sorting
        // Sorting makes sure if one month (or abbr) is a prefix of another
        // see sorting in computeMonthsParse
        for(i = 0; i < 12; i++){
            // make the regex if we don't have it already
            mom = createUTC([
                2000,
                i
            ]);
            if (strict && !this._longMonthsParse[i]) {
                this._longMonthsParse[i] = new RegExp("^" + this.months(mom, "").replace(".", "") + "$", "i");
                this._shortMonthsParse[i] = new RegExp("^" + this.monthsShort(mom, "").replace(".", "") + "$", "i");
            }
            if (!strict && !this._monthsParse[i]) {
                regex = "^" + this.months(mom, "") + "|^" + this.monthsShort(mom, "");
                this._monthsParse[i] = new RegExp(regex.replace(".", ""), "i");
            }
            // test the regex
            if (strict && format === "MMMM" && this._longMonthsParse[i].test(monthName)) return i;
            else if (strict && format === "MMM" && this._shortMonthsParse[i].test(monthName)) return i;
            else if (!strict && this._monthsParse[i].test(monthName)) return i;
        }
    }
    // MOMENTS
    function setMonth(mom, value) {
        var dayOfMonth;
        if (!mom.isValid()) // No op
        return mom;
        if (typeof value === "string") {
            if (/^\d+$/.test(value)) value = toInt(value);
            else {
                value = mom.localeData().monthsParse(value);
                // TODO: Another silent failure?
                if (!isNumber(value)) return mom;
            }
        }
        dayOfMonth = Math.min(mom.date(), daysInMonth(mom.year(), value));
        mom._d["set" + (mom._isUTC ? "UTC" : "") + "Month"](value, dayOfMonth);
        return mom;
    }
    function getSetMonth(value) {
        if (value != null) {
            setMonth(this, value);
            hooks.updateOffset(this, true);
            return this;
        } else return get(this, "Month");
    }
    function getDaysInMonth() {
        return daysInMonth(this.year(), this.month());
    }
    function monthsShortRegex(isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, "_monthsRegex")) computeMonthsParse.call(this);
            if (isStrict) return this._monthsShortStrictRegex;
            else return this._monthsShortRegex;
        } else {
            if (!hasOwnProp(this, "_monthsShortRegex")) this._monthsShortRegex = defaultMonthsShortRegex;
            return this._monthsShortStrictRegex && isStrict ? this._monthsShortStrictRegex : this._monthsShortRegex;
        }
    }
    function monthsRegex(isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, "_monthsRegex")) computeMonthsParse.call(this);
            if (isStrict) return this._monthsStrictRegex;
            else return this._monthsRegex;
        } else {
            if (!hasOwnProp(this, "_monthsRegex")) this._monthsRegex = defaultMonthsRegex;
            return this._monthsStrictRegex && isStrict ? this._monthsStrictRegex : this._monthsRegex;
        }
    }
    function computeMonthsParse() {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }
        var shortPieces = [], longPieces = [], mixedPieces = [], i, mom;
        for(i = 0; i < 12; i++){
            // make the regex if we don't have it already
            mom = createUTC([
                2000,
                i
            ]);
            shortPieces.push(this.monthsShort(mom, ""));
            longPieces.push(this.months(mom, ""));
            mixedPieces.push(this.months(mom, ""));
            mixedPieces.push(this.monthsShort(mom, ""));
        }
        // Sorting makes sure if one month (or abbr) is a prefix of another it
        // will match the longer piece.
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);
        for(i = 0; i < 12; i++){
            shortPieces[i] = regexEscape(shortPieces[i]);
            longPieces[i] = regexEscape(longPieces[i]);
        }
        for(i = 0; i < 24; i++)mixedPieces[i] = regexEscape(mixedPieces[i]);
        this._monthsRegex = new RegExp("^(" + mixedPieces.join("|") + ")", "i");
        this._monthsShortRegex = this._monthsRegex;
        this._monthsStrictRegex = new RegExp("^(" + longPieces.join("|") + ")", "i");
        this._monthsShortStrictRegex = new RegExp("^(" + shortPieces.join("|") + ")", "i");
    }
    // FORMATTING
    addFormatToken("Y", 0, 0, function() {
        var y = this.year();
        return y <= 9999 ? zeroFill(y, 4) : "+" + y;
    });
    addFormatToken(0, [
        "YY",
        2
    ], 0, function() {
        return this.year() % 100;
    });
    addFormatToken(0, [
        "YYYY",
        4
    ], 0, "year");
    addFormatToken(0, [
        "YYYYY",
        5
    ], 0, "year");
    addFormatToken(0, [
        "YYYYYY",
        6,
        true
    ], 0, "year");
    // ALIASES
    addUnitAlias("year", "y");
    // PRIORITIES
    addUnitPriority("year", 1);
    // PARSING
    addRegexToken("Y", matchSigned);
    addRegexToken("YY", match1to2, match2);
    addRegexToken("YYYY", match1to4, match4);
    addRegexToken("YYYYY", match1to6, match6);
    addRegexToken("YYYYYY", match1to6, match6);
    addParseToken([
        "YYYYY",
        "YYYYYY"
    ], YEAR);
    addParseToken("YYYY", function(input, array) {
        array[YEAR] = input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
    });
    addParseToken("YY", function(input, array) {
        array[YEAR] = hooks.parseTwoDigitYear(input);
    });
    addParseToken("Y", function(input, array) {
        array[YEAR] = parseInt(input, 10);
    });
    // HELPERS
    function daysInYear(year) {
        return isLeapYear(year) ? 366 : 365;
    }
    // HOOKS
    hooks.parseTwoDigitYear = function(input) {
        return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
    };
    // MOMENTS
    var getSetYear = makeGetSet("FullYear", true);
    function getIsLeapYear() {
        return isLeapYear(this.year());
    }
    function createDate(y, m, d, h, M, s, ms) {
        // can't just apply() to create a date:
        // https://stackoverflow.com/q/181348
        var date;
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            date = new Date(y + 400, m, d, h, M, s, ms);
            if (isFinite(date.getFullYear())) date.setFullYear(y);
        } else date = new Date(y, m, d, h, M, s, ms);
        return date;
    }
    function createUTCDate(y) {
        var date, args;
        // the Date.UTC function remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            args = Array.prototype.slice.call(arguments);
            // preserve leap years using a full 400 year cycle, then reset
            args[0] = y + 400;
            date = new Date(Date.UTC.apply(null, args));
            if (isFinite(date.getUTCFullYear())) date.setUTCFullYear(y);
        } else date = new Date(Date.UTC.apply(null, arguments));
        return date;
    }
    // start-of-first-week - start-of-year
    function firstWeekOffset(year, dow, doy) {
        var fwd = 7 + dow - doy, // first-week day local weekday -- which local weekday is fwd
        fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;
        return -fwdlw + fwd - 1;
    }
    // https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
    function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
        var localWeekday = (7 + weekday - dow) % 7, weekOffset = firstWeekOffset(year, dow, doy), dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset, resYear, resDayOfYear;
        if (dayOfYear <= 0) {
            resYear = year - 1;
            resDayOfYear = daysInYear(resYear) + dayOfYear;
        } else if (dayOfYear > daysInYear(year)) {
            resYear = year + 1;
            resDayOfYear = dayOfYear - daysInYear(year);
        } else {
            resYear = year;
            resDayOfYear = dayOfYear;
        }
        return {
            year: resYear,
            dayOfYear: resDayOfYear
        };
    }
    function weekOfYear(mom, dow, doy) {
        var weekOffset = firstWeekOffset(mom.year(), dow, doy), week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1, resWeek, resYear;
        if (week < 1) {
            resYear = mom.year() - 1;
            resWeek = week + weeksInYear(resYear, dow, doy);
        } else if (week > weeksInYear(mom.year(), dow, doy)) {
            resWeek = week - weeksInYear(mom.year(), dow, doy);
            resYear = mom.year() + 1;
        } else {
            resYear = mom.year();
            resWeek = week;
        }
        return {
            week: resWeek,
            year: resYear
        };
    }
    function weeksInYear(year, dow, doy) {
        var weekOffset = firstWeekOffset(year, dow, doy), weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
        return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
    }
    // FORMATTING
    addFormatToken("w", [
        "ww",
        2
    ], "wo", "week");
    addFormatToken("W", [
        "WW",
        2
    ], "Wo", "isoWeek");
    // ALIASES
    addUnitAlias("week", "w");
    addUnitAlias("isoWeek", "W");
    // PRIORITIES
    addUnitPriority("week", 5);
    addUnitPriority("isoWeek", 5);
    // PARSING
    addRegexToken("w", match1to2);
    addRegexToken("ww", match1to2, match2);
    addRegexToken("W", match1to2);
    addRegexToken("WW", match1to2, match2);
    addWeekParseToken([
        "w",
        "ww",
        "W",
        "WW"
    ], function(input, week, config, token) {
        week[token.substr(0, 1)] = toInt(input);
    });
    // HELPERS
    // LOCALES
    function localeWeek(mom) {
        return weekOfYear(mom, this._week.dow, this._week.doy).week;
    }
    var defaultLocaleWeek = {
        dow: 0,
        doy: 6
    };
    function localeFirstDayOfWeek() {
        return this._week.dow;
    }
    function localeFirstDayOfYear() {
        return this._week.doy;
    }
    // MOMENTS
    function getSetWeek(input) {
        var week = this.localeData().week(this);
        return input == null ? week : this.add((input - week) * 7, "d");
    }
    function getSetISOWeek(input) {
        var week = weekOfYear(this, 1, 4).week;
        return input == null ? week : this.add((input - week) * 7, "d");
    }
    // FORMATTING
    addFormatToken("d", 0, "do", "day");
    addFormatToken("dd", 0, 0, function(format) {
        return this.localeData().weekdaysMin(this, format);
    });
    addFormatToken("ddd", 0, 0, function(format) {
        return this.localeData().weekdaysShort(this, format);
    });
    addFormatToken("dddd", 0, 0, function(format) {
        return this.localeData().weekdays(this, format);
    });
    addFormatToken("e", 0, 0, "weekday");
    addFormatToken("E", 0, 0, "isoWeekday");
    // ALIASES
    addUnitAlias("day", "d");
    addUnitAlias("weekday", "e");
    addUnitAlias("isoWeekday", "E");
    // PRIORITY
    addUnitPriority("day", 11);
    addUnitPriority("weekday", 11);
    addUnitPriority("isoWeekday", 11);
    // PARSING
    addRegexToken("d", match1to2);
    addRegexToken("e", match1to2);
    addRegexToken("E", match1to2);
    addRegexToken("dd", function(isStrict, locale) {
        return locale.weekdaysMinRegex(isStrict);
    });
    addRegexToken("ddd", function(isStrict, locale) {
        return locale.weekdaysShortRegex(isStrict);
    });
    addRegexToken("dddd", function(isStrict, locale) {
        return locale.weekdaysRegex(isStrict);
    });
    addWeekParseToken([
        "dd",
        "ddd",
        "dddd"
    ], function(input, week, config, token) {
        var weekday = config._locale.weekdaysParse(input, token, config._strict);
        // if we didn't get a weekday name, mark the date as invalid
        if (weekday != null) week.d = weekday;
        else getParsingFlags(config).invalidWeekday = input;
    });
    addWeekParseToken([
        "d",
        "e",
        "E"
    ], function(input, week, config, token) {
        week[token] = toInt(input);
    });
    // HELPERS
    function parseWeekday(input, locale) {
        if (typeof input !== "string") return input;
        if (!isNaN(input)) return parseInt(input, 10);
        input = locale.weekdaysParse(input);
        if (typeof input === "number") return input;
        return null;
    }
    function parseIsoWeekday(input, locale) {
        if (typeof input === "string") return locale.weekdaysParse(input) % 7 || 7;
        return isNaN(input) ? null : input;
    }
    // LOCALES
    function shiftWeekdays(ws, n) {
        return ws.slice(n, 7).concat(ws.slice(0, n));
    }
    var defaultLocaleWeekdays = "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"), defaultLocaleWeekdaysShort = "Sun_Mon_Tue_Wed_Thu_Fri_Sat".split("_"), defaultLocaleWeekdaysMin = "Su_Mo_Tu_We_Th_Fr_Sa".split("_"), defaultWeekdaysRegex = matchWord, defaultWeekdaysShortRegex = matchWord, defaultWeekdaysMinRegex = matchWord;
    function localeWeekdays(m, format) {
        var weekdays = isArray(this._weekdays) ? this._weekdays : this._weekdays[m && m !== true && this._weekdays.isFormat.test(format) ? "format" : "standalone"];
        return m === true ? shiftWeekdays(weekdays, this._week.dow) : m ? weekdays[m.day()] : weekdays;
    }
    function localeWeekdaysShort(m) {
        return m === true ? shiftWeekdays(this._weekdaysShort, this._week.dow) : m ? this._weekdaysShort[m.day()] : this._weekdaysShort;
    }
    function localeWeekdaysMin(m) {
        return m === true ? shiftWeekdays(this._weekdaysMin, this._week.dow) : m ? this._weekdaysMin[m.day()] : this._weekdaysMin;
    }
    function handleStrictParse$1(weekdayName, format, strict) {
        var i, ii, mom, llc = weekdayName.toLocaleLowerCase();
        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._minWeekdaysParse = [];
            for(i = 0; i < 7; ++i){
                mom = createUTC([
                    2000,
                    1
                ]).day(i);
                this._minWeekdaysParse[i] = this.weekdaysMin(mom, "").toLocaleLowerCase();
                this._shortWeekdaysParse[i] = this.weekdaysShort(mom, "").toLocaleLowerCase();
                this._weekdaysParse[i] = this.weekdays(mom, "").toLocaleLowerCase();
            }
        }
        if (strict) {
            if (format === "dddd") {
                ii = indexOf.call(this._weekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === "ddd") {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else {
            if (format === "dddd") {
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === "ddd") {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
    }
    function localeWeekdaysParse(weekdayName, format, strict) {
        var i, mom, regex;
        if (this._weekdaysParseExact) return handleStrictParse$1.call(this, weekdayName, format, strict);
        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._minWeekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._fullWeekdaysParse = [];
        }
        for(i = 0; i < 7; i++){
            // make the regex if we don't have it already
            mom = createUTC([
                2000,
                1
            ]).day(i);
            if (strict && !this._fullWeekdaysParse[i]) {
                this._fullWeekdaysParse[i] = new RegExp("^" + this.weekdays(mom, "").replace(".", "\\.?") + "$", "i");
                this._shortWeekdaysParse[i] = new RegExp("^" + this.weekdaysShort(mom, "").replace(".", "\\.?") + "$", "i");
                this._minWeekdaysParse[i] = new RegExp("^" + this.weekdaysMin(mom, "").replace(".", "\\.?") + "$", "i");
            }
            if (!this._weekdaysParse[i]) {
                regex = "^" + this.weekdays(mom, "") + "|^" + this.weekdaysShort(mom, "") + "|^" + this.weekdaysMin(mom, "");
                this._weekdaysParse[i] = new RegExp(regex.replace(".", ""), "i");
            }
            // test the regex
            if (strict && format === "dddd" && this._fullWeekdaysParse[i].test(weekdayName)) return i;
            else if (strict && format === "ddd" && this._shortWeekdaysParse[i].test(weekdayName)) return i;
            else if (strict && format === "dd" && this._minWeekdaysParse[i].test(weekdayName)) return i;
            else if (!strict && this._weekdaysParse[i].test(weekdayName)) return i;
        }
    }
    // MOMENTS
    function getSetDayOfWeek(input) {
        if (!this.isValid()) return input != null ? this : NaN;
        var day = this._isUTC ? this._d.getUTCDay() : this._d.getDay();
        if (input != null) {
            input = parseWeekday(input, this.localeData());
            return this.add(input - day, "d");
        } else return day;
    }
    function getSetLocaleDayOfWeek(input) {
        if (!this.isValid()) return input != null ? this : NaN;
        var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
        return input == null ? weekday : this.add(input - weekday, "d");
    }
    function getSetISODayOfWeek(input) {
        if (!this.isValid()) return input != null ? this : NaN;
        // behaves the same as moment#day except
        // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
        // as a setter, sunday should belong to the previous week.
        if (input != null) {
            var weekday = parseIsoWeekday(input, this.localeData());
            return this.day(this.day() % 7 ? weekday : weekday - 7);
        } else return this.day() || 7;
    }
    function weekdaysRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, "_weekdaysRegex")) computeWeekdaysParse.call(this);
            if (isStrict) return this._weekdaysStrictRegex;
            else return this._weekdaysRegex;
        } else {
            if (!hasOwnProp(this, "_weekdaysRegex")) this._weekdaysRegex = defaultWeekdaysRegex;
            return this._weekdaysStrictRegex && isStrict ? this._weekdaysStrictRegex : this._weekdaysRegex;
        }
    }
    function weekdaysShortRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, "_weekdaysRegex")) computeWeekdaysParse.call(this);
            if (isStrict) return this._weekdaysShortStrictRegex;
            else return this._weekdaysShortRegex;
        } else {
            if (!hasOwnProp(this, "_weekdaysShortRegex")) this._weekdaysShortRegex = defaultWeekdaysShortRegex;
            return this._weekdaysShortStrictRegex && isStrict ? this._weekdaysShortStrictRegex : this._weekdaysShortRegex;
        }
    }
    function weekdaysMinRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, "_weekdaysRegex")) computeWeekdaysParse.call(this);
            if (isStrict) return this._weekdaysMinStrictRegex;
            else return this._weekdaysMinRegex;
        } else {
            if (!hasOwnProp(this, "_weekdaysMinRegex")) this._weekdaysMinRegex = defaultWeekdaysMinRegex;
            return this._weekdaysMinStrictRegex && isStrict ? this._weekdaysMinStrictRegex : this._weekdaysMinRegex;
        }
    }
    function computeWeekdaysParse() {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }
        var minPieces = [], shortPieces = [], longPieces = [], mixedPieces = [], i, mom, minp, shortp, longp;
        for(i = 0; i < 7; i++){
            // make the regex if we don't have it already
            mom = createUTC([
                2000,
                1
            ]).day(i);
            minp = regexEscape(this.weekdaysMin(mom, ""));
            shortp = regexEscape(this.weekdaysShort(mom, ""));
            longp = regexEscape(this.weekdays(mom, ""));
            minPieces.push(minp);
            shortPieces.push(shortp);
            longPieces.push(longp);
            mixedPieces.push(minp);
            mixedPieces.push(shortp);
            mixedPieces.push(longp);
        }
        // Sorting makes sure if one weekday (or abbr) is a prefix of another it
        // will match the longer piece.
        minPieces.sort(cmpLenRev);
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);
        this._weekdaysRegex = new RegExp("^(" + mixedPieces.join("|") + ")", "i");
        this._weekdaysShortRegex = this._weekdaysRegex;
        this._weekdaysMinRegex = this._weekdaysRegex;
        this._weekdaysStrictRegex = new RegExp("^(" + longPieces.join("|") + ")", "i");
        this._weekdaysShortStrictRegex = new RegExp("^(" + shortPieces.join("|") + ")", "i");
        this._weekdaysMinStrictRegex = new RegExp("^(" + minPieces.join("|") + ")", "i");
    }
    // FORMATTING
    function hFormat() {
        return this.hours() % 12 || 12;
    }
    function kFormat() {
        return this.hours() || 24;
    }
    addFormatToken("H", [
        "HH",
        2
    ], 0, "hour");
    addFormatToken("h", [
        "hh",
        2
    ], 0, hFormat);
    addFormatToken("k", [
        "kk",
        2
    ], 0, kFormat);
    addFormatToken("hmm", 0, 0, function() {
        return "" + hFormat.apply(this) + zeroFill(this.minutes(), 2);
    });
    addFormatToken("hmmss", 0, 0, function() {
        return "" + hFormat.apply(this) + zeroFill(this.minutes(), 2) + zeroFill(this.seconds(), 2);
    });
    addFormatToken("Hmm", 0, 0, function() {
        return "" + this.hours() + zeroFill(this.minutes(), 2);
    });
    addFormatToken("Hmmss", 0, 0, function() {
        return "" + this.hours() + zeroFill(this.minutes(), 2) + zeroFill(this.seconds(), 2);
    });
    function meridiem(token, lowercase) {
        addFormatToken(token, 0, 0, function() {
            return this.localeData().meridiem(this.hours(), this.minutes(), lowercase);
        });
    }
    meridiem("a", true);
    meridiem("A", false);
    // ALIASES
    addUnitAlias("hour", "h");
    // PRIORITY
    addUnitPriority("hour", 13);
    // PARSING
    function matchMeridiem(isStrict, locale) {
        return locale._meridiemParse;
    }
    addRegexToken("a", matchMeridiem);
    addRegexToken("A", matchMeridiem);
    addRegexToken("H", match1to2);
    addRegexToken("h", match1to2);
    addRegexToken("k", match1to2);
    addRegexToken("HH", match1to2, match2);
    addRegexToken("hh", match1to2, match2);
    addRegexToken("kk", match1to2, match2);
    addRegexToken("hmm", match3to4);
    addRegexToken("hmmss", match5to6);
    addRegexToken("Hmm", match3to4);
    addRegexToken("Hmmss", match5to6);
    addParseToken([
        "H",
        "HH"
    ], HOUR);
    addParseToken([
        "k",
        "kk"
    ], function(input, array, config) {
        var kInput = toInt(input);
        array[HOUR] = kInput === 24 ? 0 : kInput;
    });
    addParseToken([
        "a",
        "A"
    ], function(input, array, config) {
        config._isPm = config._locale.isPM(input);
        config._meridiem = input;
    });
    addParseToken([
        "h",
        "hh"
    ], function(input, array, config) {
        array[HOUR] = toInt(input);
        getParsingFlags(config).bigHour = true;
    });
    addParseToken("hmm", function(input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken("hmmss", function(input, array, config) {
        var pos1 = input.length - 4, pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken("Hmm", function(input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
    });
    addParseToken("Hmmss", function(input, array, config) {
        var pos1 = input.length - 4, pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
    });
    // LOCALES
    function localeIsPM(input) {
        // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
        // Using charAt should be more compatible.
        return (input + "").toLowerCase().charAt(0) === "p";
    }
    var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i, // Setting the hour should keep the time, because the user explicitly
    // specified which hour they want. So trying to maintain the same hour (in
    // a new timezone) makes sense. Adding/subtracting hours does not follow
    // this rule.
    getSetHour = makeGetSet("Hours", true);
    function localeMeridiem(hours, minutes, isLower) {
        if (hours > 11) return isLower ? "pm" : "PM";
        else return isLower ? "am" : "AM";
    }
    var baseConfig = {
        calendar: defaultCalendar,
        longDateFormat: defaultLongDateFormat,
        invalidDate: defaultInvalidDate,
        ordinal: defaultOrdinal,
        dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
        relativeTime: defaultRelativeTime,
        months: defaultLocaleMonths,
        monthsShort: defaultLocaleMonthsShort,
        week: defaultLocaleWeek,
        weekdays: defaultLocaleWeekdays,
        weekdaysMin: defaultLocaleWeekdaysMin,
        weekdaysShort: defaultLocaleWeekdaysShort,
        meridiemParse: defaultLocaleMeridiemParse
    };
    // internal storage for locale config files
    var locales = {}, localeFamilies = {}, globalLocale;
    function commonPrefix(arr1, arr2) {
        var i, minl = Math.min(arr1.length, arr2.length);
        for(i = 0; i < minl; i += 1){
            if (arr1[i] !== arr2[i]) return i;
        }
        return minl;
    }
    function normalizeLocale(key) {
        return key ? key.toLowerCase().replace("_", "-") : key;
    }
    // pick the locale from the array
    // try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
    // substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
    function chooseLocale(names) {
        var i = 0, j, next, locale, split;
        while(i < names.length){
            split = normalizeLocale(names[i]).split("-");
            j = split.length;
            next = normalizeLocale(names[i + 1]);
            next = next ? next.split("-") : null;
            while(j > 0){
                locale = loadLocale(split.slice(0, j).join("-"));
                if (locale) return locale;
                if (next && next.length >= j && commonPrefix(split, next) >= j - 1) break;
                j--;
            }
            i++;
        }
        return globalLocale;
    }
    function isLocaleNameSane(name) {
        // Prevent names that look like filesystem paths, i.e contain '/' or '\'
        return name.match("^[^/\\\\]*$") != null;
    }
    function loadLocale(name) {
        var oldLocale = null, aliasedRequire;
        // TODO: Find a better way to register and load all the locales in Node
        if (locales[name] === undefined && true && module && module.exports && isLocaleNameSane(name)) try {
            oldLocale = globalLocale._abbr;
            aliasedRequire = undefined;
            aliasedRequire("./locale/" + name);
            getSetGlobalLocale(oldLocale);
        } catch (e) {
            // mark as not found to avoid repeating expensive file require call causing high CPU
            // when trying to find en-US, en_US, en-us for every format call
            locales[name] = null; // null means not found
        }
        return locales[name];
    }
    // This function will load locale and then set the global locale.  If
    // no arguments are passed in, it will simply return the current global
    // locale key.
    function getSetGlobalLocale(key, values) {
        var data;
        if (key) {
            if (isUndefined(values)) data = getLocale(key);
            else data = defineLocale(key, values);
            if (data) // moment.duration._locale = moment._locale = data;
            globalLocale = data;
            else if (typeof console !== "undefined" && console.warn) //warn user if arguments are passed but the locale could not be set
            console.warn("Locale " + key + " not found. Did you forget to load it?");
        }
        return globalLocale._abbr;
    }
    function defineLocale(name, config) {
        if (config !== null) {
            var locale, parentConfig = baseConfig;
            config.abbr = name;
            if (locales[name] != null) {
                deprecateSimple("defineLocaleOverride", "use moment.updateLocale(localeName, config) to change an existing locale. moment.defineLocale(localeName, config) should only be used for creating a new locale See http://momentjs.com/guides/#/warnings/define-locale/ for more info.");
                parentConfig = locales[name]._config;
            } else if (config.parentLocale != null) {
                if (locales[config.parentLocale] != null) parentConfig = locales[config.parentLocale]._config;
                else {
                    locale = loadLocale(config.parentLocale);
                    if (locale != null) parentConfig = locale._config;
                    else {
                        if (!localeFamilies[config.parentLocale]) localeFamilies[config.parentLocale] = [];
                        localeFamilies[config.parentLocale].push({
                            name: name,
                            config: config
                        });
                        return null;
                    }
                }
            }
            locales[name] = new Locale(mergeConfigs(parentConfig, config));
            if (localeFamilies[name]) localeFamilies[name].forEach(function(x) {
                defineLocale(x.name, x.config);
            });
            // backwards compat for now: also set the locale
            // make sure we set the locale AFTER all child locales have been
            // created, so we won't end up with the child locale set.
            getSetGlobalLocale(name);
            return locales[name];
        } else {
            // useful for testing
            delete locales[name];
            return null;
        }
    }
    function updateLocale(name, config) {
        if (config != null) {
            var locale, tmpLocale, parentConfig = baseConfig;
            if (locales[name] != null && locales[name].parentLocale != null) // Update existing child locale in-place to avoid memory-leaks
            locales[name].set(mergeConfigs(locales[name]._config, config));
            else {
                // MERGE
                tmpLocale = loadLocale(name);
                if (tmpLocale != null) parentConfig = tmpLocale._config;
                config = mergeConfigs(parentConfig, config);
                if (tmpLocale == null) // updateLocale is called for creating a new locale
                // Set abbr so it will have a name (getters return
                // undefined otherwise).
                config.abbr = name;
                locale = new Locale(config);
                locale.parentLocale = locales[name];
                locales[name] = locale;
            }
            // backwards compat for now: also set the locale
            getSetGlobalLocale(name);
        } else // pass null for config to unupdate, useful for tests
        if (locales[name] != null) {
            if (locales[name].parentLocale != null) {
                locales[name] = locales[name].parentLocale;
                if (name === getSetGlobalLocale()) getSetGlobalLocale(name);
            } else if (locales[name] != null) delete locales[name];
        }
        return locales[name];
    }
    // returns locale data
    function getLocale(key) {
        var locale;
        if (key && key._locale && key._locale._abbr) key = key._locale._abbr;
        if (!key) return globalLocale;
        if (!isArray(key)) {
            //short-circuit everything else
            locale = loadLocale(key);
            if (locale) return locale;
            key = [
                key
            ];
        }
        return chooseLocale(key);
    }
    function listLocales() {
        return keys(locales);
    }
    function checkOverflow(m) {
        var overflow, a = m._a;
        if (a && getParsingFlags(m).overflow === -2) {
            overflow = a[MONTH] < 0 || a[MONTH] > 11 ? MONTH : a[DATE] < 1 || a[DATE] > daysInMonth(a[YEAR], a[MONTH]) ? DATE : a[HOUR] < 0 || a[HOUR] > 24 || a[HOUR] === 24 && (a[MINUTE] !== 0 || a[SECOND] !== 0 || a[MILLISECOND] !== 0) ? HOUR : a[MINUTE] < 0 || a[MINUTE] > 59 ? MINUTE : a[SECOND] < 0 || a[SECOND] > 59 ? SECOND : a[MILLISECOND] < 0 || a[MILLISECOND] > 999 ? MILLISECOND : -1;
            if (getParsingFlags(m)._overflowDayOfYear && (overflow < YEAR || overflow > DATE)) overflow = DATE;
            if (getParsingFlags(m)._overflowWeeks && overflow === -1) overflow = WEEK;
            if (getParsingFlags(m)._overflowWeekday && overflow === -1) overflow = WEEKDAY;
            getParsingFlags(m).overflow = overflow;
        }
        return m;
    }
    // iso 8601 regex
    // 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
    var extendedIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/, basicIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d|))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/, tzRegex = /Z|[+-]\d\d(?::?\d\d)?/, isoDates = [
        [
            "YYYYYY-MM-DD",
            /[+-]\d{6}-\d\d-\d\d/
        ],
        [
            "YYYY-MM-DD",
            /\d{4}-\d\d-\d\d/
        ],
        [
            "GGGG-[W]WW-E",
            /\d{4}-W\d\d-\d/
        ],
        [
            "GGGG-[W]WW",
            /\d{4}-W\d\d/,
            false
        ],
        [
            "YYYY-DDD",
            /\d{4}-\d{3}/
        ],
        [
            "YYYY-MM",
            /\d{4}-\d\d/,
            false
        ],
        [
            "YYYYYYMMDD",
            /[+-]\d{10}/
        ],
        [
            "YYYYMMDD",
            /\d{8}/
        ],
        [
            "GGGG[W]WWE",
            /\d{4}W\d{3}/
        ],
        [
            "GGGG[W]WW",
            /\d{4}W\d{2}/,
            false
        ],
        [
            "YYYYDDD",
            /\d{7}/
        ],
        [
            "YYYYMM",
            /\d{6}/,
            false
        ],
        [
            "YYYY",
            /\d{4}/,
            false
        ]
    ], // iso time formats and regexes
    isoTimes = [
        [
            "HH:mm:ss.SSSS",
            /\d\d:\d\d:\d\d\.\d+/
        ],
        [
            "HH:mm:ss,SSSS",
            /\d\d:\d\d:\d\d,\d+/
        ],
        [
            "HH:mm:ss",
            /\d\d:\d\d:\d\d/
        ],
        [
            "HH:mm",
            /\d\d:\d\d/
        ],
        [
            "HHmmss.SSSS",
            /\d\d\d\d\d\d\.\d+/
        ],
        [
            "HHmmss,SSSS",
            /\d\d\d\d\d\d,\d+/
        ],
        [
            "HHmmss",
            /\d\d\d\d\d\d/
        ],
        [
            "HHmm",
            /\d\d\d\d/
        ],
        [
            "HH",
            /\d\d/
        ]
    ], aspNetJsonRegex = /^\/?Date\((-?\d+)/i, // RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
    rfc2822 = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/, obsOffsets = {
        UT: 0,
        GMT: 0,
        EDT: -240,
        EST: -300,
        CDT: -300,
        CST: -360,
        MDT: -360,
        MST: -420,
        PDT: -420,
        PST: -480
    };
    // date from iso format
    function configFromISO(config) {
        var i, l, string = config._i, match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string), allowTime, dateFormat, timeFormat, tzFormat, isoDatesLen = isoDates.length, isoTimesLen = isoTimes.length;
        if (match) {
            getParsingFlags(config).iso = true;
            for(i = 0, l = isoDatesLen; i < l; i++)if (isoDates[i][1].exec(match[1])) {
                dateFormat = isoDates[i][0];
                allowTime = isoDates[i][2] !== false;
                break;
            }
            if (dateFormat == null) {
                config._isValid = false;
                return;
            }
            if (match[3]) {
                for(i = 0, l = isoTimesLen; i < l; i++)if (isoTimes[i][1].exec(match[3])) {
                    // match[2] should be 'T' or space
                    timeFormat = (match[2] || " ") + isoTimes[i][0];
                    break;
                }
                if (timeFormat == null) {
                    config._isValid = false;
                    return;
                }
            }
            if (!allowTime && timeFormat != null) {
                config._isValid = false;
                return;
            }
            if (match[4]) {
                if (tzRegex.exec(match[4])) tzFormat = "Z";
                else {
                    config._isValid = false;
                    return;
                }
            }
            config._f = dateFormat + (timeFormat || "") + (tzFormat || "");
            configFromStringAndFormat(config);
        } else config._isValid = false;
    }
    function extractFromRFC2822Strings(yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr) {
        var result = [
            untruncateYear(yearStr),
            defaultLocaleMonthsShort.indexOf(monthStr),
            parseInt(dayStr, 10),
            parseInt(hourStr, 10),
            parseInt(minuteStr, 10)
        ];
        if (secondStr) result.push(parseInt(secondStr, 10));
        return result;
    }
    function untruncateYear(yearStr) {
        var year = parseInt(yearStr, 10);
        if (year <= 49) return 2000 + year;
        else if (year <= 999) return 1900 + year;
        return year;
    }
    function preprocessRFC2822(s) {
        // Remove comments and folding whitespace and replace multiple-spaces with a single space
        return s.replace(/\([^()]*\)|[\n\t]/g, " ").replace(/(\s\s+)/g, " ").replace(/^\s\s*/, "").replace(/\s\s*$/, "");
    }
    function checkWeekday(weekdayStr, parsedInput, config) {
        if (weekdayStr) {
            // TODO: Replace the vanilla JS Date object with an independent day-of-week check.
            var weekdayProvided = defaultLocaleWeekdaysShort.indexOf(weekdayStr), weekdayActual = new Date(parsedInput[0], parsedInput[1], parsedInput[2]).getDay();
            if (weekdayProvided !== weekdayActual) {
                getParsingFlags(config).weekdayMismatch = true;
                config._isValid = false;
                return false;
            }
        }
        return true;
    }
    function calculateOffset(obsOffset, militaryOffset, numOffset) {
        if (obsOffset) return obsOffsets[obsOffset];
        else if (militaryOffset) // the only allowed military tz is Z
        return 0;
        else {
            var hm = parseInt(numOffset, 10), m = hm % 100, h = (hm - m) / 100;
            return h * 60 + m;
        }
    }
    // date and time from ref 2822 format
    function configFromRFC2822(config) {
        var match = rfc2822.exec(preprocessRFC2822(config._i)), parsedArray;
        if (match) {
            parsedArray = extractFromRFC2822Strings(match[4], match[3], match[2], match[5], match[6], match[7]);
            if (!checkWeekday(match[1], parsedArray, config)) return;
            config._a = parsedArray;
            config._tzm = calculateOffset(match[8], match[9], match[10]);
            config._d = createUTCDate.apply(null, config._a);
            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
            getParsingFlags(config).rfc2822 = true;
        } else config._isValid = false;
    }
    // date from 1) ASP.NET, 2) ISO, 3) RFC 2822 formats, or 4) optional fallback if parsing isn't strict
    function configFromString(config) {
        var matched = aspNetJsonRegex.exec(config._i);
        if (matched !== null) {
            config._d = new Date(+matched[1]);
            return;
        }
        configFromISO(config);
        if (config._isValid === false) delete config._isValid;
        else return;
        configFromRFC2822(config);
        if (config._isValid === false) delete config._isValid;
        else return;
        if (config._strict) config._isValid = false;
        else // Final attempt, use Input Fallback
        hooks.createFromInputFallback(config);
    }
    hooks.createFromInputFallback = deprecate("value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are discouraged. Please refer to http://momentjs.com/guides/#/warnings/js-date/ for more info.", function(config) {
        config._d = new Date(config._i + (config._useUTC ? " UTC" : ""));
    });
    // Pick the first defined of two or three arguments.
    function defaults(a, b, c) {
        if (a != null) return a;
        if (b != null) return b;
        return c;
    }
    function currentDateArray(config) {
        // hooks is actually the exported moment object
        var nowValue = new Date(hooks.now());
        if (config._useUTC) return [
            nowValue.getUTCFullYear(),
            nowValue.getUTCMonth(),
            nowValue.getUTCDate()
        ];
        return [
            nowValue.getFullYear(),
            nowValue.getMonth(),
            nowValue.getDate()
        ];
    }
    // convert an array to a date.
    // the array should mirror the parameters below
    // note: all values past the year are optional and will default to the lowest possible value.
    // [year, month, day , hour, minute, second, millisecond]
    function configFromArray(config) {
        var i, date, input = [], currentDate, expectedWeekday, yearToUse;
        if (config._d) return;
        currentDate = currentDateArray(config);
        //compute day of the year from weeks and weekdays
        if (config._w && config._a[DATE] == null && config._a[MONTH] == null) dayOfYearFromWeekInfo(config);
        //if the day of the year is set, figure out what it is
        if (config._dayOfYear != null) {
            yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);
            if (config._dayOfYear > daysInYear(yearToUse) || config._dayOfYear === 0) getParsingFlags(config)._overflowDayOfYear = true;
            date = createUTCDate(yearToUse, 0, config._dayOfYear);
            config._a[MONTH] = date.getUTCMonth();
            config._a[DATE] = date.getUTCDate();
        }
        // Default to current date.
        // * if no year, month, day of month are given, default to today
        // * if day of month is given, default month and year
        // * if month is given, default only year
        // * if year is given, don't default anything
        for(i = 0; i < 3 && config._a[i] == null; ++i)config._a[i] = input[i] = currentDate[i];
        // Zero out whatever was not defaulted, including time
        for(; i < 7; i++)config._a[i] = input[i] = config._a[i] == null ? i === 2 ? 1 : 0 : config._a[i];
        // Check for 24:00:00.000
        if (config._a[HOUR] === 24 && config._a[MINUTE] === 0 && config._a[SECOND] === 0 && config._a[MILLISECOND] === 0) {
            config._nextDay = true;
            config._a[HOUR] = 0;
        }
        config._d = (config._useUTC ? createUTCDate : createDate).apply(null, input);
        expectedWeekday = config._useUTC ? config._d.getUTCDay() : config._d.getDay();
        // Apply timezone offset from input. The actual utcOffset can be changed
        // with parseZone.
        if (config._tzm != null) config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
        if (config._nextDay) config._a[HOUR] = 24;
        // check for mismatching day of week
        if (config._w && typeof config._w.d !== "undefined" && config._w.d !== expectedWeekday) getParsingFlags(config).weekdayMismatch = true;
    }
    function dayOfYearFromWeekInfo(config) {
        var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow, curWeek;
        w = config._w;
        if (w.GG != null || w.W != null || w.E != null) {
            dow = 1;
            doy = 4;
            // TODO: We need to take the current isoWeekYear, but that depends on
            // how we interpret now (local, utc, fixed offset). So create
            // a now version of current config (take local/utc/offset flags, and
            // create now).
            weekYear = defaults(w.GG, config._a[YEAR], weekOfYear(createLocal(), 1, 4).year);
            week = defaults(w.W, 1);
            weekday = defaults(w.E, 1);
            if (weekday < 1 || weekday > 7) weekdayOverflow = true;
        } else {
            dow = config._locale._week.dow;
            doy = config._locale._week.doy;
            curWeek = weekOfYear(createLocal(), dow, doy);
            weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);
            // Default to current week.
            week = defaults(w.w, curWeek.week);
            if (w.d != null) {
                // weekday -- low day numbers are considered next week
                weekday = w.d;
                if (weekday < 0 || weekday > 6) weekdayOverflow = true;
            } else if (w.e != null) {
                // local weekday -- counting starts from beginning of week
                weekday = w.e + dow;
                if (w.e < 0 || w.e > 6) weekdayOverflow = true;
            } else // default to beginning of week
            weekday = dow;
        }
        if (week < 1 || week > weeksInYear(weekYear, dow, doy)) getParsingFlags(config)._overflowWeeks = true;
        else if (weekdayOverflow != null) getParsingFlags(config)._overflowWeekday = true;
        else {
            temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
            config._a[YEAR] = temp.year;
            config._dayOfYear = temp.dayOfYear;
        }
    }
    // constant that refers to the ISO standard
    hooks.ISO_8601 = function() {};
    // constant that refers to the RFC 2822 form
    hooks.RFC_2822 = function() {};
    // date from string and format string
    function configFromStringAndFormat(config) {
        // TODO: Move this to another part of the creation flow to prevent circular deps
        if (config._f === hooks.ISO_8601) {
            configFromISO(config);
            return;
        }
        if (config._f === hooks.RFC_2822) {
            configFromRFC2822(config);
            return;
        }
        config._a = [];
        getParsingFlags(config).empty = true;
        // This array is used to make a Date, either with `new Date` or `Date.UTC`
        var string = "" + config._i, i, parsedInput, tokens, token, skipped, stringLength = string.length, totalParsedInputLength = 0, era, tokenLen;
        tokens = expandFormat(config._f, config._locale).match(formattingTokens) || [];
        tokenLen = tokens.length;
        for(i = 0; i < tokenLen; i++){
            token = tokens[i];
            parsedInput = (string.match(getParseRegexForToken(token, config)) || [])[0];
            if (parsedInput) {
                skipped = string.substr(0, string.indexOf(parsedInput));
                if (skipped.length > 0) getParsingFlags(config).unusedInput.push(skipped);
                string = string.slice(string.indexOf(parsedInput) + parsedInput.length);
                totalParsedInputLength += parsedInput.length;
            }
            // don't parse if it's not a known token
            if (formatTokenFunctions[token]) {
                if (parsedInput) getParsingFlags(config).empty = false;
                else getParsingFlags(config).unusedTokens.push(token);
                addTimeToArrayFromToken(token, parsedInput, config);
            } else if (config._strict && !parsedInput) getParsingFlags(config).unusedTokens.push(token);
        }
        // add remaining unparsed input length to the string
        getParsingFlags(config).charsLeftOver = stringLength - totalParsedInputLength;
        if (string.length > 0) getParsingFlags(config).unusedInput.push(string);
        // clear _12h flag if hour is <= 12
        if (config._a[HOUR] <= 12 && getParsingFlags(config).bigHour === true && config._a[HOUR] > 0) getParsingFlags(config).bigHour = undefined;
        getParsingFlags(config).parsedDateParts = config._a.slice(0);
        getParsingFlags(config).meridiem = config._meridiem;
        // handle meridiem
        config._a[HOUR] = meridiemFixWrap(config._locale, config._a[HOUR], config._meridiem);
        // handle era
        era = getParsingFlags(config).era;
        if (era !== null) config._a[YEAR] = config._locale.erasConvertYear(era, config._a[YEAR]);
        configFromArray(config);
        checkOverflow(config);
    }
    function meridiemFixWrap(locale, hour, meridiem) {
        var isPm;
        if (meridiem == null) // nothing to do
        return hour;
        if (locale.meridiemHour != null) return locale.meridiemHour(hour, meridiem);
        else if (locale.isPM != null) {
            // Fallback
            isPm = locale.isPM(meridiem);
            if (isPm && hour < 12) hour += 12;
            if (!isPm && hour === 12) hour = 0;
            return hour;
        } else // this is not supposed to happen
        return hour;
    }
    // date from string and array of format strings
    function configFromStringAndArray(config) {
        var tempConfig, bestMoment, scoreToBeat, i, currentScore, validFormatFound, bestFormatIsValid = false, configfLen = config._f.length;
        if (configfLen === 0) {
            getParsingFlags(config).invalidFormat = true;
            config._d = new Date(NaN);
            return;
        }
        for(i = 0; i < configfLen; i++){
            currentScore = 0;
            validFormatFound = false;
            tempConfig = copyConfig({}, config);
            if (config._useUTC != null) tempConfig._useUTC = config._useUTC;
            tempConfig._f = config._f[i];
            configFromStringAndFormat(tempConfig);
            if (isValid(tempConfig)) validFormatFound = true;
            // if there is any input that was not parsed add a penalty for that format
            currentScore += getParsingFlags(tempConfig).charsLeftOver;
            //or tokens
            currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;
            getParsingFlags(tempConfig).score = currentScore;
            if (!bestFormatIsValid) {
                if (scoreToBeat == null || currentScore < scoreToBeat || validFormatFound) {
                    scoreToBeat = currentScore;
                    bestMoment = tempConfig;
                    if (validFormatFound) bestFormatIsValid = true;
                }
            } else if (currentScore < scoreToBeat) {
                scoreToBeat = currentScore;
                bestMoment = tempConfig;
            }
        }
        extend(config, bestMoment || tempConfig);
    }
    function configFromObject(config) {
        if (config._d) return;
        var i = normalizeObjectUnits(config._i), dayOrDate = i.day === undefined ? i.date : i.day;
        config._a = map([
            i.year,
            i.month,
            dayOrDate,
            i.hour,
            i.minute,
            i.second,
            i.millisecond
        ], function(obj) {
            return obj && parseInt(obj, 10);
        });
        configFromArray(config);
    }
    function createFromConfig(config) {
        var res = new Moment(checkOverflow(prepareConfig(config)));
        if (res._nextDay) {
            // Adding is smart enough around DST
            res.add(1, "d");
            res._nextDay = undefined;
        }
        return res;
    }
    function prepareConfig(config) {
        var input = config._i, format = config._f;
        config._locale = config._locale || getLocale(config._l);
        if (input === null || format === undefined && input === "") return createInvalid({
            nullInput: true
        });
        if (typeof input === "string") config._i = input = config._locale.preparse(input);
        if (isMoment(input)) return new Moment(checkOverflow(input));
        else if (isDate(input)) config._d = input;
        else if (isArray(format)) configFromStringAndArray(config);
        else if (format) configFromStringAndFormat(config);
        else configFromInput(config);
        if (!isValid(config)) config._d = null;
        return config;
    }
    function configFromInput(config) {
        var input = config._i;
        if (isUndefined(input)) config._d = new Date(hooks.now());
        else if (isDate(input)) config._d = new Date(input.valueOf());
        else if (typeof input === "string") configFromString(config);
        else if (isArray(input)) {
            config._a = map(input.slice(0), function(obj) {
                return parseInt(obj, 10);
            });
            configFromArray(config);
        } else if (isObject(input)) configFromObject(config);
        else if (isNumber(input)) // from milliseconds
        config._d = new Date(input);
        else hooks.createFromInputFallback(config);
    }
    function createLocalOrUTC(input, format, locale, strict, isUTC) {
        var c = {};
        if (format === true || format === false) {
            strict = format;
            format = undefined;
        }
        if (locale === true || locale === false) {
            strict = locale;
            locale = undefined;
        }
        if (isObject(input) && isObjectEmpty(input) || isArray(input) && input.length === 0) input = undefined;
        // object construction must be done this way.
        // https://github.com/moment/moment/issues/1423
        c._isAMomentObject = true;
        c._useUTC = c._isUTC = isUTC;
        c._l = locale;
        c._i = input;
        c._f = format;
        c._strict = strict;
        return createFromConfig(c);
    }
    function createLocal(input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, false);
    }
    var prototypeMin = deprecate("moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/", function() {
        var other = createLocal.apply(null, arguments);
        if (this.isValid() && other.isValid()) return other < this ? this : other;
        else return createInvalid();
    }), prototypeMax = deprecate("moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/", function() {
        var other = createLocal.apply(null, arguments);
        if (this.isValid() && other.isValid()) return other > this ? this : other;
        else return createInvalid();
    });
    // Pick a moment m from moments so that m[fn](other) is true for all
    // other. This relies on the function fn to be transitive.
    //
    // moments should either be an array of moment objects or an array, whose
    // first element is an array of moment objects.
    function pickBy(fn, moments) {
        var res, i;
        if (moments.length === 1 && isArray(moments[0])) moments = moments[0];
        if (!moments.length) return createLocal();
        res = moments[0];
        for(i = 1; i < moments.length; ++i)if (!moments[i].isValid() || moments[i][fn](res)) res = moments[i];
        return res;
    }
    // TODO: Use [].sort instead?
    function min() {
        var args = [].slice.call(arguments, 0);
        return pickBy("isBefore", args);
    }
    function max() {
        var args = [].slice.call(arguments, 0);
        return pickBy("isAfter", args);
    }
    var now = function() {
        return Date.now ? Date.now() : +new Date();
    };
    var ordering = [
        "year",
        "quarter",
        "month",
        "week",
        "day",
        "hour",
        "minute",
        "second",
        "millisecond"
    ];
    function isDurationValid(m) {
        var key, unitHasDecimal = false, i, orderLen = ordering.length;
        for(key in m){
            if (hasOwnProp(m, key) && !(indexOf.call(ordering, key) !== -1 && (m[key] == null || !isNaN(m[key])))) return false;
        }
        for(i = 0; i < orderLen; ++i)if (m[ordering[i]]) {
            if (unitHasDecimal) return false; // only allow non-integers for smallest unit
            if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) unitHasDecimal = true;
        }
        return true;
    }
    function isValid$1() {
        return this._isValid;
    }
    function createInvalid$1() {
        return createDuration(NaN);
    }
    function Duration(duration) {
        var normalizedInput = normalizeObjectUnits(duration), years = normalizedInput.year || 0, quarters = normalizedInput.quarter || 0, months = normalizedInput.month || 0, weeks = normalizedInput.week || normalizedInput.isoWeek || 0, days = normalizedInput.day || 0, hours = normalizedInput.hour || 0, minutes = normalizedInput.minute || 0, seconds = normalizedInput.second || 0, milliseconds = normalizedInput.millisecond || 0;
        this._isValid = isDurationValid(normalizedInput);
        // representation for dateAddRemove
        this._milliseconds = +milliseconds + seconds * 1e3 + // 1000
        minutes * 6e4 + // 1000 * 60
        hours * 3600000; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
        // Because of dateAddRemove treats 24 hours as different from a
        // day when working around DST, we need to store them separately
        this._days = +days + weeks * 7;
        // It is impossible to translate months into days without knowing
        // which months you are are talking about, so we have to store
        // it separately.
        this._months = +months + quarters * 3 + years * 12;
        this._data = {};
        this._locale = getLocale();
        this._bubble();
    }
    function isDuration(obj) {
        return obj instanceof Duration;
    }
    function absRound(number) {
        if (number < 0) return Math.round(-1 * number) * -1;
        else return Math.round(number);
    }
    // compare two arrays, return the number of differences
    function compareArrays(array1, array2, dontConvert) {
        var len = Math.min(array1.length, array2.length), lengthDiff = Math.abs(array1.length - array2.length), diffs = 0, i;
        for(i = 0; i < len; i++)if (dontConvert && array1[i] !== array2[i] || !dontConvert && toInt(array1[i]) !== toInt(array2[i])) diffs++;
        return diffs + lengthDiff;
    }
    // FORMATTING
    function offset(token, separator) {
        addFormatToken(token, 0, 0, function() {
            var offset = this.utcOffset(), sign = "+";
            if (offset < 0) {
                offset = -offset;
                sign = "-";
            }
            return sign + zeroFill(~~(offset / 60), 2) + separator + zeroFill(~~offset % 60, 2);
        });
    }
    offset("Z", ":");
    offset("ZZ", "");
    // PARSING
    addRegexToken("Z", matchShortOffset);
    addRegexToken("ZZ", matchShortOffset);
    addParseToken([
        "Z",
        "ZZ"
    ], function(input, array, config) {
        config._useUTC = true;
        config._tzm = offsetFromString(matchShortOffset, input);
    });
    // HELPERS
    // timezone chunker
    // '+10:00' > ['10',  '00']
    // '-1530'  > ['-15', '30']
    var chunkOffset = /([\+\-]|\d\d)/gi;
    function offsetFromString(matcher, string) {
        var matches = (string || "").match(matcher), chunk, parts, minutes;
        if (matches === null) return null;
        chunk = matches[matches.length - 1] || [];
        parts = (chunk + "").match(chunkOffset) || [
            "-",
            0,
            0
        ];
        minutes = +(parts[1] * 60) + toInt(parts[2]);
        return minutes === 0 ? 0 : parts[0] === "+" ? minutes : -minutes;
    }
    // Return a moment from input, that is local/utc/zone equivalent to model.
    function cloneWithOffset(input, model) {
        var res, diff;
        if (model._isUTC) {
            res = model.clone();
            diff = (isMoment(input) || isDate(input) ? input.valueOf() : createLocal(input).valueOf()) - res.valueOf();
            // Use low-level api, because this fn is low-level api.
            res._d.setTime(res._d.valueOf() + diff);
            hooks.updateOffset(res, false);
            return res;
        } else return createLocal(input).local();
    }
    function getDateOffset(m) {
        // On Firefox.24 Date#getTimezoneOffset returns a floating point.
        // https://github.com/moment/moment/pull/1871
        return -Math.round(m._d.getTimezoneOffset());
    }
    // HOOKS
    // This function will be called whenever a moment is mutated.
    // It is intended to keep the offset in sync with the timezone.
    hooks.updateOffset = function() {};
    // MOMENTS
    // keepLocalTime = true means only change the timezone, without
    // affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
    // 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
    // +0200, so we adjust the time as needed, to be valid.
    //
    // Keeping the time actually adds/subtracts (one hour)
    // from the actual represented time. That is why we call updateOffset
    // a second time. In case it wants us to change the offset again
    // _changeInProgress == true case, then we have to adjust, because
    // there is no such time in the given timezone.
    function getSetOffset(input, keepLocalTime, keepMinutes) {
        var offset = this._offset || 0, localAdjust;
        if (!this.isValid()) return input != null ? this : NaN;
        if (input != null) {
            if (typeof input === "string") {
                input = offsetFromString(matchShortOffset, input);
                if (input === null) return this;
            } else if (Math.abs(input) < 16 && !keepMinutes) input = input * 60;
            if (!this._isUTC && keepLocalTime) localAdjust = getDateOffset(this);
            this._offset = input;
            this._isUTC = true;
            if (localAdjust != null) this.add(localAdjust, "m");
            if (offset !== input) {
                if (!keepLocalTime || this._changeInProgress) addSubtract(this, createDuration(input - offset, "m"), 1, false);
                else if (!this._changeInProgress) {
                    this._changeInProgress = true;
                    hooks.updateOffset(this, true);
                    this._changeInProgress = null;
                }
            }
            return this;
        } else return this._isUTC ? offset : getDateOffset(this);
    }
    function getSetZone(input, keepLocalTime) {
        if (input != null) {
            if (typeof input !== "string") input = -input;
            this.utcOffset(input, keepLocalTime);
            return this;
        } else return -this.utcOffset();
    }
    function setOffsetToUTC(keepLocalTime) {
        return this.utcOffset(0, keepLocalTime);
    }
    function setOffsetToLocal(keepLocalTime) {
        if (this._isUTC) {
            this.utcOffset(0, keepLocalTime);
            this._isUTC = false;
            if (keepLocalTime) this.subtract(getDateOffset(this), "m");
        }
        return this;
    }
    function setOffsetToParsedOffset() {
        if (this._tzm != null) this.utcOffset(this._tzm, false, true);
        else if (typeof this._i === "string") {
            var tZone = offsetFromString(matchOffset, this._i);
            if (tZone != null) this.utcOffset(tZone);
            else this.utcOffset(0, true);
        }
        return this;
    }
    function hasAlignedHourOffset(input) {
        if (!this.isValid()) return false;
        input = input ? createLocal(input).utcOffset() : 0;
        return (this.utcOffset() - input) % 60 === 0;
    }
    function isDaylightSavingTime() {
        return this.utcOffset() > this.clone().month(0).utcOffset() || this.utcOffset() > this.clone().month(5).utcOffset();
    }
    function isDaylightSavingTimeShifted() {
        if (!isUndefined(this._isDSTShifted)) return this._isDSTShifted;
        var c = {}, other;
        copyConfig(c, this);
        c = prepareConfig(c);
        if (c._a) {
            other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
            this._isDSTShifted = this.isValid() && compareArrays(c._a, other.toArray()) > 0;
        } else this._isDSTShifted = false;
        return this._isDSTShifted;
    }
    function isLocal() {
        return this.isValid() ? !this._isUTC : false;
    }
    function isUtcOffset() {
        return this.isValid() ? this._isUTC : false;
    }
    function isUtc() {
        return this.isValid() ? this._isUTC && this._offset === 0 : false;
    }
    // ASP.NET json date format regex
    var aspNetRegex = /^(-|\+)?(?:(\d*)[. ])?(\d+):(\d+)(?::(\d+)(\.\d*)?)?$/, // from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
    // somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
    // and further modified to allow for strings containing both week and day
    isoRegex = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;
    function createDuration(input, key) {
        var duration = input, // matching against regexp is expensive, do it on demand
        match = null, sign, ret, diffRes;
        if (isDuration(input)) duration = {
            ms: input._milliseconds,
            d: input._days,
            M: input._months
        };
        else if (isNumber(input) || !isNaN(+input)) {
            duration = {};
            if (key) duration[key] = +input;
            else duration.milliseconds = +input;
        } else if (match = aspNetRegex.exec(input)) {
            sign = match[1] === "-" ? -1 : 1;
            duration = {
                y: 0,
                d: toInt(match[DATE]) * sign,
                h: toInt(match[HOUR]) * sign,
                m: toInt(match[MINUTE]) * sign,
                s: toInt(match[SECOND]) * sign,
                ms: toInt(absRound(match[MILLISECOND] * 1000)) * sign
            };
        } else if (match = isoRegex.exec(input)) {
            sign = match[1] === "-" ? -1 : 1;
            duration = {
                y: parseIso(match[2], sign),
                M: parseIso(match[3], sign),
                w: parseIso(match[4], sign),
                d: parseIso(match[5], sign),
                h: parseIso(match[6], sign),
                m: parseIso(match[7], sign),
                s: parseIso(match[8], sign)
            };
        } else if (duration == null) // checks for null or undefined
        duration = {};
        else if (typeof duration === "object" && ("from" in duration || "to" in duration)) {
            diffRes = momentsDifference(createLocal(duration.from), createLocal(duration.to));
            duration = {};
            duration.ms = diffRes.milliseconds;
            duration.M = diffRes.months;
        }
        ret = new Duration(duration);
        if (isDuration(input) && hasOwnProp(input, "_locale")) ret._locale = input._locale;
        if (isDuration(input) && hasOwnProp(input, "_isValid")) ret._isValid = input._isValid;
        return ret;
    }
    createDuration.fn = Duration.prototype;
    createDuration.invalid = createInvalid$1;
    function parseIso(inp, sign) {
        // We'd normally use ~~inp for this, but unfortunately it also
        // converts floats to ints.
        // inp may be undefined, so careful calling replace on it.
        var res = inp && parseFloat(inp.replace(",", "."));
        // apply sign while we're at it
        return (isNaN(res) ? 0 : res) * sign;
    }
    function positiveMomentsDifference(base, other) {
        var res = {};
        res.months = other.month() - base.month() + (other.year() - base.year()) * 12;
        if (base.clone().add(res.months, "M").isAfter(other)) --res.months;
        res.milliseconds = +other - +base.clone().add(res.months, "M");
        return res;
    }
    function momentsDifference(base, other) {
        var res;
        if (!(base.isValid() && other.isValid())) return {
            milliseconds: 0,
            months: 0
        };
        other = cloneWithOffset(other, base);
        if (base.isBefore(other)) res = positiveMomentsDifference(base, other);
        else {
            res = positiveMomentsDifference(other, base);
            res.milliseconds = -res.milliseconds;
            res.months = -res.months;
        }
        return res;
    }
    // TODO: remove 'name' arg after deprecation is removed
    function createAdder(direction, name) {
        return function(val, period) {
            var dur, tmp;
            //invert the arguments, but complain about it
            if (period !== null && !isNaN(+period)) {
                deprecateSimple(name, "moment()." + name + "(period, number) is deprecated. Please use moment()." + name + "(number, period). " + "See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.");
                tmp = val;
                val = period;
                period = tmp;
            }
            dur = createDuration(val, period);
            addSubtract(this, dur, direction);
            return this;
        };
    }
    function addSubtract(mom, duration, isAdding, updateOffset) {
        var milliseconds = duration._milliseconds, days = absRound(duration._days), months = absRound(duration._months);
        if (!mom.isValid()) // No op
        return;
        updateOffset = updateOffset == null ? true : updateOffset;
        if (months) setMonth(mom, get(mom, "Month") + months * isAdding);
        if (days) set$1(mom, "Date", get(mom, "Date") + days * isAdding);
        if (milliseconds) mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
        if (updateOffset) hooks.updateOffset(mom, days || months);
    }
    var add = createAdder(1, "add"), subtract = createAdder(-1, "subtract");
    function isString(input) {
        return typeof input === "string" || input instanceof String;
    }
    // type MomentInput = Moment | Date | string | number | (number | string)[] | MomentInputObject | void; // null | undefined
    function isMomentInput(input) {
        return isMoment(input) || isDate(input) || isString(input) || isNumber(input) || isNumberOrStringArray(input) || isMomentInputObject(input) || input === null || input === undefined;
    }
    function isMomentInputObject(input) {
        var objectTest = isObject(input) && !isObjectEmpty(input), propertyTest = false, properties = [
            "years",
            "year",
            "y",
            "months",
            "month",
            "M",
            "days",
            "day",
            "d",
            "dates",
            "date",
            "D",
            "hours",
            "hour",
            "h",
            "minutes",
            "minute",
            "m",
            "seconds",
            "second",
            "s",
            "milliseconds",
            "millisecond",
            "ms"
        ], i, property, propertyLen = properties.length;
        for(i = 0; i < propertyLen; i += 1){
            property = properties[i];
            propertyTest = propertyTest || hasOwnProp(input, property);
        }
        return objectTest && propertyTest;
    }
    function isNumberOrStringArray(input) {
        var arrayTest = isArray(input), dataTypeTest = false;
        if (arrayTest) dataTypeTest = input.filter(function(item) {
            return !isNumber(item) && isString(input);
        }).length === 0;
        return arrayTest && dataTypeTest;
    }
    function isCalendarSpec(input) {
        var objectTest = isObject(input) && !isObjectEmpty(input), propertyTest = false, properties = [
            "sameDay",
            "nextDay",
            "lastDay",
            "nextWeek",
            "lastWeek",
            "sameElse"
        ], i, property;
        for(i = 0; i < properties.length; i += 1){
            property = properties[i];
            propertyTest = propertyTest || hasOwnProp(input, property);
        }
        return objectTest && propertyTest;
    }
    function getCalendarFormat(myMoment, now) {
        var diff = myMoment.diff(now, "days", true);
        return diff < -6 ? "sameElse" : diff < -1 ? "lastWeek" : diff < 0 ? "lastDay" : diff < 1 ? "sameDay" : diff < 2 ? "nextDay" : diff < 7 ? "nextWeek" : "sameElse";
    }
    function calendar$1(time, formats) {
        // Support for single parameter, formats only overload to the calendar function
        if (arguments.length === 1) {
            if (!arguments[0]) {
                time = undefined;
                formats = undefined;
            } else if (isMomentInput(arguments[0])) {
                time = arguments[0];
                formats = undefined;
            } else if (isCalendarSpec(arguments[0])) {
                formats = arguments[0];
                time = undefined;
            }
        }
        // We want to compare the start of today, vs this.
        // Getting start-of-today depends on whether we're local/utc/offset or not.
        var now = time || createLocal(), sod = cloneWithOffset(now, this).startOf("day"), format = hooks.calendarFormat(this, sod) || "sameElse", output = formats && (isFunction(formats[format]) ? formats[format].call(this, now) : formats[format]);
        return this.format(output || this.localeData().calendar(format, this, createLocal(now)));
    }
    function clone() {
        return new Moment(this);
    }
    function isAfter(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) return false;
        units = normalizeUnits(units) || "millisecond";
        if (units === "millisecond") return this.valueOf() > localInput.valueOf();
        else return localInput.valueOf() < this.clone().startOf(units).valueOf();
    }
    function isBefore(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) return false;
        units = normalizeUnits(units) || "millisecond";
        if (units === "millisecond") return this.valueOf() < localInput.valueOf();
        else return this.clone().endOf(units).valueOf() < localInput.valueOf();
    }
    function isBetween(from, to, units, inclusivity) {
        var localFrom = isMoment(from) ? from : createLocal(from), localTo = isMoment(to) ? to : createLocal(to);
        if (!(this.isValid() && localFrom.isValid() && localTo.isValid())) return false;
        inclusivity = inclusivity || "()";
        return (inclusivity[0] === "(" ? this.isAfter(localFrom, units) : !this.isBefore(localFrom, units)) && (inclusivity[1] === ")" ? this.isBefore(localTo, units) : !this.isAfter(localTo, units));
    }
    function isSame(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input), inputMs;
        if (!(this.isValid() && localInput.isValid())) return false;
        units = normalizeUnits(units) || "millisecond";
        if (units === "millisecond") return this.valueOf() === localInput.valueOf();
        else {
            inputMs = localInput.valueOf();
            return this.clone().startOf(units).valueOf() <= inputMs && inputMs <= this.clone().endOf(units).valueOf();
        }
    }
    function isSameOrAfter(input, units) {
        return this.isSame(input, units) || this.isAfter(input, units);
    }
    function isSameOrBefore(input, units) {
        return this.isSame(input, units) || this.isBefore(input, units);
    }
    function diff(input, units, asFloat) {
        var that, zoneDelta, output;
        if (!this.isValid()) return NaN;
        that = cloneWithOffset(input, this);
        if (!that.isValid()) return NaN;
        zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;
        units = normalizeUnits(units);
        switch(units){
            case "year":
                output = monthDiff(this, that) / 12;
                break;
            case "month":
                output = monthDiff(this, that);
                break;
            case "quarter":
                output = monthDiff(this, that) / 3;
                break;
            case "second":
                output = (this - that) / 1e3;
                break; // 1000
            case "minute":
                output = (this - that) / 6e4;
                break; // 1000 * 60
            case "hour":
                output = (this - that) / 36e5;
                break; // 1000 * 60 * 60
            case "day":
                output = (this - that - zoneDelta) / 864e5;
                break; // 1000 * 60 * 60 * 24, negate dst
            case "week":
                output = (this - that - zoneDelta) / 6048e5;
                break; // 1000 * 60 * 60 * 24 * 7, negate dst
            default:
                output = this - that;
        }
        return asFloat ? output : absFloor(output);
    }
    function monthDiff(a, b) {
        if (a.date() < b.date()) // end-of-month calculations work correct when the start month has more
        // days than the end month.
        return -monthDiff(b, a);
        // difference in months
        var wholeMonthDiff = (b.year() - a.year()) * 12 + (b.month() - a.month()), // b is in (anchor - 1 month, anchor + 1 month)
        anchor = a.clone().add(wholeMonthDiff, "months"), anchor2, adjust;
        if (b - anchor < 0) {
            anchor2 = a.clone().add(wholeMonthDiff - 1, "months");
            // linear across the month
            adjust = (b - anchor) / (anchor - anchor2);
        } else {
            anchor2 = a.clone().add(wholeMonthDiff + 1, "months");
            // linear across the month
            adjust = (b - anchor) / (anchor2 - anchor);
        }
        //check for negative zero, return zero if negative zero
        return -(wholeMonthDiff + adjust) || 0;
    }
    hooks.defaultFormat = "YYYY-MM-DDTHH:mm:ssZ";
    hooks.defaultFormatUtc = "YYYY-MM-DDTHH:mm:ss[Z]";
    function toString() {
        return this.clone().locale("en").format("ddd MMM DD YYYY HH:mm:ss [GMT]ZZ");
    }
    function toISOString(keepOffset) {
        if (!this.isValid()) return null;
        var utc = keepOffset !== true, m = utc ? this.clone().utc() : this;
        if (m.year() < 0 || m.year() > 9999) return formatMoment(m, utc ? "YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]" : "YYYYYY-MM-DD[T]HH:mm:ss.SSSZ");
        if (isFunction(Date.prototype.toISOString)) {
            // native implementation is ~50x faster, use it when we can
            if (utc) return this.toDate().toISOString();
            else return new Date(this.valueOf() + this.utcOffset() * 60000).toISOString().replace("Z", formatMoment(m, "Z"));
        }
        return formatMoment(m, utc ? "YYYY-MM-DD[T]HH:mm:ss.SSS[Z]" : "YYYY-MM-DD[T]HH:mm:ss.SSSZ");
    }
    /**
     * Return a human readable representation of a moment that can
     * also be evaluated to get a new moment which is the same
     *
     * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
     */ function inspect() {
        if (!this.isValid()) return "moment.invalid(/* " + this._i + " */)";
        var func = "moment", zone = "", prefix, year, datetime, suffix;
        if (!this.isLocal()) {
            func = this.utcOffset() === 0 ? "moment.utc" : "moment.parseZone";
            zone = "Z";
        }
        prefix = "[" + func + '("]';
        year = 0 <= this.year() && this.year() <= 9999 ? "YYYY" : "YYYYYY";
        datetime = "-MM-DD[T]HH:mm:ss.SSS";
        suffix = zone + '[")]';
        return this.format(prefix + year + datetime + suffix);
    }
    function format(inputString) {
        if (!inputString) inputString = this.isUtc() ? hooks.defaultFormatUtc : hooks.defaultFormat;
        var output = formatMoment(this, inputString);
        return this.localeData().postformat(output);
    }
    function from(time, withoutSuffix) {
        if (this.isValid() && (isMoment(time) && time.isValid() || createLocal(time).isValid())) return createDuration({
            to: this,
            from: time
        }).locale(this.locale()).humanize(!withoutSuffix);
        else return this.localeData().invalidDate();
    }
    function fromNow(withoutSuffix) {
        return this.from(createLocal(), withoutSuffix);
    }
    function to(time, withoutSuffix) {
        if (this.isValid() && (isMoment(time) && time.isValid() || createLocal(time).isValid())) return createDuration({
            from: this,
            to: time
        }).locale(this.locale()).humanize(!withoutSuffix);
        else return this.localeData().invalidDate();
    }
    function toNow(withoutSuffix) {
        return this.to(createLocal(), withoutSuffix);
    }
    // If passed a locale key, it will set the locale for this
    // instance.  Otherwise, it will return the locale configuration
    // variables for this instance.
    function locale(key) {
        var newLocaleData;
        if (key === undefined) return this._locale._abbr;
        else {
            newLocaleData = getLocale(key);
            if (newLocaleData != null) this._locale = newLocaleData;
            return this;
        }
    }
    var lang = deprecate("moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.", function(key) {
        if (key === undefined) return this.localeData();
        else return this.locale(key);
    });
    function localeData() {
        return this._locale;
    }
    var MS_PER_SECOND = 1000, MS_PER_MINUTE = 60 * MS_PER_SECOND, MS_PER_HOUR = 60 * MS_PER_MINUTE, MS_PER_400_YEARS = 3506328 * MS_PER_HOUR;
    // actual modulo - handles negative numbers (for dates before 1970):
    function mod$1(dividend, divisor) {
        return (dividend % divisor + divisor) % divisor;
    }
    function localStartOfDate(y, m, d) {
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) // preserve leap years using a full 400 year cycle, then reset
        return new Date(y + 400, m, d) - MS_PER_400_YEARS;
        else return new Date(y, m, d).valueOf();
    }
    function utcStartOfDate(y, m, d) {
        // Date.UTC remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) // preserve leap years using a full 400 year cycle, then reset
        return Date.UTC(y + 400, m, d) - MS_PER_400_YEARS;
        else return Date.UTC(y, m, d);
    }
    function startOf(units) {
        var time, startOfDate;
        units = normalizeUnits(units);
        if (units === undefined || units === "millisecond" || !this.isValid()) return this;
        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;
        switch(units){
            case "year":
                time = startOfDate(this.year(), 0, 1);
                break;
            case "quarter":
                time = startOfDate(this.year(), this.month() - this.month() % 3, 1);
                break;
            case "month":
                time = startOfDate(this.year(), this.month(), 1);
                break;
            case "week":
                time = startOfDate(this.year(), this.month(), this.date() - this.weekday());
                break;
            case "isoWeek":
                time = startOfDate(this.year(), this.month(), this.date() - (this.isoWeekday() - 1));
                break;
            case "day":
            case "date":
                time = startOfDate(this.year(), this.month(), this.date());
                break;
            case "hour":
                time = this._d.valueOf();
                time -= mod$1(time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE), MS_PER_HOUR);
                break;
            case "minute":
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_MINUTE);
                break;
            case "second":
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_SECOND);
                break;
        }
        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }
    function endOf(units) {
        var time, startOfDate;
        units = normalizeUnits(units);
        if (units === undefined || units === "millisecond" || !this.isValid()) return this;
        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;
        switch(units){
            case "year":
                time = startOfDate(this.year() + 1, 0, 1) - 1;
                break;
            case "quarter":
                time = startOfDate(this.year(), this.month() - this.month() % 3 + 3, 1) - 1;
                break;
            case "month":
                time = startOfDate(this.year(), this.month() + 1, 1) - 1;
                break;
            case "week":
                time = startOfDate(this.year(), this.month(), this.date() - this.weekday() + 7) - 1;
                break;
            case "isoWeek":
                time = startOfDate(this.year(), this.month(), this.date() - (this.isoWeekday() - 1) + 7) - 1;
                break;
            case "day":
            case "date":
                time = startOfDate(this.year(), this.month(), this.date() + 1) - 1;
                break;
            case "hour":
                time = this._d.valueOf();
                time += MS_PER_HOUR - mod$1(time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE), MS_PER_HOUR) - 1;
                break;
            case "minute":
                time = this._d.valueOf();
                time += MS_PER_MINUTE - mod$1(time, MS_PER_MINUTE) - 1;
                break;
            case "second":
                time = this._d.valueOf();
                time += MS_PER_SECOND - mod$1(time, MS_PER_SECOND) - 1;
                break;
        }
        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }
    function valueOf() {
        return this._d.valueOf() - (this._offset || 0) * 60000;
    }
    function unix() {
        return Math.floor(this.valueOf() / 1000);
    }
    function toDate() {
        return new Date(this.valueOf());
    }
    function toArray() {
        var m = this;
        return [
            m.year(),
            m.month(),
            m.date(),
            m.hour(),
            m.minute(),
            m.second(),
            m.millisecond()
        ];
    }
    function toObject() {
        var m = this;
        return {
            years: m.year(),
            months: m.month(),
            date: m.date(),
            hours: m.hours(),
            minutes: m.minutes(),
            seconds: m.seconds(),
            milliseconds: m.milliseconds()
        };
    }
    function toJSON() {
        // new Date(NaN).toJSON() === null
        return this.isValid() ? this.toISOString() : null;
    }
    function isValid$2() {
        return isValid(this);
    }
    function parsingFlags() {
        return extend({}, getParsingFlags(this));
    }
    function invalidAt() {
        return getParsingFlags(this).overflow;
    }
    function creationData() {
        return {
            input: this._i,
            format: this._f,
            locale: this._locale,
            isUTC: this._isUTC,
            strict: this._strict
        };
    }
    addFormatToken("N", 0, 0, "eraAbbr");
    addFormatToken("NN", 0, 0, "eraAbbr");
    addFormatToken("NNN", 0, 0, "eraAbbr");
    addFormatToken("NNNN", 0, 0, "eraName");
    addFormatToken("NNNNN", 0, 0, "eraNarrow");
    addFormatToken("y", [
        "y",
        1
    ], "yo", "eraYear");
    addFormatToken("y", [
        "yy",
        2
    ], 0, "eraYear");
    addFormatToken("y", [
        "yyy",
        3
    ], 0, "eraYear");
    addFormatToken("y", [
        "yyyy",
        4
    ], 0, "eraYear");
    addRegexToken("N", matchEraAbbr);
    addRegexToken("NN", matchEraAbbr);
    addRegexToken("NNN", matchEraAbbr);
    addRegexToken("NNNN", matchEraName);
    addRegexToken("NNNNN", matchEraNarrow);
    addParseToken([
        "N",
        "NN",
        "NNN",
        "NNNN",
        "NNNNN"
    ], function(input, array, config, token) {
        var era = config._locale.erasParse(input, token, config._strict);
        if (era) getParsingFlags(config).era = era;
        else getParsingFlags(config).invalidEra = input;
    });
    addRegexToken("y", matchUnsigned);
    addRegexToken("yy", matchUnsigned);
    addRegexToken("yyy", matchUnsigned);
    addRegexToken("yyyy", matchUnsigned);
    addRegexToken("yo", matchEraYearOrdinal);
    addParseToken([
        "y",
        "yy",
        "yyy",
        "yyyy"
    ], YEAR);
    addParseToken([
        "yo"
    ], function(input, array, config, token) {
        var match;
        if (config._locale._eraYearOrdinalRegex) match = input.match(config._locale._eraYearOrdinalRegex);
        if (config._locale.eraYearOrdinalParse) array[YEAR] = config._locale.eraYearOrdinalParse(input, match);
        else array[YEAR] = parseInt(input, 10);
    });
    function localeEras(m, format) {
        var i, l, date, eras = this._eras || getLocale("en")._eras;
        for(i = 0, l = eras.length; i < l; ++i){
            switch(typeof eras[i].since){
                case "string":
                    // truncate time
                    date = hooks(eras[i].since).startOf("day");
                    eras[i].since = date.valueOf();
                    break;
            }
            switch(typeof eras[i].until){
                case "undefined":
                    eras[i].until = Infinity;
                    break;
                case "string":
                    // truncate time
                    date = hooks(eras[i].until).startOf("day").valueOf();
                    eras[i].until = date.valueOf();
                    break;
            }
        }
        return eras;
    }
    function localeErasParse(eraName, format, strict) {
        var i, l, eras = this.eras(), name, abbr, narrow;
        eraName = eraName.toUpperCase();
        for(i = 0, l = eras.length; i < l; ++i){
            name = eras[i].name.toUpperCase();
            abbr = eras[i].abbr.toUpperCase();
            narrow = eras[i].narrow.toUpperCase();
            if (strict) switch(format){
                case "N":
                case "NN":
                case "NNN":
                    if (abbr === eraName) return eras[i];
                    break;
                case "NNNN":
                    if (name === eraName) return eras[i];
                    break;
                case "NNNNN":
                    if (narrow === eraName) return eras[i];
                    break;
            }
            else if ([
                name,
                abbr,
                narrow
            ].indexOf(eraName) >= 0) return eras[i];
        }
    }
    function localeErasConvertYear(era, year) {
        var dir = era.since <= era.until ? 1 : -1;
        if (year === undefined) return hooks(era.since).year();
        else return hooks(era.since).year() + (year - era.offset) * dir;
    }
    function getEraName() {
        var i, l, val, eras = this.localeData().eras();
        for(i = 0, l = eras.length; i < l; ++i){
            // truncate time
            val = this.clone().startOf("day").valueOf();
            if (eras[i].since <= val && val <= eras[i].until) return eras[i].name;
            if (eras[i].until <= val && val <= eras[i].since) return eras[i].name;
        }
        return "";
    }
    function getEraNarrow() {
        var i, l, val, eras = this.localeData().eras();
        for(i = 0, l = eras.length; i < l; ++i){
            // truncate time
            val = this.clone().startOf("day").valueOf();
            if (eras[i].since <= val && val <= eras[i].until) return eras[i].narrow;
            if (eras[i].until <= val && val <= eras[i].since) return eras[i].narrow;
        }
        return "";
    }
    function getEraAbbr() {
        var i, l, val, eras = this.localeData().eras();
        for(i = 0, l = eras.length; i < l; ++i){
            // truncate time
            val = this.clone().startOf("day").valueOf();
            if (eras[i].since <= val && val <= eras[i].until) return eras[i].abbr;
            if (eras[i].until <= val && val <= eras[i].since) return eras[i].abbr;
        }
        return "";
    }
    function getEraYear() {
        var i, l, dir, val, eras = this.localeData().eras();
        for(i = 0, l = eras.length; i < l; ++i){
            dir = eras[i].since <= eras[i].until ? 1 : -1;
            // truncate time
            val = this.clone().startOf("day").valueOf();
            if (eras[i].since <= val && val <= eras[i].until || eras[i].until <= val && val <= eras[i].since) return (this.year() - hooks(eras[i].since).year()) * dir + eras[i].offset;
        }
        return this.year();
    }
    function erasNameRegex(isStrict) {
        if (!hasOwnProp(this, "_erasNameRegex")) computeErasParse.call(this);
        return isStrict ? this._erasNameRegex : this._erasRegex;
    }
    function erasAbbrRegex(isStrict) {
        if (!hasOwnProp(this, "_erasAbbrRegex")) computeErasParse.call(this);
        return isStrict ? this._erasAbbrRegex : this._erasRegex;
    }
    function erasNarrowRegex(isStrict) {
        if (!hasOwnProp(this, "_erasNarrowRegex")) computeErasParse.call(this);
        return isStrict ? this._erasNarrowRegex : this._erasRegex;
    }
    function matchEraAbbr(isStrict, locale) {
        return locale.erasAbbrRegex(isStrict);
    }
    function matchEraName(isStrict, locale) {
        return locale.erasNameRegex(isStrict);
    }
    function matchEraNarrow(isStrict, locale) {
        return locale.erasNarrowRegex(isStrict);
    }
    function matchEraYearOrdinal(isStrict, locale) {
        return locale._eraYearOrdinalRegex || matchUnsigned;
    }
    function computeErasParse() {
        var abbrPieces = [], namePieces = [], narrowPieces = [], mixedPieces = [], i, l, eras = this.eras();
        for(i = 0, l = eras.length; i < l; ++i){
            namePieces.push(regexEscape(eras[i].name));
            abbrPieces.push(regexEscape(eras[i].abbr));
            narrowPieces.push(regexEscape(eras[i].narrow));
            mixedPieces.push(regexEscape(eras[i].name));
            mixedPieces.push(regexEscape(eras[i].abbr));
            mixedPieces.push(regexEscape(eras[i].narrow));
        }
        this._erasRegex = new RegExp("^(" + mixedPieces.join("|") + ")", "i");
        this._erasNameRegex = new RegExp("^(" + namePieces.join("|") + ")", "i");
        this._erasAbbrRegex = new RegExp("^(" + abbrPieces.join("|") + ")", "i");
        this._erasNarrowRegex = new RegExp("^(" + narrowPieces.join("|") + ")", "i");
    }
    // FORMATTING
    addFormatToken(0, [
        "gg",
        2
    ], 0, function() {
        return this.weekYear() % 100;
    });
    addFormatToken(0, [
        "GG",
        2
    ], 0, function() {
        return this.isoWeekYear() % 100;
    });
    function addWeekYearFormatToken(token, getter) {
        addFormatToken(0, [
            token,
            token.length
        ], 0, getter);
    }
    addWeekYearFormatToken("gggg", "weekYear");
    addWeekYearFormatToken("ggggg", "weekYear");
    addWeekYearFormatToken("GGGG", "isoWeekYear");
    addWeekYearFormatToken("GGGGG", "isoWeekYear");
    // ALIASES
    addUnitAlias("weekYear", "gg");
    addUnitAlias("isoWeekYear", "GG");
    // PRIORITY
    addUnitPriority("weekYear", 1);
    addUnitPriority("isoWeekYear", 1);
    // PARSING
    addRegexToken("G", matchSigned);
    addRegexToken("g", matchSigned);
    addRegexToken("GG", match1to2, match2);
    addRegexToken("gg", match1to2, match2);
    addRegexToken("GGGG", match1to4, match4);
    addRegexToken("gggg", match1to4, match4);
    addRegexToken("GGGGG", match1to6, match6);
    addRegexToken("ggggg", match1to6, match6);
    addWeekParseToken([
        "gggg",
        "ggggg",
        "GGGG",
        "GGGGG"
    ], function(input, week, config, token) {
        week[token.substr(0, 2)] = toInt(input);
    });
    addWeekParseToken([
        "gg",
        "GG"
    ], function(input, week, config, token) {
        week[token] = hooks.parseTwoDigitYear(input);
    });
    // MOMENTS
    function getSetWeekYear(input) {
        return getSetWeekYearHelper.call(this, input, this.week(), this.weekday(), this.localeData()._week.dow, this.localeData()._week.doy);
    }
    function getSetISOWeekYear(input) {
        return getSetWeekYearHelper.call(this, input, this.isoWeek(), this.isoWeekday(), 1, 4);
    }
    function getISOWeeksInYear() {
        return weeksInYear(this.year(), 1, 4);
    }
    function getISOWeeksInISOWeekYear() {
        return weeksInYear(this.isoWeekYear(), 1, 4);
    }
    function getWeeksInYear() {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
    }
    function getWeeksInWeekYear() {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.weekYear(), weekInfo.dow, weekInfo.doy);
    }
    function getSetWeekYearHelper(input, week, weekday, dow, doy) {
        var weeksTarget;
        if (input == null) return weekOfYear(this, dow, doy).year;
        else {
            weeksTarget = weeksInYear(input, dow, doy);
            if (week > weeksTarget) week = weeksTarget;
            return setWeekAll.call(this, input, week, weekday, dow, doy);
        }
    }
    function setWeekAll(weekYear, week, weekday, dow, doy) {
        var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy), date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);
        this.year(date.getUTCFullYear());
        this.month(date.getUTCMonth());
        this.date(date.getUTCDate());
        return this;
    }
    // FORMATTING
    addFormatToken("Q", 0, "Qo", "quarter");
    // ALIASES
    addUnitAlias("quarter", "Q");
    // PRIORITY
    addUnitPriority("quarter", 7);
    // PARSING
    addRegexToken("Q", match1);
    addParseToken("Q", function(input, array) {
        array[MONTH] = (toInt(input) - 1) * 3;
    });
    // MOMENTS
    function getSetQuarter(input) {
        return input == null ? Math.ceil((this.month() + 1) / 3) : this.month((input - 1) * 3 + this.month() % 3);
    }
    // FORMATTING
    addFormatToken("D", [
        "DD",
        2
    ], "Do", "date");
    // ALIASES
    addUnitAlias("date", "D");
    // PRIORITY
    addUnitPriority("date", 9);
    // PARSING
    addRegexToken("D", match1to2);
    addRegexToken("DD", match1to2, match2);
    addRegexToken("Do", function(isStrict, locale) {
        // TODO: Remove "ordinalParse" fallback in next major release.
        return isStrict ? locale._dayOfMonthOrdinalParse || locale._ordinalParse : locale._dayOfMonthOrdinalParseLenient;
    });
    addParseToken([
        "D",
        "DD"
    ], DATE);
    addParseToken("Do", function(input, array) {
        array[DATE] = toInt(input.match(match1to2)[0]);
    });
    // MOMENTS
    var getSetDayOfMonth = makeGetSet("Date", true);
    // FORMATTING
    addFormatToken("DDD", [
        "DDDD",
        3
    ], "DDDo", "dayOfYear");
    // ALIASES
    addUnitAlias("dayOfYear", "DDD");
    // PRIORITY
    addUnitPriority("dayOfYear", 4);
    // PARSING
    addRegexToken("DDD", match1to3);
    addRegexToken("DDDD", match3);
    addParseToken([
        "DDD",
        "DDDD"
    ], function(input, array, config) {
        config._dayOfYear = toInt(input);
    });
    // HELPERS
    // MOMENTS
    function getSetDayOfYear(input) {
        var dayOfYear = Math.round((this.clone().startOf("day") - this.clone().startOf("year")) / 864e5) + 1;
        return input == null ? dayOfYear : this.add(input - dayOfYear, "d");
    }
    // FORMATTING
    addFormatToken("m", [
        "mm",
        2
    ], 0, "minute");
    // ALIASES
    addUnitAlias("minute", "m");
    // PRIORITY
    addUnitPriority("minute", 14);
    // PARSING
    addRegexToken("m", match1to2);
    addRegexToken("mm", match1to2, match2);
    addParseToken([
        "m",
        "mm"
    ], MINUTE);
    // MOMENTS
    var getSetMinute = makeGetSet("Minutes", false);
    // FORMATTING
    addFormatToken("s", [
        "ss",
        2
    ], 0, "second");
    // ALIASES
    addUnitAlias("second", "s");
    // PRIORITY
    addUnitPriority("second", 15);
    // PARSING
    addRegexToken("s", match1to2);
    addRegexToken("ss", match1to2, match2);
    addParseToken([
        "s",
        "ss"
    ], SECOND);
    // MOMENTS
    var getSetSecond = makeGetSet("Seconds", false);
    // FORMATTING
    addFormatToken("S", 0, 0, function() {
        return ~~(this.millisecond() / 100);
    });
    addFormatToken(0, [
        "SS",
        2
    ], 0, function() {
        return ~~(this.millisecond() / 10);
    });
    addFormatToken(0, [
        "SSS",
        3
    ], 0, "millisecond");
    addFormatToken(0, [
        "SSSS",
        4
    ], 0, function() {
        return this.millisecond() * 10;
    });
    addFormatToken(0, [
        "SSSSS",
        5
    ], 0, function() {
        return this.millisecond() * 100;
    });
    addFormatToken(0, [
        "SSSSSS",
        6
    ], 0, function() {
        return this.millisecond() * 1000;
    });
    addFormatToken(0, [
        "SSSSSSS",
        7
    ], 0, function() {
        return this.millisecond() * 10000;
    });
    addFormatToken(0, [
        "SSSSSSSS",
        8
    ], 0, function() {
        return this.millisecond() * 100000;
    });
    addFormatToken(0, [
        "SSSSSSSSS",
        9
    ], 0, function() {
        return this.millisecond() * 1000000;
    });
    // ALIASES
    addUnitAlias("millisecond", "ms");
    // PRIORITY
    addUnitPriority("millisecond", 16);
    // PARSING
    addRegexToken("S", match1to3, match1);
    addRegexToken("SS", match1to3, match2);
    addRegexToken("SSS", match1to3, match3);
    var token, getSetMillisecond;
    for(token = "SSSS"; token.length <= 9; token += "S")addRegexToken(token, matchUnsigned);
    function parseMs(input, array) {
        array[MILLISECOND] = toInt(("0." + input) * 1000);
    }
    for(token = "S"; token.length <= 9; token += "S")addParseToken(token, parseMs);
    getSetMillisecond = makeGetSet("Milliseconds", false);
    // FORMATTING
    addFormatToken("z", 0, 0, "zoneAbbr");
    addFormatToken("zz", 0, 0, "zoneName");
    // MOMENTS
    function getZoneAbbr() {
        return this._isUTC ? "UTC" : "";
    }
    function getZoneName() {
        return this._isUTC ? "Coordinated Universal Time" : "";
    }
    var proto = Moment.prototype;
    proto.add = add;
    proto.calendar = calendar$1;
    proto.clone = clone;
    proto.diff = diff;
    proto.endOf = endOf;
    proto.format = format;
    proto.from = from;
    proto.fromNow = fromNow;
    proto.to = to;
    proto.toNow = toNow;
    proto.get = stringGet;
    proto.invalidAt = invalidAt;
    proto.isAfter = isAfter;
    proto.isBefore = isBefore;
    proto.isBetween = isBetween;
    proto.isSame = isSame;
    proto.isSameOrAfter = isSameOrAfter;
    proto.isSameOrBefore = isSameOrBefore;
    proto.isValid = isValid$2;
    proto.lang = lang;
    proto.locale = locale;
    proto.localeData = localeData;
    proto.max = prototypeMax;
    proto.min = prototypeMin;
    proto.parsingFlags = parsingFlags;
    proto.set = stringSet;
    proto.startOf = startOf;
    proto.subtract = subtract;
    proto.toArray = toArray;
    proto.toObject = toObject;
    proto.toDate = toDate;
    proto.toISOString = toISOString;
    proto.inspect = inspect;
    if (typeof Symbol !== "undefined" && Symbol.for != null) proto[Symbol.for("nodejs.util.inspect.custom")] = function() {
        return "Moment<" + this.format() + ">";
    };
    proto.toJSON = toJSON;
    proto.toString = toString;
    proto.unix = unix;
    proto.valueOf = valueOf;
    proto.creationData = creationData;
    proto.eraName = getEraName;
    proto.eraNarrow = getEraNarrow;
    proto.eraAbbr = getEraAbbr;
    proto.eraYear = getEraYear;
    proto.year = getSetYear;
    proto.isLeapYear = getIsLeapYear;
    proto.weekYear = getSetWeekYear;
    proto.isoWeekYear = getSetISOWeekYear;
    proto.quarter = proto.quarters = getSetQuarter;
    proto.month = getSetMonth;
    proto.daysInMonth = getDaysInMonth;
    proto.week = proto.weeks = getSetWeek;
    proto.isoWeek = proto.isoWeeks = getSetISOWeek;
    proto.weeksInYear = getWeeksInYear;
    proto.weeksInWeekYear = getWeeksInWeekYear;
    proto.isoWeeksInYear = getISOWeeksInYear;
    proto.isoWeeksInISOWeekYear = getISOWeeksInISOWeekYear;
    proto.date = getSetDayOfMonth;
    proto.day = proto.days = getSetDayOfWeek;
    proto.weekday = getSetLocaleDayOfWeek;
    proto.isoWeekday = getSetISODayOfWeek;
    proto.dayOfYear = getSetDayOfYear;
    proto.hour = proto.hours = getSetHour;
    proto.minute = proto.minutes = getSetMinute;
    proto.second = proto.seconds = getSetSecond;
    proto.millisecond = proto.milliseconds = getSetMillisecond;
    proto.utcOffset = getSetOffset;
    proto.utc = setOffsetToUTC;
    proto.local = setOffsetToLocal;
    proto.parseZone = setOffsetToParsedOffset;
    proto.hasAlignedHourOffset = hasAlignedHourOffset;
    proto.isDST = isDaylightSavingTime;
    proto.isLocal = isLocal;
    proto.isUtcOffset = isUtcOffset;
    proto.isUtc = isUtc;
    proto.isUTC = isUtc;
    proto.zoneAbbr = getZoneAbbr;
    proto.zoneName = getZoneName;
    proto.dates = deprecate("dates accessor is deprecated. Use date instead.", getSetDayOfMonth);
    proto.months = deprecate("months accessor is deprecated. Use month instead", getSetMonth);
    proto.years = deprecate("years accessor is deprecated. Use year instead", getSetYear);
    proto.zone = deprecate("moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/", getSetZone);
    proto.isDSTShifted = deprecate("isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information", isDaylightSavingTimeShifted);
    function createUnix(input) {
        return createLocal(input * 1000);
    }
    function createInZone() {
        return createLocal.apply(null, arguments).parseZone();
    }
    function preParsePostFormat(string) {
        return string;
    }
    var proto$1 = Locale.prototype;
    proto$1.calendar = calendar;
    proto$1.longDateFormat = longDateFormat;
    proto$1.invalidDate = invalidDate;
    proto$1.ordinal = ordinal;
    proto$1.preparse = preParsePostFormat;
    proto$1.postformat = preParsePostFormat;
    proto$1.relativeTime = relativeTime;
    proto$1.pastFuture = pastFuture;
    proto$1.set = set;
    proto$1.eras = localeEras;
    proto$1.erasParse = localeErasParse;
    proto$1.erasConvertYear = localeErasConvertYear;
    proto$1.erasAbbrRegex = erasAbbrRegex;
    proto$1.erasNameRegex = erasNameRegex;
    proto$1.erasNarrowRegex = erasNarrowRegex;
    proto$1.months = localeMonths;
    proto$1.monthsShort = localeMonthsShort;
    proto$1.monthsParse = localeMonthsParse;
    proto$1.monthsRegex = monthsRegex;
    proto$1.monthsShortRegex = monthsShortRegex;
    proto$1.week = localeWeek;
    proto$1.firstDayOfYear = localeFirstDayOfYear;
    proto$1.firstDayOfWeek = localeFirstDayOfWeek;
    proto$1.weekdays = localeWeekdays;
    proto$1.weekdaysMin = localeWeekdaysMin;
    proto$1.weekdaysShort = localeWeekdaysShort;
    proto$1.weekdaysParse = localeWeekdaysParse;
    proto$1.weekdaysRegex = weekdaysRegex;
    proto$1.weekdaysShortRegex = weekdaysShortRegex;
    proto$1.weekdaysMinRegex = weekdaysMinRegex;
    proto$1.isPM = localeIsPM;
    proto$1.meridiem = localeMeridiem;
    function get$1(format, index, field, setter) {
        var locale = getLocale(), utc = createUTC().set(setter, index);
        return locale[field](utc, format);
    }
    function listMonthsImpl(format, index, field) {
        if (isNumber(format)) {
            index = format;
            format = undefined;
        }
        format = format || "";
        if (index != null) return get$1(format, index, field, "month");
        var i, out = [];
        for(i = 0; i < 12; i++)out[i] = get$1(format, i, field, "month");
        return out;
    }
    // ()
    // (5)
    // (fmt, 5)
    // (fmt)
    // (true)
    // (true, 5)
    // (true, fmt, 5)
    // (true, fmt)
    function listWeekdaysImpl(localeSorted, format, index, field) {
        if (typeof localeSorted === "boolean") {
            if (isNumber(format)) {
                index = format;
                format = undefined;
            }
            format = format || "";
        } else {
            format = localeSorted;
            index = format;
            localeSorted = false;
            if (isNumber(format)) {
                index = format;
                format = undefined;
            }
            format = format || "";
        }
        var locale = getLocale(), shift = localeSorted ? locale._week.dow : 0, i, out = [];
        if (index != null) return get$1(format, (index + shift) % 7, field, "day");
        for(i = 0; i < 7; i++)out[i] = get$1(format, (i + shift) % 7, field, "day");
        return out;
    }
    function listMonths(format, index) {
        return listMonthsImpl(format, index, "months");
    }
    function listMonthsShort(format, index) {
        return listMonthsImpl(format, index, "monthsShort");
    }
    function listWeekdays(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, "weekdays");
    }
    function listWeekdaysShort(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, "weekdaysShort");
    }
    function listWeekdaysMin(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, "weekdaysMin");
    }
    getSetGlobalLocale("en", {
        eras: [
            {
                since: "0001-01-01",
                until: Infinity,
                offset: 1,
                name: "Anno Domini",
                narrow: "AD",
                abbr: "AD"
            },
            {
                since: "0000-12-31",
                until: -Infinity,
                offset: 1,
                name: "Before Christ",
                narrow: "BC",
                abbr: "BC"
            }
        ],
        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
        ordinal: function(number) {
            var b = number % 10, output = toInt(number % 100 / 10) === 1 ? "th" : b === 1 ? "st" : b === 2 ? "nd" : b === 3 ? "rd" : "th";
            return number + output;
        }
    });
    // Side effect imports
    hooks.lang = deprecate("moment.lang is deprecated. Use moment.locale instead.", getSetGlobalLocale);
    hooks.langData = deprecate("moment.langData is deprecated. Use moment.localeData instead.", getLocale);
    var mathAbs = Math.abs;
    function abs() {
        var data = this._data;
        this._milliseconds = mathAbs(this._milliseconds);
        this._days = mathAbs(this._days);
        this._months = mathAbs(this._months);
        data.milliseconds = mathAbs(data.milliseconds);
        data.seconds = mathAbs(data.seconds);
        data.minutes = mathAbs(data.minutes);
        data.hours = mathAbs(data.hours);
        data.months = mathAbs(data.months);
        data.years = mathAbs(data.years);
        return this;
    }
    function addSubtract$1(duration, input, value, direction) {
        var other = createDuration(input, value);
        duration._milliseconds += direction * other._milliseconds;
        duration._days += direction * other._days;
        duration._months += direction * other._months;
        return duration._bubble();
    }
    // supports only 2.0-style add(1, 's') or add(duration)
    function add$1(input, value) {
        return addSubtract$1(this, input, value, 1);
    }
    // supports only 2.0-style subtract(1, 's') or subtract(duration)
    function subtract$1(input, value) {
        return addSubtract$1(this, input, value, -1);
    }
    function absCeil(number) {
        if (number < 0) return Math.floor(number);
        else return Math.ceil(number);
    }
    function bubble() {
        var milliseconds = this._milliseconds, days = this._days, months = this._months, data = this._data, seconds, minutes, hours, years, monthsFromDays;
        // if we have a mix of positive and negative values, bubble down first
        // check: https://github.com/moment/moment/issues/2166
        if (!(milliseconds >= 0 && days >= 0 && months >= 0 || milliseconds <= 0 && days <= 0 && months <= 0)) {
            milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
            days = 0;
            months = 0;
        }
        // The following code bubbles up values, see the tests for
        // examples of what that means.
        data.milliseconds = milliseconds % 1000;
        seconds = absFloor(milliseconds / 1000);
        data.seconds = seconds % 60;
        minutes = absFloor(seconds / 60);
        data.minutes = minutes % 60;
        hours = absFloor(minutes / 60);
        data.hours = hours % 24;
        days += absFloor(hours / 24);
        // convert days to months
        monthsFromDays = absFloor(daysToMonths(days));
        months += monthsFromDays;
        days -= absCeil(monthsToDays(monthsFromDays));
        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;
        data.days = days;
        data.months = months;
        data.years = years;
        return this;
    }
    function daysToMonths(days) {
        // 400 years have 146097 days (taking into account leap year rules)
        // 400 years have 12 months === 4800
        return days * 4800 / 146097;
    }
    function monthsToDays(months) {
        // the reverse of daysToMonths
        return months * 146097 / 4800;
    }
    function as(units) {
        if (!this.isValid()) return NaN;
        var days, months, milliseconds = this._milliseconds;
        units = normalizeUnits(units);
        if (units === "month" || units === "quarter" || units === "year") {
            days = this._days + milliseconds / 864e5;
            months = this._months + daysToMonths(days);
            switch(units){
                case "month":
                    return months;
                case "quarter":
                    return months / 3;
                case "year":
                    return months / 12;
            }
        } else {
            // handle milliseconds separately because of floating point math errors (issue #1867)
            days = this._days + Math.round(monthsToDays(this._months));
            switch(units){
                case "week":
                    return days / 7 + milliseconds / 6048e5;
                case "day":
                    return days + milliseconds / 864e5;
                case "hour":
                    return days * 24 + milliseconds / 36e5;
                case "minute":
                    return days * 1440 + milliseconds / 6e4;
                case "second":
                    return days * 86400 + milliseconds / 1000;
                // Math.floor prevents floating point math errors here
                case "millisecond":
                    return Math.floor(days * 864e5) + milliseconds;
                default:
                    throw new Error("Unknown unit " + units);
            }
        }
    }
    // TODO: Use this.as('ms')?
    function valueOf$1() {
        if (!this.isValid()) return NaN;
        return this._milliseconds + this._days * 864e5 + this._months % 12 * 2592e6 + toInt(this._months / 12) * 31536e6;
    }
    function makeAs(alias) {
        return function() {
            return this.as(alias);
        };
    }
    var asMilliseconds = makeAs("ms"), asSeconds = makeAs("s"), asMinutes = makeAs("m"), asHours = makeAs("h"), asDays = makeAs("d"), asWeeks = makeAs("w"), asMonths = makeAs("M"), asQuarters = makeAs("Q"), asYears = makeAs("y");
    function clone$1() {
        return createDuration(this);
    }
    function get$2(units) {
        units = normalizeUnits(units);
        return this.isValid() ? this[units + "s"]() : NaN;
    }
    function makeGetter(name) {
        return function() {
            return this.isValid() ? this._data[name] : NaN;
        };
    }
    var milliseconds = makeGetter("milliseconds"), seconds = makeGetter("seconds"), minutes = makeGetter("minutes"), hours = makeGetter("hours"), days = makeGetter("days"), months = makeGetter("months"), years = makeGetter("years");
    function weeks() {
        return absFloor(this.days() / 7);
    }
    var round = Math.round, thresholds = {
        ss: 44,
        s: 45,
        m: 45,
        h: 22,
        d: 26,
        w: null,
        M: 11
    };
    // helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
    function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
        return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
    }
    function relativeTime$1(posNegDuration, withoutSuffix, thresholds, locale) {
        var duration = createDuration(posNegDuration).abs(), seconds = round(duration.as("s")), minutes = round(duration.as("m")), hours = round(duration.as("h")), days = round(duration.as("d")), months = round(duration.as("M")), weeks = round(duration.as("w")), years = round(duration.as("y")), a = seconds <= thresholds.ss && [
            "s",
            seconds
        ] || seconds < thresholds.s && [
            "ss",
            seconds
        ] || minutes <= 1 && [
            "m"
        ] || minutes < thresholds.m && [
            "mm",
            minutes
        ] || hours <= 1 && [
            "h"
        ] || hours < thresholds.h && [
            "hh",
            hours
        ] || days <= 1 && [
            "d"
        ] || days < thresholds.d && [
            "dd",
            days
        ];
        if (thresholds.w != null) a = a || weeks <= 1 && [
            "w"
        ] || weeks < thresholds.w && [
            "ww",
            weeks
        ];
        a = a || months <= 1 && [
            "M"
        ] || months < thresholds.M && [
            "MM",
            months
        ] || years <= 1 && [
            "y"
        ] || [
            "yy",
            years
        ];
        a[2] = withoutSuffix;
        a[3] = +posNegDuration > 0;
        a[4] = locale;
        return substituteTimeAgo.apply(null, a);
    }
    // This function allows you to set the rounding function for relative time strings
    function getSetRelativeTimeRounding(roundingFunction) {
        if (roundingFunction === undefined) return round;
        if (typeof roundingFunction === "function") {
            round = roundingFunction;
            return true;
        }
        return false;
    }
    // This function allows you to set a threshold for relative time strings
    function getSetRelativeTimeThreshold(threshold, limit) {
        if (thresholds[threshold] === undefined) return false;
        if (limit === undefined) return thresholds[threshold];
        thresholds[threshold] = limit;
        if (threshold === "s") thresholds.ss = limit - 1;
        return true;
    }
    function humanize(argWithSuffix, argThresholds) {
        if (!this.isValid()) return this.localeData().invalidDate();
        var withSuffix = false, th = thresholds, locale, output;
        if (typeof argWithSuffix === "object") {
            argThresholds = argWithSuffix;
            argWithSuffix = false;
        }
        if (typeof argWithSuffix === "boolean") withSuffix = argWithSuffix;
        if (typeof argThresholds === "object") {
            th = Object.assign({}, thresholds, argThresholds);
            if (argThresholds.s != null && argThresholds.ss == null) th.ss = argThresholds.s - 1;
        }
        locale = this.localeData();
        output = relativeTime$1(this, !withSuffix, th, locale);
        if (withSuffix) output = locale.pastFuture(+this, output);
        return locale.postformat(output);
    }
    var abs$1 = Math.abs;
    function sign(x) {
        return (x > 0) - (x < 0) || +x;
    }
    function toISOString$1() {
        // for ISO strings we do not use the normal bubbling rules:
        //  * milliseconds bubble up until they become hours
        //  * days do not bubble at all
        //  * months bubble up until they become years
        // This is because there is no context-free conversion between hours and days
        // (think of clock changes)
        // and also not between days and months (28-31 days per month)
        if (!this.isValid()) return this.localeData().invalidDate();
        var seconds = abs$1(this._milliseconds) / 1000, days = abs$1(this._days), months = abs$1(this._months), minutes, hours, years, s, total = this.asSeconds(), totalSign, ymSign, daysSign, hmsSign;
        if (!total) // this is the same as C#'s (Noda) and python (isodate)...
        // but not other JS (goog.date)
        return "P0D";
        // 3600 seconds -> 60 minutes -> 1 hour
        minutes = absFloor(seconds / 60);
        hours = absFloor(minutes / 60);
        seconds %= 60;
        minutes %= 60;
        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;
        // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
        s = seconds ? seconds.toFixed(3).replace(/\.?0+$/, "") : "";
        totalSign = total < 0 ? "-" : "";
        ymSign = sign(this._months) !== sign(total) ? "-" : "";
        daysSign = sign(this._days) !== sign(total) ? "-" : "";
        hmsSign = sign(this._milliseconds) !== sign(total) ? "-" : "";
        return totalSign + "P" + (years ? ymSign + years + "Y" : "") + (months ? ymSign + months + "M" : "") + (days ? daysSign + days + "D" : "") + (hours || minutes || seconds ? "T" : "") + (hours ? hmsSign + hours + "H" : "") + (minutes ? hmsSign + minutes + "M" : "") + (seconds ? hmsSign + s + "S" : "");
    }
    var proto$2 = Duration.prototype;
    proto$2.isValid = isValid$1;
    proto$2.abs = abs;
    proto$2.add = add$1;
    proto$2.subtract = subtract$1;
    proto$2.as = as;
    proto$2.asMilliseconds = asMilliseconds;
    proto$2.asSeconds = asSeconds;
    proto$2.asMinutes = asMinutes;
    proto$2.asHours = asHours;
    proto$2.asDays = asDays;
    proto$2.asWeeks = asWeeks;
    proto$2.asMonths = asMonths;
    proto$2.asQuarters = asQuarters;
    proto$2.asYears = asYears;
    proto$2.valueOf = valueOf$1;
    proto$2._bubble = bubble;
    proto$2.clone = clone$1;
    proto$2.get = get$2;
    proto$2.milliseconds = milliseconds;
    proto$2.seconds = seconds;
    proto$2.minutes = minutes;
    proto$2.hours = hours;
    proto$2.days = days;
    proto$2.weeks = weeks;
    proto$2.months = months;
    proto$2.years = years;
    proto$2.humanize = humanize;
    proto$2.toISOString = toISOString$1;
    proto$2.toString = toISOString$1;
    proto$2.toJSON = toISOString$1;
    proto$2.locale = locale;
    proto$2.localeData = localeData;
    proto$2.toIsoString = deprecate("toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)", toISOString$1);
    proto$2.lang = lang;
    // FORMATTING
    addFormatToken("X", 0, 0, "unix");
    addFormatToken("x", 0, 0, "valueOf");
    // PARSING
    addRegexToken("x", matchSigned);
    addRegexToken("X", matchTimestamp);
    addParseToken("X", function(input, array, config) {
        config._d = new Date(parseFloat(input) * 1000);
    });
    addParseToken("x", function(input, array, config) {
        config._d = new Date(toInt(input));
    });
    //! moment.js
    hooks.version = "2.29.4";
    setHookCallback(createLocal);
    hooks.fn = proto;
    hooks.min = min;
    hooks.max = max;
    hooks.now = now;
    hooks.utc = createUTC;
    hooks.unix = createUnix;
    hooks.months = listMonths;
    hooks.isDate = isDate;
    hooks.locale = getSetGlobalLocale;
    hooks.invalid = createInvalid;
    hooks.duration = createDuration;
    hooks.isMoment = isMoment;
    hooks.weekdays = listWeekdays;
    hooks.parseZone = createInZone;
    hooks.localeData = getLocale;
    hooks.isDuration = isDuration;
    hooks.monthsShort = listMonthsShort;
    hooks.weekdaysMin = listWeekdaysMin;
    hooks.defineLocale = defineLocale;
    hooks.updateLocale = updateLocale;
    hooks.locales = listLocales;
    hooks.weekdaysShort = listWeekdaysShort;
    hooks.normalizeUnits = normalizeUnits;
    hooks.relativeTimeRounding = getSetRelativeTimeRounding;
    hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
    hooks.calendarFormat = getCalendarFormat;
    hooks.prototype = proto;
    // currently HTML5 input type only supports 24-hour formats
    hooks.HTML5_FMT = {
        DATETIME_LOCAL: "YYYY-MM-DDTHH:mm",
        DATETIME_LOCAL_SECONDS: "YYYY-MM-DDTHH:mm:ss",
        DATETIME_LOCAL_MS: "YYYY-MM-DDTHH:mm:ss.SSS",
        DATE: "YYYY-MM-DD",
        TIME: "HH:mm",
        TIME_SECONDS: "HH:mm:ss",
        TIME_MS: "HH:mm:ss.SSS",
        WEEK: "GGGG-[W]WW",
        MONTH: "YYYY-MM"
    };
    return hooks;
});

});

parcelRequire.register("88BPR", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $5ecc6b677832d71d$export$2e2bcd8739ae039; });

var $cNQM9 = parcelRequire("cNQM9");
var $5ecc6b677832d71d$export$2e2bcd8739ae039 = {
    props: [
        "input_name",
        "raw_blocks",
        "selected"
    ],
    data () {
        return {
            today: new Date().toISOString(),
            blocks: {},
            selected_day: undefined,
            selected_block: undefined
        };
    },
    computed: {
        days () {
            const days = [];
            for (const day_str of Object.keys(this.blocks).sort()){
                let day = (0, (/*@__PURE__*/$parcel$interopDefault($cNQM9)))(`${day_str}T00:00:00`);
                days.push(day.toDate());
            }
            return days;
        },
        days_formatted () {
            const days = [];
            for (const day of this.days)days.push({
                "key": (0, (/*@__PURE__*/$parcel$interopDefault($cNQM9)))(day).format("YYYY-MM-DD"),
                "value": (0, (/*@__PURE__*/$parcel$interopDefault($cNQM9)))(day).format("MMM Do, YYYY - dddd")
            });
            return days;
        },
        blocks_for_selected_day () {
            return this.blocks[this.selected_day];
        },
        is_day_selected () {
            return !!this.selected_day;
        }
    },
    methods: {
        formatStart (start) {
            return (0, (/*@__PURE__*/$parcel$interopDefault($cNQM9)))(start).format("hh:mm a");
        },
        formatEnd (end) {
            return (0, (/*@__PURE__*/$parcel$interopDefault($cNQM9)))(end).format("hh:mm a");
        },
        loadBlocks () {
            // Parse the JSON data into a usable data structure, localized to the browser timezone
            for (let [day_str, day_blocks] of Object.entries(this.raw_blocks)){
                this.blocks[day_str] = [];
                for (const day_block of day_blocks)this.blocks[day_str].push({
                    start: (0, (/*@__PURE__*/$parcel$interopDefault($cNQM9))).parseZone(day_block.start),
                    end: (0, (/*@__PURE__*/$parcel$interopDefault($cNQM9))).parseZone(day_block.end),
                    key: day_block.key
                });
            }
        },
        loadSelected () {
            if (this.selected) {
                let [start, end] = this.selected.split("to");
                this.selected_day = (0, (/*@__PURE__*/$parcel$interopDefault($cNQM9))).parseZone(start).format("YYYY-MM-DD");
                this.selected_block = this.selected;
            }
        }
    },
    beforeMount () {
        this.loadBlocks();
        this.loadSelected();
    }
};

});

parcelRequire.register("cvMgx", function(module, exports) {

$parcel$export(module.exports, "render", function () { return $91bdd1d763462b60$export$b3890eb0ae9dca99; });
parcelRequire("766BF");
var $7EJi6 = parcelRequire("7EJi6");
var $jQKDy = parcelRequire("jQKDy");
var $6LocX = parcelRequire("6LocX");
const $91bdd1d763462b60$var$_hoisted_1 = {
    class: "appointment-scheduler"
};
const $91bdd1d763462b60$var$_hoisted_2 = {
    class: "row"
};
const $91bdd1d763462b60$var$_hoisted_3 = {
    class: "col-md"
};
const $91bdd1d763462b60$var$_hoisted_4 = {
    class: "form-floating mb-3 border border-secondary rounded"
};
const $91bdd1d763462b60$var$_hoisted_5 = [
    "value"
];
const $91bdd1d763462b60$var$_hoisted_6 = /*#__PURE__*/ (0, $7EJi6.createElementVNode)("label", {
    class: "label",
    for: "day-select"
}, " Day ", -1);
const $91bdd1d763462b60$var$_hoisted_7 = {
    class: "col-md"
};
const $91bdd1d763462b60$var$_hoisted_8 = {
    class: "form-floating mb-3 border border-secondary rounded"
};
const $91bdd1d763462b60$var$_hoisted_9 = [
    "name",
    "disabled"
];
const $91bdd1d763462b60$var$_hoisted_10 = [
    "value"
];
const $91bdd1d763462b60$var$_hoisted_11 = /*#__PURE__*/ (0, $7EJi6.createElementVNode)("label", {
    class: "label",
    for: "block-select"
}, " Time ", -1);
function $91bdd1d763462b60$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, $7EJi6.openBlock)(), (0, $7EJi6.createElementBlock)("div", $91bdd1d763462b60$var$_hoisted_1, [
        (0, $7EJi6.createElementVNode)("div", $91bdd1d763462b60$var$_hoisted_2, [
            (0, $7EJi6.createElementVNode)("div", $91bdd1d763462b60$var$_hoisted_3, [
                (0, $7EJi6.createElementVNode)("div", $91bdd1d763462b60$var$_hoisted_4, [
                    (0, $7EJi6.withDirectives)((0, $7EJi6.createElementVNode)("select", {
                        id: "day-select",
                        class: "form-control",
                        name: "day_select",
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event)=>$data.selected_day = $event)
                    }, [
                        ((0, $7EJi6.openBlock)(true), (0, $7EJi6.createElementBlock)((0, $7EJi6.Fragment), null, (0, $7EJi6.renderList)($options.days_formatted, (day)=>{
                            return (0, $7EJi6.openBlock)(), (0, $7EJi6.createElementBlock)("option", {
                                value: day.key,
                                key: day.key
                            }, (0, $jQKDy.toDisplayString)(day.value), 9, $91bdd1d763462b60$var$_hoisted_5);
                        }), 128))
                    ], 512), [
                        [
                            (0, $6LocX.vModelSelect),
                            $data.selected_day
                        ]
                    ]),
                    $91bdd1d763462b60$var$_hoisted_6
                ])
            ]),
            (0, $7EJi6.createElementVNode)("div", $91bdd1d763462b60$var$_hoisted_7, [
                (0, $7EJi6.createElementVNode)("div", $91bdd1d763462b60$var$_hoisted_8, [
                    (0, $7EJi6.withDirectives)((0, $7EJi6.createElementVNode)("select", {
                        id: "block-select",
                        class: "form-select",
                        name: this.input_name,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event)=>$data.selected_block = $event),
                        disabled: !$options.is_day_selected
                    }, [
                        ((0, $7EJi6.openBlock)(true), (0, $7EJi6.createElementBlock)((0, $7EJi6.Fragment), null, (0, $7EJi6.renderList)($options.blocks_for_selected_day, (block)=>{
                            return (0, $7EJi6.openBlock)(), (0, $7EJi6.createElementBlock)("option", {
                                value: block.key
                            }, (0, $jQKDy.toDisplayString)($options.formatStart(block.start)) + " to " + (0, $jQKDy.toDisplayString)($options.formatEnd(block.end)), 9, $91bdd1d763462b60$var$_hoisted_10);
                        }), 256))
                    ], 8, $91bdd1d763462b60$var$_hoisted_9), [
                        [
                            (0, $6LocX.vModelSelect),
                            $data.selected_block
                        ]
                    ]),
                    $91bdd1d763462b60$var$_hoisted_11
                ])
            ])
        ])
    ]);
}

});
parcelRequire.register("766BF", function(module, exports) {
$parcel$export(module.exports, "createApp", function () { return (parcelRequire("6LocX")).createApp; });
$parcel$export(module.exports, "vModelSelect", function () { return (parcelRequire("6LocX")).vModelSelect; });
$parcel$export(module.exports, "createElementVNode", function () { return (parcelRequire("7EJi6")).createElementVNode; });
$parcel$export(module.exports, "openBlock", function () { return (parcelRequire("7EJi6")).openBlock; });
$parcel$export(module.exports, "createElementBlock", function () { return (parcelRequire("7EJi6")).createElementBlock; });
$parcel$export(module.exports, "withDirectives", function () { return (parcelRequire("7EJi6")).withDirectives; });
$parcel$export(module.exports, "Fragment", function () { return (parcelRequire("7EJi6")).Fragment; });
$parcel$export(module.exports, "renderList", function () { return (parcelRequire("7EJi6")).renderList; });
$parcel$export(module.exports, "initCustomFormatter", function () { return (parcelRequire("7EJi6")).initCustomFormatter; });
$parcel$export(module.exports, "toDisplayString", function () { return (parcelRequire("jQKDy")).toDisplayString; });
parcelRequire("6LocX");
var $7EJi6 = parcelRequire("7EJi6");parcelRequire("jQKDy");
function $52ae37e15921d7e3$var$initDev() {
    (0, $7EJi6.initCustomFormatter)();
}
const $52ae37e15921d7e3$export$ef7acd7185315e22 = ()=>{};

});
parcelRequire.register("6LocX", function(module, exports) {
$parcel$export(module.exports, "createElementVNode", function () { return (parcelRequire("7EJi6")).createElementVNode; });
$parcel$export(module.exports, "openBlock", function () { return (parcelRequire("7EJi6")).openBlock; });
$parcel$export(module.exports, "createElementBlock", function () { return (parcelRequire("7EJi6")).createElementBlock; });
$parcel$export(module.exports, "withDirectives", function () { return (parcelRequire("7EJi6")).withDirectives; });
$parcel$export(module.exports, "Fragment", function () { return (parcelRequire("7EJi6")).Fragment; });
$parcel$export(module.exports, "renderList", function () { return (parcelRequire("7EJi6")).renderList; });
$parcel$export(module.exports, "initCustomFormatter", function () { return (parcelRequire("7EJi6")).initCustomFormatter; });
$parcel$export(module.exports, "camelize", function () { return (parcelRequire("jQKDy")).camelize; });
$parcel$export(module.exports, "callWithAsyncErrorHandling", function () { return (parcelRequire("7EJi6")).callWithAsyncErrorHandling; });
$parcel$export(module.exports, "defineComponent", function () { return (parcelRequire("7EJi6")).defineComponent; });
$parcel$export(module.exports, "nextTick", function () { return (parcelRequire("7EJi6")).nextTick; });
$parcel$export(module.exports, "createVNode", function () { return (parcelRequire("7EJi6")).createVNode; });
$parcel$export(module.exports, "getCurrentInstance", function () { return (parcelRequire("7EJi6")).getCurrentInstance; });
$parcel$export(module.exports, "watchPostEffect", function () { return (parcelRequire("7EJi6")).watchPostEffect; });
$parcel$export(module.exports, "onMounted", function () { return (parcelRequire("7EJi6")).onMounted; });
$parcel$export(module.exports, "onUnmounted", function () { return (parcelRequire("7EJi6")).onUnmounted; });
$parcel$export(module.exports, "Static", function () { return (parcelRequire("7EJi6")).Static; });
$parcel$export(module.exports, "h", function () { return (parcelRequire("7EJi6")).h; });
$parcel$export(module.exports, "BaseTransition", function () { return (parcelRequire("7EJi6")).BaseTransition; });
$parcel$export(module.exports, "BaseTransitionPropsValidators", function () { return (parcelRequire("7EJi6")).BaseTransitionPropsValidators; });
$parcel$export(module.exports, "useTransitionState", function () { return (parcelRequire("7EJi6")).useTransitionState; });
$parcel$export(module.exports, "onUpdated", function () { return (parcelRequire("7EJi6")).onUpdated; });
$parcel$export(module.exports, "toRaw", function () { return (parcelRequire("hnQzm")).toRaw; });
$parcel$export(module.exports, "getTransitionRawChildren", function () { return (parcelRequire("7EJi6")).getTransitionRawChildren; });
$parcel$export(module.exports, "setTransitionHooks", function () { return (parcelRequire("7EJi6")).setTransitionHooks; });
$parcel$export(module.exports, "resolveTransitionHooks", function () { return (parcelRequire("7EJi6")).resolveTransitionHooks; });
$parcel$export(module.exports, "createRenderer", function () { return (parcelRequire("7EJi6")).createRenderer; });
$parcel$export(module.exports, "createHydrationRenderer", function () { return (parcelRequire("7EJi6")).createHydrationRenderer; });
$parcel$export(module.exports, "isRuntimeOnly", function () { return (parcelRequire("7EJi6")).isRuntimeOnly; });
$parcel$export(module.exports, "warn", function () { return (parcelRequire("7EJi6")).warn; });
$parcel$export(module.exports, "toDisplayString", function () { return (parcelRequire("jQKDy")).toDisplayString; });

$parcel$export(module.exports, "vModelSelect", function () { return $4ec9e90a8962c5db$export$87d227567b51ca39; });
$parcel$export(module.exports, "createApp", function () { return $4ec9e90a8962c5db$export$4e373c34abfa8c68; });
parcelRequire("7EJi6");
var $jQKDy = parcelRequire("jQKDy");
var $7EJi6 = parcelRequire("7EJi6");
var $hnQzm = parcelRequire("hnQzm");parcelRequire("jQKDy");

var $jQKDy = parcelRequire("jQKDy");
const $4ec9e90a8962c5db$var$svgNS = "http://www.w3.org/2000/svg";
const $4ec9e90a8962c5db$var$doc = typeof document !== "undefined" ? document : null;
const $4ec9e90a8962c5db$var$templateContainer = $4ec9e90a8962c5db$var$doc && /* @__PURE__ */ $4ec9e90a8962c5db$var$doc.createElement("template");
const $4ec9e90a8962c5db$var$nodeOps = {
    insert: (child, parent, anchor)=>{
        parent.insertBefore(child, anchor || null);
    },
    remove: (child)=>{
        const parent = child.parentNode;
        if (parent) parent.removeChild(child);
    },
    createElement: (tag, isSVG, is, props)=>{
        const el = isSVG ? $4ec9e90a8962c5db$var$doc.createElementNS($4ec9e90a8962c5db$var$svgNS, tag) : $4ec9e90a8962c5db$var$doc.createElement(tag, is ? {
            is: is
        } : void 0);
        if (tag === "select" && props && props.multiple != null) el.setAttribute("multiple", props.multiple);
        return el;
    },
    createText: (text)=>$4ec9e90a8962c5db$var$doc.createTextNode(text),
    createComment: (text)=>$4ec9e90a8962c5db$var$doc.createComment(text),
    setText: (node, text)=>{
        node.nodeValue = text;
    },
    setElementText: (el, text)=>{
        el.textContent = text;
    },
    parentNode: (node)=>node.parentNode,
    nextSibling: (node)=>node.nextSibling,
    querySelector: (selector)=>$4ec9e90a8962c5db$var$doc.querySelector(selector),
    setScopeId (el, id) {
        el.setAttribute(id, "");
    },
    // __UNSAFE__
    // Reason: innerHTML.
    // Static content here can only come from compiled templates.
    // As long as the user only uses trusted templates, this is safe.
    insertStaticContent (content, parent, anchor, isSVG, start, end) {
        const before = anchor ? anchor.previousSibling : parent.lastChild;
        if (start && (start === end || start.nextSibling)) while(true){
            parent.insertBefore(start.cloneNode(true), anchor);
            if (start === end || !(start = start.nextSibling)) break;
        }
        else {
            $4ec9e90a8962c5db$var$templateContainer.innerHTML = isSVG ? `<svg>${content}</svg>` : content;
            const template = $4ec9e90a8962c5db$var$templateContainer.content;
            if (isSVG) {
                const wrapper = template.firstChild;
                while(wrapper.firstChild)template.appendChild(wrapper.firstChild);
                template.removeChild(wrapper);
            }
            parent.insertBefore(template, anchor);
        }
        return [
            // first
            before ? before.nextSibling : parent.firstChild,
            // last
            anchor ? anchor.previousSibling : parent.lastChild
        ];
    }
};
function $4ec9e90a8962c5db$var$patchClass(el, value, isSVG) {
    const transitionClasses = el._vtc;
    if (transitionClasses) value = (value ? [
        value,
        ...transitionClasses
    ] : [
        ...transitionClasses
    ]).join(" ");
    if (value == null) el.removeAttribute("class");
    else if (isSVG) el.setAttribute("class", value);
    else el.className = value;
}
function $4ec9e90a8962c5db$var$patchStyle(el, prev, next) {
    const style = el.style;
    const isCssString = (0, $jQKDy.isString)(next);
    if (next && !isCssString) {
        if (prev && !(0, $jQKDy.isString)(prev)) {
            for(const key in prev)if (next[key] == null) $4ec9e90a8962c5db$var$setStyle(style, key, "");
        }
        for(const key in next)$4ec9e90a8962c5db$var$setStyle(style, key, next[key]);
    } else {
        const currentDisplay = style.display;
        if (isCssString) {
            if (prev !== next) style.cssText = next;
        } else if (prev) el.removeAttribute("style");
        if ("_vod" in el) style.display = currentDisplay;
    }
}
const $4ec9e90a8962c5db$var$semicolonRE = /[^\\];\s*$/;
const $4ec9e90a8962c5db$var$importantRE = /\s*!important$/;
function $4ec9e90a8962c5db$var$setStyle(style, name, val) {
    if ((0, $jQKDy.isArray)(val)) val.forEach((v)=>$4ec9e90a8962c5db$var$setStyle(style, name, v));
    else {
        if (val == null) val = "";
        if (name.startsWith("--")) style.setProperty(name, val);
        else {
            const prefixed = $4ec9e90a8962c5db$var$autoPrefix(style, name);
            if ($4ec9e90a8962c5db$var$importantRE.test(val)) style.setProperty((0, $jQKDy.hyphenate)(prefixed), val.replace($4ec9e90a8962c5db$var$importantRE, ""), "important");
            else style[prefixed] = val;
        }
    }
}
const $4ec9e90a8962c5db$var$prefixes = [
    "Webkit",
    "Moz",
    "ms"
];
const $4ec9e90a8962c5db$var$prefixCache = {};
function $4ec9e90a8962c5db$var$autoPrefix(style, rawName) {
    const cached = $4ec9e90a8962c5db$var$prefixCache[rawName];
    if (cached) return cached;
    let name = (0, $jQKDy.camelize)(rawName);
    if (name !== "filter" && name in style) return $4ec9e90a8962c5db$var$prefixCache[rawName] = name;
    name = (0, $jQKDy.capitalize)(name);
    for(let i = 0; i < $4ec9e90a8962c5db$var$prefixes.length; i++){
        const prefixed = $4ec9e90a8962c5db$var$prefixes[i] + name;
        if (prefixed in style) return $4ec9e90a8962c5db$var$prefixCache[rawName] = prefixed;
    }
    return rawName;
}
const $4ec9e90a8962c5db$var$xlinkNS = "http://www.w3.org/1999/xlink";
function $4ec9e90a8962c5db$var$patchAttr(el, key, value, isSVG, instance) {
    if (isSVG && key.startsWith("xlink:")) {
        if (value == null) el.removeAttributeNS($4ec9e90a8962c5db$var$xlinkNS, key.slice(6, key.length));
        else el.setAttributeNS($4ec9e90a8962c5db$var$xlinkNS, key, value);
    } else {
        const isBoolean = (0, $jQKDy.isSpecialBooleanAttr)(key);
        if (value == null || isBoolean && !(0, $jQKDy.includeBooleanAttr)(value)) el.removeAttribute(key);
        else el.setAttribute(key, isBoolean ? "" : value);
    }
}
function $4ec9e90a8962c5db$var$patchDOMProp(el, key, value, prevChildren, parentComponent, parentSuspense, unmountChildren) {
    if (key === "innerHTML" || key === "textContent") {
        if (prevChildren) unmountChildren(prevChildren, parentComponent, parentSuspense);
        el[key] = value == null ? "" : value;
        return;
    }
    const tag = el.tagName;
    if (key === "value" && tag !== "PROGRESS" && // custom elements may use _value internally
    !tag.includes("-")) {
        el._value = value;
        const oldValue = tag === "OPTION" ? el.getAttribute("value") : el.value;
        const newValue = value == null ? "" : value;
        if (oldValue !== newValue) el.value = newValue;
        if (value == null) el.removeAttribute(key);
        return;
    }
    let needRemove = false;
    if (value === "" || value == null) {
        const type = typeof el[key];
        if (type === "boolean") value = (0, $jQKDy.includeBooleanAttr)(value);
        else if (value == null && type === "string") {
            value = "";
            needRemove = true;
        } else if (type === "number") {
            value = 0;
            needRemove = true;
        }
    }
    try {
        el[key] = value;
    } catch (e) {}
    needRemove && el.removeAttribute(key);
}
function $4ec9e90a8962c5db$var$addEventListener(el, event, handler, options) {
    el.addEventListener(event, handler, options);
}
function $4ec9e90a8962c5db$var$removeEventListener(el, event, handler, options) {
    el.removeEventListener(event, handler, options);
}
function $4ec9e90a8962c5db$var$patchEvent(el, rawName, prevValue, nextValue, instance = null) {
    const invokers = el._vei || (el._vei = {});
    const existingInvoker = invokers[rawName];
    if (nextValue && existingInvoker) existingInvoker.value = nextValue;
    else {
        const [name, options] = $4ec9e90a8962c5db$var$parseName(rawName);
        if (nextValue) {
            const invoker = invokers[rawName] = $4ec9e90a8962c5db$var$createInvoker(nextValue, instance);
            $4ec9e90a8962c5db$var$addEventListener(el, name, invoker, options);
        } else if (existingInvoker) {
            $4ec9e90a8962c5db$var$removeEventListener(el, name, existingInvoker, options);
            invokers[rawName] = void 0;
        }
    }
}
const $4ec9e90a8962c5db$var$optionsModifierRE = /(?:Once|Passive|Capture)$/;
function $4ec9e90a8962c5db$var$parseName(name) {
    let options;
    if ($4ec9e90a8962c5db$var$optionsModifierRE.test(name)) {
        options = {};
        let m;
        while(m = name.match($4ec9e90a8962c5db$var$optionsModifierRE)){
            name = name.slice(0, name.length - m[0].length);
            options[m[0].toLowerCase()] = true;
        }
    }
    const event = name[2] === ":" ? name.slice(3) : (0, $jQKDy.hyphenate)(name.slice(2));
    return [
        event,
        options
    ];
}
let $4ec9e90a8962c5db$var$cachedNow = 0;
const $4ec9e90a8962c5db$var$p = /* @__PURE__ */ Promise.resolve();
const $4ec9e90a8962c5db$var$getNow = ()=>$4ec9e90a8962c5db$var$cachedNow || ($4ec9e90a8962c5db$var$p.then(()=>$4ec9e90a8962c5db$var$cachedNow = 0), $4ec9e90a8962c5db$var$cachedNow = Date.now());
function $4ec9e90a8962c5db$var$createInvoker(initialValue, instance) {
    const invoker = (e)=>{
        if (!e._vts) e._vts = Date.now();
        else if (e._vts <= invoker.attached) return;
        (0, $7EJi6.callWithAsyncErrorHandling)($4ec9e90a8962c5db$var$patchStopImmediatePropagation(e, invoker.value), instance, 5, [
            e
        ]);
    };
    invoker.value = initialValue;
    invoker.attached = $4ec9e90a8962c5db$var$getNow();
    return invoker;
}
function $4ec9e90a8962c5db$var$patchStopImmediatePropagation(e, value) {
    if ((0, $jQKDy.isArray)(value)) {
        const originalStop = e.stopImmediatePropagation;
        e.stopImmediatePropagation = ()=>{
            originalStop.call(e);
            e._stopped = true;
        };
        return value.map((fn)=>(e2)=>!e2._stopped && fn && fn(e2));
    } else return value;
}
const $4ec9e90a8962c5db$var$nativeOnRE = /^on[a-z]/;
const $4ec9e90a8962c5db$var$patchProp = (el, key, prevValue, nextValue, isSVG = false, prevChildren, parentComponent, parentSuspense, unmountChildren)=>{
    if (key === "class") $4ec9e90a8962c5db$var$patchClass(el, nextValue, isSVG);
    else if (key === "style") $4ec9e90a8962c5db$var$patchStyle(el, prevValue, nextValue);
    else if ((0, $jQKDy.isOn)(key)) {
        if (!(0, $jQKDy.isModelListener)(key)) $4ec9e90a8962c5db$var$patchEvent(el, key, prevValue, nextValue, parentComponent);
    } else if (key[0] === "." ? (key = key.slice(1), true) : key[0] === "^" ? (key = key.slice(1), false) : $4ec9e90a8962c5db$var$shouldSetAsProp(el, key, nextValue, isSVG)) $4ec9e90a8962c5db$var$patchDOMProp(el, key, nextValue, prevChildren, parentComponent, parentSuspense, unmountChildren);
    else {
        if (key === "true-value") el._trueValue = nextValue;
        else if (key === "false-value") el._falseValue = nextValue;
        $4ec9e90a8962c5db$var$patchAttr(el, key, nextValue, isSVG);
    }
};
function $4ec9e90a8962c5db$var$shouldSetAsProp(el, key, value, isSVG) {
    if (isSVG) {
        if (key === "innerHTML" || key === "textContent") return true;
        if (key in el && $4ec9e90a8962c5db$var$nativeOnRE.test(key) && (0, $jQKDy.isFunction)(value)) return true;
        return false;
    }
    if (key === "spellcheck" || key === "draggable" || key === "translate") return false;
    if (key === "form") return false;
    if (key === "list" && el.tagName === "INPUT") return false;
    if (key === "type" && el.tagName === "TEXTAREA") return false;
    if ($4ec9e90a8962c5db$var$nativeOnRE.test(key) && (0, $jQKDy.isString)(value)) return false;
    return key in el;
}
function $4ec9e90a8962c5db$export$a00e2346eabbdbef(options, hydrate2) {
    const Comp = (0, $7EJi6.defineComponent)(options);
    class VueCustomElement extends $4ec9e90a8962c5db$export$b337c1a55163dbe3 {
        constructor(initialProps){
            super(Comp, initialProps, hydrate2);
        }
    }
    VueCustomElement.def = Comp;
    return VueCustomElement;
}
const $4ec9e90a8962c5db$export$6debb2e68f212638 = (options)=>{
    return $4ec9e90a8962c5db$export$a00e2346eabbdbef(options, $4ec9e90a8962c5db$export$fa8d919ba61d84db);
};
const $4ec9e90a8962c5db$var$BaseClass = typeof HTMLElement !== "undefined" ? HTMLElement : class {
};
class $4ec9e90a8962c5db$export$b337c1a55163dbe3 extends $4ec9e90a8962c5db$var$BaseClass {
    constructor(_def, _props = {}, hydrate2){
        super();
        this._def = _def;
        this._props = _props;
        /**
     * @internal
     */ this._instance = null;
        this._connected = false;
        this._resolved = false;
        this._numberProps = null;
        if (this.shadowRoot && hydrate2) hydrate2(this._createVNode(), this.shadowRoot);
        else {
            this.attachShadow({
                mode: "open"
            });
            if (!this._def.__asyncLoader) this._resolveProps(this._def);
        }
    }
    connectedCallback() {
        this._connected = true;
        if (!this._instance) {
            if (this._resolved) this._update();
            else this._resolveDef();
        }
    }
    disconnectedCallback() {
        this._connected = false;
        (0, $7EJi6.nextTick)(()=>{
            if (!this._connected) {
                $4ec9e90a8962c5db$export$b3890eb0ae9dca99(null, this.shadowRoot);
                this._instance = null;
            }
        });
    }
    /**
   * resolve inner component definition (handle possible async component)
   */ _resolveDef() {
        this._resolved = true;
        for(let i = 0; i < this.attributes.length; i++)this._setAttr(this.attributes[i].name);
        new MutationObserver((mutations)=>{
            for (const m of mutations)this._setAttr(m.attributeName);
        }).observe(this, {
            attributes: true
        });
        const resolve = (def, isAsync = false)=>{
            const { props: props, styles: styles } = def;
            let numberProps;
            if (props && !(0, $jQKDy.isArray)(props)) for(const key in props){
                const opt = props[key];
                if (opt === Number || opt && opt.type === Number) {
                    if (key in this._props) this._props[key] = (0, $jQKDy.toNumber)(this._props[key]);
                    (numberProps || (numberProps = /* @__PURE__ */ Object.create(null)))[(0, $jQKDy.camelize)(key)] = true;
                }
            }
            this._numberProps = numberProps;
            if (isAsync) this._resolveProps(def);
            this._applyStyles(styles);
            this._update();
        };
        const asyncDef = this._def.__asyncLoader;
        if (asyncDef) asyncDef().then((def)=>resolve(def, true));
        else resolve(this._def);
    }
    _resolveProps(def) {
        const { props: props } = def;
        const declaredPropKeys = (0, $jQKDy.isArray)(props) ? props : Object.keys(props || {});
        for (const key of Object.keys(this))if (key[0] !== "_" && declaredPropKeys.includes(key)) this._setProp(key, this[key], true, false);
        for (const key of declaredPropKeys.map((0, $jQKDy.camelize)))Object.defineProperty(this, key, {
            get () {
                return this._getProp(key);
            },
            set (val) {
                this._setProp(key, val);
            }
        });
    }
    _setAttr(key) {
        let value = this.getAttribute(key);
        const camelKey = (0, $jQKDy.camelize)(key);
        if (this._numberProps && this._numberProps[camelKey]) value = (0, $jQKDy.toNumber)(value);
        this._setProp(camelKey, value, false);
    }
    /**
   * @internal
   */ _getProp(key) {
        return this._props[key];
    }
    /**
   * @internal
   */ _setProp(key, val, shouldReflect = true, shouldUpdate = true) {
        if (val !== this._props[key]) {
            this._props[key] = val;
            if (shouldUpdate && this._instance) this._update();
            if (shouldReflect) {
                if (val === true) this.setAttribute((0, $jQKDy.hyphenate)(key), "");
                else if (typeof val === "string" || typeof val === "number") this.setAttribute((0, $jQKDy.hyphenate)(key), val + "");
                else if (!val) this.removeAttribute((0, $jQKDy.hyphenate)(key));
            }
        }
    }
    _update() {
        $4ec9e90a8962c5db$export$b3890eb0ae9dca99(this._createVNode(), this.shadowRoot);
    }
    _createVNode() {
        const vnode = (0, $7EJi6.createVNode)(this._def, (0, $jQKDy.extend)({}, this._props));
        if (!this._instance) vnode.ce = (instance)=>{
            this._instance = instance;
            instance.isCE = true;
            var newStyles, s;
            const dispatch = (event, args)=>{
                this.dispatchEvent(new CustomEvent(event, {
                    detail: args
                }));
            };
            instance.emit = (event, ...args)=>{
                dispatch(event, args);
                if ((0, $jQKDy.hyphenate)(event) !== event) dispatch((0, $jQKDy.hyphenate)(event), args);
            };
            let parent = this;
            while(parent = parent && (parent.parentNode || parent.host))if (parent instanceof $4ec9e90a8962c5db$export$b337c1a55163dbe3) {
                instance.parent = parent._instance;
                instance.provides = parent._instance.provides;
                break;
            }
        };
        return vnode;
    }
    _applyStyles(styles) {
        if (styles) styles.forEach((css)=>{
            const s = document.createElement("style");
            s.textContent = css;
            this.shadowRoot.appendChild(s);
        });
    }
}
function $4ec9e90a8962c5db$export$9300d5b90d56e3d1(name = "$style") {
    {
        const instance = (0, $7EJi6.getCurrentInstance)();
        if (!instance) return 0, $jQKDy.EMPTY_OBJ;
        const modules = instance.type.__cssModules;
        if (!modules) return 0, $jQKDy.EMPTY_OBJ;
        const mod = modules[name];
        if (!mod) return 0, $jQKDy.EMPTY_OBJ;
        return mod;
    }
}
function $4ec9e90a8962c5db$export$ef28b76f07940108(getter) {
    const instance = (0, $7EJi6.getCurrentInstance)();
    if (!instance) return;
    const updateTeleports = instance.ut = (vars = getter(instance.proxy))=>{
        Array.from(document.querySelectorAll(`[data-v-owner="${instance.uid}"]`)).forEach((node)=>$4ec9e90a8962c5db$var$setVarsOnNode(node, vars));
    };
    const setVars = ()=>{
        const vars = getter(instance.proxy);
        $4ec9e90a8962c5db$var$setVarsOnVNode(instance.subTree, vars);
        updateTeleports(vars);
    };
    (0, $7EJi6.watchPostEffect)(setVars);
    (0, $7EJi6.onMounted)(()=>{
        const ob = new MutationObserver(setVars);
        ob.observe(instance.subTree.el.parentNode, {
            childList: true
        });
        (0, $7EJi6.onUnmounted)(()=>ob.disconnect());
    });
}
function $4ec9e90a8962c5db$var$setVarsOnVNode(vnode, vars) {
    if (vnode.shapeFlag & 128) {
        const suspense = vnode.suspense;
        vnode = suspense.activeBranch;
        if (suspense.pendingBranch && !suspense.isHydrating) suspense.effects.push(()=>{
            $4ec9e90a8962c5db$var$setVarsOnVNode(suspense.activeBranch, vars);
        });
    }
    while(vnode.component)vnode = vnode.component.subTree;
    if (vnode.shapeFlag & 1 && vnode.el) $4ec9e90a8962c5db$var$setVarsOnNode(vnode.el, vars);
    else if (vnode.type === (0, $7EJi6.Fragment)) vnode.children.forEach((c)=>$4ec9e90a8962c5db$var$setVarsOnVNode(c, vars));
    else if (vnode.type === (0, $7EJi6.Static)) {
        let { el: el, anchor: anchor } = vnode;
        while(el){
            $4ec9e90a8962c5db$var$setVarsOnNode(el, vars);
            if (el === anchor) break;
            el = el.nextSibling;
        }
    }
}
function $4ec9e90a8962c5db$var$setVarsOnNode(el, vars) {
    if (el.nodeType === 1) {
        const style = el.style;
        for(const key in vars)style.setProperty(`--${key}`, vars[key]);
    }
}
const $4ec9e90a8962c5db$var$TRANSITION = "transition";
const $4ec9e90a8962c5db$var$ANIMATION = "animation";
const $4ec9e90a8962c5db$export$be58926105124dd4 = (props, { slots: slots })=>(0, $7EJi6.h)((0, $7EJi6.BaseTransition), $4ec9e90a8962c5db$var$resolveTransitionProps(props), slots);
$4ec9e90a8962c5db$export$be58926105124dd4.displayName = "Transition";
const $4ec9e90a8962c5db$var$DOMTransitionPropsValidators = {
    name: String,
    type: String,
    css: {
        type: Boolean,
        default: true
    },
    duration: [
        String,
        Number,
        Object
    ],
    enterFromClass: String,
    enterActiveClass: String,
    enterToClass: String,
    appearFromClass: String,
    appearActiveClass: String,
    appearToClass: String,
    leaveFromClass: String,
    leaveActiveClass: String,
    leaveToClass: String
};
const $4ec9e90a8962c5db$var$TransitionPropsValidators = $4ec9e90a8962c5db$export$be58926105124dd4.props = /* @__PURE__ */ (0, $jQKDy.extend)({}, (0, $7EJi6.BaseTransitionPropsValidators), $4ec9e90a8962c5db$var$DOMTransitionPropsValidators);
const $4ec9e90a8962c5db$var$callHook = (hook, args = [])=>{
    if ((0, $jQKDy.isArray)(hook)) hook.forEach((h2)=>h2(...args));
    else if (hook) hook(...args);
};
const $4ec9e90a8962c5db$var$hasExplicitCallback = (hook)=>{
    return hook ? (0, $jQKDy.isArray)(hook) ? hook.some((h2)=>h2.length > 1) : hook.length > 1 : false;
};
function $4ec9e90a8962c5db$var$resolveTransitionProps(rawProps) {
    const baseProps = {};
    for(const key in rawProps)if (!(key in $4ec9e90a8962c5db$var$DOMTransitionPropsValidators)) baseProps[key] = rawProps[key];
    if (rawProps.css === false) return baseProps;
    const { name: name = "v", type: type, duration: duration, enterFromClass: enterFromClass = `${name}-enter-from`, enterActiveClass: enterActiveClass = `${name}-enter-active`, enterToClass: enterToClass = `${name}-enter-to`, appearFromClass: appearFromClass = enterFromClass, appearActiveClass: appearActiveClass = enterActiveClass, appearToClass: appearToClass = enterToClass, leaveFromClass: leaveFromClass = `${name}-leave-from`, leaveActiveClass: leaveActiveClass = `${name}-leave-active`, leaveToClass: leaveToClass = `${name}-leave-to` } = rawProps;
    const durations = $4ec9e90a8962c5db$var$normalizeDuration(duration);
    const enterDuration = durations && durations[0];
    const leaveDuration = durations && durations[1];
    const { onBeforeEnter: onBeforeEnter, onEnter: onEnter, onEnterCancelled: onEnterCancelled, onLeave: onLeave, onLeaveCancelled: onLeaveCancelled, onBeforeAppear: onBeforeAppear = onBeforeEnter, onAppear: onAppear = onEnter, onAppearCancelled: onAppearCancelled = onEnterCancelled } = baseProps;
    const finishEnter = (el, isAppear, done)=>{
        $4ec9e90a8962c5db$var$removeTransitionClass(el, isAppear ? appearToClass : enterToClass);
        $4ec9e90a8962c5db$var$removeTransitionClass(el, isAppear ? appearActiveClass : enterActiveClass);
        done && done();
    };
    const finishLeave = (el, done)=>{
        el._isLeaving = false;
        $4ec9e90a8962c5db$var$removeTransitionClass(el, leaveFromClass);
        $4ec9e90a8962c5db$var$removeTransitionClass(el, leaveToClass);
        $4ec9e90a8962c5db$var$removeTransitionClass(el, leaveActiveClass);
        done && done();
    };
    const makeEnterHook = (isAppear)=>{
        return (el, done)=>{
            const hook = isAppear ? onAppear : onEnter;
            const resolve = ()=>finishEnter(el, isAppear, done);
            $4ec9e90a8962c5db$var$callHook(hook, [
                el,
                resolve
            ]);
            $4ec9e90a8962c5db$var$nextFrame(()=>{
                $4ec9e90a8962c5db$var$removeTransitionClass(el, isAppear ? appearFromClass : enterFromClass);
                $4ec9e90a8962c5db$var$addTransitionClass(el, isAppear ? appearToClass : enterToClass);
                if (!$4ec9e90a8962c5db$var$hasExplicitCallback(hook)) $4ec9e90a8962c5db$var$whenTransitionEnds(el, type, enterDuration, resolve);
            });
        };
    };
    return (0, $jQKDy.extend)(baseProps, {
        onBeforeEnter (el) {
            $4ec9e90a8962c5db$var$callHook(onBeforeEnter, [
                el
            ]);
            $4ec9e90a8962c5db$var$addTransitionClass(el, enterFromClass);
            $4ec9e90a8962c5db$var$addTransitionClass(el, enterActiveClass);
        },
        onBeforeAppear (el) {
            $4ec9e90a8962c5db$var$callHook(onBeforeAppear, [
                el
            ]);
            $4ec9e90a8962c5db$var$addTransitionClass(el, appearFromClass);
            $4ec9e90a8962c5db$var$addTransitionClass(el, appearActiveClass);
        },
        onEnter: makeEnterHook(false),
        onAppear: makeEnterHook(true),
        onLeave (el, done) {
            el._isLeaving = true;
            const resolve = ()=>finishLeave(el, done);
            $4ec9e90a8962c5db$var$addTransitionClass(el, leaveFromClass);
            $4ec9e90a8962c5db$var$forceReflow();
            $4ec9e90a8962c5db$var$addTransitionClass(el, leaveActiveClass);
            $4ec9e90a8962c5db$var$nextFrame(()=>{
                if (!el._isLeaving) return;
                $4ec9e90a8962c5db$var$removeTransitionClass(el, leaveFromClass);
                $4ec9e90a8962c5db$var$addTransitionClass(el, leaveToClass);
                if (!$4ec9e90a8962c5db$var$hasExplicitCallback(onLeave)) $4ec9e90a8962c5db$var$whenTransitionEnds(el, type, leaveDuration, resolve);
            });
            $4ec9e90a8962c5db$var$callHook(onLeave, [
                el,
                resolve
            ]);
        },
        onEnterCancelled (el) {
            finishEnter(el, false);
            $4ec9e90a8962c5db$var$callHook(onEnterCancelled, [
                el
            ]);
        },
        onAppearCancelled (el) {
            finishEnter(el, true);
            $4ec9e90a8962c5db$var$callHook(onAppearCancelled, [
                el
            ]);
        },
        onLeaveCancelled (el) {
            finishLeave(el);
            $4ec9e90a8962c5db$var$callHook(onLeaveCancelled, [
                el
            ]);
        }
    });
}
function $4ec9e90a8962c5db$var$normalizeDuration(duration) {
    if (duration == null) return null;
    else if ((0, $jQKDy.isObject)(duration)) return [
        $4ec9e90a8962c5db$var$NumberOf(duration.enter),
        $4ec9e90a8962c5db$var$NumberOf(duration.leave)
    ];
    else {
        const n = $4ec9e90a8962c5db$var$NumberOf(duration);
        return [
            n,
            n
        ];
    }
}
function $4ec9e90a8962c5db$var$NumberOf(val) {
    const res = (0, $jQKDy.toNumber)(val);
    return res;
}
function $4ec9e90a8962c5db$var$addTransitionClass(el, cls) {
    cls.split(/\s+/).forEach((c)=>c && el.classList.add(c));
    (el._vtc || (el._vtc = /* @__PURE__ */ new Set())).add(cls);
}
function $4ec9e90a8962c5db$var$removeTransitionClass(el, cls) {
    cls.split(/\s+/).forEach((c)=>c && el.classList.remove(c));
    const { _vtc: _vtc } = el;
    if (_vtc) {
        _vtc.delete(cls);
        if (!_vtc.size) el._vtc = void 0;
    }
}
function $4ec9e90a8962c5db$var$nextFrame(cb) {
    requestAnimationFrame(()=>{
        requestAnimationFrame(cb);
    });
}
let $4ec9e90a8962c5db$var$endId = 0;
function $4ec9e90a8962c5db$var$whenTransitionEnds(el, expectedType, explicitTimeout, resolve) {
    const id = el._endId = ++$4ec9e90a8962c5db$var$endId;
    const resolveIfNotStale = ()=>{
        if (id === el._endId) resolve();
    };
    if (explicitTimeout) return setTimeout(resolveIfNotStale, explicitTimeout);
    const { type: type, timeout: timeout, propCount: propCount } = $4ec9e90a8962c5db$var$getTransitionInfo(el, expectedType);
    if (!type) return resolve();
    const endEvent = type + "end";
    let ended = 0;
    const end = ()=>{
        el.removeEventListener(endEvent, onEnd);
        resolveIfNotStale();
    };
    const onEnd = (e)=>{
        if (e.target === el && ++ended >= propCount) end();
    };
    setTimeout(()=>{
        if (ended < propCount) end();
    }, timeout + 1);
    el.addEventListener(endEvent, onEnd);
}
function $4ec9e90a8962c5db$var$getTransitionInfo(el, expectedType) {
    const styles = window.getComputedStyle(el);
    const getStyleProperties = (key)=>(styles[key] || "").split(", ");
    const transitionDelays = getStyleProperties(`${$4ec9e90a8962c5db$var$TRANSITION}Delay`);
    const transitionDurations = getStyleProperties(`${$4ec9e90a8962c5db$var$TRANSITION}Duration`);
    const transitionTimeout = $4ec9e90a8962c5db$var$getTimeout(transitionDelays, transitionDurations);
    const animationDelays = getStyleProperties(`${$4ec9e90a8962c5db$var$ANIMATION}Delay`);
    const animationDurations = getStyleProperties(`${$4ec9e90a8962c5db$var$ANIMATION}Duration`);
    const animationTimeout = $4ec9e90a8962c5db$var$getTimeout(animationDelays, animationDurations);
    let type = null;
    let timeout = 0;
    let propCount = 0;
    if (expectedType === $4ec9e90a8962c5db$var$TRANSITION) {
        if (transitionTimeout > 0) {
            type = $4ec9e90a8962c5db$var$TRANSITION;
            timeout = transitionTimeout;
            propCount = transitionDurations.length;
        }
    } else if (expectedType === $4ec9e90a8962c5db$var$ANIMATION) {
        if (animationTimeout > 0) {
            type = $4ec9e90a8962c5db$var$ANIMATION;
            timeout = animationTimeout;
            propCount = animationDurations.length;
        }
    } else {
        timeout = Math.max(transitionTimeout, animationTimeout);
        type = timeout > 0 ? transitionTimeout > animationTimeout ? $4ec9e90a8962c5db$var$TRANSITION : $4ec9e90a8962c5db$var$ANIMATION : null;
        propCount = type ? type === $4ec9e90a8962c5db$var$TRANSITION ? transitionDurations.length : animationDurations.length : 0;
    }
    const hasTransform = type === $4ec9e90a8962c5db$var$TRANSITION && /\b(transform|all)(,|$)/.test(getStyleProperties(`${$4ec9e90a8962c5db$var$TRANSITION}Property`).toString());
    return {
        type: type,
        timeout: timeout,
        propCount: propCount,
        hasTransform: hasTransform
    };
}
function $4ec9e90a8962c5db$var$getTimeout(delays, durations) {
    while(delays.length < durations.length)delays = delays.concat(delays);
    return Math.max(...durations.map((d, i)=>$4ec9e90a8962c5db$var$toMs(d) + $4ec9e90a8962c5db$var$toMs(delays[i])));
}
function $4ec9e90a8962c5db$var$toMs(s) {
    return Number(s.slice(0, -1).replace(",", ".")) * 1e3;
}
function $4ec9e90a8962c5db$var$forceReflow() {
    return document.body.offsetHeight;
}
const $4ec9e90a8962c5db$var$positionMap = /* @__PURE__ */ new WeakMap();
const $4ec9e90a8962c5db$var$newPositionMap = /* @__PURE__ */ new WeakMap();
const $4ec9e90a8962c5db$var$TransitionGroupImpl = {
    name: "TransitionGroup",
    props: /* @__PURE__ */ (0, $jQKDy.extend)({}, $4ec9e90a8962c5db$var$TransitionPropsValidators, {
        tag: String,
        moveClass: String
    }),
    setup (props, { slots: slots }) {
        const instance = (0, $7EJi6.getCurrentInstance)();
        const state = (0, $7EJi6.useTransitionState)();
        let prevChildren;
        let children;
        (0, $7EJi6.onUpdated)(()=>{
            if (!prevChildren.length) return;
            const moveClass = props.moveClass || `${props.name || "v"}-move`;
            if (!$4ec9e90a8962c5db$var$hasCSSTransform(prevChildren[0].el, instance.vnode.el, moveClass)) return;
            prevChildren.forEach($4ec9e90a8962c5db$var$callPendingCbs);
            prevChildren.forEach($4ec9e90a8962c5db$var$recordPosition);
            const movedChildren = prevChildren.filter($4ec9e90a8962c5db$var$applyTranslation);
            $4ec9e90a8962c5db$var$forceReflow();
            movedChildren.forEach((c)=>{
                const el = c.el;
                const style = el.style;
                $4ec9e90a8962c5db$var$addTransitionClass(el, moveClass);
                style.transform = style.webkitTransform = style.transitionDuration = "";
                const cb = el._moveCb = (e)=>{
                    if (e && e.target !== el) return;
                    if (!e || /transform$/.test(e.propertyName)) {
                        el.removeEventListener("transitionend", cb);
                        el._moveCb = null;
                        $4ec9e90a8962c5db$var$removeTransitionClass(el, moveClass);
                    }
                };
                el.addEventListener("transitionend", cb);
            });
        });
        return ()=>{
            const rawProps = (0, $hnQzm.toRaw)(props);
            const cssTransitionProps = $4ec9e90a8962c5db$var$resolveTransitionProps(rawProps);
            let tag = rawProps.tag || (0, $7EJi6.Fragment);
            prevChildren = children;
            children = slots.default ? (0, $7EJi6.getTransitionRawChildren)(slots.default()) : [];
            for(let i = 0; i < children.length; i++){
                const child = children[i];
                if (child.key != null) (0, $7EJi6.setTransitionHooks)(child, (0, $7EJi6.resolveTransitionHooks)(child, cssTransitionProps, state, instance));
            }
            if (prevChildren) for(let i = 0; i < prevChildren.length; i++){
                const child = prevChildren[i];
                (0, $7EJi6.setTransitionHooks)(child, (0, $7EJi6.resolveTransitionHooks)(child, cssTransitionProps, state, instance));
                $4ec9e90a8962c5db$var$positionMap.set(child, child.el.getBoundingClientRect());
            }
            return (0, $7EJi6.createVNode)(tag, null, children);
        };
    }
};
const $4ec9e90a8962c5db$var$removeMode = (props)=>delete props.mode;
/* @__PURE__ */ $4ec9e90a8962c5db$var$removeMode($4ec9e90a8962c5db$var$TransitionGroupImpl.props);
const $4ec9e90a8962c5db$export$19ffa8f511f7bc2e = $4ec9e90a8962c5db$var$TransitionGroupImpl;
function $4ec9e90a8962c5db$var$callPendingCbs(c) {
    const el = c.el;
    if (el._moveCb) el._moveCb();
    if (el._enterCb) el._enterCb();
}
function $4ec9e90a8962c5db$var$recordPosition(c) {
    $4ec9e90a8962c5db$var$newPositionMap.set(c, c.el.getBoundingClientRect());
}
function $4ec9e90a8962c5db$var$applyTranslation(c) {
    const oldPos = $4ec9e90a8962c5db$var$positionMap.get(c);
    const newPos = $4ec9e90a8962c5db$var$newPositionMap.get(c);
    const dx = oldPos.left - newPos.left;
    const dy = oldPos.top - newPos.top;
    if (dx || dy) {
        const s = c.el.style;
        s.transform = s.webkitTransform = `translate(${dx}px,${dy}px)`;
        s.transitionDuration = "0s";
        return c;
    }
}
function $4ec9e90a8962c5db$var$hasCSSTransform(el, root, moveClass) {
    const clone = el.cloneNode();
    if (el._vtc) el._vtc.forEach((cls)=>{
        cls.split(/\s+/).forEach((c)=>c && clone.classList.remove(c));
    });
    moveClass.split(/\s+/).forEach((c)=>c && clone.classList.add(c));
    clone.style.display = "none";
    const container = root.nodeType === 1 ? root : root.parentNode;
    container.appendChild(clone);
    const { hasTransform: hasTransform } = $4ec9e90a8962c5db$var$getTransitionInfo(clone);
    container.removeChild(clone);
    return hasTransform;
}
const $4ec9e90a8962c5db$var$getModelAssigner = (vnode)=>{
    const fn = vnode.props["onUpdate:modelValue"] || false;
    return (0, $jQKDy.isArray)(fn) ? (value)=>(0, $jQKDy.invokeArrayFns)(fn, value) : fn;
};
function $4ec9e90a8962c5db$var$onCompositionStart(e) {
    e.target.composing = true;
}
function $4ec9e90a8962c5db$var$onCompositionEnd(e) {
    const target = e.target;
    if (target.composing) {
        target.composing = false;
        target.dispatchEvent(new Event("input"));
    }
}
const $4ec9e90a8962c5db$export$f1f88689f5728478 = {
    created (el, { modifiers: { lazy: lazy, trim: trim, number: number } }, vnode) {
        el._assign = $4ec9e90a8962c5db$var$getModelAssigner(vnode);
        const castToNumber = number || vnode.props && vnode.props.type === "number";
        $4ec9e90a8962c5db$var$addEventListener(el, lazy ? "change" : "input", (e)=>{
            if (e.target.composing) return;
            let domValue = el.value;
            if (trim) domValue = domValue.trim();
            if (castToNumber) domValue = (0, $jQKDy.looseToNumber)(domValue);
            el._assign(domValue);
        });
        if (trim) $4ec9e90a8962c5db$var$addEventListener(el, "change", ()=>{
            el.value = el.value.trim();
        });
        if (!lazy) {
            $4ec9e90a8962c5db$var$addEventListener(el, "compositionstart", $4ec9e90a8962c5db$var$onCompositionStart);
            $4ec9e90a8962c5db$var$addEventListener(el, "compositionend", $4ec9e90a8962c5db$var$onCompositionEnd);
            $4ec9e90a8962c5db$var$addEventListener(el, "change", $4ec9e90a8962c5db$var$onCompositionEnd);
        }
    },
    // set value on mounted so it's after min/max for type="range"
    mounted (el, { value: value }) {
        el.value = value == null ? "" : value;
    },
    beforeUpdate (el, { value: value, modifiers: { lazy: lazy, trim: trim, number: number } }, vnode) {
        el._assign = $4ec9e90a8962c5db$var$getModelAssigner(vnode);
        if (el.composing) return;
        if (document.activeElement === el && el.type !== "range") {
            if (lazy) return;
            if (trim && el.value.trim() === value) return;
            if ((number || el.type === "number") && (0, $jQKDy.looseToNumber)(el.value) === value) return;
        }
        const newValue = value == null ? "" : value;
        if (el.value !== newValue) el.value = newValue;
    }
};
const $4ec9e90a8962c5db$export$8847c2e532b35714 = {
    // #4096 array checkboxes need to be deep traversed
    deep: true,
    created (el, _, vnode) {
        el._assign = $4ec9e90a8962c5db$var$getModelAssigner(vnode);
        $4ec9e90a8962c5db$var$addEventListener(el, "change", ()=>{
            const modelValue = el._modelValue;
            const elementValue = $4ec9e90a8962c5db$var$getValue(el);
            const checked = el.checked;
            const assign = el._assign;
            if ((0, $jQKDy.isArray)(modelValue)) {
                const index = (0, $jQKDy.looseIndexOf)(modelValue, elementValue);
                const found = index !== -1;
                if (checked && !found) assign(modelValue.concat(elementValue));
                else if (!checked && found) {
                    const filtered = [
                        ...modelValue
                    ];
                    filtered.splice(index, 1);
                    assign(filtered);
                }
            } else if ((0, $jQKDy.isSet)(modelValue)) {
                const cloned = new Set(modelValue);
                if (checked) cloned.add(elementValue);
                else cloned.delete(elementValue);
                assign(cloned);
            } else assign($4ec9e90a8962c5db$var$getCheckboxValue(el, checked));
        });
    },
    // set initial checked on mount to wait for true-value/false-value
    mounted: $4ec9e90a8962c5db$var$setChecked,
    beforeUpdate (el, binding, vnode) {
        el._assign = $4ec9e90a8962c5db$var$getModelAssigner(vnode);
        $4ec9e90a8962c5db$var$setChecked(el, binding, vnode);
    }
};
function $4ec9e90a8962c5db$var$setChecked(el, { value: value, oldValue: oldValue }, vnode) {
    el._modelValue = value;
    if ((0, $jQKDy.isArray)(value)) el.checked = (0, $jQKDy.looseIndexOf)(value, vnode.props.value) > -1;
    else if ((0, $jQKDy.isSet)(value)) el.checked = value.has(vnode.props.value);
    else if (value !== oldValue) el.checked = (0, $jQKDy.looseEqual)(value, $4ec9e90a8962c5db$var$getCheckboxValue(el, true));
}
const $4ec9e90a8962c5db$export$b4356c59b38b7aa9 = {
    created (el, { value: value }, vnode) {
        el.checked = (0, $jQKDy.looseEqual)(value, vnode.props.value);
        el._assign = $4ec9e90a8962c5db$var$getModelAssigner(vnode);
        $4ec9e90a8962c5db$var$addEventListener(el, "change", ()=>{
            el._assign($4ec9e90a8962c5db$var$getValue(el));
        });
    },
    beforeUpdate (el, { value: value, oldValue: oldValue }, vnode) {
        el._assign = $4ec9e90a8962c5db$var$getModelAssigner(vnode);
        if (value !== oldValue) el.checked = (0, $jQKDy.looseEqual)(value, vnode.props.value);
    }
};
const $4ec9e90a8962c5db$export$87d227567b51ca39 = {
    // <select multiple> value need to be deep traversed
    deep: true,
    created (el, { value: value, modifiers: { number: number } }, vnode) {
        const isSetModel = (0, $jQKDy.isSet)(value);
        $4ec9e90a8962c5db$var$addEventListener(el, "change", ()=>{
            const selectedVal = Array.prototype.filter.call(el.options, (o)=>o.selected).map((o)=>number ? (0, $jQKDy.looseToNumber)($4ec9e90a8962c5db$var$getValue(o)) : $4ec9e90a8962c5db$var$getValue(o));
            el._assign(el.multiple ? isSetModel ? new Set(selectedVal) : selectedVal : selectedVal[0]);
        });
        el._assign = $4ec9e90a8962c5db$var$getModelAssigner(vnode);
    },
    // set value in mounted & updated because <select> relies on its children
    // <option>s.
    mounted (el, { value: value }) {
        $4ec9e90a8962c5db$var$setSelected(el, value);
    },
    beforeUpdate (el, _binding, vnode) {
        el._assign = $4ec9e90a8962c5db$var$getModelAssigner(vnode);
    },
    updated (el, { value: value }) {
        $4ec9e90a8962c5db$var$setSelected(el, value);
    }
};
function $4ec9e90a8962c5db$var$setSelected(el, value) {
    const isMultiple = el.multiple;
    if (isMultiple && !(0, $jQKDy.isArray)(value) && !(0, $jQKDy.isSet)(value)) return;
    for(let i = 0, l = el.options.length; i < l; i++){
        const option = el.options[i];
        const optionValue = $4ec9e90a8962c5db$var$getValue(option);
        if (isMultiple) {
            if ((0, $jQKDy.isArray)(value)) option.selected = (0, $jQKDy.looseIndexOf)(value, optionValue) > -1;
            else option.selected = value.has(optionValue);
        } else if ((0, $jQKDy.looseEqual)($4ec9e90a8962c5db$var$getValue(option), value)) {
            if (el.selectedIndex !== i) el.selectedIndex = i;
            return;
        }
    }
    if (!isMultiple && el.selectedIndex !== -1) el.selectedIndex = -1;
}
function $4ec9e90a8962c5db$var$getValue(el) {
    return "_value" in el ? el._value : el.value;
}
function $4ec9e90a8962c5db$var$getCheckboxValue(el, checked) {
    const key = checked ? "_trueValue" : "_falseValue";
    return key in el ? el[key] : checked;
}
const $4ec9e90a8962c5db$export$5ad5c0e01ff62c5 = {
    created (el, binding, vnode) {
        $4ec9e90a8962c5db$var$callModelHook(el, binding, vnode, null, "created");
    },
    mounted (el, binding, vnode) {
        $4ec9e90a8962c5db$var$callModelHook(el, binding, vnode, null, "mounted");
    },
    beforeUpdate (el, binding, vnode, prevVNode) {
        $4ec9e90a8962c5db$var$callModelHook(el, binding, vnode, prevVNode, "beforeUpdate");
    },
    updated (el, binding, vnode, prevVNode) {
        $4ec9e90a8962c5db$var$callModelHook(el, binding, vnode, prevVNode, "updated");
    }
};
function $4ec9e90a8962c5db$var$resolveDynamicModel(tagName, type) {
    switch(tagName){
        case "SELECT":
            return $4ec9e90a8962c5db$export$87d227567b51ca39;
        case "TEXTAREA":
            return $4ec9e90a8962c5db$export$f1f88689f5728478;
        default:
            switch(type){
                case "checkbox":
                    return $4ec9e90a8962c5db$export$8847c2e532b35714;
                case "radio":
                    return $4ec9e90a8962c5db$export$b4356c59b38b7aa9;
                default:
                    return $4ec9e90a8962c5db$export$f1f88689f5728478;
            }
    }
}
function $4ec9e90a8962c5db$var$callModelHook(el, binding, vnode, prevVNode, hook) {
    const modelToUse = $4ec9e90a8962c5db$var$resolveDynamicModel(el.tagName, vnode.props && vnode.props.type);
    const fn = modelToUse[hook];
    fn && fn(el, binding, vnode, prevVNode);
}
function $4ec9e90a8962c5db$var$initVModelForSSR() {
    $4ec9e90a8962c5db$export$f1f88689f5728478.getSSRProps = ({ value: value })=>({
            value: value
        });
    $4ec9e90a8962c5db$export$b4356c59b38b7aa9.getSSRProps = ({ value: value }, vnode)=>{
        if (vnode.props && (0, $jQKDy.looseEqual)(vnode.props.value, value)) return {
            checked: true
        };
    };
    $4ec9e90a8962c5db$export$8847c2e532b35714.getSSRProps = ({ value: value }, vnode)=>{
        if ((0, $jQKDy.isArray)(value)) {
            if (vnode.props && (0, $jQKDy.looseIndexOf)(value, vnode.props.value) > -1) return {
                checked: true
            };
        } else if ((0, $jQKDy.isSet)(value)) {
            if (vnode.props && value.has(vnode.props.value)) return {
                checked: true
            };
        } else if (value) return {
            checked: true
        };
    };
    $4ec9e90a8962c5db$export$5ad5c0e01ff62c5.getSSRProps = (binding, vnode)=>{
        if (typeof vnode.type !== "string") return;
        const modelToUse = $4ec9e90a8962c5db$var$resolveDynamicModel(// resolveDynamicModel expects an uppercase tag name, but vnode.type is lowercase
        vnode.type.toUpperCase(), vnode.props && vnode.props.type);
        if (modelToUse.getSSRProps) return modelToUse.getSSRProps(binding, vnode);
    };
}
const $4ec9e90a8962c5db$var$systemModifiers = [
    "ctrl",
    "shift",
    "alt",
    "meta"
];
const $4ec9e90a8962c5db$var$modifierGuards = {
    stop: (e)=>e.stopPropagation(),
    prevent: (e)=>e.preventDefault(),
    self: (e)=>e.target !== e.currentTarget,
    ctrl: (e)=>!e.ctrlKey,
    shift: (e)=>!e.shiftKey,
    alt: (e)=>!e.altKey,
    meta: (e)=>!e.metaKey,
    left: (e)=>"button" in e && e.button !== 0,
    middle: (e)=>"button" in e && e.button !== 1,
    right: (e)=>"button" in e && e.button !== 2,
    exact: (e, modifiers)=>$4ec9e90a8962c5db$var$systemModifiers.some((m)=>e[`${m}Key`] && !modifiers.includes(m))
};
const $4ec9e90a8962c5db$export$26bd3b8e29e6f273 = (fn, modifiers)=>{
    return (event, ...args)=>{
        for(let i = 0; i < modifiers.length; i++){
            const guard = $4ec9e90a8962c5db$var$modifierGuards[modifiers[i]];
            if (guard && guard(event, modifiers)) return;
        }
        return fn(event, ...args);
    };
};
const $4ec9e90a8962c5db$var$keyNames = {
    esc: "escape",
    space: " ",
    up: "arrow-up",
    left: "arrow-left",
    right: "arrow-right",
    down: "arrow-down",
    delete: "backspace"
};
const $4ec9e90a8962c5db$export$f691a8759658f782 = (fn, modifiers)=>{
    return (event)=>{
        if (!("key" in event)) return;
        const eventKey = (0, $jQKDy.hyphenate)(event.key);
        if (modifiers.some((k)=>k === eventKey || $4ec9e90a8962c5db$var$keyNames[k] === eventKey)) return fn(event);
    };
};
const $4ec9e90a8962c5db$export$5cb4fcdc6937d7e1 = {
    beforeMount (el, { value: value }, { transition: transition }) {
        el._vod = el.style.display === "none" ? "" : el.style.display;
        if (transition && value) transition.beforeEnter(el);
        else $4ec9e90a8962c5db$var$setDisplay(el, value);
    },
    mounted (el, { value: value }, { transition: transition }) {
        if (transition && value) transition.enter(el);
    },
    updated (el, { value: value, oldValue: oldValue }, { transition: transition }) {
        if (!value === !oldValue) return;
        if (transition) {
            if (value) {
                transition.beforeEnter(el);
                $4ec9e90a8962c5db$var$setDisplay(el, true);
                transition.enter(el);
            } else transition.leave(el, ()=>{
                $4ec9e90a8962c5db$var$setDisplay(el, false);
            });
        } else $4ec9e90a8962c5db$var$setDisplay(el, value);
    },
    beforeUnmount (el, { value: value }) {
        $4ec9e90a8962c5db$var$setDisplay(el, value);
    }
};
function $4ec9e90a8962c5db$var$setDisplay(el, value) {
    el.style.display = value ? el._vod : "none";
}
function $4ec9e90a8962c5db$var$initVShowForSSR() {
    $4ec9e90a8962c5db$export$5cb4fcdc6937d7e1.getSSRProps = ({ value: value })=>{
        if (!value) return {
            style: {
                display: "none"
            }
        };
    };
}
const $4ec9e90a8962c5db$var$rendererOptions = /* @__PURE__ */ (0, $jQKDy.extend)({
    patchProp: $4ec9e90a8962c5db$var$patchProp
}, $4ec9e90a8962c5db$var$nodeOps);
let $4ec9e90a8962c5db$var$renderer;
let $4ec9e90a8962c5db$var$enabledHydration = false;
function $4ec9e90a8962c5db$var$ensureRenderer() {
    return $4ec9e90a8962c5db$var$renderer || ($4ec9e90a8962c5db$var$renderer = (0, $7EJi6.createRenderer)($4ec9e90a8962c5db$var$rendererOptions));
}
function $4ec9e90a8962c5db$var$ensureHydrationRenderer() {
    $4ec9e90a8962c5db$var$renderer = $4ec9e90a8962c5db$var$enabledHydration ? $4ec9e90a8962c5db$var$renderer : (0, $7EJi6.createHydrationRenderer)($4ec9e90a8962c5db$var$rendererOptions);
    $4ec9e90a8962c5db$var$enabledHydration = true;
    return $4ec9e90a8962c5db$var$renderer;
}
const $4ec9e90a8962c5db$export$b3890eb0ae9dca99 = (...args)=>{
    $4ec9e90a8962c5db$var$ensureRenderer().render(...args);
};
const $4ec9e90a8962c5db$export$fa8d919ba61d84db = (...args)=>{
    $4ec9e90a8962c5db$var$ensureHydrationRenderer().hydrate(...args);
};
const $4ec9e90a8962c5db$export$4e373c34abfa8c68 = (...args)=>{
    const app = $4ec9e90a8962c5db$var$ensureRenderer().createApp(...args);
    const { mount: mount } = app;
    app.mount = (containerOrSelector)=>{
        const container = $4ec9e90a8962c5db$var$normalizeContainer(containerOrSelector);
        if (!container) return;
        const component = app._component;
        if (!(0, $jQKDy.isFunction)(component) && !component.render && !component.template) component.template = container.innerHTML;
        container.innerHTML = "";
        const proxy = mount(container, false, container instanceof SVGElement);
        if (container instanceof Element) {
            container.removeAttribute("v-cloak");
            container.setAttribute("data-v-app", "");
        }
        return proxy;
    };
    return app;
};
const $4ec9e90a8962c5db$export$35800275c0037383 = (...args)=>{
    const app = $4ec9e90a8962c5db$var$ensureHydrationRenderer().createApp(...args);
    const { mount: mount } = app;
    app.mount = (containerOrSelector)=>{
        const container = $4ec9e90a8962c5db$var$normalizeContainer(containerOrSelector);
        if (container) return mount(container, true, container instanceof SVGElement);
    };
    return app;
};
function $4ec9e90a8962c5db$var$injectNativeTagCheck(app) {
    Object.defineProperty(app.config, "isNativeTag", {
        value: (tag)=>(0, $jQKDy.isHTMLTag)(tag) || (0, $jQKDy.isSVGTag)(tag),
        writable: false
    });
}
function $4ec9e90a8962c5db$var$injectCompilerOptionsCheck(app) {
    if ((0, $7EJi6.isRuntimeOnly)()) {
        const isCustomElement = app.config.isCustomElement;
        Object.defineProperty(app.config, "isCustomElement", {
            get () {
                return isCustomElement;
            },
            set () {
                (0, $7EJi6.warn)(`The \`isCustomElement\` config option is deprecated. Use \`compilerOptions.isCustomElement\` instead.`);
            }
        });
        const compilerOptions = app.config.compilerOptions;
        const msg = `The \`compilerOptions\` config option is only respected when using a build of Vue.js that includes the runtime compiler (aka "full build"). Since you are using the runtime-only build, \`compilerOptions\` must be passed to \`@vue/compiler-dom\` in the build setup instead.
- For vue-loader: pass it via vue-loader's \`compilerOptions\` loader option.
- For vue-cli: see https://cli.vuejs.org/guide/webpack.html#modifying-options-of-a-loader
- For vite: pass it via @vitejs/plugin-vue options. See https://github.com/vitejs/vite-plugin-vue/tree/main/packages/plugin-vue#example-for-passing-options-to-vuecompiler-sfc`;
        Object.defineProperty(app.config, "compilerOptions", {
            get () {
                (0, $7EJi6.warn)(msg);
                return compilerOptions;
            },
            set () {
                (0, $7EJi6.warn)(msg);
            }
        });
    }
}
function $4ec9e90a8962c5db$var$normalizeContainer(container) {
    if ((0, $jQKDy.isString)(container)) {
        const res = document.querySelector(container);
        return res;
    }
    return container;
}
let $4ec9e90a8962c5db$var$ssrDirectiveInitialized = false;
const $4ec9e90a8962c5db$export$800b28255aa678d9 = ()=>{
    if (!$4ec9e90a8962c5db$var$ssrDirectiveInitialized) {
        $4ec9e90a8962c5db$var$ssrDirectiveInitialized = true;
        $4ec9e90a8962c5db$var$initVModelForSSR();
        $4ec9e90a8962c5db$var$initVShowForSSR();
    }
};

});
parcelRequire.register("7EJi6", function(module, exports) {

$parcel$export(module.exports, "warn", function () { return $592f66aa99e3ed6d$export$c106dd0671a0fc2d; });
$parcel$export(module.exports, "callWithAsyncErrorHandling", function () { return $592f66aa99e3ed6d$export$dae85862a8d94378; });
$parcel$export(module.exports, "nextTick", function () { return $592f66aa99e3ed6d$export$bdd553fddd433dcb; });
$parcel$export(module.exports, "Fragment", function () { return $592f66aa99e3ed6d$export$ffb0004e005737fa; });
$parcel$export(module.exports, "Static", function () { return $592f66aa99e3ed6d$export$c1b9a1d3af45b7b6; });
$parcel$export(module.exports, "createVNode", function () { return $592f66aa99e3ed6d$export$bf5c4cf060303d58; });
$parcel$export(module.exports, "openBlock", function () { return $592f66aa99e3ed6d$export$e7eaa45e502fe5cc; });
$parcel$export(module.exports, "watchPostEffect", function () { return $592f66aa99e3ed6d$export$b7f27ea67102d543; });
$parcel$export(module.exports, "withDirectives", function () { return $592f66aa99e3ed6d$export$49729353e7c1e6c5; });
$parcel$export(module.exports, "useTransitionState", function () { return $592f66aa99e3ed6d$export$d2a0a1bc267c90f6; });
$parcel$export(module.exports, "onMounted", function () { return $592f66aa99e3ed6d$export$6d1641039221b5cb; });
$parcel$export(module.exports, "BaseTransitionPropsValidators", function () { return $592f66aa99e3ed6d$export$b876c99684f8cf3b; });
$parcel$export(module.exports, "getCurrentInstance", function () { return $592f66aa99e3ed6d$export$f13e630aa3915748; });
$parcel$export(module.exports, "getTransitionRawChildren", function () { return $592f66aa99e3ed6d$export$a67f9b1229c7c97a; });
$parcel$export(module.exports, "resolveTransitionHooks", function () { return $592f66aa99e3ed6d$export$76ac1779589cd824; });
$parcel$export(module.exports, "setTransitionHooks", function () { return $592f66aa99e3ed6d$export$7770a22486565649; });
$parcel$export(module.exports, "BaseTransition", function () { return $592f66aa99e3ed6d$export$abd95b5f5e8a8837; });
$parcel$export(module.exports, "defineComponent", function () { return $592f66aa99e3ed6d$export$afa64b67e5a01c3b; });
$parcel$export(module.exports, "onUpdated", function () { return $592f66aa99e3ed6d$export$5876c47052fb88b1; });
$parcel$export(module.exports, "onUnmounted", function () { return $592f66aa99e3ed6d$export$13348a43ccacfe58; });
$parcel$export(module.exports, "renderList", function () { return $592f66aa99e3ed6d$export$4bf387f59bfc6d67; });
$parcel$export(module.exports, "createRenderer", function () { return $592f66aa99e3ed6d$export$53ae2f996c64e9a; });
$parcel$export(module.exports, "createHydrationRenderer", function () { return $592f66aa99e3ed6d$export$200524cf0d997ff0; });
$parcel$export(module.exports, "createElementBlock", function () { return $592f66aa99e3ed6d$export$167055419fc69ec1; });
$parcel$export(module.exports, "createElementVNode", function () { return $592f66aa99e3ed6d$export$42098e0eaa15c48e; });
$parcel$export(module.exports, "isRuntimeOnly", function () { return $592f66aa99e3ed6d$export$c93a9c496c5211fa; });
$parcel$export(module.exports, "h", function () { return $592f66aa99e3ed6d$export$dda1d9f60106f0e9; });
$parcel$export(module.exports, "initCustomFormatter", function () { return $592f66aa99e3ed6d$export$aed4979be6a60047; });
$parcel$export(module.exports, "toRaw", function () { return (parcelRequire("hnQzm")).toRaw; });
$parcel$export(module.exports, "camelize", function () { return (parcelRequire("jQKDy")).camelize; });

var $hnQzm = parcelRequire("hnQzm");

var $jQKDy = parcelRequire("jQKDy");
const $592f66aa99e3ed6d$var$stack = [];
function $592f66aa99e3ed6d$var$pushWarningContext(vnode) {
    $592f66aa99e3ed6d$var$stack.push(vnode);
}
function $592f66aa99e3ed6d$var$popWarningContext() {
    $592f66aa99e3ed6d$var$stack.pop();
}
function $592f66aa99e3ed6d$export$c106dd0671a0fc2d(msg, ...args) {
    var vnode;
    return;
}
function $592f66aa99e3ed6d$var$getComponentTrace() {
    let currentVNode = $592f66aa99e3ed6d$var$stack[$592f66aa99e3ed6d$var$stack.length - 1];
    if (!currentVNode) return [];
    const normalizedStack = [];
    while(currentVNode){
        const last = normalizedStack[0];
        if (last && last.vnode === currentVNode) last.recurseCount++;
        else normalizedStack.push({
            vnode: currentVNode,
            recurseCount: 0
        });
        const parentInstance = currentVNode.component && currentVNode.component.parent;
        currentVNode = parentInstance && parentInstance.vnode;
    }
    return normalizedStack;
}
function $592f66aa99e3ed6d$var$formatTrace(trace) {
    const logs = [];
    trace.forEach((entry, i)=>{
        logs.push(...i === 0 ? [] : [
            `
`
        ], ...$592f66aa99e3ed6d$var$formatTraceEntry(entry));
    });
    return logs;
}
function $592f66aa99e3ed6d$var$formatTraceEntry({ vnode: vnode, recurseCount: recurseCount }) {
    const postfix = recurseCount > 0 ? `... (${recurseCount} recursive calls)` : ``;
    const isRoot = vnode.component ? vnode.component.parent == null : false;
    const open = ` at <${$592f66aa99e3ed6d$var$formatComponentName(vnode.component, vnode.type, isRoot)}`;
    const close = `>` + postfix;
    return vnode.props ? [
        open,
        ...$592f66aa99e3ed6d$var$formatProps(vnode.props),
        close
    ] : [
        open + close
    ];
}
function $592f66aa99e3ed6d$var$formatProps(props) {
    const res = [];
    const keys = Object.keys(props);
    keys.slice(0, 3).forEach((key)=>{
        res.push(...$592f66aa99e3ed6d$var$formatProp(key, props[key]));
    });
    if (keys.length > 3) res.push(` ...`);
    return res;
}
function $592f66aa99e3ed6d$var$formatProp(key, value1, raw) {
    if ((0, $jQKDy.isString)(value1)) {
        value1 = JSON.stringify(value1);
        return raw ? value1 : [
            `${key}=${value1}`
        ];
    } else if (typeof value1 === "number" || typeof value1 === "boolean" || value1 == null) return raw ? value1 : [
        `${key}=${value1}`
    ];
    else if ((0, $hnQzm.isRef)(value1)) {
        value1 = $592f66aa99e3ed6d$var$formatProp(key, (0, $hnQzm.toRaw)(value1.value), true);
        return raw ? value1 : [
            `${key}=Ref<`,
            value1,
            `>`
        ];
    } else if ((0, $jQKDy.isFunction)(value1)) return [
        `${key}=fn${value1.name ? `<${value1.name}>` : ``}`
    ];
    else {
        value1 = (0, $hnQzm.toRaw)(value1);
        return raw ? value1 : [
            `${key}=`,
            value1
        ];
    }
}
function $592f66aa99e3ed6d$export$dfbcecb440255e4a(val, type) {
    return;
}
const $592f66aa99e3ed6d$var$ErrorTypeStrings = {
    ["sp"]: "serverPrefetch hook",
    ["bc"]: "beforeCreate hook",
    ["c"]: "created hook",
    ["bm"]: "beforeMount hook",
    ["m"]: "mounted hook",
    ["bu"]: "beforeUpdate hook",
    ["u"]: "updated",
    ["bum"]: "beforeUnmount hook",
    ["um"]: "unmounted hook",
    ["a"]: "activated hook",
    ["da"]: "deactivated hook",
    ["ec"]: "errorCaptured hook",
    ["rtc"]: "renderTracked hook",
    ["rtg"]: "renderTriggered hook",
    [0]: "setup function",
    [1]: "render function",
    [2]: "watcher getter",
    [3]: "watcher callback",
    [4]: "watcher cleanup function",
    [5]: "native event handler",
    [6]: "component event handler",
    [7]: "vnode hook",
    [8]: "directive hook",
    [9]: "transition hook",
    [10]: "app errorHandler",
    [11]: "app warnHandler",
    [12]: "ref function",
    [13]: "async component loader",
    [14]: "scheduler flush. This is likely a Vue internals bug. Please open an issue at https://new-issue.vuejs.org/?repo=vuejs/core"
};
function $592f66aa99e3ed6d$export$b22fcaf88446e9bf(fn, instance, type, args) {
    let res;
    try {
        res = args ? fn(...args) : fn();
    } catch (err) {
        $592f66aa99e3ed6d$export$d3da1ecaf1206c58(err, instance, type);
    }
    return res;
}
function $592f66aa99e3ed6d$export$dae85862a8d94378(fn, instance, type, args) {
    if ((0, $jQKDy.isFunction)(fn)) {
        const res = $592f66aa99e3ed6d$export$b22fcaf88446e9bf(fn, instance, type, args);
        if (res && (0, $jQKDy.isPromise)(res)) res.catch((err)=>{
            $592f66aa99e3ed6d$export$d3da1ecaf1206c58(err, instance, type);
        });
        return res;
    }
    const values = [];
    for(let i = 0; i < fn.length; i++)values.push($592f66aa99e3ed6d$export$dae85862a8d94378(fn[i], instance, type, args));
    return values;
}
function $592f66aa99e3ed6d$export$d3da1ecaf1206c58(err, instance, type, throwInDev = true) {
    const contextVNode = instance ? instance.vnode : null;
    if (instance) {
        let cur = instance.parent;
        const exposedInstance = instance.proxy;
        const errorInfo = type;
        while(cur){
            const errorCapturedHooks = cur.ec;
            if (errorCapturedHooks) for(let i = 0; i < errorCapturedHooks.length; i++){
                if (errorCapturedHooks[i](err, exposedInstance, errorInfo) === false) return;
            }
            cur = cur.parent;
        }
        const appErrorHandler = instance.appContext.config.errorHandler;
        if (appErrorHandler) {
            $592f66aa99e3ed6d$export$b22fcaf88446e9bf(appErrorHandler, null, 10, [
                err,
                exposedInstance,
                errorInfo
            ]);
            return;
        }
    }
    $592f66aa99e3ed6d$var$logError(err, type, contextVNode, throwInDev);
}
function $592f66aa99e3ed6d$var$logError(err, type, contextVNode, throwInDev = true) {
    console.error(err);
}
let $592f66aa99e3ed6d$var$isFlushing = false;
let $592f66aa99e3ed6d$var$isFlushPending = false;
const $592f66aa99e3ed6d$var$queue = [];
let $592f66aa99e3ed6d$var$flushIndex = 0;
const $592f66aa99e3ed6d$var$pendingPostFlushCbs = [];
let $592f66aa99e3ed6d$var$activePostFlushCbs = null;
let $592f66aa99e3ed6d$var$postFlushIndex = 0;
const $592f66aa99e3ed6d$var$resolvedPromise = /* @__PURE__ */ Promise.resolve();
let $592f66aa99e3ed6d$var$currentFlushPromise = null;
const $592f66aa99e3ed6d$var$RECURSION_LIMIT = 100;
function $592f66aa99e3ed6d$export$bdd553fddd433dcb(fn) {
    const p = $592f66aa99e3ed6d$var$currentFlushPromise || $592f66aa99e3ed6d$var$resolvedPromise;
    return fn ? p.then(this ? fn.bind(this) : fn) : p;
}
function $592f66aa99e3ed6d$var$findInsertionIndex(id) {
    let start = $592f66aa99e3ed6d$var$flushIndex + 1;
    let end = $592f66aa99e3ed6d$var$queue.length;
    while(start < end){
        const middle = start + end >>> 1;
        const middleJobId = $592f66aa99e3ed6d$var$getId($592f66aa99e3ed6d$var$queue[middle]);
        middleJobId < id ? start = middle + 1 : end = middle;
    }
    return start;
}
function $592f66aa99e3ed6d$var$queueJob(job) {
    if (!$592f66aa99e3ed6d$var$queue.length || !$592f66aa99e3ed6d$var$queue.includes(job, $592f66aa99e3ed6d$var$isFlushing && job.allowRecurse ? $592f66aa99e3ed6d$var$flushIndex + 1 : $592f66aa99e3ed6d$var$flushIndex)) {
        if (job.id == null) $592f66aa99e3ed6d$var$queue.push(job);
        else $592f66aa99e3ed6d$var$queue.splice($592f66aa99e3ed6d$var$findInsertionIndex(job.id), 0, job);
        $592f66aa99e3ed6d$var$queueFlush();
    }
}
function $592f66aa99e3ed6d$var$queueFlush() {
    if (!$592f66aa99e3ed6d$var$isFlushing && !$592f66aa99e3ed6d$var$isFlushPending) {
        $592f66aa99e3ed6d$var$isFlushPending = true;
        $592f66aa99e3ed6d$var$currentFlushPromise = $592f66aa99e3ed6d$var$resolvedPromise.then($592f66aa99e3ed6d$var$flushJobs);
    }
}
function $592f66aa99e3ed6d$var$invalidateJob(job) {
    const i = $592f66aa99e3ed6d$var$queue.indexOf(job);
    if (i > $592f66aa99e3ed6d$var$flushIndex) $592f66aa99e3ed6d$var$queue.splice(i, 1);
}
function $592f66aa99e3ed6d$export$59536a0199721cab(cb) {
    if (!(0, $jQKDy.isArray)(cb)) {
        if (!$592f66aa99e3ed6d$var$activePostFlushCbs || !$592f66aa99e3ed6d$var$activePostFlushCbs.includes(cb, cb.allowRecurse ? $592f66aa99e3ed6d$var$postFlushIndex + 1 : $592f66aa99e3ed6d$var$postFlushIndex)) $592f66aa99e3ed6d$var$pendingPostFlushCbs.push(cb);
    } else $592f66aa99e3ed6d$var$pendingPostFlushCbs.push(...cb);
    $592f66aa99e3ed6d$var$queueFlush();
}
function $592f66aa99e3ed6d$var$flushPreFlushCbs(seen, i = $592f66aa99e3ed6d$var$isFlushing ? $592f66aa99e3ed6d$var$flushIndex + 1 : 0) {
    for(; i < $592f66aa99e3ed6d$var$queue.length; i++){
        const cb = $592f66aa99e3ed6d$var$queue[i];
        if (cb && cb.pre) {
            $592f66aa99e3ed6d$var$queue.splice(i, 1);
            i--;
            cb();
        }
    }
}
function $592f66aa99e3ed6d$var$flushPostFlushCbs(seen) {
    if ($592f66aa99e3ed6d$var$pendingPostFlushCbs.length) {
        const deduped = [
            ...new Set($592f66aa99e3ed6d$var$pendingPostFlushCbs)
        ];
        $592f66aa99e3ed6d$var$pendingPostFlushCbs.length = 0;
        if ($592f66aa99e3ed6d$var$activePostFlushCbs) {
            $592f66aa99e3ed6d$var$activePostFlushCbs.push(...deduped);
            return;
        }
        $592f66aa99e3ed6d$var$activePostFlushCbs = deduped;
        $592f66aa99e3ed6d$var$activePostFlushCbs.sort((a, b)=>$592f66aa99e3ed6d$var$getId(a) - $592f66aa99e3ed6d$var$getId(b));
        for($592f66aa99e3ed6d$var$postFlushIndex = 0; $592f66aa99e3ed6d$var$postFlushIndex < $592f66aa99e3ed6d$var$activePostFlushCbs.length; $592f66aa99e3ed6d$var$postFlushIndex++)$592f66aa99e3ed6d$var$activePostFlushCbs[$592f66aa99e3ed6d$var$postFlushIndex]();
        $592f66aa99e3ed6d$var$activePostFlushCbs = null;
        $592f66aa99e3ed6d$var$postFlushIndex = 0;
    }
}
const $592f66aa99e3ed6d$var$getId = (job)=>job.id == null ? Infinity : job.id;
const $592f66aa99e3ed6d$var$comparator = (a, b)=>{
    const diff = $592f66aa99e3ed6d$var$getId(a) - $592f66aa99e3ed6d$var$getId(b);
    if (diff === 0) {
        if (a.pre && !b.pre) return -1;
        if (b.pre && !a.pre) return 1;
    }
    return diff;
};
function $592f66aa99e3ed6d$var$flushJobs(seen) {
    $592f66aa99e3ed6d$var$isFlushPending = false;
    $592f66aa99e3ed6d$var$isFlushing = true;
    $592f66aa99e3ed6d$var$queue.sort($592f66aa99e3ed6d$var$comparator);
    const check = (0, $jQKDy.NOOP);
    try {
        for($592f66aa99e3ed6d$var$flushIndex = 0; $592f66aa99e3ed6d$var$flushIndex < $592f66aa99e3ed6d$var$queue.length; $592f66aa99e3ed6d$var$flushIndex++){
            const job = $592f66aa99e3ed6d$var$queue[$592f66aa99e3ed6d$var$flushIndex];
            if (job && job.active !== false) $592f66aa99e3ed6d$export$b22fcaf88446e9bf(job, null, 14);
        }
    } finally{
        $592f66aa99e3ed6d$var$flushIndex = 0;
        $592f66aa99e3ed6d$var$queue.length = 0;
        $592f66aa99e3ed6d$var$flushPostFlushCbs(seen);
        $592f66aa99e3ed6d$var$isFlushing = false;
        $592f66aa99e3ed6d$var$currentFlushPromise = null;
        if ($592f66aa99e3ed6d$var$queue.length || $592f66aa99e3ed6d$var$pendingPostFlushCbs.length) $592f66aa99e3ed6d$var$flushJobs(seen);
    }
}
function $592f66aa99e3ed6d$var$checkRecursiveUpdates(seen, fn) {
    if (!seen.has(fn)) seen.set(fn, 1);
    else {
        const count = seen.get(fn);
        if (count > $592f66aa99e3ed6d$var$RECURSION_LIMIT) {
            const instance = fn.ownerInstance;
            const componentName = instance && $592f66aa99e3ed6d$var$getComponentName(instance.type);
            $592f66aa99e3ed6d$export$c106dd0671a0fc2d(`Maximum recursive updates exceeded${componentName ? ` in component <${componentName}>` : ``}. This means you have a reactive effect that is mutating its own dependencies and thus recursively triggering itself. Possible sources include component template, render function, updated hook or watcher source function.`);
            return true;
        } else seen.set(fn, count + 1);
    }
}
let $592f66aa99e3ed6d$var$isHmrUpdating = false;
const $592f66aa99e3ed6d$var$hmrDirtyComponents = /* @__PURE__ */ new Set();
const $592f66aa99e3ed6d$var$map = /* @__PURE__ */ new Map();
function $592f66aa99e3ed6d$var$registerHMR(instance) {
    const id = instance.type.__hmrId;
    let record = $592f66aa99e3ed6d$var$map.get(id);
    if (!record) {
        $592f66aa99e3ed6d$var$createRecord(id, instance.type);
        record = $592f66aa99e3ed6d$var$map.get(id);
    }
    record.instances.add(instance);
}
function $592f66aa99e3ed6d$var$unregisterHMR(instance) {
    $592f66aa99e3ed6d$var$map.get(instance.type.__hmrId).instances.delete(instance);
}
function $592f66aa99e3ed6d$var$createRecord(id, initialDef) {
    if ($592f66aa99e3ed6d$var$map.has(id)) return false;
    $592f66aa99e3ed6d$var$map.set(id, {
        initialDef: $592f66aa99e3ed6d$var$normalizeClassComponent(initialDef),
        instances: /* @__PURE__ */ new Set()
    });
    return true;
}
function $592f66aa99e3ed6d$var$normalizeClassComponent(component) {
    return $592f66aa99e3ed6d$var$isClassComponent(component) ? component.__vccOpts : component;
}
function $592f66aa99e3ed6d$var$rerender(id, newRender) {
    const record = $592f66aa99e3ed6d$var$map.get(id);
    if (!record) return;
    record.initialDef.render = newRender;
    [
        ...record.instances
    ].forEach((instance)=>{
        if (newRender) {
            instance.render = newRender;
            $592f66aa99e3ed6d$var$normalizeClassComponent(instance.type).render = newRender;
        }
        instance.renderCache = [];
        $592f66aa99e3ed6d$var$isHmrUpdating = true;
        instance.update();
        $592f66aa99e3ed6d$var$isHmrUpdating = false;
    });
}
function $592f66aa99e3ed6d$var$reload(id, newComp) {
    const record = $592f66aa99e3ed6d$var$map.get(id);
    if (!record) return;
    newComp = $592f66aa99e3ed6d$var$normalizeClassComponent(newComp);
    $592f66aa99e3ed6d$var$updateComponentDef(record.initialDef, newComp);
    const instances = [
        ...record.instances
    ];
    for (const instance of instances){
        const oldComp = $592f66aa99e3ed6d$var$normalizeClassComponent(instance.type);
        if (!$592f66aa99e3ed6d$var$hmrDirtyComponents.has(oldComp)) {
            if (oldComp !== record.initialDef) $592f66aa99e3ed6d$var$updateComponentDef(oldComp, newComp);
            $592f66aa99e3ed6d$var$hmrDirtyComponents.add(oldComp);
        }
        instance.appContext.propsCache.delete(instance.type);
        instance.appContext.emitsCache.delete(instance.type);
        instance.appContext.optionsCache.delete(instance.type);
        if (instance.ceReload) {
            $592f66aa99e3ed6d$var$hmrDirtyComponents.add(oldComp);
            instance.ceReload(newComp.styles);
            $592f66aa99e3ed6d$var$hmrDirtyComponents.delete(oldComp);
        } else if (instance.parent) $592f66aa99e3ed6d$var$queueJob(instance.parent.update);
        else if (instance.appContext.reload) instance.appContext.reload();
        else if (typeof window !== "undefined") window.location.reload();
        else console.warn("[HMR] Root or manually mounted instance modified. Full reload required.");
    }
    $592f66aa99e3ed6d$export$59536a0199721cab(()=>{
        for (const instance of instances)$592f66aa99e3ed6d$var$hmrDirtyComponents.delete($592f66aa99e3ed6d$var$normalizeClassComponent(instance.type));
    });
}
function $592f66aa99e3ed6d$var$updateComponentDef(oldComp, newComp) {
    (0, $jQKDy.extend)(oldComp, newComp);
    for(const key in oldComp)if (key !== "__file" && !(key in newComp)) delete oldComp[key];
}
function $592f66aa99e3ed6d$var$tryWrap(fn) {
    return (id, arg)=>{
        try {
            return fn(id, arg);
        } catch (e) {
            console.error(e);
            console.warn(`[HMR] Something went wrong during Vue component hot-reload. Full reload required.`);
        }
    };
}
let $592f66aa99e3ed6d$export$6922d3b3a607469e;
let $592f66aa99e3ed6d$var$buffer = [];
let $592f66aa99e3ed6d$var$devtoolsNotInstalled = false;
function $592f66aa99e3ed6d$var$emit$1(event, ...args) {
    if ($592f66aa99e3ed6d$export$6922d3b3a607469e) $592f66aa99e3ed6d$export$6922d3b3a607469e.emit(event, ...args);
    else if (!$592f66aa99e3ed6d$var$devtoolsNotInstalled) $592f66aa99e3ed6d$var$buffer.push({
        event: event,
        args: args
    });
}
function $592f66aa99e3ed6d$export$b0c258b32c26c785(hook, target) {
    var _a, _b;
    $592f66aa99e3ed6d$export$6922d3b3a607469e = hook;
    if ($592f66aa99e3ed6d$export$6922d3b3a607469e) {
        $592f66aa99e3ed6d$export$6922d3b3a607469e.enabled = true;
        $592f66aa99e3ed6d$var$buffer.forEach(({ event: event, args: args })=>$592f66aa99e3ed6d$export$6922d3b3a607469e.emit(event, ...args));
        $592f66aa99e3ed6d$var$buffer = [];
    } else if (// handle late devtools injection - only do this if we are in an actual
    // browser environment to avoid the timer handle stalling test runner exit
    // (#4815)
    typeof window !== "undefined" && // some envs mock window but not fully
    window.HTMLElement && // also exclude jsdom
    !((_b = (_a = window.navigator) == null ? void 0 : _a.userAgent) == null ? void 0 : _b.includes("jsdom"))) {
        const replay = target.__VUE_DEVTOOLS_HOOK_REPLAY__ = target.__VUE_DEVTOOLS_HOOK_REPLAY__ || [];
        replay.push((newHook)=>{
            $592f66aa99e3ed6d$export$b0c258b32c26c785(newHook, target);
        });
        setTimeout(()=>{
            if (!$592f66aa99e3ed6d$export$6922d3b3a607469e) {
                target.__VUE_DEVTOOLS_HOOK_REPLAY__ = null;
                $592f66aa99e3ed6d$var$devtoolsNotInstalled = true;
                $592f66aa99e3ed6d$var$buffer = [];
            }
        }, 3e3);
    } else {
        $592f66aa99e3ed6d$var$devtoolsNotInstalled = true;
        $592f66aa99e3ed6d$var$buffer = [];
    }
}
function $592f66aa99e3ed6d$var$devtoolsInitApp(app, version) {
    $592f66aa99e3ed6d$var$emit$1("app:init" /* APP_INIT */ , app, version, {
        Fragment: $592f66aa99e3ed6d$export$ffb0004e005737fa,
        Text: $592f66aa99e3ed6d$export$5f1af8db9871e1d6,
        Comment: $592f66aa99e3ed6d$export$4d299b491347818a,
        Static: $592f66aa99e3ed6d$export$c1b9a1d3af45b7b6
    });
}
function $592f66aa99e3ed6d$var$devtoolsUnmountApp(app) {
    $592f66aa99e3ed6d$var$emit$1("app:unmount" /* APP_UNMOUNT */ , app);
}
const $592f66aa99e3ed6d$var$devtoolsComponentAdded = /* @__PURE__ */ $592f66aa99e3ed6d$var$createDevtoolsComponentHook("component:added" /* COMPONENT_ADDED */ );
const $592f66aa99e3ed6d$var$devtoolsComponentUpdated = /* @__PURE__ */ $592f66aa99e3ed6d$var$createDevtoolsComponentHook("component:updated" /* COMPONENT_UPDATED */ );
const $592f66aa99e3ed6d$var$_devtoolsComponentRemoved = /* @__PURE__ */ $592f66aa99e3ed6d$var$createDevtoolsComponentHook("component:removed" /* COMPONENT_REMOVED */ );
const $592f66aa99e3ed6d$var$devtoolsComponentRemoved = (component)=>{
    if ($592f66aa99e3ed6d$export$6922d3b3a607469e && typeof $592f66aa99e3ed6d$export$6922d3b3a607469e.cleanupBuffer === "function" && // remove the component if it wasn't buffered
    !$592f66aa99e3ed6d$export$6922d3b3a607469e.cleanupBuffer(component)) $592f66aa99e3ed6d$var$_devtoolsComponentRemoved(component);
};
function $592f66aa99e3ed6d$var$createDevtoolsComponentHook(hook) {
    return (component)=>{
        $592f66aa99e3ed6d$var$emit$1(hook, component.appContext.app, component.uid, component.parent ? component.parent.uid : void 0, component);
    };
}
const $592f66aa99e3ed6d$var$devtoolsPerfStart = /* @__PURE__ */ $592f66aa99e3ed6d$var$createDevtoolsPerformanceHook("perf:start" /* PERFORMANCE_START */ );
const $592f66aa99e3ed6d$var$devtoolsPerfEnd = /* @__PURE__ */ $592f66aa99e3ed6d$var$createDevtoolsPerformanceHook("perf:end" /* PERFORMANCE_END */ );
function $592f66aa99e3ed6d$var$createDevtoolsPerformanceHook(hook) {
    return (component, type, time)=>{
        $592f66aa99e3ed6d$var$emit$1(hook, component.appContext.app, component.uid, component, type, time);
    };
}
function $592f66aa99e3ed6d$var$devtoolsComponentEmit(component, event, params) {
    $592f66aa99e3ed6d$var$emit$1("component:emit" /* COMPONENT_EMIT */ , component.appContext.app, component, event, params);
}
function $592f66aa99e3ed6d$var$emit(instance, event, ...rawArgs) {
    if (instance.isUnmounted) return;
    const props = instance.vnode.props || (0, $jQKDy.EMPTY_OBJ);
    let args = rawArgs;
    const isModelListener = event.startsWith("update:");
    const modelArg = isModelListener && event.slice(7);
    if (modelArg && modelArg in props) {
        const modifiersKey = `${modelArg === "modelValue" ? "model" : modelArg}Modifiers`;
        const { number: number, trim: trim } = props[modifiersKey] || (0, $jQKDy.EMPTY_OBJ);
        if (trim) args = rawArgs.map((a)=>(0, $jQKDy.isString)(a) ? a.trim() : a);
        if (number) args = rawArgs.map((0, $jQKDy.looseToNumber));
    }
    if (__VUE_PROD_DEVTOOLS__) $592f66aa99e3ed6d$var$devtoolsComponentEmit(instance, event, args);
    let handlerName;
    let handler = props[handlerName = (0, $jQKDy.toHandlerKey)(event)] || // also try camelCase event handler (#2249)
    props[handlerName = (0, $jQKDy.toHandlerKey)((0, $jQKDy.camelize)(event))];
    if (!handler && isModelListener) handler = props[handlerName = (0, $jQKDy.toHandlerKey)((0, $jQKDy.hyphenate)(event))];
    if (handler) $592f66aa99e3ed6d$export$dae85862a8d94378(handler, instance, 6, args);
    const onceHandler = props[handlerName + `Once`];
    if (onceHandler) {
        if (!instance.emitted) instance.emitted = {};
        else if (instance.emitted[handlerName]) return;
        instance.emitted[handlerName] = true;
        $592f66aa99e3ed6d$export$dae85862a8d94378(onceHandler, instance, 6, args);
    }
}
function $592f66aa99e3ed6d$var$normalizeEmitsOptions(comp, appContext, asMixin = false) {
    const cache = appContext.emitsCache;
    const cached = cache.get(comp);
    if (cached !== void 0) return cached;
    const raw = comp.emits;
    let normalized = {};
    let hasExtends = false;
    if (__VUE_OPTIONS_API__ && !(0, $jQKDy.isFunction)(comp)) {
        const extendEmits = (raw2)=>{
            const normalizedFromExtend = $592f66aa99e3ed6d$var$normalizeEmitsOptions(raw2, appContext, true);
            if (normalizedFromExtend) {
                hasExtends = true;
                (0, $jQKDy.extend)(normalized, normalizedFromExtend);
            }
        };
        if (!asMixin && appContext.mixins.length) appContext.mixins.forEach(extendEmits);
        if (comp.extends) extendEmits(comp.extends);
        if (comp.mixins) comp.mixins.forEach(extendEmits);
    }
    if (!raw && !hasExtends) {
        if ((0, $jQKDy.isObject)(comp)) cache.set(comp, null);
        return null;
    }
    if ((0, $jQKDy.isArray)(raw)) raw.forEach((key)=>normalized[key] = null);
    else (0, $jQKDy.extend)(normalized, raw);
    if ((0, $jQKDy.isObject)(comp)) cache.set(comp, normalized);
    return normalized;
}
function $592f66aa99e3ed6d$var$isEmitListener(options, key) {
    if (!options || !(0, $jQKDy.isOn)(key)) return false;
    key = key.slice(2).replace(/Once$/, "");
    return (0, $jQKDy.hasOwn)(options, key[0].toLowerCase() + key.slice(1)) || (0, $jQKDy.hasOwn)(options, (0, $jQKDy.hyphenate)(key)) || (0, $jQKDy.hasOwn)(options, key);
}
let $592f66aa99e3ed6d$var$currentRenderingInstance = null;
let $592f66aa99e3ed6d$var$currentScopeId = null;
function $592f66aa99e3ed6d$var$setCurrentRenderingInstance(instance) {
    const prev = $592f66aa99e3ed6d$var$currentRenderingInstance;
    $592f66aa99e3ed6d$var$currentRenderingInstance = instance;
    $592f66aa99e3ed6d$var$currentScopeId = instance && instance.type.__scopeId || null;
    return prev;
}
function $592f66aa99e3ed6d$export$ac020265ca2cc4cd(id) {
    $592f66aa99e3ed6d$var$currentScopeId = id;
}
function $592f66aa99e3ed6d$export$f2dc6805dc11834e() {
    $592f66aa99e3ed6d$var$currentScopeId = null;
}
const $592f66aa99e3ed6d$export$15ba313e13f3dd04 = (_id)=>$592f66aa99e3ed6d$export$694b237e827a3d23;
function $592f66aa99e3ed6d$export$694b237e827a3d23(fn, ctx = $592f66aa99e3ed6d$var$currentRenderingInstance, isNonScopedSlot) {
    if (!ctx) return fn;
    if (fn._n) return fn;
    const renderFnWithContext = (...args)=>{
        if (renderFnWithContext._d) $592f66aa99e3ed6d$export$c20bee82f26f1e27(-1);
        const prevInstance = $592f66aa99e3ed6d$var$setCurrentRenderingInstance(ctx);
        let res;
        try {
            res = fn(...args);
        } finally{
            $592f66aa99e3ed6d$var$setCurrentRenderingInstance(prevInstance);
            if (renderFnWithContext._d) $592f66aa99e3ed6d$export$c20bee82f26f1e27(1);
        }
        if (__VUE_PROD_DEVTOOLS__) $592f66aa99e3ed6d$var$devtoolsComponentUpdated(ctx);
        return res;
    };
    renderFnWithContext._n = true;
    renderFnWithContext._c = true;
    renderFnWithContext._d = true;
    return renderFnWithContext;
}
let $592f66aa99e3ed6d$var$accessedAttrs = false;
function $592f66aa99e3ed6d$var$markAttrsAccessed() {
    $592f66aa99e3ed6d$var$accessedAttrs = true;
}
function $592f66aa99e3ed6d$var$renderComponentRoot(instance) {
    const { type: Component, vnode: vnode, proxy: proxy, withProxy: withProxy, props: props, propsOptions: [propsOptions], slots: slots, attrs: attrs, emit: emit, render: render, renderCache: renderCache, data: data, setupState: setupState, ctx: ctx, inheritAttrs: inheritAttrs } = instance;
    let result;
    let fallthroughAttrs;
    const prev = $592f66aa99e3ed6d$var$setCurrentRenderingInstance(instance);
    try {
        if (vnode.shapeFlag & 4) {
            const proxyToUse = withProxy || proxy;
            result = $592f66aa99e3ed6d$var$normalizeVNode(render.call(proxyToUse, proxyToUse, renderCache, props, setupState, data, ctx));
            fallthroughAttrs = attrs;
        } else {
            const render2 = Component;
            result = $592f66aa99e3ed6d$var$normalizeVNode(render2.length > 1 ? render2(props, {
                attrs: attrs,
                slots: slots,
                emit: emit
            }) : render2(props, null));
            fallthroughAttrs = Component.props ? attrs : $592f66aa99e3ed6d$var$getFunctionalFallthrough(attrs);
        }
    } catch (err) {
        $592f66aa99e3ed6d$var$blockStack.length = 0;
        $592f66aa99e3ed6d$export$d3da1ecaf1206c58(err, instance, 1);
        result = $592f66aa99e3ed6d$export$bf5c4cf060303d58($592f66aa99e3ed6d$export$4d299b491347818a);
    }
    let root = result;
    let setRoot = void 0;
    if (fallthroughAttrs && inheritAttrs !== false) {
        const keys = Object.keys(fallthroughAttrs);
        const { shapeFlag: shapeFlag } = root;
        if (keys.length) {
            if (shapeFlag & 7) {
                if (propsOptions && keys.some((0, $jQKDy.isModelListener))) fallthroughAttrs = $592f66aa99e3ed6d$var$filterModelListeners(fallthroughAttrs, propsOptions);
                root = $592f66aa99e3ed6d$export$ee4f9e12c0a92a1a(root, fallthroughAttrs);
            }
        }
    }
    if (vnode.dirs) {
        root = $592f66aa99e3ed6d$export$ee4f9e12c0a92a1a(root);
        root.dirs = root.dirs ? root.dirs.concat(vnode.dirs) : vnode.dirs;
    }
    if (vnode.transition) root.transition = vnode.transition;
    result = root;
    $592f66aa99e3ed6d$var$setCurrentRenderingInstance(prev);
    return result;
}
const $592f66aa99e3ed6d$var$getChildRoot = (vnode)=>{
    const rawChildren = vnode.children;
    const dynamicChildren = vnode.dynamicChildren;
    const childRoot = $592f66aa99e3ed6d$var$filterSingleRoot(rawChildren);
    if (!childRoot) return [
        vnode,
        void 0
    ];
    const index = rawChildren.indexOf(childRoot);
    const dynamicIndex = dynamicChildren ? dynamicChildren.indexOf(childRoot) : -1;
    const setRoot = (updatedRoot)=>{
        rawChildren[index] = updatedRoot;
        if (dynamicChildren) {
            if (dynamicIndex > -1) dynamicChildren[dynamicIndex] = updatedRoot;
            else if (updatedRoot.patchFlag > 0) vnode.dynamicChildren = [
                ...dynamicChildren,
                updatedRoot
            ];
        }
    };
    return [
        $592f66aa99e3ed6d$var$normalizeVNode(childRoot),
        setRoot
    ];
};
function $592f66aa99e3ed6d$var$filterSingleRoot(children) {
    let singleRoot;
    for(let i = 0; i < children.length; i++){
        const child = children[i];
        if ($592f66aa99e3ed6d$export$3868d13f8734ae81(child)) {
            if (child.type !== $592f66aa99e3ed6d$export$4d299b491347818a || child.children === "v-if") {
                if (singleRoot) return;
                else singleRoot = child;
            }
        } else return;
    }
    return singleRoot;
}
const $592f66aa99e3ed6d$var$getFunctionalFallthrough = (attrs)=>{
    let res;
    for(const key in attrs)if (key === "class" || key === "style" || (0, $jQKDy.isOn)(key)) (res || (res = {}))[key] = attrs[key];
    return res;
};
const $592f66aa99e3ed6d$var$filterModelListeners = (attrs, props)=>{
    const res = {};
    for(const key in attrs)if (!(0, $jQKDy.isModelListener)(key) || !(key.slice(9) in props)) res[key] = attrs[key];
    return res;
};
const $592f66aa99e3ed6d$var$isElementRoot = (vnode)=>{
    return vnode.shapeFlag & 7 || vnode.type === $592f66aa99e3ed6d$export$4d299b491347818a;
};
function $592f66aa99e3ed6d$var$shouldUpdateComponent(prevVNode, nextVNode, optimized) {
    const { props: prevProps, children: prevChildren, component: component } = prevVNode;
    const { props: nextProps, children: nextChildren, patchFlag: patchFlag } = nextVNode;
    const emits = component.emitsOptions;
    if (nextVNode.dirs || nextVNode.transition) return true;
    if (optimized && patchFlag >= 0) {
        if (patchFlag & 1024) return true;
        if (patchFlag & 16) {
            if (!prevProps) return !!nextProps;
            return $592f66aa99e3ed6d$var$hasPropsChanged(prevProps, nextProps, emits);
        } else if (patchFlag & 8) {
            const dynamicProps = nextVNode.dynamicProps;
            for(let i = 0; i < dynamicProps.length; i++){
                const key = dynamicProps[i];
                if (nextProps[key] !== prevProps[key] && !$592f66aa99e3ed6d$var$isEmitListener(emits, key)) return true;
            }
        }
    } else {
        if (prevChildren || nextChildren) {
            if (!nextChildren || !nextChildren.$stable) return true;
        }
        if (prevProps === nextProps) return false;
        if (!prevProps) return !!nextProps;
        if (!nextProps) return true;
        return $592f66aa99e3ed6d$var$hasPropsChanged(prevProps, nextProps, emits);
    }
    return false;
}
function $592f66aa99e3ed6d$var$hasPropsChanged(prevProps, nextProps, emitsOptions) {
    const nextKeys = Object.keys(nextProps);
    if (nextKeys.length !== Object.keys(prevProps).length) return true;
    for(let i = 0; i < nextKeys.length; i++){
        const key = nextKeys[i];
        if (nextProps[key] !== prevProps[key] && !$592f66aa99e3ed6d$var$isEmitListener(emitsOptions, key)) return true;
    }
    return false;
}
function $592f66aa99e3ed6d$var$updateHOCHostEl({ vnode: vnode, parent: parent }, el) {
    while(parent && parent.subTree === vnode){
        (vnode = parent.vnode).el = el;
        parent = parent.parent;
    }
}
const $592f66aa99e3ed6d$var$isSuspense = (type)=>type.__isSuspense;
const $592f66aa99e3ed6d$var$SuspenseImpl = {
    name: "Suspense",
    // In order to make Suspense tree-shakable, we need to avoid importing it
    // directly in the renderer. The renderer checks for the __isSuspense flag
    // on a vnode's type and calls the `process` method, passing in renderer
    // internals.
    __isSuspense: true,
    process (n1, n2, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized, rendererInternals) {
        if (n1 == null) $592f66aa99e3ed6d$var$mountSuspense(n2, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized, rendererInternals);
        else $592f66aa99e3ed6d$var$patchSuspense(n1, n2, container, anchor, parentComponent, isSVG, slotScopeIds, optimized, rendererInternals);
    },
    hydrate: $592f66aa99e3ed6d$var$hydrateSuspense,
    create: $592f66aa99e3ed6d$var$createSuspenseBoundary,
    normalize: $592f66aa99e3ed6d$var$normalizeSuspenseChildren
};
const $592f66aa99e3ed6d$export$74bf444e3cd11ea5 = $592f66aa99e3ed6d$var$SuspenseImpl;
function $592f66aa99e3ed6d$var$triggerEvent(vnode, name) {
    const eventListener = vnode.props && vnode.props[name];
    if ((0, $jQKDy.isFunction)(eventListener)) eventListener();
}
function $592f66aa99e3ed6d$var$mountSuspense(vnode, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized, rendererInternals) {
    const { p: patch, o: { createElement: createElement } } = rendererInternals;
    const hiddenContainer = createElement("div");
    const suspense = vnode.suspense = $592f66aa99e3ed6d$var$createSuspenseBoundary(vnode, parentSuspense, parentComponent, container, hiddenContainer, anchor, isSVG, slotScopeIds, optimized, rendererInternals);
    patch(null, suspense.pendingBranch = vnode.ssContent, hiddenContainer, null, parentComponent, suspense, isSVG, slotScopeIds);
    if (suspense.deps > 0) {
        $592f66aa99e3ed6d$var$triggerEvent(vnode, "onPending");
        $592f66aa99e3ed6d$var$triggerEvent(vnode, "onFallback");
        patch(null, vnode.ssFallback, container, anchor, parentComponent, null, // fallback tree will not have suspense context
        isSVG, slotScopeIds);
        $592f66aa99e3ed6d$var$setActiveBranch(suspense, vnode.ssFallback);
    } else suspense.resolve(false, true);
}
function $592f66aa99e3ed6d$var$patchSuspense(n1, n2, container, anchor, parentComponent, isSVG, slotScopeIds, optimized, { p: patch, um: unmount, o: { createElement: createElement } }) {
    const suspense = n2.suspense = n1.suspense;
    suspense.vnode = n2;
    n2.el = n1.el;
    const newBranch = n2.ssContent;
    const newFallback = n2.ssFallback;
    const { activeBranch: activeBranch, pendingBranch: pendingBranch, isInFallback: isInFallback, isHydrating: isHydrating } = suspense;
    if (pendingBranch) {
        suspense.pendingBranch = newBranch;
        if ($592f66aa99e3ed6d$var$isSameVNodeType(newBranch, pendingBranch)) {
            patch(pendingBranch, newBranch, suspense.hiddenContainer, null, parentComponent, suspense, isSVG, slotScopeIds, optimized);
            if (suspense.deps <= 0) suspense.resolve();
            else if (isInFallback) {
                patch(activeBranch, newFallback, container, anchor, parentComponent, null, // fallback tree will not have suspense context
                isSVG, slotScopeIds, optimized);
                $592f66aa99e3ed6d$var$setActiveBranch(suspense, newFallback);
            }
        } else {
            suspense.pendingId++;
            if (isHydrating) {
                suspense.isHydrating = false;
                suspense.activeBranch = pendingBranch;
            } else unmount(pendingBranch, parentComponent, suspense);
            suspense.deps = 0;
            suspense.effects.length = 0;
            suspense.hiddenContainer = createElement("div");
            if (isInFallback) {
                patch(null, newBranch, suspense.hiddenContainer, null, parentComponent, suspense, isSVG, slotScopeIds, optimized);
                if (suspense.deps <= 0) suspense.resolve();
                else {
                    patch(activeBranch, newFallback, container, anchor, parentComponent, null, // fallback tree will not have suspense context
                    isSVG, slotScopeIds, optimized);
                    $592f66aa99e3ed6d$var$setActiveBranch(suspense, newFallback);
                }
            } else if (activeBranch && $592f66aa99e3ed6d$var$isSameVNodeType(newBranch, activeBranch)) {
                patch(activeBranch, newBranch, container, anchor, parentComponent, suspense, isSVG, slotScopeIds, optimized);
                suspense.resolve(true);
            } else {
                patch(null, newBranch, suspense.hiddenContainer, null, parentComponent, suspense, isSVG, slotScopeIds, optimized);
                if (suspense.deps <= 0) suspense.resolve();
            }
        }
    } else if (activeBranch && $592f66aa99e3ed6d$var$isSameVNodeType(newBranch, activeBranch)) {
        patch(activeBranch, newBranch, container, anchor, parentComponent, suspense, isSVG, slotScopeIds, optimized);
        $592f66aa99e3ed6d$var$setActiveBranch(suspense, newBranch);
    } else {
        $592f66aa99e3ed6d$var$triggerEvent(n2, "onPending");
        suspense.pendingBranch = newBranch;
        suspense.pendingId++;
        patch(null, newBranch, suspense.hiddenContainer, null, parentComponent, suspense, isSVG, slotScopeIds, optimized);
        if (suspense.deps <= 0) suspense.resolve();
        else {
            const { timeout: timeout, pendingId: pendingId } = suspense;
            if (timeout > 0) setTimeout(()=>{
                if (suspense.pendingId === pendingId) suspense.fallback(newFallback);
            }, timeout);
            else if (timeout === 0) suspense.fallback(newFallback);
        }
    }
}
let $592f66aa99e3ed6d$var$hasWarned = false;
function $592f66aa99e3ed6d$var$createSuspenseBoundary(vnode, parentSuspense, parentComponent, container, hiddenContainer, anchor, isSVG, slotScopeIds, optimized, rendererInternals, isHydrating = false) {
    const { p: patch, m: move, um: unmount, n: next, o: { parentNode: parentNode, remove: remove } } = rendererInternals;
    let parentSuspenseId;
    const isSuspensible = $592f66aa99e3ed6d$var$isVNodeSuspensible(vnode);
    if (isSuspensible) {
        if (parentSuspense == null ? void 0 : parentSuspense.pendingBranch) {
            parentSuspenseId = parentSuspense.pendingId;
            parentSuspense.deps++;
        }
    }
    const timeout = vnode.props ? (0, $jQKDy.toNumber)(vnode.props.timeout) : void 0;
    const suspense = {
        vnode: vnode,
        parent: parentSuspense,
        parentComponent: parentComponent,
        isSVG: isSVG,
        container: container,
        hiddenContainer: hiddenContainer,
        anchor: anchor,
        deps: 0,
        pendingId: 0,
        timeout: typeof timeout === "number" ? timeout : -1,
        activeBranch: null,
        pendingBranch: null,
        isInFallback: true,
        isHydrating: isHydrating,
        isUnmounted: false,
        effects: [],
        resolve (resume = false, sync = false) {
            const { vnode: vnode2, activeBranch: activeBranch, pendingBranch: pendingBranch, pendingId: pendingId, effects: effects, parentComponent: parentComponent2, container: container2 } = suspense;
            if (suspense.isHydrating) suspense.isHydrating = false;
            else if (!resume) {
                const delayEnter = activeBranch && pendingBranch.transition && pendingBranch.transition.mode === "out-in";
                if (delayEnter) activeBranch.transition.afterLeave = ()=>{
                    if (pendingId === suspense.pendingId) move(pendingBranch, container2, anchor2, 0);
                };
                let { anchor: anchor2 } = suspense;
                if (activeBranch) {
                    anchor2 = next(activeBranch);
                    unmount(activeBranch, parentComponent2, suspense, true);
                }
                if (!delayEnter) move(pendingBranch, container2, anchor2, 0);
            }
            $592f66aa99e3ed6d$var$setActiveBranch(suspense, pendingBranch);
            suspense.pendingBranch = null;
            suspense.isInFallback = false;
            let parent = suspense.parent;
            let hasUnresolvedAncestor = false;
            while(parent){
                if (parent.pendingBranch) {
                    parent.effects.push(...effects);
                    hasUnresolvedAncestor = true;
                    break;
                }
                parent = parent.parent;
            }
            if (!hasUnresolvedAncestor) $592f66aa99e3ed6d$export$59536a0199721cab(effects);
            suspense.effects = [];
            if (isSuspensible) {
                if (parentSuspense && parentSuspense.pendingBranch && parentSuspenseId === parentSuspense.pendingId) {
                    parentSuspense.deps--;
                    if (parentSuspense.deps === 0 && !sync) parentSuspense.resolve();
                }
            }
            $592f66aa99e3ed6d$var$triggerEvent(vnode2, "onResolve");
        },
        fallback (fallbackVNode) {
            if (!suspense.pendingBranch) return;
            const { vnode: vnode2, activeBranch: activeBranch, parentComponent: parentComponent2, container: container2, isSVG: isSVG2 } = suspense;
            $592f66aa99e3ed6d$var$triggerEvent(vnode2, "onFallback");
            const anchor2 = next(activeBranch);
            const mountFallback = ()=>{
                if (!suspense.isInFallback) return;
                patch(null, fallbackVNode, container2, anchor2, parentComponent2, null, // fallback tree will not have suspense context
                isSVG2, slotScopeIds, optimized);
                $592f66aa99e3ed6d$var$setActiveBranch(suspense, fallbackVNode);
            };
            const delayEnter = fallbackVNode.transition && fallbackVNode.transition.mode === "out-in";
            if (delayEnter) activeBranch.transition.afterLeave = mountFallback;
            suspense.isInFallback = true;
            unmount(activeBranch, parentComponent2, null, // no suspense so unmount hooks fire now
            true);
            if (!delayEnter) mountFallback();
        },
        move (container2, anchor2, type) {
            suspense.activeBranch && move(suspense.activeBranch, container2, anchor2, type);
            suspense.container = container2;
        },
        next () {
            return suspense.activeBranch && next(suspense.activeBranch);
        },
        registerDep (instance, setupRenderEffect) {
            const isInPendingSuspense = !!suspense.pendingBranch;
            if (isInPendingSuspense) suspense.deps++;
            const hydratedEl = instance.vnode.el;
            instance.asyncDep.catch((err)=>{
                $592f66aa99e3ed6d$export$d3da1ecaf1206c58(err, instance, 0);
            }).then((asyncSetupResult)=>{
                if (instance.isUnmounted || suspense.isUnmounted || suspense.pendingId !== instance.suspenseId) return;
                instance.asyncResolved = true;
                const { vnode: vnode2 } = instance;
                $592f66aa99e3ed6d$var$handleSetupResult(instance, asyncSetupResult, false);
                if (hydratedEl) vnode2.el = hydratedEl;
                const placeholder = !hydratedEl && instance.subTree.el;
                setupRenderEffect(instance, vnode2, // component may have been moved before resolve.
                // if this is not a hydration, instance.subTree will be the comment
                // placeholder.
                parentNode(hydratedEl || instance.subTree.el), // anchor will not be used if this is hydration, so only need to
                // consider the comment placeholder case.
                hydratedEl ? null : next(instance.subTree), suspense, isSVG, optimized);
                if (placeholder) remove(placeholder);
                $592f66aa99e3ed6d$var$updateHOCHostEl(instance, vnode2.el);
                if (isInPendingSuspense && --suspense.deps === 0) suspense.resolve();
            });
        },
        unmount (parentSuspense2, doRemove) {
            suspense.isUnmounted = true;
            if (suspense.activeBranch) unmount(suspense.activeBranch, parentComponent, parentSuspense2, doRemove);
            if (suspense.pendingBranch) unmount(suspense.pendingBranch, parentComponent, parentSuspense2, doRemove);
        }
    };
    return suspense;
}
function $592f66aa99e3ed6d$var$hydrateSuspense(node, vnode, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized, rendererInternals, hydrateNode) {
    const suspense = vnode.suspense = $592f66aa99e3ed6d$var$createSuspenseBoundary(vnode, parentSuspense, parentComponent, node.parentNode, document.createElement("div"), null, isSVG, slotScopeIds, optimized, rendererInternals, true);
    const result = hydrateNode(node, suspense.pendingBranch = vnode.ssContent, parentComponent, suspense, slotScopeIds, optimized);
    if (suspense.deps === 0) suspense.resolve(false, true);
    return result;
}
function $592f66aa99e3ed6d$var$normalizeSuspenseChildren(vnode) {
    const { shapeFlag: shapeFlag, children: children } = vnode;
    const isSlotChildren = shapeFlag & 32;
    vnode.ssContent = $592f66aa99e3ed6d$var$normalizeSuspenseSlot(isSlotChildren ? children.default : children);
    vnode.ssFallback = isSlotChildren ? $592f66aa99e3ed6d$var$normalizeSuspenseSlot(children.fallback) : $592f66aa99e3ed6d$export$bf5c4cf060303d58($592f66aa99e3ed6d$export$4d299b491347818a);
}
function $592f66aa99e3ed6d$var$normalizeSuspenseSlot(s) {
    let block;
    if ((0, $jQKDy.isFunction)(s)) {
        const trackBlock = $592f66aa99e3ed6d$var$isBlockTreeEnabled && s._c;
        if (trackBlock) {
            s._d = false;
            $592f66aa99e3ed6d$export$e7eaa45e502fe5cc();
        }
        s = s();
        if (trackBlock) {
            s._d = true;
            block = $592f66aa99e3ed6d$var$currentBlock;
            $592f66aa99e3ed6d$var$closeBlock();
        }
    }
    if ((0, $jQKDy.isArray)(s)) {
        const singleChild = $592f66aa99e3ed6d$var$filterSingleRoot(s);
        s = singleChild;
    }
    s = $592f66aa99e3ed6d$var$normalizeVNode(s);
    if (block && !s.dynamicChildren) s.dynamicChildren = block.filter((c)=>c !== s);
    return s;
}
function $592f66aa99e3ed6d$var$queueEffectWithSuspense(fn, suspense) {
    if (suspense && suspense.pendingBranch) {
        if ((0, $jQKDy.isArray)(fn)) suspense.effects.push(...fn);
        else suspense.effects.push(fn);
    } else $592f66aa99e3ed6d$export$59536a0199721cab(fn);
}
function $592f66aa99e3ed6d$var$setActiveBranch(suspense, branch) {
    suspense.activeBranch = branch;
    const { vnode: vnode, parentComponent: parentComponent } = suspense;
    const el = vnode.el = branch.el;
    if (parentComponent && parentComponent.subTree === vnode) {
        parentComponent.vnode.el = el;
        $592f66aa99e3ed6d$var$updateHOCHostEl(parentComponent, el);
    }
}
function $592f66aa99e3ed6d$var$isVNodeSuspensible(vnode) {
    var _a;
    return ((_a = vnode.props) == null ? void 0 : _a.suspensible) != null && vnode.props.suspensible !== false;
}
function $592f66aa99e3ed6d$export$ede35fc0e5500309(effect, options) {
    return $592f66aa99e3ed6d$var$doWatch(effect, null, options);
}
function $592f66aa99e3ed6d$export$b7f27ea67102d543(effect, options) {
    return $592f66aa99e3ed6d$var$doWatch(effect, null, {
        flush: "post"
    });
}
function $592f66aa99e3ed6d$export$2035654f31b0e555(effect, options) {
    return $592f66aa99e3ed6d$var$doWatch(effect, null, {
        flush: "sync"
    });
}
const $592f66aa99e3ed6d$var$INITIAL_WATCHER_VALUE = {};
function $592f66aa99e3ed6d$export$3db5d71bdb2d5499(source, cb, options) {
    return $592f66aa99e3ed6d$var$doWatch(source, cb, options);
}
function $592f66aa99e3ed6d$var$doWatch(source, cb, { immediate: immediate, deep: deep, flush: flush, onTrack: onTrack, onTrigger: onTrigger } = (0, $jQKDy.EMPTY_OBJ)) {
    var _a;
    const warnInvalidSource = (s)=>{
        $592f66aa99e3ed6d$export$c106dd0671a0fc2d(`Invalid watch source: `, s, `A watch source can only be a getter/effect function, a ref, a reactive object, or an array of these types.`);
    };
    const instance = (0, $hnQzm.getCurrentScope)() === ((_a = $592f66aa99e3ed6d$var$currentInstance) == null ? void 0 : _a.scope) ? $592f66aa99e3ed6d$var$currentInstance : null;
    let getter;
    let forceTrigger = false;
    let isMultiSource = false;
    if ((0, $hnQzm.isRef)(source)) {
        getter = ()=>source.value;
        forceTrigger = (0, $hnQzm.isShallow)(source);
    } else if ((0, $hnQzm.isReactive)(source)) {
        getter = ()=>source;
        deep = true;
    } else if ((0, $jQKDy.isArray)(source)) {
        isMultiSource = true;
        forceTrigger = source.some((s)=>(0, $hnQzm.isReactive)(s) || (0, $hnQzm.isShallow)(s));
        getter = ()=>source.map((s)=>{
                if ((0, $hnQzm.isRef)(s)) return s.value;
                else if ((0, $hnQzm.isReactive)(s)) return $592f66aa99e3ed6d$var$traverse(s);
                else if ((0, $jQKDy.isFunction)(s)) return $592f66aa99e3ed6d$export$b22fcaf88446e9bf(s, instance, 2);
            });
    } else if ((0, $jQKDy.isFunction)(source)) {
        if (cb) getter = ()=>$592f66aa99e3ed6d$export$b22fcaf88446e9bf(source, instance, 2);
        else getter = ()=>{
            if (instance && instance.isUnmounted) return;
            if (cleanup) cleanup();
            return $592f66aa99e3ed6d$export$dae85862a8d94378(source, instance, 3, [
                onCleanup
            ]);
        };
    } else getter = (0, $jQKDy.NOOP);
    if (cb && deep) {
        const baseGetter = getter;
        getter = ()=>$592f66aa99e3ed6d$var$traverse(baseGetter());
    }
    let cleanup;
    let onCleanup = (fn)=>{
        cleanup = effect.onStop = ()=>{
            $592f66aa99e3ed6d$export$b22fcaf88446e9bf(fn, instance, 4);
        };
    };
    let ssrCleanup;
    if ($592f66aa99e3ed6d$var$isInSSRComponentSetup) {
        onCleanup = (0, $jQKDy.NOOP);
        if (!cb) getter();
        else if (immediate) $592f66aa99e3ed6d$export$dae85862a8d94378(cb, instance, 3, [
            getter(),
            isMultiSource ? [] : void 0,
            onCleanup
        ]);
        if (flush === "sync") {
            const ctx = $592f66aa99e3ed6d$export$6b1c54dc4befcda();
            ssrCleanup = ctx.__watcherHandles || (ctx.__watcherHandles = []);
        } else return 0, $jQKDy.NOOP;
    }
    let oldValue = isMultiSource ? new Array(source.length).fill($592f66aa99e3ed6d$var$INITIAL_WATCHER_VALUE) : $592f66aa99e3ed6d$var$INITIAL_WATCHER_VALUE;
    const job = ()=>{
        if (!effect.active) return;
        if (cb) {
            const newValue = effect.run();
            if (deep || forceTrigger || (isMultiSource ? newValue.some((v1, i)=>(0, $jQKDy.hasChanged)(v1, oldValue[i])) : (0, $jQKDy.hasChanged)(newValue, oldValue)) || false) {
                if (cleanup) cleanup();
                $592f66aa99e3ed6d$export$dae85862a8d94378(cb, instance, 3, [
                    newValue,
                    // pass undefined as the old value when it's changed for the first time
                    oldValue === $592f66aa99e3ed6d$var$INITIAL_WATCHER_VALUE ? void 0 : isMultiSource && oldValue[0] === $592f66aa99e3ed6d$var$INITIAL_WATCHER_VALUE ? [] : oldValue,
                    onCleanup
                ]);
                oldValue = newValue;
            }
        } else effect.run();
    };
    job.allowRecurse = !!cb;
    let scheduler;
    if (flush === "sync") scheduler = job;
    else if (flush === "post") scheduler = ()=>$592f66aa99e3ed6d$var$queuePostRenderEffect(job, instance && instance.suspense);
    else {
        job.pre = true;
        if (instance) job.id = instance.uid;
        scheduler = ()=>$592f66aa99e3ed6d$var$queueJob(job);
    }
    const effect = new (0, $hnQzm.ReactiveEffect)(getter, scheduler);
    if (cb) {
        if (immediate) job();
        else oldValue = effect.run();
    } else if (flush === "post") $592f66aa99e3ed6d$var$queuePostRenderEffect(effect.run.bind(effect), instance && instance.suspense);
    else effect.run();
    const unwatch = ()=>{
        effect.stop();
        if (instance && instance.scope) (0, $jQKDy.remove)(instance.scope.effects, effect);
    };
    if (ssrCleanup) ssrCleanup.push(unwatch);
    return unwatch;
}
function $592f66aa99e3ed6d$var$instanceWatch(source, value1, options) {
    const publicThis = this.proxy;
    const getter = (0, $jQKDy.isString)(source) ? source.includes(".") ? $592f66aa99e3ed6d$var$createPathGetter(publicThis, source) : ()=>publicThis[source] : source.bind(publicThis, publicThis);
    let cb;
    if ((0, $jQKDy.isFunction)(value1)) cb = value1;
    else {
        cb = value1.handler;
        options = value1;
    }
    const cur = $592f66aa99e3ed6d$var$currentInstance;
    $592f66aa99e3ed6d$var$setCurrentInstance(this);
    const res = $592f66aa99e3ed6d$var$doWatch(getter, cb.bind(publicThis), options);
    if (cur) $592f66aa99e3ed6d$var$setCurrentInstance(cur);
    else $592f66aa99e3ed6d$var$unsetCurrentInstance();
    return res;
}
function $592f66aa99e3ed6d$var$createPathGetter(ctx, path) {
    const segments = path.split(".");
    return ()=>{
        let cur = ctx;
        for(let i = 0; i < segments.length && cur; i++)cur = cur[segments[i]];
        return cur;
    };
}
function $592f66aa99e3ed6d$var$traverse(value1, seen) {
    if (!(0, $jQKDy.isObject)(value1) || value1["__v_skip"]) return value1;
    seen = seen || /* @__PURE__ */ new Set();
    if (seen.has(value1)) return value1;
    seen.add(value1);
    if ((0, $hnQzm.isRef)(value1)) $592f66aa99e3ed6d$var$traverse(value1.value, seen);
    else if ((0, $jQKDy.isArray)(value1)) for(let i = 0; i < value1.length; i++)$592f66aa99e3ed6d$var$traverse(value1[i], seen);
    else if ((0, $jQKDy.isSet)(value1) || (0, $jQKDy.isMap)(value1)) value1.forEach((v1)=>{
        $592f66aa99e3ed6d$var$traverse(v1, seen);
    });
    else if ((0, $jQKDy.isPlainObject)(value1)) for(const key in value1)$592f66aa99e3ed6d$var$traverse(value1[key], seen);
    return value1;
}
function $592f66aa99e3ed6d$var$validateDirectiveName(name) {
    if ((0, $jQKDy.isBuiltInDirective)(name)) $592f66aa99e3ed6d$export$c106dd0671a0fc2d("Do not use built-in directive ids as custom directive id: " + name);
}
function $592f66aa99e3ed6d$export$49729353e7c1e6c5(vnode, directives) {
    const internalInstance = $592f66aa99e3ed6d$var$currentRenderingInstance;
    if (internalInstance === null) return vnode;
    const instance = $592f66aa99e3ed6d$var$getExposeProxy(internalInstance) || internalInstance.proxy;
    const bindings = vnode.dirs || (vnode.dirs = []);
    for(let i = 0; i < directives.length; i++){
        let [dir, value1, arg, modifiers = (0, $jQKDy.EMPTY_OBJ)] = directives[i];
        if (dir) {
            if ((0, $jQKDy.isFunction)(dir)) dir = {
                mounted: dir,
                updated: dir
            };
            if (dir.deep) $592f66aa99e3ed6d$var$traverse(value1);
            bindings.push({
                dir: dir,
                instance: instance,
                value: value1,
                oldValue: void 0,
                arg: arg,
                modifiers: modifiers
            });
        }
    }
    return vnode;
}
function $592f66aa99e3ed6d$var$invokeDirectiveHook(vnode, prevVNode, instance, name) {
    const bindings = vnode.dirs;
    const oldBindings = prevVNode && prevVNode.dirs;
    for(let i = 0; i < bindings.length; i++){
        const binding = bindings[i];
        if (oldBindings) binding.oldValue = oldBindings[i].value;
        let hook = binding.dir[name];
        if (hook) {
            (0, $hnQzm.pauseTracking)();
            $592f66aa99e3ed6d$export$dae85862a8d94378(hook, instance, 8, [
                vnode.el,
                binding,
                vnode,
                prevVNode
            ]);
            (0, $hnQzm.resetTracking)();
        }
    }
}
function $592f66aa99e3ed6d$export$d2a0a1bc267c90f6() {
    const state = {
        isMounted: false,
        isLeaving: false,
        isUnmounting: false,
        leavingVNodes: /* @__PURE__ */ new Map()
    };
    $592f66aa99e3ed6d$export$6d1641039221b5cb(()=>{
        state.isMounted = true;
    });
    $592f66aa99e3ed6d$export$40c420df62d2614(()=>{
        state.isUnmounting = true;
    });
    return state;
}
const $592f66aa99e3ed6d$var$TransitionHookValidator = [
    Function,
    Array
];
const $592f66aa99e3ed6d$export$b876c99684f8cf3b = {
    mode: String,
    appear: Boolean,
    persisted: Boolean,
    // enter
    onBeforeEnter: $592f66aa99e3ed6d$var$TransitionHookValidator,
    onEnter: $592f66aa99e3ed6d$var$TransitionHookValidator,
    onAfterEnter: $592f66aa99e3ed6d$var$TransitionHookValidator,
    onEnterCancelled: $592f66aa99e3ed6d$var$TransitionHookValidator,
    // leave
    onBeforeLeave: $592f66aa99e3ed6d$var$TransitionHookValidator,
    onLeave: $592f66aa99e3ed6d$var$TransitionHookValidator,
    onAfterLeave: $592f66aa99e3ed6d$var$TransitionHookValidator,
    onLeaveCancelled: $592f66aa99e3ed6d$var$TransitionHookValidator,
    // appear
    onBeforeAppear: $592f66aa99e3ed6d$var$TransitionHookValidator,
    onAppear: $592f66aa99e3ed6d$var$TransitionHookValidator,
    onAfterAppear: $592f66aa99e3ed6d$var$TransitionHookValidator,
    onAppearCancelled: $592f66aa99e3ed6d$var$TransitionHookValidator
};
const $592f66aa99e3ed6d$var$BaseTransitionImpl = {
    name: `BaseTransition`,
    props: $592f66aa99e3ed6d$export$b876c99684f8cf3b,
    setup (props, { slots: slots }) {
        const instance = $592f66aa99e3ed6d$export$f13e630aa3915748();
        const state = $592f66aa99e3ed6d$export$d2a0a1bc267c90f6();
        let prevTransitionKey;
        return ()=>{
            const children = slots.default && $592f66aa99e3ed6d$export$a67f9b1229c7c97a(slots.default(), true);
            if (!children || !children.length) return;
            let child = children[0];
            if (children.length > 1) {
                let hasFound = false;
                for (const c of children)if (c.type !== $592f66aa99e3ed6d$export$4d299b491347818a) {
                    child = c;
                    hasFound = true;
                    break;
                }
            }
            const rawProps = (0, $hnQzm.toRaw)(props);
            const { mode: mode } = rawProps;
            if (state.isLeaving) return $592f66aa99e3ed6d$var$emptyPlaceholder(child);
            const innerChild = $592f66aa99e3ed6d$var$getKeepAliveChild(child);
            if (!innerChild) return $592f66aa99e3ed6d$var$emptyPlaceholder(child);
            const enterHooks = $592f66aa99e3ed6d$export$76ac1779589cd824(innerChild, rawProps, state, instance);
            $592f66aa99e3ed6d$export$7770a22486565649(innerChild, enterHooks);
            const oldChild = instance.subTree;
            const oldInnerChild = oldChild && $592f66aa99e3ed6d$var$getKeepAliveChild(oldChild);
            let transitionKeyChanged = false;
            const { getTransitionKey: getTransitionKey } = innerChild.type;
            if (getTransitionKey) {
                const key = getTransitionKey();
                if (prevTransitionKey === void 0) prevTransitionKey = key;
                else if (key !== prevTransitionKey) {
                    prevTransitionKey = key;
                    transitionKeyChanged = true;
                }
            }
            if (oldInnerChild && oldInnerChild.type !== $592f66aa99e3ed6d$export$4d299b491347818a && (!$592f66aa99e3ed6d$var$isSameVNodeType(innerChild, oldInnerChild) || transitionKeyChanged)) {
                const leavingHooks = $592f66aa99e3ed6d$export$76ac1779589cd824(oldInnerChild, rawProps, state, instance);
                $592f66aa99e3ed6d$export$7770a22486565649(oldInnerChild, leavingHooks);
                if (mode === "out-in") {
                    state.isLeaving = true;
                    leavingHooks.afterLeave = ()=>{
                        state.isLeaving = false;
                        if (instance.update.active !== false) instance.update();
                    };
                    return $592f66aa99e3ed6d$var$emptyPlaceholder(child);
                } else if (mode === "in-out" && innerChild.type !== $592f66aa99e3ed6d$export$4d299b491347818a) leavingHooks.delayLeave = (el, earlyRemove, delayedLeave)=>{
                    const leavingVNodesCache = $592f66aa99e3ed6d$var$getLeavingNodesForType(state, oldInnerChild);
                    leavingVNodesCache[String(oldInnerChild.key)] = oldInnerChild;
                    el._leaveCb = ()=>{
                        earlyRemove();
                        el._leaveCb = void 0;
                        delete enterHooks.delayedLeave;
                    };
                    enterHooks.delayedLeave = delayedLeave;
                };
            }
            return child;
        };
    }
};
const $592f66aa99e3ed6d$export$abd95b5f5e8a8837 = $592f66aa99e3ed6d$var$BaseTransitionImpl;
function $592f66aa99e3ed6d$var$getLeavingNodesForType(state, vnode) {
    const { leavingVNodes: leavingVNodes } = state;
    let leavingVNodesCache = leavingVNodes.get(vnode.type);
    if (!leavingVNodesCache) {
        leavingVNodesCache = /* @__PURE__ */ Object.create(null);
        leavingVNodes.set(vnode.type, leavingVNodesCache);
    }
    return leavingVNodesCache;
}
function $592f66aa99e3ed6d$export$76ac1779589cd824(vnode, props, state, instance) {
    const { appear: appear, mode: mode, persisted: persisted = false, onBeforeEnter: onBeforeEnter, onEnter: onEnter, onAfterEnter: onAfterEnter, onEnterCancelled: onEnterCancelled, onBeforeLeave: onBeforeLeave, onLeave: onLeave, onAfterLeave: onAfterLeave, onLeaveCancelled: onLeaveCancelled, onBeforeAppear: onBeforeAppear, onAppear: onAppear, onAfterAppear: onAfterAppear, onAppearCancelled: onAppearCancelled } = props;
    const key = String(vnode.key);
    const leavingVNodesCache = $592f66aa99e3ed6d$var$getLeavingNodesForType(state, vnode);
    const callHook = (hook, args)=>{
        hook && $592f66aa99e3ed6d$export$dae85862a8d94378(hook, instance, 9, args);
    };
    const callAsyncHook = (hook, args)=>{
        const done = args[1];
        callHook(hook, args);
        if ((0, $jQKDy.isArray)(hook)) {
            if (hook.every((hook2)=>hook2.length <= 1)) done();
        } else if (hook.length <= 1) done();
    };
    const hooks = {
        mode: mode,
        persisted: persisted,
        beforeEnter (el) {
            let hook = onBeforeEnter;
            if (!state.isMounted) {
                if (appear) hook = onBeforeAppear || onBeforeEnter;
                else return;
            }
            if (el._leaveCb) el._leaveCb(true);
            const leavingVNode = leavingVNodesCache[key];
            if (leavingVNode && $592f66aa99e3ed6d$var$isSameVNodeType(vnode, leavingVNode) && leavingVNode.el._leaveCb) leavingVNode.el._leaveCb();
            callHook(hook, [
                el
            ]);
        },
        enter (el) {
            let hook = onEnter;
            let afterHook = onAfterEnter;
            let cancelHook = onEnterCancelled;
            if (!state.isMounted) {
                if (appear) {
                    hook = onAppear || onEnter;
                    afterHook = onAfterAppear || onAfterEnter;
                    cancelHook = onAppearCancelled || onEnterCancelled;
                } else return;
            }
            let called = false;
            const done = el._enterCb = (cancelled)=>{
                if (called) return;
                called = true;
                if (cancelled) callHook(cancelHook, [
                    el
                ]);
                else callHook(afterHook, [
                    el
                ]);
                if (hooks.delayedLeave) hooks.delayedLeave();
                el._enterCb = void 0;
            };
            if (hook) callAsyncHook(hook, [
                el,
                done
            ]);
            else done();
        },
        leave (el, remove) {
            const key2 = String(vnode.key);
            if (el._enterCb) el._enterCb(true);
            if (state.isUnmounting) return remove();
            callHook(onBeforeLeave, [
                el
            ]);
            let called = false;
            const done = el._leaveCb = (cancelled)=>{
                if (called) return;
                called = true;
                remove();
                if (cancelled) callHook(onLeaveCancelled, [
                    el
                ]);
                else callHook(onAfterLeave, [
                    el
                ]);
                el._leaveCb = void 0;
                if (leavingVNodesCache[key2] === vnode) delete leavingVNodesCache[key2];
            };
            leavingVNodesCache[key2] = vnode;
            if (onLeave) callAsyncHook(onLeave, [
                el,
                done
            ]);
            else done();
        },
        clone (vnode2) {
            return $592f66aa99e3ed6d$export$76ac1779589cd824(vnode2, props, state, instance);
        }
    };
    return hooks;
}
function $592f66aa99e3ed6d$var$emptyPlaceholder(vnode) {
    if ($592f66aa99e3ed6d$var$isKeepAlive(vnode)) {
        vnode = $592f66aa99e3ed6d$export$ee4f9e12c0a92a1a(vnode);
        vnode.children = null;
        return vnode;
    }
}
function $592f66aa99e3ed6d$var$getKeepAliveChild(vnode) {
    return $592f66aa99e3ed6d$var$isKeepAlive(vnode) ? vnode.children ? vnode.children[0] : void 0 : vnode;
}
function $592f66aa99e3ed6d$export$7770a22486565649(vnode, hooks) {
    if (vnode.shapeFlag & 6 && vnode.component) $592f66aa99e3ed6d$export$7770a22486565649(vnode.component.subTree, hooks);
    else if (vnode.shapeFlag & 128) {
        vnode.ssContent.transition = hooks.clone(vnode.ssContent);
        vnode.ssFallback.transition = hooks.clone(vnode.ssFallback);
    } else vnode.transition = hooks;
}
function $592f66aa99e3ed6d$export$a67f9b1229c7c97a(children, keepComment = false, parentKey) {
    let ret = [];
    let keyedFragmentCount = 0;
    for(let i = 0; i < children.length; i++){
        let child = children[i];
        const key = parentKey == null ? child.key : String(parentKey) + String(child.key != null ? child.key : i);
        if (child.type === $592f66aa99e3ed6d$export$ffb0004e005737fa) {
            if (child.patchFlag & 128) keyedFragmentCount++;
            ret = ret.concat($592f66aa99e3ed6d$export$a67f9b1229c7c97a(child.children, keepComment, key));
        } else if (keepComment || child.type !== $592f66aa99e3ed6d$export$4d299b491347818a) ret.push(key != null ? $592f66aa99e3ed6d$export$ee4f9e12c0a92a1a(child, {
            key: key
        }) : child);
    }
    if (keyedFragmentCount > 1) for(let i = 0; i < ret.length; i++)ret[i].patchFlag = -2;
    return ret;
}
function $592f66aa99e3ed6d$export$afa64b67e5a01c3b(options, extraOptions) {
    return (0, $jQKDy.isFunction)(options) ? // #8326: extend call and options.name access are considered side-effects
    // by Rollup, so we have to wrap it in a pure-annotated IIFE.
    /* @__PURE__ */ (()=>(0, $jQKDy.extend)({
            name: options.name
        }, extraOptions, {
            setup: options
        }))() : options;
}
const $592f66aa99e3ed6d$var$isAsyncWrapper = (i)=>!!i.type.__asyncLoader;
function $592f66aa99e3ed6d$export$d75d499b4c16cf21(source) {
    if ((0, $jQKDy.isFunction)(source)) source = {
        loader: source
    };
    const { loader: loader, loadingComponent: loadingComponent, errorComponent: errorComponent, delay: delay = 200, timeout: timeout, suspensible: // undefined = never times out
    suspensible = true, onError: userOnError } = source;
    let pendingRequest = null;
    let resolvedComp;
    let retries = 0;
    const retry = ()=>{
        retries++;
        pendingRequest = null;
        return load();
    };
    const load = ()=>{
        let thisRequest;
        return pendingRequest || (thisRequest = pendingRequest = loader().catch((err)=>{
            err = err instanceof Error ? err : new Error(String(err));
            if (userOnError) return new Promise((resolve, reject)=>{
                const userRetry = ()=>resolve(retry());
                const userFail = ()=>reject(err);
                userOnError(err, userRetry, userFail, retries + 1);
            });
            else throw err;
        }).then((comp)=>{
            if (thisRequest !== pendingRequest && pendingRequest) return pendingRequest;
            if (comp && (comp.__esModule || comp[Symbol.toStringTag] === "Module")) comp = comp.default;
            resolvedComp = comp;
            return comp;
        }));
    };
    return $592f66aa99e3ed6d$export$afa64b67e5a01c3b({
        name: "AsyncComponentWrapper",
        __asyncLoader: load,
        get __asyncResolved () {
            return resolvedComp;
        },
        setup () {
            const instance = $592f66aa99e3ed6d$var$currentInstance;
            if (resolvedComp) return ()=>$592f66aa99e3ed6d$var$createInnerComp(resolvedComp, instance);
            const onError = (err)=>{
                pendingRequest = null;
                $592f66aa99e3ed6d$export$d3da1ecaf1206c58(err, instance, 13, !errorComponent);
            };
            if (suspensible && instance.suspense || $592f66aa99e3ed6d$var$isInSSRComponentSetup) return load().then((comp)=>{
                return ()=>$592f66aa99e3ed6d$var$createInnerComp(comp, instance);
            }).catch((err)=>{
                onError(err);
                return ()=>errorComponent ? $592f66aa99e3ed6d$export$bf5c4cf060303d58(errorComponent, {
                        error: err
                    }) : null;
            });
            const loaded = (0, $hnQzm.ref)(false);
            const error = (0, $hnQzm.ref)();
            const delayed = (0, $hnQzm.ref)(!!delay);
            if (delay) setTimeout(()=>{
                delayed.value = false;
            }, delay);
            if (timeout != null) setTimeout(()=>{
                if (!loaded.value && !error.value) {
                    const err = new Error(`Async component timed out after ${timeout}ms.`);
                    onError(err);
                    error.value = err;
                }
            }, timeout);
            load().then(()=>{
                loaded.value = true;
                if (instance.parent && $592f66aa99e3ed6d$var$isKeepAlive(instance.parent.vnode)) $592f66aa99e3ed6d$var$queueJob(instance.parent.update);
            }).catch((err)=>{
                onError(err);
                error.value = err;
            });
            return ()=>{
                if (loaded.value && resolvedComp) return $592f66aa99e3ed6d$var$createInnerComp(resolvedComp, instance);
                else if (error.value && errorComponent) return $592f66aa99e3ed6d$export$bf5c4cf060303d58(errorComponent, {
                    error: error.value
                });
                else if (loadingComponent && !delayed.value) return $592f66aa99e3ed6d$export$bf5c4cf060303d58(loadingComponent);
            };
        }
    });
}
function $592f66aa99e3ed6d$var$createInnerComp(comp, parent) {
    const { ref: ref2, props: props, children: children, ce: ce } = parent.vnode;
    const vnode = $592f66aa99e3ed6d$export$bf5c4cf060303d58(comp, props, children);
    vnode.ref = ref2;
    vnode.ce = ce;
    delete parent.vnode.ce;
    return vnode;
}
const $592f66aa99e3ed6d$var$isKeepAlive = (vnode)=>vnode.type.__isKeepAlive;
const $592f66aa99e3ed6d$var$KeepAliveImpl = {
    name: `KeepAlive`,
    // Marker for special handling inside the renderer. We are not using a ===
    // check directly on KeepAlive in the renderer, because importing it directly
    // would prevent it from being tree-shaken.
    __isKeepAlive: true,
    props: {
        include: [
            String,
            RegExp,
            Array
        ],
        exclude: [
            String,
            RegExp,
            Array
        ],
        max: [
            String,
            Number
        ]
    },
    setup (props, { slots: slots }) {
        const instance = $592f66aa99e3ed6d$export$f13e630aa3915748();
        const sharedContext = instance.ctx;
        if (!sharedContext.renderer) return ()=>{
            const children = slots.default && slots.default();
            return children && children.length === 1 ? children[0] : children;
        };
        const cache = /* @__PURE__ */ new Map();
        const keys = /* @__PURE__ */ new Set();
        let current = null;
        if (__VUE_PROD_DEVTOOLS__) instance.__v_cache = cache;
        const parentSuspense = instance.suspense;
        const { renderer: { p: patch, m: move, um: _unmount, o: { createElement: createElement } } } = sharedContext;
        const storageContainer = createElement("div");
        sharedContext.activate = (vnode, container, anchor, isSVG, optimized)=>{
            const instance2 = vnode.component;
            move(vnode, container, anchor, 0, parentSuspense);
            patch(instance2.vnode, vnode, container, anchor, instance2, parentSuspense, isSVG, vnode.slotScopeIds, optimized);
            $592f66aa99e3ed6d$var$queuePostRenderEffect(()=>{
                instance2.isDeactivated = false;
                if (instance2.a) (0, $jQKDy.invokeArrayFns)(instance2.a);
                const vnodeHook = vnode.props && vnode.props.onVnodeMounted;
                if (vnodeHook) $592f66aa99e3ed6d$var$invokeVNodeHook(vnodeHook, instance2.parent, vnode);
            }, parentSuspense);
            if (__VUE_PROD_DEVTOOLS__) $592f66aa99e3ed6d$var$devtoolsComponentAdded(instance2);
        };
        sharedContext.deactivate = (vnode)=>{
            const instance2 = vnode.component;
            move(vnode, storageContainer, null, 1, parentSuspense);
            $592f66aa99e3ed6d$var$queuePostRenderEffect(()=>{
                if (instance2.da) (0, $jQKDy.invokeArrayFns)(instance2.da);
                const vnodeHook = vnode.props && vnode.props.onVnodeUnmounted;
                if (vnodeHook) $592f66aa99e3ed6d$var$invokeVNodeHook(vnodeHook, instance2.parent, vnode);
                instance2.isDeactivated = true;
            }, parentSuspense);
            if (__VUE_PROD_DEVTOOLS__) $592f66aa99e3ed6d$var$devtoolsComponentAdded(instance2);
        };
        function unmount(vnode) {
            $592f66aa99e3ed6d$var$resetShapeFlag(vnode);
            _unmount(vnode, instance, parentSuspense, true);
        }
        function pruneCache(filter) {
            cache.forEach((vnode, key)=>{
                const name = $592f66aa99e3ed6d$var$getComponentName(vnode.type);
                if (name && (!filter || !filter(name))) pruneCacheEntry(key);
            });
        }
        function pruneCacheEntry(key) {
            const cached = cache.get(key);
            if (!current || !$592f66aa99e3ed6d$var$isSameVNodeType(cached, current)) unmount(cached);
            else if (current) $592f66aa99e3ed6d$var$resetShapeFlag(current);
            cache.delete(key);
            keys.delete(key);
        }
        $592f66aa99e3ed6d$export$3db5d71bdb2d5499(()=>[
                props.include,
                props.exclude
            ], ([include, exclude])=>{
            include && pruneCache((name)=>$592f66aa99e3ed6d$var$matches(include, name));
            exclude && pruneCache((name)=>!$592f66aa99e3ed6d$var$matches(exclude, name));
        }, // prune post-render after `current` has been updated
        {
            flush: "post",
            deep: true
        });
        let pendingCacheKey = null;
        const cacheSubtree = ()=>{
            if (pendingCacheKey != null) cache.set(pendingCacheKey, $592f66aa99e3ed6d$var$getInnerChild(instance.subTree));
        };
        $592f66aa99e3ed6d$export$6d1641039221b5cb(cacheSubtree);
        $592f66aa99e3ed6d$export$5876c47052fb88b1(cacheSubtree);
        $592f66aa99e3ed6d$export$40c420df62d2614(()=>{
            cache.forEach((cached)=>{
                const { subTree: subTree, suspense: suspense } = instance;
                const vnode = $592f66aa99e3ed6d$var$getInnerChild(subTree);
                if (cached.type === vnode.type && cached.key === vnode.key) {
                    $592f66aa99e3ed6d$var$resetShapeFlag(vnode);
                    const da = vnode.component.da;
                    da && $592f66aa99e3ed6d$var$queuePostRenderEffect(da, suspense);
                    return;
                }
                unmount(cached);
            });
        });
        return ()=>{
            pendingCacheKey = null;
            if (!slots.default) return null;
            const children = slots.default();
            const rawVNode = children[0];
            if (children.length > 1) {
                current = null;
                return children;
            } else if (!$592f66aa99e3ed6d$export$3868d13f8734ae81(rawVNode) || !(rawVNode.shapeFlag & 4) && !(rawVNode.shapeFlag & 128)) {
                current = null;
                return rawVNode;
            }
            let vnode = $592f66aa99e3ed6d$var$getInnerChild(rawVNode);
            const comp = vnode.type;
            const name = $592f66aa99e3ed6d$var$getComponentName($592f66aa99e3ed6d$var$isAsyncWrapper(vnode) ? vnode.type.__asyncResolved || {} : comp);
            const { include: include, exclude: exclude, max: max } = props;
            if (include && (!name || !$592f66aa99e3ed6d$var$matches(include, name)) || exclude && name && $592f66aa99e3ed6d$var$matches(exclude, name)) {
                current = vnode;
                return rawVNode;
            }
            const key = vnode.key == null ? comp : vnode.key;
            const cachedVNode = cache.get(key);
            if (vnode.el) {
                vnode = $592f66aa99e3ed6d$export$ee4f9e12c0a92a1a(vnode);
                if (rawVNode.shapeFlag & 128) rawVNode.ssContent = vnode;
            }
            pendingCacheKey = key;
            if (cachedVNode) {
                vnode.el = cachedVNode.el;
                vnode.component = cachedVNode.component;
                if (vnode.transition) $592f66aa99e3ed6d$export$7770a22486565649(vnode, vnode.transition);
                vnode.shapeFlag |= 512;
                keys.delete(key);
                keys.add(key);
            } else {
                keys.add(key);
                if (max && keys.size > parseInt(max, 10)) pruneCacheEntry(keys.values().next().value);
            }
            vnode.shapeFlag |= 256;
            current = vnode;
            return $592f66aa99e3ed6d$var$isSuspense(rawVNode.type) ? rawVNode : vnode;
        };
    }
};
const $592f66aa99e3ed6d$export$70eb8a58709972df = $592f66aa99e3ed6d$var$KeepAliveImpl;
function $592f66aa99e3ed6d$var$matches(pattern, name) {
    if ((0, $jQKDy.isArray)(pattern)) return pattern.some((p)=>$592f66aa99e3ed6d$var$matches(p, name));
    else if ((0, $jQKDy.isString)(pattern)) return pattern.split(",").includes(name);
    else if ((0, $jQKDy.isRegExp)(pattern)) return pattern.test(name);
    return false;
}
function $592f66aa99e3ed6d$export$ba52d824b95a2154(hook, target) {
    $592f66aa99e3ed6d$var$registerKeepAliveHook(hook, "a", target);
}
function $592f66aa99e3ed6d$export$bf1440eeaf5fa709(hook, target) {
    $592f66aa99e3ed6d$var$registerKeepAliveHook(hook, "da", target);
}
function $592f66aa99e3ed6d$var$registerKeepAliveHook(hook, type, target = $592f66aa99e3ed6d$var$currentInstance) {
    const wrappedHook = hook.__wdc || (hook.__wdc = ()=>{
        let current = target;
        while(current){
            if (current.isDeactivated) return;
            current = current.parent;
        }
        return hook();
    });
    $592f66aa99e3ed6d$var$injectHook(type, wrappedHook, target);
    if (target) {
        let current = target.parent;
        while(current && current.parent){
            if ($592f66aa99e3ed6d$var$isKeepAlive(current.parent.vnode)) $592f66aa99e3ed6d$var$injectToKeepAliveRoot(wrappedHook, type, target, current);
            current = current.parent;
        }
    }
}
function $592f66aa99e3ed6d$var$injectToKeepAliveRoot(hook, type, target, keepAliveRoot) {
    const injected = $592f66aa99e3ed6d$var$injectHook(type, hook, keepAliveRoot, true);
    $592f66aa99e3ed6d$export$13348a43ccacfe58(()=>{
        (0, $jQKDy.remove)(keepAliveRoot[type], injected);
    }, target);
}
function $592f66aa99e3ed6d$var$resetShapeFlag(vnode) {
    vnode.shapeFlag &= -257;
    vnode.shapeFlag &= -513;
}
function $592f66aa99e3ed6d$var$getInnerChild(vnode) {
    return vnode.shapeFlag & 128 ? vnode.ssContent : vnode;
}
function $592f66aa99e3ed6d$var$injectHook(type, hook, target = $592f66aa99e3ed6d$var$currentInstance, prepend = false) {
    if (target) {
        const hooks = target[type] || (target[type] = []);
        const wrappedHook = hook.__weh || (hook.__weh = (...args)=>{
            if (target.isUnmounted) return;
            (0, $hnQzm.pauseTracking)();
            $592f66aa99e3ed6d$var$setCurrentInstance(target);
            const res = $592f66aa99e3ed6d$export$dae85862a8d94378(hook, target, type, args);
            $592f66aa99e3ed6d$var$unsetCurrentInstance();
            (0, $hnQzm.resetTracking)();
            return res;
        });
        if (prepend) hooks.unshift(wrappedHook);
        else hooks.push(wrappedHook);
        return wrappedHook;
    }
}
const $592f66aa99e3ed6d$var$createHook = (lifecycle)=>(hook, target = $592f66aa99e3ed6d$var$currentInstance)=>// post-create lifecycle registrations are noops during SSR (except for serverPrefetch)
        (!$592f66aa99e3ed6d$var$isInSSRComponentSetup || lifecycle === "sp") && $592f66aa99e3ed6d$var$injectHook(lifecycle, (...args)=>hook(...args), target);
const $592f66aa99e3ed6d$export$23b7aeb0d671f804 = $592f66aa99e3ed6d$var$createHook("bm");
const $592f66aa99e3ed6d$export$6d1641039221b5cb = $592f66aa99e3ed6d$var$createHook("m");
const $592f66aa99e3ed6d$export$ab91988a13872e4c = $592f66aa99e3ed6d$var$createHook("bu");
const $592f66aa99e3ed6d$export$5876c47052fb88b1 = $592f66aa99e3ed6d$var$createHook("u");
const $592f66aa99e3ed6d$export$40c420df62d2614 = $592f66aa99e3ed6d$var$createHook("bum");
const $592f66aa99e3ed6d$export$13348a43ccacfe58 = $592f66aa99e3ed6d$var$createHook("um");
const $592f66aa99e3ed6d$export$ebf0c601f267bceb = $592f66aa99e3ed6d$var$createHook("sp");
const $592f66aa99e3ed6d$export$898295a813d662eb = $592f66aa99e3ed6d$var$createHook("rtg");
const $592f66aa99e3ed6d$export$2b41f4235363e921 = $592f66aa99e3ed6d$var$createHook("rtc");
function $592f66aa99e3ed6d$export$6a3a15856e50ad19(hook, target = $592f66aa99e3ed6d$var$currentInstance) {
    $592f66aa99e3ed6d$var$injectHook("ec", hook, target);
}
const $592f66aa99e3ed6d$var$COMPONENTS = "components";
const $592f66aa99e3ed6d$var$DIRECTIVES = "directives";
function $592f66aa99e3ed6d$export$681d65eec9d1d1e8(name, maybeSelfReference) {
    return $592f66aa99e3ed6d$var$resolveAsset($592f66aa99e3ed6d$var$COMPONENTS, name, true, maybeSelfReference) || name;
}
const $592f66aa99e3ed6d$var$NULL_DYNAMIC_COMPONENT = Symbol.for("v-ndc");
function $592f66aa99e3ed6d$export$b44c564a05ca975(component) {
    if ((0, $jQKDy.isString)(component)) return $592f66aa99e3ed6d$var$resolveAsset($592f66aa99e3ed6d$var$COMPONENTS, component, false) || component;
    else return component || $592f66aa99e3ed6d$var$NULL_DYNAMIC_COMPONENT;
}
function $592f66aa99e3ed6d$export$a1989e995cd481be(name) {
    return $592f66aa99e3ed6d$var$resolveAsset($592f66aa99e3ed6d$var$DIRECTIVES, name);
}
function $592f66aa99e3ed6d$var$resolveAsset(type, name, warnMissing = true, maybeSelfReference = false) {
    const instance = $592f66aa99e3ed6d$var$currentRenderingInstance || $592f66aa99e3ed6d$var$currentInstance;
    if (instance) {
        const Component = instance.type;
        if (type === $592f66aa99e3ed6d$var$COMPONENTS) {
            const selfName = $592f66aa99e3ed6d$var$getComponentName(Component, false);
            if (selfName && (selfName === name || selfName === (0, $jQKDy.camelize)(name) || selfName === (0, $jQKDy.capitalize)((0, $jQKDy.camelize)(name)))) return Component;
        }
        const res = // local registration
        // check instance[type] first which is resolved for options API
        $592f66aa99e3ed6d$var$resolve(instance[type] || Component[type], name) || // global registration
        $592f66aa99e3ed6d$var$resolve(instance.appContext[type], name);
        if (!res && maybeSelfReference) return Component;
        return res;
    }
}
function $592f66aa99e3ed6d$var$resolve(registry, name) {
    return registry && (registry[name] || registry[(0, $jQKDy.camelize)(name)] || registry[(0, $jQKDy.capitalize)((0, $jQKDy.camelize)(name))]);
}
function $592f66aa99e3ed6d$export$4bf387f59bfc6d67(source, renderItem, cache, index) {
    let ret;
    const cached = cache && cache[index];
    if ((0, $jQKDy.isArray)(source) || (0, $jQKDy.isString)(source)) {
        ret = new Array(source.length);
        for(let i = 0, l = source.length; i < l; i++)ret[i] = renderItem(source[i], i, void 0, cached && cached[i]);
    } else if (typeof source === "number") {
        ret = new Array(source);
        for(let i = 0; i < source; i++)ret[i] = renderItem(i + 1, i, void 0, cached && cached[i]);
    } else if ((0, $jQKDy.isObject)(source)) {
        if (source[Symbol.iterator]) ret = Array.from(source, (item, i)=>renderItem(item, i, void 0, cached && cached[i]));
        else {
            const keys = Object.keys(source);
            ret = new Array(keys.length);
            for(let i = 0, l = keys.length; i < l; i++){
                const key = keys[i];
                ret[i] = renderItem(source[key], key, i, cached && cached[i]);
            }
        }
    } else ret = [];
    if (cache) cache[index] = ret;
    return ret;
}
function $592f66aa99e3ed6d$export$85738f8fcd0a5430(slots, dynamicSlots) {
    for(let i = 0; i < dynamicSlots.length; i++){
        const slot = dynamicSlots[i];
        if ((0, $jQKDy.isArray)(slot)) for(let j = 0; j < slot.length; j++)slots[slot[j].name] = slot[j].fn;
        else if (slot) slots[slot.name] = slot.key ? (...args)=>{
            const res = slot.fn(...args);
            if (res) res.key = slot.key;
            return res;
        } : slot.fn;
    }
    return slots;
}
function $592f66aa99e3ed6d$export$4abee4c34694ada1(slots, name, props = {}, fallback, noSlotted) {
    if ($592f66aa99e3ed6d$var$currentRenderingInstance.isCE || $592f66aa99e3ed6d$var$currentRenderingInstance.parent && $592f66aa99e3ed6d$var$isAsyncWrapper($592f66aa99e3ed6d$var$currentRenderingInstance.parent) && $592f66aa99e3ed6d$var$currentRenderingInstance.parent.isCE) {
        if (name !== "default") props.name = name;
        return $592f66aa99e3ed6d$export$bf5c4cf060303d58("slot", props, fallback && fallback());
    }
    let slot = slots[name];
    if (slot && slot._c) slot._d = false;
    $592f66aa99e3ed6d$export$e7eaa45e502fe5cc();
    const validSlotContent = slot && $592f66aa99e3ed6d$var$ensureValidVNode(slot(props));
    const rendered = $592f66aa99e3ed6d$export$9f2dfe8048dfb22b($592f66aa99e3ed6d$export$ffb0004e005737fa, {
        key: props.key || // slot content array of a dynamic conditional slot may have a branch
        // key attached in the `createSlots` helper, respect that
        validSlotContent && validSlotContent.key || `_${name}`
    }, validSlotContent || (fallback ? fallback() : []), validSlotContent && slots._ === 1 ? 64 : -2);
    if (!noSlotted && rendered.scopeId) rendered.slotScopeIds = [
        rendered.scopeId + "-s"
    ];
    if (slot && slot._c) slot._d = true;
    return rendered;
}
function $592f66aa99e3ed6d$var$ensureValidVNode(vnodes) {
    return vnodes.some((child)=>{
        if (!$592f66aa99e3ed6d$export$3868d13f8734ae81(child)) return true;
        if (child.type === $592f66aa99e3ed6d$export$4d299b491347818a) return false;
        if (child.type === $592f66aa99e3ed6d$export$ffb0004e005737fa && !$592f66aa99e3ed6d$var$ensureValidVNode(child.children)) return false;
        return true;
    }) ? vnodes : null;
}
function $592f66aa99e3ed6d$export$2fb94ff667a6a1a(obj, preserveCaseIfNecessary) {
    const ret = {};
    for(const key in obj)ret[preserveCaseIfNecessary && /[A-Z]/.test(key) ? `on:${key}` : (0, $jQKDy.toHandlerKey)(key)] = obj[key];
    return ret;
}
const $592f66aa99e3ed6d$var$getPublicInstance = (i)=>{
    if (!i) return null;
    if ($592f66aa99e3ed6d$var$isStatefulComponent(i)) return $592f66aa99e3ed6d$var$getExposeProxy(i) || i.proxy;
    return $592f66aa99e3ed6d$var$getPublicInstance(i.parent);
};
const $592f66aa99e3ed6d$var$publicPropertiesMap = // Move PURE marker to new line to workaround compiler discarding it
// due to type annotation
/* @__PURE__ */ (0, $jQKDy.extend)(/* @__PURE__ */ Object.create(null), {
    $: (i)=>i,
    $el: (i)=>i.vnode.el,
    $data: (i)=>i.data,
    $props: (i)=>(0, i.props),
    $attrs: (i)=>(0, i.attrs),
    $slots: (i)=>(0, i.slots),
    $refs: (i)=>(0, i.refs),
    $parent: (i)=>$592f66aa99e3ed6d$var$getPublicInstance(i.parent),
    $root: (i)=>$592f66aa99e3ed6d$var$getPublicInstance(i.root),
    $emit: (i)=>i.emit,
    $options: (i)=>__VUE_OPTIONS_API__ ? $592f66aa99e3ed6d$var$resolveMergedOptions(i) : i.type,
    $forceUpdate: (i)=>i.f || (i.f = ()=>$592f66aa99e3ed6d$var$queueJob(i.update)),
    $nextTick: (i)=>i.n || (i.n = $592f66aa99e3ed6d$export$bdd553fddd433dcb.bind(i.proxy)),
    $watch: (i)=>__VUE_OPTIONS_API__ ? $592f66aa99e3ed6d$var$instanceWatch.bind(i) : (0, $jQKDy.NOOP)
});
const $592f66aa99e3ed6d$var$isReservedPrefix = (key)=>key === "_" || key === "$";
const $592f66aa99e3ed6d$var$hasSetupBinding = (state, key)=>state !== (0, $jQKDy.EMPTY_OBJ) && !state.__isScriptSetup && (0, $jQKDy.hasOwn)(state, key);
const $592f66aa99e3ed6d$var$PublicInstanceProxyHandlers = {
    get ({ _: instance }, key) {
        const { ctx: ctx, setupState: setupState, data: data, props: props, accessCache: accessCache, type: type, appContext: appContext } = instance;
        let normalizedProps;
        if (key[0] !== "$") {
            const n = accessCache[key];
            if (n !== void 0) switch(n){
                case 1 /* SETUP */ :
                    return setupState[key];
                case 2 /* DATA */ :
                    return data[key];
                case 4 /* CONTEXT */ :
                    return ctx[key];
                case 3 /* PROPS */ :
                    return props[key];
            }
            else if ($592f66aa99e3ed6d$var$hasSetupBinding(setupState, key)) {
                accessCache[key] = 1 /* SETUP */ ;
                return setupState[key];
            } else if (data !== (0, $jQKDy.EMPTY_OBJ) && (0, $jQKDy.hasOwn)(data, key)) {
                accessCache[key] = 2 /* DATA */ ;
                return data[key];
            } else if (// only cache other properties when instance has declared (thus stable)
            // props
            (normalizedProps = instance.propsOptions[0]) && (0, $jQKDy.hasOwn)(normalizedProps, key)) {
                accessCache[key] = 3 /* PROPS */ ;
                return props[key];
            } else if (ctx !== (0, $jQKDy.EMPTY_OBJ) && (0, $jQKDy.hasOwn)(ctx, key)) {
                accessCache[key] = 4 /* CONTEXT */ ;
                return ctx[key];
            } else if (!__VUE_OPTIONS_API__ || $592f66aa99e3ed6d$var$shouldCacheAccess) accessCache[key] = 0 /* OTHER */ ;
        }
        const publicGetter = $592f66aa99e3ed6d$var$publicPropertiesMap[key];
        let cssModule, globalProperties;
        if (publicGetter) {
            if (key === "$attrs") (0, $hnQzm.track)(instance, "get", key);
            return publicGetter(instance);
        } else if (// css module (injected by vue-loader)
        (cssModule = type.__cssModules) && (cssModule = cssModule[key])) return cssModule;
        else if (ctx !== (0, $jQKDy.EMPTY_OBJ) && (0, $jQKDy.hasOwn)(ctx, key)) {
            accessCache[key] = 4 /* CONTEXT */ ;
            return ctx[key];
        } else if (// global properties
        globalProperties = appContext.config.globalProperties, (0, $jQKDy.hasOwn)(globalProperties, key)) return globalProperties[key];
    },
    set ({ _: instance }, key, value1) {
        const { data: data, setupState: setupState, ctx: ctx } = instance;
        if ($592f66aa99e3ed6d$var$hasSetupBinding(setupState, key)) {
            setupState[key] = value1;
            return true;
        } else {
            if (data !== (0, $jQKDy.EMPTY_OBJ) && (0, $jQKDy.hasOwn)(data, key)) {
                data[key] = value1;
                return true;
            } else if ((0, $jQKDy.hasOwn)(instance.props, key)) return false;
        }
        if (key[0] === "$" && key.slice(1) in instance) return false;
        else ctx[key] = value1;
        return true;
    },
    has ({ _: { data: data, setupState: setupState, accessCache: accessCache, ctx: ctx, appContext: appContext, propsOptions: propsOptions } }, key) {
        let normalizedProps;
        return !!accessCache[key] || data !== (0, $jQKDy.EMPTY_OBJ) && (0, $jQKDy.hasOwn)(data, key) || $592f66aa99e3ed6d$var$hasSetupBinding(setupState, key) || (normalizedProps = propsOptions[0]) && (0, $jQKDy.hasOwn)(normalizedProps, key) || (0, $jQKDy.hasOwn)(ctx, key) || (0, $jQKDy.hasOwn)($592f66aa99e3ed6d$var$publicPropertiesMap, key) || (0, $jQKDy.hasOwn)(appContext.config.globalProperties, key);
    },
    defineProperty (target, key, descriptor) {
        if (descriptor.get != null) target._.accessCache[key] = 0;
        else if ((0, $jQKDy.hasOwn)(descriptor, "value")) this.set(target, key, descriptor.value, null);
        return Reflect.defineProperty(target, key, descriptor);
    }
};
var $592f66aa99e3ed6d$var$target;
const $592f66aa99e3ed6d$var$RuntimeCompiledPublicInstanceProxyHandlers = /* @__PURE__ */ (0, $jQKDy.extend)({}, $592f66aa99e3ed6d$var$PublicInstanceProxyHandlers, {
    get (target, key) {
        if (key === Symbol.unscopables) return;
        return $592f66aa99e3ed6d$var$PublicInstanceProxyHandlers.get(target, key, target);
    },
    has (_, key) {
        const has = key[0] !== "_" && !(0, $jQKDy.isGloballyWhitelisted)(key);
        return has;
    }
});
function $592f66aa99e3ed6d$var$createDevRenderContext(instance) {
    const target = {};
    Object.defineProperty(target, `_`, {
        configurable: true,
        enumerable: false,
        get: ()=>instance
    });
    Object.keys($592f66aa99e3ed6d$var$publicPropertiesMap).forEach((key)=>{
        Object.defineProperty(target, key, {
            configurable: true,
            enumerable: false,
            get: ()=>$592f66aa99e3ed6d$var$publicPropertiesMap[key](instance),
            // intercepted by the proxy so no need for implementation,
            // but needed to prevent set errors
            set: (0, $jQKDy.NOOP)
        });
    });
    return target;
}
function $592f66aa99e3ed6d$var$exposePropsOnRenderContext(instance) {
    const { ctx: ctx, propsOptions: [propsOptions] } = instance;
    if (propsOptions) Object.keys(propsOptions).forEach((key)=>{
        Object.defineProperty(ctx, key, {
            enumerable: true,
            configurable: true,
            get: ()=>instance.props[key],
            set: (0, $jQKDy.NOOP)
        });
    });
}
function $592f66aa99e3ed6d$var$exposeSetupStateOnRenderContext(instance) {
    const { ctx: ctx, setupState: setupState } = instance;
    Object.keys((0, $hnQzm.toRaw)(setupState)).forEach((key)=>{
        if (!setupState.__isScriptSetup) {
            if ($592f66aa99e3ed6d$var$isReservedPrefix(key[0])) {
                $592f66aa99e3ed6d$export$c106dd0671a0fc2d(`setup() return property ${JSON.stringify(key)} should not start with "$" or "_" which are reserved prefixes for Vue internals.`);
                return;
            }
            Object.defineProperty(ctx, key, {
                enumerable: true,
                configurable: true,
                get: ()=>setupState[key],
                set: (0, $jQKDy.NOOP)
            });
        }
    });
}
const $592f66aa99e3ed6d$var$warnRuntimeUsage = (method)=>$592f66aa99e3ed6d$export$c106dd0671a0fc2d(`${method}() is a compiler-hint helper that is only usable inside <script setup> of a single file component. Its arguments should be compiled away and passing it at runtime has no effect.`);
function $592f66aa99e3ed6d$export$80b33eababae110e() {
    return null;
}
function $592f66aa99e3ed6d$export$51ecece22fc17ddc() {
    return null;
}
function $592f66aa99e3ed6d$export$da25b65ca24b518a(exposed) {}
function $592f66aa99e3ed6d$export$77e79129327f3d0d(options) {}
function $592f66aa99e3ed6d$export$1b3acd4bb805b712() {
    return null;
}
function $592f66aa99e3ed6d$export$acd55aa037e791bb() {}
function $592f66aa99e3ed6d$export$4df9c0969a9e0160(props, defaults) {
    return null;
}
function $592f66aa99e3ed6d$export$9203a8e84125433c() {
    return $592f66aa99e3ed6d$var$getContext().slots;
}
function $592f66aa99e3ed6d$export$75e29435042cd2ea() {
    return $592f66aa99e3ed6d$var$getContext().attrs;
}
function $592f66aa99e3ed6d$export$fb78bd113157f1a1(props, name, options) {
    const i = $592f66aa99e3ed6d$export$f13e630aa3915748();
    if (options && options.local) {
        const proxy = (0, $hnQzm.ref)(props[name]);
        $592f66aa99e3ed6d$export$3db5d71bdb2d5499(()=>props[name], (v1)=>proxy.value = v1);
        $592f66aa99e3ed6d$export$3db5d71bdb2d5499(proxy, (value1)=>{
            if (value1 !== props[name]) i.emit(`update:${name}`, value1);
        });
        return proxy;
    } else return {
        __v_isRef: true,
        get value () {
            return props[name];
        },
        set value (value){
            i.emit(`update:${name}`, value);
        }
    };
}
function $592f66aa99e3ed6d$var$getContext() {
    const i = $592f66aa99e3ed6d$export$f13e630aa3915748();
    return i.setupContext || (i.setupContext = $592f66aa99e3ed6d$var$createSetupContext(i));
}
function $592f66aa99e3ed6d$var$normalizePropsOrEmits(props) {
    return (0, $jQKDy.isArray)(props) ? props.reduce((normalized, p)=>(normalized[p] = null, normalized), {}) : props;
}
function $592f66aa99e3ed6d$export$ec60f47d4a8a2e7f(raw, defaults) {
    const props = $592f66aa99e3ed6d$var$normalizePropsOrEmits(raw);
    for(const key in defaults){
        if (key.startsWith("__skip")) continue;
        let opt = props[key];
        if (opt) {
            if ((0, $jQKDy.isArray)(opt) || (0, $jQKDy.isFunction)(opt)) opt = props[key] = {
                type: opt,
                default: defaults[key]
            };
            else opt.default = defaults[key];
        } else if (opt === null) opt = props[key] = {
            default: defaults[key]
        };
        if (opt && defaults[`__skip_${key}`]) opt.skipFactory = true;
    }
    return props;
}
function $592f66aa99e3ed6d$export$ad4f724f587e6828(a, b) {
    if (!a || !b) return a || b;
    if ((0, $jQKDy.isArray)(a) && (0, $jQKDy.isArray)(b)) return a.concat(b);
    return (0, $jQKDy.extend)({}, $592f66aa99e3ed6d$var$normalizePropsOrEmits(a), $592f66aa99e3ed6d$var$normalizePropsOrEmits(b));
}
function $592f66aa99e3ed6d$export$7c343e855c563faa(props, excludedKeys) {
    const ret = {};
    for(const key in props)if (!excludedKeys.includes(key)) Object.defineProperty(ret, key, {
        enumerable: true,
        get: ()=>props[key]
    });
    return ret;
}
function $592f66aa99e3ed6d$export$d6d6f7369f1fb104(getAwaitable) {
    const ctx = $592f66aa99e3ed6d$export$f13e630aa3915748();
    let awaitable = getAwaitable();
    $592f66aa99e3ed6d$var$unsetCurrentInstance();
    if ((0, $jQKDy.isPromise)(awaitable)) awaitable = awaitable.catch((e)=>{
        $592f66aa99e3ed6d$var$setCurrentInstance(ctx);
        throw e;
    });
    return [
        awaitable,
        ()=>$592f66aa99e3ed6d$var$setCurrentInstance(ctx)
    ];
}
function $592f66aa99e3ed6d$var$createDuplicateChecker() {
    const cache = /* @__PURE__ */ Object.create(null);
    return (type, key)=>{
        if (cache[key]) $592f66aa99e3ed6d$export$c106dd0671a0fc2d(`${type} property "${key}" is already defined in ${cache[key]}.`);
        else cache[key] = type;
    };
}
let $592f66aa99e3ed6d$var$shouldCacheAccess = true;
function $592f66aa99e3ed6d$var$applyOptions(instance) {
    const options = $592f66aa99e3ed6d$var$resolveMergedOptions(instance);
    const publicThis = instance.proxy;
    const ctx = instance.ctx;
    $592f66aa99e3ed6d$var$shouldCacheAccess = false;
    if (options.beforeCreate) $592f66aa99e3ed6d$var$callHook(options.beforeCreate, instance, "bc");
    const { // state
    data: dataOptions, computed: computedOptions, methods: methods, watch: watchOptions, provide: provideOptions, inject: injectOptions, created: // lifecycle
    created, beforeMount: beforeMount, mounted: mounted, beforeUpdate: beforeUpdate, updated: updated, activated: activated, deactivated: deactivated, beforeDestroy: beforeDestroy, beforeUnmount: beforeUnmount, destroyed: destroyed, unmounted: unmounted, render: render, renderTracked: renderTracked, renderTriggered: renderTriggered, errorCaptured: errorCaptured, serverPrefetch: serverPrefetch, expose: // public API
    expose, inheritAttrs: inheritAttrs, components: // assets
    components, directives: directives, filters: filters } = options;
    const checkDuplicateProperties = null;
    if (injectOptions) $592f66aa99e3ed6d$var$resolveInjections(injectOptions, ctx, checkDuplicateProperties);
    if (methods) for(const key in methods){
        const methodHandler = methods[key];
        if ((0, $jQKDy.isFunction)(methodHandler)) ctx[key] = methodHandler.bind(publicThis);
    }
    if (dataOptions) {
        const data = dataOptions.call(publicThis, publicThis);
        if (!(0, $jQKDy.isObject)(data)) ;
        else instance.data = (0, $hnQzm.reactive)(data);
    }
    $592f66aa99e3ed6d$var$shouldCacheAccess = true;
    if (computedOptions) for(const key in computedOptions){
        const opt = computedOptions[key];
        const get = (0, $jQKDy.isFunction)(opt) ? opt.bind(publicThis, publicThis) : (0, $jQKDy.isFunction)(opt.get) ? opt.get.bind(publicThis, publicThis) : (0, $jQKDy.NOOP);
        const set = !(0, $jQKDy.isFunction)(opt) && (0, $jQKDy.isFunction)(opt.set) ? opt.set.bind(publicThis) : (0, $jQKDy.NOOP);
        const c = $592f66aa99e3ed6d$export$2983e091f1a1e8e2({
            get: get,
            set: set
        });
        Object.defineProperty(ctx, key, {
            enumerable: true,
            configurable: true,
            get: ()=>c.value,
            set: (v1)=>c.value = v1
        });
    }
    if (watchOptions) for(const key in watchOptions)$592f66aa99e3ed6d$var$createWatcher(watchOptions[key], ctx, publicThis, key);
    if (provideOptions) {
        const provides = (0, $jQKDy.isFunction)(provideOptions) ? provideOptions.call(publicThis) : provideOptions;
        Reflect.ownKeys(provides).forEach((key)=>{
            $592f66aa99e3ed6d$export$abe1e183e22e10ad(key, provides[key]);
        });
    }
    if (created) $592f66aa99e3ed6d$var$callHook(created, instance, "c");
    function registerLifecycleHook(register, hook) {
        if ((0, $jQKDy.isArray)(hook)) hook.forEach((_hook)=>register(_hook.bind(publicThis)));
        else if (hook) register(hook.bind(publicThis));
    }
    registerLifecycleHook($592f66aa99e3ed6d$export$23b7aeb0d671f804, beforeMount);
    registerLifecycleHook($592f66aa99e3ed6d$export$6d1641039221b5cb, mounted);
    registerLifecycleHook($592f66aa99e3ed6d$export$ab91988a13872e4c, beforeUpdate);
    registerLifecycleHook($592f66aa99e3ed6d$export$5876c47052fb88b1, updated);
    registerLifecycleHook($592f66aa99e3ed6d$export$ba52d824b95a2154, activated);
    registerLifecycleHook($592f66aa99e3ed6d$export$bf1440eeaf5fa709, deactivated);
    registerLifecycleHook($592f66aa99e3ed6d$export$6a3a15856e50ad19, errorCaptured);
    registerLifecycleHook($592f66aa99e3ed6d$export$2b41f4235363e921, renderTracked);
    registerLifecycleHook($592f66aa99e3ed6d$export$898295a813d662eb, renderTriggered);
    registerLifecycleHook($592f66aa99e3ed6d$export$40c420df62d2614, beforeUnmount);
    registerLifecycleHook($592f66aa99e3ed6d$export$13348a43ccacfe58, unmounted);
    registerLifecycleHook($592f66aa99e3ed6d$export$ebf0c601f267bceb, serverPrefetch);
    if ((0, $jQKDy.isArray)(expose)) {
        if (expose.length) {
            const exposed = instance.exposed || (instance.exposed = {});
            expose.forEach((key)=>{
                Object.defineProperty(exposed, key, {
                    get: ()=>publicThis[key],
                    set: (val)=>publicThis[key] = val
                });
            });
        } else if (!instance.exposed) instance.exposed = {};
    }
    if (render && instance.render === (0, $jQKDy.NOOP)) instance.render = render;
    if (inheritAttrs != null) instance.inheritAttrs = inheritAttrs;
    if (components) instance.components = components;
    if (directives) instance.directives = directives;
}
function $592f66aa99e3ed6d$var$resolveInjections(injectOptions, ctx, checkDuplicateProperties = (0, $jQKDy.NOOP)) {
    if ((0, $jQKDy.isArray)(injectOptions)) injectOptions = $592f66aa99e3ed6d$var$normalizeInject(injectOptions);
    for(const key in injectOptions){
        const opt = injectOptions[key];
        let injected;
        if ((0, $jQKDy.isObject)(opt)) {
            if ("default" in opt) injected = $592f66aa99e3ed6d$export$a976684a0efeb93f(opt.from || key, opt.default, true);
            else injected = $592f66aa99e3ed6d$export$a976684a0efeb93f(opt.from || key);
        } else injected = $592f66aa99e3ed6d$export$a976684a0efeb93f(opt);
        if ((0, $hnQzm.isRef)(injected)) Object.defineProperty(ctx, key, {
            enumerable: true,
            configurable: true,
            get: ()=>injected.value,
            set: (v1)=>injected.value = v1
        });
        else ctx[key] = injected;
    }
}
function $592f66aa99e3ed6d$var$callHook(hook, instance, type) {
    $592f66aa99e3ed6d$export$dae85862a8d94378((0, $jQKDy.isArray)(hook) ? hook.map((h)=>h.bind(instance.proxy)) : hook.bind(instance.proxy), instance, type);
}
function $592f66aa99e3ed6d$var$createWatcher(raw, ctx, publicThis, key) {
    const getter = key.includes(".") ? $592f66aa99e3ed6d$var$createPathGetter(publicThis, key) : ()=>publicThis[key];
    if ((0, $jQKDy.isString)(raw)) {
        const handler = ctx[raw];
        if ((0, $jQKDy.isFunction)(handler)) $592f66aa99e3ed6d$export$3db5d71bdb2d5499(getter, handler);
    } else if ((0, $jQKDy.isFunction)(raw)) $592f66aa99e3ed6d$export$3db5d71bdb2d5499(getter, raw.bind(publicThis));
    else if ((0, $jQKDy.isObject)(raw)) {
        if ((0, $jQKDy.isArray)(raw)) raw.forEach((r)=>$592f66aa99e3ed6d$var$createWatcher(r, ctx, publicThis, key));
        else {
            const handler = (0, $jQKDy.isFunction)(raw.handler) ? raw.handler.bind(publicThis) : ctx[raw.handler];
            if ((0, $jQKDy.isFunction)(handler)) $592f66aa99e3ed6d$export$3db5d71bdb2d5499(getter, handler, raw);
        }
    } else ;
}
function $592f66aa99e3ed6d$var$resolveMergedOptions(instance) {
    const base = instance.type;
    const { mixins: mixins, extends: extendsOptions } = base;
    const { mixins: globalMixins, optionsCache: cache, config: { optionMergeStrategies: optionMergeStrategies } } = instance.appContext;
    const cached = cache.get(base);
    let resolved;
    if (cached) resolved = cached;
    else if (!globalMixins.length && !mixins && !extendsOptions) resolved = base;
    else {
        resolved = {};
        if (globalMixins.length) globalMixins.forEach((m)=>$592f66aa99e3ed6d$var$mergeOptions(resolved, m, optionMergeStrategies, true));
        $592f66aa99e3ed6d$var$mergeOptions(resolved, base, optionMergeStrategies);
    }
    if ((0, $jQKDy.isObject)(base)) cache.set(base, resolved);
    return resolved;
}
function $592f66aa99e3ed6d$var$mergeOptions(to, from, strats, asMixin = false) {
    const { mixins: mixins, extends: extendsOptions } = from;
    if (extendsOptions) $592f66aa99e3ed6d$var$mergeOptions(to, extendsOptions, strats, true);
    if (mixins) mixins.forEach((m)=>$592f66aa99e3ed6d$var$mergeOptions(to, m, strats, true));
    for(const key in from){
        if (asMixin && key === "expose") ;
        else {
            const strat = $592f66aa99e3ed6d$var$internalOptionMergeStrats[key] || strats && strats[key];
            to[key] = strat ? strat(to[key], from[key]) : from[key];
        }
    }
    return to;
}
const $592f66aa99e3ed6d$var$internalOptionMergeStrats = {
    data: $592f66aa99e3ed6d$var$mergeDataFn,
    props: $592f66aa99e3ed6d$var$mergeEmitsOrPropsOptions,
    emits: $592f66aa99e3ed6d$var$mergeEmitsOrPropsOptions,
    // objects
    methods: $592f66aa99e3ed6d$var$mergeObjectOptions,
    computed: $592f66aa99e3ed6d$var$mergeObjectOptions,
    // lifecycle
    beforeCreate: $592f66aa99e3ed6d$var$mergeAsArray,
    created: $592f66aa99e3ed6d$var$mergeAsArray,
    beforeMount: $592f66aa99e3ed6d$var$mergeAsArray,
    mounted: $592f66aa99e3ed6d$var$mergeAsArray,
    beforeUpdate: $592f66aa99e3ed6d$var$mergeAsArray,
    updated: $592f66aa99e3ed6d$var$mergeAsArray,
    beforeDestroy: $592f66aa99e3ed6d$var$mergeAsArray,
    beforeUnmount: $592f66aa99e3ed6d$var$mergeAsArray,
    destroyed: $592f66aa99e3ed6d$var$mergeAsArray,
    unmounted: $592f66aa99e3ed6d$var$mergeAsArray,
    activated: $592f66aa99e3ed6d$var$mergeAsArray,
    deactivated: $592f66aa99e3ed6d$var$mergeAsArray,
    errorCaptured: $592f66aa99e3ed6d$var$mergeAsArray,
    serverPrefetch: $592f66aa99e3ed6d$var$mergeAsArray,
    // assets
    components: $592f66aa99e3ed6d$var$mergeObjectOptions,
    directives: $592f66aa99e3ed6d$var$mergeObjectOptions,
    // watch
    watch: $592f66aa99e3ed6d$var$mergeWatchOptions,
    // provide / inject
    provide: $592f66aa99e3ed6d$var$mergeDataFn,
    inject: $592f66aa99e3ed6d$var$mergeInject
};
function $592f66aa99e3ed6d$var$mergeDataFn(to, from) {
    if (!from) return to;
    if (!to) return from;
    return function mergedDataFn() {
        return (0, $jQKDy.extend)((0, $jQKDy.isFunction)(to) ? to.call(this, this) : to, (0, $jQKDy.isFunction)(from) ? from.call(this, this) : from);
    };
}
function $592f66aa99e3ed6d$var$mergeInject(to, from) {
    return $592f66aa99e3ed6d$var$mergeObjectOptions($592f66aa99e3ed6d$var$normalizeInject(to), $592f66aa99e3ed6d$var$normalizeInject(from));
}
function $592f66aa99e3ed6d$var$normalizeInject(raw) {
    if ((0, $jQKDy.isArray)(raw)) {
        const res = {};
        for(let i = 0; i < raw.length; i++)res[raw[i]] = raw[i];
        return res;
    }
    return raw;
}
function $592f66aa99e3ed6d$var$mergeAsArray(to, from) {
    return to ? [
        ...new Set([].concat(to, from))
    ] : from;
}
function $592f66aa99e3ed6d$var$mergeObjectOptions(to, from) {
    return to ? (0, $jQKDy.extend)(/* @__PURE__ */ Object.create(null), to, from) : from;
}
function $592f66aa99e3ed6d$var$mergeEmitsOrPropsOptions(to, from) {
    if (to) {
        if ((0, $jQKDy.isArray)(to) && (0, $jQKDy.isArray)(from)) return [
            .../* @__PURE__ */ new Set([
                ...to,
                ...from
            ])
        ];
        return (0, $jQKDy.extend)(/* @__PURE__ */ Object.create(null), $592f66aa99e3ed6d$var$normalizePropsOrEmits(to), $592f66aa99e3ed6d$var$normalizePropsOrEmits(from != null ? from : {}));
    } else return from;
}
function $592f66aa99e3ed6d$var$mergeWatchOptions(to, from) {
    if (!to) return from;
    if (!from) return to;
    const merged = (0, $jQKDy.extend)(/* @__PURE__ */ Object.create(null), to);
    for(const key in from)merged[key] = $592f66aa99e3ed6d$var$mergeAsArray(to[key], from[key]);
    return merged;
}
function $592f66aa99e3ed6d$var$createAppContext() {
    return {
        app: null,
        config: {
            isNativeTag: (0, $jQKDy.NO),
            performance: false,
            globalProperties: {},
            optionMergeStrategies: {},
            errorHandler: void 0,
            warnHandler: void 0,
            compilerOptions: {}
        },
        mixins: [],
        components: {},
        directives: {},
        provides: /* @__PURE__ */ Object.create(null),
        optionsCache: /* @__PURE__ */ new WeakMap(),
        propsCache: /* @__PURE__ */ new WeakMap(),
        emitsCache: /* @__PURE__ */ new WeakMap()
    };
}
let $592f66aa99e3ed6d$var$uid$1 = 0;
function $592f66aa99e3ed6d$var$createAppAPI(render, hydrate) {
    return function createApp(rootComponent, rootProps = null) {
        if (!(0, $jQKDy.isFunction)(rootComponent)) rootComponent = (0, $jQKDy.extend)({}, rootComponent);
        if (rootProps != null && !(0, $jQKDy.isObject)(rootProps)) rootProps = null;
        const context = $592f66aa99e3ed6d$var$createAppContext();
        const installedPlugins = /* @__PURE__ */ new Set();
        let isMounted = false;
        const app = context.app = {
            _uid: $592f66aa99e3ed6d$var$uid$1++,
            _component: rootComponent,
            _props: rootProps,
            _container: null,
            _context: context,
            _instance: null,
            version: $592f66aa99e3ed6d$export$83d89fbfd8236492,
            get config () {
                return context.config;
            },
            set config (v){},
            use (plugin, ...options) {
                if (installedPlugins.has(plugin)) ;
                else if (plugin && (0, $jQKDy.isFunction)(plugin.install)) {
                    installedPlugins.add(plugin);
                    plugin.install(app, ...options);
                } else if ((0, $jQKDy.isFunction)(plugin)) {
                    installedPlugins.add(plugin);
                    plugin(app, ...options);
                }
                return app;
            },
            mixin (mixin) {
                if (__VUE_OPTIONS_API__) {
                    if (!context.mixins.includes(mixin)) context.mixins.push(mixin);
                }
                return app;
            },
            component (name, component) {
                if (!component) return context.components[name];
                context.components[name] = component;
                return app;
            },
            directive (name, directive) {
                if (!directive) return context.directives[name];
                context.directives[name] = directive;
                return app;
            },
            mount (rootContainer, isHydrate, isSVG) {
                if (!isMounted) {
                    const vnode = $592f66aa99e3ed6d$export$bf5c4cf060303d58(rootComponent, rootProps);
                    vnode.appContext = context;
                    if (isHydrate && hydrate) hydrate(vnode, rootContainer);
                    else render(vnode, rootContainer, isSVG);
                    isMounted = true;
                    app._container = rootContainer;
                    rootContainer.__vue_app__ = app;
                    if (__VUE_PROD_DEVTOOLS__) {
                        app._instance = vnode.component;
                        $592f66aa99e3ed6d$var$devtoolsInitApp(app, $592f66aa99e3ed6d$export$83d89fbfd8236492);
                    }
                    return $592f66aa99e3ed6d$var$getExposeProxy(vnode.component) || vnode.component.proxy;
                }
            },
            unmount () {
                if (isMounted) {
                    render(null, app._container);
                    if (__VUE_PROD_DEVTOOLS__) {
                        app._instance = null;
                        $592f66aa99e3ed6d$var$devtoolsUnmountApp(app);
                    }
                    delete app._container.__vue_app__;
                }
            },
            provide (key, value1) {
                context.provides[key] = value1;
                return app;
            },
            runWithContext (fn) {
                $592f66aa99e3ed6d$var$currentApp = app;
                try {
                    return fn();
                } finally{
                    $592f66aa99e3ed6d$var$currentApp = null;
                }
            }
        };
        return app;
    };
}
let $592f66aa99e3ed6d$var$currentApp = null;
function $592f66aa99e3ed6d$export$abe1e183e22e10ad(key, value1) {
    if (!$592f66aa99e3ed6d$var$currentInstance) ;
    else {
        let provides = $592f66aa99e3ed6d$var$currentInstance.provides;
        const parentProvides = $592f66aa99e3ed6d$var$currentInstance.parent && $592f66aa99e3ed6d$var$currentInstance.parent.provides;
        if (parentProvides === provides) provides = $592f66aa99e3ed6d$var$currentInstance.provides = Object.create(parentProvides);
        provides[key] = value1;
    }
}
function $592f66aa99e3ed6d$export$a976684a0efeb93f(key, defaultValue, treatDefaultAsFactory = false) {
    const instance = $592f66aa99e3ed6d$var$currentInstance || $592f66aa99e3ed6d$var$currentRenderingInstance;
    if (instance || $592f66aa99e3ed6d$var$currentApp) {
        const provides = instance ? instance.parent == null ? instance.vnode.appContext && instance.vnode.appContext.provides : instance.parent.provides : $592f66aa99e3ed6d$var$currentApp._context.provides;
        if (provides && key in provides) return provides[key];
        else if (arguments.length > 1) return treatDefaultAsFactory && (0, $jQKDy.isFunction)(defaultValue) ? defaultValue.call(instance && instance.proxy) : defaultValue;
    }
}
function $592f66aa99e3ed6d$export$caf6761f24fc571a() {
    return !!($592f66aa99e3ed6d$var$currentInstance || $592f66aa99e3ed6d$var$currentRenderingInstance || $592f66aa99e3ed6d$var$currentApp);
}
function $592f66aa99e3ed6d$var$initProps(instance, rawProps, isStateful, isSSR = false) {
    const props = {};
    const attrs = {};
    (0, $jQKDy.def)(attrs, $592f66aa99e3ed6d$var$InternalObjectKey, 1);
    instance.propsDefaults = /* @__PURE__ */ Object.create(null);
    $592f66aa99e3ed6d$var$setFullProps(instance, rawProps, props, attrs);
    for(const key in instance.propsOptions[0])if (!(key in props)) props[key] = void 0;
    if (isStateful) instance.props = isSSR ? props : (0, $hnQzm.shallowReactive)(props);
    else if (!instance.type.props) instance.props = attrs;
    else instance.props = props;
    instance.attrs = attrs;
}
function $592f66aa99e3ed6d$var$isInHmrContext(instance) {
    while(instance){
        if (instance.type.__hmrId) return true;
        instance = instance.parent;
    }
}
function $592f66aa99e3ed6d$var$updateProps(instance, rawProps, rawPrevProps, optimized) {
    const { props: props, attrs: attrs, vnode: { patchFlag: patchFlag } } = instance;
    const rawCurrentProps = (0, $hnQzm.toRaw)(props);
    const [options] = instance.propsOptions;
    let hasAttrsChanged = false;
    if (// always force full diff in dev
    // - #1942 if hmr is enabled with sfc component
    // - vite#872 non-sfc component used by sfc component
    (optimized || patchFlag > 0) && !(patchFlag & 16)) {
        if (patchFlag & 8) {
            const propsToUpdate = instance.vnode.dynamicProps;
            for(let i = 0; i < propsToUpdate.length; i++){
                let key = propsToUpdate[i];
                if ($592f66aa99e3ed6d$var$isEmitListener(instance.emitsOptions, key)) continue;
                const value1 = rawProps[key];
                if (options) {
                    if ((0, $jQKDy.hasOwn)(attrs, key)) {
                        if (value1 !== attrs[key]) {
                            attrs[key] = value1;
                            hasAttrsChanged = true;
                        }
                    } else {
                        const camelizedKey = (0, $jQKDy.camelize)(key);
                        props[camelizedKey] = $592f66aa99e3ed6d$var$resolvePropValue(options, rawCurrentProps, camelizedKey, value1, instance, false);
                    }
                } else if (value1 !== attrs[key]) {
                    attrs[key] = value1;
                    hasAttrsChanged = true;
                }
            }
        }
    } else {
        if ($592f66aa99e3ed6d$var$setFullProps(instance, rawProps, props, attrs)) hasAttrsChanged = true;
        let kebabKey;
        for(const key in rawCurrentProps)if (!rawProps || // for camelCase
        !(0, $jQKDy.hasOwn)(rawProps, key) && // it's possible the original props was passed in as kebab-case
        // and converted to camelCase (#955)
        ((kebabKey = (0, $jQKDy.hyphenate)(key)) === key || !(0, $jQKDy.hasOwn)(rawProps, kebabKey))) {
            if (options) {
                if (rawPrevProps && // for camelCase
                (rawPrevProps[key] !== void 0 || // for kebab-case
                rawPrevProps[kebabKey] !== void 0)) props[key] = $592f66aa99e3ed6d$var$resolvePropValue(options, rawCurrentProps, key, void 0, instance, true);
            } else delete props[key];
        }
        if (attrs !== rawCurrentProps) {
            for(const key in attrs)if (!rawProps || !(0, $jQKDy.hasOwn)(rawProps, key) && true) {
                delete attrs[key];
                hasAttrsChanged = true;
            }
        }
    }
    if (hasAttrsChanged) (0, $hnQzm.trigger)(instance, "set", "$attrs");
}
function $592f66aa99e3ed6d$var$setFullProps(instance, rawProps, props, attrs) {
    const [options, needCastKeys] = instance.propsOptions;
    let hasAttrsChanged = false;
    let rawCastValues;
    if (rawProps) for(let key in rawProps){
        if ((0, $jQKDy.isReservedProp)(key)) continue;
        const value1 = rawProps[key];
        let camelKey;
        if (options && (0, $jQKDy.hasOwn)(options, camelKey = (0, $jQKDy.camelize)(key))) {
            if (!needCastKeys || !needCastKeys.includes(camelKey)) props[camelKey] = value1;
            else (rawCastValues || (rawCastValues = {}))[camelKey] = value1;
        } else if (!$592f66aa99e3ed6d$var$isEmitListener(instance.emitsOptions, key)) {
            if (!(key in attrs) || value1 !== attrs[key]) {
                attrs[key] = value1;
                hasAttrsChanged = true;
            }
        }
    }
    if (needCastKeys) {
        const rawCurrentProps = (0, $hnQzm.toRaw)(props);
        const castValues = rawCastValues || (0, $jQKDy.EMPTY_OBJ);
        for(let i = 0; i < needCastKeys.length; i++){
            const key = needCastKeys[i];
            props[key] = $592f66aa99e3ed6d$var$resolvePropValue(options, rawCurrentProps, key, castValues[key], instance, !(0, $jQKDy.hasOwn)(castValues, key));
        }
    }
    return hasAttrsChanged;
}
function $592f66aa99e3ed6d$var$resolvePropValue(options, props, key, value1, instance, isAbsent) {
    const opt = options[key];
    if (opt != null) {
        const hasDefault = (0, $jQKDy.hasOwn)(opt, "default");
        if (hasDefault && value1 === void 0) {
            const defaultValue = opt.default;
            if (opt.type !== Function && !opt.skipFactory && (0, $jQKDy.isFunction)(defaultValue)) {
                const { propsDefaults: propsDefaults } = instance;
                if (key in propsDefaults) value1 = propsDefaults[key];
                else {
                    $592f66aa99e3ed6d$var$setCurrentInstance(instance);
                    value1 = propsDefaults[key] = defaultValue.call(null, props);
                    $592f66aa99e3ed6d$var$unsetCurrentInstance();
                }
            } else value1 = defaultValue;
        }
        if (opt[0 /* shouldCast */ ]) {
            if (isAbsent && !hasDefault) value1 = false;
            else if (opt[1 /* shouldCastTrue */ ] && (value1 === "" || value1 === (0, $jQKDy.hyphenate)(key))) value1 = true;
        }
    }
    return value1;
}
function $592f66aa99e3ed6d$var$normalizePropsOptions(comp, appContext, asMixin = false) {
    const cache = appContext.propsCache;
    const cached = cache.get(comp);
    if (cached) return cached;
    const raw = comp.props;
    const normalized = {};
    const needCastKeys = [];
    let hasExtends = false;
    if (__VUE_OPTIONS_API__ && !(0, $jQKDy.isFunction)(comp)) {
        const extendProps = (raw2)=>{
            hasExtends = true;
            const [props, keys] = $592f66aa99e3ed6d$var$normalizePropsOptions(raw2, appContext, true);
            (0, $jQKDy.extend)(normalized, props);
            if (keys) needCastKeys.push(...keys);
        };
        if (!asMixin && appContext.mixins.length) appContext.mixins.forEach(extendProps);
        if (comp.extends) extendProps(comp.extends);
        if (comp.mixins) comp.mixins.forEach(extendProps);
    }
    if (!raw && !hasExtends) {
        if ((0, $jQKDy.isObject)(comp)) cache.set(comp, (0, $jQKDy.EMPTY_ARR));
        return 0, $jQKDy.EMPTY_ARR;
    }
    if ((0, $jQKDy.isArray)(raw)) for(let i = 0; i < raw.length; i++){
        const normalizedKey = (0, $jQKDy.camelize)(raw[i]);
        if ($592f66aa99e3ed6d$var$validatePropName(normalizedKey)) normalized[normalizedKey] = (0, $jQKDy.EMPTY_OBJ);
    }
    else if (raw) for(const key in raw){
        const normalizedKey = (0, $jQKDy.camelize)(key);
        if ($592f66aa99e3ed6d$var$validatePropName(normalizedKey)) {
            const opt = raw[key];
            const prop = normalized[normalizedKey] = (0, $jQKDy.isArray)(opt) || (0, $jQKDy.isFunction)(opt) ? {
                type: opt
            } : (0, $jQKDy.extend)({}, opt);
            if (prop) {
                const booleanIndex = $592f66aa99e3ed6d$var$getTypeIndex(Boolean, prop.type);
                const stringIndex = $592f66aa99e3ed6d$var$getTypeIndex(String, prop.type);
                prop[0 /* shouldCast */ ] = booleanIndex > -1;
                prop[1 /* shouldCastTrue */ ] = stringIndex < 0 || booleanIndex < stringIndex;
                if (booleanIndex > -1 || (0, $jQKDy.hasOwn)(prop, "default")) needCastKeys.push(normalizedKey);
            }
        }
    }
    const res = [
        normalized,
        needCastKeys
    ];
    if ((0, $jQKDy.isObject)(comp)) cache.set(comp, res);
    return res;
}
function $592f66aa99e3ed6d$var$validatePropName(key) {
    if (key[0] !== "$") return true;
    return false;
}
function $592f66aa99e3ed6d$var$getType(ctor) {
    const match = ctor && ctor.toString().match(/^\s*(function|class) (\w+)/);
    return match ? match[2] : ctor === null ? "null" : "";
}
function $592f66aa99e3ed6d$var$isSameType(a, b) {
    return $592f66aa99e3ed6d$var$getType(a) === $592f66aa99e3ed6d$var$getType(b);
}
function $592f66aa99e3ed6d$var$getTypeIndex(type, expectedTypes) {
    if ((0, $jQKDy.isArray)(expectedTypes)) return expectedTypes.findIndex((t)=>$592f66aa99e3ed6d$var$isSameType(t, type));
    else if ((0, $jQKDy.isFunction)(expectedTypes)) return $592f66aa99e3ed6d$var$isSameType(expectedTypes, type) ? 0 : -1;
    return -1;
}
function $592f66aa99e3ed6d$var$validateProps(rawProps, props, instance) {
    const resolvedValues = (0, $hnQzm.toRaw)(props);
    const options = instance.propsOptions[0];
    for(const key in options){
        let opt = options[key];
        if (opt == null) continue;
        $592f66aa99e3ed6d$var$validateProp(key, resolvedValues[key], opt, !(0, $jQKDy.hasOwn)(rawProps, key) && !(0, $jQKDy.hasOwn)(rawProps, (0, $jQKDy.hyphenate)(key)));
    }
}
function $592f66aa99e3ed6d$var$validateProp(name, value1, prop, isAbsent) {
    const { type: type, required: required, validator: validator, skipCheck: skipCheck } = prop;
    if (required && isAbsent) {
        $592f66aa99e3ed6d$export$c106dd0671a0fc2d('Missing required prop: "' + name + '"');
        return;
    }
    if (value1 == null && !required) return;
    if (type != null && type !== true && !skipCheck) {
        let isValid = false;
        const types = (0, $jQKDy.isArray)(type) ? type : [
            type
        ];
        const expectedTypes = [];
        for(let i = 0; i < types.length && !isValid; i++){
            const { valid: valid, expectedType: expectedType } = $592f66aa99e3ed6d$var$assertType(value1, types[i]);
            expectedTypes.push(expectedType || "");
            isValid = valid;
        }
        if (!isValid) {
            $592f66aa99e3ed6d$export$c106dd0671a0fc2d($592f66aa99e3ed6d$var$getInvalidTypeMessage(name, value1, expectedTypes));
            return;
        }
    }
    if (validator && !validator(value1)) $592f66aa99e3ed6d$export$c106dd0671a0fc2d('Invalid prop: custom validator check failed for prop "' + name + '".');
}
const $592f66aa99e3ed6d$var$isSimpleType = /* @__PURE__ */ (0, $jQKDy.makeMap)("String,Number,Boolean,Function,Symbol,BigInt");
function $592f66aa99e3ed6d$var$assertType(value1, type) {
    let valid;
    const expectedType = $592f66aa99e3ed6d$var$getType(type);
    if ($592f66aa99e3ed6d$var$isSimpleType(expectedType)) {
        const t = typeof value1;
        valid = t === expectedType.toLowerCase();
        if (!valid && t === "object") valid = value1 instanceof type;
    } else if (expectedType === "Object") valid = (0, $jQKDy.isObject)(value1);
    else if (expectedType === "Array") valid = (0, $jQKDy.isArray)(value1);
    else if (expectedType === "null") valid = value1 === null;
    else valid = value1 instanceof type;
    return {
        valid: valid,
        expectedType: expectedType
    };
}
function $592f66aa99e3ed6d$var$getInvalidTypeMessage(name, value1, expectedTypes) {
    let message = `Invalid prop: type check failed for prop "${name}". Expected ${expectedTypes.map((0, $jQKDy.capitalize)).join(" | ")}`;
    const expectedType = expectedTypes[0];
    const receivedType = (0, $jQKDy.toRawType)(value1);
    const expectedValue = $592f66aa99e3ed6d$var$styleValue(value1, expectedType);
    const receivedValue = $592f66aa99e3ed6d$var$styleValue(value1, receivedType);
    if (expectedTypes.length === 1 && $592f66aa99e3ed6d$var$isExplicable(expectedType) && !$592f66aa99e3ed6d$var$isBoolean(expectedType, receivedType)) message += ` with value ${expectedValue}`;
    message += `, got ${receivedType} `;
    if ($592f66aa99e3ed6d$var$isExplicable(receivedType)) message += `with value ${receivedValue}.`;
    return message;
}
function $592f66aa99e3ed6d$var$styleValue(value1, type) {
    if (type === "String") return `"${value1}"`;
    else if (type === "Number") return `${Number(value1)}`;
    else return `${value1}`;
}
function $592f66aa99e3ed6d$var$isExplicable(type) {
    const explicitTypes = [
        "string",
        "number",
        "boolean"
    ];
    return explicitTypes.some((elem)=>type.toLowerCase() === elem);
}
function $592f66aa99e3ed6d$var$isBoolean(...args) {
    return args.some((elem)=>elem.toLowerCase() === "boolean");
}
const $592f66aa99e3ed6d$var$isInternalKey = (key)=>key[0] === "_" || key === "$stable";
const $592f66aa99e3ed6d$var$normalizeSlotValue = (value1)=>(0, $jQKDy.isArray)(value1) ? value1.map($592f66aa99e3ed6d$var$normalizeVNode) : [
        $592f66aa99e3ed6d$var$normalizeVNode(value1)
    ];
const $592f66aa99e3ed6d$var$normalizeSlot = (key, rawSlot, ctx)=>{
    if (rawSlot._n) return rawSlot;
    const normalized = $592f66aa99e3ed6d$export$694b237e827a3d23((...args)=>{
        return $592f66aa99e3ed6d$var$normalizeSlotValue(rawSlot(...args));
    }, ctx);
    normalized._c = false;
    return normalized;
};
const $592f66aa99e3ed6d$var$normalizeObjectSlots = (rawSlots, slots, instance)=>{
    const ctx = rawSlots._ctx;
    for(const key in rawSlots){
        if ($592f66aa99e3ed6d$var$isInternalKey(key)) continue;
        const value1 = rawSlots[key];
        if ((0, $jQKDy.isFunction)(value1)) slots[key] = $592f66aa99e3ed6d$var$normalizeSlot(key, value1, ctx);
        else if (value1 != null) {
            const normalized = $592f66aa99e3ed6d$var$normalizeSlotValue(value1);
            slots[key] = ()=>normalized;
        }
    }
};
const $592f66aa99e3ed6d$var$normalizeVNodeSlots = (instance, children)=>{
    const normalized = $592f66aa99e3ed6d$var$normalizeSlotValue(children);
    instance.slots.default = ()=>normalized;
};
const $592f66aa99e3ed6d$var$initSlots = (instance, children)=>{
    if (instance.vnode.shapeFlag & 32) {
        const type = children._;
        if (type) {
            instance.slots = (0, $hnQzm.toRaw)(children);
            (0, $jQKDy.def)(children, "_", type);
        } else $592f66aa99e3ed6d$var$normalizeObjectSlots(children, instance.slots = {});
    } else {
        instance.slots = {};
        if (children) $592f66aa99e3ed6d$var$normalizeVNodeSlots(instance, children);
    }
    (0, $jQKDy.def)(instance.slots, $592f66aa99e3ed6d$var$InternalObjectKey, 1);
};
const $592f66aa99e3ed6d$var$updateSlots = (instance, children, optimized)=>{
    const { vnode: vnode, slots: slots } = instance;
    let needDeletionCheck = true;
    let deletionComparisonTarget = (0, $jQKDy.EMPTY_OBJ);
    if (vnode.shapeFlag & 32) {
        const type = children._;
        if (type) {
            if (optimized && type === 1) needDeletionCheck = false;
            else {
                (0, $jQKDy.extend)(slots, children);
                if (!optimized && type === 1) delete slots._;
            }
        } else {
            needDeletionCheck = !children.$stable;
            $592f66aa99e3ed6d$var$normalizeObjectSlots(children, slots);
        }
        deletionComparisonTarget = children;
    } else if (children) {
        $592f66aa99e3ed6d$var$normalizeVNodeSlots(instance, children);
        deletionComparisonTarget = {
            default: 1
        };
    }
    if (needDeletionCheck) {
        for(const key in slots)if (!$592f66aa99e3ed6d$var$isInternalKey(key) && !(key in deletionComparisonTarget)) delete slots[key];
    }
};
function $592f66aa99e3ed6d$var$setRef(rawRef, oldRawRef, parentSuspense, vnode, isUnmount = false) {
    if ((0, $jQKDy.isArray)(rawRef)) {
        rawRef.forEach((r, i)=>$592f66aa99e3ed6d$var$setRef(r, oldRawRef && ((0, $jQKDy.isArray)(oldRawRef) ? oldRawRef[i] : oldRawRef), parentSuspense, vnode, isUnmount));
        return;
    }
    if ($592f66aa99e3ed6d$var$isAsyncWrapper(vnode) && !isUnmount) return;
    const refValue = vnode.shapeFlag & 4 ? $592f66aa99e3ed6d$var$getExposeProxy(vnode.component) || vnode.component.proxy : vnode.el;
    const value1 = isUnmount ? null : refValue;
    const { i: owner, r: ref } = rawRef;
    const oldRef = oldRawRef && oldRawRef.r;
    const refs = owner.refs === (0, $jQKDy.EMPTY_OBJ) ? owner.refs = {} : owner.refs;
    const setupState = owner.setupState;
    if (oldRef != null && oldRef !== ref) {
        if ((0, $jQKDy.isString)(oldRef)) {
            refs[oldRef] = null;
            if ((0, $jQKDy.hasOwn)(setupState, oldRef)) setupState[oldRef] = null;
        } else if ((0, $hnQzm.isRef)(oldRef)) oldRef.value = null;
    }
    if ((0, $jQKDy.isFunction)(ref)) $592f66aa99e3ed6d$export$b22fcaf88446e9bf(ref, owner, 12, [
        value1,
        refs
    ]);
    else {
        const _isString = (0, $jQKDy.isString)(ref);
        const _isRef = (0, $hnQzm.isRef)(ref);
        if (_isString || _isRef) {
            const doSet = ()=>{
                if (rawRef.f) {
                    const existing = _isString ? (0, $jQKDy.hasOwn)(setupState, ref) ? setupState[ref] : refs[ref] : ref.value;
                    if (isUnmount) (0, $jQKDy.isArray)(existing) && (0, $jQKDy.remove)(existing, refValue);
                    else {
                        if (!(0, $jQKDy.isArray)(existing)) {
                            if (_isString) {
                                refs[ref] = [
                                    refValue
                                ];
                                if ((0, $jQKDy.hasOwn)(setupState, ref)) setupState[ref] = refs[ref];
                            } else {
                                ref.value = [
                                    refValue
                                ];
                                if (rawRef.k) refs[rawRef.k] = ref.value;
                            }
                        } else if (!existing.includes(refValue)) existing.push(refValue);
                    }
                } else if (_isString) {
                    refs[ref] = value1;
                    if ((0, $jQKDy.hasOwn)(setupState, ref)) setupState[ref] = value1;
                } else if (_isRef) {
                    ref.value = value1;
                    if (rawRef.k) refs[rawRef.k] = value1;
                }
            };
            if (value1) {
                doSet.id = -1;
                $592f66aa99e3ed6d$var$queuePostRenderEffect(doSet, parentSuspense);
            } else doSet();
        }
    }
}
let $592f66aa99e3ed6d$var$hasMismatch = false;
const $592f66aa99e3ed6d$var$isSVGContainer = (container)=>/svg/.test(container.namespaceURI) && container.tagName !== "foreignObject";
const $592f66aa99e3ed6d$var$isComment = (node)=>node.nodeType === 8 /* COMMENT */ ;
function $592f66aa99e3ed6d$var$createHydrationFunctions(rendererInternals) {
    const { mt: mountComponent, p: patch, o: { patchProp: patchProp, createText: createText, nextSibling: nextSibling, parentNode: parentNode, remove: remove, insert: insert, createComment: createComment } } = rendererInternals;
    const hydrate = (vnode, container)=>{
        if (!container.hasChildNodes()) {
            patch(null, vnode, container);
            $592f66aa99e3ed6d$var$flushPostFlushCbs();
            container._vnode = vnode;
            return;
        }
        $592f66aa99e3ed6d$var$hasMismatch = false;
        hydrateNode(container.firstChild, vnode, null, null, null);
        $592f66aa99e3ed6d$var$flushPostFlushCbs();
        container._vnode = vnode;
        if ($592f66aa99e3ed6d$var$hasMismatch && true) console.error(`Hydration completed but contains mismatches.`);
    };
    const hydrateNode = (node, vnode, parentComponent, parentSuspense, slotScopeIds, optimized = false)=>{
        const isFragmentStart = $592f66aa99e3ed6d$var$isComment(node) && node.data === "[";
        const onMismatch = ()=>handleMismatch(node, vnode, parentComponent, parentSuspense, slotScopeIds, isFragmentStart);
        const { type: type, ref: ref, shapeFlag: shapeFlag, patchFlag: patchFlag } = vnode;
        let domType = node.nodeType;
        vnode.el = node;
        if (patchFlag === -2) {
            optimized = false;
            vnode.dynamicChildren = null;
        }
        let nextNode = null;
        switch(type){
            case $592f66aa99e3ed6d$export$5f1af8db9871e1d6:
                if (domType !== 3 /* TEXT */ ) {
                    if (vnode.children === "") {
                        insert(vnode.el = createText(""), parentNode(node), node);
                        nextNode = node;
                    } else nextNode = onMismatch();
                } else {
                    if (node.data !== vnode.children) {
                        $592f66aa99e3ed6d$var$hasMismatch = true;
                        node.data = vnode.children;
                    }
                    nextNode = nextSibling(node);
                }
                break;
            case $592f66aa99e3ed6d$export$4d299b491347818a:
                if (domType !== 8 /* COMMENT */  || isFragmentStart) nextNode = onMismatch();
                else nextNode = nextSibling(node);
                break;
            case $592f66aa99e3ed6d$export$c1b9a1d3af45b7b6:
                if (isFragmentStart) {
                    node = nextSibling(node);
                    domType = node.nodeType;
                }
                if (domType === 1 /* ELEMENT */  || domType === 3 /* TEXT */ ) {
                    nextNode = node;
                    const needToAdoptContent = !vnode.children.length;
                    for(let i = 0; i < vnode.staticCount; i++){
                        if (needToAdoptContent) vnode.children += nextNode.nodeType === 1 /* ELEMENT */  ? nextNode.outerHTML : nextNode.data;
                        if (i === vnode.staticCount - 1) vnode.anchor = nextNode;
                        nextNode = nextSibling(nextNode);
                    }
                    return isFragmentStart ? nextSibling(nextNode) : nextNode;
                } else onMismatch();
                break;
            case $592f66aa99e3ed6d$export$ffb0004e005737fa:
                if (!isFragmentStart) nextNode = onMismatch();
                else nextNode = hydrateFragment(node, vnode, parentComponent, parentSuspense, slotScopeIds, optimized);
                break;
            default:
                if (shapeFlag & 1) {
                    if (domType !== 1 /* ELEMENT */  || vnode.type.toLowerCase() !== node.tagName.toLowerCase()) nextNode = onMismatch();
                    else nextNode = hydrateElement(node, vnode, parentComponent, parentSuspense, slotScopeIds, optimized);
                } else if (shapeFlag & 6) {
                    vnode.slotScopeIds = slotScopeIds;
                    const container = parentNode(node);
                    mountComponent(vnode, container, null, parentComponent, parentSuspense, $592f66aa99e3ed6d$var$isSVGContainer(container), optimized);
                    nextNode = isFragmentStart ? locateClosingAsyncAnchor(node) : nextSibling(node);
                    if (nextNode && $592f66aa99e3ed6d$var$isComment(nextNode) && nextNode.data === "teleport end") nextNode = nextSibling(nextNode);
                    if ($592f66aa99e3ed6d$var$isAsyncWrapper(vnode)) {
                        let subTree;
                        if (isFragmentStart) {
                            subTree = $592f66aa99e3ed6d$export$bf5c4cf060303d58($592f66aa99e3ed6d$export$ffb0004e005737fa);
                            subTree.anchor = nextNode ? nextNode.previousSibling : container.lastChild;
                        } else subTree = node.nodeType === 3 ? $592f66aa99e3ed6d$export$22f9b5ffd89dac9("") : $592f66aa99e3ed6d$export$bf5c4cf060303d58("div");
                        subTree.el = node;
                        vnode.component.subTree = subTree;
                    }
                } else if (shapeFlag & 64) {
                    if (domType !== 8 /* COMMENT */ ) nextNode = onMismatch();
                    else nextNode = vnode.type.hydrate(node, vnode, parentComponent, parentSuspense, slotScopeIds, optimized, rendererInternals, hydrateChildren);
                } else if (shapeFlag & 128) nextNode = vnode.type.hydrate(node, vnode, parentComponent, parentSuspense, $592f66aa99e3ed6d$var$isSVGContainer(parentNode(node)), slotScopeIds, optimized, rendererInternals, hydrateNode);
        }
        if (ref != null) $592f66aa99e3ed6d$var$setRef(ref, null, parentSuspense, vnode);
        return nextNode;
    };
    const hydrateElement = (el, vnode, parentComponent, parentSuspense, slotScopeIds, optimized)=>{
        optimized = optimized || !!vnode.dynamicChildren;
        const { type: type, props: props, patchFlag: patchFlag, shapeFlag: shapeFlag, dirs: dirs } = vnode;
        const forcePatchValue = type === "input" && dirs || type === "option";
        if (forcePatchValue || patchFlag !== -1) {
            if (dirs) $592f66aa99e3ed6d$var$invokeDirectiveHook(vnode, null, parentComponent, "created");
            if (props) {
                if (forcePatchValue || !optimized || patchFlag & 48) {
                    for(const key in props)if (forcePatchValue && key.endsWith("value") || (0, $jQKDy.isOn)(key) && !(0, $jQKDy.isReservedProp)(key)) patchProp(el, key, null, props[key], false, void 0, parentComponent);
                } else if (props.onClick) patchProp(el, "onClick", null, props.onClick, false, void 0, parentComponent);
            }
            let vnodeHooks;
            if (vnodeHooks = props && props.onVnodeBeforeMount) $592f66aa99e3ed6d$var$invokeVNodeHook(vnodeHooks, parentComponent, vnode);
            if (dirs) $592f66aa99e3ed6d$var$invokeDirectiveHook(vnode, null, parentComponent, "beforeMount");
            if ((vnodeHooks = props && props.onVnodeMounted) || dirs) $592f66aa99e3ed6d$var$queueEffectWithSuspense(()=>{
                vnodeHooks && $592f66aa99e3ed6d$var$invokeVNodeHook(vnodeHooks, parentComponent, vnode);
                dirs && $592f66aa99e3ed6d$var$invokeDirectiveHook(vnode, null, parentComponent, "mounted");
            }, parentSuspense);
            if (shapeFlag & 16 && // skip if element has innerHTML / textContent
            !(props && (props.innerHTML || props.textContent))) {
                let next = hydrateChildren(el.firstChild, vnode, el, parentComponent, parentSuspense, slotScopeIds, optimized);
                let hasWarned = false;
                while(next){
                    $592f66aa99e3ed6d$var$hasMismatch = true;
                    const cur = next;
                    next = next.nextSibling;
                    remove(cur);
                }
            } else if (shapeFlag & 8) {
                if (el.textContent !== vnode.children) {
                    $592f66aa99e3ed6d$var$hasMismatch = true;
                    el.textContent = vnode.children;
                }
            }
        }
        return el.nextSibling;
    };
    const hydrateChildren = (node, parentVNode, container, parentComponent, parentSuspense, slotScopeIds, optimized)=>{
        optimized = optimized || !!parentVNode.dynamicChildren;
        const children = parentVNode.children;
        const l = children.length;
        let hasWarned = false;
        for(let i = 0; i < l; i++){
            const vnode = optimized ? children[i] : children[i] = $592f66aa99e3ed6d$var$normalizeVNode(children[i]);
            if (node) node = hydrateNode(node, vnode, parentComponent, parentSuspense, slotScopeIds, optimized);
            else if (vnode.type === $592f66aa99e3ed6d$export$5f1af8db9871e1d6 && !vnode.children) continue;
            else {
                $592f66aa99e3ed6d$var$hasMismatch = true;
                patch(null, vnode, container, null, parentComponent, parentSuspense, $592f66aa99e3ed6d$var$isSVGContainer(container), slotScopeIds);
            }
        }
        return node;
    };
    const hydrateFragment = (node, vnode, parentComponent, parentSuspense, slotScopeIds, optimized)=>{
        const { slotScopeIds: fragmentSlotScopeIds } = vnode;
        if (fragmentSlotScopeIds) slotScopeIds = slotScopeIds ? slotScopeIds.concat(fragmentSlotScopeIds) : fragmentSlotScopeIds;
        const container = parentNode(node);
        const next = hydrateChildren(nextSibling(node), vnode, container, parentComponent, parentSuspense, slotScopeIds, optimized);
        if (next && $592f66aa99e3ed6d$var$isComment(next) && next.data === "]") return nextSibling(vnode.anchor = next);
        else {
            $592f66aa99e3ed6d$var$hasMismatch = true;
            insert(vnode.anchor = createComment(`]`), container, next);
            return next;
        }
    };
    const handleMismatch = (node, vnode, parentComponent, parentSuspense, slotScopeIds, isFragment)=>{
        $592f66aa99e3ed6d$var$hasMismatch = true;
        vnode.el = null;
        if (isFragment) {
            const end = locateClosingAsyncAnchor(node);
            while(true){
                const next2 = nextSibling(node);
                if (next2 && next2 !== end) remove(next2);
                else break;
            }
        }
        const next = nextSibling(node);
        const container = parentNode(node);
        remove(node);
        patch(null, vnode, container, next, parentComponent, parentSuspense, $592f66aa99e3ed6d$var$isSVGContainer(container), slotScopeIds);
        return next;
    };
    const locateClosingAsyncAnchor = (node)=>{
        let match = 0;
        while(node){
            node = nextSibling(node);
            if (node && $592f66aa99e3ed6d$var$isComment(node)) {
                if (node.data === "[") match++;
                if (node.data === "]") {
                    if (match === 0) return nextSibling(node);
                    else match--;
                }
            }
        }
        return node;
    };
    return [
        hydrate,
        hydrateNode
    ];
}
let $592f66aa99e3ed6d$var$supported;
let $592f66aa99e3ed6d$var$perf;
function $592f66aa99e3ed6d$var$startMeasure(instance, type) {
    if (instance.appContext.config.performance && $592f66aa99e3ed6d$var$isSupported()) $592f66aa99e3ed6d$var$perf.mark(`vue-${type}-${instance.uid}`);
    if (__VUE_PROD_DEVTOOLS__) $592f66aa99e3ed6d$var$devtoolsPerfStart(instance, type, $592f66aa99e3ed6d$var$isSupported() ? $592f66aa99e3ed6d$var$perf.now() : Date.now());
}
function $592f66aa99e3ed6d$var$endMeasure(instance, type) {
    if (instance.appContext.config.performance && $592f66aa99e3ed6d$var$isSupported()) {
        const startTag = `vue-${type}-${instance.uid}`;
        const endTag = startTag + `:end`;
        $592f66aa99e3ed6d$var$perf.mark(endTag);
        $592f66aa99e3ed6d$var$perf.measure(`<${$592f66aa99e3ed6d$var$formatComponentName(instance, instance.type)}> ${type}`, startTag, endTag);
        $592f66aa99e3ed6d$var$perf.clearMarks(startTag);
        $592f66aa99e3ed6d$var$perf.clearMarks(endTag);
    }
    if (__VUE_PROD_DEVTOOLS__) $592f66aa99e3ed6d$var$devtoolsPerfEnd(instance, type, $592f66aa99e3ed6d$var$isSupported() ? $592f66aa99e3ed6d$var$perf.now() : Date.now());
}
function $592f66aa99e3ed6d$var$isSupported() {
    if ($592f66aa99e3ed6d$var$supported !== void 0) return $592f66aa99e3ed6d$var$supported;
    if (typeof window !== "undefined" && window.performance) {
        $592f66aa99e3ed6d$var$supported = true;
        $592f66aa99e3ed6d$var$perf = window.performance;
    } else $592f66aa99e3ed6d$var$supported = false;
    return $592f66aa99e3ed6d$var$supported;
}
function $592f66aa99e3ed6d$var$initFeatureFlags() {
    const needWarn = [];
    if (typeof __VUE_OPTIONS_API__ !== "boolean") (0, $jQKDy.getGlobalThis)().__VUE_OPTIONS_API__ = true;
    if (typeof __VUE_PROD_DEVTOOLS__ !== "boolean") (0, $jQKDy.getGlobalThis)().__VUE_PROD_DEVTOOLS__ = false;
}
const $592f66aa99e3ed6d$var$queuePostRenderEffect = $592f66aa99e3ed6d$var$queueEffectWithSuspense;
function $592f66aa99e3ed6d$export$53ae2f996c64e9a(options) {
    return $592f66aa99e3ed6d$var$baseCreateRenderer(options);
}
function $592f66aa99e3ed6d$export$200524cf0d997ff0(options) {
    return $592f66aa99e3ed6d$var$baseCreateRenderer(options, $592f66aa99e3ed6d$var$createHydrationFunctions);
}
function $592f66aa99e3ed6d$var$baseCreateRenderer(options, createHydrationFns) {
    $592f66aa99e3ed6d$var$initFeatureFlags();
    const target = (0, $jQKDy.getGlobalThis)();
    target.__VUE__ = true;
    if (__VUE_PROD_DEVTOOLS__) $592f66aa99e3ed6d$export$b0c258b32c26c785(target.__VUE_DEVTOOLS_GLOBAL_HOOK__, target);
    const { insert: hostInsert, remove: hostRemove, patchProp: hostPatchProp, createElement: hostCreateElement, createText: hostCreateText, createComment: hostCreateComment, setText: hostSetText, setElementText: hostSetElementText, parentNode: hostParentNode, nextSibling: hostNextSibling, setScopeId: hostSetScopeId = (0, $jQKDy.NOOP), insertStaticContent: hostInsertStaticContent } = options;
    const patch = (n1, n2, container, anchor = null, parentComponent = null, parentSuspense = null, isSVG = false, slotScopeIds = null, optimized = !!n2.dynamicChildren)=>{
        if (n1 === n2) return;
        if (n1 && !$592f66aa99e3ed6d$var$isSameVNodeType(n1, n2)) {
            anchor = getNextHostNode(n1);
            unmount(n1, parentComponent, parentSuspense, true);
            n1 = null;
        }
        if (n2.patchFlag === -2) {
            optimized = false;
            n2.dynamicChildren = null;
        }
        const { type: type, ref: ref, shapeFlag: shapeFlag } = n2;
        switch(type){
            case $592f66aa99e3ed6d$export$5f1af8db9871e1d6:
                processText(n1, n2, container, anchor);
                break;
            case $592f66aa99e3ed6d$export$4d299b491347818a:
                processCommentNode(n1, n2, container, anchor);
                break;
            case $592f66aa99e3ed6d$export$c1b9a1d3af45b7b6:
                if (n1 == null) mountStaticNode(n2, container, anchor, isSVG);
                break;
            case $592f66aa99e3ed6d$export$ffb0004e005737fa:
                processFragment(n1, n2, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized);
                break;
            default:
                if (shapeFlag & 1) processElement(n1, n2, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized);
                else if (shapeFlag & 6) processComponent(n1, n2, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized);
                else if (shapeFlag & 64) type.process(n1, n2, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized, internals);
                else if (shapeFlag & 128) type.process(n1, n2, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized, internals);
        }
        if (ref != null && parentComponent) $592f66aa99e3ed6d$var$setRef(ref, n1 && n1.ref, parentSuspense, n2 || n1, !n2);
    };
    const processText = (n1, n2, container, anchor)=>{
        if (n1 == null) hostInsert(n2.el = hostCreateText(n2.children), container, anchor);
        else {
            const el = n2.el = n1.el;
            if (n2.children !== n1.children) hostSetText(el, n2.children);
        }
    };
    const processCommentNode = (n1, n2, container, anchor)=>{
        if (n1 == null) hostInsert(n2.el = hostCreateComment(n2.children || ""), container, anchor);
        else n2.el = n1.el;
    };
    const mountStaticNode = (n2, container, anchor, isSVG)=>{
        [n2.el, n2.anchor] = hostInsertStaticContent(n2.children, container, anchor, isSVG, n2.el, n2.anchor);
    };
    const patchStaticNode = (n1, n2, container, isSVG)=>{
        if (n2.children !== n1.children) {
            const anchor = hostNextSibling(n1.anchor);
            removeStaticNode(n1);
            [n2.el, n2.anchor] = hostInsertStaticContent(n2.children, container, anchor, isSVG);
        } else {
            n2.el = n1.el;
            n2.anchor = n1.anchor;
        }
    };
    const moveStaticNode = ({ el: el, anchor: anchor }, container, nextSibling)=>{
        let next;
        while(el && el !== anchor){
            next = hostNextSibling(el);
            hostInsert(el, container, nextSibling);
            el = next;
        }
        hostInsert(anchor, container, nextSibling);
    };
    const removeStaticNode = ({ el: el, anchor: anchor })=>{
        let next;
        while(el && el !== anchor){
            next = hostNextSibling(el);
            hostRemove(el);
            el = next;
        }
        hostRemove(anchor);
    };
    const processElement = (n1, n2, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized)=>{
        isSVG = isSVG || n2.type === "svg";
        if (n1 == null) mountElement(n2, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized);
        else patchElement(n1, n2, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized);
    };
    const mountElement = (vnode, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized)=>{
        let el;
        let vnodeHook;
        const { type: type, props: props, shapeFlag: shapeFlag, transition: transition, dirs: dirs } = vnode;
        el = vnode.el = hostCreateElement(vnode.type, isSVG, props && props.is, props);
        if (shapeFlag & 8) hostSetElementText(el, vnode.children);
        else if (shapeFlag & 16) mountChildren(vnode.children, el, null, parentComponent, parentSuspense, isSVG && type !== "foreignObject", slotScopeIds, optimized);
        if (dirs) $592f66aa99e3ed6d$var$invokeDirectiveHook(vnode, null, parentComponent, "created");
        setScopeId(el, vnode, vnode.scopeId, slotScopeIds, parentComponent);
        if (props) {
            for(const key in props)if (key !== "value" && !(0, $jQKDy.isReservedProp)(key)) hostPatchProp(el, key, null, props[key], isSVG, vnode.children, parentComponent, parentSuspense, unmountChildren);
            if ("value" in props) hostPatchProp(el, "value", null, props.value);
            if (vnodeHook = props.onVnodeBeforeMount) $592f66aa99e3ed6d$var$invokeVNodeHook(vnodeHook, parentComponent, vnode);
        }
        if (__VUE_PROD_DEVTOOLS__) {
            Object.defineProperty(el, "__vnode", {
                value: vnode,
                enumerable: false
            });
            Object.defineProperty(el, "__vueParentComponent", {
                value: parentComponent,
                enumerable: false
            });
        }
        if (dirs) $592f66aa99e3ed6d$var$invokeDirectiveHook(vnode, null, parentComponent, "beforeMount");
        const needCallTransitionHooks = (!parentSuspense || parentSuspense && !parentSuspense.pendingBranch) && transition && !transition.persisted;
        if (needCallTransitionHooks) transition.beforeEnter(el);
        hostInsert(el, container, anchor);
        if ((vnodeHook = props && props.onVnodeMounted) || needCallTransitionHooks || dirs) $592f66aa99e3ed6d$var$queuePostRenderEffect(()=>{
            vnodeHook && $592f66aa99e3ed6d$var$invokeVNodeHook(vnodeHook, parentComponent, vnode);
            needCallTransitionHooks && transition.enter(el);
            dirs && $592f66aa99e3ed6d$var$invokeDirectiveHook(vnode, null, parentComponent, "mounted");
        }, parentSuspense);
    };
    const setScopeId = (el, vnode, scopeId, slotScopeIds, parentComponent)=>{
        if (scopeId) hostSetScopeId(el, scopeId);
        if (slotScopeIds) for(let i = 0; i < slotScopeIds.length; i++)hostSetScopeId(el, slotScopeIds[i]);
        if (parentComponent) {
            let subTree = parentComponent.subTree;
            if (vnode === subTree) {
                const parentVNode = parentComponent.vnode;
                setScopeId(el, parentVNode, parentVNode.scopeId, parentVNode.slotScopeIds, parentComponent.parent);
            }
        }
    };
    const mountChildren = (children, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized, start = 0)=>{
        for(let i = start; i < children.length; i++){
            const child = children[i] = optimized ? $592f66aa99e3ed6d$var$cloneIfMounted(children[i]) : $592f66aa99e3ed6d$var$normalizeVNode(children[i]);
            patch(null, child, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized);
        }
    };
    const patchElement = (n1, n2, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized)=>{
        const el = n2.el = n1.el;
        let { patchFlag: patchFlag, dynamicChildren: dynamicChildren, dirs: dirs } = n2;
        patchFlag |= n1.patchFlag & 16;
        const oldProps = n1.props || (0, $jQKDy.EMPTY_OBJ);
        const newProps = n2.props || (0, $jQKDy.EMPTY_OBJ);
        let vnodeHook;
        parentComponent && $592f66aa99e3ed6d$var$toggleRecurse(parentComponent, false);
        if (vnodeHook = newProps.onVnodeBeforeUpdate) $592f66aa99e3ed6d$var$invokeVNodeHook(vnodeHook, parentComponent, n2, n1);
        if (dirs) $592f66aa99e3ed6d$var$invokeDirectiveHook(n2, n1, parentComponent, "beforeUpdate");
        parentComponent && $592f66aa99e3ed6d$var$toggleRecurse(parentComponent, true);
        const areChildrenSVG = isSVG && n2.type !== "foreignObject";
        if (dynamicChildren) patchBlockChildren(n1.dynamicChildren, dynamicChildren, el, parentComponent, parentSuspense, areChildrenSVG, slotScopeIds);
        else if (!optimized) patchChildren(n1, n2, el, null, parentComponent, parentSuspense, areChildrenSVG, slotScopeIds, false);
        if (patchFlag > 0) {
            if (patchFlag & 16) patchProps(el, n2, oldProps, newProps, parentComponent, parentSuspense, isSVG);
            else {
                if (patchFlag & 2) {
                    if (oldProps.class !== newProps.class) hostPatchProp(el, "class", null, newProps.class, isSVG);
                }
                if (patchFlag & 4) hostPatchProp(el, "style", oldProps.style, newProps.style, isSVG);
                if (patchFlag & 8) {
                    const propsToUpdate = n2.dynamicProps;
                    for(let i = 0; i < propsToUpdate.length; i++){
                        const key = propsToUpdate[i];
                        const prev = oldProps[key];
                        const next = newProps[key];
                        if (next !== prev || key === "value") hostPatchProp(el, key, prev, next, isSVG, n1.children, parentComponent, parentSuspense, unmountChildren);
                    }
                }
            }
            if (patchFlag & 1) {
                if (n1.children !== n2.children) hostSetElementText(el, n2.children);
            }
        } else if (!optimized && dynamicChildren == null) patchProps(el, n2, oldProps, newProps, parentComponent, parentSuspense, isSVG);
        if ((vnodeHook = newProps.onVnodeUpdated) || dirs) $592f66aa99e3ed6d$var$queuePostRenderEffect(()=>{
            vnodeHook && $592f66aa99e3ed6d$var$invokeVNodeHook(vnodeHook, parentComponent, n2, n1);
            dirs && $592f66aa99e3ed6d$var$invokeDirectiveHook(n2, n1, parentComponent, "updated");
        }, parentSuspense);
    };
    const patchBlockChildren = (oldChildren, newChildren, fallbackContainer, parentComponent, parentSuspense, isSVG, slotScopeIds)=>{
        for(let i = 0; i < newChildren.length; i++){
            const oldVNode = oldChildren[i];
            const newVNode = newChildren[i];
            const container = // oldVNode may be an errored async setup() component inside Suspense
            // which will not have a mounted element
            oldVNode.el && // - In the case of a Fragment, we need to provide the actual parent
            // of the Fragment itself so it can move its children.
            (oldVNode.type === $592f66aa99e3ed6d$export$ffb0004e005737fa || // - In the case of different nodes, there is going to be a replacement
            // which also requires the correct parent container
            !$592f66aa99e3ed6d$var$isSameVNodeType(oldVNode, newVNode) || // - In the case of a component, it could contain anything.
            oldVNode.shapeFlag & 70) ? hostParentNode(oldVNode.el) : // In other cases, the parent container is not actually used so we
            // just pass the block element here to avoid a DOM parentNode call.
            fallbackContainer;
            patch(oldVNode, newVNode, container, null, parentComponent, parentSuspense, isSVG, slotScopeIds, true);
        }
    };
    const patchProps = (el, vnode, oldProps, newProps, parentComponent, parentSuspense, isSVG)=>{
        if (oldProps !== newProps) {
            if (oldProps !== (0, $jQKDy.EMPTY_OBJ)) {
                for(const key in oldProps)if (!(0, $jQKDy.isReservedProp)(key) && !(key in newProps)) hostPatchProp(el, key, oldProps[key], null, isSVG, vnode.children, parentComponent, parentSuspense, unmountChildren);
            }
            for(const key in newProps){
                if ((0, $jQKDy.isReservedProp)(key)) continue;
                const next = newProps[key];
                const prev = oldProps[key];
                if (next !== prev && key !== "value") hostPatchProp(el, key, prev, next, isSVG, vnode.children, parentComponent, parentSuspense, unmountChildren);
            }
            if ("value" in newProps) hostPatchProp(el, "value", oldProps.value, newProps.value);
        }
    };
    const processFragment = (n1, n2, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized)=>{
        const fragmentStartAnchor = n2.el = n1 ? n1.el : hostCreateText("");
        const fragmentEndAnchor = n2.anchor = n1 ? n1.anchor : hostCreateText("");
        let { patchFlag: patchFlag, dynamicChildren: dynamicChildren, slotScopeIds: fragmentSlotScopeIds } = n2;
        if (fragmentSlotScopeIds) slotScopeIds = slotScopeIds ? slotScopeIds.concat(fragmentSlotScopeIds) : fragmentSlotScopeIds;
        if (n1 == null) {
            hostInsert(fragmentStartAnchor, container, anchor);
            hostInsert(fragmentEndAnchor, container, anchor);
            mountChildren(n2.children, container, fragmentEndAnchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized);
        } else if (patchFlag > 0 && patchFlag & 64 && dynamicChildren && // #2715 the previous fragment could've been a BAILed one as a result
        // of renderSlot() with no valid children
        n1.dynamicChildren) {
            patchBlockChildren(n1.dynamicChildren, dynamicChildren, container, parentComponent, parentSuspense, isSVG, slotScopeIds);
            if (// #2080 if the stable fragment has a key, it's a <template v-for> that may
            //  get moved around. Make sure all root level vnodes inherit el.
            // #2134 or if it's a component root, it may also get moved around
            // as the component is being moved.
            n2.key != null || parentComponent && n2 === parentComponent.subTree) $592f66aa99e3ed6d$var$traverseStaticChildren(n1, n2, true);
        } else patchChildren(n1, n2, container, fragmentEndAnchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized);
    };
    const processComponent = (n1, n2, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized)=>{
        n2.slotScopeIds = slotScopeIds;
        if (n1 == null) {
            if (n2.shapeFlag & 512) parentComponent.ctx.activate(n2, container, anchor, isSVG, optimized);
            else mountComponent(n2, container, anchor, parentComponent, parentSuspense, isSVG, optimized);
        } else updateComponent(n1, n2, optimized);
    };
    const mountComponent = (initialVNode, container, anchor, parentComponent, parentSuspense, isSVG, optimized)=>{
        const instance = initialVNode.component = $592f66aa99e3ed6d$var$createComponentInstance(initialVNode, parentComponent, parentSuspense);
        if ($592f66aa99e3ed6d$var$isKeepAlive(initialVNode)) instance.ctx.renderer = internals;
        $592f66aa99e3ed6d$var$setupComponent(instance);
        if (instance.asyncDep) {
            parentSuspense && parentSuspense.registerDep(instance, setupRenderEffect);
            if (!initialVNode.el) {
                const placeholder = instance.subTree = $592f66aa99e3ed6d$export$bf5c4cf060303d58($592f66aa99e3ed6d$export$4d299b491347818a);
                processCommentNode(null, placeholder, container, anchor);
            }
            return;
        }
        setupRenderEffect(instance, initialVNode, container, anchor, parentSuspense, isSVG, optimized);
    };
    const updateComponent = (n1, n2, optimized)=>{
        const instance = n2.component = n1.component;
        if ($592f66aa99e3ed6d$var$shouldUpdateComponent(n1, n2, optimized)) {
            if (instance.asyncDep && !instance.asyncResolved) {
                updateComponentPreRender(instance, n2, optimized);
                return;
            } else {
                instance.next = n2;
                $592f66aa99e3ed6d$var$invalidateJob(instance.update);
                instance.update();
            }
        } else {
            n2.el = n1.el;
            instance.vnode = n2;
        }
    };
    const setupRenderEffect = (instance, initialVNode, container, anchor, parentSuspense, isSVG, optimized)=>{
        const componentUpdateFn = ()=>{
            if (!instance.isMounted) {
                let vnodeHook;
                const { el: el, props: props } = initialVNode;
                const { bm: bm, m: m, parent: parent } = instance;
                const isAsyncWrapperVNode = $592f66aa99e3ed6d$var$isAsyncWrapper(initialVNode);
                $592f66aa99e3ed6d$var$toggleRecurse(instance, false);
                if (bm) (0, $jQKDy.invokeArrayFns)(bm);
                if (!isAsyncWrapperVNode && (vnodeHook = props && props.onVnodeBeforeMount)) $592f66aa99e3ed6d$var$invokeVNodeHook(vnodeHook, parent, initialVNode);
                $592f66aa99e3ed6d$var$toggleRecurse(instance, true);
                if (el && hydrateNode) {
                    const hydrateSubTree = ()=>{
                        instance.subTree = $592f66aa99e3ed6d$var$renderComponentRoot(instance);
                        hydrateNode(el, instance.subTree, instance, parentSuspense, null);
                    };
                    if (isAsyncWrapperVNode) initialVNode.type.__asyncLoader().then(// note: we are moving the render call into an async callback,
                    // which means it won't track dependencies - but it's ok because
                    // a server-rendered async wrapper is already in resolved state
                    // and it will never need to change.
                    ()=>!instance.isUnmounted && hydrateSubTree());
                    else hydrateSubTree();
                } else {
                    const subTree = instance.subTree = $592f66aa99e3ed6d$var$renderComponentRoot(instance);
                    patch(null, subTree, container, anchor, instance, parentSuspense, isSVG);
                    initialVNode.el = subTree.el;
                }
                if (m) $592f66aa99e3ed6d$var$queuePostRenderEffect(m, parentSuspense);
                if (!isAsyncWrapperVNode && (vnodeHook = props && props.onVnodeMounted)) {
                    const scopedInitialVNode = initialVNode;
                    $592f66aa99e3ed6d$var$queuePostRenderEffect(()=>$592f66aa99e3ed6d$var$invokeVNodeHook(vnodeHook, parent, scopedInitialVNode), parentSuspense);
                }
                if (initialVNode.shapeFlag & 256 || parent && $592f66aa99e3ed6d$var$isAsyncWrapper(parent.vnode) && parent.vnode.shapeFlag & 256) instance.a && $592f66aa99e3ed6d$var$queuePostRenderEffect(instance.a, parentSuspense);
                instance.isMounted = true;
                if (__VUE_PROD_DEVTOOLS__) $592f66aa99e3ed6d$var$devtoolsComponentAdded(instance);
                initialVNode = container = anchor = null;
            } else {
                let { next: next, bu: bu, u: u, parent: parent, vnode: vnode } = instance;
                let originNext = next;
                let vnodeHook;
                $592f66aa99e3ed6d$var$toggleRecurse(instance, false);
                if (next) {
                    next.el = vnode.el;
                    updateComponentPreRender(instance, next, optimized);
                } else next = vnode;
                if (bu) (0, $jQKDy.invokeArrayFns)(bu);
                if (vnodeHook = next.props && next.props.onVnodeBeforeUpdate) $592f66aa99e3ed6d$var$invokeVNodeHook(vnodeHook, parent, next, vnode);
                $592f66aa99e3ed6d$var$toggleRecurse(instance, true);
                const nextTree = $592f66aa99e3ed6d$var$renderComponentRoot(instance);
                const prevTree = instance.subTree;
                instance.subTree = nextTree;
                patch(prevTree, nextTree, // parent may have changed if it's in a teleport
                hostParentNode(prevTree.el), // anchor may have changed if it's in a fragment
                getNextHostNode(prevTree), instance, parentSuspense, isSVG);
                next.el = nextTree.el;
                if (originNext === null) $592f66aa99e3ed6d$var$updateHOCHostEl(instance, nextTree.el);
                if (u) $592f66aa99e3ed6d$var$queuePostRenderEffect(u, parentSuspense);
                if (vnodeHook = next.props && next.props.onVnodeUpdated) $592f66aa99e3ed6d$var$queuePostRenderEffect(()=>$592f66aa99e3ed6d$var$invokeVNodeHook(vnodeHook, parent, next, vnode), parentSuspense);
                if (__VUE_PROD_DEVTOOLS__) $592f66aa99e3ed6d$var$devtoolsComponentUpdated(instance);
            }
        };
        const effect = instance.effect = new (0, $hnQzm.ReactiveEffect)(componentUpdateFn, ()=>$592f66aa99e3ed6d$var$queueJob(update), instance.scope);
        const update = instance.update = ()=>effect.run();
        update.id = instance.uid;
        $592f66aa99e3ed6d$var$toggleRecurse(instance, true);
        var e, e1;
        update();
    };
    const updateComponentPreRender = (instance, nextVNode, optimized)=>{
        nextVNode.component = instance;
        const prevProps = instance.vnode.props;
        instance.vnode = nextVNode;
        instance.next = null;
        $592f66aa99e3ed6d$var$updateProps(instance, nextVNode.props, prevProps, optimized);
        $592f66aa99e3ed6d$var$updateSlots(instance, nextVNode.children, optimized);
        (0, $hnQzm.pauseTracking)();
        $592f66aa99e3ed6d$var$flushPreFlushCbs();
        (0, $hnQzm.resetTracking)();
    };
    const patchChildren = (n1, n2, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized = false)=>{
        const c1 = n1 && n1.children;
        const prevShapeFlag = n1 ? n1.shapeFlag : 0;
        const c2 = n2.children;
        const { patchFlag: patchFlag, shapeFlag: shapeFlag } = n2;
        if (patchFlag > 0) {
            if (patchFlag & 128) {
                patchKeyedChildren(c1, c2, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized);
                return;
            } else if (patchFlag & 256) {
                patchUnkeyedChildren(c1, c2, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized);
                return;
            }
        }
        if (shapeFlag & 8) {
            if (prevShapeFlag & 16) unmountChildren(c1, parentComponent, parentSuspense);
            if (c2 !== c1) hostSetElementText(container, c2);
        } else if (prevShapeFlag & 16) {
            if (shapeFlag & 16) patchKeyedChildren(c1, c2, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized);
            else unmountChildren(c1, parentComponent, parentSuspense, true);
        } else {
            if (prevShapeFlag & 8) hostSetElementText(container, "");
            if (shapeFlag & 16) mountChildren(c2, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized);
        }
    };
    const patchUnkeyedChildren = (c1, c2, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized)=>{
        c1 = c1 || (0, $jQKDy.EMPTY_ARR);
        c2 = c2 || (0, $jQKDy.EMPTY_ARR);
        const oldLength = c1.length;
        const newLength = c2.length;
        const commonLength = Math.min(oldLength, newLength);
        let i;
        for(i = 0; i < commonLength; i++){
            const nextChild = c2[i] = optimized ? $592f66aa99e3ed6d$var$cloneIfMounted(c2[i]) : $592f66aa99e3ed6d$var$normalizeVNode(c2[i]);
            patch(c1[i], nextChild, container, null, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized);
        }
        if (oldLength > newLength) unmountChildren(c1, parentComponent, parentSuspense, true, false, commonLength);
        else mountChildren(c2, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized, commonLength);
    };
    const patchKeyedChildren = (c1, c2, container, parentAnchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized)=>{
        let i = 0;
        const l2 = c2.length;
        let e1 = c1.length - 1;
        let e2 = l2 - 1;
        while(i <= e1 && i <= e2){
            const n1 = c1[i];
            const n2 = c2[i] = optimized ? $592f66aa99e3ed6d$var$cloneIfMounted(c2[i]) : $592f66aa99e3ed6d$var$normalizeVNode(c2[i]);
            if ($592f66aa99e3ed6d$var$isSameVNodeType(n1, n2)) patch(n1, n2, container, null, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized);
            else break;
            i++;
        }
        while(i <= e1 && i <= e2){
            const n1 = c1[e1];
            const n2 = c2[e2] = optimized ? $592f66aa99e3ed6d$var$cloneIfMounted(c2[e2]) : $592f66aa99e3ed6d$var$normalizeVNode(c2[e2]);
            if ($592f66aa99e3ed6d$var$isSameVNodeType(n1, n2)) patch(n1, n2, container, null, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized);
            else break;
            e1--;
            e2--;
        }
        if (i > e1) {
            if (i <= e2) {
                const nextPos = e2 + 1;
                const anchor = nextPos < l2 ? c2[nextPos].el : parentAnchor;
                while(i <= e2){
                    patch(null, c2[i] = optimized ? $592f66aa99e3ed6d$var$cloneIfMounted(c2[i]) : $592f66aa99e3ed6d$var$normalizeVNode(c2[i]), container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized);
                    i++;
                }
            }
        } else if (i > e2) while(i <= e1){
            unmount(c1[i], parentComponent, parentSuspense, true);
            i++;
        }
        else {
            const s1 = i;
            const s2 = i;
            const keyToNewIndexMap = /* @__PURE__ */ new Map();
            for(i = s2; i <= e2; i++){
                const nextChild = c2[i] = optimized ? $592f66aa99e3ed6d$var$cloneIfMounted(c2[i]) : $592f66aa99e3ed6d$var$normalizeVNode(c2[i]);
                if (nextChild.key != null) keyToNewIndexMap.set(nextChild.key, i);
            }
            let j;
            let patched = 0;
            const toBePatched = e2 - s2 + 1;
            let moved = false;
            let maxNewIndexSoFar = 0;
            const newIndexToOldIndexMap = new Array(toBePatched);
            for(i = 0; i < toBePatched; i++)newIndexToOldIndexMap[i] = 0;
            for(i = s1; i <= e1; i++){
                const prevChild = c1[i];
                if (patched >= toBePatched) {
                    unmount(prevChild, parentComponent, parentSuspense, true);
                    continue;
                }
                let newIndex;
                if (prevChild.key != null) newIndex = keyToNewIndexMap.get(prevChild.key);
                else {
                    for(j = s2; j <= e2; j++)if (newIndexToOldIndexMap[j - s2] === 0 && $592f66aa99e3ed6d$var$isSameVNodeType(prevChild, c2[j])) {
                        newIndex = j;
                        break;
                    }
                }
                if (newIndex === void 0) unmount(prevChild, parentComponent, parentSuspense, true);
                else {
                    newIndexToOldIndexMap[newIndex - s2] = i + 1;
                    if (newIndex >= maxNewIndexSoFar) maxNewIndexSoFar = newIndex;
                    else moved = true;
                    patch(prevChild, c2[newIndex], container, null, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized);
                    patched++;
                }
            }
            const increasingNewIndexSequence = moved ? $592f66aa99e3ed6d$var$getSequence(newIndexToOldIndexMap) : (0, $jQKDy.EMPTY_ARR);
            j = increasingNewIndexSequence.length - 1;
            for(i = toBePatched - 1; i >= 0; i--){
                const nextIndex = s2 + i;
                const nextChild = c2[nextIndex];
                const anchor = nextIndex + 1 < l2 ? c2[nextIndex + 1].el : parentAnchor;
                if (newIndexToOldIndexMap[i] === 0) patch(null, nextChild, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized);
                else if (moved) {
                    if (j < 0 || i !== increasingNewIndexSequence[j]) move(nextChild, container, anchor, 2);
                    else j--;
                }
            }
        }
    };
    const move = (vnode, container, anchor, moveType, parentSuspense = null)=>{
        const { el: el, type: type, transition: transition, children: children, shapeFlag: shapeFlag } = vnode;
        if (shapeFlag & 6) {
            move(vnode.component.subTree, container, anchor, moveType);
            return;
        }
        if (shapeFlag & 128) {
            vnode.suspense.move(container, anchor, moveType);
            return;
        }
        if (shapeFlag & 64) {
            type.move(vnode, container, anchor, internals);
            return;
        }
        if (type === $592f66aa99e3ed6d$export$ffb0004e005737fa) {
            hostInsert(el, container, anchor);
            for(let i = 0; i < children.length; i++)move(children[i], container, anchor, moveType);
            hostInsert(vnode.anchor, container, anchor);
            return;
        }
        if (type === $592f66aa99e3ed6d$export$c1b9a1d3af45b7b6) {
            moveStaticNode(vnode, container, anchor);
            return;
        }
        const needTransition = moveType !== 2 && shapeFlag & 1 && transition;
        if (needTransition) {
            if (moveType === 0) {
                transition.beforeEnter(el);
                hostInsert(el, container, anchor);
                $592f66aa99e3ed6d$var$queuePostRenderEffect(()=>transition.enter(el), parentSuspense);
            } else {
                const { leave: leave, delayLeave: delayLeave, afterLeave: afterLeave } = transition;
                const remove2 = ()=>hostInsert(el, container, anchor);
                const performLeave = ()=>{
                    leave(el, ()=>{
                        remove2();
                        afterLeave && afterLeave();
                    });
                };
                if (delayLeave) delayLeave(el, remove2, performLeave);
                else performLeave();
            }
        } else hostInsert(el, container, anchor);
    };
    const unmount = (vnode, parentComponent, parentSuspense, doRemove = false, optimized = false)=>{
        const { type: type, props: props, ref: ref, children: children, dynamicChildren: dynamicChildren, shapeFlag: shapeFlag, patchFlag: patchFlag, dirs: dirs } = vnode;
        if (ref != null) $592f66aa99e3ed6d$var$setRef(ref, null, parentSuspense, vnode, true);
        if (shapeFlag & 256) {
            parentComponent.ctx.deactivate(vnode);
            return;
        }
        const shouldInvokeDirs = shapeFlag & 1 && dirs;
        const shouldInvokeVnodeHook = !$592f66aa99e3ed6d$var$isAsyncWrapper(vnode);
        let vnodeHook;
        if (shouldInvokeVnodeHook && (vnodeHook = props && props.onVnodeBeforeUnmount)) $592f66aa99e3ed6d$var$invokeVNodeHook(vnodeHook, parentComponent, vnode);
        if (shapeFlag & 6) unmountComponent(vnode.component, parentSuspense, doRemove);
        else {
            if (shapeFlag & 128) {
                vnode.suspense.unmount(parentSuspense, doRemove);
                return;
            }
            if (shouldInvokeDirs) $592f66aa99e3ed6d$var$invokeDirectiveHook(vnode, null, parentComponent, "beforeUnmount");
            if (shapeFlag & 64) vnode.type.remove(vnode, parentComponent, parentSuspense, optimized, internals, doRemove);
            else if (dynamicChildren && // #1153: fast path should not be taken for non-stable (v-for) fragments
            (type !== $592f66aa99e3ed6d$export$ffb0004e005737fa || patchFlag > 0 && patchFlag & 64)) unmountChildren(dynamicChildren, parentComponent, parentSuspense, false, true);
            else if (type === $592f66aa99e3ed6d$export$ffb0004e005737fa && patchFlag & 384 || !optimized && shapeFlag & 16) unmountChildren(children, parentComponent, parentSuspense);
            if (doRemove) remove(vnode);
        }
        if (shouldInvokeVnodeHook && (vnodeHook = props && props.onVnodeUnmounted) || shouldInvokeDirs) $592f66aa99e3ed6d$var$queuePostRenderEffect(()=>{
            vnodeHook && $592f66aa99e3ed6d$var$invokeVNodeHook(vnodeHook, parentComponent, vnode);
            shouldInvokeDirs && $592f66aa99e3ed6d$var$invokeDirectiveHook(vnode, null, parentComponent, "unmounted");
        }, parentSuspense);
    };
    const remove = (vnode)=>{
        const { type: type, el: el, anchor: anchor, transition: transition } = vnode;
        if (type === $592f66aa99e3ed6d$export$ffb0004e005737fa) {
            var child;
            removeFragment(el, anchor);
            return;
        }
        if (type === $592f66aa99e3ed6d$export$c1b9a1d3af45b7b6) {
            removeStaticNode(vnode);
            return;
        }
        const performRemove = ()=>{
            hostRemove(el);
            if (transition && !transition.persisted && transition.afterLeave) transition.afterLeave();
        };
        if (vnode.shapeFlag & 1 && transition && !transition.persisted) {
            const { leave: leave, delayLeave: delayLeave } = transition;
            const performLeave = ()=>leave(el, performRemove);
            if (delayLeave) delayLeave(vnode.el, performRemove, performLeave);
            else performLeave();
        } else performRemove();
    };
    const removeFragment = (cur, end)=>{
        let next;
        while(cur !== end){
            next = hostNextSibling(cur);
            hostRemove(cur);
            cur = next;
        }
        hostRemove(end);
    };
    const unmountComponent = (instance, parentSuspense, doRemove)=>{
        const { bum: bum, scope: scope, update: update, subTree: subTree, um: um } = instance;
        if (bum) (0, $jQKDy.invokeArrayFns)(bum);
        scope.stop();
        if (update) {
            update.active = false;
            unmount(subTree, instance, parentSuspense, doRemove);
        }
        if (um) $592f66aa99e3ed6d$var$queuePostRenderEffect(um, parentSuspense);
        $592f66aa99e3ed6d$var$queuePostRenderEffect(()=>{
            instance.isUnmounted = true;
        }, parentSuspense);
        if (parentSuspense && parentSuspense.pendingBranch && !parentSuspense.isUnmounted && instance.asyncDep && !instance.asyncResolved && instance.suspenseId === parentSuspense.pendingId) {
            parentSuspense.deps--;
            if (parentSuspense.deps === 0) parentSuspense.resolve();
        }
        if (__VUE_PROD_DEVTOOLS__) $592f66aa99e3ed6d$var$devtoolsComponentRemoved(instance);
    };
    const unmountChildren = (children, parentComponent, parentSuspense, doRemove = false, optimized = false, start = 0)=>{
        for(let i = start; i < children.length; i++)unmount(children[i], parentComponent, parentSuspense, doRemove, optimized);
    };
    const getNextHostNode = (vnode)=>{
        if (vnode.shapeFlag & 6) return getNextHostNode(vnode.component.subTree);
        if (vnode.shapeFlag & 128) return vnode.suspense.next();
        return hostNextSibling(vnode.anchor || vnode.el);
    };
    const render = (vnode, container, isSVG)=>{
        if (vnode == null) {
            if (container._vnode) unmount(container._vnode, null, null, true);
        } else patch(container._vnode || null, vnode, container, null, null, null, isSVG);
        $592f66aa99e3ed6d$var$flushPreFlushCbs();
        $592f66aa99e3ed6d$var$flushPostFlushCbs();
        container._vnode = vnode;
    };
    const internals = {
        p: patch,
        um: unmount,
        m: move,
        r: remove,
        mt: mountComponent,
        mc: mountChildren,
        pc: patchChildren,
        pbc: patchBlockChildren,
        n: getNextHostNode,
        o: options
    };
    let hydrate;
    let hydrateNode;
    if (createHydrationFns) [hydrate, hydrateNode] = createHydrationFns(internals);
    return {
        render: render,
        hydrate: hydrate,
        createApp: $592f66aa99e3ed6d$var$createAppAPI(render, hydrate)
    };
}
function $592f66aa99e3ed6d$var$toggleRecurse({ effect: effect, update: update }, allowed) {
    effect.allowRecurse = update.allowRecurse = allowed;
}
function $592f66aa99e3ed6d$var$traverseStaticChildren(n1, n2, shallow = false) {
    const ch1 = n1.children;
    const ch2 = n2.children;
    if ((0, $jQKDy.isArray)(ch1) && (0, $jQKDy.isArray)(ch2)) for(let i = 0; i < ch1.length; i++){
        const c1 = ch1[i];
        let c2 = ch2[i];
        if (c2.shapeFlag & 1 && !c2.dynamicChildren) {
            if (c2.patchFlag <= 0 || c2.patchFlag === 32) {
                c2 = ch2[i] = $592f66aa99e3ed6d$var$cloneIfMounted(ch2[i]);
                c2.el = c1.el;
            }
            if (!shallow) $592f66aa99e3ed6d$var$traverseStaticChildren(c1, c2);
        }
        if (c2.type === $592f66aa99e3ed6d$export$5f1af8db9871e1d6) c2.el = c1.el;
    }
}
function $592f66aa99e3ed6d$var$getSequence(arr) {
    const p = arr.slice();
    const result = [
        0
    ];
    let i, j, u, v1, c;
    const len = arr.length;
    for(i = 0; i < len; i++){
        const arrI = arr[i];
        if (arrI !== 0) {
            j = result[result.length - 1];
            if (arr[j] < arrI) {
                p[i] = j;
                result.push(i);
                continue;
            }
            u = 0;
            v1 = result.length - 1;
            while(u < v1){
                c = u + v1 >> 1;
                if (arr[result[c]] < arrI) u = c + 1;
                else v1 = c;
            }
            if (arrI < arr[result[u]]) {
                if (u > 0) p[i] = result[u - 1];
                result[u] = i;
            }
        }
    }
    u = result.length;
    v1 = result[u - 1];
    while(u-- > 0){
        result[u] = v1;
        v1 = p[v1];
    }
    return result;
}
const $592f66aa99e3ed6d$var$isTeleport = (type)=>type.__isTeleport;
const $592f66aa99e3ed6d$var$isTeleportDisabled = (props)=>props && (props.disabled || props.disabled === "");
const $592f66aa99e3ed6d$var$isTargetSVG = (target)=>typeof SVGElement !== "undefined" && target instanceof SVGElement;
const $592f66aa99e3ed6d$var$resolveTarget = (props, select)=>{
    const targetSelector = props && props.to;
    if ((0, $jQKDy.isString)(targetSelector)) {
        if (!select) return null;
        else {
            const target = select(targetSelector);
            target;
            return target;
        }
    } else return targetSelector;
};
const $592f66aa99e3ed6d$var$TeleportImpl = {
    __isTeleport: true,
    process (n1, n2, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized, internals) {
        const { mc: mountChildren, pc: patchChildren, pbc: patchBlockChildren, o: { insert: insert, querySelector: querySelector, createText: createText, createComment: createComment } } = internals;
        const disabled = $592f66aa99e3ed6d$var$isTeleportDisabled(n2.props);
        let { shapeFlag: shapeFlag, children: children, dynamicChildren: dynamicChildren } = n2;
        if (n1 == null) {
            const placeholder = n2.el = createText("");
            const mainAnchor = n2.anchor = createText("");
            insert(placeholder, container, anchor);
            insert(mainAnchor, container, anchor);
            const target = n2.target = $592f66aa99e3ed6d$var$resolveTarget(n2.props, querySelector);
            const targetAnchor = n2.targetAnchor = createText("");
            if (target) {
                insert(targetAnchor, target);
                isSVG = isSVG || $592f66aa99e3ed6d$var$isTargetSVG(target);
            }
            const mount = (container2, anchor2)=>{
                if (shapeFlag & 16) mountChildren(children, container2, anchor2, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized);
            };
            if (disabled) mount(container, mainAnchor);
            else if (target) mount(target, targetAnchor);
        } else {
            n2.el = n1.el;
            const mainAnchor = n2.anchor = n1.anchor;
            const target = n2.target = n1.target;
            const targetAnchor = n2.targetAnchor = n1.targetAnchor;
            const wasDisabled = $592f66aa99e3ed6d$var$isTeleportDisabled(n1.props);
            const currentContainer = wasDisabled ? container : target;
            const currentAnchor = wasDisabled ? mainAnchor : targetAnchor;
            isSVG = isSVG || $592f66aa99e3ed6d$var$isTargetSVG(target);
            if (dynamicChildren) {
                patchBlockChildren(n1.dynamicChildren, dynamicChildren, currentContainer, parentComponent, parentSuspense, isSVG, slotScopeIds);
                $592f66aa99e3ed6d$var$traverseStaticChildren(n1, n2, true);
            } else if (!optimized) patchChildren(n1, n2, currentContainer, currentAnchor, parentComponent, parentSuspense, isSVG, slotScopeIds, false);
            if (disabled) {
                if (!wasDisabled) $592f66aa99e3ed6d$var$moveTeleport(n2, container, mainAnchor, internals, 1);
            } else {
                if ((n2.props && n2.props.to) !== (n1.props && n1.props.to)) {
                    const nextTarget = n2.target = $592f66aa99e3ed6d$var$resolveTarget(n2.props, querySelector);
                    if (nextTarget) $592f66aa99e3ed6d$var$moveTeleport(n2, nextTarget, null, internals, 0);
                } else if (wasDisabled) $592f66aa99e3ed6d$var$moveTeleport(n2, target, targetAnchor, internals, 1);
            }
        }
        $592f66aa99e3ed6d$var$updateCssVars(n2);
    },
    remove (vnode, parentComponent, parentSuspense, optimized, { um: unmount, o: { remove: hostRemove } }, doRemove) {
        const { shapeFlag: shapeFlag, children: children, anchor: anchor, targetAnchor: targetAnchor, target: target, props: props } = vnode;
        if (target) hostRemove(targetAnchor);
        if (doRemove || !$592f66aa99e3ed6d$var$isTeleportDisabled(props)) {
            hostRemove(anchor);
            if (shapeFlag & 16) for(let i = 0; i < children.length; i++){
                const child = children[i];
                unmount(child, parentComponent, parentSuspense, true, !!child.dynamicChildren);
            }
        }
    },
    move: $592f66aa99e3ed6d$var$moveTeleport,
    hydrate: $592f66aa99e3ed6d$var$hydrateTeleport
};
function $592f66aa99e3ed6d$var$moveTeleport(vnode, container, parentAnchor, { o: { insert: insert }, m: move }, moveType = 2) {
    if (moveType === 0) insert(vnode.targetAnchor, container, parentAnchor);
    const { el: el, anchor: anchor, shapeFlag: shapeFlag, children: children, props: props } = vnode;
    const isReorder = moveType === 2;
    if (isReorder) insert(el, container, parentAnchor);
    if (!isReorder || $592f66aa99e3ed6d$var$isTeleportDisabled(props)) {
        if (shapeFlag & 16) for(let i = 0; i < children.length; i++)move(children[i], container, parentAnchor, 2);
    }
    if (isReorder) insert(anchor, container, parentAnchor);
}
function $592f66aa99e3ed6d$var$hydrateTeleport(node, vnode, parentComponent, parentSuspense, slotScopeIds, optimized, { o: { nextSibling: nextSibling, parentNode: parentNode, querySelector: querySelector } }, hydrateChildren) {
    const target = vnode.target = $592f66aa99e3ed6d$var$resolveTarget(vnode.props, querySelector);
    if (target) {
        const targetNode = target._lpa || target.firstChild;
        if (vnode.shapeFlag & 16) {
            if ($592f66aa99e3ed6d$var$isTeleportDisabled(vnode.props)) {
                vnode.anchor = hydrateChildren(nextSibling(node), vnode, parentNode(node), parentComponent, parentSuspense, slotScopeIds, optimized);
                vnode.targetAnchor = targetNode;
            } else {
                vnode.anchor = nextSibling(node);
                let targetAnchor = targetNode;
                while(targetAnchor){
                    targetAnchor = nextSibling(targetAnchor);
                    if (targetAnchor && targetAnchor.nodeType === 8 && targetAnchor.data === "teleport anchor") {
                        vnode.targetAnchor = targetAnchor;
                        target._lpa = vnode.targetAnchor && nextSibling(vnode.targetAnchor);
                        break;
                    }
                }
                hydrateChildren(targetNode, vnode, target, parentComponent, parentSuspense, slotScopeIds, optimized);
            }
        }
        $592f66aa99e3ed6d$var$updateCssVars(vnode);
    }
    return vnode.anchor && nextSibling(vnode.anchor);
}
const $592f66aa99e3ed6d$export$76d55a0304a371f4 = $592f66aa99e3ed6d$var$TeleportImpl;
function $592f66aa99e3ed6d$var$updateCssVars(vnode) {
    const ctx = vnode.ctx;
    if (ctx && ctx.ut) {
        let node = vnode.children[0].el;
        while(node !== vnode.targetAnchor){
            if (node.nodeType === 1) node.setAttribute("data-v-owner", ctx.uid);
            node = node.nextSibling;
        }
        ctx.ut();
    }
}
const $592f66aa99e3ed6d$export$ffb0004e005737fa = Symbol.for("v-fgt");
const $592f66aa99e3ed6d$export$5f1af8db9871e1d6 = Symbol.for("v-txt");
const $592f66aa99e3ed6d$export$4d299b491347818a = Symbol.for("v-cmt");
const $592f66aa99e3ed6d$export$c1b9a1d3af45b7b6 = Symbol.for("v-stc");
const $592f66aa99e3ed6d$var$blockStack = [];
let $592f66aa99e3ed6d$var$currentBlock = null;
function $592f66aa99e3ed6d$export$e7eaa45e502fe5cc(disableTracking = false) {
    $592f66aa99e3ed6d$var$blockStack.push($592f66aa99e3ed6d$var$currentBlock = disableTracking ? null : []);
}
function $592f66aa99e3ed6d$var$closeBlock() {
    $592f66aa99e3ed6d$var$blockStack.pop();
    $592f66aa99e3ed6d$var$currentBlock = $592f66aa99e3ed6d$var$blockStack[$592f66aa99e3ed6d$var$blockStack.length - 1] || null;
}
let $592f66aa99e3ed6d$var$isBlockTreeEnabled = 1;
function $592f66aa99e3ed6d$export$c20bee82f26f1e27(value1) {
    $592f66aa99e3ed6d$var$isBlockTreeEnabled += value1;
}
function $592f66aa99e3ed6d$var$setupBlock(vnode) {
    vnode.dynamicChildren = $592f66aa99e3ed6d$var$isBlockTreeEnabled > 0 ? $592f66aa99e3ed6d$var$currentBlock || (0, $jQKDy.EMPTY_ARR) : null;
    $592f66aa99e3ed6d$var$closeBlock();
    if ($592f66aa99e3ed6d$var$isBlockTreeEnabled > 0 && $592f66aa99e3ed6d$var$currentBlock) $592f66aa99e3ed6d$var$currentBlock.push(vnode);
    return vnode;
}
function $592f66aa99e3ed6d$export$167055419fc69ec1(type, props, children, patchFlag, dynamicProps, shapeFlag) {
    return $592f66aa99e3ed6d$var$setupBlock($592f66aa99e3ed6d$export$42098e0eaa15c48e(type, props, children, patchFlag, dynamicProps, shapeFlag, true));
}
function $592f66aa99e3ed6d$export$9f2dfe8048dfb22b(type, props, children, patchFlag, dynamicProps) {
    return $592f66aa99e3ed6d$var$setupBlock($592f66aa99e3ed6d$export$bf5c4cf060303d58(type, props, children, patchFlag, dynamicProps, true));
}
function $592f66aa99e3ed6d$export$3868d13f8734ae81(value1) {
    return value1 ? value1.__v_isVNode === true : false;
}
function $592f66aa99e3ed6d$var$isSameVNodeType(n1, n2) {
    return n1.type === n2.type && n1.key === n2.key;
}
let $592f66aa99e3ed6d$var$vnodeArgsTransformer;
function $592f66aa99e3ed6d$export$83beccd3afeeb809(transformer) {
    $592f66aa99e3ed6d$var$vnodeArgsTransformer = transformer;
}
const $592f66aa99e3ed6d$var$createVNodeWithArgsTransform = (...args)=>{
    return $592f66aa99e3ed6d$var$_createVNode(...$592f66aa99e3ed6d$var$vnodeArgsTransformer ? $592f66aa99e3ed6d$var$vnodeArgsTransformer(args, $592f66aa99e3ed6d$var$currentRenderingInstance) : args);
};
const $592f66aa99e3ed6d$var$InternalObjectKey = `__vInternal`;
const $592f66aa99e3ed6d$var$normalizeKey = ({ key: key })=>key != null ? key : null;
const $592f66aa99e3ed6d$var$normalizeRef = ({ ref: ref, ref_key: ref_key, ref_for: ref_for })=>{
    if (typeof ref === "number") ref = "" + ref;
    return ref != null ? (0, $jQKDy.isString)(ref) || (0, $hnQzm.isRef)(ref) || (0, $jQKDy.isFunction)(ref) ? {
        i: $592f66aa99e3ed6d$var$currentRenderingInstance,
        r: ref,
        k: ref_key,
        f: !!ref_for
    } : ref : null;
};
function $592f66aa99e3ed6d$export$42098e0eaa15c48e(type, props = null, children = null, patchFlag = 0, dynamicProps = null, shapeFlag = type === $592f66aa99e3ed6d$export$ffb0004e005737fa ? 0 : 1, isBlockNode = false, needFullChildrenNormalization = false) {
    const vnode = {
        __v_isVNode: true,
        __v_skip: true,
        type: type,
        props: props,
        key: props && $592f66aa99e3ed6d$var$normalizeKey(props),
        ref: props && $592f66aa99e3ed6d$var$normalizeRef(props),
        scopeId: $592f66aa99e3ed6d$var$currentScopeId,
        slotScopeIds: null,
        children: children,
        component: null,
        suspense: null,
        ssContent: null,
        ssFallback: null,
        dirs: null,
        transition: null,
        el: null,
        anchor: null,
        target: null,
        targetAnchor: null,
        staticCount: 0,
        shapeFlag: shapeFlag,
        patchFlag: patchFlag,
        dynamicProps: dynamicProps,
        dynamicChildren: null,
        appContext: null,
        ctx: $592f66aa99e3ed6d$var$currentRenderingInstance
    };
    if (needFullChildrenNormalization) {
        $592f66aa99e3ed6d$var$normalizeChildren(vnode, children);
        if (shapeFlag & 128) type.normalize(vnode);
    } else if (children) vnode.shapeFlag |= (0, $jQKDy.isString)(children) ? 8 : 16;
    if ($592f66aa99e3ed6d$var$isBlockTreeEnabled > 0 && // avoid a block node from tracking itself
    !isBlockNode && // has current parent block
    $592f66aa99e3ed6d$var$currentBlock && // presence of a patch flag indicates this node needs patching on updates.
    // component nodes also should always be patched, because even if the
    // component doesn't need to update, it needs to persist the instance on to
    // the next vnode so that it can be properly unmounted later.
    (vnode.patchFlag > 0 || shapeFlag & 6) && // the EVENTS flag is only for hydration and if it is the only flag, the
    // vnode should not be considered dynamic due to handler caching.
    vnode.patchFlag !== 32) $592f66aa99e3ed6d$var$currentBlock.push(vnode);
    return vnode;
}
const $592f66aa99e3ed6d$export$bf5c4cf060303d58 = $592f66aa99e3ed6d$var$_createVNode;
function $592f66aa99e3ed6d$var$_createVNode(type, props = null, children = null, patchFlag = 0, dynamicProps = null, isBlockNode = false) {
    if (!type || type === $592f66aa99e3ed6d$var$NULL_DYNAMIC_COMPONENT) type = $592f66aa99e3ed6d$export$4d299b491347818a;
    if ($592f66aa99e3ed6d$export$3868d13f8734ae81(type)) {
        const cloned = $592f66aa99e3ed6d$export$ee4f9e12c0a92a1a(type, props, true);
        if (children) $592f66aa99e3ed6d$var$normalizeChildren(cloned, children);
        if ($592f66aa99e3ed6d$var$isBlockTreeEnabled > 0 && !isBlockNode && $592f66aa99e3ed6d$var$currentBlock) {
            if (cloned.shapeFlag & 6) $592f66aa99e3ed6d$var$currentBlock[$592f66aa99e3ed6d$var$currentBlock.indexOf(type)] = cloned;
            else $592f66aa99e3ed6d$var$currentBlock.push(cloned);
        }
        cloned.patchFlag |= -2;
        return cloned;
    }
    if ($592f66aa99e3ed6d$var$isClassComponent(type)) type = type.__vccOpts;
    if (props) {
        props = $592f66aa99e3ed6d$export$1f1be0e0e384d7d2(props);
        let { class: klass, style: style } = props;
        if (klass && !(0, $jQKDy.isString)(klass)) props.class = (0, $jQKDy.normalizeClass)(klass);
        if ((0, $jQKDy.isObject)(style)) {
            if ((0, $hnQzm.isProxy)(style) && !(0, $jQKDy.isArray)(style)) style = (0, $jQKDy.extend)({}, style);
            props.style = (0, $jQKDy.normalizeStyle)(style);
        }
    }
    const shapeFlag = (0, $jQKDy.isString)(type) ? 1 : $592f66aa99e3ed6d$var$isSuspense(type) ? 128 : $592f66aa99e3ed6d$var$isTeleport(type) ? 64 : (0, $jQKDy.isObject)(type) ? 4 : (0, $jQKDy.isFunction)(type) ? 2 : 0;
    return $592f66aa99e3ed6d$export$42098e0eaa15c48e(type, props, children, patchFlag, dynamicProps, shapeFlag, isBlockNode, true);
}
function $592f66aa99e3ed6d$export$1f1be0e0e384d7d2(props) {
    if (!props) return null;
    return (0, $hnQzm.isProxy)(props) || $592f66aa99e3ed6d$var$InternalObjectKey in props ? (0, $jQKDy.extend)({}, props) : props;
}
function $592f66aa99e3ed6d$export$ee4f9e12c0a92a1a(vnode, extraProps, mergeRef = false) {
    const { props: props, ref: ref, patchFlag: patchFlag, children: children } = vnode;
    const mergedProps = extraProps ? $592f66aa99e3ed6d$export$9d1611c77c2fe928(props || {}, extraProps) : props;
    const cloned = {
        __v_isVNode: true,
        __v_skip: true,
        type: vnode.type,
        props: mergedProps,
        key: mergedProps && $592f66aa99e3ed6d$var$normalizeKey(mergedProps),
        ref: extraProps && extraProps.ref ? // #2078 in the case of <component :is="vnode" ref="extra"/>
        // if the vnode itself already has a ref, cloneVNode will need to merge
        // the refs so the single vnode can be set on multiple refs
        mergeRef && ref ? (0, $jQKDy.isArray)(ref) ? ref.concat($592f66aa99e3ed6d$var$normalizeRef(extraProps)) : [
            ref,
            $592f66aa99e3ed6d$var$normalizeRef(extraProps)
        ] : $592f66aa99e3ed6d$var$normalizeRef(extraProps) : ref,
        scopeId: vnode.scopeId,
        slotScopeIds: vnode.slotScopeIds,
        children: children,
        target: vnode.target,
        targetAnchor: vnode.targetAnchor,
        staticCount: vnode.staticCount,
        shapeFlag: vnode.shapeFlag,
        // if the vnode is cloned with extra props, we can no longer assume its
        // existing patch flag to be reliable and need to add the FULL_PROPS flag.
        // note: preserve flag for fragments since they use the flag for children
        // fast paths only.
        patchFlag: extraProps && vnode.type !== $592f66aa99e3ed6d$export$ffb0004e005737fa ? patchFlag === -1 ? 16 : patchFlag | 16 : patchFlag,
        dynamicProps: vnode.dynamicProps,
        dynamicChildren: vnode.dynamicChildren,
        appContext: vnode.appContext,
        dirs: vnode.dirs,
        transition: vnode.transition,
        // These should technically only be non-null on mounted VNodes. However,
        // they *should* be copied for kept-alive vnodes. So we just always copy
        // them since them being non-null during a mount doesn't affect the logic as
        // they will simply be overwritten.
        component: vnode.component,
        suspense: vnode.suspense,
        ssContent: vnode.ssContent && $592f66aa99e3ed6d$export$ee4f9e12c0a92a1a(vnode.ssContent),
        ssFallback: vnode.ssFallback && $592f66aa99e3ed6d$export$ee4f9e12c0a92a1a(vnode.ssFallback),
        el: vnode.el,
        anchor: vnode.anchor,
        ctx: vnode.ctx,
        ce: vnode.ce
    };
    return cloned;
}
function $592f66aa99e3ed6d$var$deepCloneVNode(vnode) {
    const cloned = $592f66aa99e3ed6d$export$ee4f9e12c0a92a1a(vnode);
    if ((0, $jQKDy.isArray)(vnode.children)) cloned.children = vnode.children.map($592f66aa99e3ed6d$var$deepCloneVNode);
    return cloned;
}
function $592f66aa99e3ed6d$export$22f9b5ffd89dac9(text = " ", flag = 0) {
    return $592f66aa99e3ed6d$export$bf5c4cf060303d58($592f66aa99e3ed6d$export$5f1af8db9871e1d6, null, text, flag);
}
function $592f66aa99e3ed6d$export$33a9f6dd2840e6bb(content, numberOfNodes) {
    const vnode = $592f66aa99e3ed6d$export$bf5c4cf060303d58($592f66aa99e3ed6d$export$c1b9a1d3af45b7b6, null, content);
    vnode.staticCount = numberOfNodes;
    return vnode;
}
function $592f66aa99e3ed6d$export$49553837c7236d3c(text = "", asBlock = false) {
    return asBlock ? ($592f66aa99e3ed6d$export$e7eaa45e502fe5cc(), $592f66aa99e3ed6d$export$9f2dfe8048dfb22b($592f66aa99e3ed6d$export$4d299b491347818a, null, text)) : $592f66aa99e3ed6d$export$bf5c4cf060303d58($592f66aa99e3ed6d$export$4d299b491347818a, null, text);
}
function $592f66aa99e3ed6d$var$normalizeVNode(child) {
    if (child == null || typeof child === "boolean") return $592f66aa99e3ed6d$export$bf5c4cf060303d58($592f66aa99e3ed6d$export$4d299b491347818a);
    else if ((0, $jQKDy.isArray)(child)) return $592f66aa99e3ed6d$export$bf5c4cf060303d58($592f66aa99e3ed6d$export$ffb0004e005737fa, null, // #3666, avoid reference pollution when reusing vnode
    child.slice());
    else if (typeof child === "object") return $592f66aa99e3ed6d$var$cloneIfMounted(child);
    else return $592f66aa99e3ed6d$export$bf5c4cf060303d58($592f66aa99e3ed6d$export$5f1af8db9871e1d6, null, String(child));
}
function $592f66aa99e3ed6d$var$cloneIfMounted(child) {
    return child.el === null && child.patchFlag !== -1 || child.memo ? child : $592f66aa99e3ed6d$export$ee4f9e12c0a92a1a(child);
}
function $592f66aa99e3ed6d$var$normalizeChildren(vnode, children) {
    let type = 0;
    const { shapeFlag: shapeFlag } = vnode;
    if (children == null) children = null;
    else if ((0, $jQKDy.isArray)(children)) type = 16;
    else if (typeof children === "object") {
        if (shapeFlag & 65) {
            const slot = children.default;
            if (slot) {
                slot._c && (slot._d = false);
                $592f66aa99e3ed6d$var$normalizeChildren(vnode, slot());
                slot._c && (slot._d = true);
            }
            return;
        } else {
            type = 32;
            const slotFlag = children._;
            if (!slotFlag && !($592f66aa99e3ed6d$var$InternalObjectKey in children)) children._ctx = $592f66aa99e3ed6d$var$currentRenderingInstance;
            else if (slotFlag === 3 && $592f66aa99e3ed6d$var$currentRenderingInstance) {
                if ($592f66aa99e3ed6d$var$currentRenderingInstance.slots._ === 1) children._ = 1;
                else {
                    children._ = 2;
                    vnode.patchFlag |= 1024;
                }
            }
        }
    } else if ((0, $jQKDy.isFunction)(children)) {
        children = {
            default: children,
            _ctx: $592f66aa99e3ed6d$var$currentRenderingInstance
        };
        type = 32;
    } else {
        children = String(children);
        if (shapeFlag & 64) {
            type = 16;
            children = [
                $592f66aa99e3ed6d$export$22f9b5ffd89dac9(children)
            ];
        } else type = 8;
    }
    vnode.children = children;
    vnode.shapeFlag |= type;
}
function $592f66aa99e3ed6d$export$9d1611c77c2fe928(...args) {
    const ret = {};
    for(let i = 0; i < args.length; i++){
        const toMerge = args[i];
        for(const key in toMerge){
            if (key === "class") {
                if (ret.class !== toMerge.class) ret.class = (0, $jQKDy.normalizeClass)([
                    ret.class,
                    toMerge.class
                ]);
            } else if (key === "style") ret.style = (0, $jQKDy.normalizeStyle)([
                ret.style,
                toMerge.style
            ]);
            else if ((0, $jQKDy.isOn)(key)) {
                const existing = ret[key];
                const incoming = toMerge[key];
                if (incoming && existing !== incoming && !((0, $jQKDy.isArray)(existing) && existing.includes(incoming))) ret[key] = existing ? [].concat(existing, incoming) : incoming;
            } else if (key !== "") ret[key] = toMerge[key];
        }
    }
    return ret;
}
function $592f66aa99e3ed6d$var$invokeVNodeHook(hook, instance, vnode, prevVNode = null) {
    $592f66aa99e3ed6d$export$dae85862a8d94378(hook, instance, 7, [
        vnode,
        prevVNode
    ]);
}
const $592f66aa99e3ed6d$var$emptyAppContext = $592f66aa99e3ed6d$var$createAppContext();
let $592f66aa99e3ed6d$var$uid = 0;
function $592f66aa99e3ed6d$var$createComponentInstance(vnode, parent, suspense) {
    const type = vnode.type;
    const appContext = (parent ? parent.appContext : vnode.appContext) || $592f66aa99e3ed6d$var$emptyAppContext;
    const instance = {
        uid: $592f66aa99e3ed6d$var$uid++,
        vnode: vnode,
        type: type,
        parent: parent,
        appContext: appContext,
        root: null,
        // to be immediately set
        next: null,
        subTree: null,
        // will be set synchronously right after creation
        effect: null,
        update: null,
        // will be set synchronously right after creation
        scope: new (0, $hnQzm.EffectScope)(true),
        render: null,
        proxy: null,
        exposed: null,
        exposeProxy: null,
        withProxy: null,
        provides: parent ? parent.provides : Object.create(appContext.provides),
        accessCache: null,
        renderCache: [],
        // local resolved assets
        components: null,
        directives: null,
        // resolved props and emits options
        propsOptions: $592f66aa99e3ed6d$var$normalizePropsOptions(type, appContext),
        emitsOptions: $592f66aa99e3ed6d$var$normalizeEmitsOptions(type, appContext),
        // emit
        emit: null,
        // to be set immediately
        emitted: null,
        // props default value
        propsDefaults: (0, $jQKDy.EMPTY_OBJ),
        // inheritAttrs
        inheritAttrs: type.inheritAttrs,
        // state
        ctx: (0, $jQKDy.EMPTY_OBJ),
        data: (0, $jQKDy.EMPTY_OBJ),
        props: (0, $jQKDy.EMPTY_OBJ),
        attrs: (0, $jQKDy.EMPTY_OBJ),
        slots: (0, $jQKDy.EMPTY_OBJ),
        refs: (0, $jQKDy.EMPTY_OBJ),
        setupState: (0, $jQKDy.EMPTY_OBJ),
        setupContext: null,
        attrsProxy: null,
        slotsProxy: null,
        suspense: // suspense related
        suspense,
        suspenseId: suspense ? suspense.pendingId : 0,
        asyncDep: null,
        asyncResolved: false,
        // lifecycle hooks
        // not using enums here because it results in computed properties
        isMounted: false,
        isUnmounted: false,
        isDeactivated: false,
        bc: null,
        c: null,
        bm: null,
        m: null,
        bu: null,
        u: null,
        um: null,
        bum: null,
        da: null,
        a: null,
        rtg: null,
        rtc: null,
        ec: null,
        sp: null
    };
    instance.ctx = {
        _: instance
    };
    instance.root = parent ? parent.root : instance;
    instance.emit = $592f66aa99e3ed6d$var$emit.bind(null, instance);
    if (vnode.ce) vnode.ce(instance);
    return instance;
}
let $592f66aa99e3ed6d$var$currentInstance = null;
const $592f66aa99e3ed6d$export$f13e630aa3915748 = ()=>$592f66aa99e3ed6d$var$currentInstance || $592f66aa99e3ed6d$var$currentRenderingInstance;
let $592f66aa99e3ed6d$var$internalSetCurrentInstance;
let $592f66aa99e3ed6d$var$globalCurrentInstanceSetters;
let $592f66aa99e3ed6d$var$settersKey = "__VUE_INSTANCE_SETTERS__";
if (!($592f66aa99e3ed6d$var$globalCurrentInstanceSetters = (0, $jQKDy.getGlobalThis)()[$592f66aa99e3ed6d$var$settersKey])) $592f66aa99e3ed6d$var$globalCurrentInstanceSetters = (0, $jQKDy.getGlobalThis)()[$592f66aa99e3ed6d$var$settersKey] = [];
$592f66aa99e3ed6d$var$globalCurrentInstanceSetters.push((i)=>$592f66aa99e3ed6d$var$currentInstance = i);
$592f66aa99e3ed6d$var$internalSetCurrentInstance = (instance)=>{
    if ($592f66aa99e3ed6d$var$globalCurrentInstanceSetters.length > 1) $592f66aa99e3ed6d$var$globalCurrentInstanceSetters.forEach((s)=>s(instance));
    else $592f66aa99e3ed6d$var$globalCurrentInstanceSetters[0](instance);
};
const $592f66aa99e3ed6d$var$setCurrentInstance = (instance)=>{
    $592f66aa99e3ed6d$var$internalSetCurrentInstance(instance);
    instance.scope.on();
};
const $592f66aa99e3ed6d$var$unsetCurrentInstance = ()=>{
    $592f66aa99e3ed6d$var$currentInstance && $592f66aa99e3ed6d$var$currentInstance.scope.off();
    $592f66aa99e3ed6d$var$internalSetCurrentInstance(null);
};
const $592f66aa99e3ed6d$var$isBuiltInTag = /* @__PURE__ */ (0, $jQKDy.makeMap)("slot,component");
function $592f66aa99e3ed6d$var$validateComponentName(name, config) {
    const appIsNativeTag = config.isNativeTag || (0, $jQKDy.NO);
    if ($592f66aa99e3ed6d$var$isBuiltInTag(name) || appIsNativeTag(name)) $592f66aa99e3ed6d$export$c106dd0671a0fc2d("Do not use built-in or reserved HTML elements as component id: " + name);
}
function $592f66aa99e3ed6d$var$isStatefulComponent(instance) {
    return instance.vnode.shapeFlag & 4;
}
let $592f66aa99e3ed6d$var$isInSSRComponentSetup = false;
function $592f66aa99e3ed6d$var$setupComponent(instance, isSSR = false) {
    $592f66aa99e3ed6d$var$isInSSRComponentSetup = isSSR;
    const { props: props, children: children } = instance.vnode;
    const isStateful = $592f66aa99e3ed6d$var$isStatefulComponent(instance);
    $592f66aa99e3ed6d$var$initProps(instance, props, isStateful, isSSR);
    $592f66aa99e3ed6d$var$initSlots(instance, children);
    const setupResult = isStateful ? $592f66aa99e3ed6d$var$setupStatefulComponent(instance, isSSR) : void 0;
    $592f66aa99e3ed6d$var$isInSSRComponentSetup = false;
    return setupResult;
}
function $592f66aa99e3ed6d$var$setupStatefulComponent(instance, isSSR) {
    var _a;
    const Component = instance.type;
    instance.accessCache = /* @__PURE__ */ Object.create(null);
    instance.proxy = (0, $hnQzm.markRaw)(new Proxy(instance.ctx, $592f66aa99e3ed6d$var$PublicInstanceProxyHandlers));
    const { setup: setup } = Component;
    if (setup) {
        const setupContext = instance.setupContext = setup.length > 1 ? $592f66aa99e3ed6d$var$createSetupContext(instance) : null;
        $592f66aa99e3ed6d$var$setCurrentInstance(instance);
        (0, $hnQzm.pauseTracking)();
        const setupResult = $592f66aa99e3ed6d$export$b22fcaf88446e9bf(setup, instance, 0, [
            (0, instance.props),
            setupContext
        ]);
        (0, $hnQzm.resetTracking)();
        $592f66aa99e3ed6d$var$unsetCurrentInstance();
        if ((0, $jQKDy.isPromise)(setupResult)) {
            setupResult.then($592f66aa99e3ed6d$var$unsetCurrentInstance, $592f66aa99e3ed6d$var$unsetCurrentInstance);
            if (isSSR) return setupResult.then((resolvedResult)=>{
                $592f66aa99e3ed6d$var$handleSetupResult(instance, resolvedResult, isSSR);
            }).catch((e)=>{
                $592f66aa99e3ed6d$export$d3da1ecaf1206c58(e, instance, 0);
            });
            else instance.asyncDep = setupResult;
        } else $592f66aa99e3ed6d$var$handleSetupResult(instance, setupResult, isSSR);
    } else $592f66aa99e3ed6d$var$finishComponentSetup(instance, isSSR);
}
function $592f66aa99e3ed6d$var$handleSetupResult(instance, setupResult, isSSR) {
    if ((0, $jQKDy.isFunction)(setupResult)) {
        if (instance.type.__ssrInlineRender) instance.ssrRender = setupResult;
        else instance.render = setupResult;
    } else if ((0, $jQKDy.isObject)(setupResult)) {
        if (__VUE_PROD_DEVTOOLS__) instance.devtoolsRawSetupState = setupResult;
        instance.setupState = (0, $hnQzm.proxyRefs)(setupResult);
    }
    $592f66aa99e3ed6d$var$finishComponentSetup(instance, isSSR);
}
let $592f66aa99e3ed6d$var$compile;
let $592f66aa99e3ed6d$var$installWithProxy;
function $592f66aa99e3ed6d$export$667bb5a67822b941(_compile) {
    $592f66aa99e3ed6d$var$compile = _compile;
    $592f66aa99e3ed6d$var$installWithProxy = (i)=>{
        if (i.render._rc) i.withProxy = new Proxy(i.ctx, $592f66aa99e3ed6d$var$RuntimeCompiledPublicInstanceProxyHandlers);
    };
}
const $592f66aa99e3ed6d$export$c93a9c496c5211fa = ()=>!$592f66aa99e3ed6d$var$compile;
function $592f66aa99e3ed6d$var$finishComponentSetup(instance, isSSR, skipOptions) {
    const Component = instance.type;
    if (!instance.render) {
        if (!isSSR && $592f66aa99e3ed6d$var$compile && !Component.render) {
            const template = Component.template || $592f66aa99e3ed6d$var$resolveMergedOptions(instance).template;
            if (template) {
                const { isCustomElement: isCustomElement, compilerOptions: compilerOptions } = instance.appContext.config;
                const { delimiters: delimiters, compilerOptions: componentCompilerOptions } = Component;
                const finalCompilerOptions = (0, $jQKDy.extend)((0, $jQKDy.extend)({
                    isCustomElement: isCustomElement,
                    delimiters: delimiters
                }, compilerOptions), componentCompilerOptions);
                Component.render = $592f66aa99e3ed6d$var$compile(template, finalCompilerOptions);
            }
        }
        instance.render = Component.render || (0, $jQKDy.NOOP);
        if ($592f66aa99e3ed6d$var$installWithProxy) $592f66aa99e3ed6d$var$installWithProxy(instance);
    }
    if (__VUE_OPTIONS_API__ && true) {
        $592f66aa99e3ed6d$var$setCurrentInstance(instance);
        (0, $hnQzm.pauseTracking)();
        $592f66aa99e3ed6d$var$applyOptions(instance);
        (0, $hnQzm.resetTracking)();
        $592f66aa99e3ed6d$var$unsetCurrentInstance();
    }
}
function $592f66aa99e3ed6d$var$getAttrsProxy(instance) {
    return instance.attrsProxy || (instance.attrsProxy = new Proxy(instance.attrs, {
        get (target, key) {
            (0, $hnQzm.track)(instance, "get", "$attrs");
            return target[key];
        }
    }));
}
function $592f66aa99e3ed6d$var$getSlotsProxy(instance) {
    return instance.slotsProxy || (instance.slotsProxy = new Proxy(instance.slots, {
        get (target, key) {
            (0, $hnQzm.track)(instance, "get", "$slots");
            return target[key];
        }
    }));
}
function $592f66aa99e3ed6d$var$createSetupContext(instance) {
    const expose = (exposed)=>{
        instance.exposed = exposed || {};
    };
    var event, args;
    return {
        get attrs () {
            return $592f66aa99e3ed6d$var$getAttrsProxy(instance);
        },
        slots: instance.slots,
        emit: instance.emit,
        expose: expose
    };
}
function $592f66aa99e3ed6d$var$getExposeProxy(instance) {
    if (instance.exposed) return instance.exposeProxy || (instance.exposeProxy = new Proxy((0, $hnQzm.proxyRefs)((0, $hnQzm.markRaw)(instance.exposed)), {
        get (target, key) {
            if (key in target) return target[key];
            else if (key in $592f66aa99e3ed6d$var$publicPropertiesMap) return $592f66aa99e3ed6d$var$publicPropertiesMap[key](instance);
        },
        has (target, key) {
            return key in target || key in $592f66aa99e3ed6d$var$publicPropertiesMap;
        }
    }));
}
const $592f66aa99e3ed6d$var$classifyRE = /(?:^|[-_])(\w)/g;
const $592f66aa99e3ed6d$var$classify = (str)=>str.replace($592f66aa99e3ed6d$var$classifyRE, (c)=>c.toUpperCase()).replace(/[-_]/g, "");
function $592f66aa99e3ed6d$var$getComponentName(Component, includeInferred = true) {
    return (0, $jQKDy.isFunction)(Component) ? Component.displayName || Component.name : Component.name || includeInferred && Component.__name;
}
function $592f66aa99e3ed6d$var$formatComponentName(instance, Component, isRoot = false) {
    let name = $592f66aa99e3ed6d$var$getComponentName(Component);
    if (!name && Component.__file) {
        const match = Component.__file.match(/([^/\\]+)\.\w+$/);
        if (match) name = match[1];
    }
    if (!name && instance && instance.parent) {
        const inferFromRegistry = (registry)=>{
            for(const key in registry){
                if (registry[key] === Component) return key;
            }
        };
        name = inferFromRegistry(instance.components || instance.parent.type.components) || inferFromRegistry(instance.appContext.components);
    }
    return name ? $592f66aa99e3ed6d$var$classify(name) : isRoot ? `App` : `Anonymous`;
}
function $592f66aa99e3ed6d$var$isClassComponent(value1) {
    return (0, $jQKDy.isFunction)(value1) && "__vccOpts" in value1;
}
const $592f66aa99e3ed6d$export$2983e091f1a1e8e2 = (getterOrOptions, debugOptions)=>{
    return (0, $hnQzm.computed)(getterOrOptions, debugOptions, $592f66aa99e3ed6d$var$isInSSRComponentSetup);
};
function $592f66aa99e3ed6d$export$dda1d9f60106f0e9(type, propsOrChildren, children) {
    const l = arguments.length;
    if (l === 2) {
        if ((0, $jQKDy.isObject)(propsOrChildren) && !(0, $jQKDy.isArray)(propsOrChildren)) {
            if ($592f66aa99e3ed6d$export$3868d13f8734ae81(propsOrChildren)) return $592f66aa99e3ed6d$export$bf5c4cf060303d58(type, null, [
                propsOrChildren
            ]);
            return $592f66aa99e3ed6d$export$bf5c4cf060303d58(type, propsOrChildren);
        } else return $592f66aa99e3ed6d$export$bf5c4cf060303d58(type, null, propsOrChildren);
    } else {
        if (l > 3) children = Array.prototype.slice.call(arguments, 2);
        else if (l === 3 && $592f66aa99e3ed6d$export$3868d13f8734ae81(children)) children = [
            children
        ];
        return $592f66aa99e3ed6d$export$bf5c4cf060303d58(type, propsOrChildren, children);
    }
}
const $592f66aa99e3ed6d$export$f2549a27e18acf2d = Symbol.for("v-scx");
const $592f66aa99e3ed6d$export$6b1c54dc4befcda = ()=>{
    {
        const ctx = $592f66aa99e3ed6d$export$a976684a0efeb93f($592f66aa99e3ed6d$export$f2549a27e18acf2d);
        ctx;
        return ctx;
    }
};
function $592f66aa99e3ed6d$var$isShallow(value1) {
    return !!(value1 && value1["__v_isShallow"]);
}
function $592f66aa99e3ed6d$export$aed4979be6a60047() {
    return;
    function formatInstance(instance) {
        const blocks = [];
        if (instance.type.props && instance.props) blocks.push(createInstanceBlock("props", (0, $hnQzm.toRaw)(instance.props)));
        if (instance.setupState !== (0, $jQKDy.EMPTY_OBJ)) blocks.push(createInstanceBlock("setup", instance.setupState));
        if (instance.data !== (0, $jQKDy.EMPTY_OBJ)) blocks.push(createInstanceBlock("data", (0, $hnQzm.toRaw)(instance.data)));
        const computed = extractKeys(instance, "computed");
        if (computed) blocks.push(createInstanceBlock("computed", computed));
        const injected = extractKeys(instance, "inject");
        if (injected) blocks.push(createInstanceBlock("injected", injected));
        blocks.push([
            "div",
            {},
            [
                "span",
                {
                    style: keywordStyle.style + ";opacity:0.66"
                },
                "$ (internal): "
            ],
            [
                "object",
                {
                    object: instance
                }
            ]
        ]);
        return blocks;
    }
    function createInstanceBlock(type, target) {
        target = (0, $jQKDy.extend)({}, target);
        if (!Object.keys(target).length) return [
            "span",
            {}
        ];
        return [
            "div",
            {
                style: "line-height:1.25em;margin-bottom:0.6em"
            },
            [
                "div",
                {
                    style: "color:#476582"
                },
                type
            ],
            [
                "div",
                {
                    style: "padding-left:1.25em"
                },
                ...Object.keys(target).map((key)=>{
                    return [
                        "div",
                        {},
                        [
                            "span",
                            keywordStyle,
                            key + ": "
                        ],
                        formatValue(target[key], false)
                    ];
                })
            ]
        ];
    }
    function formatValue(v1, asRaw = true) {
        if (typeof v1 === "number") return [
            "span",
            numberStyle,
            v1
        ];
        else if (typeof v1 === "string") return [
            "span",
            stringStyle,
            JSON.stringify(v1)
        ];
        else if (typeof v1 === "boolean") return [
            "span",
            keywordStyle,
            v1
        ];
        else if ((0, $jQKDy.isObject)(v1)) return [
            "object",
            {
                object: asRaw ? (0, $hnQzm.toRaw)(v1) : v1
            }
        ];
        else return [
            "span",
            stringStyle,
            String(v1)
        ];
    }
    function extractKeys(instance, type) {
        const Comp = instance.type;
        if ((0, $jQKDy.isFunction)(Comp)) return;
        const extracted = {};
        for(const key in instance.ctx)if (isKeyOfType(Comp, key, type)) extracted[key] = instance.ctx[key];
        return extracted;
    }
    function isKeyOfType(Comp, key, type) {
        const opts = Comp[type];
        if ((0, $jQKDy.isArray)(opts) && opts.includes(key) || (0, $jQKDy.isObject)(opts) && key in opts) return true;
        if (Comp.extends && isKeyOfType(Comp.extends, key, type)) return true;
        if (Comp.mixins && Comp.mixins.some((m)=>isKeyOfType(m, key, type))) return true;
    }
    function genRefFlag(v1) {
        if ($592f66aa99e3ed6d$var$isShallow(v1)) return `ShallowRef`;
        if (v1.effect) return `ComputedRef`;
        return `Ref`;
    }
}
function $592f66aa99e3ed6d$export$2a6d714a4d738ae(memo, render, cache, index) {
    const cached = cache[index];
    if (cached && $592f66aa99e3ed6d$export$bf525184d622787c(cached, memo)) return cached;
    const ret = render();
    ret.memo = memo.slice();
    return cache[index] = ret;
}
function $592f66aa99e3ed6d$export$bf525184d622787c(cached, memo) {
    const prev = cached.memo;
    if (prev.length != memo.length) return false;
    for(let i = 0; i < prev.length; i++){
        if ((0, $jQKDy.hasChanged)(prev[i], memo[i])) return false;
    }
    if ($592f66aa99e3ed6d$var$isBlockTreeEnabled > 0 && $592f66aa99e3ed6d$var$currentBlock) $592f66aa99e3ed6d$var$currentBlock.push(cached);
    return true;
}
const $592f66aa99e3ed6d$export$83d89fbfd8236492 = "3.3.4";
const $592f66aa99e3ed6d$var$_ssrUtils = {
    createComponentInstance: $592f66aa99e3ed6d$var$createComponentInstance,
    setupComponent: $592f66aa99e3ed6d$var$setupComponent,
    renderComponentRoot: $592f66aa99e3ed6d$var$renderComponentRoot,
    setCurrentRenderingInstance: $592f66aa99e3ed6d$var$setCurrentRenderingInstance,
    isVNode: $592f66aa99e3ed6d$export$3868d13f8734ae81,
    normalizeVNode: $592f66aa99e3ed6d$var$normalizeVNode
};
const $592f66aa99e3ed6d$export$a9679033567b336d = $592f66aa99e3ed6d$var$_ssrUtils;
const $592f66aa99e3ed6d$export$83cf26e06ea620e1 = null;
const $592f66aa99e3ed6d$export$dc678eddf276286e = null;

});
parcelRequire.register("hnQzm", function(module, exports) {

$parcel$export(module.exports, "EffectScope", function () { return $ca7d5cd0cdb57e5a$export$1168ed9dbc71ddbd; });
$parcel$export(module.exports, "getCurrentScope", function () { return $ca7d5cd0cdb57e5a$export$c7be4b0125a10cba; });
$parcel$export(module.exports, "ReactiveEffect", function () { return $ca7d5cd0cdb57e5a$export$28352bb4dd362521; });
$parcel$export(module.exports, "pauseTracking", function () { return $ca7d5cd0cdb57e5a$export$938a971395fef855; });
$parcel$export(module.exports, "resetTracking", function () { return $ca7d5cd0cdb57e5a$export$c39176b1babaa8b8; });
$parcel$export(module.exports, "track", function () { return $ca7d5cd0cdb57e5a$export$6b2a7d5132615086; });
$parcel$export(module.exports, "trigger", function () { return $ca7d5cd0cdb57e5a$export$e614dc9140f7ae71; });
$parcel$export(module.exports, "toRaw", function () { return $ca7d5cd0cdb57e5a$export$ab18938b9fc5f28e; });
$parcel$export(module.exports, "isRef", function () { return $ca7d5cd0cdb57e5a$export$4f9f5282de18fc69; });
$parcel$export(module.exports, "reactive", function () { return $ca7d5cd0cdb57e5a$export$90a44edba14e47be; });
$parcel$export(module.exports, "isShallow", function () { return $ca7d5cd0cdb57e5a$export$7f3fe6025abfa26e; });
$parcel$export(module.exports, "shallowReactive", function () { return $ca7d5cd0cdb57e5a$export$8d81cefd22d22260; });
$parcel$export(module.exports, "isReactive", function () { return $ca7d5cd0cdb57e5a$export$352205f445242f02; });
$parcel$export(module.exports, "isProxy", function () { return $ca7d5cd0cdb57e5a$export$5f3ca29d057519b3; });
$parcel$export(module.exports, "markRaw", function () { return $ca7d5cd0cdb57e5a$export$995ab8b13ad7a9d0; });
$parcel$export(module.exports, "ref", function () { return $ca7d5cd0cdb57e5a$export$eff4d24c3ff7876e; });
$parcel$export(module.exports, "proxyRefs", function () { return $ca7d5cd0cdb57e5a$export$f353fd1b97db3fa0; });
$parcel$export(module.exports, "computed", function () { return $ca7d5cd0cdb57e5a$export$2983e091f1a1e8e2; });

var $jQKDy = parcelRequire("jQKDy");
function $ca7d5cd0cdb57e5a$var$warn(msg, ...args) {
    console.warn(`[Vue warn] ${msg}`, ...args);
}
let $ca7d5cd0cdb57e5a$var$activeEffectScope;
class $ca7d5cd0cdb57e5a$export$1168ed9dbc71ddbd {
    constructor(detached = false){
        this.detached = detached;
        /**
     * @internal
     */ this._active = true;
        /**
     * @internal
     */ this.effects = [];
        /**
     * @internal
     */ this.cleanups = [];
        this.parent = $ca7d5cd0cdb57e5a$var$activeEffectScope;
        if (!detached && $ca7d5cd0cdb57e5a$var$activeEffectScope) this.index = ($ca7d5cd0cdb57e5a$var$activeEffectScope.scopes || ($ca7d5cd0cdb57e5a$var$activeEffectScope.scopes = [])).push(this) - 1;
    }
    get active() {
        return this._active;
    }
    run(fn) {
        if (this._active) {
            const currentEffectScope = $ca7d5cd0cdb57e5a$var$activeEffectScope;
            try {
                $ca7d5cd0cdb57e5a$var$activeEffectScope = this;
                return fn();
            } finally{
                $ca7d5cd0cdb57e5a$var$activeEffectScope = currentEffectScope;
            }
        }
    }
    /**
   * This should only be called on non-detached scopes
   * @internal
   */ on() {
        $ca7d5cd0cdb57e5a$var$activeEffectScope = this;
    }
    /**
   * This should only be called on non-detached scopes
   * @internal
   */ off() {
        $ca7d5cd0cdb57e5a$var$activeEffectScope = this.parent;
    }
    stop(fromParent) {
        if (this._active) {
            let i, l;
            for(i = 0, l = this.effects.length; i < l; i++)this.effects[i].stop();
            for(i = 0, l = this.cleanups.length; i < l; i++)this.cleanups[i]();
            if (this.scopes) for(i = 0, l = this.scopes.length; i < l; i++)this.scopes[i].stop(true);
            if (!this.detached && this.parent && !fromParent) {
                const last = this.parent.scopes.pop();
                if (last && last !== this) {
                    this.parent.scopes[this.index] = last;
                    last.index = this.index;
                }
            }
            this.parent = void 0;
            this._active = false;
        }
    }
}
function $ca7d5cd0cdb57e5a$export$7056603ea81600be(detached) {
    return new $ca7d5cd0cdb57e5a$export$1168ed9dbc71ddbd(detached);
}
function $ca7d5cd0cdb57e5a$var$recordEffectScope(effect, scope = $ca7d5cd0cdb57e5a$var$activeEffectScope) {
    if (scope && scope.active) scope.effects.push(effect);
}
function $ca7d5cd0cdb57e5a$export$c7be4b0125a10cba() {
    return $ca7d5cd0cdb57e5a$var$activeEffectScope;
}
function $ca7d5cd0cdb57e5a$export$a780418acd4762da(fn) {
    if ($ca7d5cd0cdb57e5a$var$activeEffectScope) $ca7d5cd0cdb57e5a$var$activeEffectScope.cleanups.push(fn);
}
const $ca7d5cd0cdb57e5a$var$createDep = (effects)=>{
    const dep = new Set(effects);
    dep.w = 0;
    dep.n = 0;
    return dep;
};
const $ca7d5cd0cdb57e5a$var$wasTracked = (dep)=>(dep.w & $ca7d5cd0cdb57e5a$var$trackOpBit) > 0;
const $ca7d5cd0cdb57e5a$var$newTracked = (dep)=>(dep.n & $ca7d5cd0cdb57e5a$var$trackOpBit) > 0;
const $ca7d5cd0cdb57e5a$var$initDepMarkers = ({ deps: deps })=>{
    if (deps.length) for(let i = 0; i < deps.length; i++)deps[i].w |= $ca7d5cd0cdb57e5a$var$trackOpBit;
};
const $ca7d5cd0cdb57e5a$var$finalizeDepMarkers = (effect)=>{
    const { deps: deps } = effect;
    if (deps.length) {
        let ptr = 0;
        for(let i = 0; i < deps.length; i++){
            const dep = deps[i];
            if ($ca7d5cd0cdb57e5a$var$wasTracked(dep) && !$ca7d5cd0cdb57e5a$var$newTracked(dep)) dep.delete(effect);
            else deps[ptr++] = dep;
            dep.w &= ~$ca7d5cd0cdb57e5a$var$trackOpBit;
            dep.n &= ~$ca7d5cd0cdb57e5a$var$trackOpBit;
        }
        deps.length = ptr;
    }
};
const $ca7d5cd0cdb57e5a$var$targetMap = /* @__PURE__ */ new WeakMap();
let $ca7d5cd0cdb57e5a$var$effectTrackDepth = 0;
let $ca7d5cd0cdb57e5a$var$trackOpBit = 1;
const $ca7d5cd0cdb57e5a$var$maxMarkerBits = 30;
let $ca7d5cd0cdb57e5a$var$activeEffect;
const $ca7d5cd0cdb57e5a$export$3c41b1a4e06acc14 = Symbol("");
const $ca7d5cd0cdb57e5a$var$MAP_KEY_ITERATE_KEY = Symbol("");
class $ca7d5cd0cdb57e5a$export$28352bb4dd362521 {
    constructor(fn, scheduler = null, scope){
        this.fn = fn;
        this.scheduler = scheduler;
        this.active = true;
        this.deps = [];
        this.parent = void 0;
        $ca7d5cd0cdb57e5a$var$recordEffectScope(this, scope);
    }
    run() {
        if (!this.active) return this.fn();
        let parent = $ca7d5cd0cdb57e5a$var$activeEffect;
        let lastShouldTrack = $ca7d5cd0cdb57e5a$var$shouldTrack;
        while(parent){
            if (parent === this) return;
            parent = parent.parent;
        }
        try {
            this.parent = $ca7d5cd0cdb57e5a$var$activeEffect;
            $ca7d5cd0cdb57e5a$var$activeEffect = this;
            $ca7d5cd0cdb57e5a$var$shouldTrack = true;
            $ca7d5cd0cdb57e5a$var$trackOpBit = 1 << ++$ca7d5cd0cdb57e5a$var$effectTrackDepth;
            if ($ca7d5cd0cdb57e5a$var$effectTrackDepth <= $ca7d5cd0cdb57e5a$var$maxMarkerBits) $ca7d5cd0cdb57e5a$var$initDepMarkers(this);
            else $ca7d5cd0cdb57e5a$var$cleanupEffect(this);
            return this.fn();
        } finally{
            if ($ca7d5cd0cdb57e5a$var$effectTrackDepth <= $ca7d5cd0cdb57e5a$var$maxMarkerBits) $ca7d5cd0cdb57e5a$var$finalizeDepMarkers(this);
            $ca7d5cd0cdb57e5a$var$trackOpBit = 1 << --$ca7d5cd0cdb57e5a$var$effectTrackDepth;
            $ca7d5cd0cdb57e5a$var$activeEffect = this.parent;
            $ca7d5cd0cdb57e5a$var$shouldTrack = lastShouldTrack;
            this.parent = void 0;
            if (this.deferStop) this.stop();
        }
    }
    stop() {
        if ($ca7d5cd0cdb57e5a$var$activeEffect === this) this.deferStop = true;
        else if (this.active) {
            $ca7d5cd0cdb57e5a$var$cleanupEffect(this);
            if (this.onStop) this.onStop();
            this.active = false;
        }
    }
}
function $ca7d5cd0cdb57e5a$var$cleanupEffect(effect2) {
    const { deps: deps } = effect2;
    if (deps.length) {
        for(let i = 0; i < deps.length; i++)deps[i].delete(effect2);
        deps.length = 0;
    }
}
function $ca7d5cd0cdb57e5a$export$dc573d8a6576cdb3(fn, options) {
    if (fn.effect) fn = fn.effect.fn;
    const _effect = new $ca7d5cd0cdb57e5a$export$28352bb4dd362521(fn);
    if (options) {
        (0, $jQKDy.extend)(_effect, options);
        if (options.scope) $ca7d5cd0cdb57e5a$var$recordEffectScope(_effect, options.scope);
    }
    if (!options || !options.lazy) _effect.run();
    const runner = _effect.run.bind(_effect);
    runner.effect = _effect;
    return runner;
}
function $ca7d5cd0cdb57e5a$export$fa6813432f753b0d(runner) {
    runner.effect.stop();
}
let $ca7d5cd0cdb57e5a$var$shouldTrack = true;
const $ca7d5cd0cdb57e5a$var$trackStack = [];
function $ca7d5cd0cdb57e5a$export$938a971395fef855() {
    $ca7d5cd0cdb57e5a$var$trackStack.push($ca7d5cd0cdb57e5a$var$shouldTrack);
    $ca7d5cd0cdb57e5a$var$shouldTrack = false;
}
function $ca7d5cd0cdb57e5a$export$1f8ffc6fd33b1d16() {
    $ca7d5cd0cdb57e5a$var$trackStack.push($ca7d5cd0cdb57e5a$var$shouldTrack);
    $ca7d5cd0cdb57e5a$var$shouldTrack = true;
}
function $ca7d5cd0cdb57e5a$export$c39176b1babaa8b8() {
    const last = $ca7d5cd0cdb57e5a$var$trackStack.pop();
    $ca7d5cd0cdb57e5a$var$shouldTrack = last === void 0 ? true : last;
}
function $ca7d5cd0cdb57e5a$export$6b2a7d5132615086(target, type, key) {
    if ($ca7d5cd0cdb57e5a$var$shouldTrack && $ca7d5cd0cdb57e5a$var$activeEffect) {
        let depsMap = $ca7d5cd0cdb57e5a$var$targetMap.get(target);
        if (!depsMap) $ca7d5cd0cdb57e5a$var$targetMap.set(target, depsMap = /* @__PURE__ */ new Map());
        let dep = depsMap.get(key);
        if (!dep) depsMap.set(key, dep = $ca7d5cd0cdb57e5a$var$createDep());
        const eventInfo = void 0;
        $ca7d5cd0cdb57e5a$var$trackEffects(dep, eventInfo);
    }
}
function $ca7d5cd0cdb57e5a$var$trackEffects(dep, debuggerEventExtraInfo) {
    let shouldTrack2 = false;
    if ($ca7d5cd0cdb57e5a$var$effectTrackDepth <= $ca7d5cd0cdb57e5a$var$maxMarkerBits) {
        if (!$ca7d5cd0cdb57e5a$var$newTracked(dep)) {
            dep.n |= $ca7d5cd0cdb57e5a$var$trackOpBit;
            shouldTrack2 = !$ca7d5cd0cdb57e5a$var$wasTracked(dep);
        }
    } else shouldTrack2 = !dep.has($ca7d5cd0cdb57e5a$var$activeEffect);
    if (shouldTrack2) {
        dep.add($ca7d5cd0cdb57e5a$var$activeEffect);
        $ca7d5cd0cdb57e5a$var$activeEffect.deps.push(dep);
    }
}
function $ca7d5cd0cdb57e5a$export$e614dc9140f7ae71(target, type, key, newValue, oldValue, oldTarget) {
    const depsMap = $ca7d5cd0cdb57e5a$var$targetMap.get(target);
    if (!depsMap) return;
    let deps = [];
    if (type === "clear") deps = [
        ...depsMap.values()
    ];
    else if (key === "length" && (0, $jQKDy.isArray)(target)) {
        const newLength = Number(newValue);
        depsMap.forEach((dep, key2)=>{
            if (key2 === "length" || key2 >= newLength) deps.push(dep);
        });
    } else {
        if (key !== void 0) deps.push(depsMap.get(key));
        switch(type){
            case "add":
                if (!(0, $jQKDy.isArray)(target)) {
                    deps.push(depsMap.get($ca7d5cd0cdb57e5a$export$3c41b1a4e06acc14));
                    if ((0, $jQKDy.isMap)(target)) deps.push(depsMap.get($ca7d5cd0cdb57e5a$var$MAP_KEY_ITERATE_KEY));
                } else if ((0, $jQKDy.isIntegerKey)(key)) deps.push(depsMap.get("length"));
                break;
            case "delete":
                if (!(0, $jQKDy.isArray)(target)) {
                    deps.push(depsMap.get($ca7d5cd0cdb57e5a$export$3c41b1a4e06acc14));
                    if ((0, $jQKDy.isMap)(target)) deps.push(depsMap.get($ca7d5cd0cdb57e5a$var$MAP_KEY_ITERATE_KEY));
                }
                break;
            case "set":
                if ((0, $jQKDy.isMap)(target)) deps.push(depsMap.get($ca7d5cd0cdb57e5a$export$3c41b1a4e06acc14));
                break;
        }
    }
    const eventInfo = void 0;
    if (deps.length === 1) {
        if (deps[0]) $ca7d5cd0cdb57e5a$var$triggerEffects(deps[0]);
    } else {
        const effects = [];
        for (const dep of deps)if (dep) effects.push(...dep);
        $ca7d5cd0cdb57e5a$var$triggerEffects($ca7d5cd0cdb57e5a$var$createDep(effects));
    }
}
function $ca7d5cd0cdb57e5a$var$triggerEffects(dep, debuggerEventExtraInfo) {
    const effects = (0, $jQKDy.isArray)(dep) ? dep : [
        ...dep
    ];
    for (const effect2 of effects)if (effect2.computed) $ca7d5cd0cdb57e5a$var$triggerEffect(effect2, debuggerEventExtraInfo);
    for (const effect2 of effects)if (!effect2.computed) $ca7d5cd0cdb57e5a$var$triggerEffect(effect2, debuggerEventExtraInfo);
}
function $ca7d5cd0cdb57e5a$var$triggerEffect(effect2, debuggerEventExtraInfo) {
    if (effect2 !== $ca7d5cd0cdb57e5a$var$activeEffect || effect2.allowRecurse) {
        if (effect2.scheduler) effect2.scheduler();
        else effect2.run();
    }
}
function $ca7d5cd0cdb57e5a$var$getDepFromReactive(object, key) {
    var _a;
    return (_a = $ca7d5cd0cdb57e5a$var$targetMap.get(object)) == null ? void 0 : _a.get(key);
}
const $ca7d5cd0cdb57e5a$var$isNonTrackableKeys = /* @__PURE__ */ (0, $jQKDy.makeMap)(`__proto__,__v_isRef,__isVue`);
const $ca7d5cd0cdb57e5a$var$builtInSymbols = new Set(/* @__PURE__ */ Object.getOwnPropertyNames(Symbol).filter((key)=>key !== "arguments" && key !== "caller").map((key)=>Symbol[key]).filter((0, $jQKDy.isSymbol)));
const $ca7d5cd0cdb57e5a$var$get$1 = /* @__PURE__ */ $ca7d5cd0cdb57e5a$var$createGetter();
const $ca7d5cd0cdb57e5a$var$shallowGet = /* @__PURE__ */ $ca7d5cd0cdb57e5a$var$createGetter(false, true);
const $ca7d5cd0cdb57e5a$var$readonlyGet = /* @__PURE__ */ $ca7d5cd0cdb57e5a$var$createGetter(true);
const $ca7d5cd0cdb57e5a$var$shallowReadonlyGet = /* @__PURE__ */ $ca7d5cd0cdb57e5a$var$createGetter(true, true);
const $ca7d5cd0cdb57e5a$var$arrayInstrumentations = /* @__PURE__ */ $ca7d5cd0cdb57e5a$var$createArrayInstrumentations();
function $ca7d5cd0cdb57e5a$var$createArrayInstrumentations() {
    const instrumentations = {};
    [
        "includes",
        "indexOf",
        "lastIndexOf"
    ].forEach((key)=>{
        instrumentations[key] = function(...args) {
            const arr = $ca7d5cd0cdb57e5a$export$ab18938b9fc5f28e(this);
            for(let i = 0, l = this.length; i < l; i++)$ca7d5cd0cdb57e5a$export$6b2a7d5132615086(arr, "get", i + "");
            const res = arr[key](...args);
            if (res === -1 || res === false) return arr[key](...args.map($ca7d5cd0cdb57e5a$export$ab18938b9fc5f28e));
            else return res;
        };
    });
    [
        "push",
        "pop",
        "shift",
        "unshift",
        "splice"
    ].forEach((key)=>{
        instrumentations[key] = function(...args) {
            $ca7d5cd0cdb57e5a$export$938a971395fef855();
            const res = $ca7d5cd0cdb57e5a$export$ab18938b9fc5f28e(this)[key].apply(this, args);
            $ca7d5cd0cdb57e5a$export$c39176b1babaa8b8();
            return res;
        };
    });
    return instrumentations;
}
function $ca7d5cd0cdb57e5a$var$hasOwnProperty(key) {
    const obj = $ca7d5cd0cdb57e5a$export$ab18938b9fc5f28e(this);
    $ca7d5cd0cdb57e5a$export$6b2a7d5132615086(obj, "has", key);
    return obj.hasOwnProperty(key);
}
function $ca7d5cd0cdb57e5a$var$createGetter(isReadonly2 = false, shallow = false) {
    return function get2(target, key, receiver) {
        if (key === "__v_isReactive") return !isReadonly2;
        else if (key === "__v_isReadonly") return isReadonly2;
        else if (key === "__v_isShallow") return shallow;
        else if (key === "__v_raw" && receiver === (isReadonly2 ? shallow ? $ca7d5cd0cdb57e5a$var$shallowReadonlyMap : $ca7d5cd0cdb57e5a$var$readonlyMap : shallow ? $ca7d5cd0cdb57e5a$var$shallowReactiveMap : $ca7d5cd0cdb57e5a$var$reactiveMap).get(target)) return target;
        const targetIsArray = (0, $jQKDy.isArray)(target);
        if (!isReadonly2) {
            if (targetIsArray && (0, $jQKDy.hasOwn)($ca7d5cd0cdb57e5a$var$arrayInstrumentations, key)) return Reflect.get($ca7d5cd0cdb57e5a$var$arrayInstrumentations, key, receiver);
            if (key === "hasOwnProperty") return $ca7d5cd0cdb57e5a$var$hasOwnProperty;
        }
        const res = Reflect.get(target, key, receiver);
        if ((0, $jQKDy.isSymbol)(key) ? $ca7d5cd0cdb57e5a$var$builtInSymbols.has(key) : $ca7d5cd0cdb57e5a$var$isNonTrackableKeys(key)) return res;
        if (!isReadonly2) $ca7d5cd0cdb57e5a$export$6b2a7d5132615086(target, "get", key);
        if (shallow) return res;
        if ($ca7d5cd0cdb57e5a$export$4f9f5282de18fc69(res)) return targetIsArray && (0, $jQKDy.isIntegerKey)(key) ? res : res.value;
        if ((0, $jQKDy.isObject)(res)) return isReadonly2 ? $ca7d5cd0cdb57e5a$export$6ec456bd5b7b3c51(res) : $ca7d5cd0cdb57e5a$export$90a44edba14e47be(res);
        return res;
    };
}
const $ca7d5cd0cdb57e5a$var$set$1 = /* @__PURE__ */ $ca7d5cd0cdb57e5a$var$createSetter();
const $ca7d5cd0cdb57e5a$var$shallowSet = /* @__PURE__ */ $ca7d5cd0cdb57e5a$var$createSetter(true);
function $ca7d5cd0cdb57e5a$var$createSetter(shallow = false) {
    return function set2(target, key, value, receiver) {
        let oldValue = target[key];
        if ($ca7d5cd0cdb57e5a$export$92d09b48637741e7(oldValue) && $ca7d5cd0cdb57e5a$export$4f9f5282de18fc69(oldValue) && !$ca7d5cd0cdb57e5a$export$4f9f5282de18fc69(value)) return false;
        if (!shallow) {
            if (!$ca7d5cd0cdb57e5a$export$7f3fe6025abfa26e(value) && !$ca7d5cd0cdb57e5a$export$92d09b48637741e7(value)) {
                oldValue = $ca7d5cd0cdb57e5a$export$ab18938b9fc5f28e(oldValue);
                value = $ca7d5cd0cdb57e5a$export$ab18938b9fc5f28e(value);
            }
            if (!(0, $jQKDy.isArray)(target) && $ca7d5cd0cdb57e5a$export$4f9f5282de18fc69(oldValue) && !$ca7d5cd0cdb57e5a$export$4f9f5282de18fc69(value)) {
                oldValue.value = value;
                return true;
            }
        }
        const hadKey = (0, $jQKDy.isArray)(target) && (0, $jQKDy.isIntegerKey)(key) ? Number(key) < target.length : (0, $jQKDy.hasOwn)(target, key);
        const result = Reflect.set(target, key, value, receiver);
        if (target === $ca7d5cd0cdb57e5a$export$ab18938b9fc5f28e(receiver)) {
            if (!hadKey) $ca7d5cd0cdb57e5a$export$e614dc9140f7ae71(target, "add", key, value);
            else if ((0, $jQKDy.hasChanged)(value, oldValue)) $ca7d5cd0cdb57e5a$export$e614dc9140f7ae71(target, "set", key, value, oldValue);
        }
        return result;
    };
}
function $ca7d5cd0cdb57e5a$var$deleteProperty(target, key) {
    const hadKey = (0, $jQKDy.hasOwn)(target, key);
    const oldValue = target[key];
    const result = Reflect.deleteProperty(target, key);
    if (result && hadKey) $ca7d5cd0cdb57e5a$export$e614dc9140f7ae71(target, "delete", key, void 0, oldValue);
    return result;
}
function $ca7d5cd0cdb57e5a$var$has$1(target, key) {
    const result = Reflect.has(target, key);
    if (!(0, $jQKDy.isSymbol)(key) || !$ca7d5cd0cdb57e5a$var$builtInSymbols.has(key)) $ca7d5cd0cdb57e5a$export$6b2a7d5132615086(target, "has", key);
    return result;
}
function $ca7d5cd0cdb57e5a$var$ownKeys(target) {
    $ca7d5cd0cdb57e5a$export$6b2a7d5132615086(target, "iterate", (0, $jQKDy.isArray)(target) ? "length" : $ca7d5cd0cdb57e5a$export$3c41b1a4e06acc14);
    return Reflect.ownKeys(target);
}
const $ca7d5cd0cdb57e5a$var$mutableHandlers = {
    get: $ca7d5cd0cdb57e5a$var$get$1,
    set: $ca7d5cd0cdb57e5a$var$set$1,
    deleteProperty: $ca7d5cd0cdb57e5a$var$deleteProperty,
    has: $ca7d5cd0cdb57e5a$var$has$1,
    ownKeys: $ca7d5cd0cdb57e5a$var$ownKeys
};
const $ca7d5cd0cdb57e5a$var$readonlyHandlers = {
    get: $ca7d5cd0cdb57e5a$var$readonlyGet,
    set (target, key) {
        return true;
    },
    deleteProperty (target, key) {
        return true;
    }
};
const $ca7d5cd0cdb57e5a$var$shallowReactiveHandlers = /* @__PURE__ */ (0, $jQKDy.extend)({}, $ca7d5cd0cdb57e5a$var$mutableHandlers, {
    get: $ca7d5cd0cdb57e5a$var$shallowGet,
    set: $ca7d5cd0cdb57e5a$var$shallowSet
});
const $ca7d5cd0cdb57e5a$var$shallowReadonlyHandlers = /* @__PURE__ */ (0, $jQKDy.extend)({}, $ca7d5cd0cdb57e5a$var$readonlyHandlers, {
    get: $ca7d5cd0cdb57e5a$var$shallowReadonlyGet
});
const $ca7d5cd0cdb57e5a$var$toShallow = (value)=>value;
const $ca7d5cd0cdb57e5a$var$getProto = (v)=>Reflect.getPrototypeOf(v);
function $ca7d5cd0cdb57e5a$var$get(target, key, isReadonly = false, isShallow = false) {
    target = target["__v_raw"];
    const rawTarget = $ca7d5cd0cdb57e5a$export$ab18938b9fc5f28e(target);
    const rawKey = $ca7d5cd0cdb57e5a$export$ab18938b9fc5f28e(key);
    if (!isReadonly) {
        if (key !== rawKey) $ca7d5cd0cdb57e5a$export$6b2a7d5132615086(rawTarget, "get", key);
        $ca7d5cd0cdb57e5a$export$6b2a7d5132615086(rawTarget, "get", rawKey);
    }
    const { has: has2 } = $ca7d5cd0cdb57e5a$var$getProto(rawTarget);
    const wrap = isShallow ? $ca7d5cd0cdb57e5a$var$toShallow : isReadonly ? $ca7d5cd0cdb57e5a$var$toReadonly : $ca7d5cd0cdb57e5a$var$toReactive;
    if (has2.call(rawTarget, key)) return wrap(target.get(key));
    else if (has2.call(rawTarget, rawKey)) return wrap(target.get(rawKey));
    else if (target !== rawTarget) target.get(key);
}
function $ca7d5cd0cdb57e5a$var$has(key, isReadonly = false) {
    const target = this["__v_raw"];
    const rawTarget = $ca7d5cd0cdb57e5a$export$ab18938b9fc5f28e(target);
    const rawKey = $ca7d5cd0cdb57e5a$export$ab18938b9fc5f28e(key);
    if (!isReadonly) {
        if (key !== rawKey) $ca7d5cd0cdb57e5a$export$6b2a7d5132615086(rawTarget, "has", key);
        $ca7d5cd0cdb57e5a$export$6b2a7d5132615086(rawTarget, "has", rawKey);
    }
    return key === rawKey ? target.has(key) : target.has(key) || target.has(rawKey);
}
function $ca7d5cd0cdb57e5a$var$size(target, isReadonly = false) {
    target = target["__v_raw"];
    !isReadonly && $ca7d5cd0cdb57e5a$export$6b2a7d5132615086($ca7d5cd0cdb57e5a$export$ab18938b9fc5f28e(target), "iterate", $ca7d5cd0cdb57e5a$export$3c41b1a4e06acc14);
    return Reflect.get(target, "size", target);
}
function $ca7d5cd0cdb57e5a$var$add(value) {
    value = $ca7d5cd0cdb57e5a$export$ab18938b9fc5f28e(value);
    const target = $ca7d5cd0cdb57e5a$export$ab18938b9fc5f28e(this);
    const proto = $ca7d5cd0cdb57e5a$var$getProto(target);
    const hadKey = proto.has.call(target, value);
    if (!hadKey) {
        target.add(value);
        $ca7d5cd0cdb57e5a$export$e614dc9140f7ae71(target, "add", value, value);
    }
    return this;
}
function $ca7d5cd0cdb57e5a$var$set(key, value) {
    value = $ca7d5cd0cdb57e5a$export$ab18938b9fc5f28e(value);
    const target = $ca7d5cd0cdb57e5a$export$ab18938b9fc5f28e(this);
    const { has: has2, get: get2 } = $ca7d5cd0cdb57e5a$var$getProto(target);
    let hadKey = has2.call(target, key);
    if (!hadKey) {
        key = $ca7d5cd0cdb57e5a$export$ab18938b9fc5f28e(key);
        hadKey = has2.call(target, key);
    }
    const oldValue = get2.call(target, key);
    target.set(key, value);
    if (!hadKey) $ca7d5cd0cdb57e5a$export$e614dc9140f7ae71(target, "add", key, value);
    else if ((0, $jQKDy.hasChanged)(value, oldValue)) $ca7d5cd0cdb57e5a$export$e614dc9140f7ae71(target, "set", key, value, oldValue);
    return this;
}
function $ca7d5cd0cdb57e5a$var$deleteEntry(key) {
    const target = $ca7d5cd0cdb57e5a$export$ab18938b9fc5f28e(this);
    const { has: has2, get: get2 } = $ca7d5cd0cdb57e5a$var$getProto(target);
    let hadKey = has2.call(target, key);
    if (!hadKey) {
        key = $ca7d5cd0cdb57e5a$export$ab18938b9fc5f28e(key);
        hadKey = has2.call(target, key);
    }
    const oldValue = get2 ? get2.call(target, key) : void 0;
    const result = target.delete(key);
    if (hadKey) $ca7d5cd0cdb57e5a$export$e614dc9140f7ae71(target, "delete", key, void 0, oldValue);
    return result;
}
function $ca7d5cd0cdb57e5a$var$clear() {
    const target = $ca7d5cd0cdb57e5a$export$ab18938b9fc5f28e(this);
    const hadItems = target.size !== 0;
    const oldTarget = void 0;
    const result = target.clear();
    if (hadItems) $ca7d5cd0cdb57e5a$export$e614dc9140f7ae71(target, "clear", void 0, void 0, oldTarget);
    return result;
}
function $ca7d5cd0cdb57e5a$var$createForEach(isReadonly, isShallow) {
    return function forEach(callback, thisArg) {
        const observed = this;
        const target = observed["__v_raw"];
        const rawTarget = $ca7d5cd0cdb57e5a$export$ab18938b9fc5f28e(target);
        const wrap = isShallow ? $ca7d5cd0cdb57e5a$var$toShallow : isReadonly ? $ca7d5cd0cdb57e5a$var$toReadonly : $ca7d5cd0cdb57e5a$var$toReactive;
        !isReadonly && $ca7d5cd0cdb57e5a$export$6b2a7d5132615086(rawTarget, "iterate", $ca7d5cd0cdb57e5a$export$3c41b1a4e06acc14);
        return target.forEach((value, key)=>{
            return callback.call(thisArg, wrap(value), wrap(key), observed);
        });
    };
}
function $ca7d5cd0cdb57e5a$var$createIterableMethod(method, isReadonly, isShallow) {
    return function(...args) {
        const target = this["__v_raw"];
        const rawTarget = $ca7d5cd0cdb57e5a$export$ab18938b9fc5f28e(target);
        const targetIsMap = (0, $jQKDy.isMap)(rawTarget);
        const isPair = method === "entries" || method === Symbol.iterator && targetIsMap;
        const isKeyOnly = method === "keys" && targetIsMap;
        const innerIterator = target[method](...args);
        const wrap = isShallow ? $ca7d5cd0cdb57e5a$var$toShallow : isReadonly ? $ca7d5cd0cdb57e5a$var$toReadonly : $ca7d5cd0cdb57e5a$var$toReactive;
        !isReadonly && $ca7d5cd0cdb57e5a$export$6b2a7d5132615086(rawTarget, "iterate", isKeyOnly ? $ca7d5cd0cdb57e5a$var$MAP_KEY_ITERATE_KEY : $ca7d5cd0cdb57e5a$export$3c41b1a4e06acc14);
        return {
            // iterator protocol
            next () {
                const { value: value, done: done } = innerIterator.next();
                return done ? {
                    value: value,
                    done: done
                } : {
                    value: isPair ? [
                        wrap(value[0]),
                        wrap(value[1])
                    ] : wrap(value),
                    done: done
                };
            },
            // iterable protocol
            [Symbol.iterator] () {
                return this;
            }
        };
    };
}
function $ca7d5cd0cdb57e5a$var$createReadonlyMethod(type) {
    return function(...args) {
        return type === "delete" ? false : this;
    };
}
function $ca7d5cd0cdb57e5a$var$createInstrumentations() {
    const mutableInstrumentations2 = {
        get (key) {
            return $ca7d5cd0cdb57e5a$var$get(this, key);
        },
        get size () {
            return $ca7d5cd0cdb57e5a$var$size(this);
        },
        has: $ca7d5cd0cdb57e5a$var$has,
        add: $ca7d5cd0cdb57e5a$var$add,
        set: $ca7d5cd0cdb57e5a$var$set,
        delete: $ca7d5cd0cdb57e5a$var$deleteEntry,
        clear: $ca7d5cd0cdb57e5a$var$clear,
        forEach: $ca7d5cd0cdb57e5a$var$createForEach(false, false)
    };
    const shallowInstrumentations2 = {
        get (key) {
            return $ca7d5cd0cdb57e5a$var$get(this, key, false, true);
        },
        get size () {
            return $ca7d5cd0cdb57e5a$var$size(this);
        },
        has: $ca7d5cd0cdb57e5a$var$has,
        add: $ca7d5cd0cdb57e5a$var$add,
        set: $ca7d5cd0cdb57e5a$var$set,
        delete: $ca7d5cd0cdb57e5a$var$deleteEntry,
        clear: $ca7d5cd0cdb57e5a$var$clear,
        forEach: $ca7d5cd0cdb57e5a$var$createForEach(false, true)
    };
    const readonlyInstrumentations2 = {
        get (key) {
            return $ca7d5cd0cdb57e5a$var$get(this, key, true);
        },
        get size () {
            return $ca7d5cd0cdb57e5a$var$size(this, true);
        },
        has (key) {
            return $ca7d5cd0cdb57e5a$var$has.call(this, key, true);
        },
        add: $ca7d5cd0cdb57e5a$var$createReadonlyMethod("add"),
        set: $ca7d5cd0cdb57e5a$var$createReadonlyMethod("set"),
        delete: $ca7d5cd0cdb57e5a$var$createReadonlyMethod("delete"),
        clear: $ca7d5cd0cdb57e5a$var$createReadonlyMethod("clear"),
        forEach: $ca7d5cd0cdb57e5a$var$createForEach(true, false)
    };
    const shallowReadonlyInstrumentations2 = {
        get (key) {
            return $ca7d5cd0cdb57e5a$var$get(this, key, true, true);
        },
        get size () {
            return $ca7d5cd0cdb57e5a$var$size(this, true);
        },
        has (key) {
            return $ca7d5cd0cdb57e5a$var$has.call(this, key, true);
        },
        add: $ca7d5cd0cdb57e5a$var$createReadonlyMethod("add"),
        set: $ca7d5cd0cdb57e5a$var$createReadonlyMethod("set"),
        delete: $ca7d5cd0cdb57e5a$var$createReadonlyMethod("delete"),
        clear: $ca7d5cd0cdb57e5a$var$createReadonlyMethod("clear"),
        forEach: $ca7d5cd0cdb57e5a$var$createForEach(true, true)
    };
    const iteratorMethods = [
        "keys",
        "values",
        "entries",
        Symbol.iterator
    ];
    iteratorMethods.forEach((method)=>{
        mutableInstrumentations2[method] = $ca7d5cd0cdb57e5a$var$createIterableMethod(method, false, false);
        readonlyInstrumentations2[method] = $ca7d5cd0cdb57e5a$var$createIterableMethod(method, true, false);
        shallowInstrumentations2[method] = $ca7d5cd0cdb57e5a$var$createIterableMethod(method, false, true);
        shallowReadonlyInstrumentations2[method] = $ca7d5cd0cdb57e5a$var$createIterableMethod(method, true, true);
    });
    return [
        mutableInstrumentations2,
        readonlyInstrumentations2,
        shallowInstrumentations2,
        shallowReadonlyInstrumentations2
    ];
}
const [$ca7d5cd0cdb57e5a$var$mutableInstrumentations, $ca7d5cd0cdb57e5a$var$readonlyInstrumentations, $ca7d5cd0cdb57e5a$var$shallowInstrumentations, $ca7d5cd0cdb57e5a$var$shallowReadonlyInstrumentations] = /* @__PURE__ */ $ca7d5cd0cdb57e5a$var$createInstrumentations();
function $ca7d5cd0cdb57e5a$var$createInstrumentationGetter(isReadonly, shallow) {
    const instrumentations = shallow ? isReadonly ? $ca7d5cd0cdb57e5a$var$shallowReadonlyInstrumentations : $ca7d5cd0cdb57e5a$var$shallowInstrumentations : isReadonly ? $ca7d5cd0cdb57e5a$var$readonlyInstrumentations : $ca7d5cd0cdb57e5a$var$mutableInstrumentations;
    return (target, key, receiver)=>{
        if (key === "__v_isReactive") return !isReadonly;
        else if (key === "__v_isReadonly") return isReadonly;
        else if (key === "__v_raw") return target;
        return Reflect.get((0, $jQKDy.hasOwn)(instrumentations, key) && key in target ? instrumentations : target, key, receiver);
    };
}
const $ca7d5cd0cdb57e5a$var$mutableCollectionHandlers = {
    get: /* @__PURE__ */ $ca7d5cd0cdb57e5a$var$createInstrumentationGetter(false, false)
};
const $ca7d5cd0cdb57e5a$var$shallowCollectionHandlers = {
    get: /* @__PURE__ */ $ca7d5cd0cdb57e5a$var$createInstrumentationGetter(false, true)
};
const $ca7d5cd0cdb57e5a$var$readonlyCollectionHandlers = {
    get: /* @__PURE__ */ $ca7d5cd0cdb57e5a$var$createInstrumentationGetter(true, false)
};
const $ca7d5cd0cdb57e5a$var$shallowReadonlyCollectionHandlers = {
    get: /* @__PURE__ */ $ca7d5cd0cdb57e5a$var$createInstrumentationGetter(true, true)
};
function $ca7d5cd0cdb57e5a$var$checkIdentityKeys(target, has2, key) {
    const rawKey = $ca7d5cd0cdb57e5a$export$ab18938b9fc5f28e(key);
    if (rawKey !== key && has2.call(target, rawKey)) {
        const type = (0, $jQKDy.toRawType)(target);
        console.warn(`Reactive ${type} contains both the raw and reactive versions of the same object${type === `Map` ? ` as keys` : ``}, which can lead to inconsistencies. Avoid differentiating between the raw and reactive versions of an object and only use the reactive version if possible.`);
    }
}
const $ca7d5cd0cdb57e5a$var$reactiveMap = /* @__PURE__ */ new WeakMap();
const $ca7d5cd0cdb57e5a$var$shallowReactiveMap = /* @__PURE__ */ new WeakMap();
const $ca7d5cd0cdb57e5a$var$readonlyMap = /* @__PURE__ */ new WeakMap();
const $ca7d5cd0cdb57e5a$var$shallowReadonlyMap = /* @__PURE__ */ new WeakMap();
function $ca7d5cd0cdb57e5a$var$targetTypeMap(rawType) {
    switch(rawType){
        case "Object":
        case "Array":
            return 1 /* COMMON */ ;
        case "Map":
        case "Set":
        case "WeakMap":
        case "WeakSet":
            return 2 /* COLLECTION */ ;
        default:
            return 0 /* INVALID */ ;
    }
}
function $ca7d5cd0cdb57e5a$var$getTargetType(value) {
    return value["__v_skip"] || !Object.isExtensible(value) ? 0 /* INVALID */  : $ca7d5cd0cdb57e5a$var$targetTypeMap((0, $jQKDy.toRawType)(value));
}
function $ca7d5cd0cdb57e5a$export$90a44edba14e47be(target) {
    if ($ca7d5cd0cdb57e5a$export$92d09b48637741e7(target)) return target;
    return $ca7d5cd0cdb57e5a$var$createReactiveObject(target, false, $ca7d5cd0cdb57e5a$var$mutableHandlers, $ca7d5cd0cdb57e5a$var$mutableCollectionHandlers, $ca7d5cd0cdb57e5a$var$reactiveMap);
}
function $ca7d5cd0cdb57e5a$export$8d81cefd22d22260(target) {
    return $ca7d5cd0cdb57e5a$var$createReactiveObject(target, false, $ca7d5cd0cdb57e5a$var$shallowReactiveHandlers, $ca7d5cd0cdb57e5a$var$shallowCollectionHandlers, $ca7d5cd0cdb57e5a$var$shallowReactiveMap);
}
function $ca7d5cd0cdb57e5a$export$6ec456bd5b7b3c51(target) {
    return $ca7d5cd0cdb57e5a$var$createReactiveObject(target, true, $ca7d5cd0cdb57e5a$var$readonlyHandlers, $ca7d5cd0cdb57e5a$var$readonlyCollectionHandlers, $ca7d5cd0cdb57e5a$var$readonlyMap);
}
function $ca7d5cd0cdb57e5a$export$7c4b5f2b50f09f6b(target) {
    return $ca7d5cd0cdb57e5a$var$createReactiveObject(target, true, $ca7d5cd0cdb57e5a$var$shallowReadonlyHandlers, $ca7d5cd0cdb57e5a$var$shallowReadonlyCollectionHandlers, $ca7d5cd0cdb57e5a$var$shallowReadonlyMap);
}
function $ca7d5cd0cdb57e5a$var$createReactiveObject(target, isReadonly2, baseHandlers, collectionHandlers, proxyMap) {
    if (!(0, $jQKDy.isObject)(target)) return target;
    if (target["__v_raw"] && !(isReadonly2 && target["__v_isReactive"])) return target;
    const existingProxy = proxyMap.get(target);
    if (existingProxy) return existingProxy;
    const targetType = $ca7d5cd0cdb57e5a$var$getTargetType(target);
    if (targetType === 0 /* INVALID */ ) return target;
    const proxy = new Proxy(target, targetType === 2 /* COLLECTION */  ? collectionHandlers : baseHandlers);
    proxyMap.set(target, proxy);
    return proxy;
}
function $ca7d5cd0cdb57e5a$export$352205f445242f02(value) {
    if ($ca7d5cd0cdb57e5a$export$92d09b48637741e7(value)) return $ca7d5cd0cdb57e5a$export$352205f445242f02(value["__v_raw"]);
    return !!(value && value["__v_isReactive"]);
}
function $ca7d5cd0cdb57e5a$export$92d09b48637741e7(value) {
    return !!(value && value["__v_isReadonly"]);
}
function $ca7d5cd0cdb57e5a$export$7f3fe6025abfa26e(value) {
    return !!(value && value["__v_isShallow"]);
}
function $ca7d5cd0cdb57e5a$export$5f3ca29d057519b3(value) {
    return $ca7d5cd0cdb57e5a$export$352205f445242f02(value) || $ca7d5cd0cdb57e5a$export$92d09b48637741e7(value);
}
function $ca7d5cd0cdb57e5a$export$ab18938b9fc5f28e(observed) {
    const raw = observed && observed["__v_raw"];
    return raw ? $ca7d5cd0cdb57e5a$export$ab18938b9fc5f28e(raw) : observed;
}
function $ca7d5cd0cdb57e5a$export$995ab8b13ad7a9d0(value) {
    (0, $jQKDy.def)(value, "__v_skip", true);
    return value;
}
const $ca7d5cd0cdb57e5a$var$toReactive = (value)=>(0, $jQKDy.isObject)(value) ? $ca7d5cd0cdb57e5a$export$90a44edba14e47be(value) : value;
const $ca7d5cd0cdb57e5a$var$toReadonly = (value)=>(0, $jQKDy.isObject)(value) ? $ca7d5cd0cdb57e5a$export$6ec456bd5b7b3c51(value) : value;
function $ca7d5cd0cdb57e5a$var$trackRefValue(ref2) {
    if ($ca7d5cd0cdb57e5a$var$shouldTrack && $ca7d5cd0cdb57e5a$var$activeEffect) {
        ref2 = $ca7d5cd0cdb57e5a$export$ab18938b9fc5f28e(ref2);
        $ca7d5cd0cdb57e5a$var$trackEffects(ref2.dep || (ref2.dep = $ca7d5cd0cdb57e5a$var$createDep()));
    }
}
function $ca7d5cd0cdb57e5a$var$triggerRefValue(ref2, newVal) {
    ref2 = $ca7d5cd0cdb57e5a$export$ab18938b9fc5f28e(ref2);
    const dep = ref2.dep;
    if (dep) $ca7d5cd0cdb57e5a$var$triggerEffects(dep);
}
function $ca7d5cd0cdb57e5a$export$4f9f5282de18fc69(r) {
    return !!(r && r.__v_isRef === true);
}
function $ca7d5cd0cdb57e5a$export$eff4d24c3ff7876e(value) {
    return $ca7d5cd0cdb57e5a$var$createRef(value, false);
}
function $ca7d5cd0cdb57e5a$export$9b7bc5fe3b17c8b3(value) {
    return $ca7d5cd0cdb57e5a$var$createRef(value, true);
}
function $ca7d5cd0cdb57e5a$var$createRef(rawValue, shallow) {
    if ($ca7d5cd0cdb57e5a$export$4f9f5282de18fc69(rawValue)) return rawValue;
    return new $ca7d5cd0cdb57e5a$var$RefImpl(rawValue, shallow);
}
class $ca7d5cd0cdb57e5a$var$RefImpl {
    constructor(value, __v_isShallow){
        this.__v_isShallow = __v_isShallow;
        this.dep = void 0;
        this.__v_isRef = true;
        this._rawValue = __v_isShallow ? value : $ca7d5cd0cdb57e5a$export$ab18938b9fc5f28e(value);
        this._value = __v_isShallow ? value : $ca7d5cd0cdb57e5a$var$toReactive(value);
    }
    get value() {
        $ca7d5cd0cdb57e5a$var$trackRefValue(this);
        return this._value;
    }
    set value(newVal) {
        const useDirectValue = this.__v_isShallow || $ca7d5cd0cdb57e5a$export$7f3fe6025abfa26e(newVal) || $ca7d5cd0cdb57e5a$export$92d09b48637741e7(newVal);
        newVal = useDirectValue ? newVal : $ca7d5cd0cdb57e5a$export$ab18938b9fc5f28e(newVal);
        if ((0, $jQKDy.hasChanged)(newVal, this._rawValue)) {
            this._rawValue = newVal;
            this._value = useDirectValue ? newVal : $ca7d5cd0cdb57e5a$var$toReactive(newVal);
            $ca7d5cd0cdb57e5a$var$triggerRefValue(this, newVal);
        }
    }
}
function $ca7d5cd0cdb57e5a$export$f402f86588575ccc(ref2) {
    $ca7d5cd0cdb57e5a$var$triggerRefValue(ref2, void 0);
}
function $ca7d5cd0cdb57e5a$export$a239a76781616204(ref2) {
    return $ca7d5cd0cdb57e5a$export$4f9f5282de18fc69(ref2) ? ref2.value : ref2;
}
function $ca7d5cd0cdb57e5a$export$30bdcc2218aa9458(source) {
    return (0, $jQKDy.isFunction)(source) ? source() : $ca7d5cd0cdb57e5a$export$a239a76781616204(source);
}
const $ca7d5cd0cdb57e5a$var$shallowUnwrapHandlers = {
    get: (target, key, receiver)=>$ca7d5cd0cdb57e5a$export$a239a76781616204(Reflect.get(target, key, receiver)),
    set: (target, key, value, receiver)=>{
        const oldValue = target[key];
        if ($ca7d5cd0cdb57e5a$export$4f9f5282de18fc69(oldValue) && !$ca7d5cd0cdb57e5a$export$4f9f5282de18fc69(value)) {
            oldValue.value = value;
            return true;
        } else return Reflect.set(target, key, value, receiver);
    }
};
function $ca7d5cd0cdb57e5a$export$f353fd1b97db3fa0(objectWithRefs) {
    return $ca7d5cd0cdb57e5a$export$352205f445242f02(objectWithRefs) ? objectWithRefs : new Proxy(objectWithRefs, $ca7d5cd0cdb57e5a$var$shallowUnwrapHandlers);
}
class $ca7d5cd0cdb57e5a$var$CustomRefImpl {
    constructor(factory){
        this.dep = void 0;
        this.__v_isRef = true;
        const { get: get, set: set } = factory(()=>$ca7d5cd0cdb57e5a$var$trackRefValue(this), ()=>$ca7d5cd0cdb57e5a$var$triggerRefValue(this));
        this._get = get;
        this._set = set;
    }
    get value() {
        return this._get();
    }
    set value(newVal) {
        this._set(newVal);
    }
}
function $ca7d5cd0cdb57e5a$export$a20c2dd6199824cb(factory) {
    return new $ca7d5cd0cdb57e5a$var$CustomRefImpl(factory);
}
function $ca7d5cd0cdb57e5a$export$2e9533675e5e70e0(object) {
    const ret = (0, $jQKDy.isArray)(object) ? new Array(object.length) : {};
    for(const key in object)ret[key] = $ca7d5cd0cdb57e5a$var$propertyToRef(object, key);
    return ret;
}
class $ca7d5cd0cdb57e5a$var$ObjectRefImpl {
    constructor(_object, _key, _defaultValue){
        this._object = _object;
        this._key = _key;
        this._defaultValue = _defaultValue;
        this.__v_isRef = true;
    }
    get value() {
        const val = this._object[this._key];
        return val === void 0 ? this._defaultValue : val;
    }
    set value(newVal) {
        this._object[this._key] = newVal;
    }
    get dep() {
        return $ca7d5cd0cdb57e5a$var$getDepFromReactive($ca7d5cd0cdb57e5a$export$ab18938b9fc5f28e(this._object), this._key);
    }
}
class $ca7d5cd0cdb57e5a$var$GetterRefImpl {
    constructor(_getter){
        this._getter = _getter;
        this.__v_isRef = true;
        this.__v_isReadonly = true;
    }
    get value() {
        return this._getter();
    }
}
function $ca7d5cd0cdb57e5a$export$1f60508e4f47b4b7(source, key, defaultValue) {
    if ($ca7d5cd0cdb57e5a$export$4f9f5282de18fc69(source)) return source;
    else if ((0, $jQKDy.isFunction)(source)) return new $ca7d5cd0cdb57e5a$var$GetterRefImpl(source);
    else if ((0, $jQKDy.isObject)(source) && arguments.length > 1) return $ca7d5cd0cdb57e5a$var$propertyToRef(source, key, defaultValue);
    else return $ca7d5cd0cdb57e5a$export$eff4d24c3ff7876e(source);
}
function $ca7d5cd0cdb57e5a$var$propertyToRef(source, key, defaultValue) {
    const val = source[key];
    return $ca7d5cd0cdb57e5a$export$4f9f5282de18fc69(val) ? val : new $ca7d5cd0cdb57e5a$var$ObjectRefImpl(source, key, defaultValue);
}
class $ca7d5cd0cdb57e5a$var$ComputedRefImpl {
    constructor(getter, _setter, isReadonly, isSSR){
        this._setter = _setter;
        this.dep = void 0;
        this.__v_isRef = true;
        this["__v_isReadonly"] = false;
        this._dirty = true;
        this.effect = new $ca7d5cd0cdb57e5a$export$28352bb4dd362521(getter, ()=>{
            if (!this._dirty) {
                this._dirty = true;
                $ca7d5cd0cdb57e5a$var$triggerRefValue(this);
            }
        });
        this.effect.computed = this;
        this.effect.active = this._cacheable = !isSSR;
        this["__v_isReadonly"] = isReadonly;
    }
    get value() {
        const self = $ca7d5cd0cdb57e5a$export$ab18938b9fc5f28e(this);
        $ca7d5cd0cdb57e5a$var$trackRefValue(self);
        if (self._dirty || !self._cacheable) {
            self._dirty = false;
            self._value = self.effect.run();
        }
        return self._value;
    }
    set value(newValue) {
        this._setter(newValue);
    }
}
function $ca7d5cd0cdb57e5a$export$2983e091f1a1e8e2(getterOrOptions, debugOptions, isSSR = false) {
    let getter;
    let setter;
    const onlyGetter = (0, $jQKDy.isFunction)(getterOrOptions);
    if (onlyGetter) {
        getter = getterOrOptions;
        setter = (0, $jQKDy.NOOP);
    } else {
        getter = getterOrOptions.get;
        setter = getterOrOptions.set;
    }
    const cRef = new $ca7d5cd0cdb57e5a$var$ComputedRefImpl(getter, setter, onlyGetter || !setter, isSSR);
    return cRef;
}
const $ca7d5cd0cdb57e5a$var$tick = /* @__PURE__ */ Promise.resolve();
const $ca7d5cd0cdb57e5a$var$queue = [];
let $ca7d5cd0cdb57e5a$var$queued = false;
const $ca7d5cd0cdb57e5a$var$scheduler = (fn)=>{
    $ca7d5cd0cdb57e5a$var$queue.push(fn);
    if (!$ca7d5cd0cdb57e5a$var$queued) {
        $ca7d5cd0cdb57e5a$var$queued = true;
        $ca7d5cd0cdb57e5a$var$tick.then($ca7d5cd0cdb57e5a$var$flush);
    }
};
const $ca7d5cd0cdb57e5a$var$flush = ()=>{
    for(let i = 0; i < $ca7d5cd0cdb57e5a$var$queue.length; i++)$ca7d5cd0cdb57e5a$var$queue[i]();
    $ca7d5cd0cdb57e5a$var$queue.length = 0;
    $ca7d5cd0cdb57e5a$var$queued = false;
};
class $ca7d5cd0cdb57e5a$var$DeferredComputedRefImpl {
    constructor(getter){
        this.dep = void 0;
        this._dirty = true;
        this.__v_isRef = true;
        this["__v_isReadonly"] = true;
        let compareTarget;
        let hasCompareTarget = false;
        let scheduled = false;
        this.effect = new $ca7d5cd0cdb57e5a$export$28352bb4dd362521(getter, (computedTrigger)=>{
            if (this.dep) {
                if (computedTrigger) {
                    compareTarget = this._value;
                    hasCompareTarget = true;
                } else if (!scheduled) {
                    const valueToCompare = hasCompareTarget ? compareTarget : this._value;
                    scheduled = true;
                    hasCompareTarget = false;
                    $ca7d5cd0cdb57e5a$var$scheduler(()=>{
                        if (this.effect.active && this._get() !== valueToCompare) $ca7d5cd0cdb57e5a$var$triggerRefValue(this);
                        scheduled = false;
                    });
                }
                for (const e of this.dep)if (e.computed instanceof $ca7d5cd0cdb57e5a$var$DeferredComputedRefImpl) e.scheduler(true);
            }
            this._dirty = true;
        });
        this.effect.computed = this;
    }
    _get() {
        if (this._dirty) {
            this._dirty = false;
            return this._value = this.effect.run();
        }
        return this._value;
    }
    get value() {
        $ca7d5cd0cdb57e5a$var$trackRefValue(this);
        return $ca7d5cd0cdb57e5a$export$ab18938b9fc5f28e(this)._get();
    }
}
function $ca7d5cd0cdb57e5a$export$483264c4ec4c46ce(getter) {
    return new $ca7d5cd0cdb57e5a$var$DeferredComputedRefImpl(getter);
}

});
parcelRequire.register("jQKDy", function(module, exports) {

$parcel$export(module.exports, "makeMap", function () { return $e7370cc25155ff4d$export$b41394a5437791c8; });
$parcel$export(module.exports, "EMPTY_OBJ", function () { return $e7370cc25155ff4d$export$cf583d23ab39677c; });
$parcel$export(module.exports, "EMPTY_ARR", function () { return $e7370cc25155ff4d$export$6bd8558f433f1cc1; });
$parcel$export(module.exports, "NOOP", function () { return $e7370cc25155ff4d$export$5702a91a6f42969f; });
$parcel$export(module.exports, "NO", function () { return $e7370cc25155ff4d$export$c01351c0af048e39; });
$parcel$export(module.exports, "isOn", function () { return $e7370cc25155ff4d$export$1a2d97de39ecbb75; });
$parcel$export(module.exports, "isModelListener", function () { return $e7370cc25155ff4d$export$793aa5469768d691; });
$parcel$export(module.exports, "extend", function () { return $e7370cc25155ff4d$export$8b58be045bf06082; });
$parcel$export(module.exports, "remove", function () { return $e7370cc25155ff4d$export$cd7f480d6b8286c3; });
$parcel$export(module.exports, "hasOwn", function () { return $e7370cc25155ff4d$export$b5a638e9b3fff9f3; });
$parcel$export(module.exports, "isArray", function () { return $e7370cc25155ff4d$export$43bee75e5e14138e; });
$parcel$export(module.exports, "isMap", function () { return $e7370cc25155ff4d$export$5c90113a285f2241; });
$parcel$export(module.exports, "isSet", function () { return $e7370cc25155ff4d$export$6750766a7c7ec627; });
$parcel$export(module.exports, "isRegExp", function () { return $e7370cc25155ff4d$export$49841c62b9eff15; });
$parcel$export(module.exports, "isFunction", function () { return $e7370cc25155ff4d$export$f6e2535fb5126e54; });
$parcel$export(module.exports, "isString", function () { return $e7370cc25155ff4d$export$844ec244b1367d54; });
$parcel$export(module.exports, "isSymbol", function () { return $e7370cc25155ff4d$export$a244864fd9645c7f; });
$parcel$export(module.exports, "isObject", function () { return $e7370cc25155ff4d$export$a6cdc56e425d0d0a; });
$parcel$export(module.exports, "isPromise", function () { return $e7370cc25155ff4d$export$4369c812aac99591; });
$parcel$export(module.exports, "toRawType", function () { return $e7370cc25155ff4d$export$5ad0a3c360b8fbb5; });
$parcel$export(module.exports, "isPlainObject", function () { return $e7370cc25155ff4d$export$53b83ca8eaab0383; });
$parcel$export(module.exports, "isIntegerKey", function () { return $e7370cc25155ff4d$export$e2a2b93446ec9fe; });
$parcel$export(module.exports, "isReservedProp", function () { return $e7370cc25155ff4d$export$bf7d3c0236f0aa85; });
$parcel$export(module.exports, "isBuiltInDirective", function () { return $e7370cc25155ff4d$export$a9c1fdb3030c2a6b; });
$parcel$export(module.exports, "camelize", function () { return $e7370cc25155ff4d$export$161d051f5dd25de7; });
$parcel$export(module.exports, "hyphenate", function () { return $e7370cc25155ff4d$export$6e6a0a3676c4b8bb; });
$parcel$export(module.exports, "capitalize", function () { return $e7370cc25155ff4d$export$9a00dee1beb8f576; });
$parcel$export(module.exports, "toHandlerKey", function () { return $e7370cc25155ff4d$export$8c022799eeaaefcd; });
$parcel$export(module.exports, "hasChanged", function () { return $e7370cc25155ff4d$export$f619eb8b89076d23; });
$parcel$export(module.exports, "invokeArrayFns", function () { return $e7370cc25155ff4d$export$39951422d618a9d3; });
$parcel$export(module.exports, "def", function () { return $e7370cc25155ff4d$export$8afb76124cf08683; });
$parcel$export(module.exports, "looseToNumber", function () { return $e7370cc25155ff4d$export$d3be7195bcc2f31b; });
$parcel$export(module.exports, "toNumber", function () { return $e7370cc25155ff4d$export$a0a81dc3380ce7d3; });
$parcel$export(module.exports, "getGlobalThis", function () { return $e7370cc25155ff4d$export$ff5f2eeb11fc7e14; });
$parcel$export(module.exports, "isGloballyWhitelisted", function () { return $e7370cc25155ff4d$export$d6571a1911e4f27e; });
$parcel$export(module.exports, "normalizeStyle", function () { return $e7370cc25155ff4d$export$8756898546458274; });
$parcel$export(module.exports, "normalizeClass", function () { return $e7370cc25155ff4d$export$4f7022d2d68e2c5a; });
$parcel$export(module.exports, "isHTMLTag", function () { return $e7370cc25155ff4d$export$1ccf854a0984f890; });
$parcel$export(module.exports, "isSVGTag", function () { return $e7370cc25155ff4d$export$6328ce7565ea1049; });
$parcel$export(module.exports, "isSpecialBooleanAttr", function () { return $e7370cc25155ff4d$export$d186f5eb2e810715; });
$parcel$export(module.exports, "includeBooleanAttr", function () { return $e7370cc25155ff4d$export$e3f3cdb1390d56ce; });
$parcel$export(module.exports, "looseEqual", function () { return $e7370cc25155ff4d$export$ae8015769846262c; });
$parcel$export(module.exports, "looseIndexOf", function () { return $e7370cc25155ff4d$export$42912a80cedb8bd4; });
$parcel$export(module.exports, "toDisplayString", function () { return $e7370cc25155ff4d$export$b5b1545233b45293; });
function $e7370cc25155ff4d$export$b41394a5437791c8(str, expectsLowerCase) {
    const map = /* @__PURE__ */ Object.create(null);
    const list = str.split(",");
    for(let i = 0; i < list.length; i++)map[list[i]] = true;
    return expectsLowerCase ? (val)=>!!map[val.toLowerCase()] : (val)=>!!map[val];
}
const $e7370cc25155ff4d$export$cf583d23ab39677c = {};
const $e7370cc25155ff4d$export$6bd8558f433f1cc1 = [];
const $e7370cc25155ff4d$export$5702a91a6f42969f = ()=>{};
const $e7370cc25155ff4d$export$c01351c0af048e39 = ()=>false;
const $e7370cc25155ff4d$var$onRE = /^on[^a-z]/;
const $e7370cc25155ff4d$export$1a2d97de39ecbb75 = (key)=>$e7370cc25155ff4d$var$onRE.test(key);
const $e7370cc25155ff4d$export$793aa5469768d691 = (key)=>key.startsWith("onUpdate:");
const $e7370cc25155ff4d$export$8b58be045bf06082 = Object.assign;
const $e7370cc25155ff4d$export$cd7f480d6b8286c3 = (arr, el)=>{
    const i = arr.indexOf(el);
    if (i > -1) arr.splice(i, 1);
};
const $e7370cc25155ff4d$var$hasOwnProperty = Object.prototype.hasOwnProperty;
const $e7370cc25155ff4d$export$b5a638e9b3fff9f3 = (val, key)=>$e7370cc25155ff4d$var$hasOwnProperty.call(val, key);
const $e7370cc25155ff4d$export$43bee75e5e14138e = Array.isArray;
const $e7370cc25155ff4d$export$5c90113a285f2241 = (val)=>$e7370cc25155ff4d$export$1dccc787cc36538b(val) === "[object Map]";
const $e7370cc25155ff4d$export$6750766a7c7ec627 = (val)=>$e7370cc25155ff4d$export$1dccc787cc36538b(val) === "[object Set]";
const $e7370cc25155ff4d$export$871608497c498473 = (val)=>$e7370cc25155ff4d$export$1dccc787cc36538b(val) === "[object Date]";
const $e7370cc25155ff4d$export$49841c62b9eff15 = (val)=>$e7370cc25155ff4d$export$1dccc787cc36538b(val) === "[object RegExp]";
const $e7370cc25155ff4d$export$f6e2535fb5126e54 = (val)=>typeof val === "function";
const $e7370cc25155ff4d$export$844ec244b1367d54 = (val)=>typeof val === "string";
const $e7370cc25155ff4d$export$a244864fd9645c7f = (val)=>typeof val === "symbol";
const $e7370cc25155ff4d$export$a6cdc56e425d0d0a = (val)=>val !== null && typeof val === "object";
const $e7370cc25155ff4d$export$4369c812aac99591 = (val)=>{
    return $e7370cc25155ff4d$export$a6cdc56e425d0d0a(val) && $e7370cc25155ff4d$export$f6e2535fb5126e54(val.then) && $e7370cc25155ff4d$export$f6e2535fb5126e54(val.catch);
};
const $e7370cc25155ff4d$export$830c053460e5ddf6 = Object.prototype.toString;
const $e7370cc25155ff4d$export$1dccc787cc36538b = (value)=>$e7370cc25155ff4d$export$830c053460e5ddf6.call(value);
const $e7370cc25155ff4d$export$5ad0a3c360b8fbb5 = (value)=>{
    return $e7370cc25155ff4d$export$1dccc787cc36538b(value).slice(8, -1);
};
const $e7370cc25155ff4d$export$53b83ca8eaab0383 = (val)=>$e7370cc25155ff4d$export$1dccc787cc36538b(val) === "[object Object]";
const $e7370cc25155ff4d$export$e2a2b93446ec9fe = (key)=>$e7370cc25155ff4d$export$844ec244b1367d54(key) && key !== "NaN" && key[0] !== "-" && "" + parseInt(key, 10) === key;
const $e7370cc25155ff4d$export$bf7d3c0236f0aa85 = /* @__PURE__ */ $e7370cc25155ff4d$export$b41394a5437791c8(// the leading comma is intentional so empty string "" is also included
",key,ref,ref_for,ref_key,onVnodeBeforeMount,onVnodeMounted,onVnodeBeforeUpdate,onVnodeUpdated,onVnodeBeforeUnmount,onVnodeUnmounted");
const $e7370cc25155ff4d$export$a9c1fdb3030c2a6b = /* @__PURE__ */ $e7370cc25155ff4d$export$b41394a5437791c8("bind,cloak,else-if,else,for,html,if,model,on,once,pre,show,slot,text,memo");
const $e7370cc25155ff4d$var$cacheStringFunction = (fn)=>{
    const cache = /* @__PURE__ */ Object.create(null);
    return (str)=>{
        const hit = cache[str];
        return hit || (cache[str] = fn(str));
    };
};
const $e7370cc25155ff4d$var$camelizeRE = /-(\w)/g;
const $e7370cc25155ff4d$export$161d051f5dd25de7 = $e7370cc25155ff4d$var$cacheStringFunction((str)=>{
    return str.replace($e7370cc25155ff4d$var$camelizeRE, (_, c)=>c ? c.toUpperCase() : "");
});
const $e7370cc25155ff4d$var$hyphenateRE = /\B([A-Z])/g;
const $e7370cc25155ff4d$export$6e6a0a3676c4b8bb = $e7370cc25155ff4d$var$cacheStringFunction((str)=>str.replace($e7370cc25155ff4d$var$hyphenateRE, "-$1").toLowerCase());
const $e7370cc25155ff4d$export$9a00dee1beb8f576 = $e7370cc25155ff4d$var$cacheStringFunction((str)=>str.charAt(0).toUpperCase() + str.slice(1));
const $e7370cc25155ff4d$export$8c022799eeaaefcd = $e7370cc25155ff4d$var$cacheStringFunction((str)=>str ? `on${$e7370cc25155ff4d$export$9a00dee1beb8f576(str)}` : ``);
const $e7370cc25155ff4d$export$f619eb8b89076d23 = (value, oldValue)=>!Object.is(value, oldValue);
const $e7370cc25155ff4d$export$39951422d618a9d3 = (fns, arg)=>{
    for(let i = 0; i < fns.length; i++)fns[i](arg);
};
const $e7370cc25155ff4d$export$8afb76124cf08683 = (obj, key, value)=>{
    Object.defineProperty(obj, key, {
        configurable: true,
        enumerable: false,
        value: value
    });
};
const $e7370cc25155ff4d$export$d3be7195bcc2f31b = (val)=>{
    const n = parseFloat(val);
    return isNaN(n) ? val : n;
};
const $e7370cc25155ff4d$export$a0a81dc3380ce7d3 = (val)=>{
    const n = $e7370cc25155ff4d$export$844ec244b1367d54(val) ? Number(val) : NaN;
    return isNaN(n) ? val : n;
};
let $e7370cc25155ff4d$var$_globalThis;
const $e7370cc25155ff4d$export$ff5f2eeb11fc7e14 = ()=>{
    return $e7370cc25155ff4d$var$_globalThis || ($e7370cc25155ff4d$var$_globalThis = typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : typeof $parcel$global !== "undefined" ? $parcel$global : {});
};
const $e7370cc25155ff4d$var$identRE = /^[_$a-zA-Z\xA0-\uFFFF][_$a-zA-Z0-9\xA0-\uFFFF]*$/;
function $e7370cc25155ff4d$export$53d5e12f9a1d3cde(name) {
    return $e7370cc25155ff4d$var$identRE.test(name) ? `__props.${name}` : `__props[${JSON.stringify(name)}]`;
}
const $e7370cc25155ff4d$export$def7dc2c2e95a08a = {
    [1]: `TEXT`,
    [2]: `CLASS`,
    [4]: `STYLE`,
    [8]: `PROPS`,
    [16]: `FULL_PROPS`,
    [32]: `HYDRATE_EVENTS`,
    [64]: `STABLE_FRAGMENT`,
    [128]: `KEYED_FRAGMENT`,
    [256]: `UNKEYED_FRAGMENT`,
    [512]: `NEED_PATCH`,
    [1024]: `DYNAMIC_SLOTS`,
    [2048]: `DEV_ROOT_FRAGMENT`,
    [-1]: `HOISTED`,
    [-2]: `BAIL`
};
const $e7370cc25155ff4d$export$624972196ed3745f = {
    [1]: "STABLE",
    [2]: "DYNAMIC",
    [3]: "FORWARDED"
};
const $e7370cc25155ff4d$var$GLOBALS_WHITE_LISTED = "Infinity,undefined,NaN,isFinite,isNaN,parseFloat,parseInt,decodeURI,decodeURIComponent,encodeURI,encodeURIComponent,Math,Number,Date,Array,Object,Boolean,String,RegExp,Map,Set,JSON,Intl,BigInt,console";
const $e7370cc25155ff4d$export$d6571a1911e4f27e = /* @__PURE__ */ $e7370cc25155ff4d$export$b41394a5437791c8($e7370cc25155ff4d$var$GLOBALS_WHITE_LISTED);
const $e7370cc25155ff4d$var$range = 2;
function $e7370cc25155ff4d$export$f9c0d8b6684a279b(source, start = 0, end = source.length) {
    let lines = source.split(/(\r?\n)/);
    const newlineSequences = lines.filter((_, idx)=>idx % 2 === 1);
    lines = lines.filter((_, idx)=>idx % 2 === 0);
    let count = 0;
    const res = [];
    for(let i = 0; i < lines.length; i++){
        count += lines[i].length + (newlineSequences[i] && newlineSequences[i].length || 0);
        if (count >= start) {
            for(let j = i - $e7370cc25155ff4d$var$range; j <= i + $e7370cc25155ff4d$var$range || end > count; j++){
                if (j < 0 || j >= lines.length) continue;
                const line = j + 1;
                res.push(`${line}${" ".repeat(Math.max(3 - String(line).length, 0))}|  ${lines[j]}`);
                const lineLength = lines[j].length;
                const newLineSeqLength = newlineSequences[j] && newlineSequences[j].length || 0;
                if (j === i) {
                    const pad = start - (count - (lineLength + newLineSeqLength));
                    const length = Math.max(1, end > count ? lineLength - pad : end - start);
                    res.push(`   |  ` + " ".repeat(pad) + "^".repeat(length));
                } else if (j > i) {
                    if (end > count) {
                        const length = Math.max(Math.min(end - count, lineLength), 1);
                        res.push(`   |  ` + "^".repeat(length));
                    }
                    count += lineLength + newLineSeqLength;
                }
            }
            break;
        }
    }
    return res.join("\n");
}
function $e7370cc25155ff4d$export$8756898546458274(value) {
    if ($e7370cc25155ff4d$export$43bee75e5e14138e(value)) {
        const res = {};
        for(let i = 0; i < value.length; i++){
            const item = value[i];
            const normalized = $e7370cc25155ff4d$export$844ec244b1367d54(item) ? $e7370cc25155ff4d$export$76a205ce979d066a(item) : $e7370cc25155ff4d$export$8756898546458274(item);
            if (normalized) for(const key in normalized)res[key] = normalized[key];
        }
        return res;
    } else if ($e7370cc25155ff4d$export$844ec244b1367d54(value)) return value;
    else if ($e7370cc25155ff4d$export$a6cdc56e425d0d0a(value)) return value;
}
const $e7370cc25155ff4d$var$listDelimiterRE = /;(?![^(]*\))/g;
const $e7370cc25155ff4d$var$propertyDelimiterRE = /:([^]+)/;
const $e7370cc25155ff4d$var$styleCommentRE = /\/\*[^]*?\*\//g;
function $e7370cc25155ff4d$export$76a205ce979d066a(cssText) {
    const ret = {};
    cssText.replace($e7370cc25155ff4d$var$styleCommentRE, "").split($e7370cc25155ff4d$var$listDelimiterRE).forEach((item)=>{
        if (item) {
            const tmp = item.split($e7370cc25155ff4d$var$propertyDelimiterRE);
            tmp.length > 1 && (ret[tmp[0].trim()] = tmp[1].trim());
        }
    });
    return ret;
}
function $e7370cc25155ff4d$export$9466a5a0ee6f1479(styles) {
    let ret = "";
    if (!styles || $e7370cc25155ff4d$export$844ec244b1367d54(styles)) return ret;
    for(const key in styles){
        const value = styles[key];
        const normalizedKey = key.startsWith(`--`) ? key : $e7370cc25155ff4d$export$6e6a0a3676c4b8bb(key);
        if ($e7370cc25155ff4d$export$844ec244b1367d54(value) || typeof value === "number") ret += `${normalizedKey}:${value};`;
    }
    return ret;
}
function $e7370cc25155ff4d$export$4f7022d2d68e2c5a(value) {
    let res = "";
    if ($e7370cc25155ff4d$export$844ec244b1367d54(value)) res = value;
    else if ($e7370cc25155ff4d$export$43bee75e5e14138e(value)) for(let i = 0; i < value.length; i++){
        const normalized = $e7370cc25155ff4d$export$4f7022d2d68e2c5a(value[i]);
        if (normalized) res += normalized + " ";
    }
    else if ($e7370cc25155ff4d$export$a6cdc56e425d0d0a(value)) {
        for(const name in value)if (value[name]) res += name + " ";
    }
    return res.trim();
}
function $e7370cc25155ff4d$export$601abcd8103db5e4(props) {
    if (!props) return null;
    let { class: klass, style: style } = props;
    if (klass && !$e7370cc25155ff4d$export$844ec244b1367d54(klass)) props.class = $e7370cc25155ff4d$export$4f7022d2d68e2c5a(klass);
    if (style) props.style = $e7370cc25155ff4d$export$8756898546458274(style);
    return props;
}
const $e7370cc25155ff4d$var$HTML_TAGS = "html,body,base,head,link,meta,style,title,address,article,aside,footer,header,hgroup,h1,h2,h3,h4,h5,h6,nav,section,div,dd,dl,dt,figcaption,figure,picture,hr,img,li,main,ol,p,pre,ul,a,b,abbr,bdi,bdo,br,cite,code,data,dfn,em,i,kbd,mark,q,rp,rt,ruby,s,samp,small,span,strong,sub,sup,time,u,var,wbr,area,audio,map,track,video,embed,object,param,source,canvas,script,noscript,del,ins,caption,col,colgroup,table,thead,tbody,td,th,tr,button,datalist,fieldset,form,input,label,legend,meter,optgroup,option,output,progress,select,textarea,details,dialog,menu,summary,template,blockquote,iframe,tfoot";
const $e7370cc25155ff4d$var$SVG_TAGS = "svg,animate,animateMotion,animateTransform,circle,clipPath,color-profile,defs,desc,discard,ellipse,feBlend,feColorMatrix,feComponentTransfer,feComposite,feConvolveMatrix,feDiffuseLighting,feDisplacementMap,feDistantLight,feDropShadow,feFlood,feFuncA,feFuncB,feFuncG,feFuncR,feGaussianBlur,feImage,feMerge,feMergeNode,feMorphology,feOffset,fePointLight,feSpecularLighting,feSpotLight,feTile,feTurbulence,filter,foreignObject,g,hatch,hatchpath,image,line,linearGradient,marker,mask,mesh,meshgradient,meshpatch,meshrow,metadata,mpath,path,pattern,polygon,polyline,radialGradient,rect,set,solidcolor,stop,switch,symbol,text,textPath,title,tspan,unknown,use,view";
const $e7370cc25155ff4d$var$VOID_TAGS = "area,base,br,col,embed,hr,img,input,link,meta,param,source,track,wbr";
const $e7370cc25155ff4d$export$1ccf854a0984f890 = /* @__PURE__ */ $e7370cc25155ff4d$export$b41394a5437791c8($e7370cc25155ff4d$var$HTML_TAGS);
const $e7370cc25155ff4d$export$6328ce7565ea1049 = /* @__PURE__ */ $e7370cc25155ff4d$export$b41394a5437791c8($e7370cc25155ff4d$var$SVG_TAGS);
const $e7370cc25155ff4d$export$e5f2d3d97d9367a4 = /* @__PURE__ */ $e7370cc25155ff4d$export$b41394a5437791c8($e7370cc25155ff4d$var$VOID_TAGS);
const $e7370cc25155ff4d$var$specialBooleanAttrs = `itemscope,allowfullscreen,formnovalidate,ismap,nomodule,novalidate,readonly`;
const $e7370cc25155ff4d$export$d186f5eb2e810715 = /* @__PURE__ */ $e7370cc25155ff4d$export$b41394a5437791c8($e7370cc25155ff4d$var$specialBooleanAttrs);
const $e7370cc25155ff4d$export$f763ba3b84e9cd8c = /* @__PURE__ */ $e7370cc25155ff4d$export$b41394a5437791c8($e7370cc25155ff4d$var$specialBooleanAttrs + `,async,autofocus,autoplay,controls,default,defer,disabled,hidden,inert,loop,open,required,reversed,scoped,seamless,checked,muted,multiple,selected`);
function $e7370cc25155ff4d$export$e3f3cdb1390d56ce(value) {
    return !!value || value === "";
}
const $e7370cc25155ff4d$var$unsafeAttrCharRE = /[>/="'\u0009\u000a\u000c\u0020]/;
const $e7370cc25155ff4d$var$attrValidationCache = {};
function $e7370cc25155ff4d$export$d55ef77660f30d12(name) {
    if ($e7370cc25155ff4d$var$attrValidationCache.hasOwnProperty(name)) return $e7370cc25155ff4d$var$attrValidationCache[name];
    const isUnsafe = $e7370cc25155ff4d$var$unsafeAttrCharRE.test(name);
    if (isUnsafe) console.error(`unsafe attribute name: ${name}`);
    return $e7370cc25155ff4d$var$attrValidationCache[name] = !isUnsafe;
}
const $e7370cc25155ff4d$export$b66fd0cae8dec3c8 = {
    acceptCharset: "accept-charset",
    className: "class",
    htmlFor: "for",
    httpEquiv: "http-equiv"
};
const $e7370cc25155ff4d$export$f7e7a1cc7da8d5e9 = /* @__PURE__ */ $e7370cc25155ff4d$export$b41394a5437791c8(`accept,accept-charset,accesskey,action,align,allow,alt,async,autocapitalize,autocomplete,autofocus,autoplay,background,bgcolor,border,buffered,capture,challenge,charset,checked,cite,class,code,codebase,color,cols,colspan,content,contenteditable,contextmenu,controls,coords,crossorigin,csp,data,datetime,decoding,default,defer,dir,dirname,disabled,download,draggable,dropzone,enctype,enterkeyhint,for,form,formaction,formenctype,formmethod,formnovalidate,formtarget,headers,height,hidden,high,href,hreflang,http-equiv,icon,id,importance,inert,integrity,ismap,itemprop,keytype,kind,label,lang,language,loading,list,loop,low,manifest,max,maxlength,minlength,media,min,multiple,muted,name,novalidate,open,optimum,pattern,ping,placeholder,poster,preload,radiogroup,readonly,referrerpolicy,rel,required,reversed,rows,rowspan,sandbox,scope,scoped,selected,shape,size,sizes,slot,span,spellcheck,src,srcdoc,srclang,srcset,start,step,style,summary,tabindex,target,title,translate,type,usemap,value,width,wrap`);
const $e7370cc25155ff4d$export$80da416f43933831 = /* @__PURE__ */ $e7370cc25155ff4d$export$b41394a5437791c8(`xmlns,accent-height,accumulate,additive,alignment-baseline,alphabetic,amplitude,arabic-form,ascent,attributeName,attributeType,azimuth,baseFrequency,baseline-shift,baseProfile,bbox,begin,bias,by,calcMode,cap-height,class,clip,clipPathUnits,clip-path,clip-rule,color,color-interpolation,color-interpolation-filters,color-profile,color-rendering,contentScriptType,contentStyleType,crossorigin,cursor,cx,cy,d,decelerate,descent,diffuseConstant,direction,display,divisor,dominant-baseline,dur,dx,dy,edgeMode,elevation,enable-background,end,exponent,fill,fill-opacity,fill-rule,filter,filterRes,filterUnits,flood-color,flood-opacity,font-family,font-size,font-size-adjust,font-stretch,font-style,font-variant,font-weight,format,from,fr,fx,fy,g1,g2,glyph-name,glyph-orientation-horizontal,glyph-orientation-vertical,glyphRef,gradientTransform,gradientUnits,hanging,height,href,hreflang,horiz-adv-x,horiz-origin-x,id,ideographic,image-rendering,in,in2,intercept,k,k1,k2,k3,k4,kernelMatrix,kernelUnitLength,kerning,keyPoints,keySplines,keyTimes,lang,lengthAdjust,letter-spacing,lighting-color,limitingConeAngle,local,marker-end,marker-mid,marker-start,markerHeight,markerUnits,markerWidth,mask,maskContentUnits,maskUnits,mathematical,max,media,method,min,mode,name,numOctaves,offset,opacity,operator,order,orient,orientation,origin,overflow,overline-position,overline-thickness,panose-1,paint-order,path,pathLength,patternContentUnits,patternTransform,patternUnits,ping,pointer-events,points,pointsAtX,pointsAtY,pointsAtZ,preserveAlpha,preserveAspectRatio,primitiveUnits,r,radius,referrerPolicy,refX,refY,rel,rendering-intent,repeatCount,repeatDur,requiredExtensions,requiredFeatures,restart,result,rotate,rx,ry,scale,seed,shape-rendering,slope,spacing,specularConstant,specularExponent,speed,spreadMethod,startOffset,stdDeviation,stemh,stemv,stitchTiles,stop-color,stop-opacity,strikethrough-position,strikethrough-thickness,string,stroke,stroke-dasharray,stroke-dashoffset,stroke-linecap,stroke-linejoin,stroke-miterlimit,stroke-opacity,stroke-width,style,surfaceScale,systemLanguage,tabindex,tableValues,target,targetX,targetY,text-anchor,text-decoration,text-rendering,textLength,to,transform,transform-origin,type,u1,u2,underline-position,underline-thickness,unicode,unicode-bidi,unicode-range,units-per-em,v-alphabetic,v-hanging,v-ideographic,v-mathematical,values,vector-effect,version,vert-adv-y,vert-origin-x,vert-origin-y,viewBox,viewTarget,visibility,width,widths,word-spacing,writing-mode,x,x-height,x1,x2,xChannelSelector,xlink:actuate,xlink:arcrole,xlink:href,xlink:role,xlink:show,xlink:title,xlink:type,xml:base,xml:lang,xml:space,y,y1,y2,yChannelSelector,z,zoomAndPan`);
const $e7370cc25155ff4d$var$escapeRE = /["'&<>]/;
function $e7370cc25155ff4d$export$4cf11838cdc2a8a8(string) {
    const str = "" + string;
    const match = $e7370cc25155ff4d$var$escapeRE.exec(str);
    if (!match) return str;
    let html = "";
    let escaped;
    let index;
    let lastIndex = 0;
    for(index = match.index; index < str.length; index++){
        switch(str.charCodeAt(index)){
            case 34:
                escaped = "&quot;";
                break;
            case 38:
                escaped = "&amp;";
                break;
            case 39:
                escaped = "&#39;";
                break;
            case 60:
                escaped = "&lt;";
                break;
            case 62:
                escaped = "&gt;";
                break;
            default:
                continue;
        }
        if (lastIndex !== index) html += str.slice(lastIndex, index);
        lastIndex = index + 1;
        html += escaped;
    }
    return lastIndex !== index ? html + str.slice(lastIndex, index) : html;
}
const $e7370cc25155ff4d$var$commentStripRE = /^-?>|<!--|-->|--!>|<!-$/g;
function $e7370cc25155ff4d$export$7b105034a53bde5f(src) {
    return src.replace($e7370cc25155ff4d$var$commentStripRE, "");
}
function $e7370cc25155ff4d$var$looseCompareArrays(a, b) {
    if (a.length !== b.length) return false;
    let equal = true;
    for(let i = 0; equal && i < a.length; i++)equal = $e7370cc25155ff4d$export$ae8015769846262c(a[i], b[i]);
    return equal;
}
function $e7370cc25155ff4d$export$ae8015769846262c(a, b) {
    if (a === b) return true;
    let aValidType = $e7370cc25155ff4d$export$871608497c498473(a);
    let bValidType = $e7370cc25155ff4d$export$871608497c498473(b);
    if (aValidType || bValidType) return aValidType && bValidType ? a.getTime() === b.getTime() : false;
    aValidType = $e7370cc25155ff4d$export$a244864fd9645c7f(a);
    bValidType = $e7370cc25155ff4d$export$a244864fd9645c7f(b);
    if (aValidType || bValidType) return a === b;
    aValidType = $e7370cc25155ff4d$export$43bee75e5e14138e(a);
    bValidType = $e7370cc25155ff4d$export$43bee75e5e14138e(b);
    if (aValidType || bValidType) return aValidType && bValidType ? $e7370cc25155ff4d$var$looseCompareArrays(a, b) : false;
    aValidType = $e7370cc25155ff4d$export$a6cdc56e425d0d0a(a);
    bValidType = $e7370cc25155ff4d$export$a6cdc56e425d0d0a(b);
    if (aValidType || bValidType) {
        if (!aValidType || !bValidType) return false;
        const aKeysCount = Object.keys(a).length;
        const bKeysCount = Object.keys(b).length;
        if (aKeysCount !== bKeysCount) return false;
        for(const key in a){
            const aHasKey = a.hasOwnProperty(key);
            const bHasKey = b.hasOwnProperty(key);
            if (aHasKey && !bHasKey || !aHasKey && bHasKey || !$e7370cc25155ff4d$export$ae8015769846262c(a[key], b[key])) return false;
        }
    }
    return String(a) === String(b);
}
function $e7370cc25155ff4d$export$42912a80cedb8bd4(arr, val) {
    return arr.findIndex((item)=>$e7370cc25155ff4d$export$ae8015769846262c(item, val));
}
const $e7370cc25155ff4d$export$b5b1545233b45293 = (val)=>{
    return $e7370cc25155ff4d$export$844ec244b1367d54(val) ? val : val == null ? "" : $e7370cc25155ff4d$export$43bee75e5e14138e(val) || $e7370cc25155ff4d$export$a6cdc56e425d0d0a(val) && (val.toString === $e7370cc25155ff4d$export$830c053460e5ddf6 || !$e7370cc25155ff4d$export$f6e2535fb5126e54(val.toString)) ? JSON.stringify(val, $e7370cc25155ff4d$var$replacer, 2) : String(val);
};
const $e7370cc25155ff4d$var$replacer = (_key, val)=>{
    if (val && val.__v_isRef) return $e7370cc25155ff4d$var$replacer(_key, val.value);
    else if ($e7370cc25155ff4d$export$5c90113a285f2241(val)) return {
        [`Map(${val.size})`]: [
            ...val.entries()
        ].reduce((entries, [key, val2])=>{
            entries[`${key} =>`] = val2;
            return entries;
        }, {})
    };
    else if ($e7370cc25155ff4d$export$6750766a7c7ec627(val)) return {
        [`Set(${val.size})`]: [
            ...val.values()
        ]
    };
    else if ($e7370cc25155ff4d$export$a6cdc56e425d0d0a(val) && !$e7370cc25155ff4d$export$43bee75e5e14138e(val) && !$e7370cc25155ff4d$export$53b83ca8eaab0383(val)) return String(val);
    return val;
};

});






parcelRequire.register("lSY2z", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $feed36ec45236e81$export$2e2bcd8739ae039; });
let $feed36ec45236e81$var$NOOP = ()=>{};
var $feed36ec45236e81$export$2e2bcd8739ae039 = (script)=>{};

});

// base.js
//
// All Javascript and CSS common to all pages including the public site, dashboard, but not the admin.
// Import all Sass/CSS files to be compiled into base.css

document.addEventListener("DOMContentLoaded", function() {
    // Get all elements with class "auto-close"
    const autoCloseElements = document.querySelectorAll(".alert-autoclose");
    // Define a function to handle the fading and sliding animation
    function fadeAndSlide(element) {
        const fadeDuration = 500;
        const slideDuration = 500;
        // Step 1: Fade out the element
        let opacity = 1;
        const fadeInterval = setInterval(function() {
            if (opacity > 0) {
                opacity -= 0.1;
                element.style.opacity = opacity;
            } else {
                clearInterval(fadeInterval);
                // Step 2: Slide up the element
                let height = element.offsetHeight;
                const slideInterval = setInterval(function() {
                    if (height > 0) {
                        height -= 10;
                        element.style.height = height + "px";
                    } else {
                        clearInterval(slideInterval);
                        // Step 3: Remove the element from the DOM
                        if (element.parentNode) element.parentNode.removeChild(element);
                    }
                }, slideDuration / 10);
            }
        }, fadeDuration / 10);
    }
    // Set a timeout to execute the animation after 5000 milliseconds (5 seconds)
    setTimeout(function() {
        autoCloseElements.forEach(function(element) {
            fadeAndSlide(element);
        });
    }, 10000);
});


document.addEventListener("DOMContentLoaded", function() {
    // Password field toggler
    const passwordTogglers = document.querySelectorAll(".password-field__toggle");
    passwordTogglers.forEach((toggler)=>{
        toggler.addEventListener("change", ()=>{
            const passwordField = toggler.closest(".password-field");
            const passwordInput = passwordField.querySelector("input.password-field__input");
            passwordInput.type = toggler.checked ? "text" : "password";
        });
    });
    // Show passphrase
    const showPassphraseButton = document.getElementById("js-show-passphrase");
    const passphrase = document.getElementById("customer-network-passphrase");
    if (showPassphraseButton && passphrase) showPassphraseButton.addEventListener("click", ()=>{
        passphrase.innerHTML = "<pre class='m-0 pt-1'>" + passphrase.dataset.passphrase + "</pre>";
    });
    // Prevent double submit
    function disable_buttons(form, message) {
        const buttons = document.querySelectorAll('button[type="submit"], input[type="submit"]');
        for (const button of buttons){
            button.disabled = true;
            if (message) button.innerHTML = message;
        }
    }
    const disableForms = document.querySelectorAll(".js-prevent-double-submit");
    for (const form of disableForms){
        const message = form.dataset.message;
        let submitTimer;
        form.addEventListener("submit", function(e) {
            e.preventDefault();
            disable_buttons(this, message);
            if (submitTimer) clearTimeout(submitTimer);
            submitTimer = setTimeout(()=>{
                this.submit();
            }, 0);
        });
    }
});


// Create an infinite marquee of elements that scrolls right to left. The containing div should be set to
// `display: flex` on a row axis with`overflow: hidden`. Each child element should be sized in such a way that they
// are bigger than the container, such as making their width a percentage of the container.
//
// Usage:
//
//      <div data-marquee data-marquee-speed="0.25" data-marquee-repeat="-1" data-marquee-reversed="true">
//
// data-marquee-speed: The speed of the marquee. Default 1, which travels ~100 pixels per second.
// data-marquee-repeat: Number of times to repeat. Default: -1 (infinite)
// data-marquee-reversed: If the animation should be reversed, or left to right. Default: false
function $3e8f3adb9623a584$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $3e8f3adb9623a584$var$_inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
}
/*!
 * GSAP 3.12.2
 * https://greensock.com
 *
 * @license Copyright 2008-2023, GreenSock. All rights reserved.
 * Subject to the terms at https://greensock.com/standard-license or for
 * Club GreenSock members, the agreement issued with that membership.
 * @author: Jack Doyle, jack@greensock.com
*/ /* eslint-disable */ var $3e8f3adb9623a584$export$4922bee768729a77 = {
    autoSleep: 120,
    force3D: "auto",
    nullTargetWarn: 1,
    units: {
        lineHeight: ""
    }
}, $3e8f3adb9623a584$var$_defaults = {
    duration: .5,
    overwrite: false,
    delay: 0
}, $3e8f3adb9623a584$var$_suppressOverwrites, $3e8f3adb9623a584$var$_reverting, $3e8f3adb9623a584$var$_context, $3e8f3adb9623a584$var$_bigNum = 1e8, $3e8f3adb9623a584$var$_tinyNum = 1 / $3e8f3adb9623a584$var$_bigNum, $3e8f3adb9623a584$var$_2PI = Math.PI * 2, $3e8f3adb9623a584$var$_HALF_PI = $3e8f3adb9623a584$var$_2PI / 4, $3e8f3adb9623a584$var$_gsID = 0, $3e8f3adb9623a584$var$_sqrt = Math.sqrt, $3e8f3adb9623a584$var$_cos = Math.cos, $3e8f3adb9623a584$var$_sin = Math.sin, $3e8f3adb9623a584$export$f664476fd67145ca = function _isString(value) {
    return typeof value === "string";
}, $3e8f3adb9623a584$var$_isFunction = function _isFunction(value) {
    return typeof value === "function";
}, $3e8f3adb9623a584$var$_isNumber = function _isNumber(value) {
    return typeof value === "number";
}, $3e8f3adb9623a584$export$a8178c063a9fd3a1 = function _isUndefined(value) {
    return typeof value === "undefined";
}, $3e8f3adb9623a584$var$_isObject = function _isObject(value) {
    return typeof value === "object";
}, $3e8f3adb9623a584$var$_isNotFalse = function _isNotFalse(value) {
    return value !== false;
}, $3e8f3adb9623a584$var$_windowExists = function _windowExists() {
    return typeof window !== "undefined";
}, $3e8f3adb9623a584$var$_isFuncOrString = function _isFuncOrString(value) {
    return $3e8f3adb9623a584$var$_isFunction(value) || $3e8f3adb9623a584$export$f664476fd67145ca(value);
}, $3e8f3adb9623a584$var$_isTypedArray = typeof ArrayBuffer === "function" && ArrayBuffer.isView || function() {}, // note: IE10 has ArrayBuffer, but NOT ArrayBuffer.isView().
$3e8f3adb9623a584$var$_isArray = Array.isArray, $3e8f3adb9623a584$var$_strictNumExp = /(?:-?\.?\d|\.)+/gi, //only numbers (including negatives and decimals) but NOT relative values.
$3e8f3adb9623a584$export$b9d44bb6523120d6 = /[-+=.]*\d+[.e\-+]*\d*[e\-+]*\d*/g, //finds any numbers, including ones that start with += or -=, negative numbers, and ones in scientific notation like 1e-8.
$3e8f3adb9623a584$export$65c88bbd597e7b0a = /[-+=.]*\d+[.e-]*\d*[a-z%]*/g, $3e8f3adb9623a584$var$_complexStringNumExp = /[-+=.]*\d+\.?\d*(?:e-|e\+)?\d*/gi, //duplicate so that while we're looping through matches from exec(), it doesn't contaminate the lastIndex of _numExp which we use to search for colors too.
$3e8f3adb9623a584$export$5a680e28b0b61bc = /[+-]=-?[.\d]+/, $3e8f3adb9623a584$var$_delimitedValueExp = /[^,'"\[\]\s]+/gi, // previously /[#\-+.]*\b[a-z\d\-=+%.]+/gi but didn't catch special characters.
$3e8f3adb9623a584$var$_unitExp = /^[+\-=e\s\d]*\d+[.\d]*([a-z]*|%)\s*$/i, $3e8f3adb9623a584$var$_globalTimeline, $3e8f3adb9623a584$var$_win, $3e8f3adb9623a584$var$_coreInitted, $3e8f3adb9623a584$var$_doc, $3e8f3adb9623a584$var$_globals = {}, $3e8f3adb9623a584$var$_installScope = {}, $3e8f3adb9623a584$var$_coreReady, $3e8f3adb9623a584$var$_install = function _install(scope) {
    return ($3e8f3adb9623a584$var$_installScope = $3e8f3adb9623a584$var$_merge(scope, $3e8f3adb9623a584$var$_globals)) && $3e8f3adb9623a584$export$99ee26438460406a;
}, $3e8f3adb9623a584$export$7fb54635790b59a5 = function _missingPlugin(property, value) {
    return console.warn("Invalid property", property, "set to", value, "Missing plugin? gsap.registerPlugin()");
}, $3e8f3adb9623a584$var$_warn = function _warn(message, suppress) {
    return !suppress && console.warn(message);
}, $3e8f3adb9623a584$var$_addGlobal = function _addGlobal(name, obj) {
    return name && ($3e8f3adb9623a584$var$_globals[name] = obj) && $3e8f3adb9623a584$var$_installScope && ($3e8f3adb9623a584$var$_installScope[name] = obj) || $3e8f3adb9623a584$var$_globals;
}, $3e8f3adb9623a584$var$_emptyFunc = function _emptyFunc() {
    return 0;
}, $3e8f3adb9623a584$var$_startAtRevertConfig = {
    suppressEvents: true,
    isStart: true,
    kill: false
}, $3e8f3adb9623a584$var$_revertConfigNoKill = {
    suppressEvents: true,
    kill: false
}, $3e8f3adb9623a584$var$_revertConfig = {
    suppressEvents: true
}, $3e8f3adb9623a584$var$_reservedProps = {}, $3e8f3adb9623a584$var$_lazyTweens = [], $3e8f3adb9623a584$var$_lazyLookup = {}, $3e8f3adb9623a584$var$_lastRenderedFrame, $3e8f3adb9623a584$export$d305d8ec5d7c26b8 = {}, $3e8f3adb9623a584$var$_effects = {}, $3e8f3adb9623a584$var$_nextGCFrame = 30, $3e8f3adb9623a584$var$_harnessPlugins = [], $3e8f3adb9623a584$var$_callbackNames = "", $3e8f3adb9623a584$var$_harness = function _harness(targets) {
    var target = targets[0], harnessPlugin, i;
    $3e8f3adb9623a584$var$_isObject(target) || $3e8f3adb9623a584$var$_isFunction(target) || (targets = [
        targets
    ]);
    if (!(harnessPlugin = (target._gsap || {}).harness)) {
        // find the first target with a harness. We assume targets passed into an animation will be of similar type, meaning the same kind of harness can be used for them all (performance optimization)
        i = $3e8f3adb9623a584$var$_harnessPlugins.length;
        while(i-- && !$3e8f3adb9623a584$var$_harnessPlugins[i].targetTest(target));
        harnessPlugin = $3e8f3adb9623a584$var$_harnessPlugins[i];
    }
    i = targets.length;
    while(i--)targets[i] && (targets[i]._gsap || (targets[i]._gsap = new $3e8f3adb9623a584$export$cf10981d5419cad5(targets[i], harnessPlugin))) || targets.splice(i, 1);
    return targets;
}, $3e8f3adb9623a584$export$8b9be379d2de2a39 = function _getCache(target) {
    return target._gsap || $3e8f3adb9623a584$var$_harness($3e8f3adb9623a584$export$45b10814cc054894(target))[0]._gsap;
}, $3e8f3adb9623a584$export$51d6bbe898aef1f9 = function _getProperty(target, property, v) {
    return (v = target[property]) && $3e8f3adb9623a584$var$_isFunction(v) ? target[property]() : $3e8f3adb9623a584$export$a8178c063a9fd3a1(v) && target.getAttribute && target.getAttribute(property) || v;
}, $3e8f3adb9623a584$export$f9000b814859f126 = function _forEachName(names, func) {
    return (names = names.split(",")).forEach(func) || names;
}, //split a comma-delimited list of names into an array, then run a forEach() function and return the split array (this is just a way to consolidate/shorten some code).
$3e8f3adb9623a584$export$9c8d725d65e13f94 = function _round(value) {
    return Math.round(value * 100000) / 100000 || 0;
}, $3e8f3adb9623a584$var$_roundPrecise = function _roundPrecise(value) {
    return Math.round(value * 10000000) / 10000000 || 0;
}, // increased precision mostly for timing values.
$3e8f3adb9623a584$export$dac762bc6301b560 = function _parseRelative(start, value) {
    var operator = value.charAt(0), end = parseFloat(value.substr(2));
    start = parseFloat(start);
    return operator === "+" ? start + end : operator === "-" ? start - end : operator === "*" ? start * end : start / end;
}, $3e8f3adb9623a584$var$_arrayContainsAny = function _arrayContainsAny(toSearch, toFind) {
    //searches one array to find matches for any of the items in the toFind array. As soon as one is found, it returns true. It does NOT return all the matches; it's simply a boolean search.
    var l = toFind.length, i = 0;
    for(; toSearch.indexOf(toFind[i]) < 0 && ++i < l;);
    return i < l;
}, $3e8f3adb9623a584$var$_lazyRender = function _lazyRender() {
    var l = $3e8f3adb9623a584$var$_lazyTweens.length, a = $3e8f3adb9623a584$var$_lazyTweens.slice(0), i, tween;
    $3e8f3adb9623a584$var$_lazyLookup = {};
    $3e8f3adb9623a584$var$_lazyTweens.length = 0;
    for(i = 0; i < l; i++){
        tween = a[i];
        tween && tween._lazy && (tween.render(tween._lazy[0], tween._lazy[1], true)._lazy = 0);
    }
}, $3e8f3adb9623a584$var$_lazySafeRender = function _lazySafeRender(animation, time, suppressEvents, force) {
    $3e8f3adb9623a584$var$_lazyTweens.length && !$3e8f3adb9623a584$var$_reverting && $3e8f3adb9623a584$var$_lazyRender();
    animation.render(time, suppressEvents, force || $3e8f3adb9623a584$var$_reverting && time < 0 && (animation._initted || animation._startAt));
    $3e8f3adb9623a584$var$_lazyTweens.length && !$3e8f3adb9623a584$var$_reverting && $3e8f3adb9623a584$var$_lazyRender(); //in case rendering caused any tweens to lazy-init, we should render them because typically when someone calls seek() or time() or progress(), they expect an immediate render.
}, $3e8f3adb9623a584$var$_numericIfPossible = function _numericIfPossible(value) {
    var n = parseFloat(value);
    return (n || n === 0) && (value + "").match($3e8f3adb9623a584$var$_delimitedValueExp).length < 2 ? n : $3e8f3adb9623a584$export$f664476fd67145ca(value) ? value.trim() : value;
}, $3e8f3adb9623a584$var$_passThrough = function _passThrough(p) {
    return p;
}, $3e8f3adb9623a584$export$dc2b19673bb53610 = function _setDefaults(obj, defaults) {
    for(var p in defaults)p in obj || (obj[p] = defaults[p]);
    return obj;
}, $3e8f3adb9623a584$var$_setKeyframeDefaults = function _setKeyframeDefaults(excludeDuration) {
    return function(obj, defaults) {
        for(var p in defaults)p in obj || p === "duration" && excludeDuration || p === "ease" || (obj[p] = defaults[p]);
    };
}, $3e8f3adb9623a584$var$_merge = function _merge(base, toMerge) {
    for(var p in toMerge)base[p] = toMerge[p];
    return base;
}, $3e8f3adb9623a584$var$_mergeDeep = function _mergeDeep(base, toMerge) {
    for(var p in toMerge)p !== "__proto__" && p !== "constructor" && p !== "prototype" && (base[p] = $3e8f3adb9623a584$var$_isObject(toMerge[p]) ? _mergeDeep(base[p] || (base[p] = {}), toMerge[p]) : toMerge[p]);
    return base;
}, $3e8f3adb9623a584$var$_copyExcluding = function _copyExcluding(obj, excluding) {
    var copy = {}, p;
    for(p in obj)p in excluding || (copy[p] = obj[p]);
    return copy;
}, $3e8f3adb9623a584$var$_inheritDefaults = function _inheritDefaults(vars) {
    var parent = vars.parent || $3e8f3adb9623a584$var$_globalTimeline, func = vars.keyframes ? $3e8f3adb9623a584$var$_setKeyframeDefaults($3e8f3adb9623a584$var$_isArray(vars.keyframes)) : $3e8f3adb9623a584$export$dc2b19673bb53610;
    if ($3e8f3adb9623a584$var$_isNotFalse(vars.inherit)) while(parent){
        func(vars, parent.vars.defaults);
        parent = parent.parent || parent._dp;
    }
    return vars;
}, $3e8f3adb9623a584$var$_arraysMatch = function _arraysMatch(a1, a2) {
    var i = a1.length, match = i === a2.length;
    while(match && i-- && a1[i] === a2[i]);
    return i < 0;
}, $3e8f3adb9623a584$var$_addLinkedListItem = function _addLinkedListItem(parent, child, firstProp, lastProp, sortBy) {
    if (firstProp === void 0) firstProp = "_first";
    if (lastProp === void 0) lastProp = "_last";
    var prev = parent[lastProp], t;
    if (sortBy) {
        t = child[sortBy];
        while(prev && prev[sortBy] > t)prev = prev._prev;
    }
    if (prev) {
        child._next = prev._next;
        prev._next = child;
    } else {
        child._next = parent[firstProp];
        parent[firstProp] = child;
    }
    if (child._next) child._next._prev = child;
    else parent[lastProp] = child;
    child._prev = prev;
    child.parent = child._dp = parent;
    return child;
}, $3e8f3adb9623a584$export$cd008aa6cd8844e3 = function _removeLinkedListItem(parent, child, firstProp, lastProp) {
    if (firstProp === void 0) firstProp = "_first";
    if (lastProp === void 0) lastProp = "_last";
    var prev = child._prev, next = child._next;
    if (prev) prev._next = next;
    else if (parent[firstProp] === child) parent[firstProp] = next;
    if (next) next._prev = prev;
    else if (parent[lastProp] === child) parent[lastProp] = prev;
    child._next = child._prev = child.parent = null; // don't delete the _dp just so we can revert if necessary. But parent should be null to indicate the item isn't in a linked list.
}, $3e8f3adb9623a584$var$_removeFromParent = function _removeFromParent(child, onlyIfParentHasAutoRemove) {
    child.parent && (!onlyIfParentHasAutoRemove || child.parent.autoRemoveChildren) && child.parent.remove && child.parent.remove(child);
    child._act = 0;
}, $3e8f3adb9623a584$var$_uncache = function _uncache(animation, child) {
    if (animation && (!child || child._end > animation._dur || child._start < 0)) {
        // performance optimization: if a child animation is passed in we should only uncache if that child EXTENDS the animation (its end time is beyond the end)
        var a = animation;
        while(a){
            a._dirty = 1;
            a = a.parent;
        }
    }
    return animation;
}, $3e8f3adb9623a584$var$_recacheAncestors = function _recacheAncestors(animation) {
    var parent = animation.parent;
    while(parent && parent.parent){
        //sometimes we must force a re-sort of all children and update the duration/totalDuration of all ancestor timelines immediately in case, for example, in the middle of a render loop, one tween alters another tween's timeScale which shoves its startTime before 0, forcing the parent timeline to shift around and shiftChildren() which could affect that next tween's render (startTime). Doesn't matter for the root timeline though.
        parent._dirty = 1;
        parent.totalDuration();
        parent = parent.parent;
    }
    return animation;
}, $3e8f3adb9623a584$var$_rewindStartAt = function _rewindStartAt(tween, totalTime, suppressEvents, force) {
    return tween._startAt && ($3e8f3adb9623a584$var$_reverting ? tween._startAt.revert($3e8f3adb9623a584$var$_revertConfigNoKill) : tween.vars.immediateRender && !tween.vars.autoRevert || tween._startAt.render(totalTime, true, force));
}, $3e8f3adb9623a584$var$_hasNoPausedAncestors = function _hasNoPausedAncestors(animation) {
    return !animation || animation._ts && _hasNoPausedAncestors(animation.parent);
}, $3e8f3adb9623a584$var$_elapsedCycleDuration = function _elapsedCycleDuration(animation) {
    return animation._repeat ? $3e8f3adb9623a584$var$_animationCycle(animation._tTime, animation = animation.duration() + animation._rDelay) * animation : 0;
}, // feed in the totalTime and cycleDuration and it'll return the cycle (iteration minus 1) and if the playhead is exactly at the very END, it will NOT bump up to the next cycle.
$3e8f3adb9623a584$var$_animationCycle = function _animationCycle(tTime, cycleDuration) {
    var whole = Math.floor(tTime /= cycleDuration);
    return tTime && whole === tTime ? whole - 1 : whole;
}, $3e8f3adb9623a584$var$_parentToChildTotalTime = function _parentToChildTotalTime(parentTime, child) {
    return (parentTime - child._start) * child._ts + (child._ts >= 0 ? 0 : child._dirty ? child.totalDuration() : child._tDur);
}, $3e8f3adb9623a584$var$_setEnd = function _setEnd(animation) {
    return animation._end = $3e8f3adb9623a584$var$_roundPrecise(animation._start + (animation._tDur / Math.abs(animation._ts || animation._rts || $3e8f3adb9623a584$var$_tinyNum) || 0));
}, $3e8f3adb9623a584$var$_alignPlayhead = function _alignPlayhead(animation, totalTime) {
    // adjusts the animation's _start and _end according to the provided totalTime (only if the parent's smoothChildTiming is true and the animation isn't paused). It doesn't do any rendering or forcing things back into parent timelines, etc. - that's what totalTime() is for.
    var parent = animation._dp;
    if (parent && parent.smoothChildTiming && animation._ts) {
        animation._start = $3e8f3adb9623a584$var$_roundPrecise(parent._time - (animation._ts > 0 ? totalTime / animation._ts : ((animation._dirty ? animation.totalDuration() : animation._tDur) - totalTime) / -animation._ts));
        $3e8f3adb9623a584$var$_setEnd(animation);
        parent._dirty || $3e8f3adb9623a584$var$_uncache(parent, animation); //for performance improvement. If the parent's cache is already dirty, it already took care of marking the ancestors as dirty too, so skip the function call here.
    }
    return animation;
}, /*
_totalTimeToTime = (clampedTotalTime, duration, repeat, repeatDelay, yoyo) => {
	let cycleDuration = duration + repeatDelay,
		time = _round(clampedTotalTime % cycleDuration);
	if (time > duration) {
		time = duration;
	}
	return (yoyo && (~~(clampedTotalTime / cycleDuration) & 1)) ? duration - time : time;
},
*/ $3e8f3adb9623a584$var$_postAddChecks = function _postAddChecks(timeline, child) {
    var t;
    if (child._time || !child._dur && child._initted || child._start < timeline._time && (child._dur || !child.add)) {
        // in case, for example, the _start is moved on a tween that has already rendered, or if it's being inserted into a timeline BEFORE where the playhead is currently. Imagine it's at its end state, then the startTime is moved WAY later (after the end of this timeline), it should render at its beginning. Special case: if it's a timeline (has .add() method) and no duration, we can skip rendering because the user may be populating it AFTER adding it to a parent timeline (unconventional, but possible, and we wouldn't want it to get removed if the parent's autoRemoveChildren is true).
        t = $3e8f3adb9623a584$var$_parentToChildTotalTime(timeline.rawTime(), child);
        if (!child._dur || $3e8f3adb9623a584$var$_clamp(0, child.totalDuration(), t) - child._tTime > $3e8f3adb9623a584$var$_tinyNum) child.render(t, true);
    } //if the timeline has already ended but the inserted tween/timeline extends the duration, we should enable this timeline again so that it renders properly. We should also align the playhead with the parent timeline's when appropriate.
    if ($3e8f3adb9623a584$var$_uncache(timeline, child)._dp && timeline._initted && timeline._time >= timeline._dur && timeline._ts) {
        //in case any of the ancestors had completed but should now be enabled...
        if (timeline._dur < timeline.duration()) {
            t = timeline;
            while(t._dp){
                t.rawTime() >= 0 && t.totalTime(t._tTime); //moves the timeline (shifts its startTime) if necessary, and also enables it. If it's currently zero, though, it may not be scheduled to render until later so there's no need to force it to align with the current playhead position. Only move to catch up with the playhead.
                t = t._dp;
            }
        }
        timeline._zTime = -$3e8f3adb9623a584$var$_tinyNum; // helps ensure that the next render() will be forced (crossingStart = true in render()), even if the duration hasn't changed (we're adding a child which would need to get rendered). Definitely an edge case. Note: we MUST do this AFTER the loop above where the totalTime() might trigger a render() because this _addToTimeline() method gets called from the Animation constructor, BEFORE tweens even record their targets, etc. so we wouldn't want things to get triggered in the wrong order.
    }
}, $3e8f3adb9623a584$var$_addToTimeline = function _addToTimeline(timeline, child, position, skipChecks) {
    child.parent && $3e8f3adb9623a584$var$_removeFromParent(child);
    child._start = $3e8f3adb9623a584$var$_roundPrecise(($3e8f3adb9623a584$var$_isNumber(position) ? position : position || timeline !== $3e8f3adb9623a584$var$_globalTimeline ? $3e8f3adb9623a584$var$_parsePosition(timeline, position, child) : timeline._time) + child._delay);
    child._end = $3e8f3adb9623a584$var$_roundPrecise(child._start + (child.totalDuration() / Math.abs(child.timeScale()) || 0));
    $3e8f3adb9623a584$var$_addLinkedListItem(timeline, child, "_first", "_last", timeline._sort ? "_start" : 0);
    $3e8f3adb9623a584$var$_isFromOrFromStart(child) || (timeline._recent = child);
    skipChecks || $3e8f3adb9623a584$var$_postAddChecks(timeline, child);
    timeline._ts < 0 && $3e8f3adb9623a584$var$_alignPlayhead(timeline, timeline._tTime); // if the timeline is reversed and the new child makes it longer, we may need to adjust the parent's _start (push it back)
    return timeline;
}, $3e8f3adb9623a584$var$_scrollTrigger = function _scrollTrigger(animation, trigger) {
    return ($3e8f3adb9623a584$var$_globals.ScrollTrigger || $3e8f3adb9623a584$export$7fb54635790b59a5("scrollTrigger", trigger)) && $3e8f3adb9623a584$var$_globals.ScrollTrigger.create(trigger, animation);
}, $3e8f3adb9623a584$var$_attemptInitTween = function _attemptInitTween(tween, time, force, suppressEvents, tTime) {
    $3e8f3adb9623a584$var$_initTween(tween, time, tTime);
    if (!tween._initted) return 1;
    if (!force && tween._pt && !$3e8f3adb9623a584$var$_reverting && (tween._dur && tween.vars.lazy !== false || !tween._dur && tween.vars.lazy) && $3e8f3adb9623a584$var$_lastRenderedFrame !== $3e8f3adb9623a584$export$762ed8fbedb691e3.frame) {
        $3e8f3adb9623a584$var$_lazyTweens.push(tween);
        tween._lazy = [
            tTime,
            suppressEvents
        ];
        return 1;
    }
}, $3e8f3adb9623a584$var$_parentPlayheadIsBeforeStart = function _parentPlayheadIsBeforeStart(_ref) {
    var parent = _ref.parent;
    return parent && parent._ts && parent._initted && !parent._lock && (parent.rawTime() < 0 || _parentPlayheadIsBeforeStart(parent));
}, // check parent's _lock because when a timeline repeats/yoyos and does its artificial wrapping, we shouldn't force the ratio back to 0
$3e8f3adb9623a584$var$_isFromOrFromStart = function _isFromOrFromStart(_ref2) {
    var data = _ref2.data;
    return data === "isFromStart" || data === "isStart";
}, $3e8f3adb9623a584$var$_renderZeroDurationTween = function _renderZeroDurationTween(tween, totalTime, suppressEvents, force) {
    var prevRatio = tween.ratio, ratio = totalTime < 0 || !totalTime && (!tween._start && $3e8f3adb9623a584$var$_parentPlayheadIsBeforeStart(tween) && !(!tween._initted && $3e8f3adb9623a584$var$_isFromOrFromStart(tween)) || (tween._ts < 0 || tween._dp._ts < 0) && !$3e8f3adb9623a584$var$_isFromOrFromStart(tween)) ? 0 : 1, // if the tween or its parent is reversed and the totalTime is 0, we should go to a ratio of 0. Edge case: if a from() or fromTo() stagger tween is placed later in a timeline, the "startAt" zero-duration tween could initially render at a time when the parent timeline's playhead is technically BEFORE where this tween is, so make sure that any "from" and "fromTo" startAt tweens are rendered the first time at a ratio of 1.
    repeatDelay = tween._rDelay, tTime = 0, pt, iteration, prevIteration;
    if (repeatDelay && tween._repeat) {
        // in case there's a zero-duration tween that has a repeat with a repeatDelay
        tTime = $3e8f3adb9623a584$var$_clamp(0, tween._tDur, totalTime);
        iteration = $3e8f3adb9623a584$var$_animationCycle(tTime, repeatDelay);
        tween._yoyo && iteration & 1 && (ratio = 1 - ratio);
        if (iteration !== $3e8f3adb9623a584$var$_animationCycle(tween._tTime, repeatDelay)) {
            // if iteration changed
            prevRatio = 1 - ratio;
            tween.vars.repeatRefresh && tween._initted && tween.invalidate();
        }
    }
    if (ratio !== prevRatio || $3e8f3adb9623a584$var$_reverting || force || tween._zTime === $3e8f3adb9623a584$var$_tinyNum || !totalTime && tween._zTime) {
        if (!tween._initted && $3e8f3adb9623a584$var$_attemptInitTween(tween, totalTime, force, suppressEvents, tTime)) // if we render the very beginning (time == 0) of a fromTo(), we must force the render (normal tweens wouldn't need to render at a time of 0 when the prevTime was also 0). This is also mandatory to make sure overwriting kicks in immediately.
        return;
        prevIteration = tween._zTime;
        tween._zTime = totalTime || (suppressEvents ? $3e8f3adb9623a584$var$_tinyNum : 0); // when the playhead arrives at EXACTLY time 0 (right on top) of a zero-duration tween, we need to discern if events are suppressed so that when the playhead moves again (next time), it'll trigger the callback. If events are NOT suppressed, obviously the callback would be triggered in this render. Basically, the callback should fire either when the playhead ARRIVES or LEAVES this exact spot, not both. Imagine doing a timeline.seek(0) and there's a callback that sits at 0. Since events are suppressed on that seek() by default, nothing will fire, but when the playhead moves off of that position, the callback should fire. This behavior is what people intuitively expect.
        suppressEvents || (suppressEvents = totalTime && !prevIteration); // if it was rendered previously at exactly 0 (_zTime) and now the playhead is moving away, DON'T fire callbacks otherwise they'll seem like duplicates.
        tween.ratio = ratio;
        tween._from && (ratio = 1 - ratio);
        tween._time = 0;
        tween._tTime = tTime;
        pt = tween._pt;
        while(pt){
            pt.r(ratio, pt.d);
            pt = pt._next;
        }
        totalTime < 0 && $3e8f3adb9623a584$var$_rewindStartAt(tween, totalTime, suppressEvents, true);
        tween._onUpdate && !suppressEvents && $3e8f3adb9623a584$var$_callback(tween, "onUpdate");
        tTime && tween._repeat && !suppressEvents && tween.parent && $3e8f3adb9623a584$var$_callback(tween, "onRepeat");
        if ((totalTime >= tween._tDur || totalTime < 0) && tween.ratio === ratio) {
            ratio && $3e8f3adb9623a584$var$_removeFromParent(tween, 1);
            if (!suppressEvents && !$3e8f3adb9623a584$var$_reverting) {
                $3e8f3adb9623a584$var$_callback(tween, ratio ? "onComplete" : "onReverseComplete", true);
                tween._prom && tween._prom();
            }
        }
    } else if (!tween._zTime) tween._zTime = totalTime;
}, $3e8f3adb9623a584$var$_findNextPauseTween = function _findNextPauseTween(animation, prevTime, time) {
    var child;
    if (time > prevTime) {
        child = animation._first;
        while(child && child._start <= time){
            if (child.data === "isPause" && child._start > prevTime) return child;
            child = child._next;
        }
    } else {
        child = animation._last;
        while(child && child._start >= time){
            if (child.data === "isPause" && child._start < prevTime) return child;
            child = child._prev;
        }
    }
}, $3e8f3adb9623a584$var$_setDuration = function _setDuration(animation, duration, skipUncache, leavePlayhead) {
    var repeat = animation._repeat, dur = $3e8f3adb9623a584$var$_roundPrecise(duration) || 0, totalProgress = animation._tTime / animation._tDur;
    totalProgress && !leavePlayhead && (animation._time *= dur / animation._dur);
    animation._dur = dur;
    animation._tDur = !repeat ? dur : repeat < 0 ? 1e10 : $3e8f3adb9623a584$var$_roundPrecise(dur * (repeat + 1) + animation._rDelay * repeat);
    totalProgress > 0 && !leavePlayhead && $3e8f3adb9623a584$var$_alignPlayhead(animation, animation._tTime = animation._tDur * totalProgress);
    animation.parent && $3e8f3adb9623a584$var$_setEnd(animation);
    skipUncache || $3e8f3adb9623a584$var$_uncache(animation.parent, animation);
    return animation;
}, $3e8f3adb9623a584$var$_onUpdateTotalDuration = function _onUpdateTotalDuration(animation) {
    return animation instanceof $3e8f3adb9623a584$export$e6a97ba2cae5bb94 ? $3e8f3adb9623a584$var$_uncache(animation) : $3e8f3adb9623a584$var$_setDuration(animation, animation._dur);
}, $3e8f3adb9623a584$var$_zeroPosition = {
    _start: 0,
    endTime: $3e8f3adb9623a584$var$_emptyFunc,
    totalDuration: $3e8f3adb9623a584$var$_emptyFunc
}, $3e8f3adb9623a584$var$_parsePosition = function _parsePosition(animation, position, percentAnimation) {
    var labels = animation.labels, recent = animation._recent || $3e8f3adb9623a584$var$_zeroPosition, clippedDuration = animation.duration() >= $3e8f3adb9623a584$var$_bigNum ? recent.endTime(false) : animation._dur, //in case there's a child that infinitely repeats, users almost never intend for the insertion point of a new child to be based on a SUPER long value like that so we clip it and assume the most recently-added child's endTime should be used instead.
    i, offset, isPercent;
    if ($3e8f3adb9623a584$export$f664476fd67145ca(position) && (isNaN(position) || position in labels)) {
        //if the string is a number like "1", check to see if there's a label with that name, otherwise interpret it as a number (absolute value).
        offset = position.charAt(0);
        isPercent = position.substr(-1) === "%";
        i = position.indexOf("=");
        if (offset === "<" || offset === ">") {
            i >= 0 && (position = position.replace(/=/, ""));
            return (offset === "<" ? recent._start : recent.endTime(recent._repeat >= 0)) + (parseFloat(position.substr(1)) || 0) * (isPercent ? (i < 0 ? recent : percentAnimation).totalDuration() / 100 : 1);
        }
        if (i < 0) {
            position in labels || (labels[position] = clippedDuration);
            return labels[position];
        }
        offset = parseFloat(position.charAt(i - 1) + position.substr(i + 1));
        if (isPercent && percentAnimation) offset = offset / 100 * ($3e8f3adb9623a584$var$_isArray(percentAnimation) ? percentAnimation[0] : percentAnimation).totalDuration();
        return i > 1 ? _parsePosition(animation, position.substr(0, i - 1), percentAnimation) + offset : clippedDuration + offset;
    }
    return position == null ? clippedDuration : +position;
}, $3e8f3adb9623a584$var$_createTweenType = function _createTweenType(type, params, timeline) {
    var isLegacy = $3e8f3adb9623a584$var$_isNumber(params[1]), varsIndex = (isLegacy ? 2 : 1) + (type < 2 ? 0 : 1), vars = params[varsIndex], irVars, parent;
    isLegacy && (vars.duration = params[1]);
    vars.parent = timeline;
    if (type) {
        irVars = vars;
        parent = timeline;
        while(parent && !("immediateRender" in irVars)){
            // inheritance hasn't happened yet, but someone may have set a default in an ancestor timeline. We could do vars.immediateRender = _isNotFalse(_inheritDefaults(vars).immediateRender) but that'd exact a slight performance penalty because _inheritDefaults() also runs in the Tween constructor. We're paying a small kb price here to gain speed.
            irVars = parent.vars.defaults || {};
            parent = $3e8f3adb9623a584$var$_isNotFalse(parent.vars.inherit) && parent.parent;
        }
        vars.immediateRender = $3e8f3adb9623a584$var$_isNotFalse(irVars.immediateRender);
        type < 2 ? vars.runBackwards = 1 : vars.startAt = params[varsIndex - 1]; // "from" vars
    }
    return new $3e8f3adb9623a584$export$208a41d6b4e37b97(params[0], vars, params[varsIndex + 1]);
}, $3e8f3adb9623a584$var$_conditionalReturn = function _conditionalReturn(value, func) {
    return value || value === 0 ? func(value) : func;
}, $3e8f3adb9623a584$var$_clamp = function _clamp(min, max, value) {
    return value < min ? min : value > max ? max : value;
}, $3e8f3adb9623a584$export$65f2564e9a9b9222 = function getUnit(value, v) {
    return !$3e8f3adb9623a584$export$f664476fd67145ca(value) || !(v = $3e8f3adb9623a584$var$_unitExp.exec(value)) ? "" : v[1];
}, // note: protect against padded numbers as strings, like "100.100". That shouldn't return "00" as the unit. If it's numeric, return no unit.
$3e8f3adb9623a584$export$7d15b64cf5a3a4c4 = function clamp(min, max, value) {
    return $3e8f3adb9623a584$var$_conditionalReturn(value, function(v) {
        return $3e8f3adb9623a584$var$_clamp(min, max, v);
    });
}, $3e8f3adb9623a584$var$_slice = [].slice, $3e8f3adb9623a584$var$_isArrayLike = function _isArrayLike(value, nonEmpty) {
    return value && $3e8f3adb9623a584$var$_isObject(value) && "length" in value && (!nonEmpty && !value.length || value.length - 1 in value && $3e8f3adb9623a584$var$_isObject(value[0])) && !value.nodeType && value !== $3e8f3adb9623a584$var$_win;
}, $3e8f3adb9623a584$var$_flatten = function _flatten(ar, leaveStrings, accumulator) {
    if (accumulator === void 0) accumulator = [];
    return ar.forEach(function(value) {
        var _accumulator;
        return $3e8f3adb9623a584$export$f664476fd67145ca(value) && !leaveStrings || $3e8f3adb9623a584$var$_isArrayLike(value, 1) ? (_accumulator = accumulator).push.apply(_accumulator, $3e8f3adb9623a584$export$45b10814cc054894(value)) : accumulator.push(value);
    }) || accumulator;
}, //takes any value and returns an array. If it's a string (and leaveStrings isn't true), it'll use document.querySelectorAll() and convert that to an array. It'll also accept iterables like jQuery objects.
$3e8f3adb9623a584$export$45b10814cc054894 = function toArray(value, scope, leaveStrings) {
    return $3e8f3adb9623a584$var$_context && !scope && $3e8f3adb9623a584$var$_context.selector ? $3e8f3adb9623a584$var$_context.selector(value) : $3e8f3adb9623a584$export$f664476fd67145ca(value) && !leaveStrings && ($3e8f3adb9623a584$var$_coreInitted || !$3e8f3adb9623a584$var$_wake()) ? $3e8f3adb9623a584$var$_slice.call((scope || $3e8f3adb9623a584$var$_doc).querySelectorAll(value), 0) : $3e8f3adb9623a584$var$_isArray(value) ? $3e8f3adb9623a584$var$_flatten(value, leaveStrings) : $3e8f3adb9623a584$var$_isArrayLike(value) ? $3e8f3adb9623a584$var$_slice.call(value, 0) : value ? [
        value
    ] : [];
}, $3e8f3adb9623a584$export$aea217a45095ce11 = function selector(value) {
    value = $3e8f3adb9623a584$export$45b10814cc054894(value)[0] || $3e8f3adb9623a584$var$_warn("Invalid scope") || {};
    return function(v) {
        var el = value.current || value.nativeElement || value;
        return $3e8f3adb9623a584$export$45b10814cc054894(v, el.querySelectorAll ? el : el === value ? $3e8f3adb9623a584$var$_warn("Invalid scope") || $3e8f3adb9623a584$var$_doc.createElement("div") : value);
    };
}, $3e8f3adb9623a584$export$448332262467e042 = function shuffle(a) {
    return a.sort(function() {
        return .5 - Math.random();
    });
}, // alternative that's a bit faster and more reliably diverse but bigger:   for (let j, v, i = a.length; i; j = Math.floor(Math.random() * i), v = a[--i], a[i] = a[j], a[j] = v); return a;
//for distributing values across an array. Can accept a number, a function or (most commonly) a function which can contain the following properties: {base, amount, from, ease, grid, axis, length, each}. Returns a function that expects the following parameters: index, target, array. Recognizes the following
$3e8f3adb9623a584$export$f02a9ddbe4480f19 = function distribute(v) {
    if ($3e8f3adb9623a584$var$_isFunction(v)) return v;
    var vars = $3e8f3adb9623a584$var$_isObject(v) ? v : {
        each: v
    }, //n:1 is just to indicate v was a number; we leverage that later to set v according to the length we get. If a number is passed in, we treat it like the old stagger value where 0.1, for example, would mean that things would be distributed with 0.1 between each element in the array rather than a total "amount" that's chunked out among them all.
    ease = $3e8f3adb9623a584$var$_parseEase(vars.ease), from = vars.from || 0, base = parseFloat(vars.base) || 0, cache = {}, isDecimal = from > 0 && from < 1, ratios = isNaN(from) || isDecimal, axis = vars.axis, ratioX = from, ratioY = from;
    if ($3e8f3adb9623a584$export$f664476fd67145ca(from)) ratioX = ratioY = ({
        center: .5,
        edges: .5,
        end: 1
    })[from] || 0;
    else if (!isDecimal && ratios) {
        ratioX = from[0];
        ratioY = from[1];
    }
    return function(i, target, a) {
        var l = (a || vars).length, distances = cache[l], originX, originY, x, y, d, j, max, min, wrapAt;
        if (!distances) {
            wrapAt = vars.grid === "auto" ? 0 : (vars.grid || [
                1,
                $3e8f3adb9623a584$var$_bigNum
            ])[1];
            if (!wrapAt) {
                max = -$3e8f3adb9623a584$var$_bigNum;
                while(max < (max = a[wrapAt++].getBoundingClientRect().left) && wrapAt < l);
                wrapAt--;
            }
            distances = cache[l] = [];
            originX = ratios ? Math.min(wrapAt, l) * ratioX - .5 : from % wrapAt;
            originY = wrapAt === $3e8f3adb9623a584$var$_bigNum ? 0 : ratios ? l * ratioY / wrapAt - .5 : from / wrapAt | 0;
            max = 0;
            min = $3e8f3adb9623a584$var$_bigNum;
            for(j = 0; j < l; j++){
                x = j % wrapAt - originX;
                y = originY - (j / wrapAt | 0);
                distances[j] = d = !axis ? $3e8f3adb9623a584$var$_sqrt(x * x + y * y) : Math.abs(axis === "y" ? y : x);
                d > max && (max = d);
                d < min && (min = d);
            }
            from === "random" && $3e8f3adb9623a584$export$448332262467e042(distances);
            distances.max = max - min;
            distances.min = min;
            distances.v = l = (parseFloat(vars.amount) || parseFloat(vars.each) * (wrapAt > l ? l - 1 : !axis ? Math.max(wrapAt, l / wrapAt) : axis === "y" ? l / wrapAt : wrapAt) || 0) * (from === "edges" ? -1 : 1);
            distances.b = l < 0 ? base - l : base;
            distances.u = $3e8f3adb9623a584$export$65f2564e9a9b9222(vars.amount || vars.each) || 0; //unit
            ease = ease && l < 0 ? $3e8f3adb9623a584$var$_invertEase(ease) : ease;
        }
        l = (distances[i] - distances.min) / distances.max || 0;
        return $3e8f3adb9623a584$var$_roundPrecise(distances.b + (ease ? ease(l) : l) * distances.v) + distances.u; //round in order to work around floating point errors
    };
}, $3e8f3adb9623a584$export$dd12390e6b265a17 = function _roundModifier(v) {
    //pass in 0.1 get a function that'll round to the nearest tenth, or 5 to round to the closest 5, or 0.001 to the closest 1000th, etc.
    var p = Math.pow(10, ((v + "").split(".")[1] || "").length); //to avoid floating point math errors (like 24 * 0.1 == 2.4000000000000004), we chop off at a specific number of decimal places (much faster than toFixed())
    return function(raw) {
        var n = $3e8f3adb9623a584$var$_roundPrecise(Math.round(parseFloat(raw) / v) * v * p);
        return (n - n % 1) / p + ($3e8f3adb9623a584$var$_isNumber(raw) ? 0 : $3e8f3adb9623a584$export$65f2564e9a9b9222(raw)); // n - n % 1 replaces Math.floor() in order to handle negative values properly. For example, Math.floor(-150.00000000000003) is 151!
    };
}, $3e8f3adb9623a584$export$51a0620f7a28532b = function snap(snapTo, value) {
    var isArray = $3e8f3adb9623a584$var$_isArray(snapTo), radius, is2D;
    if (!isArray && $3e8f3adb9623a584$var$_isObject(snapTo)) {
        radius = isArray = snapTo.radius || $3e8f3adb9623a584$var$_bigNum;
        if (snapTo.values) {
            snapTo = $3e8f3adb9623a584$export$45b10814cc054894(snapTo.values);
            if (is2D = !$3e8f3adb9623a584$var$_isNumber(snapTo[0])) radius *= radius; //performance optimization so we don't have to Math.sqrt() in the loop.
        } else snapTo = $3e8f3adb9623a584$export$dd12390e6b265a17(snapTo.increment);
    }
    return $3e8f3adb9623a584$var$_conditionalReturn(value, !isArray ? $3e8f3adb9623a584$export$dd12390e6b265a17(snapTo) : $3e8f3adb9623a584$var$_isFunction(snapTo) ? function(raw) {
        is2D = snapTo(raw);
        return Math.abs(is2D - raw) <= radius ? is2D : raw;
    } : function(raw) {
        var x = parseFloat(is2D ? raw.x : raw), y = parseFloat(is2D ? raw.y : 0), min = $3e8f3adb9623a584$var$_bigNum, closest = 0, i = snapTo.length, dx, dy;
        while(i--){
            if (is2D) {
                dx = snapTo[i].x - x;
                dy = snapTo[i].y - y;
                dx = dx * dx + dy * dy;
            } else dx = Math.abs(snapTo[i] - x);
            if (dx < min) {
                min = dx;
                closest = i;
            }
        }
        closest = !radius || min <= radius ? snapTo[closest] : raw;
        return is2D || closest === raw || $3e8f3adb9623a584$var$_isNumber(raw) ? closest : closest + $3e8f3adb9623a584$export$65f2564e9a9b9222(raw);
    });
}, $3e8f3adb9623a584$export$4385e60b38654f68 = function random(min, max, roundingIncrement, returnFunction) {
    return $3e8f3adb9623a584$var$_conditionalReturn($3e8f3adb9623a584$var$_isArray(min) ? !max : roundingIncrement === true ? (roundingIncrement = 0, false) : !returnFunction, function() {
        return $3e8f3adb9623a584$var$_isArray(min) ? min[~~(Math.random() * min.length)] : (roundingIncrement = roundingIncrement || 1e-5, returnFunction = roundingIncrement < 1 ? Math.pow(10, (roundingIncrement + "").length - 2) : 1) && Math.floor(Math.round((min - roundingIncrement / 2 + Math.random() * (max - min + roundingIncrement * .99)) / roundingIncrement) * roundingIncrement * returnFunction) / returnFunction;
    });
}, $3e8f3adb9623a584$export$a4627e546088548d = function pipe() {
    for(var _len = arguments.length, functions = new Array(_len), _key = 0; _key < _len; _key++)functions[_key] = arguments[_key];
    return function(value) {
        return functions.reduce(function(v, f) {
            return f(v);
        }, value);
    };
}, $3e8f3adb9623a584$export$d7502930aa5492de = function unitize(func, unit) {
    return function(value) {
        return func(parseFloat(value)) + (unit || $3e8f3adb9623a584$export$65f2564e9a9b9222(value));
    };
}, $3e8f3adb9623a584$export$a3295358bff77e = function normalize(min, max, value) {
    return $3e8f3adb9623a584$export$f65a7599bbc6b121(min, max, 0, 1, value);
}, $3e8f3adb9623a584$var$_wrapArray = function _wrapArray(a, wrapper, value) {
    return $3e8f3adb9623a584$var$_conditionalReturn(value, function(index) {
        return a[~~wrapper(index)];
    });
}, $3e8f3adb9623a584$export$4997ffc0176396a6 = function wrap(min, max, value) {
    // NOTE: wrap() CANNOT be an arrow function! A very odd compiling bug causes problems (unrelated to GSAP).
    var range = max - min;
    return $3e8f3adb9623a584$var$_isArray(min) ? $3e8f3adb9623a584$var$_wrapArray(min, wrap(0, min.length), max) : $3e8f3adb9623a584$var$_conditionalReturn(value, function(value) {
        return (range + (value - min) % range) % range + min;
    });
}, $3e8f3adb9623a584$export$cfc0b067273edc55 = function wrapYoyo(min, max, value) {
    var range = max - min, total = range * 2;
    return $3e8f3adb9623a584$var$_isArray(min) ? $3e8f3adb9623a584$var$_wrapArray(min, wrapYoyo(0, min.length - 1), max) : $3e8f3adb9623a584$var$_conditionalReturn(value, function(value) {
        value = (total + (value - min) % total) % total || 0;
        return min + (value > range ? total - value : value);
    });
}, $3e8f3adb9623a584$export$d5962a97e3cde94d = function _replaceRandom(value) {
    //replaces all occurrences of random(...) in a string with the calculated random value. can be a range like random(-100, 100, 5) or an array like random([0, 100, 500])
    var prev = 0, s = "", i, nums, end, isArray;
    while(~(i = value.indexOf("random(", prev))){
        end = value.indexOf(")", i);
        isArray = value.charAt(i + 7) === "[";
        nums = value.substr(i + 7, end - i - 7).match(isArray ? $3e8f3adb9623a584$var$_delimitedValueExp : $3e8f3adb9623a584$var$_strictNumExp);
        s += value.substr(prev, i - prev) + $3e8f3adb9623a584$export$4385e60b38654f68(isArray ? nums : +nums[0], isArray ? 0 : +nums[1], +nums[2] || 1e-5);
        prev = end + 1;
    }
    return s + value.substr(prev, value.length - prev);
}, $3e8f3adb9623a584$export$f65a7599bbc6b121 = function mapRange(inMin, inMax, outMin, outMax, value) {
    var inRange = inMax - inMin, outRange = outMax - outMin;
    return $3e8f3adb9623a584$var$_conditionalReturn(value, function(value) {
        return outMin + ((value - inMin) / inRange * outRange || 0);
    });
}, $3e8f3adb9623a584$export$89e29e4ab65e70a9 = function interpolate(start, end, progress, mutate) {
    var func = isNaN(start + end) ? 0 : function(p) {
        return (1 - p) * start + p * end;
    };
    if (!func) {
        var isString = $3e8f3adb9623a584$export$f664476fd67145ca(start), master = {}, p, i, interpolators, l, il;
        progress === true && (mutate = 1) && (progress = null);
        if (isString) {
            start = {
                p: start
            };
            end = {
                p: end
            };
        } else if ($3e8f3adb9623a584$var$_isArray(start) && !$3e8f3adb9623a584$var$_isArray(end)) {
            interpolators = [];
            l = start.length;
            il = l - 2;
            for(i = 1; i < l; i++)interpolators.push(interpolate(start[i - 1], start[i])); //build the interpolators up front as a performance optimization so that when the function is called many times, it can just reuse them.
            l--;
            func = function func(p) {
                p *= l;
                var i = Math.min(il, ~~p);
                return interpolators[i](p - i);
            };
            progress = end;
        } else if (!mutate) start = $3e8f3adb9623a584$var$_merge($3e8f3adb9623a584$var$_isArray(start) ? [] : {}, start);
        if (!interpolators) {
            for(p in end)$3e8f3adb9623a584$var$_addPropTween.call(master, start, p, "get", end[p]);
            func = function func(p) {
                return $3e8f3adb9623a584$var$_renderPropTweens(p, master) || (isString ? start.p : start);
            };
        }
    }
    return $3e8f3adb9623a584$var$_conditionalReturn(progress, func);
}, $3e8f3adb9623a584$var$_getLabelInDirection = function _getLabelInDirection(timeline, fromTime, backward) {
    //used for nextLabel() and previousLabel()
    var labels = timeline.labels, min = $3e8f3adb9623a584$var$_bigNum, p, distance, label;
    for(p in labels){
        distance = labels[p] - fromTime;
        if (distance < 0 === !!backward && distance && min > (distance = Math.abs(distance))) {
            label = p;
            min = distance;
        }
    }
    return label;
}, $3e8f3adb9623a584$var$_callback = function _callback(animation, type, executeLazyFirst) {
    var v = animation.vars, callback = v[type], prevContext = $3e8f3adb9623a584$var$_context, context = animation._ctx, params, scope, result;
    if (!callback) return;
    params = v[type + "Params"];
    scope = v.callbackScope || animation;
    executeLazyFirst && $3e8f3adb9623a584$var$_lazyTweens.length && $3e8f3adb9623a584$var$_lazyRender(); //in case rendering caused any tweens to lazy-init, we should render them because typically when a timeline finishes, users expect things to have rendered fully. Imagine an onUpdate on a timeline that reports/checks tweened values.
    context && ($3e8f3adb9623a584$var$_context = context);
    result = params ? callback.apply(scope, params) : callback.call(scope);
    $3e8f3adb9623a584$var$_context = prevContext;
    return result;
}, $3e8f3adb9623a584$var$_interrupt = function _interrupt(animation) {
    $3e8f3adb9623a584$var$_removeFromParent(animation);
    animation.scrollTrigger && animation.scrollTrigger.kill(!!$3e8f3adb9623a584$var$_reverting);
    animation.progress() < 1 && $3e8f3adb9623a584$var$_callback(animation, "onInterrupt");
    return animation;
}, $3e8f3adb9623a584$var$_quickTween, $3e8f3adb9623a584$var$_registerPluginQueue = [], $3e8f3adb9623a584$var$_createPlugin = function _createPlugin(config) {
    if ($3e8f3adb9623a584$var$_windowExists() && config) {
        // edge case: some build tools may pass in a null/undefined value
        config = !config.name && config["default"] || config; //UMD packaging wraps things oddly, so for example MotionPathHelper becomes {MotionPathHelper:MotionPathHelper, default:MotionPathHelper}.
        var name = config.name, isFunc = $3e8f3adb9623a584$var$_isFunction(config), Plugin = name && !isFunc && config.init ? function() {
            this._props = [];
        } : config, //in case someone passes in an object that's not a plugin, like CustomEase
        instanceDefaults = {
            init: $3e8f3adb9623a584$var$_emptyFunc,
            render: $3e8f3adb9623a584$var$_renderPropTweens,
            add: $3e8f3adb9623a584$var$_addPropTween,
            kill: $3e8f3adb9623a584$var$_killPropTweensOf,
            modifier: $3e8f3adb9623a584$var$_addPluginModifier,
            rawVars: 0
        }, statics = {
            targetTest: 0,
            get: 0,
            getSetter: $3e8f3adb9623a584$export$d60fbc1e0278aaf0,
            aliases: {},
            register: 0
        };
        $3e8f3adb9623a584$var$_wake();
        if (config !== Plugin) {
            if ($3e8f3adb9623a584$export$d305d8ec5d7c26b8[name]) return;
            $3e8f3adb9623a584$export$dc2b19673bb53610(Plugin, $3e8f3adb9623a584$export$dc2b19673bb53610($3e8f3adb9623a584$var$_copyExcluding(config, instanceDefaults), statics)); //static methods
            $3e8f3adb9623a584$var$_merge(Plugin.prototype, $3e8f3adb9623a584$var$_merge(instanceDefaults, $3e8f3adb9623a584$var$_copyExcluding(config, statics))); //instance methods
            $3e8f3adb9623a584$export$d305d8ec5d7c26b8[Plugin.prop = name] = Plugin;
            if (config.targetTest) {
                $3e8f3adb9623a584$var$_harnessPlugins.push(Plugin);
                $3e8f3adb9623a584$var$_reservedProps[name] = 1;
            }
            name = (name === "css" ? "CSS" : name.charAt(0).toUpperCase() + name.substr(1)) + "Plugin"; //for the global name. "motionPath" should become MotionPathPlugin
        }
        $3e8f3adb9623a584$var$_addGlobal(name, Plugin);
        config.register && config.register($3e8f3adb9623a584$export$99ee26438460406a, Plugin, $3e8f3adb9623a584$export$3a67f7f44b1e838a);
    } else config && $3e8f3adb9623a584$var$_registerPluginQueue.push(config);
}, /*
 * --------------------------------------------------------------------------------------
 * COLORS
 * --------------------------------------------------------------------------------------
 */ $3e8f3adb9623a584$var$_255 = 255, $3e8f3adb9623a584$var$_colorLookup = {
    aqua: [
        0,
        $3e8f3adb9623a584$var$_255,
        $3e8f3adb9623a584$var$_255
    ],
    lime: [
        0,
        $3e8f3adb9623a584$var$_255,
        0
    ],
    silver: [
        192,
        192,
        192
    ],
    black: [
        0,
        0,
        0
    ],
    maroon: [
        128,
        0,
        0
    ],
    teal: [
        0,
        128,
        128
    ],
    blue: [
        0,
        0,
        $3e8f3adb9623a584$var$_255
    ],
    navy: [
        0,
        0,
        128
    ],
    white: [
        $3e8f3adb9623a584$var$_255,
        $3e8f3adb9623a584$var$_255,
        $3e8f3adb9623a584$var$_255
    ],
    olive: [
        128,
        128,
        0
    ],
    yellow: [
        $3e8f3adb9623a584$var$_255,
        $3e8f3adb9623a584$var$_255,
        0
    ],
    orange: [
        $3e8f3adb9623a584$var$_255,
        165,
        0
    ],
    gray: [
        128,
        128,
        128
    ],
    purple: [
        128,
        0,
        128
    ],
    green: [
        0,
        128,
        0
    ],
    red: [
        $3e8f3adb9623a584$var$_255,
        0,
        0
    ],
    pink: [
        $3e8f3adb9623a584$var$_255,
        192,
        203
    ],
    cyan: [
        0,
        $3e8f3adb9623a584$var$_255,
        $3e8f3adb9623a584$var$_255
    ],
    transparent: [
        $3e8f3adb9623a584$var$_255,
        $3e8f3adb9623a584$var$_255,
        $3e8f3adb9623a584$var$_255,
        0
    ]
}, // possible future idea to replace the hard-coded color name values - put this in the ticker.wake() where we set the _doc:
// let ctx = _doc.createElement("canvas").getContext("2d");
// _forEachName("aqua,lime,silver,black,maroon,teal,blue,navy,white,olive,yellow,orange,gray,purple,green,red,pink,cyan", color => {ctx.fillStyle = color; _colorLookup[color] = splitColor(ctx.fillStyle)});
$3e8f3adb9623a584$var$_hue = function _hue(h, m1, m2) {
    h += h < 0 ? 1 : h > 1 ? -1 : 0;
    return (h * 6 < 1 ? m1 + (m2 - m1) * h * 6 : h < .5 ? m2 : h * 3 < 2 ? m1 + (m2 - m1) * (2 / 3 - h) * 6 : m1) * $3e8f3adb9623a584$var$_255 + .5 | 0;
}, $3e8f3adb9623a584$export$73d6f35be992df24 = function splitColor(v, toHSL, forceAlpha) {
    var a = !v ? $3e8f3adb9623a584$var$_colorLookup.black : $3e8f3adb9623a584$var$_isNumber(v) ? [
        v >> 16,
        v >> 8 & $3e8f3adb9623a584$var$_255,
        v & $3e8f3adb9623a584$var$_255
    ] : 0, r, g, b, h, s, l, max, min, d, wasHSL;
    if (!a) {
        if (v.substr(-1) === ",") //sometimes a trailing comma is included and we should chop it off (typically from a comma-delimited list of values like a textShadow:"2px 2px 2px blue, 5px 5px 5px rgb(255,0,0)" - in this example "blue," has a trailing comma. We could strip it out inside parseComplex() but we'd need to do it to the beginning and ending values plus it wouldn't provide protection from other potential scenarios like if the user passes in a similar value.
        v = v.substr(0, v.length - 1);
        if ($3e8f3adb9623a584$var$_colorLookup[v]) a = $3e8f3adb9623a584$var$_colorLookup[v];
        else if (v.charAt(0) === "#") {
            if (v.length < 6) {
                //for shorthand like #9F0 or #9F0F (could have alpha)
                r = v.charAt(1);
                g = v.charAt(2);
                b = v.charAt(3);
                v = "#" + r + r + g + g + b + b + (v.length === 5 ? v.charAt(4) + v.charAt(4) : "");
            }
            if (v.length === 9) {
                // hex with alpha, like #fd5e53ff
                a = parseInt(v.substr(1, 6), 16);
                return [
                    a >> 16,
                    a >> 8 & $3e8f3adb9623a584$var$_255,
                    a & $3e8f3adb9623a584$var$_255,
                    parseInt(v.substr(7), 16) / 255
                ];
            }
            v = parseInt(v.substr(1), 16);
            a = [
                v >> 16,
                v >> 8 & $3e8f3adb9623a584$var$_255,
                v & $3e8f3adb9623a584$var$_255
            ];
        } else if (v.substr(0, 3) === "hsl") {
            a = wasHSL = v.match($3e8f3adb9623a584$var$_strictNumExp);
            if (!toHSL) {
                h = +a[0] % 360 / 360;
                s = +a[1] / 100;
                l = +a[2] / 100;
                g = l <= .5 ? l * (s + 1) : l + s - l * s;
                r = l * 2 - g;
                a.length > 3 && (a[3] *= 1); //cast as number
                a[0] = $3e8f3adb9623a584$var$_hue(h + 1 / 3, r, g);
                a[1] = $3e8f3adb9623a584$var$_hue(h, r, g);
                a[2] = $3e8f3adb9623a584$var$_hue(h - 1 / 3, r, g);
            } else if (~v.indexOf("=")) {
                //if relative values are found, just return the raw strings with the relative prefixes in place.
                a = v.match($3e8f3adb9623a584$export$b9d44bb6523120d6);
                forceAlpha && a.length < 4 && (a[3] = 1);
                return a;
            }
        } else a = v.match($3e8f3adb9623a584$var$_strictNumExp) || $3e8f3adb9623a584$var$_colorLookup.transparent;
        a = a.map(Number);
    }
    if (toHSL && !wasHSL) {
        r = a[0] / $3e8f3adb9623a584$var$_255;
        g = a[1] / $3e8f3adb9623a584$var$_255;
        b = a[2] / $3e8f3adb9623a584$var$_255;
        max = Math.max(r, g, b);
        min = Math.min(r, g, b);
        l = (max + min) / 2;
        if (max === min) h = s = 0;
        else {
            d = max - min;
            s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
            h = max === r ? (g - b) / d + (g < b ? 6 : 0) : max === g ? (b - r) / d + 2 : (r - g) / d + 4;
            h *= 60;
        }
        a[0] = ~~(h + .5);
        a[1] = ~~(s * 100 + .5);
        a[2] = ~~(l * 100 + .5);
    }
    forceAlpha && a.length < 4 && (a[3] = 1);
    return a;
}, $3e8f3adb9623a584$var$_colorOrderData = function _colorOrderData(v) {
    // strips out the colors from the string, finds all the numeric slots (with units) and returns an array of those. The Array also has a "c" property which is an Array of the index values where the colors belong. This is to help work around issues where there's a mis-matched order of color/numeric data like drop-shadow(#f00 0px 1px 2px) and drop-shadow(0x 1px 2px #f00). This is basically a helper function used in _formatColors()
    var values = [], c = [], i = -1;
    v.split($3e8f3adb9623a584$export$dd733e62515be2bd).forEach(function(v) {
        var a = v.match($3e8f3adb9623a584$export$65c88bbd597e7b0a) || [];
        values.push.apply(values, a);
        c.push(i += a.length + 1);
    });
    values.c = c;
    return values;
}, $3e8f3adb9623a584$var$_formatColors = function _formatColors(s, toHSL, orderMatchData) {
    var result = "", colors = (s + result).match($3e8f3adb9623a584$export$dd733e62515be2bd), type = toHSL ? "hsla(" : "rgba(", i = 0, c, shell, d, l;
    if (!colors) return s;
    colors = colors.map(function(color) {
        return (color = $3e8f3adb9623a584$export$73d6f35be992df24(color, toHSL, 1)) && type + (toHSL ? color[0] + "," + color[1] + "%," + color[2] + "%," + color[3] : color.join(",")) + ")";
    });
    if (orderMatchData) {
        d = $3e8f3adb9623a584$var$_colorOrderData(s);
        c = orderMatchData.c;
        if (c.join(result) !== d.c.join(result)) {
            shell = s.replace($3e8f3adb9623a584$export$dd733e62515be2bd, "1").split($3e8f3adb9623a584$export$65c88bbd597e7b0a);
            l = shell.length - 1;
            for(; i < l; i++)result += shell[i] + (~c.indexOf(i) ? colors.shift() || type + "0,0,0,0)" : (d.length ? d : colors.length ? colors : orderMatchData).shift());
        }
    }
    if (!shell) {
        shell = s.split($3e8f3adb9623a584$export$dd733e62515be2bd);
        l = shell.length - 1;
        for(; i < l; i++)result += shell[i] + colors[i];
    }
    return result + shell[l];
}, $3e8f3adb9623a584$export$dd733e62515be2bd = function() {
    var s = "(?:\\b(?:(?:rgb|rgba|hsl|hsla)\\(.+?\\))|\\B#(?:[0-9a-f]{3,4}){1,2}\\b", //we'll dynamically build this Regular Expression to conserve file size. After building it, it will be able to find rgb(), rgba(), # (hexadecimal), and named color values like red, blue, purple, etc.,
    p;
    for(p in $3e8f3adb9623a584$var$_colorLookup)s += "|" + p + "\\b";
    return new RegExp(s + ")", "gi");
}(), $3e8f3adb9623a584$var$_hslExp = /hsl[a]?\(/, $3e8f3adb9623a584$export$7eb2e5eb5eeb96a4 = function _colorStringFilter(a) {
    var combined = a.join(" "), toHSL;
    $3e8f3adb9623a584$export$dd733e62515be2bd.lastIndex = 0;
    if ($3e8f3adb9623a584$export$dd733e62515be2bd.test(combined)) {
        toHSL = $3e8f3adb9623a584$var$_hslExp.test(combined);
        a[1] = $3e8f3adb9623a584$var$_formatColors(a[1], toHSL);
        a[0] = $3e8f3adb9623a584$var$_formatColors(a[0], toHSL, $3e8f3adb9623a584$var$_colorOrderData(a[1])); // make sure the order of numbers/colors match with the END value.
        return true;
    }
}, /*
 * --------------------------------------------------------------------------------------
 * TICKER
 * --------------------------------------------------------------------------------------
 */ $3e8f3adb9623a584$var$_tickerActive, $3e8f3adb9623a584$export$762ed8fbedb691e3 = function() {
    var _getTime = Date.now, _lagThreshold = 500, _adjustedLag = 33, _startTime = _getTime(), _lastUpdate = _startTime, _gap = 1000 / 240, _nextTime = _gap, _listeners = [], _id, _req, _raf, _self, _delta, _i, _tick = function _tick(v) {
        var elapsed = _getTime() - _lastUpdate, manual = v === true, overlap, dispatch, time, frame;
        elapsed > _lagThreshold && (_startTime += elapsed - _adjustedLag);
        _lastUpdate += elapsed;
        time = _lastUpdate - _startTime;
        overlap = time - _nextTime;
        if (overlap > 0 || manual) {
            frame = ++_self.frame;
            _delta = time - _self.time * 1000;
            _self.time = time = time / 1000;
            _nextTime += overlap + (overlap >= _gap ? 4 : _gap - overlap);
            dispatch = 1;
        }
        manual || (_id = _req(_tick)); //make sure the request is made before we dispatch the "tick" event so that timing is maintained. Otherwise, if processing the "tick" requires a bunch of time (like 15ms) and we're using a setTimeout() that's based on 16.7ms, it'd technically take 31.7ms between frames otherwise.
        if (dispatch) for(_i = 0; _i < _listeners.length; _i++)// use _i and check _listeners.length instead of a variable because a listener could get removed during the loop, and if that happens to an element less than the current index, it'd throw things off in the loop.
        _listeners[_i](time, _delta, frame, v);
    };
    _self = {
        time: 0,
        frame: 0,
        tick: function tick() {
            _tick(true);
        },
        deltaRatio: function deltaRatio(fps) {
            return _delta / (1000 / (fps || 60));
        },
        wake: function wake() {
            if ($3e8f3adb9623a584$var$_coreReady) {
                if (!$3e8f3adb9623a584$var$_coreInitted && $3e8f3adb9623a584$var$_windowExists()) {
                    $3e8f3adb9623a584$var$_win = $3e8f3adb9623a584$var$_coreInitted = window;
                    $3e8f3adb9623a584$var$_doc = $3e8f3adb9623a584$var$_win.document || {};
                    $3e8f3adb9623a584$var$_globals.gsap = $3e8f3adb9623a584$export$99ee26438460406a;
                    ($3e8f3adb9623a584$var$_win.gsapVersions || ($3e8f3adb9623a584$var$_win.gsapVersions = [])).push($3e8f3adb9623a584$export$99ee26438460406a.version);
                    $3e8f3adb9623a584$var$_install($3e8f3adb9623a584$var$_installScope || $3e8f3adb9623a584$var$_win.GreenSockGlobals || !$3e8f3adb9623a584$var$_win.gsap && $3e8f3adb9623a584$var$_win || {});
                    _raf = $3e8f3adb9623a584$var$_win.requestAnimationFrame;
                    $3e8f3adb9623a584$var$_registerPluginQueue.forEach($3e8f3adb9623a584$var$_createPlugin);
                }
                _id && _self.sleep();
                _req = _raf || function(f) {
                    return setTimeout(f, _nextTime - _self.time * 1000 + 1 | 0);
                };
                $3e8f3adb9623a584$var$_tickerActive = 1;
                _tick(2);
            }
        },
        sleep: function sleep() {
            (_raf ? $3e8f3adb9623a584$var$_win.cancelAnimationFrame : clearTimeout)(_id);
            $3e8f3adb9623a584$var$_tickerActive = 0;
            _req = $3e8f3adb9623a584$var$_emptyFunc;
        },
        lagSmoothing: function lagSmoothing(threshold, adjustedLag) {
            _lagThreshold = threshold || Infinity; // zero should be interpreted as basically unlimited
            _adjustedLag = Math.min(adjustedLag || 33, _lagThreshold);
        },
        fps: function fps(_fps) {
            _gap = 1000 / (_fps || 240);
            _nextTime = _self.time * 1000 + _gap;
        },
        add: function add(callback, once, prioritize) {
            var func = once ? function(t, d, f, v) {
                callback(t, d, f, v);
                _self.remove(func);
            } : callback;
            _self.remove(callback);
            _listeners[prioritize ? "unshift" : "push"](func);
            $3e8f3adb9623a584$var$_wake();
            return func;
        },
        remove: function remove(callback, i) {
            ~(i = _listeners.indexOf(callback)) && _listeners.splice(i, 1) && _i >= i && _i--;
        },
        _listeners: _listeners
    };
    return _self;
}(), $3e8f3adb9623a584$var$_wake = function _wake() {
    return !$3e8f3adb9623a584$var$_tickerActive && $3e8f3adb9623a584$export$762ed8fbedb691e3.wake();
}, //also ensures the core classes are initialized.
/*
* -------------------------------------------------
* EASING
* -------------------------------------------------
*/ $3e8f3adb9623a584$var$_easeMap = {}, $3e8f3adb9623a584$var$_customEaseExp = /^[\d.\-M][\d.\-,\s]/, $3e8f3adb9623a584$var$_quotesExp = /["']/g, $3e8f3adb9623a584$var$_parseObjectInString = function _parseObjectInString(value) {
    //takes a string like "{wiggles:10, type:anticipate})" and turns it into a real object. Notice it ends in ")" and includes the {} wrappers. This is because we only use this function for parsing ease configs and prioritized optimization rather than reusability.
    var obj = {}, split = value.substr(1, value.length - 3).split(":"), key = split[0], i = 1, l = split.length, index, val, parsedVal;
    for(; i < l; i++){
        val = split[i];
        index = i !== l - 1 ? val.lastIndexOf(",") : val.length;
        parsedVal = val.substr(0, index);
        obj[key] = isNaN(parsedVal) ? parsedVal.replace($3e8f3adb9623a584$var$_quotesExp, "").trim() : +parsedVal;
        key = val.substr(index + 1).trim();
    }
    return obj;
}, $3e8f3adb9623a584$var$_valueInParentheses = function _valueInParentheses(value) {
    var open = value.indexOf("(") + 1, close = value.indexOf(")"), nested = value.indexOf("(", open);
    return value.substring(open, ~nested && nested < close ? value.indexOf(")", close + 1) : close);
}, $3e8f3adb9623a584$var$_configEaseFromString = function _configEaseFromString(name) {
    //name can be a string like "elastic.out(1,0.5)", and pass in _easeMap as obj and it'll parse it out and call the actual function like _easeMap.Elastic.easeOut.config(1,0.5). It will also parse custom ease strings as long as CustomEase is loaded and registered (internally as _easeMap._CE).
    var split = (name + "").split("("), ease = $3e8f3adb9623a584$var$_easeMap[split[0]];
    return ease && split.length > 1 && ease.config ? ease.config.apply(null, ~name.indexOf("{") ? [
        $3e8f3adb9623a584$var$_parseObjectInString(split[1])
    ] : $3e8f3adb9623a584$var$_valueInParentheses(name).split(",").map($3e8f3adb9623a584$var$_numericIfPossible)) : $3e8f3adb9623a584$var$_easeMap._CE && $3e8f3adb9623a584$var$_customEaseExp.test(name) ? $3e8f3adb9623a584$var$_easeMap._CE("", name) : ease;
}, $3e8f3adb9623a584$var$_invertEase = function _invertEase(ease) {
    return function(p) {
        return 1 - ease(1 - p);
    };
}, // allow yoyoEase to be set in children and have those affected when the parent/ancestor timeline yoyos.
$3e8f3adb9623a584$var$_propagateYoyoEase = function _propagateYoyoEase(timeline, isYoyo) {
    var child = timeline._first, ease;
    while(child){
        if (child instanceof $3e8f3adb9623a584$export$e6a97ba2cae5bb94) _propagateYoyoEase(child, isYoyo);
        else if (child.vars.yoyoEase && (!child._yoyo || !child._repeat) && child._yoyo !== isYoyo) {
            if (child.timeline) _propagateYoyoEase(child.timeline, isYoyo);
            else {
                ease = child._ease;
                child._ease = child._yEase;
                child._yEase = ease;
                child._yoyo = isYoyo;
            }
        }
        child = child._next;
    }
}, $3e8f3adb9623a584$var$_parseEase = function _parseEase(ease, defaultEase) {
    return !ease ? defaultEase : ($3e8f3adb9623a584$var$_isFunction(ease) ? ease : $3e8f3adb9623a584$var$_easeMap[ease] || $3e8f3adb9623a584$var$_configEaseFromString(ease)) || defaultEase;
}, $3e8f3adb9623a584$var$_insertEase = function _insertEase(names, easeIn, easeOut, easeInOut) {
    if (easeOut === void 0) easeOut = function easeOut(p) {
        return 1 - easeIn(1 - p);
    };
    if (easeInOut === void 0) easeInOut = function easeInOut(p) {
        return p < .5 ? easeIn(p * 2) / 2 : 1 - easeIn((1 - p) * 2) / 2;
    };
    var ease = {
        easeIn: easeIn,
        easeOut: easeOut,
        easeInOut: easeInOut
    }, lowercaseName;
    $3e8f3adb9623a584$export$f9000b814859f126(names, function(name) {
        $3e8f3adb9623a584$var$_easeMap[name] = $3e8f3adb9623a584$var$_globals[name] = ease;
        $3e8f3adb9623a584$var$_easeMap[lowercaseName = name.toLowerCase()] = easeOut;
        for(var p in ease)$3e8f3adb9623a584$var$_easeMap[lowercaseName + (p === "easeIn" ? ".in" : p === "easeOut" ? ".out" : ".inOut")] = $3e8f3adb9623a584$var$_easeMap[name + "." + p] = ease[p];
    });
    return ease;
}, $3e8f3adb9623a584$var$_easeInOutFromOut = function _easeInOutFromOut(easeOut) {
    return function(p) {
        return p < .5 ? (1 - easeOut(1 - p * 2)) / 2 : .5 + easeOut((p - .5) * 2) / 2;
    };
}, $3e8f3adb9623a584$var$_configElastic = function _configElastic(type, amplitude, period) {
    var p1 = amplitude >= 1 ? amplitude : 1, //note: if amplitude is < 1, we simply adjust the period for a more natural feel. Otherwise the math doesn't work right and the curve starts at 1.
    p2 = (period || (type ? .3 : .45)) / (amplitude < 1 ? amplitude : 1), p3 = p2 / $3e8f3adb9623a584$var$_2PI * (Math.asin(1 / p1) || 0), easeOut = function easeOut(p) {
        return p === 1 ? 1 : p1 * Math.pow(2, -10 * p) * $3e8f3adb9623a584$var$_sin((p - p3) * p2) + 1;
    }, ease = type === "out" ? easeOut : type === "in" ? function(p) {
        return 1 - easeOut(1 - p);
    } : $3e8f3adb9623a584$var$_easeInOutFromOut(easeOut);
    p2 = $3e8f3adb9623a584$var$_2PI / p2; //precalculate to optimize
    ease.config = function(amplitude, period) {
        return _configElastic(type, amplitude, period);
    };
    return ease;
}, $3e8f3adb9623a584$var$_configBack = function _configBack(type, overshoot) {
    if (overshoot === void 0) overshoot = 1.70158;
    var easeOut = function easeOut(p) {
        return p ? --p * p * ((overshoot + 1) * p + overshoot) + 1 : 0;
    }, ease = type === "out" ? easeOut : type === "in" ? function(p) {
        return 1 - easeOut(1 - p);
    } : $3e8f3adb9623a584$var$_easeInOutFromOut(easeOut);
    ease.config = function(overshoot) {
        return _configBack(type, overshoot);
    };
    return ease;
}; // a cheaper (kb and cpu) but more mild way to get a parameterized weighted ease by feeding in a value between -1 (easeIn) and 1 (easeOut) where 0 is linear.
// _weightedEase = ratio => {
// 	let y = 0.5 + ratio / 2;
// 	return p => (2 * (1 - p) * p * y + p * p);
// },
// a stronger (but more expensive kb/cpu) parameterized weighted ease that lets you feed in a value between -1 (easeIn) and 1 (easeOut) where 0 is linear.
// _weightedEaseStrong = ratio => {
// 	ratio = .5 + ratio / 2;
// 	let o = 1 / 3 * (ratio < .5 ? ratio : 1 - ratio),
// 		b = ratio - o,
// 		c = ratio + o;
// 	return p => p === 1 ? p : 3 * b * (1 - p) * (1 - p) * p + 3 * c * (1 - p) * p * p + p * p * p;
// };
$3e8f3adb9623a584$export$f9000b814859f126("Linear,Quad,Cubic,Quart,Quint,Strong", function(name, i) {
    var power = i < 5 ? i + 1 : i;
    $3e8f3adb9623a584$var$_insertEase(name + ",Power" + (power - 1), i ? function(p) {
        return Math.pow(p, power);
    } : function(p) {
        return p;
    }, function(p) {
        return 1 - Math.pow(1 - p, power);
    }, function(p) {
        return p < .5 ? Math.pow(p * 2, power) / 2 : 1 - Math.pow((1 - p) * 2, power) / 2;
    });
});
$3e8f3adb9623a584$var$_easeMap.Linear.easeNone = $3e8f3adb9623a584$var$_easeMap.none = $3e8f3adb9623a584$var$_easeMap.Linear.easeIn;
$3e8f3adb9623a584$var$_insertEase("Elastic", $3e8f3adb9623a584$var$_configElastic("in"), $3e8f3adb9623a584$var$_configElastic("out"), $3e8f3adb9623a584$var$_configElastic());
(function(n, c) {
    var n1 = 1 / c, n2 = 2 * n1, n3 = 2.5 * n1, easeOut = function easeOut(p) {
        return p < n1 ? n * p * p : p < n2 ? n * Math.pow(p - 1.5 / c, 2) + .75 : p < n3 ? n * (p -= 2.25 / c) * p + .9375 : n * Math.pow(p - 2.625 / c, 2) + .984375;
    };
    $3e8f3adb9623a584$var$_insertEase("Bounce", function(p) {
        return 1 - easeOut(1 - p);
    }, easeOut);
})(7.5625, 2.75);
$3e8f3adb9623a584$var$_insertEase("Expo", function(p) {
    return p ? Math.pow(2, 10 * (p - 1)) : 0;
});
$3e8f3adb9623a584$var$_insertEase("Circ", function(p) {
    return -($3e8f3adb9623a584$var$_sqrt(1 - p * p) - 1);
});
$3e8f3adb9623a584$var$_insertEase("Sine", function(p) {
    return p === 1 ? 1 : -$3e8f3adb9623a584$var$_cos(p * $3e8f3adb9623a584$var$_HALF_PI) + 1;
});
$3e8f3adb9623a584$var$_insertEase("Back", $3e8f3adb9623a584$var$_configBack("in"), $3e8f3adb9623a584$var$_configBack("out"), $3e8f3adb9623a584$var$_configBack());
$3e8f3adb9623a584$var$_easeMap.SteppedEase = $3e8f3adb9623a584$var$_easeMap.steps = $3e8f3adb9623a584$var$_globals.SteppedEase = {
    config: function config(steps, immediateStart) {
        if (steps === void 0) steps = 1;
        var p1 = 1 / steps, p2 = steps + (immediateStart ? 0 : 1), p3 = immediateStart ? 1 : 0, max = 1 - $3e8f3adb9623a584$var$_tinyNum;
        return function(p) {
            return ((p2 * $3e8f3adb9623a584$var$_clamp(0, max, p) | 0) + p3) * p1;
        };
    }
};
$3e8f3adb9623a584$var$_defaults.ease = $3e8f3adb9623a584$var$_easeMap["quad.out"];
$3e8f3adb9623a584$export$f9000b814859f126("onComplete,onUpdate,onStart,onRepeat,onReverseComplete,onInterrupt", function(name) {
    return $3e8f3adb9623a584$var$_callbackNames += name + "," + name + "Params,";
});
var $3e8f3adb9623a584$export$cf10981d5419cad5 = function GSCache(target, harness) {
    this.id = $3e8f3adb9623a584$var$_gsID++;
    target._gsap = this;
    this.target = target;
    this.harness = harness;
    this.get = harness ? harness.get : $3e8f3adb9623a584$export$51d6bbe898aef1f9;
    this.set = harness ? harness.getSetter : $3e8f3adb9623a584$export$d60fbc1e0278aaf0;
};
var $3e8f3adb9623a584$export$c35d437ae5945fcd = /*#__PURE__*/ function() {
    function Animation(vars) {
        this.vars = vars;
        this._delay = +vars.delay || 0;
        if (this._repeat = vars.repeat === Infinity ? -2 : vars.repeat || 0) {
            // TODO: repeat: Infinity on a timeline's children must flag that timeline internally and affect its totalDuration, otherwise it'll stop in the negative direction when reaching the start.
            this._rDelay = vars.repeatDelay || 0;
            this._yoyo = !!vars.yoyo || !!vars.yoyoEase;
        }
        this._ts = 1;
        $3e8f3adb9623a584$var$_setDuration(this, +vars.duration, 1, 1);
        this.data = vars.data;
        if ($3e8f3adb9623a584$var$_context) {
            this._ctx = $3e8f3adb9623a584$var$_context;
            $3e8f3adb9623a584$var$_context.data.push(this);
        }
        $3e8f3adb9623a584$var$_tickerActive || $3e8f3adb9623a584$export$762ed8fbedb691e3.wake();
    }
    var _proto = Animation.prototype;
    _proto.delay = function delay(value) {
        if (value || value === 0) {
            this.parent && this.parent.smoothChildTiming && this.startTime(this._start + value - this._delay);
            this._delay = value;
            return this;
        }
        return this._delay;
    };
    _proto.duration = function duration(value) {
        return arguments.length ? this.totalDuration(this._repeat > 0 ? value + (value + this._rDelay) * this._repeat : value) : this.totalDuration() && this._dur;
    };
    _proto.totalDuration = function totalDuration(value) {
        if (!arguments.length) return this._tDur;
        this._dirty = 0;
        return $3e8f3adb9623a584$var$_setDuration(this, this._repeat < 0 ? value : (value - this._repeat * this._rDelay) / (this._repeat + 1));
    };
    _proto.totalTime = function totalTime(_totalTime, suppressEvents) {
        $3e8f3adb9623a584$var$_wake();
        if (!arguments.length) return this._tTime;
        var parent = this._dp;
        if (parent && parent.smoothChildTiming && this._ts) {
            $3e8f3adb9623a584$var$_alignPlayhead(this, _totalTime);
            !parent._dp || parent.parent || $3e8f3adb9623a584$var$_postAddChecks(parent, this); // edge case: if this is a child of a timeline that already completed, for example, we must re-activate the parent.
            //in case any of the ancestor timelines had completed but should now be enabled, we should reset their totalTime() which will also ensure that they're lined up properly and enabled. Skip for animations that are on the root (wasteful). Example: a TimelineLite.exportRoot() is performed when there's a paused tween on the root, the export will not complete until that tween is unpaused, but imagine a child gets restarted later, after all [unpaused] tweens have completed. The start of that child would get pushed out, but one of the ancestors may have completed.
            while(parent && parent.parent){
                if (parent.parent._time !== parent._start + (parent._ts >= 0 ? parent._tTime / parent._ts : (parent.totalDuration() - parent._tTime) / -parent._ts)) parent.totalTime(parent._tTime, true);
                parent = parent.parent;
            }
            if (!this.parent && this._dp.autoRemoveChildren && (this._ts > 0 && _totalTime < this._tDur || this._ts < 0 && _totalTime > 0 || !this._tDur && !_totalTime)) //if the animation doesn't have a parent, put it back into its last parent (recorded as _dp for exactly cases like this). Limit to parents with autoRemoveChildren (like globalTimeline) so that if the user manually removes an animation from a timeline and then alters its playhead, it doesn't get added back in.
            $3e8f3adb9623a584$var$_addToTimeline(this._dp, this, this._start - this._delay);
        }
        if (this._tTime !== _totalTime || !this._dur && !suppressEvents || this._initted && Math.abs(this._zTime) === $3e8f3adb9623a584$var$_tinyNum || !_totalTime && !this._initted && (this.add || this._ptLookup)) {
            // check for _ptLookup on a Tween instance to ensure it has actually finished being instantiated, otherwise if this.reverse() gets called in the Animation constructor, it could trigger a render() here even though the _targets weren't populated, thus when _init() is called there won't be any PropTweens (it'll act like the tween is non-functional)
            this._ts || (this._pTime = _totalTime); // otherwise, if an animation is paused, then the playhead is moved back to zero, then resumed, it'd revert back to the original time at the pause
            //if (!this._lock) { // avoid endless recursion (not sure we need this yet or if it's worth the performance hit)
            //   this._lock = 1;
            $3e8f3adb9623a584$var$_lazySafeRender(this, _totalTime, suppressEvents); //   this._lock = 0;
        //}
        }
        return this;
    };
    _proto.time = function time(value, suppressEvents) {
        return arguments.length ? this.totalTime(Math.min(this.totalDuration(), value + $3e8f3adb9623a584$var$_elapsedCycleDuration(this)) % (this._dur + this._rDelay) || (value ? this._dur : 0), suppressEvents) : this._time; // note: if the modulus results in 0, the playhead could be exactly at the end or the beginning, and we always defer to the END with a non-zero value, otherwise if you set the time() to the very end (duration()), it would render at the START!
    };
    _proto.totalProgress = function totalProgress(value, suppressEvents) {
        return arguments.length ? this.totalTime(this.totalDuration() * value, suppressEvents) : this.totalDuration() ? Math.min(1, this._tTime / this._tDur) : this.ratio;
    };
    _proto.progress = function progress(value, suppressEvents) {
        return arguments.length ? this.totalTime(this.duration() * (this._yoyo && !(this.iteration() & 1) ? 1 - value : value) + $3e8f3adb9623a584$var$_elapsedCycleDuration(this), suppressEvents) : this.duration() ? Math.min(1, this._time / this._dur) : this.ratio;
    };
    _proto.iteration = function iteration(value, suppressEvents) {
        var cycleDuration = this.duration() + this._rDelay;
        return arguments.length ? this.totalTime(this._time + (value - 1) * cycleDuration, suppressEvents) : this._repeat ? $3e8f3adb9623a584$var$_animationCycle(this._tTime, cycleDuration) + 1 : 1;
    } // potential future addition:
    ;
    _proto.timeScale = function timeScale(value) {
        if (!arguments.length) return this._rts === -$3e8f3adb9623a584$var$_tinyNum ? 0 : this._rts; // recorded timeScale. Special case: if someone calls reverse() on an animation with timeScale of 0, we assign it -_tinyNum to remember it's reversed.
        if (this._rts === value) return this;
        var tTime = this.parent && this._ts ? $3e8f3adb9623a584$var$_parentToChildTotalTime(this.parent._time, this) : this._tTime; // make sure to do the parentToChildTotalTime() BEFORE setting the new _ts because the old one must be used in that calculation.
        // future addition? Up side: fast and minimal file size. Down side: only works on this animation; if a timeline is reversed, for example, its childrens' onReverse wouldn't get called.
        //(+value < 0 && this._rts >= 0) && _callback(this, "onReverse", true);
        // prioritize rendering where the parent's playhead lines up instead of this._tTime because there could be a tween that's animating another tween's timeScale in the same rendering loop (same parent), thus if the timeScale tween renders first, it would alter _start BEFORE _tTime was set on that tick (in the rendering loop), effectively freezing it until the timeScale tween finishes.
        this._rts = +value || 0;
        this._ts = this._ps || value === -$3e8f3adb9623a584$var$_tinyNum ? 0 : this._rts; // _ts is the functional timeScale which would be 0 if the animation is paused.
        this.totalTime($3e8f3adb9623a584$var$_clamp(-Math.abs(this._delay), this._tDur, tTime), true);
        $3e8f3adb9623a584$var$_setEnd(this); // if parent.smoothChildTiming was false, the end time didn't get updated in the _alignPlayhead() method, so do it here.
        return $3e8f3adb9623a584$var$_recacheAncestors(this);
    };
    _proto.paused = function paused(value) {
        if (!arguments.length) return this._ps;
        if (this._ps !== value) {
            this._ps = value;
            if (value) {
                this._pTime = this._tTime || Math.max(-this._delay, this.rawTime()); // if the pause occurs during the delay phase, make sure that's factored in when resuming.
                this._ts = this._act = 0; // _ts is the functional timeScale, so a paused tween would effectively have a timeScale of 0. We record the "real" timeScale as _rts (recorded time scale)
            } else {
                $3e8f3adb9623a584$var$_wake();
                this._ts = this._rts; //only defer to _pTime (pauseTime) if tTime is zero. Remember, someone could pause() an animation, then scrub the playhead and resume(). If the parent doesn't have smoothChildTiming, we render at the rawTime() because the startTime won't get updated.
                this.totalTime(this.parent && !this.parent.smoothChildTiming ? this.rawTime() : this._tTime || this._pTime, this.progress() === 1 && Math.abs(this._zTime) !== $3e8f3adb9623a584$var$_tinyNum && (this._tTime -= $3e8f3adb9623a584$var$_tinyNum)); // edge case: animation.progress(1).pause().play() wouldn't render again because the playhead is already at the end, but the call to totalTime() below will add it back to its parent...and not remove it again (since removing only happens upon rendering at a new time). Offsetting the _tTime slightly is done simply to cause the final render in totalTime() that'll pop it off its timeline (if autoRemoveChildren is true, of course). Check to make sure _zTime isn't -_tinyNum to avoid an edge case where the playhead is pushed to the end but INSIDE a tween/callback, the timeline itself is paused thus halting rendering and leaving a few unrendered. When resuming, it wouldn't render those otherwise.
            }
        }
        return this;
    };
    _proto.startTime = function startTime(value) {
        if (arguments.length) {
            this._start = value;
            var parent = this.parent || this._dp;
            parent && (parent._sort || !this.parent) && $3e8f3adb9623a584$var$_addToTimeline(parent, this, value - this._delay);
            return this;
        }
        return this._start;
    };
    _proto.endTime = function endTime(includeRepeats) {
        return this._start + ($3e8f3adb9623a584$var$_isNotFalse(includeRepeats) ? this.totalDuration() : this.duration()) / Math.abs(this._ts || 1);
    };
    _proto.rawTime = function rawTime(wrapRepeats) {
        var parent = this.parent || this._dp; // _dp = detached parent
        return !parent ? this._tTime : wrapRepeats && (!this._ts || this._repeat && this._time && this.totalProgress() < 1) ? this._tTime % (this._dur + this._rDelay) : !this._ts ? this._tTime : $3e8f3adb9623a584$var$_parentToChildTotalTime(parent.rawTime(wrapRepeats), this);
    };
    _proto.revert = function revert(config) {
        if (config === void 0) config = $3e8f3adb9623a584$var$_revertConfig;
        var prevIsReverting = $3e8f3adb9623a584$var$_reverting;
        $3e8f3adb9623a584$var$_reverting = config;
        if (this._initted || this._startAt) {
            this.timeline && this.timeline.revert(config);
            this.totalTime(-0.01, config.suppressEvents);
        }
        this.data !== "nested" && config.kill !== false && this.kill();
        $3e8f3adb9623a584$var$_reverting = prevIsReverting;
        return this;
    };
    _proto.globalTime = function globalTime(rawTime) {
        var animation = this, time = arguments.length ? rawTime : animation.rawTime();
        while(animation){
            time = animation._start + time / (animation._ts || 1);
            animation = animation._dp;
        }
        return !this.parent && this._sat ? this._sat.vars.immediateRender ? -Infinity : this._sat.globalTime(rawTime) : time; // the _startAt tweens for .fromTo() and .from() that have immediateRender should always be FIRST in the timeline (important for context.revert()). "_sat" stands for _startAtTween, referring to the parent tween that created the _startAt. We must discern if that tween had immediateRender so that we can know whether or not to prioritize it in revert().
    };
    _proto.repeat = function repeat(value) {
        if (arguments.length) {
            this._repeat = value === Infinity ? -2 : value;
            return $3e8f3adb9623a584$var$_onUpdateTotalDuration(this);
        }
        return this._repeat === -2 ? Infinity : this._repeat;
    };
    _proto.repeatDelay = function repeatDelay(value) {
        if (arguments.length) {
            var time = this._time;
            this._rDelay = value;
            $3e8f3adb9623a584$var$_onUpdateTotalDuration(this);
            return time ? this.time(time) : this;
        }
        return this._rDelay;
    };
    _proto.yoyo = function yoyo(value) {
        if (arguments.length) {
            this._yoyo = value;
            return this;
        }
        return this._yoyo;
    };
    _proto.seek = function seek(position, suppressEvents) {
        return this.totalTime($3e8f3adb9623a584$var$_parsePosition(this, position), $3e8f3adb9623a584$var$_isNotFalse(suppressEvents));
    };
    _proto.restart = function restart(includeDelay, suppressEvents) {
        return this.play().totalTime(includeDelay ? -this._delay : 0, $3e8f3adb9623a584$var$_isNotFalse(suppressEvents));
    };
    _proto.play = function play(from, suppressEvents) {
        from != null && this.seek(from, suppressEvents);
        return this.reversed(false).paused(false);
    };
    _proto.reverse = function reverse(from, suppressEvents) {
        from != null && this.seek(from || this.totalDuration(), suppressEvents);
        return this.reversed(true).paused(false);
    };
    _proto.pause = function pause(atTime, suppressEvents) {
        atTime != null && this.seek(atTime, suppressEvents);
        return this.paused(true);
    };
    _proto.resume = function resume() {
        return this.paused(false);
    };
    _proto.reversed = function reversed(value) {
        if (arguments.length) {
            !!value !== this.reversed() && this.timeScale(-this._rts || (value ? -$3e8f3adb9623a584$var$_tinyNum : 0)); // in case timeScale is zero, reversing would have no effect so we use _tinyNum.
            return this;
        }
        return this._rts < 0;
    };
    _proto.invalidate = function invalidate() {
        this._initted = this._act = 0;
        this._zTime = -$3e8f3adb9623a584$var$_tinyNum;
        return this;
    };
    _proto.isActive = function isActive() {
        var parent = this.parent || this._dp, start = this._start, rawTime;
        return !!(!parent || this._ts && this._initted && parent.isActive() && (rawTime = parent.rawTime(true)) >= start && rawTime < this.endTime(true) - $3e8f3adb9623a584$var$_tinyNum);
    };
    _proto.eventCallback = function eventCallback(type, callback, params) {
        var vars = this.vars;
        if (arguments.length > 1) {
            if (!callback) delete vars[type];
            else {
                vars[type] = callback;
                params && (vars[type + "Params"] = params);
                type === "onUpdate" && (this._onUpdate = callback);
            }
            return this;
        }
        return vars[type];
    };
    _proto.then = function then(onFulfilled) {
        var self = this;
        return new Promise(function(resolve) {
            var f = $3e8f3adb9623a584$var$_isFunction(onFulfilled) ? onFulfilled : $3e8f3adb9623a584$var$_passThrough, _resolve = function _resolve() {
                var _then = self.then;
                self.then = null; // temporarily null the then() method to avoid an infinite loop (see https://github.com/greensock/GSAP/issues/322)
                $3e8f3adb9623a584$var$_isFunction(f) && (f = f(self)) && (f.then || f === self) && (self.then = _then);
                resolve(f);
                self.then = _then;
            };
            if (self._initted && self.totalProgress() === 1 && self._ts >= 0 || !self._tTime && self._ts < 0) _resolve();
            else self._prom = _resolve;
        });
    };
    _proto.kill = function kill() {
        $3e8f3adb9623a584$var$_interrupt(this);
    };
    return Animation;
}();
$3e8f3adb9623a584$export$dc2b19673bb53610($3e8f3adb9623a584$export$c35d437ae5945fcd.prototype, {
    _time: 0,
    _start: 0,
    _end: 0,
    _tTime: 0,
    _tDur: 0,
    _dirty: 0,
    _repeat: 0,
    _yoyo: false,
    parent: null,
    _initted: false,
    _rDelay: 0,
    _ts: 1,
    _dp: 0,
    ratio: 0,
    _zTime: -$3e8f3adb9623a584$var$_tinyNum,
    _prom: 0,
    _ps: false,
    _rts: 1
});
var $3e8f3adb9623a584$export$e6a97ba2cae5bb94 = /*#__PURE__*/ function(_Animation) {
    $3e8f3adb9623a584$var$_inheritsLoose(Timeline, _Animation);
    function Timeline(vars, position) {
        var _this;
        if (vars === void 0) vars = {};
        _this = _Animation.call(this, vars) || this;
        _this.labels = {};
        _this.smoothChildTiming = !!vars.smoothChildTiming;
        _this.autoRemoveChildren = !!vars.autoRemoveChildren;
        _this._sort = $3e8f3adb9623a584$var$_isNotFalse(vars.sortChildren);
        $3e8f3adb9623a584$var$_globalTimeline && $3e8f3adb9623a584$var$_addToTimeline(vars.parent || $3e8f3adb9623a584$var$_globalTimeline, $3e8f3adb9623a584$var$_assertThisInitialized(_this), position);
        vars.reversed && _this.reverse();
        vars.paused && _this.paused(true);
        vars.scrollTrigger && $3e8f3adb9623a584$var$_scrollTrigger($3e8f3adb9623a584$var$_assertThisInitialized(_this), vars.scrollTrigger);
        return _this;
    }
    var _proto2 = Timeline.prototype;
    _proto2.to = function to(targets, vars, position) {
        $3e8f3adb9623a584$var$_createTweenType(0, arguments, this);
        return this;
    };
    _proto2.from = function from(targets, vars, position) {
        $3e8f3adb9623a584$var$_createTweenType(1, arguments, this);
        return this;
    };
    _proto2.fromTo = function fromTo(targets, fromVars, toVars, position) {
        $3e8f3adb9623a584$var$_createTweenType(2, arguments, this);
        return this;
    };
    _proto2.set = function set(targets, vars, position) {
        vars.duration = 0;
        vars.parent = this;
        $3e8f3adb9623a584$var$_inheritDefaults(vars).repeatDelay || (vars.repeat = 0);
        vars.immediateRender = !!vars.immediateRender;
        new $3e8f3adb9623a584$export$208a41d6b4e37b97(targets, vars, $3e8f3adb9623a584$var$_parsePosition(this, position), 1);
        return this;
    };
    _proto2.call = function call(callback, params, position) {
        return $3e8f3adb9623a584$var$_addToTimeline(this, $3e8f3adb9623a584$export$208a41d6b4e37b97.delayedCall(0, callback, params), position);
    } //ONLY for backward compatibility! Maybe delete?
    ;
    _proto2.staggerTo = function staggerTo(targets, duration, vars, stagger, position, onCompleteAll, onCompleteAllParams) {
        vars.duration = duration;
        vars.stagger = vars.stagger || stagger;
        vars.onComplete = onCompleteAll;
        vars.onCompleteParams = onCompleteAllParams;
        vars.parent = this;
        new $3e8f3adb9623a584$export$208a41d6b4e37b97(targets, vars, $3e8f3adb9623a584$var$_parsePosition(this, position));
        return this;
    };
    _proto2.staggerFrom = function staggerFrom(targets, duration, vars, stagger, position, onCompleteAll, onCompleteAllParams) {
        vars.runBackwards = 1;
        $3e8f3adb9623a584$var$_inheritDefaults(vars).immediateRender = $3e8f3adb9623a584$var$_isNotFalse(vars.immediateRender);
        return this.staggerTo(targets, duration, vars, stagger, position, onCompleteAll, onCompleteAllParams);
    };
    _proto2.staggerFromTo = function staggerFromTo(targets, duration, fromVars, toVars, stagger, position, onCompleteAll, onCompleteAllParams) {
        toVars.startAt = fromVars;
        $3e8f3adb9623a584$var$_inheritDefaults(toVars).immediateRender = $3e8f3adb9623a584$var$_isNotFalse(toVars.immediateRender);
        return this.staggerTo(targets, duration, toVars, stagger, position, onCompleteAll, onCompleteAllParams);
    };
    _proto2.render = function render(totalTime, suppressEvents, force) {
        var prevTime = this._time, tDur = this._dirty ? this.totalDuration() : this._tDur, dur = this._dur, tTime = totalTime <= 0 ? 0 : $3e8f3adb9623a584$var$_roundPrecise(totalTime), // if a paused timeline is resumed (or its _start is updated for another reason...which rounds it), that could result in the playhead shifting a **tiny** amount and a zero-duration child at that spot may get rendered at a different ratio, like its totalTime in render() may be 1e-17 instead of 0, for example.
        crossingStart = this._zTime < 0 !== totalTime < 0 && (this._initted || !dur), time, child, next, iteration, cycleDuration, prevPaused, pauseTween, timeScale, prevStart, prevIteration, yoyo, isYoyo;
        this !== $3e8f3adb9623a584$var$_globalTimeline && tTime > tDur && totalTime >= 0 && (tTime = tDur);
        if (tTime !== this._tTime || force || crossingStart) {
            if (prevTime !== this._time && dur) {
                //if totalDuration() finds a child with a negative startTime and smoothChildTiming is true, things get shifted around internally so we need to adjust the time accordingly. For example, if a tween starts at -30 we must shift EVERYTHING forward 30 seconds and move this timeline's startTime backward by 30 seconds so that things align with the playhead (no jump).
                tTime += this._time - prevTime;
                totalTime += this._time - prevTime;
            }
            time = tTime;
            prevStart = this._start;
            timeScale = this._ts;
            prevPaused = !timeScale;
            if (crossingStart) {
                dur || (prevTime = this._zTime); //when the playhead arrives at EXACTLY time 0 (right on top) of a zero-duration timeline, we need to discern if events are suppressed so that when the playhead moves again (next time), it'll trigger the callback. If events are NOT suppressed, obviously the callback would be triggered in this render. Basically, the callback should fire either when the playhead ARRIVES or LEAVES this exact spot, not both. Imagine doing a timeline.seek(0) and there's a callback that sits at 0. Since events are suppressed on that seek() by default, nothing will fire, but when the playhead moves off of that position, the callback should fire. This behavior is what people intuitively expect.
                (totalTime || !suppressEvents) && (this._zTime = totalTime);
            }
            if (this._repeat) {
                //adjust the time for repeats and yoyos
                yoyo = this._yoyo;
                cycleDuration = dur + this._rDelay;
                if (this._repeat < -1 && totalTime < 0) return this.totalTime(cycleDuration * 100 + totalTime, suppressEvents, force);
                time = $3e8f3adb9623a584$var$_roundPrecise(tTime % cycleDuration); //round to avoid floating point errors. (4 % 0.8 should be 0 but some browsers report it as 0.79999999!)
                if (tTime === tDur) {
                    // the tDur === tTime is for edge cases where there's a lengthy decimal on the duration and it may reach the very end but the time is rendered as not-quite-there (remember, tDur is rounded to 4 decimals whereas dur isn't)
                    iteration = this._repeat;
                    time = dur;
                } else {
                    iteration = ~~(tTime / cycleDuration);
                    if (iteration && iteration === tTime / cycleDuration) {
                        time = dur;
                        iteration--;
                    }
                    time > dur && (time = dur);
                }
                prevIteration = $3e8f3adb9623a584$var$_animationCycle(this._tTime, cycleDuration);
                !prevTime && this._tTime && prevIteration !== iteration && this._tTime - prevIteration * cycleDuration - this._dur <= 0 && (prevIteration = iteration); // edge case - if someone does addPause() at the very beginning of a repeating timeline, that pause is technically at the same spot as the end which causes this._time to get set to 0 when the totalTime would normally place the playhead at the end. See https://greensock.com/forums/topic/23823-closing-nav-animation-not-working-on-ie-and-iphone-6-maybe-other-older-browser/?tab=comments#comment-113005 also, this._tTime - prevIteration * cycleDuration - this._dur <= 0 just checks to make sure it wasn't previously in the "repeatDelay" portion
                if (yoyo && iteration & 1) {
                    time = dur - time;
                    isYoyo = 1;
                }
                /*
        make sure children at the end/beginning of the timeline are rendered properly. If, for example,
        a 3-second long timeline rendered at 2.9 seconds previously, and now renders at 3.2 seconds (which
        would get translated to 2.8 seconds if the timeline yoyos or 0.2 seconds if it just repeats), there
        could be a callback or a short tween that's at 2.95 or 3 seconds in which wouldn't render. So
        we need to push the timeline to the end (and/or beginning depending on its yoyo value). Also we must
        ensure that zero-duration tweens at the very beginning or end of the Timeline work.
        */ if (iteration !== prevIteration && !this._lock) {
                    var rewinding = yoyo && prevIteration & 1, doesWrap = rewinding === (yoyo && iteration & 1);
                    iteration < prevIteration && (rewinding = !rewinding);
                    prevTime = rewinding ? 0 : tTime % dur ? dur : tTime; // if the playhead is landing exactly at the end of an iteration, use that totalTime rather than only the duration, otherwise it'll skip the 2nd render since it's effectively at the same time.
                    this._lock = 1;
                    this.render(prevTime || (isYoyo ? 0 : $3e8f3adb9623a584$var$_roundPrecise(iteration * cycleDuration)), suppressEvents, !dur)._lock = 0;
                    this._tTime = tTime; // if a user gets the iteration() inside the onRepeat, for example, it should be accurate.
                    !suppressEvents && this.parent && $3e8f3adb9623a584$var$_callback(this, "onRepeat");
                    this.vars.repeatRefresh && !isYoyo && (this.invalidate()._lock = 1);
                    if (prevTime && prevTime !== this._time || prevPaused !== !this._ts || this.vars.onRepeat && !this.parent && !this._act) // if prevTime is 0 and we render at the very end, _time will be the end, thus won't match. So in this edge case, prevTime won't match _time but that's okay. If it gets killed in the onRepeat, eject as well.
                    return this;
                    dur = this._dur; // in case the duration changed in the onRepeat
                    tDur = this._tDur;
                    if (doesWrap) {
                        this._lock = 2;
                        prevTime = rewinding ? dur : -0.0001;
                        this.render(prevTime, true);
                        this.vars.repeatRefresh && !isYoyo && this.invalidate();
                    }
                    this._lock = 0;
                    if (!this._ts && !prevPaused) return this;
                     //in order for yoyoEase to work properly when there's a stagger, we must swap out the ease in each sub-tween.
                    $3e8f3adb9623a584$var$_propagateYoyoEase(this, isYoyo);
                }
            }
            if (this._hasPause && !this._forcing && this._lock < 2) {
                pauseTween = $3e8f3adb9623a584$var$_findNextPauseTween(this, $3e8f3adb9623a584$var$_roundPrecise(prevTime), $3e8f3adb9623a584$var$_roundPrecise(time));
                if (pauseTween) tTime -= time - (time = pauseTween._start);
            }
            this._tTime = tTime;
            this._time = time;
            this._act = !timeScale; //as long as it's not paused, force it to be active so that if the user renders independent of the parent timeline, it'll be forced to re-render on the next tick.
            if (!this._initted) {
                this._onUpdate = this.vars.onUpdate;
                this._initted = 1;
                this._zTime = totalTime;
                prevTime = 0; // upon init, the playhead should always go forward; someone could invalidate() a completed timeline and then if they restart(), that would make child tweens render in reverse order which could lock in the wrong starting values if they build on each other, like tl.to(obj, {x: 100}).to(obj, {x: 0}).
            }
            if (!prevTime && time && !suppressEvents && !iteration) {
                $3e8f3adb9623a584$var$_callback(this, "onStart");
                if (this._tTime !== tTime) // in case the onStart triggered a render at a different spot, eject. Like if someone did animation.pause(0.5) or something inside the onStart.
                return this;
            }
            if (time >= prevTime && totalTime >= 0) {
                child = this._first;
                while(child){
                    next = child._next;
                    if ((child._act || time >= child._start) && child._ts && pauseTween !== child) {
                        if (child.parent !== this) // an extreme edge case - the child's render could do something like kill() the "next" one in the linked list, or reparent it. In that case we must re-initiate the whole render to be safe.
                        return this.render(totalTime, suppressEvents, force);
                        child.render(child._ts > 0 ? (time - child._start) * child._ts : (child._dirty ? child.totalDuration() : child._tDur) + (time - child._start) * child._ts, suppressEvents, force);
                        if (time !== this._time || !this._ts && !prevPaused) {
                            //in case a tween pauses or seeks the timeline when rendering, like inside of an onUpdate/onComplete
                            pauseTween = 0;
                            next && (tTime += this._zTime = -$3e8f3adb9623a584$var$_tinyNum); // it didn't finish rendering, so flag zTime as negative so that so that the next time render() is called it'll be forced (to render any remaining children)
                            break;
                        }
                    }
                    child = next;
                }
            } else {
                child = this._last;
                var adjustedTime = totalTime < 0 ? totalTime : time; //when the playhead goes backward beyond the start of this timeline, we must pass that information down to the child animations so that zero-duration tweens know whether to render their starting or ending values.
                while(child){
                    next = child._prev;
                    if ((child._act || adjustedTime <= child._end) && child._ts && pauseTween !== child) {
                        if (child.parent !== this) // an extreme edge case - the child's render could do something like kill() the "next" one in the linked list, or reparent it. In that case we must re-initiate the whole render to be safe.
                        return this.render(totalTime, suppressEvents, force);
                        child.render(child._ts > 0 ? (adjustedTime - child._start) * child._ts : (child._dirty ? child.totalDuration() : child._tDur) + (adjustedTime - child._start) * child._ts, suppressEvents, force || $3e8f3adb9623a584$var$_reverting && (child._initted || child._startAt)); // if reverting, we should always force renders of initted tweens (but remember that .fromTo() or .from() may have a _startAt but not _initted yet). If, for example, a .fromTo() tween with a stagger (which creates an internal timeline) gets reverted BEFORE some of its child tweens render for the first time, it may not properly trigger them to revert.
                        if (time !== this._time || !this._ts && !prevPaused) {
                            //in case a tween pauses or seeks the timeline when rendering, like inside of an onUpdate/onComplete
                            pauseTween = 0;
                            next && (tTime += this._zTime = adjustedTime ? -$3e8f3adb9623a584$var$_tinyNum : $3e8f3adb9623a584$var$_tinyNum); // it didn't finish rendering, so adjust zTime so that so that the next time render() is called it'll be forced (to render any remaining children)
                            break;
                        }
                    }
                    child = next;
                }
            }
            if (pauseTween && !suppressEvents) {
                this.pause();
                pauseTween.render(time >= prevTime ? 0 : -$3e8f3adb9623a584$var$_tinyNum)._zTime = time >= prevTime ? 1 : -1;
                if (this._ts) {
                    //the callback resumed playback! So since we may have held back the playhead due to where the pause is positioned, go ahead and jump to where it's SUPPOSED to be (if no pause happened).
                    this._start = prevStart; //if the pause was at an earlier time and the user resumed in the callback, it could reposition the timeline (changing its startTime), throwing things off slightly, so we make sure the _start doesn't shift.
                    $3e8f3adb9623a584$var$_setEnd(this);
                    return this.render(totalTime, suppressEvents, force);
                }
            }
            this._onUpdate && !suppressEvents && $3e8f3adb9623a584$var$_callback(this, "onUpdate", true);
            if (tTime === tDur && this._tTime >= this.totalDuration() || !tTime && prevTime) {
                if (prevStart === this._start || Math.abs(timeScale) !== Math.abs(this._ts)) {
                    if (!this._lock) {
                        // remember, a child's callback may alter this timeline's playhead or timeScale which is why we need to add some of these checks.
                        (totalTime || !dur) && (tTime === tDur && this._ts > 0 || !tTime && this._ts < 0) && $3e8f3adb9623a584$var$_removeFromParent(this, 1); // don't remove if the timeline is reversed and the playhead isn't at 0, otherwise tl.progress(1).reverse() won't work. Only remove if the playhead is at the end and timeScale is positive, or if the playhead is at 0 and the timeScale is negative.
                        if (!suppressEvents && !(totalTime < 0 && !prevTime) && (tTime || prevTime || !tDur)) {
                            $3e8f3adb9623a584$var$_callback(this, tTime === tDur && totalTime >= 0 ? "onComplete" : "onReverseComplete", true);
                            this._prom && !(tTime < tDur && this.timeScale() > 0) && this._prom();
                        }
                    }
                }
            }
        }
        return this;
    };
    _proto2.add = function add(child, position) {
        var _this2 = this;
        $3e8f3adb9623a584$var$_isNumber(position) || (position = $3e8f3adb9623a584$var$_parsePosition(this, position, child));
        if (!(child instanceof $3e8f3adb9623a584$export$c35d437ae5945fcd)) {
            if ($3e8f3adb9623a584$var$_isArray(child)) {
                child.forEach(function(obj) {
                    return _this2.add(obj, position);
                });
                return this;
            }
            if ($3e8f3adb9623a584$export$f664476fd67145ca(child)) return this.addLabel(child, position);
            if ($3e8f3adb9623a584$var$_isFunction(child)) child = $3e8f3adb9623a584$export$208a41d6b4e37b97.delayedCall(0, child);
            else return this;
        }
        return this !== child ? $3e8f3adb9623a584$var$_addToTimeline(this, child, position) : this; //don't allow a timeline to be added to itself as a child!
    };
    _proto2.getChildren = function getChildren(nested, tweens, timelines, ignoreBeforeTime) {
        if (nested === void 0) nested = true;
        if (tweens === void 0) tweens = true;
        if (timelines === void 0) timelines = true;
        if (ignoreBeforeTime === void 0) ignoreBeforeTime = -$3e8f3adb9623a584$var$_bigNum;
        var a = [], child = this._first;
        while(child){
            if (child._start >= ignoreBeforeTime) {
                if (child instanceof $3e8f3adb9623a584$export$208a41d6b4e37b97) tweens && a.push(child);
                else {
                    timelines && a.push(child);
                    nested && a.push.apply(a, child.getChildren(true, tweens, timelines));
                }
            }
            child = child._next;
        }
        return a;
    };
    _proto2.getById = function getById(id) {
        var animations = this.getChildren(1, 1, 1), i = animations.length;
        while(i--){
            if (animations[i].vars.id === id) return animations[i];
        }
    };
    _proto2.remove = function remove(child) {
        if ($3e8f3adb9623a584$export$f664476fd67145ca(child)) return this.removeLabel(child);
        if ($3e8f3adb9623a584$var$_isFunction(child)) return this.killTweensOf(child);
        $3e8f3adb9623a584$export$cd008aa6cd8844e3(this, child);
        if (child === this._recent) this._recent = this._last;
        return $3e8f3adb9623a584$var$_uncache(this);
    };
    _proto2.totalTime = function totalTime(_totalTime2, suppressEvents) {
        if (!arguments.length) return this._tTime;
        this._forcing = 1;
        if (!this._dp && this._ts) //special case for the global timeline (or any other that has no parent or detached parent).
        this._start = $3e8f3adb9623a584$var$_roundPrecise($3e8f3adb9623a584$export$762ed8fbedb691e3.time - (this._ts > 0 ? _totalTime2 / this._ts : (this.totalDuration() - _totalTime2) / -this._ts));
        _Animation.prototype.totalTime.call(this, _totalTime2, suppressEvents);
        this._forcing = 0;
        return this;
    };
    _proto2.addLabel = function addLabel(label, position) {
        this.labels[label] = $3e8f3adb9623a584$var$_parsePosition(this, position);
        return this;
    };
    _proto2.removeLabel = function removeLabel(label) {
        delete this.labels[label];
        return this;
    };
    _proto2.addPause = function addPause(position, callback, params) {
        var t = $3e8f3adb9623a584$export$208a41d6b4e37b97.delayedCall(0, callback || $3e8f3adb9623a584$var$_emptyFunc, params);
        t.data = "isPause";
        this._hasPause = 1;
        return $3e8f3adb9623a584$var$_addToTimeline(this, t, $3e8f3adb9623a584$var$_parsePosition(this, position));
    };
    _proto2.removePause = function removePause(position) {
        var child = this._first;
        position = $3e8f3adb9623a584$var$_parsePosition(this, position);
        while(child){
            if (child._start === position && child.data === "isPause") $3e8f3adb9623a584$var$_removeFromParent(child);
            child = child._next;
        }
    };
    _proto2.killTweensOf = function killTweensOf(targets, props, onlyActive) {
        var tweens = this.getTweensOf(targets, onlyActive), i = tweens.length;
        while(i--)$3e8f3adb9623a584$var$_overwritingTween !== tweens[i] && tweens[i].kill(targets, props);
        return this;
    };
    _proto2.getTweensOf = function getTweensOf(targets, onlyActive) {
        var a = [], parsedTargets = $3e8f3adb9623a584$export$45b10814cc054894(targets), child = this._first, isGlobalTime = $3e8f3adb9623a584$var$_isNumber(onlyActive), // a number is interpreted as a global time. If the animation spans
        children;
        while(child){
            if (child instanceof $3e8f3adb9623a584$export$208a41d6b4e37b97) {
                if ($3e8f3adb9623a584$var$_arrayContainsAny(child._targets, parsedTargets) && (isGlobalTime ? (!$3e8f3adb9623a584$var$_overwritingTween || child._initted && child._ts) && child.globalTime(0) <= onlyActive && child.globalTime(child.totalDuration()) > onlyActive : !onlyActive || child.isActive())) // note: if this is for overwriting, it should only be for tweens that aren't paused and are initted.
                a.push(child);
            } else if ((children = child.getTweensOf(parsedTargets, onlyActive)).length) a.push.apply(a, children);
            child = child._next;
        }
        return a;
    } // potential future feature - targets() on timelines
    ;
    _proto2.tweenTo = function tweenTo(position, vars) {
        vars = vars || {};
        var tl = this, endTime = $3e8f3adb9623a584$var$_parsePosition(tl, position), _vars = vars, startAt = _vars.startAt, _onStart = _vars.onStart, onStartParams = _vars.onStartParams, immediateRender = _vars.immediateRender, initted, tween = $3e8f3adb9623a584$export$208a41d6b4e37b97.to(tl, $3e8f3adb9623a584$export$dc2b19673bb53610({
            ease: vars.ease || "none",
            lazy: false,
            immediateRender: false,
            time: endTime,
            overwrite: "auto",
            duration: vars.duration || Math.abs((endTime - (startAt && "time" in startAt ? startAt.time : tl._time)) / tl.timeScale()) || $3e8f3adb9623a584$var$_tinyNum,
            onStart: function onStart() {
                tl.pause();
                if (!initted) {
                    var duration = vars.duration || Math.abs((endTime - (startAt && "time" in startAt ? startAt.time : tl._time)) / tl.timeScale());
                    tween._dur !== duration && $3e8f3adb9623a584$var$_setDuration(tween, duration, 0, 1).render(tween._time, true, true);
                    initted = 1;
                }
                _onStart && _onStart.apply(tween, onStartParams || []); //in case the user had an onStart in the vars - we don't want to overwrite it.
            }
        }, vars));
        return immediateRender ? tween.render(0) : tween;
    };
    _proto2.tweenFromTo = function tweenFromTo(fromPosition, toPosition, vars) {
        return this.tweenTo(toPosition, $3e8f3adb9623a584$export$dc2b19673bb53610({
            startAt: {
                time: $3e8f3adb9623a584$var$_parsePosition(this, fromPosition)
            }
        }, vars));
    };
    _proto2.recent = function recent() {
        return this._recent;
    };
    _proto2.nextLabel = function nextLabel(afterTime) {
        if (afterTime === void 0) afterTime = this._time;
        return $3e8f3adb9623a584$var$_getLabelInDirection(this, $3e8f3adb9623a584$var$_parsePosition(this, afterTime));
    };
    _proto2.previousLabel = function previousLabel(beforeTime) {
        if (beforeTime === void 0) beforeTime = this._time;
        return $3e8f3adb9623a584$var$_getLabelInDirection(this, $3e8f3adb9623a584$var$_parsePosition(this, beforeTime), 1);
    };
    _proto2.currentLabel = function currentLabel(value) {
        return arguments.length ? this.seek(value, true) : this.previousLabel(this._time + $3e8f3adb9623a584$var$_tinyNum);
    };
    _proto2.shiftChildren = function shiftChildren(amount, adjustLabels, ignoreBeforeTime) {
        if (ignoreBeforeTime === void 0) ignoreBeforeTime = 0;
        var child = this._first, labels = this.labels, p;
        while(child){
            if (child._start >= ignoreBeforeTime) {
                child._start += amount;
                child._end += amount;
            }
            child = child._next;
        }
        if (adjustLabels) {
            for(p in labels)if (labels[p] >= ignoreBeforeTime) labels[p] += amount;
        }
        return $3e8f3adb9623a584$var$_uncache(this);
    };
    _proto2.invalidate = function invalidate(soft) {
        var child = this._first;
        this._lock = 0;
        while(child){
            child.invalidate(soft);
            child = child._next;
        }
        return _Animation.prototype.invalidate.call(this, soft);
    };
    _proto2.clear = function clear(includeLabels) {
        if (includeLabels === void 0) includeLabels = true;
        var child = this._first, next;
        while(child){
            next = child._next;
            this.remove(child);
            child = next;
        }
        this._dp && (this._time = this._tTime = this._pTime = 0);
        includeLabels && (this.labels = {});
        return $3e8f3adb9623a584$var$_uncache(this);
    };
    _proto2.totalDuration = function totalDuration(value) {
        var max = 0, self = this, child = self._last, prevStart = $3e8f3adb9623a584$var$_bigNum, prev, start, parent;
        if (arguments.length) return self.timeScale((self._repeat < 0 ? self.duration() : self.totalDuration()) / (self.reversed() ? -value : value));
        if (self._dirty) {
            parent = self.parent;
            while(child){
                prev = child._prev; //record it here in case the tween changes position in the sequence...
                child._dirty && child.totalDuration(); //could change the tween._startTime, so make sure the animation's cache is clean before analyzing it.
                start = child._start;
                if (start > prevStart && self._sort && child._ts && !self._lock) {
                    //in case one of the tweens shifted out of order, it needs to be re-inserted into the correct position in the sequence
                    self._lock = 1; //prevent endless recursive calls - there are methods that get triggered that check duration/totalDuration when we add().
                    $3e8f3adb9623a584$var$_addToTimeline(self, child, start - child._delay, 1)._lock = 0;
                } else prevStart = start;
                if (start < 0 && child._ts) {
                    //children aren't allowed to have negative startTimes unless smoothChildTiming is true, so adjust here if one is found.
                    max -= start;
                    if (!parent && !self._dp || parent && parent.smoothChildTiming) {
                        self._start += start / self._ts;
                        self._time -= start;
                        self._tTime -= start;
                    }
                    self.shiftChildren(-start, false, -Infinity);
                    prevStart = 0;
                }
                child._end > max && child._ts && (max = child._end);
                child = prev;
            }
            $3e8f3adb9623a584$var$_setDuration(self, self === $3e8f3adb9623a584$var$_globalTimeline && self._time > max ? self._time : max, 1, 1);
            self._dirty = 0;
        }
        return self._tDur;
    };
    Timeline.updateRoot = function updateRoot(time) {
        if ($3e8f3adb9623a584$var$_globalTimeline._ts) {
            $3e8f3adb9623a584$var$_lazySafeRender($3e8f3adb9623a584$var$_globalTimeline, $3e8f3adb9623a584$var$_parentToChildTotalTime(time, $3e8f3adb9623a584$var$_globalTimeline));
            $3e8f3adb9623a584$var$_lastRenderedFrame = $3e8f3adb9623a584$export$762ed8fbedb691e3.frame;
        }
        if ($3e8f3adb9623a584$export$762ed8fbedb691e3.frame >= $3e8f3adb9623a584$var$_nextGCFrame) {
            $3e8f3adb9623a584$var$_nextGCFrame += $3e8f3adb9623a584$export$4922bee768729a77.autoSleep || 120;
            var child = $3e8f3adb9623a584$var$_globalTimeline._first;
            if (!child || !child._ts) {
                if ($3e8f3adb9623a584$export$4922bee768729a77.autoSleep && $3e8f3adb9623a584$export$762ed8fbedb691e3._listeners.length < 2) {
                    while(child && !child._ts)child = child._next;
                    child || $3e8f3adb9623a584$export$762ed8fbedb691e3.sleep();
                }
            }
        }
    };
    return Timeline;
}($3e8f3adb9623a584$export$c35d437ae5945fcd);
$3e8f3adb9623a584$export$dc2b19673bb53610($3e8f3adb9623a584$export$e6a97ba2cae5bb94.prototype, {
    _lock: 0,
    _hasPause: 0,
    _forcing: 0
});
var $3e8f3adb9623a584$var$_addComplexStringPropTween = function _addComplexStringPropTween(target, prop, start, end, setter, stringFilter, funcParam) {
    //note: we call _addComplexStringPropTween.call(tweenInstance...) to ensure that it's scoped properly. We may call it from within a plugin too, thus "this" would refer to the plugin.
    var pt = new $3e8f3adb9623a584$export$3a67f7f44b1e838a(this._pt, target, prop, 0, 1, $3e8f3adb9623a584$export$c5bc8e04394ecb2, null, setter), index = 0, matchIndex = 0, result, startNums, color, endNum, chunk, startNum, hasRandom, a;
    pt.b = start;
    pt.e = end;
    start += ""; //ensure values are strings
    end += "";
    if (hasRandom = ~end.indexOf("random(")) end = $3e8f3adb9623a584$export$d5962a97e3cde94d(end);
    if (stringFilter) {
        a = [
            start,
            end
        ];
        stringFilter(a, target, prop); //pass an array with the starting and ending values and let the filter do whatever it needs to the values.
        start = a[0];
        end = a[1];
    }
    startNums = start.match($3e8f3adb9623a584$var$_complexStringNumExp) || [];
    while(result = $3e8f3adb9623a584$var$_complexStringNumExp.exec(end)){
        endNum = result[0];
        chunk = end.substring(index, result.index);
        if (color) color = (color + 1) % 5;
        else if (chunk.substr(-5) === "rgba(") color = 1;
        if (endNum !== startNums[matchIndex++]) {
            startNum = parseFloat(startNums[matchIndex - 1]) || 0; //these nested PropTweens are handled in a special way - we'll never actually call a render or setter method on them. We'll just loop through them in the parent complex string PropTween's render method.
            pt._pt = {
                _next: pt._pt,
                p: chunk || matchIndex === 1 ? chunk : ",",
                //note: SVG spec allows omission of comma/space when a negative sign is wedged between two numbers, like 2.5-5.3 instead of 2.5,-5.3 but when tweening, the negative value may switch to positive, so we insert the comma just in case.
                s: startNum,
                c: endNum.charAt(1) === "=" ? $3e8f3adb9623a584$export$dac762bc6301b560(startNum, endNum) - startNum : parseFloat(endNum) - startNum,
                m: color && color < 4 ? Math.round : 0
            };
            index = $3e8f3adb9623a584$var$_complexStringNumExp.lastIndex;
        }
    }
    pt.c = index < end.length ? end.substring(index, end.length) : ""; //we use the "c" of the PropTween to store the final part of the string (after the last number)
    pt.fp = funcParam;
    if ($3e8f3adb9623a584$export$5a680e28b0b61bc.test(end) || hasRandom) pt.e = 0; //if the end string contains relative values or dynamic random(...) values, delete the end it so that on the final render we don't actually set it to the string with += or -= characters (forces it to use the calculated value).
    this._pt = pt; //start the linked list with this new PropTween. Remember, we call _addComplexStringPropTween.call(tweenInstance...) to ensure that it's scoped properly. We may call it from within a plugin too, thus "this" would refer to the plugin.
    return pt;
}, $3e8f3adb9623a584$var$_addPropTween = function _addPropTween(target, prop, start, end, index, targets, modifier, stringFilter, funcParam, optional) {
    $3e8f3adb9623a584$var$_isFunction(end) && (end = end(index || 0, target, targets));
    var currentValue = target[prop], parsedStart = start !== "get" ? start : !$3e8f3adb9623a584$var$_isFunction(currentValue) ? currentValue : funcParam ? target[prop.indexOf("set") || !$3e8f3adb9623a584$var$_isFunction(target["get" + prop.substr(3)]) ? prop : "get" + prop.substr(3)](funcParam) : target[prop](), setter = !$3e8f3adb9623a584$var$_isFunction(currentValue) ? $3e8f3adb9623a584$var$_setterPlain : funcParam ? $3e8f3adb9623a584$var$_setterFuncWithParam : $3e8f3adb9623a584$var$_setterFunc, pt;
    if ($3e8f3adb9623a584$export$f664476fd67145ca(end)) {
        if (~end.indexOf("random(")) end = $3e8f3adb9623a584$export$d5962a97e3cde94d(end);
        if (end.charAt(1) === "=") {
            pt = $3e8f3adb9623a584$export$dac762bc6301b560(parsedStart, end) + ($3e8f3adb9623a584$export$65f2564e9a9b9222(parsedStart) || 0);
            if (pt || pt === 0) // to avoid isNaN, like if someone passes in a value like "!= whatever"
            end = pt;
        }
    }
    if (!optional || parsedStart !== end || $3e8f3adb9623a584$var$_forceAllPropTweens) {
        if (!isNaN(parsedStart * end) && end !== "") {
            // fun fact: any number multiplied by "" is evaluated as the number 0!
            pt = new $3e8f3adb9623a584$export$3a67f7f44b1e838a(this._pt, target, prop, +parsedStart || 0, end - (parsedStart || 0), typeof currentValue === "boolean" ? $3e8f3adb9623a584$var$_renderBoolean : $3e8f3adb9623a584$var$_renderPlain, 0, setter);
            funcParam && (pt.fp = funcParam);
            modifier && pt.modifier(modifier, this, target);
            return this._pt = pt;
        }
        !currentValue && !(prop in target) && $3e8f3adb9623a584$export$7fb54635790b59a5(prop, end);
        return $3e8f3adb9623a584$var$_addComplexStringPropTween.call(this, target, prop, parsedStart, end, setter, stringFilter || $3e8f3adb9623a584$export$4922bee768729a77.stringFilter, funcParam);
    }
}, //creates a copy of the vars object and processes any function-based values (putting the resulting values directly into the copy) as well as strings with "random()" in them. It does NOT process relative values.
$3e8f3adb9623a584$var$_processVars = function _processVars(vars, index, target, targets, tween) {
    $3e8f3adb9623a584$var$_isFunction(vars) && (vars = $3e8f3adb9623a584$var$_parseFuncOrString(vars, tween, index, target, targets));
    if (!$3e8f3adb9623a584$var$_isObject(vars) || vars.style && vars.nodeType || $3e8f3adb9623a584$var$_isArray(vars) || $3e8f3adb9623a584$var$_isTypedArray(vars)) return $3e8f3adb9623a584$export$f664476fd67145ca(vars) ? $3e8f3adb9623a584$var$_parseFuncOrString(vars, tween, index, target, targets) : vars;
    var copy = {}, p;
    for(p in vars)copy[p] = $3e8f3adb9623a584$var$_parseFuncOrString(vars[p], tween, index, target, targets);
    return copy;
}, $3e8f3adb9623a584$export$5c457b74208010cf = function _checkPlugin(property, vars, tween, index, target, targets) {
    var plugin, pt, ptLookup, i;
    if ($3e8f3adb9623a584$export$d305d8ec5d7c26b8[property] && (plugin = new $3e8f3adb9623a584$export$d305d8ec5d7c26b8[property]()).init(target, plugin.rawVars ? vars[property] : $3e8f3adb9623a584$var$_processVars(vars[property], index, target, targets, tween), tween, index, targets) !== false) {
        tween._pt = pt = new $3e8f3adb9623a584$export$3a67f7f44b1e838a(tween._pt, target, property, 0, 1, plugin.render, plugin, 0, plugin.priority);
        if (tween !== $3e8f3adb9623a584$var$_quickTween) {
            ptLookup = tween._ptLookup[tween._targets.indexOf(target)]; //note: we can't use tween._ptLookup[index] because for staggered tweens, the index from the fullTargets array won't match what it is in each individual tween that spawns from the stagger.
            i = plugin._props.length;
            while(i--)ptLookup[plugin._props[i]] = pt;
        }
    }
    return plugin;
}, $3e8f3adb9623a584$var$_overwritingTween, //store a reference temporarily so we can avoid overwriting itself.
$3e8f3adb9623a584$var$_forceAllPropTweens, $3e8f3adb9623a584$var$_initTween = function _initTween(tween, time, tTime) {
    var vars = tween.vars, ease = vars.ease, startAt = vars.startAt, immediateRender = vars.immediateRender, lazy = vars.lazy, onUpdate = vars.onUpdate, onUpdateParams = vars.onUpdateParams, callbackScope = vars.callbackScope, runBackwards = vars.runBackwards, yoyoEase = vars.yoyoEase, keyframes = vars.keyframes, autoRevert = vars.autoRevert, dur = tween._dur, prevStartAt = tween._startAt, targets = tween._targets, parent = tween.parent, fullTargets = parent && parent.data === "nested" ? parent.vars.targets : targets, autoOverwrite = tween._overwrite === "auto" && !$3e8f3adb9623a584$var$_suppressOverwrites, tl = tween.timeline, cleanVars, i, p, pt, target, hasPriority, gsData, harness, plugin, ptLookup, index, harnessVars, overwritten;
    tl && (!keyframes || !ease) && (ease = "none");
    tween._ease = $3e8f3adb9623a584$var$_parseEase(ease, $3e8f3adb9623a584$var$_defaults.ease);
    tween._yEase = yoyoEase ? $3e8f3adb9623a584$var$_invertEase($3e8f3adb9623a584$var$_parseEase(yoyoEase === true ? ease : yoyoEase, $3e8f3adb9623a584$var$_defaults.ease)) : 0;
    if (yoyoEase && tween._yoyo && !tween._repeat) {
        //there must have been a parent timeline with yoyo:true that is currently in its yoyo phase, so flip the eases.
        yoyoEase = tween._yEase;
        tween._yEase = tween._ease;
        tween._ease = yoyoEase;
    }
    tween._from = !tl && !!vars.runBackwards; //nested timelines should never run backwards - the backwards-ness is in the child tweens.
    if (!tl || keyframes && !vars.stagger) {
        //if there's an internal timeline, skip all the parsing because we passed that task down the chain.
        harness = targets[0] ? $3e8f3adb9623a584$export$8b9be379d2de2a39(targets[0]).harness : 0;
        harnessVars = harness && vars[harness.prop]; //someone may need to specify CSS-specific values AND non-CSS values, like if the element has an "x" property plus it's a standard DOM element. We allow people to distinguish by wrapping plugin-specific stuff in a css:{} object for example.
        cleanVars = $3e8f3adb9623a584$var$_copyExcluding(vars, $3e8f3adb9623a584$var$_reservedProps);
        if (prevStartAt) {
            prevStartAt._zTime < 0 && prevStartAt.progress(1); // in case it's a lazy startAt that hasn't rendered yet.
            time < 0 && runBackwards && immediateRender && !autoRevert ? prevStartAt.render(-1, true) : prevStartAt.revert(runBackwards && dur ? $3e8f3adb9623a584$var$_revertConfigNoKill : $3e8f3adb9623a584$var$_startAtRevertConfig); // if it's a "startAt" (not "from()" or runBackwards: true), we only need to do a shallow revert (keep transforms cached in CSSPlugin)
            // don't just _removeFromParent(prevStartAt.render(-1, true)) because that'll leave inline styles. We're creating a new _startAt for "startAt" tweens that re-capture things to ensure that if the pre-tween values changed since the tween was created, they're recorded.
            prevStartAt._lazy = 0;
        }
        if (startAt) {
            $3e8f3adb9623a584$var$_removeFromParent(tween._startAt = $3e8f3adb9623a584$export$208a41d6b4e37b97.set(targets, $3e8f3adb9623a584$export$dc2b19673bb53610({
                data: "isStart",
                overwrite: false,
                parent: parent,
                immediateRender: true,
                lazy: !prevStartAt && $3e8f3adb9623a584$var$_isNotFalse(lazy),
                startAt: null,
                delay: 0,
                onUpdate: onUpdate,
                onUpdateParams: onUpdateParams,
                callbackScope: callbackScope,
                stagger: 0
            }, startAt))); //copy the properties/values into a new object to avoid collisions, like var to = {x:0}, from = {x:500}; timeline.fromTo(e, from, to).fromTo(e, to, from);
            tween._startAt._dp = 0; // don't allow it to get put back into root timeline! Like when revert() is called and totalTime() gets set.
            tween._startAt._sat = tween; // used in globalTime(). _sat stands for _startAtTween
            time < 0 && ($3e8f3adb9623a584$var$_reverting || !immediateRender && !autoRevert) && tween._startAt.revert($3e8f3adb9623a584$var$_revertConfigNoKill); // rare edge case, like if a render is forced in the negative direction of a non-initted tween.
            if (immediateRender) {
                if (dur && time <= 0 && tTime <= 0) {
                    // check tTime here because in the case of a yoyo tween whose playhead gets pushed to the end like tween.progress(1), we should allow it through so that the onComplete gets fired properly.
                    time && (tween._zTime = time);
                    return; //we skip initialization here so that overwriting doesn't occur until the tween actually begins. Otherwise, if you create several immediateRender:true tweens of the same target/properties to drop into a Timeline, the last one created would overwrite the first ones because they didn't get placed into the timeline yet before the first render occurs and kicks in overwriting.
                }
            }
        } else if (runBackwards && dur) //from() tweens must be handled uniquely: their beginning values must be rendered but we don't want overwriting to occur yet (when time is still 0). Wait until the tween actually begins before doing all the routines like overwriting. At that time, we should render at the END of the tween to ensure that things initialize correctly (remember, from() tweens go backwards)
        {
            if (!prevStartAt) {
                time && (immediateRender = false); //in rare cases (like if a from() tween runs and then is invalidate()-ed), immediateRender could be true but the initial forced-render gets skipped, so there's no need to force the render in this context when the _time is greater than 0
                p = $3e8f3adb9623a584$export$dc2b19673bb53610({
                    overwrite: false,
                    data: "isFromStart",
                    //we tag the tween with as "isFromStart" so that if [inside a plugin] we need to only do something at the very END of a tween, we have a way of identifying this tween as merely the one that's setting the beginning values for a "from()" tween. For example, clearProps in CSSPlugin should only get applied at the very END of a tween and without this tag, from(...{height:100, clearProps:"height", delay:1}) would wipe the height at the beginning of the tween and after 1 second, it'd kick back in.
                    lazy: immediateRender && !prevStartAt && $3e8f3adb9623a584$var$_isNotFalse(lazy),
                    immediateRender: immediateRender,
                    //zero-duration tweens render immediately by default, but if we're not specifically instructed to render this tween immediately, we should skip this and merely _init() to record the starting values (rendering them immediately would push them to completion which is wasteful in that case - we'd have to render(-1) immediately after)
                    stagger: 0,
                    parent: parent //ensures that nested tweens that had a stagger are handled properly, like gsap.from(".class", {y: gsap.utils.wrap([-100,100]), stagger: 0.5})
                }, cleanVars);
                harnessVars && (p[harness.prop] = harnessVars); // in case someone does something like .from(..., {css:{}})
                $3e8f3adb9623a584$var$_removeFromParent(tween._startAt = $3e8f3adb9623a584$export$208a41d6b4e37b97.set(targets, p));
                tween._startAt._dp = 0; // don't allow it to get put back into root timeline!
                tween._startAt._sat = tween; // used in globalTime()
                time < 0 && ($3e8f3adb9623a584$var$_reverting ? tween._startAt.revert($3e8f3adb9623a584$var$_revertConfigNoKill) : tween._startAt.render(-1, true));
                tween._zTime = time;
                if (!immediateRender) _initTween(tween._startAt, $3e8f3adb9623a584$var$_tinyNum, $3e8f3adb9623a584$var$_tinyNum); //ensures that the initial values are recorded
                else if (!time) return;
            }
        }
        tween._pt = tween._ptCache = 0;
        lazy = dur && $3e8f3adb9623a584$var$_isNotFalse(lazy) || lazy && !dur;
        for(i = 0; i < targets.length; i++){
            target = targets[i];
            gsData = target._gsap || $3e8f3adb9623a584$var$_harness(targets)[i]._gsap;
            tween._ptLookup[i] = ptLookup = {};
            $3e8f3adb9623a584$var$_lazyLookup[gsData.id] && $3e8f3adb9623a584$var$_lazyTweens.length && $3e8f3adb9623a584$var$_lazyRender(); //if other tweens of the same target have recently initted but haven't rendered yet, we've got to force the render so that the starting values are correct (imagine populating a timeline with a bunch of sequential tweens and then jumping to the end)
            index = fullTargets === targets ? i : fullTargets.indexOf(target);
            if (harness && (plugin = new harness()).init(target, harnessVars || cleanVars, tween, index, fullTargets) !== false) {
                tween._pt = pt = new $3e8f3adb9623a584$export$3a67f7f44b1e838a(tween._pt, target, plugin.name, 0, 1, plugin.render, plugin, 0, plugin.priority);
                plugin._props.forEach(function(name) {
                    ptLookup[name] = pt;
                });
                plugin.priority && (hasPriority = 1);
            }
            if (!harness || harnessVars) {
                for(p in cleanVars)if ($3e8f3adb9623a584$export$d305d8ec5d7c26b8[p] && (plugin = $3e8f3adb9623a584$export$5c457b74208010cf(p, cleanVars, tween, index, target, fullTargets))) plugin.priority && (hasPriority = 1);
                else ptLookup[p] = pt = $3e8f3adb9623a584$var$_addPropTween.call(tween, target, p, "get", cleanVars[p], index, fullTargets, 0, vars.stringFilter);
            }
            tween._op && tween._op[i] && tween.kill(target, tween._op[i]);
            if (autoOverwrite && tween._pt) {
                $3e8f3adb9623a584$var$_overwritingTween = tween;
                $3e8f3adb9623a584$var$_globalTimeline.killTweensOf(target, ptLookup, tween.globalTime(time)); // make sure the overwriting doesn't overwrite THIS tween!!!
                overwritten = !tween.parent;
                $3e8f3adb9623a584$var$_overwritingTween = 0;
            }
            tween._pt && lazy && ($3e8f3adb9623a584$var$_lazyLookup[gsData.id] = 1);
        }
        hasPriority && $3e8f3adb9623a584$export$eed5824f53346d57(tween);
        tween._onInit && tween._onInit(tween); //plugins like RoundProps must wait until ALL of the PropTweens are instantiated. In the plugin's init() function, it sets the _onInit on the tween instance. May not be pretty/intuitive, but it's fast and keeps file size down.
    }
    tween._onUpdate = onUpdate;
    tween._initted = (!tween._op || tween._pt) && !overwritten; // if overwrittenProps resulted in the entire tween being killed, do NOT flag it as initted or else it may render for one tick.
    keyframes && time <= 0 && tl.render($3e8f3adb9623a584$var$_bigNum, true, true); // if there's a 0% keyframe, it'll render in the "before" state for any staggered/delayed animations thus when the following tween initializes, it'll use the "before" state instead of the "after" state as the initial values.
}, $3e8f3adb9623a584$var$_updatePropTweens = function _updatePropTweens(tween, property, value, start, startIsRelative, ratio, time) {
    var ptCache = (tween._pt && tween._ptCache || (tween._ptCache = {}))[property], pt, rootPT, lookup, i;
    if (!ptCache) {
        ptCache = tween._ptCache[property] = [];
        lookup = tween._ptLookup;
        i = tween._targets.length;
        while(i--){
            pt = lookup[i][property];
            if (pt && pt.d && pt.d._pt) {
                // it's a plugin, so find the nested PropTween
                pt = pt.d._pt;
                while(pt && pt.p !== property && pt.fp !== property)// "fp" is functionParam for things like setting CSS variables which require .setProperty("--var-name", value)
                pt = pt._next;
            }
            if (!pt) {
                // there is no PropTween associated with that property, so we must FORCE one to be created and ditch out of this
                // if the tween has other properties that already rendered at new positions, we'd normally have to rewind to put them back like tween.render(0, true) before forcing an _initTween(), but that can create another edge case like tweening a timeline's progress would trigger onUpdates to fire which could move other things around. It's better to just inform users that .resetTo() should ONLY be used for tweens that already have that property. For example, you can't gsap.to(...{ y: 0 }) and then tween.restTo("x", 200) for example.
                $3e8f3adb9623a584$var$_forceAllPropTweens = 1; // otherwise, when we _addPropTween() and it finds no change between the start and end values, it skips creating a PropTween (for efficiency...why tween when there's no difference?) but in this case we NEED that PropTween created so we can edit it.
                tween.vars[property] = "+=0";
                $3e8f3adb9623a584$var$_initTween(tween, time);
                $3e8f3adb9623a584$var$_forceAllPropTweens = 0;
                return 1;
            }
            ptCache.push(pt);
        }
    }
    i = ptCache.length;
    while(i--){
        rootPT = ptCache[i];
        pt = rootPT._pt || rootPT; // complex values may have nested PropTweens. We only accommodate the FIRST value.
        pt.s = (start || start === 0) && !startIsRelative ? start : pt.s + (start || 0) + ratio * pt.c;
        pt.c = value - pt.s;
        rootPT.e && (rootPT.e = $3e8f3adb9623a584$export$9c8d725d65e13f94(value) + $3e8f3adb9623a584$export$65f2564e9a9b9222(rootPT.e)); // mainly for CSSPlugin (end value)
        rootPT.b && (rootPT.b = pt.s + $3e8f3adb9623a584$export$65f2564e9a9b9222(rootPT.b)); // (beginning value)
    }
}, $3e8f3adb9623a584$var$_addAliasesToVars = function _addAliasesToVars(targets, vars) {
    var harness = targets[0] ? $3e8f3adb9623a584$export$8b9be379d2de2a39(targets[0]).harness : 0, propertyAliases = harness && harness.aliases, copy, p, i, aliases;
    if (!propertyAliases) return vars;
    copy = $3e8f3adb9623a584$var$_merge({}, vars);
    for(p in propertyAliases)if (p in copy) {
        aliases = propertyAliases[p].split(",");
        i = aliases.length;
        while(i--)copy[aliases[i]] = copy[p];
    }
    return copy;
}, // parses multiple formats, like {"0%": {x: 100}, {"50%": {x: -20}} and { x: {"0%": 100, "50%": -20} }, and an "ease" can be set on any object. We populate an "allProps" object with an Array for each property, like {x: [{}, {}], y:[{}, {}]} with data for each property tween. The objects have a "t" (time), "v", (value), and "e" (ease) property. This allows us to piece together a timeline later.
$3e8f3adb9623a584$var$_parseKeyframe = function _parseKeyframe(prop, obj, allProps, easeEach) {
    var ease = obj.ease || easeEach || "power1.inOut", p, a;
    if ($3e8f3adb9623a584$var$_isArray(obj)) {
        a = allProps[prop] || (allProps[prop] = []); // t = time (out of 100), v = value, e = ease
        obj.forEach(function(value, i) {
            return a.push({
                t: i / (obj.length - 1) * 100,
                v: value,
                e: ease
            });
        });
    } else for(p in obj){
        a = allProps[p] || (allProps[p] = []);
        p === "ease" || a.push({
            t: parseFloat(prop),
            v: obj[p],
            e: ease
        });
    }
}, $3e8f3adb9623a584$var$_parseFuncOrString = function _parseFuncOrString(value, tween, i, target, targets) {
    return $3e8f3adb9623a584$var$_isFunction(value) ? value.call(tween, i, target, targets) : $3e8f3adb9623a584$export$f664476fd67145ca(value) && ~value.indexOf("random(") ? $3e8f3adb9623a584$export$d5962a97e3cde94d(value) : value;
}, $3e8f3adb9623a584$var$_staggerTweenProps = $3e8f3adb9623a584$var$_callbackNames + "repeat,repeatDelay,yoyo,repeatRefresh,yoyoEase,autoRevert", $3e8f3adb9623a584$var$_staggerPropsToSkip = {};
$3e8f3adb9623a584$export$f9000b814859f126($3e8f3adb9623a584$var$_staggerTweenProps + ",id,stagger,delay,duration,paused,scrollTrigger", function(name) {
    return $3e8f3adb9623a584$var$_staggerPropsToSkip[name] = 1;
});
var $3e8f3adb9623a584$export$208a41d6b4e37b97 = /*#__PURE__*/ function(_Animation2) {
    $3e8f3adb9623a584$var$_inheritsLoose(Tween, _Animation2);
    function Tween(targets, vars, position, skipInherit) {
        var _this3;
        if (typeof vars === "number") {
            position.duration = vars;
            vars = position;
            position = null;
        }
        _this3 = _Animation2.call(this, skipInherit ? vars : $3e8f3adb9623a584$var$_inheritDefaults(vars)) || this;
        var _this3$vars = _this3.vars, duration = _this3$vars.duration, delay = _this3$vars.delay, immediateRender = _this3$vars.immediateRender, stagger = _this3$vars.stagger, overwrite = _this3$vars.overwrite, keyframes = _this3$vars.keyframes, defaults = _this3$vars.defaults, scrollTrigger = _this3$vars.scrollTrigger, yoyoEase = _this3$vars.yoyoEase, parent = vars.parent || $3e8f3adb9623a584$var$_globalTimeline, parsedTargets = ($3e8f3adb9623a584$var$_isArray(targets) || $3e8f3adb9623a584$var$_isTypedArray(targets) ? $3e8f3adb9623a584$var$_isNumber(targets[0]) : "length" in vars) ? [
            targets
        ] : $3e8f3adb9623a584$export$45b10814cc054894(targets), tl, i, copy, l, p, curTarget, staggerFunc, staggerVarsToMerge;
        _this3._targets = parsedTargets.length ? $3e8f3adb9623a584$var$_harness(parsedTargets) : $3e8f3adb9623a584$var$_warn("GSAP target " + targets + " not found. https://greensock.com", !$3e8f3adb9623a584$export$4922bee768729a77.nullTargetWarn) || [];
        _this3._ptLookup = []; //PropTween lookup. An array containing an object for each target, having keys for each tweening property
        _this3._overwrite = overwrite;
        if (keyframes || stagger || $3e8f3adb9623a584$var$_isFuncOrString(duration) || $3e8f3adb9623a584$var$_isFuncOrString(delay)) {
            vars = _this3.vars;
            tl = _this3.timeline = new $3e8f3adb9623a584$export$e6a97ba2cae5bb94({
                data: "nested",
                defaults: defaults || {},
                targets: parent && parent.data === "nested" ? parent.vars.targets : parsedTargets
            }); // we need to store the targets because for staggers and keyframes, we end up creating an individual tween for each but function-based values need to know the index and the whole Array of targets.
            tl.kill();
            tl.parent = tl._dp = $3e8f3adb9623a584$var$_assertThisInitialized(_this3);
            tl._start = 0;
            if (stagger || $3e8f3adb9623a584$var$_isFuncOrString(duration) || $3e8f3adb9623a584$var$_isFuncOrString(delay)) {
                l = parsedTargets.length;
                staggerFunc = stagger && $3e8f3adb9623a584$export$f02a9ddbe4480f19(stagger);
                if ($3e8f3adb9623a584$var$_isObject(stagger)) {
                    //users can pass in callbacks like onStart/onComplete in the stagger object. These should fire with each individual tween.
                    for(p in stagger)if (~$3e8f3adb9623a584$var$_staggerTweenProps.indexOf(p)) {
                        staggerVarsToMerge || (staggerVarsToMerge = {});
                        staggerVarsToMerge[p] = stagger[p];
                    }
                }
                for(i = 0; i < l; i++){
                    copy = $3e8f3adb9623a584$var$_copyExcluding(vars, $3e8f3adb9623a584$var$_staggerPropsToSkip);
                    copy.stagger = 0;
                    yoyoEase && (copy.yoyoEase = yoyoEase);
                    staggerVarsToMerge && $3e8f3adb9623a584$var$_merge(copy, staggerVarsToMerge);
                    curTarget = parsedTargets[i]; //don't just copy duration or delay because if they're a string or function, we'd end up in an infinite loop because _isFuncOrString() would evaluate as true in the child tweens, entering this loop, etc. So we parse the value straight from vars and default to 0.
                    copy.duration = +$3e8f3adb9623a584$var$_parseFuncOrString(duration, $3e8f3adb9623a584$var$_assertThisInitialized(_this3), i, curTarget, parsedTargets);
                    copy.delay = (+$3e8f3adb9623a584$var$_parseFuncOrString(delay, $3e8f3adb9623a584$var$_assertThisInitialized(_this3), i, curTarget, parsedTargets) || 0) - _this3._delay;
                    if (!stagger && l === 1 && copy.delay) {
                        // if someone does delay:"random(1, 5)", repeat:-1, for example, the delay shouldn't be inside the repeat.
                        _this3._delay = delay = copy.delay;
                        _this3._start += delay;
                        copy.delay = 0;
                    }
                    tl.to(curTarget, copy, staggerFunc ? staggerFunc(i, curTarget, parsedTargets) : 0);
                    tl._ease = $3e8f3adb9623a584$var$_easeMap.none;
                }
                tl.duration() ? duration = delay = 0 : _this3.timeline = 0; // if the timeline's duration is 0, we don't need a timeline internally!
            } else if (keyframes) {
                $3e8f3adb9623a584$var$_inheritDefaults($3e8f3adb9623a584$export$dc2b19673bb53610(tl.vars.defaults, {
                    ease: "none"
                }));
                tl._ease = $3e8f3adb9623a584$var$_parseEase(keyframes.ease || vars.ease || "none");
                var time = 0, a, kf, v;
                if ($3e8f3adb9623a584$var$_isArray(keyframes)) {
                    keyframes.forEach(function(frame) {
                        return tl.to(parsedTargets, frame, ">");
                    });
                    tl.duration(); // to ensure tl._dur is cached because we tap into it for performance purposes in the render() method.
                } else {
                    copy = {};
                    for(p in keyframes)p === "ease" || p === "easeEach" || $3e8f3adb9623a584$var$_parseKeyframe(p, keyframes[p], copy, keyframes.easeEach);
                    for(p in copy){
                        a = copy[p].sort(function(a, b) {
                            return a.t - b.t;
                        });
                        time = 0;
                        for(i = 0; i < a.length; i++){
                            kf = a[i];
                            v = {
                                ease: kf.e,
                                duration: (kf.t - (i ? a[i - 1].t : 0)) / 100 * duration
                            };
                            v[p] = kf.v;
                            tl.to(parsedTargets, v, time);
                            time += v.duration;
                        }
                    }
                    tl.duration() < duration && tl.to({}, {
                        duration: duration - tl.duration()
                    }); // in case keyframes didn't go to 100%
                }
            }
            duration || _this3.duration(duration = tl.duration());
        } else _this3.timeline = 0; //speed optimization, faster lookups (no going up the prototype chain)
        if (overwrite === true && !$3e8f3adb9623a584$var$_suppressOverwrites) {
            $3e8f3adb9623a584$var$_overwritingTween = $3e8f3adb9623a584$var$_assertThisInitialized(_this3);
            $3e8f3adb9623a584$var$_globalTimeline.killTweensOf(parsedTargets);
            $3e8f3adb9623a584$var$_overwritingTween = 0;
        }
        $3e8f3adb9623a584$var$_addToTimeline(parent, $3e8f3adb9623a584$var$_assertThisInitialized(_this3), position);
        vars.reversed && _this3.reverse();
        vars.paused && _this3.paused(true);
        if (immediateRender || !duration && !keyframes && _this3._start === $3e8f3adb9623a584$var$_roundPrecise(parent._time) && $3e8f3adb9623a584$var$_isNotFalse(immediateRender) && $3e8f3adb9623a584$var$_hasNoPausedAncestors($3e8f3adb9623a584$var$_assertThisInitialized(_this3)) && parent.data !== "nested") {
            _this3._tTime = -$3e8f3adb9623a584$var$_tinyNum; //forces a render without having to set the render() "force" parameter to true because we want to allow lazying by default (using the "force" parameter always forces an immediate full render)
            _this3.render(Math.max(0, -delay) || 0); //in case delay is negative
        }
        scrollTrigger && $3e8f3adb9623a584$var$_scrollTrigger($3e8f3adb9623a584$var$_assertThisInitialized(_this3), scrollTrigger);
        return _this3;
    }
    var _proto3 = Tween.prototype;
    _proto3.render = function render(totalTime, suppressEvents, force) {
        var prevTime = this._time, tDur = this._tDur, dur = this._dur, isNegative = totalTime < 0, tTime = totalTime > tDur - $3e8f3adb9623a584$var$_tinyNum && !isNegative ? tDur : totalTime < $3e8f3adb9623a584$var$_tinyNum ? 0 : totalTime, time, pt, iteration, cycleDuration, prevIteration, isYoyo, ratio, timeline, yoyoEase;
        if (!dur) $3e8f3adb9623a584$var$_renderZeroDurationTween(this, totalTime, suppressEvents, force);
        else if (tTime !== this._tTime || !totalTime || force || !this._initted && this._tTime || this._startAt && this._zTime < 0 !== isNegative) {
            //this senses if we're crossing over the start time, in which case we must record _zTime and force the render, but we do it in this lengthy conditional way for performance reasons (usually we can skip the calculations): this._initted && (this._zTime < 0) !== (totalTime < 0)
            time = tTime;
            timeline = this.timeline;
            if (this._repeat) {
                //adjust the time for repeats and yoyos
                cycleDuration = dur + this._rDelay;
                if (this._repeat < -1 && isNegative) return this.totalTime(cycleDuration * 100 + totalTime, suppressEvents, force);
                time = $3e8f3adb9623a584$var$_roundPrecise(tTime % cycleDuration); //round to avoid floating point errors. (4 % 0.8 should be 0 but some browsers report it as 0.79999999!)
                if (tTime === tDur) {
                    // the tDur === tTime is for edge cases where there's a lengthy decimal on the duration and it may reach the very end but the time is rendered as not-quite-there (remember, tDur is rounded to 4 decimals whereas dur isn't)
                    iteration = this._repeat;
                    time = dur;
                } else {
                    iteration = ~~(tTime / cycleDuration);
                    if (iteration && iteration === tTime / cycleDuration) {
                        time = dur;
                        iteration--;
                    }
                    time > dur && (time = dur);
                }
                isYoyo = this._yoyo && iteration & 1;
                if (isYoyo) {
                    yoyoEase = this._yEase;
                    time = dur - time;
                }
                prevIteration = $3e8f3adb9623a584$var$_animationCycle(this._tTime, cycleDuration);
                if (time === prevTime && !force && this._initted) {
                    //could be during the repeatDelay part. No need to render and fire callbacks.
                    this._tTime = tTime;
                    return this;
                }
                if (iteration !== prevIteration) {
                    timeline && this._yEase && $3e8f3adb9623a584$var$_propagateYoyoEase(timeline, isYoyo); //repeatRefresh functionality
                    if (this.vars.repeatRefresh && !isYoyo && !this._lock) {
                        this._lock = force = 1; //force, otherwise if lazy is true, the _attemptInitTween() will return and we'll jump out and get caught bouncing on each tick.
                        this.render($3e8f3adb9623a584$var$_roundPrecise(cycleDuration * iteration), true).invalidate()._lock = 0;
                    }
                }
            }
            if (!this._initted) {
                if ($3e8f3adb9623a584$var$_attemptInitTween(this, isNegative ? totalTime : time, force, suppressEvents, tTime)) {
                    this._tTime = 0; // in constructor if immediateRender is true, we set _tTime to -_tinyNum to have the playhead cross the starting point but we can't leave _tTime as a negative number.
                    return this;
                }
                if (prevTime !== this._time) // rare edge case - during initialization, an onUpdate in the _startAt (.fromTo()) might force this tween to render at a different spot in which case we should ditch this render() call so that it doesn't revert the values.
                return this;
                if (dur !== this._dur) // while initting, a plugin like InertiaPlugin might alter the duration, so rerun from the start to ensure everything renders as it should.
                return this.render(totalTime, suppressEvents, force);
            }
            this._tTime = tTime;
            this._time = time;
            if (!this._act && this._ts) {
                this._act = 1; //as long as it's not paused, force it to be active so that if the user renders independent of the parent timeline, it'll be forced to re-render on the next tick.
                this._lazy = 0;
            }
            this.ratio = ratio = (yoyoEase || this._ease)(time / dur);
            if (this._from) this.ratio = ratio = 1 - ratio;
            if (time && !prevTime && !suppressEvents && !iteration) {
                $3e8f3adb9623a584$var$_callback(this, "onStart");
                if (this._tTime !== tTime) // in case the onStart triggered a render at a different spot, eject. Like if someone did animation.pause(0.5) or something inside the onStart.
                return this;
            }
            pt = this._pt;
            while(pt){
                pt.r(ratio, pt.d);
                pt = pt._next;
            }
            timeline && timeline.render(totalTime < 0 ? totalTime : !time && isYoyo ? -$3e8f3adb9623a584$var$_tinyNum : timeline._dur * timeline._ease(time / this._dur), suppressEvents, force) || this._startAt && (this._zTime = totalTime);
            if (this._onUpdate && !suppressEvents) {
                isNegative && $3e8f3adb9623a584$var$_rewindStartAt(this, totalTime, suppressEvents, force); //note: for performance reasons, we tuck this conditional logic inside less traveled areas (most tweens don't have an onUpdate). We'd just have it at the end before the onComplete, but the values should be updated before any onUpdate is called, so we ALSO put it here and then if it's not called, we do so later near the onComplete.
                $3e8f3adb9623a584$var$_callback(this, "onUpdate");
            }
            this._repeat && iteration !== prevIteration && this.vars.onRepeat && !suppressEvents && this.parent && $3e8f3adb9623a584$var$_callback(this, "onRepeat");
            if ((tTime === this._tDur || !tTime) && this._tTime === tTime) {
                isNegative && !this._onUpdate && $3e8f3adb9623a584$var$_rewindStartAt(this, totalTime, true, true);
                (totalTime || !dur) && (tTime === this._tDur && this._ts > 0 || !tTime && this._ts < 0) && $3e8f3adb9623a584$var$_removeFromParent(this, 1); // don't remove if we're rendering at exactly a time of 0, as there could be autoRevert values that should get set on the next tick (if the playhead goes backward beyond the startTime, negative totalTime). Don't remove if the timeline is reversed and the playhead isn't at 0, otherwise tl.progress(1).reverse() won't work. Only remove if the playhead is at the end and timeScale is positive, or if the playhead is at 0 and the timeScale is negative.
                if (!suppressEvents && !(isNegative && !prevTime) && (tTime || prevTime || isYoyo)) {
                    // if prevTime and tTime are zero, we shouldn't fire the onReverseComplete. This could happen if you gsap.to(... {paused:true}).play();
                    $3e8f3adb9623a584$var$_callback(this, tTime === tDur ? "onComplete" : "onReverseComplete", true);
                    this._prom && !(tTime < tDur && this.timeScale() > 0) && this._prom();
                }
            }
        }
        return this;
    };
    _proto3.targets = function targets() {
        return this._targets;
    };
    _proto3.invalidate = function invalidate(soft) {
        // "soft" gives us a way to clear out everything EXCEPT the recorded pre-"from" portion of from() tweens. Otherwise, for example, if you tween.progress(1).render(0, true true).invalidate(), the "from" values would persist and then on the next render, the from() tweens would initialize and the current value would match the "from" values, thus animate from the same value to the same value (no animation). We tap into this in ScrollTrigger's refresh() where we must push a tween to completion and then back again but honor its init state in case the tween is dependent on another tween further up on the page.
        (!soft || !this.vars.runBackwards) && (this._startAt = 0);
        this._pt = this._op = this._onUpdate = this._lazy = this.ratio = 0;
        this._ptLookup = [];
        this.timeline && this.timeline.invalidate(soft);
        return _Animation2.prototype.invalidate.call(this, soft);
    };
    _proto3.resetTo = function resetTo(property, value, start, startIsRelative) {
        $3e8f3adb9623a584$var$_tickerActive || $3e8f3adb9623a584$export$762ed8fbedb691e3.wake();
        this._ts || this.play();
        var time = Math.min(this._dur, (this._dp._time - this._start) * this._ts), ratio;
        this._initted || $3e8f3adb9623a584$var$_initTween(this, time);
        ratio = this._ease(time / this._dur); // don't just get tween.ratio because it may not have rendered yet.
        // possible future addition to allow an object with multiple values to update, like tween.resetTo({x: 100, y: 200}); At this point, it doesn't seem worth the added kb given the fact that most users will likely opt for the convenient gsap.quickTo() way of interacting with this method.
        // if (_isObject(property)) { // performance optimization
        // 	for (p in property) {
        // 		if (_updatePropTweens(this, p, property[p], value ? value[p] : null, start, ratio, time)) {
        // 			return this.resetTo(property, value, start, startIsRelative); // if a PropTween wasn't found for the property, it'll get forced with a re-initialization so we need to jump out and start over again.
        // 		}
        // 	}
        // } else {
        if ($3e8f3adb9623a584$var$_updatePropTweens(this, property, value, start, startIsRelative, ratio, time)) return this.resetTo(property, value, start, startIsRelative); // if a PropTween wasn't found for the property, it'll get forced with a re-initialization so we need to jump out and start over again.
         //}
        $3e8f3adb9623a584$var$_alignPlayhead(this, 0);
        this.parent || $3e8f3adb9623a584$var$_addLinkedListItem(this._dp, this, "_first", "_last", this._dp._sort ? "_start" : 0);
        return this.render(0);
    };
    _proto3.kill = function kill(targets, vars) {
        if (vars === void 0) vars = "all";
        if (!targets && (!vars || vars === "all")) {
            this._lazy = this._pt = 0;
            return this.parent ? $3e8f3adb9623a584$var$_interrupt(this) : this;
        }
        if (this.timeline) {
            var tDur = this.timeline.totalDuration();
            this.timeline.killTweensOf(targets, vars, $3e8f3adb9623a584$var$_overwritingTween && $3e8f3adb9623a584$var$_overwritingTween.vars.overwrite !== true)._first || $3e8f3adb9623a584$var$_interrupt(this); // if nothing is left tweening, interrupt.
            this.parent && tDur !== this.timeline.totalDuration() && $3e8f3adb9623a584$var$_setDuration(this, this._dur * this.timeline._tDur / tDur, 0, 1); // if a nested tween is killed that changes the duration, it should affect this tween's duration. We must use the ratio, though, because sometimes the internal timeline is stretched like for keyframes where they don't all add up to whatever the parent tween's duration was set to.
            return this;
        }
        var parsedTargets = this._targets, killingTargets = targets ? $3e8f3adb9623a584$export$45b10814cc054894(targets) : parsedTargets, propTweenLookup = this._ptLookup, firstPT = this._pt, overwrittenProps, curLookup, curOverwriteProps, props, p, pt, i;
        if ((!vars || vars === "all") && $3e8f3adb9623a584$var$_arraysMatch(parsedTargets, killingTargets)) {
            vars === "all" && (this._pt = 0);
            return $3e8f3adb9623a584$var$_interrupt(this);
        }
        overwrittenProps = this._op = this._op || [];
        if (vars !== "all") {
            //so people can pass in a comma-delimited list of property names
            if ($3e8f3adb9623a584$export$f664476fd67145ca(vars)) {
                p = {};
                $3e8f3adb9623a584$export$f9000b814859f126(vars, function(name) {
                    return p[name] = 1;
                });
                vars = p;
            }
            vars = $3e8f3adb9623a584$var$_addAliasesToVars(parsedTargets, vars);
        }
        i = parsedTargets.length;
        while(i--)if (~killingTargets.indexOf(parsedTargets[i])) {
            curLookup = propTweenLookup[i];
            if (vars === "all") {
                overwrittenProps[i] = vars;
                props = curLookup;
                curOverwriteProps = {};
            } else {
                curOverwriteProps = overwrittenProps[i] = overwrittenProps[i] || {};
                props = vars;
            }
            for(p in props){
                pt = curLookup && curLookup[p];
                if (pt) {
                    if (!("kill" in pt.d) || pt.d.kill(p) === true) $3e8f3adb9623a584$export$cd008aa6cd8844e3(this, pt, "_pt");
                    delete curLookup[p];
                }
                if (curOverwriteProps !== "all") curOverwriteProps[p] = 1;
            }
        }
        this._initted && !this._pt && firstPT && $3e8f3adb9623a584$var$_interrupt(this); //if all tweening properties are killed, kill the tween. Without this line, if there's a tween with multiple targets and then you killTweensOf() each target individually, the tween would technically still remain active and fire its onComplete even though there aren't any more properties tweening.
        return this;
    };
    Tween.to = function to(targets, vars) {
        return new Tween(targets, vars, arguments[2]);
    };
    Tween.from = function from(targets, vars) {
        return $3e8f3adb9623a584$var$_createTweenType(1, arguments);
    };
    Tween.delayedCall = function delayedCall(delay, callback, params, scope) {
        return new Tween(callback, 0, {
            immediateRender: false,
            lazy: false,
            overwrite: false,
            delay: delay,
            onComplete: callback,
            onReverseComplete: callback,
            onCompleteParams: params,
            onReverseCompleteParams: params,
            callbackScope: scope
        }); // we must use onReverseComplete too for things like timeline.add(() => {...}) which should be triggered in BOTH directions (forward and reverse)
    };
    Tween.fromTo = function fromTo(targets, fromVars, toVars) {
        return $3e8f3adb9623a584$var$_createTweenType(2, arguments);
    };
    Tween.set = function set(targets, vars) {
        vars.duration = 0;
        vars.repeatDelay || (vars.repeat = 0);
        return new Tween(targets, vars);
    };
    Tween.killTweensOf = function killTweensOf(targets, props, onlyActive) {
        return $3e8f3adb9623a584$var$_globalTimeline.killTweensOf(targets, props, onlyActive);
    };
    return Tween;
}($3e8f3adb9623a584$export$c35d437ae5945fcd);
$3e8f3adb9623a584$export$dc2b19673bb53610($3e8f3adb9623a584$export$208a41d6b4e37b97.prototype, {
    _targets: [],
    _lazy: 0,
    _startAt: 0,
    _op: 0,
    _onInit: 0
}); //add the pertinent timeline methods to Tween instances so that users can chain conveniently and create a timeline automatically. (removed due to concerns that it'd ultimately add to more confusion especially for beginners)
// _forEachName("to,from,fromTo,set,call,add,addLabel,addPause", name => {
// 	Tween.prototype[name] = function() {
// 		let tl = new Timeline();
// 		return _addToTimeline(tl, this)[name].apply(tl, toArray(arguments));
// 	}
// });
//for backward compatibility. Leverage the timeline calls.
$3e8f3adb9623a584$export$f9000b814859f126("staggerTo,staggerFrom,staggerFromTo", function(name) {
    $3e8f3adb9623a584$export$208a41d6b4e37b97[name] = function() {
        var tl = new $3e8f3adb9623a584$export$e6a97ba2cae5bb94(), params = $3e8f3adb9623a584$var$_slice.call(arguments, 0);
        params.splice(name === "staggerFromTo" ? 5 : 4, 0, 0);
        return tl[name].apply(tl, params);
    };
});
/*
 * --------------------------------------------------------------------------------------
 * PROPTWEEN
 * --------------------------------------------------------------------------------------
 */ var $3e8f3adb9623a584$var$_setterPlain = function _setterPlain(target, property, value) {
    return target[property] = value;
}, $3e8f3adb9623a584$var$_setterFunc = function _setterFunc(target, property, value) {
    return target[property](value);
}, $3e8f3adb9623a584$var$_setterFuncWithParam = function _setterFuncWithParam(target, property, value, data) {
    return target[property](data.fp, value);
}, $3e8f3adb9623a584$var$_setterAttribute = function _setterAttribute(target, property, value) {
    return target.setAttribute(property, value);
}, $3e8f3adb9623a584$export$d60fbc1e0278aaf0 = function _getSetter(target, property) {
    return $3e8f3adb9623a584$var$_isFunction(target[property]) ? $3e8f3adb9623a584$var$_setterFunc : $3e8f3adb9623a584$export$a8178c063a9fd3a1(target[property]) && target.setAttribute ? $3e8f3adb9623a584$var$_setterAttribute : $3e8f3adb9623a584$var$_setterPlain;
}, $3e8f3adb9623a584$var$_renderPlain = function _renderPlain(ratio, data) {
    return data.set(data.t, data.p, Math.round((data.s + data.c * ratio) * 1000000) / 1000000, data);
}, $3e8f3adb9623a584$var$_renderBoolean = function _renderBoolean(ratio, data) {
    return data.set(data.t, data.p, !!(data.s + data.c * ratio), data);
}, $3e8f3adb9623a584$export$c5bc8e04394ecb2 = function _renderComplexString(ratio, data) {
    var pt = data._pt, s = "";
    if (!ratio && data.b) //b = beginning string
    s = data.b;
    else if (ratio === 1 && data.e) //e = ending string
    s = data.e;
    else {
        while(pt){
            s = pt.p + (pt.m ? pt.m(pt.s + pt.c * ratio) : Math.round((pt.s + pt.c * ratio) * 10000) / 10000) + s; //we use the "p" property for the text inbetween (like a suffix). And in the context of a complex string, the modifier (m) is typically just Math.round(), like for RGB colors.
            pt = pt._next;
        }
        s += data.c; //we use the "c" of the PropTween to store the final chunk of non-numeric text.
    }
    data.set(data.t, data.p, s, data);
}, $3e8f3adb9623a584$var$_renderPropTweens = function _renderPropTweens(ratio, data) {
    var pt = data._pt;
    while(pt){
        pt.r(ratio, pt.d);
        pt = pt._next;
    }
}, $3e8f3adb9623a584$var$_addPluginModifier = function _addPluginModifier(modifier, tween, target, property) {
    var pt = this._pt, next;
    while(pt){
        next = pt._next;
        pt.p === property && pt.modifier(modifier, tween, target);
        pt = next;
    }
}, $3e8f3adb9623a584$var$_killPropTweensOf = function _killPropTweensOf(property) {
    var pt = this._pt, hasNonDependentRemaining, next;
    while(pt){
        next = pt._next;
        if (pt.p === property && !pt.op || pt.op === property) $3e8f3adb9623a584$export$cd008aa6cd8844e3(this, pt, "_pt");
        else if (!pt.dep) hasNonDependentRemaining = 1;
        pt = next;
    }
    return !hasNonDependentRemaining;
}, $3e8f3adb9623a584$var$_setterWithModifier = function _setterWithModifier(target, property, value, data) {
    data.mSet(target, property, data.m.call(data.tween, value, data.mt), data);
}, $3e8f3adb9623a584$export$eed5824f53346d57 = function _sortPropTweensByPriority(parent) {
    var pt = parent._pt, next, pt2, first, last; //sorts the PropTween linked list in order of priority because some plugins need to do their work after ALL of the PropTweens were created (like RoundPropsPlugin and ModifiersPlugin)
    while(pt){
        next = pt._next;
        pt2 = first;
        while(pt2 && pt2.pr > pt.pr)pt2 = pt2._next;
        if (pt._prev = pt2 ? pt2._prev : last) pt._prev._next = pt;
        else first = pt;
        if (pt._next = pt2) pt2._prev = pt;
        else last = pt;
        pt = next;
    }
    parent._pt = first;
}; //PropTween key: t = target, p = prop, r = renderer, d = data, s = start, c = change, op = overwriteProperty (ONLY populated when it's different than p), pr = priority, _next/_prev for the linked list siblings, set = setter, m = modifier, mSet = modifierSetter (the original setter, before a modifier was added)
var $3e8f3adb9623a584$export$3a67f7f44b1e838a = /*#__PURE__*/ function() {
    function PropTween(next, target, prop, start, change, renderer, data, setter, priority) {
        this.t = target;
        this.s = start;
        this.c = change;
        this.p = prop;
        this.r = renderer || $3e8f3adb9623a584$var$_renderPlain;
        this.d = data || this;
        this.set = setter || $3e8f3adb9623a584$var$_setterPlain;
        this.pr = priority || 0;
        this._next = next;
        if (next) next._prev = this;
    }
    var _proto4 = PropTween.prototype;
    _proto4.modifier = function modifier(func, tween, target) {
        this.mSet = this.mSet || this.set; //in case it was already set (a PropTween can only have one modifier)
        this.set = $3e8f3adb9623a584$var$_setterWithModifier;
        this.m = func;
        this.mt = target; //modifier target
        this.tween = tween;
    };
    return PropTween;
}(); //Initialization tasks
$3e8f3adb9623a584$export$f9000b814859f126($3e8f3adb9623a584$var$_callbackNames + "parent,duration,ease,delay,overwrite,runBackwards,startAt,yoyo,immediateRender,repeat,repeatDelay,data,paused,reversed,lazy,callbackScope,stringFilter,id,yoyoEase,stagger,inherit,repeatRefresh,keyframes,autoRevert,scrollTrigger", function(name) {
    return $3e8f3adb9623a584$var$_reservedProps[name] = 1;
});
$3e8f3adb9623a584$var$_globals.TweenMax = $3e8f3adb9623a584$var$_globals.TweenLite = $3e8f3adb9623a584$export$208a41d6b4e37b97;
$3e8f3adb9623a584$var$_globals.TimelineLite = $3e8f3adb9623a584$var$_globals.TimelineMax = $3e8f3adb9623a584$export$e6a97ba2cae5bb94;
$3e8f3adb9623a584$var$_globalTimeline = new $3e8f3adb9623a584$export$e6a97ba2cae5bb94({
    sortChildren: false,
    defaults: $3e8f3adb9623a584$var$_defaults,
    autoRemoveChildren: true,
    id: "root",
    smoothChildTiming: true
});
$3e8f3adb9623a584$export$4922bee768729a77.stringFilter = $3e8f3adb9623a584$export$7eb2e5eb5eeb96a4;
var $3e8f3adb9623a584$var$_media = [], $3e8f3adb9623a584$var$_listeners = {}, $3e8f3adb9623a584$var$_emptyArray = [], $3e8f3adb9623a584$var$_lastMediaTime = 0, $3e8f3adb9623a584$var$_contextID = 0, $3e8f3adb9623a584$var$_dispatch = function _dispatch(type) {
    return ($3e8f3adb9623a584$var$_listeners[type] || $3e8f3adb9623a584$var$_emptyArray).map(function(f) {
        return f();
    });
}, $3e8f3adb9623a584$var$_onMediaChange = function _onMediaChange() {
    var time = Date.now(), matches = [];
    if (time - $3e8f3adb9623a584$var$_lastMediaTime > 2) {
        $3e8f3adb9623a584$var$_dispatch("matchMediaInit");
        $3e8f3adb9623a584$var$_media.forEach(function(c) {
            var queries = c.queries, conditions = c.conditions, match, p, anyMatch, toggled;
            for(p in queries){
                match = $3e8f3adb9623a584$var$_win.matchMedia(queries[p]).matches; // Firefox doesn't update the "matches" property of the MediaQueryList object correctly - it only does so as it calls its change handler - so we must re-create a media query here to ensure it's accurate.
                match && (anyMatch = 1);
                if (match !== conditions[p]) {
                    conditions[p] = match;
                    toggled = 1;
                }
            }
            if (toggled) {
                c.revert();
                anyMatch && matches.push(c);
            }
        });
        $3e8f3adb9623a584$var$_dispatch("matchMediaRevert");
        matches.forEach(function(c) {
            return c.onMatch(c);
        });
        $3e8f3adb9623a584$var$_lastMediaTime = time;
        $3e8f3adb9623a584$var$_dispatch("matchMedia");
    }
};
var $3e8f3adb9623a584$var$Context = /*#__PURE__*/ function() {
    function Context(func, scope) {
        this.selector = scope && $3e8f3adb9623a584$export$aea217a45095ce11(scope);
        this.data = [];
        this._r = []; // returned/cleanup functions
        this.isReverted = false;
        this.id = $3e8f3adb9623a584$var$_contextID++; // to work around issues that frameworks like Vue cause by making things into Proxies which make it impossible to do something like _media.indexOf(this) because "this" would no longer refer to the Context instance itself - it'd refer to a Proxy! We needed a way to identify the context uniquely
        func && this.add(func);
    }
    var _proto5 = Context.prototype;
    _proto5.add = function add(name, func, scope) {
        // possible future addition if we need the ability to add() an animation to a context and for whatever reason cannot create that animation inside of a context.add(() => {...}) function.
        // if (name && _isFunction(name.revert)) {
        // 	this.data.push(name);
        // 	return (name._ctx = this);
        // }
        if ($3e8f3adb9623a584$var$_isFunction(name)) {
            scope = func;
            func = name;
            name = $3e8f3adb9623a584$var$_isFunction;
        }
        var self = this, f = function f() {
            var prev = $3e8f3adb9623a584$var$_context, prevSelector = self.selector, result;
            prev && prev !== self && prev.data.push(self);
            scope && (self.selector = $3e8f3adb9623a584$export$aea217a45095ce11(scope));
            $3e8f3adb9623a584$var$_context = self;
            result = func.apply(self, arguments);
            $3e8f3adb9623a584$var$_isFunction(result) && self._r.push(result);
            $3e8f3adb9623a584$var$_context = prev;
            self.selector = prevSelector;
            self.isReverted = false;
            return result;
        };
        self.last = f;
        return name === $3e8f3adb9623a584$var$_isFunction ? f(self) : name ? self[name] = f : f;
    };
    _proto5.ignore = function ignore(func) {
        var prev = $3e8f3adb9623a584$var$_context;
        $3e8f3adb9623a584$var$_context = null;
        func(this);
        $3e8f3adb9623a584$var$_context = prev;
    };
    _proto5.getTweens = function getTweens() {
        var a = [];
        this.data.forEach(function(e) {
            return e instanceof Context ? a.push.apply(a, e.getTweens()) : e instanceof $3e8f3adb9623a584$export$208a41d6b4e37b97 && !(e.parent && e.parent.data === "nested") && a.push(e);
        });
        return a;
    };
    _proto5.clear = function clear() {
        this._r.length = this.data.length = 0;
    };
    _proto5.kill = function kill(revert, matchMedia) {
        var _this4 = this;
        if (revert) {
            var tweens = this.getTweens();
            this.data.forEach(function(t) {
                // Flip plugin tweens are very different in that they should actually be pushed to their end. The plugin replaces the timeline's .revert() method to do exactly that. But we also need to remove any of those nested tweens inside the flip timeline so that they don't get individually reverted.
                if (t.data === "isFlip") {
                    t.revert();
                    t.getChildren(true, true, false).forEach(function(tween) {
                        return tweens.splice(tweens.indexOf(tween), 1);
                    });
                }
            }); // save as an object so that we can cache the globalTime for each tween to optimize performance during the sort
            tweens.map(function(t) {
                return {
                    g: t.globalTime(0),
                    t: t
                };
            }).sort(function(a, b) {
                return b.g - a.g || -Infinity;
            }).forEach(function(o) {
                return o.t.revert(revert);
            }); // note: all of the _startAt tweens should be reverted in reverse order that they were created, and they'll all have the same globalTime (-1) so the " || -1" in the sort keeps the order properly.
            this.data.forEach(function(e) {
                return !(e instanceof $3e8f3adb9623a584$export$208a41d6b4e37b97) && e.revert && e.revert(revert);
            });
            this._r.forEach(function(f) {
                return f(revert, _this4);
            });
            this.isReverted = true;
        } else this.data.forEach(function(e) {
            return e.kill && e.kill();
        });
        this.clear();
        if (matchMedia) {
            var i = $3e8f3adb9623a584$var$_media.length;
            while(i--)// previously, we checked _media.indexOf(this), but some frameworks like Vue enforce Proxy objects that make it impossible to get the proper result that way, so we must use a unique ID number instead.
            $3e8f3adb9623a584$var$_media[i].id === this.id && $3e8f3adb9623a584$var$_media.splice(i, 1);
        }
    };
    _proto5.revert = function revert(config) {
        this.kill(config || {});
    };
    return Context;
}();
var $3e8f3adb9623a584$var$MatchMedia = /*#__PURE__*/ function() {
    function MatchMedia(scope) {
        this.contexts = [];
        this.scope = scope;
    }
    var _proto6 = MatchMedia.prototype;
    _proto6.add = function add(conditions, func, scope) {
        $3e8f3adb9623a584$var$_isObject(conditions) || (conditions = {
            matches: conditions
        });
        var context = new $3e8f3adb9623a584$var$Context(0, scope || this.scope), cond = context.conditions = {}, mq, p, active;
        $3e8f3adb9623a584$var$_context && !context.selector && (context.selector = $3e8f3adb9623a584$var$_context.selector); // in case a context is created inside a context. Like a gsap.matchMedia() that's inside a scoped gsap.context()
        this.contexts.push(context);
        func = context.add("onMatch", func);
        context.queries = conditions;
        for(p in conditions)if (p === "all") active = 1;
        else {
            mq = $3e8f3adb9623a584$var$_win.matchMedia(conditions[p]);
            if (mq) {
                $3e8f3adb9623a584$var$_media.indexOf(context) < 0 && $3e8f3adb9623a584$var$_media.push(context);
                (cond[p] = mq.matches) && (active = 1);
                mq.addListener ? mq.addListener($3e8f3adb9623a584$var$_onMediaChange) : mq.addEventListener("change", $3e8f3adb9623a584$var$_onMediaChange);
            }
        }
        active && func(context);
        return this;
    } // refresh() {
    ;
    _proto6.revert = function revert(config) {
        this.kill(config || {});
    };
    _proto6.kill = function kill(revert) {
        this.contexts.forEach(function(c) {
            return c.kill(revert, true);
        });
    };
    return MatchMedia;
}();
/*
 * --------------------------------------------------------------------------------------
 * GSAP
 * --------------------------------------------------------------------------------------
 */ var $3e8f3adb9623a584$var$_gsap = {
    registerPlugin: function registerPlugin() {
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        args.forEach(function(config) {
            return $3e8f3adb9623a584$var$_createPlugin(config);
        });
    },
    timeline: function timeline(vars) {
        return new $3e8f3adb9623a584$export$e6a97ba2cae5bb94(vars);
    },
    getTweensOf: function getTweensOf(targets, onlyActive) {
        return $3e8f3adb9623a584$var$_globalTimeline.getTweensOf(targets, onlyActive);
    },
    getProperty: function getProperty(target, property, unit, uncache) {
        $3e8f3adb9623a584$export$f664476fd67145ca(target) && (target = $3e8f3adb9623a584$export$45b10814cc054894(target)[0]); //in case selector text or an array is passed in
        var getter = $3e8f3adb9623a584$export$8b9be379d2de2a39(target || {}).get, format = unit ? $3e8f3adb9623a584$var$_passThrough : $3e8f3adb9623a584$var$_numericIfPossible;
        unit === "native" && (unit = "");
        return !target ? target : !property ? function(property, unit, uncache) {
            return format(($3e8f3adb9623a584$export$d305d8ec5d7c26b8[property] && $3e8f3adb9623a584$export$d305d8ec5d7c26b8[property].get || getter)(target, property, unit, uncache));
        } : format(($3e8f3adb9623a584$export$d305d8ec5d7c26b8[property] && $3e8f3adb9623a584$export$d305d8ec5d7c26b8[property].get || getter)(target, property, unit, uncache));
    },
    quickSetter: function quickSetter(target, property, unit) {
        target = $3e8f3adb9623a584$export$45b10814cc054894(target);
        if (target.length > 1) {
            var setters = target.map(function(t) {
                return $3e8f3adb9623a584$export$99ee26438460406a.quickSetter(t, property, unit);
            }), l = setters.length;
            return function(value) {
                var i = l;
                while(i--)setters[i](value);
            };
        }
        target = target[0] || {};
        var Plugin = $3e8f3adb9623a584$export$d305d8ec5d7c26b8[property], cache = $3e8f3adb9623a584$export$8b9be379d2de2a39(target), p = cache.harness && (cache.harness.aliases || {})[property] || property, // in case it's an alias, like "rotate" for "rotation".
        setter = Plugin ? function(value) {
            var p = new Plugin();
            $3e8f3adb9623a584$var$_quickTween._pt = 0;
            p.init(target, unit ? value + unit : value, $3e8f3adb9623a584$var$_quickTween, 0, [
                target
            ]);
            p.render(1, p);
            $3e8f3adb9623a584$var$_quickTween._pt && $3e8f3adb9623a584$var$_renderPropTweens(1, $3e8f3adb9623a584$var$_quickTween);
        } : cache.set(target, p);
        return Plugin ? setter : function(value) {
            return setter(target, p, unit ? value + unit : value, cache, 1);
        };
    },
    quickTo: function quickTo(target, property, vars) {
        var _merge2;
        var tween = $3e8f3adb9623a584$export$99ee26438460406a.to(target, $3e8f3adb9623a584$var$_merge((_merge2 = {}, _merge2[property] = "+=0.1", _merge2.paused = true, _merge2), vars || {})), func = function func(value, start, startIsRelative) {
            return tween.resetTo(property, value, start, startIsRelative);
        };
        func.tween = tween;
        return func;
    },
    isTweening: function isTweening(targets) {
        return $3e8f3adb9623a584$var$_globalTimeline.getTweensOf(targets, true).length > 0;
    },
    defaults: function defaults(value) {
        value && value.ease && (value.ease = $3e8f3adb9623a584$var$_parseEase(value.ease, $3e8f3adb9623a584$var$_defaults.ease));
        return $3e8f3adb9623a584$var$_mergeDeep($3e8f3adb9623a584$var$_defaults, value || {});
    },
    config: function config(value) {
        return $3e8f3adb9623a584$var$_mergeDeep($3e8f3adb9623a584$export$4922bee768729a77, value || {});
    },
    registerEffect: function registerEffect(_ref3) {
        var name = _ref3.name, effect = _ref3.effect, plugins = _ref3.plugins, defaults = _ref3.defaults, extendTimeline = _ref3.extendTimeline;
        (plugins || "").split(",").forEach(function(pluginName) {
            return pluginName && !$3e8f3adb9623a584$export$d305d8ec5d7c26b8[pluginName] && !$3e8f3adb9623a584$var$_globals[pluginName] && $3e8f3adb9623a584$var$_warn(name + " effect requires " + pluginName + " plugin.");
        });
        $3e8f3adb9623a584$var$_effects[name] = function(targets, vars, tl) {
            return effect($3e8f3adb9623a584$export$45b10814cc054894(targets), $3e8f3adb9623a584$export$dc2b19673bb53610(vars || {}, defaults), tl);
        };
        if (extendTimeline) $3e8f3adb9623a584$export$e6a97ba2cae5bb94.prototype[name] = function(targets, vars, position) {
            return this.add($3e8f3adb9623a584$var$_effects[name](targets, $3e8f3adb9623a584$var$_isObject(vars) ? vars : (position = vars) && {}, this), position);
        };
    },
    registerEase: function registerEase(name, ease) {
        $3e8f3adb9623a584$var$_easeMap[name] = $3e8f3adb9623a584$var$_parseEase(ease);
    },
    parseEase: function parseEase(ease, defaultEase) {
        return arguments.length ? $3e8f3adb9623a584$var$_parseEase(ease, defaultEase) : $3e8f3adb9623a584$var$_easeMap;
    },
    getById: function getById(id) {
        return $3e8f3adb9623a584$var$_globalTimeline.getById(id);
    },
    exportRoot: function exportRoot(vars, includeDelayedCalls) {
        if (vars === void 0) vars = {};
        var tl = new $3e8f3adb9623a584$export$e6a97ba2cae5bb94(vars), child, next;
        tl.smoothChildTiming = $3e8f3adb9623a584$var$_isNotFalse(vars.smoothChildTiming);
        $3e8f3adb9623a584$var$_globalTimeline.remove(tl);
        tl._dp = 0; //otherwise it'll get re-activated when adding children and be re-introduced into _globalTimeline's linked list (then added to itself).
        tl._time = tl._tTime = $3e8f3adb9623a584$var$_globalTimeline._time;
        child = $3e8f3adb9623a584$var$_globalTimeline._first;
        while(child){
            next = child._next;
            if (includeDelayedCalls || !(!child._dur && child instanceof $3e8f3adb9623a584$export$208a41d6b4e37b97 && child.vars.onComplete === child._targets[0])) $3e8f3adb9623a584$var$_addToTimeline(tl, child, child._start - child._delay);
            child = next;
        }
        $3e8f3adb9623a584$var$_addToTimeline($3e8f3adb9623a584$var$_globalTimeline, tl, 0);
        return tl;
    },
    context: function context(func, scope) {
        return func ? new $3e8f3adb9623a584$var$Context(func, scope) : $3e8f3adb9623a584$var$_context;
    },
    matchMedia: function matchMedia(scope) {
        return new $3e8f3adb9623a584$var$MatchMedia(scope);
    },
    matchMediaRefresh: function matchMediaRefresh() {
        return $3e8f3adb9623a584$var$_media.forEach(function(c) {
            var cond = c.conditions, found, p;
            for(p in cond)if (cond[p]) {
                cond[p] = false;
                found = 1;
            }
            found && c.revert();
        }) || $3e8f3adb9623a584$var$_onMediaChange();
    },
    addEventListener: function addEventListener(type, callback) {
        var a = $3e8f3adb9623a584$var$_listeners[type] || ($3e8f3adb9623a584$var$_listeners[type] = []);
        ~a.indexOf(callback) || a.push(callback);
    },
    removeEventListener: function removeEventListener(type, callback) {
        var a = $3e8f3adb9623a584$var$_listeners[type], i = a && a.indexOf(callback);
        i >= 0 && a.splice(i, 1);
    },
    utils: {
        wrap: $3e8f3adb9623a584$export$4997ffc0176396a6,
        wrapYoyo: $3e8f3adb9623a584$export$cfc0b067273edc55,
        distribute: $3e8f3adb9623a584$export$f02a9ddbe4480f19,
        random: $3e8f3adb9623a584$export$4385e60b38654f68,
        snap: $3e8f3adb9623a584$export$51a0620f7a28532b,
        normalize: $3e8f3adb9623a584$export$a3295358bff77e,
        getUnit: $3e8f3adb9623a584$export$65f2564e9a9b9222,
        clamp: $3e8f3adb9623a584$export$7d15b64cf5a3a4c4,
        splitColor: $3e8f3adb9623a584$export$73d6f35be992df24,
        toArray: $3e8f3adb9623a584$export$45b10814cc054894,
        selector: $3e8f3adb9623a584$export$aea217a45095ce11,
        mapRange: $3e8f3adb9623a584$export$f65a7599bbc6b121,
        pipe: $3e8f3adb9623a584$export$a4627e546088548d,
        unitize: $3e8f3adb9623a584$export$d7502930aa5492de,
        interpolate: $3e8f3adb9623a584$export$89e29e4ab65e70a9,
        shuffle: $3e8f3adb9623a584$export$448332262467e042
    },
    install: $3e8f3adb9623a584$var$_install,
    effects: $3e8f3adb9623a584$var$_effects,
    ticker: $3e8f3adb9623a584$export$762ed8fbedb691e3,
    updateRoot: $3e8f3adb9623a584$export$e6a97ba2cae5bb94.updateRoot,
    plugins: $3e8f3adb9623a584$export$d305d8ec5d7c26b8,
    globalTimeline: $3e8f3adb9623a584$var$_globalTimeline,
    core: {
        PropTween: $3e8f3adb9623a584$export$3a67f7f44b1e838a,
        globals: $3e8f3adb9623a584$var$_addGlobal,
        Tween: $3e8f3adb9623a584$export$208a41d6b4e37b97,
        Timeline: $3e8f3adb9623a584$export$e6a97ba2cae5bb94,
        Animation: $3e8f3adb9623a584$export$c35d437ae5945fcd,
        getCache: $3e8f3adb9623a584$export$8b9be379d2de2a39,
        _removeLinkedListItem: $3e8f3adb9623a584$export$cd008aa6cd8844e3,
        reverting: function reverting() {
            return $3e8f3adb9623a584$var$_reverting;
        },
        context: function context(toAdd) {
            if (toAdd && $3e8f3adb9623a584$var$_context) {
                $3e8f3adb9623a584$var$_context.data.push(toAdd);
                toAdd._ctx = $3e8f3adb9623a584$var$_context;
            }
            return $3e8f3adb9623a584$var$_context;
        },
        suppressOverwrites: function suppressOverwrites(value) {
            return $3e8f3adb9623a584$var$_suppressOverwrites = value;
        }
    }
};
$3e8f3adb9623a584$export$f9000b814859f126("to,from,fromTo,delayedCall,set,killTweensOf", function(name) {
    return $3e8f3adb9623a584$var$_gsap[name] = $3e8f3adb9623a584$export$208a41d6b4e37b97[name];
});
$3e8f3adb9623a584$export$762ed8fbedb691e3.add($3e8f3adb9623a584$export$e6a97ba2cae5bb94.updateRoot);
$3e8f3adb9623a584$var$_quickTween = $3e8f3adb9623a584$var$_gsap.to({}, {
    duration: 0
}); // ---- EXTRA PLUGINS --------------------------------------------------------
var $3e8f3adb9623a584$var$_getPluginPropTween = function _getPluginPropTween(plugin, prop) {
    var pt = plugin._pt;
    while(pt && pt.p !== prop && pt.op !== prop && pt.fp !== prop)pt = pt._next;
    return pt;
}, $3e8f3adb9623a584$var$_addModifiers = function _addModifiers(tween, modifiers) {
    var targets = tween._targets, p, i, pt;
    for(p in modifiers){
        i = targets.length;
        while(i--){
            pt = tween._ptLookup[i][p];
            if (pt && (pt = pt.d)) {
                if (pt._pt) // is a plugin
                pt = $3e8f3adb9623a584$var$_getPluginPropTween(pt, p);
                pt && pt.modifier && pt.modifier(modifiers[p], tween, targets[i], p);
            }
        }
    }
}, $3e8f3adb9623a584$var$_buildModifierPlugin = function _buildModifierPlugin(name, modifier) {
    return {
        name: name,
        rawVars: 1,
        //don't pre-process function-based values or "random()" strings.
        init: function init(target, vars, tween) {
            tween._onInit = function(tween) {
                var temp, p;
                if ($3e8f3adb9623a584$export$f664476fd67145ca(vars)) {
                    temp = {};
                    $3e8f3adb9623a584$export$f9000b814859f126(vars, function(name) {
                        return temp[name] = 1;
                    }); //if the user passes in a comma-delimited list of property names to roundProps, like "x,y", we round to whole numbers.
                    vars = temp;
                }
                if (modifier) {
                    temp = {};
                    for(p in vars)temp[p] = modifier(vars[p]);
                    vars = temp;
                }
                $3e8f3adb9623a584$var$_addModifiers(tween, vars);
            };
        }
    };
}; //register core plugins
var $3e8f3adb9623a584$export$99ee26438460406a = $3e8f3adb9623a584$var$_gsap.registerPlugin({
    name: "attr",
    init: function init(target, vars, tween, index, targets) {
        var p, pt, v;
        this.tween = tween;
        for(p in vars){
            v = target.getAttribute(p) || "";
            pt = this.add(target, "setAttribute", (v || 0) + "", vars[p], index, targets, 0, 0, p);
            pt.op = p;
            pt.b = v; // record the beginning value so we can revert()
            this._props.push(p);
        }
    },
    render: function render(ratio, data) {
        var pt = data._pt;
        while(pt){
            $3e8f3adb9623a584$var$_reverting ? pt.set(pt.t, pt.p, pt.b, pt) : pt.r(ratio, pt.d); // if reverting, go back to the original (pt.b)
            pt = pt._next;
        }
    }
}, {
    name: "endArray",
    init: function init(target, value) {
        var i = value.length;
        while(i--)this.add(target, i, target[i] || 0, value[i], 0, 0, 0, 0, 0, 1);
    }
}, $3e8f3adb9623a584$var$_buildModifierPlugin("roundProps", $3e8f3adb9623a584$export$dd12390e6b265a17), $3e8f3adb9623a584$var$_buildModifierPlugin("modifiers"), $3e8f3adb9623a584$var$_buildModifierPlugin("snap", $3e8f3adb9623a584$export$51a0620f7a28532b)) || $3e8f3adb9623a584$var$_gsap; //to prevent the core plugins from being dropped via aggressive tree shaking, we must include them in the variable declaration in this way.
$3e8f3adb9623a584$export$208a41d6b4e37b97.version = $3e8f3adb9623a584$export$e6a97ba2cae5bb94.version = $3e8f3adb9623a584$export$99ee26438460406a.version = "3.12.2";
$3e8f3adb9623a584$var$_coreReady = 1;
$3e8f3adb9623a584$var$_windowExists() && $3e8f3adb9623a584$var$_wake();
var $3e8f3adb9623a584$export$2fae1e8613537d5f = $3e8f3adb9623a584$var$_easeMap.Power0, $3e8f3adb9623a584$export$5d84ab4efbecec39 = $3e8f3adb9623a584$var$_easeMap.Power1, $3e8f3adb9623a584$export$d8c694b7490ad65d = $3e8f3adb9623a584$var$_easeMap.Power2, $3e8f3adb9623a584$export$acebdf2b184a0b6f = $3e8f3adb9623a584$var$_easeMap.Power3, $3e8f3adb9623a584$export$42e40a141003d2f0 = $3e8f3adb9623a584$var$_easeMap.Power4, $3e8f3adb9623a584$export$cff00ccf6e2392de = $3e8f3adb9623a584$var$_easeMap.Linear, $3e8f3adb9623a584$export$7005c9eb6671414d = $3e8f3adb9623a584$var$_easeMap.Quad, $3e8f3adb9623a584$export$755261d5a1567778 = $3e8f3adb9623a584$var$_easeMap.Cubic, $3e8f3adb9623a584$export$daf531446cad3d2a = $3e8f3adb9623a584$var$_easeMap.Quart, $3e8f3adb9623a584$export$4c407d38ce8ad8cc = $3e8f3adb9623a584$var$_easeMap.Quint, $3e8f3adb9623a584$export$f301627d437cff88 = $3e8f3adb9623a584$var$_easeMap.Strong, $3e8f3adb9623a584$export$56ebabebb04a9ca9 = $3e8f3adb9623a584$var$_easeMap.Elastic, $3e8f3adb9623a584$export$25e48ac541203d4a = $3e8f3adb9623a584$var$_easeMap.Back, $3e8f3adb9623a584$export$f7a11c7543d81853 = $3e8f3adb9623a584$var$_easeMap.SteppedEase, $3e8f3adb9623a584$export$d20e79fdc3899e95 = $3e8f3adb9623a584$var$_easeMap.Bounce, $3e8f3adb9623a584$export$bed2d20ad96b784c = $3e8f3adb9623a584$var$_easeMap.Sine, $3e8f3adb9623a584$export$41e9d1ff1a2fb15a = $3e8f3adb9623a584$var$_easeMap.Expo, $3e8f3adb9623a584$export$ce49a57dd865b86c = $3e8f3adb9623a584$var$_easeMap.Circ;


/*!
 * CSSPlugin 3.12.2
 * https://greensock.com
 *
 * Copyright 2008-2023, GreenSock. All rights reserved.
 * Subject to the terms at https://greensock.com/standard-license or for
 * Club GreenSock members, the agreement issued with that membership.
 * @author: Jack Doyle, jack@greensock.com
*/ /* eslint-disable */ 
var $77ec02c321bf14d7$var$_win, $77ec02c321bf14d7$var$_doc, $77ec02c321bf14d7$var$_docElement, $77ec02c321bf14d7$var$_pluginInitted, $77ec02c321bf14d7$var$_tempDiv, $77ec02c321bf14d7$var$_tempDivStyler, $77ec02c321bf14d7$var$_recentSetterPlugin, $77ec02c321bf14d7$var$_reverting, $77ec02c321bf14d7$var$_windowExists = function _windowExists() {
    return typeof window !== "undefined";
}, $77ec02c321bf14d7$var$_transformProps = {}, $77ec02c321bf14d7$var$_RAD2DEG = 180 / Math.PI, $77ec02c321bf14d7$var$_DEG2RAD = Math.PI / 180, $77ec02c321bf14d7$var$_atan2 = Math.atan2, $77ec02c321bf14d7$var$_bigNum = 1e8, $77ec02c321bf14d7$var$_capsExp = /([A-Z])/g, $77ec02c321bf14d7$var$_horizontalExp = /(left|right|width|margin|padding|x)/i, $77ec02c321bf14d7$var$_complexExp = /[\s,\(]\S/, $77ec02c321bf14d7$var$_propertyAliases = {
    autoAlpha: "opacity,visibility",
    scale: "scaleX,scaleY",
    alpha: "opacity"
}, $77ec02c321bf14d7$var$_renderCSSProp = function _renderCSSProp(ratio, data) {
    return data.set(data.t, data.p, Math.round((data.s + data.c * ratio) * 10000) / 10000 + data.u, data);
}, $77ec02c321bf14d7$var$_renderPropWithEnd = function _renderPropWithEnd(ratio, data) {
    return data.set(data.t, data.p, ratio === 1 ? data.e : Math.round((data.s + data.c * ratio) * 10000) / 10000 + data.u, data);
}, $77ec02c321bf14d7$var$_renderCSSPropWithBeginning = function _renderCSSPropWithBeginning(ratio, data) {
    return data.set(data.t, data.p, ratio ? Math.round((data.s + data.c * ratio) * 10000) / 10000 + data.u : data.b, data);
}, //if units change, we need a way to render the original unit/value when the tween goes all the way back to the beginning (ratio:0)
$77ec02c321bf14d7$var$_renderRoundedCSSProp = function _renderRoundedCSSProp(ratio, data) {
    var value = data.s + data.c * ratio;
    data.set(data.t, data.p, ~~(value + (value < 0 ? -0.5 : .5)) + data.u, data);
}, $77ec02c321bf14d7$var$_renderNonTweeningValue = function _renderNonTweeningValue(ratio, data) {
    return data.set(data.t, data.p, ratio ? data.e : data.b, data);
}, $77ec02c321bf14d7$var$_renderNonTweeningValueOnlyAtEnd = function _renderNonTweeningValueOnlyAtEnd(ratio, data) {
    return data.set(data.t, data.p, ratio !== 1 ? data.b : data.e, data);
}, $77ec02c321bf14d7$var$_setterCSSStyle = function _setterCSSStyle(target, property, value) {
    return target.style[property] = value;
}, $77ec02c321bf14d7$var$_setterCSSProp = function _setterCSSProp(target, property, value) {
    return target.style.setProperty(property, value);
}, $77ec02c321bf14d7$var$_setterTransform = function _setterTransform(target, property, value) {
    return target._gsap[property] = value;
}, $77ec02c321bf14d7$var$_setterScale = function _setterScale(target, property, value) {
    return target._gsap.scaleX = target._gsap.scaleY = value;
}, $77ec02c321bf14d7$var$_setterScaleWithRender = function _setterScaleWithRender(target, property, value, data, ratio) {
    var cache = target._gsap;
    cache.scaleX = cache.scaleY = value;
    cache.renderTransform(ratio, cache);
}, $77ec02c321bf14d7$var$_setterTransformWithRender = function _setterTransformWithRender(target, property, value, data, ratio) {
    var cache = target._gsap;
    cache[property] = value;
    cache.renderTransform(ratio, cache);
}, $77ec02c321bf14d7$var$_transformProp = "transform", $77ec02c321bf14d7$var$_transformOriginProp = $77ec02c321bf14d7$var$_transformProp + "Origin", $77ec02c321bf14d7$var$_saveStyle = function _saveStyle(property, isNotCSS) {
    var _this = this;
    var target = this.target, style = target.style;
    if (property in $77ec02c321bf14d7$var$_transformProps && style) {
        this.tfm = this.tfm || {};
        if (property !== "transform") {
            property = $77ec02c321bf14d7$var$_propertyAliases[property] || property;
            ~property.indexOf(",") ? property.split(",").forEach(function(a) {
                return _this.tfm[a] = $77ec02c321bf14d7$var$_get(target, a);
            }) : this.tfm[property] = target._gsap.x ? target._gsap[property] : $77ec02c321bf14d7$var$_get(target, property); // note: scale would map to "scaleX,scaleY", thus we loop and apply them both.
        } else return $77ec02c321bf14d7$var$_propertyAliases.transform.split(",").forEach(function(p) {
            return _saveStyle.call(_this, p, isNotCSS);
        });
        if (this.props.indexOf($77ec02c321bf14d7$var$_transformProp) >= 0) return;
        if (target._gsap.svg) {
            this.svgo = target.getAttribute("data-svg-origin");
            this.props.push($77ec02c321bf14d7$var$_transformOriginProp, isNotCSS, "");
        }
        property = $77ec02c321bf14d7$var$_transformProp;
    }
    (style || isNotCSS) && this.props.push(property, isNotCSS, style[property]);
}, $77ec02c321bf14d7$var$_removeIndependentTransforms = function _removeIndependentTransforms(style) {
    if (style.translate) {
        style.removeProperty("translate");
        style.removeProperty("scale");
        style.removeProperty("rotate");
    }
}, $77ec02c321bf14d7$var$_revertStyle = function _revertStyle() {
    var props = this.props, target = this.target, style = target.style, cache = target._gsap, i, p;
    for(i = 0; i < props.length; i += 3)// stored like this: property, isNotCSS, value
    props[i + 1] ? target[props[i]] = props[i + 2] : props[i + 2] ? style[props[i]] = props[i + 2] : style.removeProperty(props[i].substr(0, 2) === "--" ? props[i] : props[i].replace($77ec02c321bf14d7$var$_capsExp, "-$1").toLowerCase());
    if (this.tfm) {
        for(p in this.tfm)cache[p] = this.tfm[p];
        if (cache.svg) {
            cache.renderTransform();
            target.setAttribute("data-svg-origin", this.svgo || "");
        }
        i = $77ec02c321bf14d7$var$_reverting();
        if ((!i || !i.isStart) && !style[$77ec02c321bf14d7$var$_transformProp]) {
            $77ec02c321bf14d7$var$_removeIndependentTransforms(style);
            cache.uncache = 1; // if it's a startAt that's being reverted in the _initTween() of the core, we don't need to uncache transforms. This is purely a performance optimization.
        }
    }
}, $77ec02c321bf14d7$var$_getStyleSaver = function _getStyleSaver(target, properties) {
    var saver = {
        target: target,
        props: [],
        revert: $77ec02c321bf14d7$var$_revertStyle,
        save: $77ec02c321bf14d7$var$_saveStyle
    };
    target._gsap || (0, $3e8f3adb9623a584$export$99ee26438460406a).core.getCache(target); // just make sure there's a _gsap cache defined because we read from it in _saveStyle() and it's more efficient to just check it here once.
    properties && properties.split(",").forEach(function(p) {
        return saver.save(p);
    });
    return saver;
}, $77ec02c321bf14d7$var$_supports3D, $77ec02c321bf14d7$export$a232bb0480ae674a = function _createElement(type, ns) {
    var e = $77ec02c321bf14d7$var$_doc.createElementNS ? $77ec02c321bf14d7$var$_doc.createElementNS((ns || "http://www.w3.org/1999/xhtml").replace(/^https/, "http"), type) : $77ec02c321bf14d7$var$_doc.createElement(type); //some servers swap in https for http in the namespace which can break things, making "style" inaccessible.
    return e.style ? e : $77ec02c321bf14d7$var$_doc.createElement(type); //some environments won't allow access to the element's style when created with a namespace in which case we default to the standard createElement() to work around the issue. Also note that when GSAP is embedded directly inside an SVG file, createElement() won't allow access to the style object in Firefox (see https://greensock.com/forums/topic/20215-problem-using-tweenmax-in-standalone-self-containing-svg-file-err-cannot-set-property-csstext-of-undefined/).
}, $77ec02c321bf14d7$var$_getComputedProperty = function _getComputedProperty(target, property, skipPrefixFallback) {
    var cs = getComputedStyle(target);
    return cs[property] || cs.getPropertyValue(property.replace($77ec02c321bf14d7$var$_capsExp, "-$1").toLowerCase()) || cs.getPropertyValue(property) || !skipPrefixFallback && _getComputedProperty(target, $77ec02c321bf14d7$export$8cbef5dd49a09c8b(property) || property, 1) || ""; //css variables may not need caps swapped out for dashes and lowercase.
}, $77ec02c321bf14d7$var$_prefixes = "O,Moz,ms,Ms,Webkit".split(","), $77ec02c321bf14d7$export$8cbef5dd49a09c8b = function _checkPropPrefix(property, element, preferPrefix) {
    var e = element || $77ec02c321bf14d7$var$_tempDiv, s = e.style, i = 5;
    if (property in s && !preferPrefix) return property;
    property = property.charAt(0).toUpperCase() + property.substr(1);
    while(i-- && !($77ec02c321bf14d7$var$_prefixes[i] + property in s));
    return i < 0 ? null : (i === 3 ? "ms" : i >= 0 ? $77ec02c321bf14d7$var$_prefixes[i] : "") + property;
}, $77ec02c321bf14d7$var$_initCore = function _initCore() {
    if ($77ec02c321bf14d7$var$_windowExists() && window.document) {
        $77ec02c321bf14d7$var$_win = window;
        $77ec02c321bf14d7$var$_doc = $77ec02c321bf14d7$var$_win.document;
        $77ec02c321bf14d7$var$_docElement = $77ec02c321bf14d7$var$_doc.documentElement;
        $77ec02c321bf14d7$var$_tempDiv = $77ec02c321bf14d7$export$a232bb0480ae674a("div") || {
            style: {}
        };
        $77ec02c321bf14d7$var$_tempDivStyler = $77ec02c321bf14d7$export$a232bb0480ae674a("div");
        $77ec02c321bf14d7$var$_transformProp = $77ec02c321bf14d7$export$8cbef5dd49a09c8b($77ec02c321bf14d7$var$_transformProp);
        $77ec02c321bf14d7$var$_transformOriginProp = $77ec02c321bf14d7$var$_transformProp + "Origin";
        $77ec02c321bf14d7$var$_tempDiv.style.cssText = "border-width:0;line-height:0;position:absolute;padding:0"; //make sure to override certain properties that may contaminate measurements, in case the user has overreaching style sheets.
        $77ec02c321bf14d7$var$_supports3D = !!$77ec02c321bf14d7$export$8cbef5dd49a09c8b("perspective");
        $77ec02c321bf14d7$var$_reverting = (0, $3e8f3adb9623a584$export$99ee26438460406a).core.reverting;
        $77ec02c321bf14d7$var$_pluginInitted = 1;
    }
}, $77ec02c321bf14d7$var$_getBBoxHack = function _getBBoxHack(swapIfPossible) {
    //works around issues in some browsers (like Firefox) that don't correctly report getBBox() on SVG elements inside a <defs> element and/or <mask>. We try creating an SVG, adding it to the documentElement and toss the element in there so that it's definitely part of the rendering tree, then grab the bbox and if it works, we actually swap out the original getBBox() method for our own that does these extra steps whenever getBBox is needed. This helps ensure that performance is optimal (only do all these extra steps when absolutely necessary...most elements don't need it).
    var svg = $77ec02c321bf14d7$export$a232bb0480ae674a("svg", this.ownerSVGElement && this.ownerSVGElement.getAttribute("xmlns") || "http://www.w3.org/2000/svg"), oldParent = this.parentNode, oldSibling = this.nextSibling, oldCSS = this.style.cssText, bbox;
    $77ec02c321bf14d7$var$_docElement.appendChild(svg);
    svg.appendChild(this);
    this.style.display = "block";
    if (swapIfPossible) try {
        bbox = this.getBBox();
        this._gsapBBox = this.getBBox; //store the original
        this.getBBox = _getBBoxHack;
    } catch (e) {}
    else if (this._gsapBBox) bbox = this._gsapBBox();
    if (oldParent) {
        if (oldSibling) oldParent.insertBefore(this, oldSibling);
        else oldParent.appendChild(this);
    }
    $77ec02c321bf14d7$var$_docElement.removeChild(svg);
    this.style.cssText = oldCSS;
    return bbox;
}, $77ec02c321bf14d7$var$_getAttributeFallbacks = function _getAttributeFallbacks(target, attributesArray) {
    var i = attributesArray.length;
    while(i--){
        if (target.hasAttribute(attributesArray[i])) return target.getAttribute(attributesArray[i]);
    }
}, $77ec02c321bf14d7$export$41bc7c2d1e04f11b = function _getBBox(target) {
    var bounds;
    try {
        bounds = target.getBBox(); //Firefox throws errors if you try calling getBBox() on an SVG element that's not rendered (like in a <symbol> or <defs>). https://bugzilla.mozilla.org/show_bug.cgi?id=612118
    } catch (error) {
        bounds = $77ec02c321bf14d7$var$_getBBoxHack.call(target, true);
    }
    bounds && (bounds.width || bounds.height) || target.getBBox === $77ec02c321bf14d7$var$_getBBoxHack || (bounds = $77ec02c321bf14d7$var$_getBBoxHack.call(target, true)); //some browsers (like Firefox) misreport the bounds if the element has zero width and height (it just assumes it's at x:0, y:0), thus we need to manually grab the position in that case.
    return bounds && !bounds.width && !bounds.x && !bounds.y ? {
        x: +$77ec02c321bf14d7$var$_getAttributeFallbacks(target, [
            "x",
            "cx",
            "x1"
        ]) || 0,
        y: +$77ec02c321bf14d7$var$_getAttributeFallbacks(target, [
            "y",
            "cy",
            "y1"
        ]) || 0,
        width: 0,
        height: 0
    } : bounds;
}, $77ec02c321bf14d7$var$_isSVG = function _isSVG(e) {
    return !!(e.getCTM && (!e.parentNode || e.ownerSVGElement) && $77ec02c321bf14d7$export$41bc7c2d1e04f11b(e));
}, //reports if the element is an SVG on which getBBox() actually works
$77ec02c321bf14d7$var$_removeProperty = function _removeProperty(target, property) {
    if (property) {
        var style = target.style;
        if (property in $77ec02c321bf14d7$var$_transformProps && property !== $77ec02c321bf14d7$var$_transformOriginProp) property = $77ec02c321bf14d7$var$_transformProp;
        if (style.removeProperty) {
            if (property.substr(0, 2) === "ms" || property.substr(0, 6) === "webkit") //Microsoft and some Webkit browsers don't conform to the standard of capitalizing the first prefix character, so we adjust so that when we prefix the caps with a dash, it's correct (otherwise it'd be "ms-transform" instead of "-ms-transform" for IE9, for example)
            property = "-" + property;
            style.removeProperty(property.replace($77ec02c321bf14d7$var$_capsExp, "-$1").toLowerCase());
        } else //note: old versions of IE use "removeAttribute()" instead of "removeProperty()"
        style.removeAttribute(property);
    }
}, $77ec02c321bf14d7$var$_addNonTweeningPT = function _addNonTweeningPT(plugin, target, property, beginning, end, onlySetAtEnd) {
    var pt = new (0, $3e8f3adb9623a584$export$3a67f7f44b1e838a)(plugin._pt, target, property, 0, 1, onlySetAtEnd ? $77ec02c321bf14d7$var$_renderNonTweeningValueOnlyAtEnd : $77ec02c321bf14d7$var$_renderNonTweeningValue);
    plugin._pt = pt;
    pt.b = beginning;
    pt.e = end;
    plugin._props.push(property);
    return pt;
}, $77ec02c321bf14d7$var$_nonConvertibleUnits = {
    deg: 1,
    rad: 1,
    turn: 1
}, $77ec02c321bf14d7$var$_nonStandardLayouts = {
    grid: 1,
    flex: 1
}, //takes a single value like 20px and converts it to the unit specified, like "%", returning only the numeric amount.
$77ec02c321bf14d7$var$_convertToUnit = function _convertToUnit(target, property, value, unit) {
    var curValue = parseFloat(value) || 0, curUnit = (value + "").trim().substr((curValue + "").length) || "px", // some browsers leave extra whitespace at the beginning of CSS variables, hence the need to trim()
    style = $77ec02c321bf14d7$var$_tempDiv.style, horizontal = $77ec02c321bf14d7$var$_horizontalExp.test(property), isRootSVG = target.tagName.toLowerCase() === "svg", measureProperty = (isRootSVG ? "client" : "offset") + (horizontal ? "Width" : "Height"), amount = 100, toPixels = unit === "px", toPercent = unit === "%", px, parent, cache, isSVG;
    if (unit === curUnit || !curValue || $77ec02c321bf14d7$var$_nonConvertibleUnits[unit] || $77ec02c321bf14d7$var$_nonConvertibleUnits[curUnit]) return curValue;
    curUnit !== "px" && !toPixels && (curValue = _convertToUnit(target, property, value, "px"));
    isSVG = target.getCTM && $77ec02c321bf14d7$var$_isSVG(target);
    if ((toPercent || curUnit === "%") && ($77ec02c321bf14d7$var$_transformProps[property] || ~property.indexOf("adius"))) {
        px = isSVG ? target.getBBox()[horizontal ? "width" : "height"] : target[measureProperty];
        return (0, $3e8f3adb9623a584$export$9c8d725d65e13f94)(toPercent ? curValue / px * amount : curValue / 100 * px);
    }
    style[horizontal ? "width" : "height"] = amount + (toPixels ? curUnit : unit);
    parent = ~property.indexOf("adius") || unit === "em" && target.appendChild && !isRootSVG ? target : target.parentNode;
    if (isSVG) parent = (target.ownerSVGElement || {}).parentNode;
    if (!parent || parent === $77ec02c321bf14d7$var$_doc || !parent.appendChild) parent = $77ec02c321bf14d7$var$_doc.body;
    cache = parent._gsap;
    if (cache && toPercent && cache.width && horizontal && cache.time === (0, $3e8f3adb9623a584$export$762ed8fbedb691e3).time && !cache.uncache) return (0, $3e8f3adb9623a584$export$9c8d725d65e13f94)(curValue / cache.width * amount);
    else {
        (toPercent || curUnit === "%") && !$77ec02c321bf14d7$var$_nonStandardLayouts[$77ec02c321bf14d7$var$_getComputedProperty(parent, "display")] && (style.position = $77ec02c321bf14d7$var$_getComputedProperty(target, "position"));
        parent === target && (style.position = "static"); // like for borderRadius, if it's a % we must have it relative to the target itself but that may not have position: relative or position: absolute in which case it'd go up the chain until it finds its offsetParent (bad). position: static protects against that.
        parent.appendChild($77ec02c321bf14d7$var$_tempDiv);
        px = $77ec02c321bf14d7$var$_tempDiv[measureProperty];
        parent.removeChild($77ec02c321bf14d7$var$_tempDiv);
        style.position = "absolute";
        if (horizontal && toPercent) {
            cache = (0, $3e8f3adb9623a584$export$8b9be379d2de2a39)(parent);
            cache.time = (0, $3e8f3adb9623a584$export$762ed8fbedb691e3).time;
            cache.width = parent[measureProperty];
        }
    }
    return (0, $3e8f3adb9623a584$export$9c8d725d65e13f94)(toPixels ? px * curValue / amount : px && curValue ? amount / px * curValue : 0);
}, $77ec02c321bf14d7$var$_get = function _get(target, property, unit, uncache) {
    var value;
    $77ec02c321bf14d7$var$_pluginInitted || $77ec02c321bf14d7$var$_initCore();
    if (property in $77ec02c321bf14d7$var$_propertyAliases && property !== "transform") {
        property = $77ec02c321bf14d7$var$_propertyAliases[property];
        if (~property.indexOf(",")) property = property.split(",")[0];
    }
    if ($77ec02c321bf14d7$var$_transformProps[property] && property !== "transform") {
        value = $77ec02c321bf14d7$var$_parseTransform(target, uncache);
        value = property !== "transformOrigin" ? value[property] : value.svg ? value.origin : $77ec02c321bf14d7$var$_firstTwoOnly($77ec02c321bf14d7$var$_getComputedProperty(target, $77ec02c321bf14d7$var$_transformOriginProp)) + " " + value.zOrigin + "px";
    } else {
        value = target.style[property];
        if (!value || value === "auto" || uncache || ~(value + "").indexOf("calc(")) value = $77ec02c321bf14d7$var$_specialProps[property] && $77ec02c321bf14d7$var$_specialProps[property](target, property, unit) || $77ec02c321bf14d7$var$_getComputedProperty(target, property) || (0, $3e8f3adb9623a584$export$51d6bbe898aef1f9)(target, property) || (property === "opacity" ? 1 : 0); // note: some browsers, like Firefox, don't report borderRadius correctly! Instead, it only reports every corner like  borderTopLeftRadius
    }
    return unit && !~(value + "").trim().indexOf(" ") ? $77ec02c321bf14d7$var$_convertToUnit(target, property, value, unit) + unit : value;
}, $77ec02c321bf14d7$var$_tweenComplexCSSString = function _tweenComplexCSSString(target, prop, start, end) {
    // note: we call _tweenComplexCSSString.call(pluginInstance...) to ensure that it's scoped properly. We may call it from within a plugin too, thus "this" would refer to the plugin.
    if (!start || start === "none") {
        // some browsers like Safari actually PREFER the prefixed property and mis-report the unprefixed value like clipPath (BUG). In other words, even though clipPath exists in the style ("clipPath" in target.style) and it's set in the CSS properly (along with -webkit-clip-path), Safari reports clipPath as "none" whereas WebkitClipPath reports accurately like "ellipse(100% 0% at 50% 0%)", so in this case we must SWITCH to using the prefixed property instead. See https://greensock.com/forums/topic/18310-clippath-doesnt-work-on-ios/
        var p = $77ec02c321bf14d7$export$8cbef5dd49a09c8b(prop, target, 1), s = p && $77ec02c321bf14d7$var$_getComputedProperty(target, p, 1);
        if (s && s !== start) {
            prop = p;
            start = s;
        } else if (prop === "borderColor") start = $77ec02c321bf14d7$var$_getComputedProperty(target, "borderTopColor"); // Firefox bug: always reports "borderColor" as "", so we must fall back to borderTopColor. See https://greensock.com/forums/topic/24583-how-to-return-colors-that-i-had-after-reverse/
    }
    var pt = new (0, $3e8f3adb9623a584$export$3a67f7f44b1e838a)(this._pt, target.style, prop, 0, 1, (0, $3e8f3adb9623a584$export$c5bc8e04394ecb2)), index = 0, matchIndex = 0, a, result, startValues, startNum, color, startValue, endValue, endNum, chunk, endUnit, startUnit, endValues;
    pt.b = start;
    pt.e = end;
    start += ""; // ensure values are strings
    end += "";
    if (end === "auto") {
        target.style[prop] = end;
        end = $77ec02c321bf14d7$var$_getComputedProperty(target, prop) || end;
        target.style[prop] = start;
    }
    a = [
        start,
        end
    ];
    (0, $3e8f3adb9623a584$export$7eb2e5eb5eeb96a4)(a); // pass an array with the starting and ending values and let the filter do whatever it needs to the values. If colors are found, it returns true and then we must match where the color shows up order-wise because for things like boxShadow, sometimes the browser provides the computed values with the color FIRST, but the user provides it with the color LAST, so flip them if necessary. Same for drop-shadow().
    start = a[0];
    end = a[1];
    startValues = start.match((0, $3e8f3adb9623a584$export$65c88bbd597e7b0a)) || [];
    endValues = end.match((0, $3e8f3adb9623a584$export$65c88bbd597e7b0a)) || [];
    if (endValues.length) {
        while(result = (0, $3e8f3adb9623a584$export$65c88bbd597e7b0a).exec(end)){
            endValue = result[0];
            chunk = end.substring(index, result.index);
            if (color) color = (color + 1) % 5;
            else if (chunk.substr(-5) === "rgba(" || chunk.substr(-5) === "hsla(") color = 1;
            if (endValue !== (startValue = startValues[matchIndex++] || "")) {
                startNum = parseFloat(startValue) || 0;
                startUnit = startValue.substr((startNum + "").length);
                endValue.charAt(1) === "=" && (endValue = (0, $3e8f3adb9623a584$export$dac762bc6301b560)(startNum, endValue) + startUnit);
                endNum = parseFloat(endValue);
                endUnit = endValue.substr((endNum + "").length);
                index = (0, $3e8f3adb9623a584$export$65c88bbd597e7b0a).lastIndex - endUnit.length;
                if (!endUnit) {
                    //if something like "perspective:300" is passed in and we must add a unit to the end
                    endUnit = endUnit || (0, $3e8f3adb9623a584$export$4922bee768729a77).units[prop] || startUnit;
                    if (index === end.length) {
                        end += endUnit;
                        pt.e += endUnit;
                    }
                }
                if (startUnit !== endUnit) startNum = $77ec02c321bf14d7$var$_convertToUnit(target, prop, startValue, endUnit) || 0;
                 // these nested PropTweens are handled in a special way - we'll never actually call a render or setter method on them. We'll just loop through them in the parent complex string PropTween's render method.
                pt._pt = {
                    _next: pt._pt,
                    p: chunk || matchIndex === 1 ? chunk : ",",
                    //note: SVG spec allows omission of comma/space when a negative sign is wedged between two numbers, like 2.5-5.3 instead of 2.5,-5.3 but when tweening, the negative value may switch to positive, so we insert the comma just in case.
                    s: startNum,
                    c: endNum - startNum,
                    m: color && color < 4 || prop === "zIndex" ? Math.round : 0
                };
            }
        }
        pt.c = index < end.length ? end.substring(index, end.length) : ""; //we use the "c" of the PropTween to store the final part of the string (after the last number)
    } else pt.r = prop === "display" && end === "none" ? $77ec02c321bf14d7$var$_renderNonTweeningValueOnlyAtEnd : $77ec02c321bf14d7$var$_renderNonTweeningValue;
    (0, $3e8f3adb9623a584$export$5a680e28b0b61bc).test(end) && (pt.e = 0); //if the end string contains relative values or dynamic random(...) values, delete the end it so that on the final render we don't actually set it to the string with += or -= characters (forces it to use the calculated value).
    this._pt = pt; //start the linked list with this new PropTween. Remember, we call _tweenComplexCSSString.call(pluginInstance...) to ensure that it's scoped properly. We may call it from within another plugin too, thus "this" would refer to the plugin.
    return pt;
}, $77ec02c321bf14d7$var$_keywordToPercent = {
    top: "0%",
    bottom: "100%",
    left: "0%",
    right: "100%",
    center: "50%"
}, $77ec02c321bf14d7$var$_convertKeywordsToPercentages = function _convertKeywordsToPercentages(value) {
    var split = value.split(" "), x = split[0], y = split[1] || "50%";
    if (x === "top" || x === "bottom" || y === "left" || y === "right") {
        //the user provided them in the wrong order, so flip them
        value = x;
        x = y;
        y = value;
    }
    split[0] = $77ec02c321bf14d7$var$_keywordToPercent[x] || x;
    split[1] = $77ec02c321bf14d7$var$_keywordToPercent[y] || y;
    return split.join(" ");
}, $77ec02c321bf14d7$var$_renderClearProps = function _renderClearProps(ratio, data) {
    if (data.tween && data.tween._time === data.tween._dur) {
        var target = data.t, style = target.style, props = data.u, cache = target._gsap, prop, clearTransforms, i;
        if (props === "all" || props === true) {
            style.cssText = "";
            clearTransforms = 1;
        } else {
            props = props.split(",");
            i = props.length;
            while(--i > -1){
                prop = props[i];
                if ($77ec02c321bf14d7$var$_transformProps[prop]) {
                    clearTransforms = 1;
                    prop = prop === "transformOrigin" ? $77ec02c321bf14d7$var$_transformOriginProp : $77ec02c321bf14d7$var$_transformProp;
                }
                $77ec02c321bf14d7$var$_removeProperty(target, prop);
            }
        }
        if (clearTransforms) {
            $77ec02c321bf14d7$var$_removeProperty(target, $77ec02c321bf14d7$var$_transformProp);
            if (cache) {
                cache.svg && target.removeAttribute("transform");
                $77ec02c321bf14d7$var$_parseTransform(target, 1); // force all the cached values back to "normal"/identity, otherwise if there's another tween that's already set to render transforms on this element, it could display the wrong values.
                cache.uncache = 1;
                $77ec02c321bf14d7$var$_removeIndependentTransforms(style);
            }
        }
    }
}, // note: specialProps should return 1 if (and only if) they have a non-zero priority. It indicates we need to sort the linked list.
$77ec02c321bf14d7$var$_specialProps = {
    clearProps: function clearProps(plugin, target, property, endValue, tween) {
        if (tween.data !== "isFromStart") {
            var pt = plugin._pt = new (0, $3e8f3adb9623a584$export$3a67f7f44b1e838a)(plugin._pt, target, property, 0, 0, $77ec02c321bf14d7$var$_renderClearProps);
            pt.u = endValue;
            pt.pr = -10;
            pt.tween = tween;
            plugin._props.push(property);
            return 1;
        }
    }
}, /*
 * --------------------------------------------------------------------------------------
 * TRANSFORMS
 * --------------------------------------------------------------------------------------
 */ $77ec02c321bf14d7$var$_identity2DMatrix = [
    1,
    0,
    0,
    1,
    0,
    0
], $77ec02c321bf14d7$var$_rotationalProperties = {}, $77ec02c321bf14d7$var$_isNullTransform = function _isNullTransform(value) {
    return value === "matrix(1, 0, 0, 1, 0, 0)" || value === "none" || !value;
}, $77ec02c321bf14d7$var$_getComputedTransformMatrixAsArray = function _getComputedTransformMatrixAsArray(target) {
    var matrixString = $77ec02c321bf14d7$var$_getComputedProperty(target, $77ec02c321bf14d7$var$_transformProp);
    return $77ec02c321bf14d7$var$_isNullTransform(matrixString) ? $77ec02c321bf14d7$var$_identity2DMatrix : matrixString.substr(7).match((0, $3e8f3adb9623a584$export$b9d44bb6523120d6)).map((0, $3e8f3adb9623a584$export$9c8d725d65e13f94));
}, $77ec02c321bf14d7$var$_getMatrix = function _getMatrix(target, force2D) {
    var cache = target._gsap || (0, $3e8f3adb9623a584$export$8b9be379d2de2a39)(target), style = target.style, matrix = $77ec02c321bf14d7$var$_getComputedTransformMatrixAsArray(target), parent, nextSibling, temp, addedToDOM;
    if (cache.svg && target.getAttribute("transform")) {
        temp = target.transform.baseVal.consolidate().matrix; //ensures that even complex values like "translate(50,60) rotate(135,0,0)" are parsed because it mashes it into a matrix.
        matrix = [
            temp.a,
            temp.b,
            temp.c,
            temp.d,
            temp.e,
            temp.f
        ];
        return matrix.join(",") === "1,0,0,1,0,0" ? $77ec02c321bf14d7$var$_identity2DMatrix : matrix;
    } else if (matrix === $77ec02c321bf14d7$var$_identity2DMatrix && !target.offsetParent && target !== $77ec02c321bf14d7$var$_docElement && !cache.svg) {
        //note: if offsetParent is null, that means the element isn't in the normal document flow, like if it has display:none or one of its ancestors has display:none). Firefox returns null for getComputedStyle() if the element is in an iframe that has display:none. https://bugzilla.mozilla.org/show_bug.cgi?id=548397
        //browsers don't report transforms accurately unless the element is in the DOM and has a display value that's not "none". Firefox and Microsoft browsers have a partial bug where they'll report transforms even if display:none BUT not any percentage-based values like translate(-50%, 8px) will be reported as if it's translate(0, 8px).
        temp = style.display;
        style.display = "block";
        parent = target.parentNode;
        if (!parent || !target.offsetParent) {
            // note: in 3.3.0 we switched target.offsetParent to _doc.body.contains(target) to avoid [sometimes unnecessary] MutationObserver calls but that wasn't adequate because there are edge cases where nested position: fixed elements need to get reparented to accurately sense transforms. See https://github.com/greensock/GSAP/issues/388 and https://github.com/greensock/GSAP/issues/375
            addedToDOM = 1; //flag
            nextSibling = target.nextElementSibling;
            $77ec02c321bf14d7$var$_docElement.appendChild(target); //we must add it to the DOM in order to get values properly
        }
        matrix = $77ec02c321bf14d7$var$_getComputedTransformMatrixAsArray(target);
        temp ? style.display = temp : $77ec02c321bf14d7$var$_removeProperty(target, "display");
        if (addedToDOM) nextSibling ? parent.insertBefore(target, nextSibling) : parent ? parent.appendChild(target) : $77ec02c321bf14d7$var$_docElement.removeChild(target);
    }
    return force2D && matrix.length > 6 ? [
        matrix[0],
        matrix[1],
        matrix[4],
        matrix[5],
        matrix[12],
        matrix[13]
    ] : matrix;
}, $77ec02c321bf14d7$var$_applySVGOrigin = function _applySVGOrigin(target, origin, originIsAbsolute, smooth, matrixArray, pluginToAddPropTweensTo) {
    var cache = target._gsap, matrix = matrixArray || $77ec02c321bf14d7$var$_getMatrix(target, true), xOriginOld = cache.xOrigin || 0, yOriginOld = cache.yOrigin || 0, xOffsetOld = cache.xOffset || 0, yOffsetOld = cache.yOffset || 0, a = matrix[0], b = matrix[1], c = matrix[2], d = matrix[3], tx = matrix[4], ty = matrix[5], originSplit = origin.split(" "), xOrigin = parseFloat(originSplit[0]) || 0, yOrigin = parseFloat(originSplit[1]) || 0, bounds, determinant, x, y;
    if (!originIsAbsolute) {
        bounds = $77ec02c321bf14d7$export$41bc7c2d1e04f11b(target);
        xOrigin = bounds.x + (~originSplit[0].indexOf("%") ? xOrigin / 100 * bounds.width : xOrigin);
        yOrigin = bounds.y + (~(originSplit[1] || originSplit[0]).indexOf("%") ? yOrigin / 100 * bounds.height : yOrigin);
    } else if (matrix !== $77ec02c321bf14d7$var$_identity2DMatrix && (determinant = a * d - b * c)) {
        //if it's zero (like if scaleX and scaleY are zero), skip it to avoid errors with dividing by zero.
        x = xOrigin * (d / determinant) + yOrigin * (-c / determinant) + (c * ty - d * tx) / determinant;
        y = xOrigin * (-b / determinant) + yOrigin * (a / determinant) - (a * ty - b * tx) / determinant;
        xOrigin = x;
        yOrigin = y;
    }
    if (smooth || smooth !== false && cache.smooth) {
        tx = xOrigin - xOriginOld;
        ty = yOrigin - yOriginOld;
        cache.xOffset = xOffsetOld + (tx * a + ty * c) - tx;
        cache.yOffset = yOffsetOld + (tx * b + ty * d) - ty;
    } else cache.xOffset = cache.yOffset = 0;
    cache.xOrigin = xOrigin;
    cache.yOrigin = yOrigin;
    cache.smooth = !!smooth;
    cache.origin = origin;
    cache.originIsAbsolute = !!originIsAbsolute;
    target.style[$77ec02c321bf14d7$var$_transformOriginProp] = "0px 0px"; //otherwise, if someone sets  an origin via CSS, it will likely interfere with the SVG transform attribute ones (because remember, we're baking the origin into the matrix() value).
    if (pluginToAddPropTweensTo) {
        $77ec02c321bf14d7$var$_addNonTweeningPT(pluginToAddPropTweensTo, cache, "xOrigin", xOriginOld, xOrigin);
        $77ec02c321bf14d7$var$_addNonTweeningPT(pluginToAddPropTweensTo, cache, "yOrigin", yOriginOld, yOrigin);
        $77ec02c321bf14d7$var$_addNonTweeningPT(pluginToAddPropTweensTo, cache, "xOffset", xOffsetOld, cache.xOffset);
        $77ec02c321bf14d7$var$_addNonTweeningPT(pluginToAddPropTweensTo, cache, "yOffset", yOffsetOld, cache.yOffset);
    }
    target.setAttribute("data-svg-origin", xOrigin + " " + yOrigin);
}, $77ec02c321bf14d7$var$_parseTransform = function _parseTransform(target, uncache) {
    var cache = target._gsap || new (0, $3e8f3adb9623a584$export$cf10981d5419cad5)(target);
    if ("x" in cache && !uncache && !cache.uncache) return cache;
    var style = target.style, invertedScaleX = cache.scaleX < 0, px = "px", deg = "deg", cs = getComputedStyle(target), origin = $77ec02c321bf14d7$var$_getComputedProperty(target, $77ec02c321bf14d7$var$_transformOriginProp) || "0", x, y, z, scaleX, scaleY, rotation, rotationX, rotationY, skewX, skewY, perspective, xOrigin, yOrigin, matrix, angle, cos, sin, a, b, c, d, a12, a22, t1, t2, t3, a13, a23, a33, a42, a43, a32;
    x = y = z = rotation = rotationX = rotationY = skewX = skewY = perspective = 0;
    scaleX = scaleY = 1;
    cache.svg = !!(target.getCTM && $77ec02c321bf14d7$var$_isSVG(target));
    if (cs.translate) {
        // accommodate independent transforms by combining them into normal ones.
        if (cs.translate !== "none" || cs.scale !== "none" || cs.rotate !== "none") style[$77ec02c321bf14d7$var$_transformProp] = (cs.translate !== "none" ? "translate3d(" + (cs.translate + " 0 0").split(" ").slice(0, 3).join(", ") + ") " : "") + (cs.rotate !== "none" ? "rotate(" + cs.rotate + ") " : "") + (cs.scale !== "none" ? "scale(" + cs.scale.split(" ").join(",") + ") " : "") + (cs[$77ec02c321bf14d7$var$_transformProp] !== "none" ? cs[$77ec02c321bf14d7$var$_transformProp] : "");
        style.scale = style.rotate = style.translate = "none";
    }
    matrix = $77ec02c321bf14d7$var$_getMatrix(target, cache.svg);
    if (cache.svg) {
        if (cache.uncache) {
            // if cache.uncache is true (and maybe if origin is 0,0), we need to set element.style.transformOrigin = (cache.xOrigin - bbox.x) + "px " + (cache.yOrigin - bbox.y) + "px". Previously we let the data-svg-origin stay instead, but when introducing revert(), it complicated things.
            t2 = target.getBBox();
            origin = cache.xOrigin - t2.x + "px " + (cache.yOrigin - t2.y) + "px";
            t1 = "";
        } else t1 = !uncache && target.getAttribute("data-svg-origin"); //  Remember, to work around browser inconsistencies we always force SVG elements' transformOrigin to 0,0 and offset the translation accordingly.
        $77ec02c321bf14d7$var$_applySVGOrigin(target, t1 || origin, !!t1 || cache.originIsAbsolute, cache.smooth !== false, matrix);
    }
    xOrigin = cache.xOrigin || 0;
    yOrigin = cache.yOrigin || 0;
    if (matrix !== $77ec02c321bf14d7$var$_identity2DMatrix) {
        a = matrix[0]; //a11
        b = matrix[1]; //a21
        c = matrix[2]; //a31
        d = matrix[3]; //a41
        x = a12 = matrix[4];
        y = a22 = matrix[5]; //2D matrix
        if (matrix.length === 6) {
            scaleX = Math.sqrt(a * a + b * b);
            scaleY = Math.sqrt(d * d + c * c);
            rotation = a || b ? $77ec02c321bf14d7$var$_atan2(b, a) * $77ec02c321bf14d7$var$_RAD2DEG : 0; //note: if scaleX is 0, we cannot accurately measure rotation. Same for skewX with a scaleY of 0. Therefore, we default to the previously recorded value (or zero if that doesn't exist).
            skewX = c || d ? $77ec02c321bf14d7$var$_atan2(c, d) * $77ec02c321bf14d7$var$_RAD2DEG + rotation : 0;
            skewX && (scaleY *= Math.abs(Math.cos(skewX * $77ec02c321bf14d7$var$_DEG2RAD)));
            if (cache.svg) {
                x -= xOrigin - (xOrigin * a + yOrigin * c);
                y -= yOrigin - (xOrigin * b + yOrigin * d);
            } //3D matrix
        } else {
            a32 = matrix[6];
            a42 = matrix[7];
            a13 = matrix[8];
            a23 = matrix[9];
            a33 = matrix[10];
            a43 = matrix[11];
            x = matrix[12];
            y = matrix[13];
            z = matrix[14];
            angle = $77ec02c321bf14d7$var$_atan2(a32, a33);
            rotationX = angle * $77ec02c321bf14d7$var$_RAD2DEG; //rotationX
            if (angle) {
                cos = Math.cos(-angle);
                sin = Math.sin(-angle);
                t1 = a12 * cos + a13 * sin;
                t2 = a22 * cos + a23 * sin;
                t3 = a32 * cos + a33 * sin;
                a13 = a12 * -sin + a13 * cos;
                a23 = a22 * -sin + a23 * cos;
                a33 = a32 * -sin + a33 * cos;
                a43 = a42 * -sin + a43 * cos;
                a12 = t1;
                a22 = t2;
                a32 = t3;
            } //rotationY
            angle = $77ec02c321bf14d7$var$_atan2(-c, a33);
            rotationY = angle * $77ec02c321bf14d7$var$_RAD2DEG;
            if (angle) {
                cos = Math.cos(-angle);
                sin = Math.sin(-angle);
                t1 = a * cos - a13 * sin;
                t2 = b * cos - a23 * sin;
                t3 = c * cos - a33 * sin;
                a43 = d * sin + a43 * cos;
                a = t1;
                b = t2;
                c = t3;
            } //rotationZ
            angle = $77ec02c321bf14d7$var$_atan2(b, a);
            rotation = angle * $77ec02c321bf14d7$var$_RAD2DEG;
            if (angle) {
                cos = Math.cos(angle);
                sin = Math.sin(angle);
                t1 = a * cos + b * sin;
                t2 = a12 * cos + a22 * sin;
                b = b * cos - a * sin;
                a22 = a22 * cos - a12 * sin;
                a = t1;
                a12 = t2;
            }
            if (rotationX && Math.abs(rotationX) + Math.abs(rotation) > 359.9) {
                //when rotationY is set, it will often be parsed as 180 degrees different than it should be, and rotationX and rotation both being 180 (it looks the same), so we adjust for that here.
                rotationX = rotation = 0;
                rotationY = 180 - rotationY;
            }
            scaleX = (0, $3e8f3adb9623a584$export$9c8d725d65e13f94)(Math.sqrt(a * a + b * b + c * c));
            scaleY = (0, $3e8f3adb9623a584$export$9c8d725d65e13f94)(Math.sqrt(a22 * a22 + a32 * a32));
            angle = $77ec02c321bf14d7$var$_atan2(a12, a22);
            skewX = Math.abs(angle) > 0.0002 ? angle * $77ec02c321bf14d7$var$_RAD2DEG : 0;
            perspective = a43 ? 1 / (a43 < 0 ? -a43 : a43) : 0;
        }
        if (cache.svg) {
            //sense if there are CSS transforms applied on an SVG element in which case we must overwrite them when rendering. The transform attribute is more reliable cross-browser, but we can't just remove the CSS ones because they may be applied in a CSS rule somewhere (not just inline).
            t1 = target.getAttribute("transform");
            cache.forceCSS = target.setAttribute("transform", "") || !$77ec02c321bf14d7$var$_isNullTransform($77ec02c321bf14d7$var$_getComputedProperty(target, $77ec02c321bf14d7$var$_transformProp));
            t1 && target.setAttribute("transform", t1);
        }
    }
    if (Math.abs(skewX) > 90 && Math.abs(skewX) < 270) {
        if (invertedScaleX) {
            scaleX *= -1;
            skewX += rotation <= 0 ? 180 : -180;
            rotation += rotation <= 0 ? 180 : -180;
        } else {
            scaleY *= -1;
            skewX += skewX <= 0 ? 180 : -180;
        }
    }
    uncache = uncache || cache.uncache;
    cache.x = x - ((cache.xPercent = x && (!uncache && cache.xPercent || (Math.round(target.offsetWidth / 2) === Math.round(-x) ? -50 : 0))) ? target.offsetWidth * cache.xPercent / 100 : 0) + px;
    cache.y = y - ((cache.yPercent = y && (!uncache && cache.yPercent || (Math.round(target.offsetHeight / 2) === Math.round(-y) ? -50 : 0))) ? target.offsetHeight * cache.yPercent / 100 : 0) + px;
    cache.z = z + px;
    cache.scaleX = (0, $3e8f3adb9623a584$export$9c8d725d65e13f94)(scaleX);
    cache.scaleY = (0, $3e8f3adb9623a584$export$9c8d725d65e13f94)(scaleY);
    cache.rotation = (0, $3e8f3adb9623a584$export$9c8d725d65e13f94)(rotation) + deg;
    cache.rotationX = (0, $3e8f3adb9623a584$export$9c8d725d65e13f94)(rotationX) + deg;
    cache.rotationY = (0, $3e8f3adb9623a584$export$9c8d725d65e13f94)(rotationY) + deg;
    cache.skewX = skewX + deg;
    cache.skewY = skewY + deg;
    cache.transformPerspective = perspective + px;
    if (cache.zOrigin = parseFloat(origin.split(" ")[2]) || 0) style[$77ec02c321bf14d7$var$_transformOriginProp] = $77ec02c321bf14d7$var$_firstTwoOnly(origin);
    cache.xOffset = cache.yOffset = 0;
    cache.force3D = (0, $3e8f3adb9623a584$export$4922bee768729a77).force3D;
    cache.renderTransform = cache.svg ? $77ec02c321bf14d7$var$_renderSVGTransforms : $77ec02c321bf14d7$var$_supports3D ? $77ec02c321bf14d7$var$_renderCSSTransforms : $77ec02c321bf14d7$var$_renderNon3DTransforms;
    cache.uncache = 0;
    return cache;
}, $77ec02c321bf14d7$var$_firstTwoOnly = function _firstTwoOnly(value) {
    return (value = value.split(" "))[0] + " " + value[1];
}, //for handling transformOrigin values, stripping out the 3rd dimension
$77ec02c321bf14d7$var$_addPxTranslate = function _addPxTranslate(target, start, value) {
    var unit = (0, $3e8f3adb9623a584$export$65f2564e9a9b9222)(start);
    return (0, $3e8f3adb9623a584$export$9c8d725d65e13f94)(parseFloat(start) + parseFloat($77ec02c321bf14d7$var$_convertToUnit(target, "x", value + "px", unit))) + unit;
}, $77ec02c321bf14d7$var$_renderNon3DTransforms = function _renderNon3DTransforms(ratio, cache) {
    cache.z = "0px";
    cache.rotationY = cache.rotationX = "0deg";
    cache.force3D = 0;
    $77ec02c321bf14d7$var$_renderCSSTransforms(ratio, cache);
}, $77ec02c321bf14d7$var$_zeroDeg = "0deg", $77ec02c321bf14d7$var$_zeroPx = "0px", $77ec02c321bf14d7$var$_endParenthesis = ") ", $77ec02c321bf14d7$var$_renderCSSTransforms = function _renderCSSTransforms(ratio, cache) {
    var _ref = cache || this, xPercent = _ref.xPercent, yPercent = _ref.yPercent, x = _ref.x, y = _ref.y, z = _ref.z, rotation = _ref.rotation, rotationY = _ref.rotationY, rotationX = _ref.rotationX, skewX = _ref.skewX, skewY = _ref.skewY, scaleX = _ref.scaleX, scaleY = _ref.scaleY, transformPerspective = _ref.transformPerspective, force3D = _ref.force3D, target = _ref.target, zOrigin = _ref.zOrigin, transforms = "", use3D = force3D === "auto" && ratio && ratio !== 1 || force3D === true; // Safari has a bug that causes it not to render 3D transform-origin values properly, so we force the z origin to 0, record it in the cache, and then do the math here to offset the translate values accordingly (basically do the 3D transform-origin part manually)
    if (zOrigin && (rotationX !== $77ec02c321bf14d7$var$_zeroDeg || rotationY !== $77ec02c321bf14d7$var$_zeroDeg)) {
        var angle = parseFloat(rotationY) * $77ec02c321bf14d7$var$_DEG2RAD, a13 = Math.sin(angle), a33 = Math.cos(angle), cos;
        angle = parseFloat(rotationX) * $77ec02c321bf14d7$var$_DEG2RAD;
        cos = Math.cos(angle);
        x = $77ec02c321bf14d7$var$_addPxTranslate(target, x, a13 * cos * -zOrigin);
        y = $77ec02c321bf14d7$var$_addPxTranslate(target, y, -Math.sin(angle) * -zOrigin);
        z = $77ec02c321bf14d7$var$_addPxTranslate(target, z, a33 * cos * -zOrigin + zOrigin);
    }
    if (transformPerspective !== $77ec02c321bf14d7$var$_zeroPx) transforms += "perspective(" + transformPerspective + $77ec02c321bf14d7$var$_endParenthesis;
    if (xPercent || yPercent) transforms += "translate(" + xPercent + "%, " + yPercent + "%) ";
    if (use3D || x !== $77ec02c321bf14d7$var$_zeroPx || y !== $77ec02c321bf14d7$var$_zeroPx || z !== $77ec02c321bf14d7$var$_zeroPx) transforms += z !== $77ec02c321bf14d7$var$_zeroPx || use3D ? "translate3d(" + x + ", " + y + ", " + z + ") " : "translate(" + x + ", " + y + $77ec02c321bf14d7$var$_endParenthesis;
    if (rotation !== $77ec02c321bf14d7$var$_zeroDeg) transforms += "rotate(" + rotation + $77ec02c321bf14d7$var$_endParenthesis;
    if (rotationY !== $77ec02c321bf14d7$var$_zeroDeg) transforms += "rotateY(" + rotationY + $77ec02c321bf14d7$var$_endParenthesis;
    if (rotationX !== $77ec02c321bf14d7$var$_zeroDeg) transforms += "rotateX(" + rotationX + $77ec02c321bf14d7$var$_endParenthesis;
    if (skewX !== $77ec02c321bf14d7$var$_zeroDeg || skewY !== $77ec02c321bf14d7$var$_zeroDeg) transforms += "skew(" + skewX + ", " + skewY + $77ec02c321bf14d7$var$_endParenthesis;
    if (scaleX !== 1 || scaleY !== 1) transforms += "scale(" + scaleX + ", " + scaleY + $77ec02c321bf14d7$var$_endParenthesis;
    target.style[$77ec02c321bf14d7$var$_transformProp] = transforms || "translate(0, 0)";
}, $77ec02c321bf14d7$var$_renderSVGTransforms = function _renderSVGTransforms(ratio, cache) {
    var _ref2 = cache || this, xPercent = _ref2.xPercent, yPercent = _ref2.yPercent, x = _ref2.x, y = _ref2.y, rotation = _ref2.rotation, skewX = _ref2.skewX, skewY = _ref2.skewY, scaleX = _ref2.scaleX, scaleY = _ref2.scaleY, target = _ref2.target, xOrigin = _ref2.xOrigin, yOrigin = _ref2.yOrigin, xOffset = _ref2.xOffset, yOffset = _ref2.yOffset, forceCSS = _ref2.forceCSS, tx = parseFloat(x), ty = parseFloat(y), a11, a21, a12, a22, temp;
    rotation = parseFloat(rotation);
    skewX = parseFloat(skewX);
    skewY = parseFloat(skewY);
    if (skewY) {
        //for performance reasons, we combine all skewing into the skewX and rotation values. Remember, a skewY of 10 degrees looks the same as a rotation of 10 degrees plus a skewX of 10 degrees.
        skewY = parseFloat(skewY);
        skewX += skewY;
        rotation += skewY;
    }
    if (rotation || skewX) {
        rotation *= $77ec02c321bf14d7$var$_DEG2RAD;
        skewX *= $77ec02c321bf14d7$var$_DEG2RAD;
        a11 = Math.cos(rotation) * scaleX;
        a21 = Math.sin(rotation) * scaleX;
        a12 = Math.sin(rotation - skewX) * -scaleY;
        a22 = Math.cos(rotation - skewX) * scaleY;
        if (skewX) {
            skewY *= $77ec02c321bf14d7$var$_DEG2RAD;
            temp = Math.tan(skewX - skewY);
            temp = Math.sqrt(1 + temp * temp);
            a12 *= temp;
            a22 *= temp;
            if (skewY) {
                temp = Math.tan(skewY);
                temp = Math.sqrt(1 + temp * temp);
                a11 *= temp;
                a21 *= temp;
            }
        }
        a11 = (0, $3e8f3adb9623a584$export$9c8d725d65e13f94)(a11);
        a21 = (0, $3e8f3adb9623a584$export$9c8d725d65e13f94)(a21);
        a12 = (0, $3e8f3adb9623a584$export$9c8d725d65e13f94)(a12);
        a22 = (0, $3e8f3adb9623a584$export$9c8d725d65e13f94)(a22);
    } else {
        a11 = scaleX;
        a22 = scaleY;
        a21 = a12 = 0;
    }
    if (tx && !~(x + "").indexOf("px") || ty && !~(y + "").indexOf("px")) {
        tx = $77ec02c321bf14d7$var$_convertToUnit(target, "x", x, "px");
        ty = $77ec02c321bf14d7$var$_convertToUnit(target, "y", y, "px");
    }
    if (xOrigin || yOrigin || xOffset || yOffset) {
        tx = (0, $3e8f3adb9623a584$export$9c8d725d65e13f94)(tx + xOrigin - (xOrigin * a11 + yOrigin * a12) + xOffset);
        ty = (0, $3e8f3adb9623a584$export$9c8d725d65e13f94)(ty + yOrigin - (xOrigin * a21 + yOrigin * a22) + yOffset);
    }
    if (xPercent || yPercent) {
        //The SVG spec doesn't support percentage-based translation in the "transform" attribute, so we merge it into the translation to simulate it.
        temp = target.getBBox();
        tx = (0, $3e8f3adb9623a584$export$9c8d725d65e13f94)(tx + xPercent / 100 * temp.width);
        ty = (0, $3e8f3adb9623a584$export$9c8d725d65e13f94)(ty + yPercent / 100 * temp.height);
    }
    temp = "matrix(" + a11 + "," + a21 + "," + a12 + "," + a22 + "," + tx + "," + ty + ")";
    target.setAttribute("transform", temp);
    forceCSS && (target.style[$77ec02c321bf14d7$var$_transformProp] = temp); //some browsers prioritize CSS transforms over the transform attribute. When we sense that the user has CSS transforms applied, we must overwrite them this way (otherwise some browser simply won't render the transform attribute changes!)
}, $77ec02c321bf14d7$var$_addRotationalPropTween = function _addRotationalPropTween(plugin, target, property, startNum, endValue) {
    var cap = 360, isString = (0, $3e8f3adb9623a584$export$f664476fd67145ca)(endValue), endNum = parseFloat(endValue) * (isString && ~endValue.indexOf("rad") ? $77ec02c321bf14d7$var$_RAD2DEG : 1), change = endNum - startNum, finalValue = startNum + change + "deg", direction, pt;
    if (isString) {
        direction = endValue.split("_")[1];
        if (direction === "short") {
            change %= cap;
            if (change !== change % (cap / 2)) change += change < 0 ? cap : -cap;
        }
        if (direction === "cw" && change < 0) change = (change + cap * $77ec02c321bf14d7$var$_bigNum) % cap - ~~(change / cap) * cap;
        else if (direction === "ccw" && change > 0) change = (change - cap * $77ec02c321bf14d7$var$_bigNum) % cap - ~~(change / cap) * cap;
    }
    plugin._pt = pt = new (0, $3e8f3adb9623a584$export$3a67f7f44b1e838a)(plugin._pt, target, property, startNum, change, $77ec02c321bf14d7$var$_renderPropWithEnd);
    pt.e = finalValue;
    pt.u = "deg";
    plugin._props.push(property);
    return pt;
}, $77ec02c321bf14d7$var$_assign = function _assign(target, source) {
    // Internet Explorer doesn't have Object.assign(), so we recreate it here.
    for(var p in source)target[p] = source[p];
    return target;
}, $77ec02c321bf14d7$var$_addRawTransformPTs = function _addRawTransformPTs(plugin, transforms, target) {
    //for handling cases where someone passes in a whole transform string, like transform: "scale(2, 3) rotate(20deg) translateY(30em)"
    var startCache = $77ec02c321bf14d7$var$_assign({}, target._gsap), exclude = "perspective,force3D,transformOrigin,svgOrigin", style = target.style, endCache, p, startValue, endValue, startNum, endNum, startUnit, endUnit;
    if (startCache.svg) {
        startValue = target.getAttribute("transform");
        target.setAttribute("transform", "");
        style[$77ec02c321bf14d7$var$_transformProp] = transforms;
        endCache = $77ec02c321bf14d7$var$_parseTransform(target, 1);
        $77ec02c321bf14d7$var$_removeProperty(target, $77ec02c321bf14d7$var$_transformProp);
        target.setAttribute("transform", startValue);
    } else {
        startValue = getComputedStyle(target)[$77ec02c321bf14d7$var$_transformProp];
        style[$77ec02c321bf14d7$var$_transformProp] = transforms;
        endCache = $77ec02c321bf14d7$var$_parseTransform(target, 1);
        style[$77ec02c321bf14d7$var$_transformProp] = startValue;
    }
    for(p in $77ec02c321bf14d7$var$_transformProps){
        startValue = startCache[p];
        endValue = endCache[p];
        if (startValue !== endValue && exclude.indexOf(p) < 0) {
            //tweening to no perspective gives very unintuitive results - just keep the same perspective in that case.
            startUnit = (0, $3e8f3adb9623a584$export$65f2564e9a9b9222)(startValue);
            endUnit = (0, $3e8f3adb9623a584$export$65f2564e9a9b9222)(endValue);
            startNum = startUnit !== endUnit ? $77ec02c321bf14d7$var$_convertToUnit(target, p, startValue, endUnit) : parseFloat(startValue);
            endNum = parseFloat(endValue);
            plugin._pt = new (0, $3e8f3adb9623a584$export$3a67f7f44b1e838a)(plugin._pt, endCache, p, startNum, endNum - startNum, $77ec02c321bf14d7$var$_renderCSSProp);
            plugin._pt.u = endUnit || 0;
            plugin._props.push(p);
        }
    }
    $77ec02c321bf14d7$var$_assign(endCache, startCache);
}; // handle splitting apart padding, margin, borderWidth, and borderRadius into their 4 components. Firefox, for example, won't report borderRadius correctly - it will only do borderTopLeftRadius and the other corners. We also want to handle paddingTop, marginLeft, borderRightWidth, etc.
(0, $3e8f3adb9623a584$export$f9000b814859f126)("padding,margin,Width,Radius", function(name, index) {
    var t = "Top", r = "Right", b = "Bottom", l = "Left", props = (index < 3 ? [
        t,
        r,
        b,
        l
    ] : [
        t + l,
        t + r,
        b + r,
        b + l
    ]).map(function(side) {
        return index < 2 ? name + side : "border" + side + name;
    });
    $77ec02c321bf14d7$var$_specialProps[index > 1 ? "border" + name : name] = function(plugin, target, property, endValue, tween) {
        var a, vars;
        if (arguments.length < 4) {
            // getter, passed target, property, and unit (from _get())
            a = props.map(function(prop) {
                return $77ec02c321bf14d7$var$_get(plugin, prop, property);
            });
            vars = a.join(" ");
            return vars.split(a[0]).length === 5 ? a[0] : vars;
        }
        a = (endValue + "").split(" ");
        vars = {};
        props.forEach(function(prop, i) {
            return vars[prop] = a[i] = a[i] || a[(i - 1) / 2 | 0];
        });
        plugin.init(target, vars, tween);
    };
});
var $77ec02c321bf14d7$export$855822f522f18eef = {
    name: "css",
    register: $77ec02c321bf14d7$var$_initCore,
    targetTest: function targetTest(target) {
        return target.style && target.nodeType;
    },
    init: function init(target, vars, tween, index, targets) {
        var props = this._props, style = target.style, startAt = tween.vars.startAt, startValue, endValue, endNum, startNum, type, specialProp, p, startUnit, endUnit, relative, isTransformRelated, transformPropTween, cache, smooth, hasPriority, inlineProps;
        $77ec02c321bf14d7$var$_pluginInitted || $77ec02c321bf14d7$var$_initCore(); // we may call init() multiple times on the same plugin instance, like when adding special properties, so make sure we don't overwrite the revert data or inlineProps
        this.styles = this.styles || $77ec02c321bf14d7$var$_getStyleSaver(target);
        inlineProps = this.styles.props;
        this.tween = tween;
        for(p in vars){
            if (p === "autoRound") continue;
            endValue = vars[p];
            if ((0, $3e8f3adb9623a584$export$d305d8ec5d7c26b8)[p] && (0, $3e8f3adb9623a584$export$5c457b74208010cf)(p, vars, tween, index, target, targets)) continue;
            type = typeof endValue;
            specialProp = $77ec02c321bf14d7$var$_specialProps[p];
            if (type === "function") {
                endValue = endValue.call(tween, index, target, targets);
                type = typeof endValue;
            }
            if (type === "string" && ~endValue.indexOf("random(")) endValue = (0, $3e8f3adb9623a584$export$d5962a97e3cde94d)(endValue);
            if (specialProp) specialProp(this, target, p, endValue, tween) && (hasPriority = 1);
            else if (p.substr(0, 2) === "--") {
                //CSS variable
                startValue = (getComputedStyle(target).getPropertyValue(p) + "").trim();
                endValue += "";
                (0, $3e8f3adb9623a584$export$dd733e62515be2bd).lastIndex = 0;
                if (!(0, $3e8f3adb9623a584$export$dd733e62515be2bd).test(startValue)) {
                    // colors don't have units
                    startUnit = (0, $3e8f3adb9623a584$export$65f2564e9a9b9222)(startValue);
                    endUnit = (0, $3e8f3adb9623a584$export$65f2564e9a9b9222)(endValue);
                }
                endUnit ? startUnit !== endUnit && (startValue = $77ec02c321bf14d7$var$_convertToUnit(target, p, startValue, endUnit) + endUnit) : startUnit && (endValue += startUnit);
                this.add(style, "setProperty", startValue, endValue, index, targets, 0, 0, p);
                props.push(p);
                inlineProps.push(p, 0, style[p]);
            } else if (type !== "undefined") {
                if (startAt && p in startAt) {
                    // in case someone hard-codes a complex value as the start, like top: "calc(2vh / 2)". Without this, it'd use the computed value (always in px)
                    startValue = typeof startAt[p] === "function" ? startAt[p].call(tween, index, target, targets) : startAt[p];
                    (0, $3e8f3adb9623a584$export$f664476fd67145ca)(startValue) && ~startValue.indexOf("random(") && (startValue = (0, $3e8f3adb9623a584$export$d5962a97e3cde94d)(startValue));
                    (0, $3e8f3adb9623a584$export$65f2564e9a9b9222)(startValue + "") || (startValue += (0, $3e8f3adb9623a584$export$4922bee768729a77).units[p] || (0, $3e8f3adb9623a584$export$65f2564e9a9b9222)($77ec02c321bf14d7$var$_get(target, p)) || ""); // for cases when someone passes in a unitless value like {x: 100}; if we try setting translate(100, 0px) it won't work.
                    (startValue + "").charAt(1) === "=" && (startValue = $77ec02c321bf14d7$var$_get(target, p)); // can't work with relative values
                } else startValue = $77ec02c321bf14d7$var$_get(target, p);
                startNum = parseFloat(startValue);
                relative = type === "string" && endValue.charAt(1) === "=" && endValue.substr(0, 2);
                relative && (endValue = endValue.substr(2));
                endNum = parseFloat(endValue);
                if (p in $77ec02c321bf14d7$var$_propertyAliases) {
                    if (p === "autoAlpha") {
                        //special case where we control the visibility along with opacity. We still allow the opacity value to pass through and get tweened.
                        if (startNum === 1 && $77ec02c321bf14d7$var$_get(target, "visibility") === "hidden" && endNum) //if visibility is initially set to "hidden", we should interpret that as intent to make opacity 0 (a convenience)
                        startNum = 0;
                        inlineProps.push("visibility", 0, style.visibility);
                        $77ec02c321bf14d7$var$_addNonTweeningPT(this, style, "visibility", startNum ? "inherit" : "hidden", endNum ? "inherit" : "hidden", !endNum);
                    }
                    if (p !== "scale" && p !== "transform") {
                        p = $77ec02c321bf14d7$var$_propertyAliases[p];
                        ~p.indexOf(",") && (p = p.split(",")[0]);
                    }
                }
                isTransformRelated = p in $77ec02c321bf14d7$var$_transformProps; //--- TRANSFORM-RELATED ---
                if (isTransformRelated) {
                    this.styles.save(p);
                    if (!transformPropTween) {
                        cache = target._gsap;
                        cache.renderTransform && !vars.parseTransform || $77ec02c321bf14d7$var$_parseTransform(target, vars.parseTransform); // if, for example, gsap.set(... {transform:"translateX(50vw)"}), the _get() call doesn't parse the transform, thus cache.renderTransform won't be set yet so force the parsing of the transform here.
                        smooth = vars.smoothOrigin !== false && cache.smooth;
                        transformPropTween = this._pt = new (0, $3e8f3adb9623a584$export$3a67f7f44b1e838a)(this._pt, style, $77ec02c321bf14d7$var$_transformProp, 0, 1, cache.renderTransform, cache, 0, -1); //the first time through, create the rendering PropTween so that it runs LAST (in the linked list, we keep adding to the beginning)
                        transformPropTween.dep = 1; //flag it as dependent so that if things get killed/overwritten and this is the only PropTween left, we can safely kill the whole tween.
                    }
                    if (p === "scale") {
                        this._pt = new (0, $3e8f3adb9623a584$export$3a67f7f44b1e838a)(this._pt, cache, "scaleY", cache.scaleY, (relative ? (0, $3e8f3adb9623a584$export$dac762bc6301b560)(cache.scaleY, relative + endNum) : endNum) - cache.scaleY || 0, $77ec02c321bf14d7$var$_renderCSSProp);
                        this._pt.u = 0;
                        props.push("scaleY", p);
                        p += "X";
                    } else if (p === "transformOrigin") {
                        inlineProps.push($77ec02c321bf14d7$var$_transformOriginProp, 0, style[$77ec02c321bf14d7$var$_transformOriginProp]);
                        endValue = $77ec02c321bf14d7$var$_convertKeywordsToPercentages(endValue); //in case something like "left top" or "bottom right" is passed in. Convert to percentages.
                        if (cache.svg) $77ec02c321bf14d7$var$_applySVGOrigin(target, endValue, 0, smooth, 0, this);
                        else {
                            endUnit = parseFloat(endValue.split(" ")[2]) || 0; //handle the zOrigin separately!
                            endUnit !== cache.zOrigin && $77ec02c321bf14d7$var$_addNonTweeningPT(this, cache, "zOrigin", cache.zOrigin, endUnit);
                            $77ec02c321bf14d7$var$_addNonTweeningPT(this, style, p, $77ec02c321bf14d7$var$_firstTwoOnly(startValue), $77ec02c321bf14d7$var$_firstTwoOnly(endValue));
                        }
                        continue;
                    } else if (p === "svgOrigin") {
                        $77ec02c321bf14d7$var$_applySVGOrigin(target, endValue, 1, smooth, 0, this);
                        continue;
                    } else if (p in $77ec02c321bf14d7$var$_rotationalProperties) {
                        $77ec02c321bf14d7$var$_addRotationalPropTween(this, cache, p, startNum, relative ? (0, $3e8f3adb9623a584$export$dac762bc6301b560)(startNum, relative + endValue) : endValue);
                        continue;
                    } else if (p === "smoothOrigin") {
                        $77ec02c321bf14d7$var$_addNonTweeningPT(this, cache, "smooth", cache.smooth, endValue);
                        continue;
                    } else if (p === "force3D") {
                        cache[p] = endValue;
                        continue;
                    } else if (p === "transform") {
                        $77ec02c321bf14d7$var$_addRawTransformPTs(this, endValue, target);
                        continue;
                    }
                } else if (!(p in style)) p = $77ec02c321bf14d7$export$8cbef5dd49a09c8b(p) || p;
                if (isTransformRelated || (endNum || endNum === 0) && (startNum || startNum === 0) && !$77ec02c321bf14d7$var$_complexExp.test(endValue) && p in style) {
                    startUnit = (startValue + "").substr((startNum + "").length);
                    endNum || (endNum = 0); // protect against NaN
                    endUnit = (0, $3e8f3adb9623a584$export$65f2564e9a9b9222)(endValue) || (p in (0, $3e8f3adb9623a584$export$4922bee768729a77).units ? (0, $3e8f3adb9623a584$export$4922bee768729a77).units[p] : startUnit);
                    startUnit !== endUnit && (startNum = $77ec02c321bf14d7$var$_convertToUnit(target, p, startValue, endUnit));
                    this._pt = new (0, $3e8f3adb9623a584$export$3a67f7f44b1e838a)(this._pt, isTransformRelated ? cache : style, p, startNum, (relative ? (0, $3e8f3adb9623a584$export$dac762bc6301b560)(startNum, relative + endNum) : endNum) - startNum, !isTransformRelated && (endUnit === "px" || p === "zIndex") && vars.autoRound !== false ? $77ec02c321bf14d7$var$_renderRoundedCSSProp : $77ec02c321bf14d7$var$_renderCSSProp);
                    this._pt.u = endUnit || 0;
                    if (startUnit !== endUnit && endUnit !== "%") {
                        //when the tween goes all the way back to the beginning, we need to revert it to the OLD/ORIGINAL value (with those units). We record that as a "b" (beginning) property and point to a render method that handles that. (performance optimization)
                        this._pt.b = startValue;
                        this._pt.r = $77ec02c321bf14d7$var$_renderCSSPropWithBeginning;
                    }
                } else if (!(p in style)) {
                    if (p in target) //maybe it's not a style - it could be a property added directly to an element in which case we'll try to animate that.
                    this.add(target, p, startValue || target[p], relative ? relative + endValue : endValue, index, targets);
                    else if (p !== "parseTransform") {
                        (0, $3e8f3adb9623a584$export$7fb54635790b59a5)(p, endValue);
                        continue;
                    }
                } else $77ec02c321bf14d7$var$_tweenComplexCSSString.call(this, target, p, startValue, relative ? relative + endValue : endValue);
                isTransformRelated || (p in style ? inlineProps.push(p, 0, style[p]) : inlineProps.push(p, 1, startValue || target[p]));
                props.push(p);
            }
        }
        hasPriority && (0, $3e8f3adb9623a584$export$eed5824f53346d57)(this);
    },
    render: function render(ratio, data) {
        if (data.tween._time || !$77ec02c321bf14d7$var$_reverting()) {
            var pt = data._pt;
            while(pt){
                pt.r(ratio, pt.d);
                pt = pt._next;
            }
        } else data.styles.revert();
    },
    get: $77ec02c321bf14d7$var$_get,
    aliases: $77ec02c321bf14d7$var$_propertyAliases,
    getSetter: function getSetter(target, property, plugin) {
        //returns a setter function that accepts target, property, value and applies it accordingly. Remember, properties like "x" aren't as simple as target.style.property = value because they've got to be applied to a proxy object and then merged into a transform string in a renderer.
        var p = $77ec02c321bf14d7$var$_propertyAliases[property];
        p && p.indexOf(",") < 0 && (property = p);
        return property in $77ec02c321bf14d7$var$_transformProps && property !== $77ec02c321bf14d7$var$_transformOriginProp && (target._gsap.x || $77ec02c321bf14d7$var$_get(target, "x")) ? plugin && $77ec02c321bf14d7$var$_recentSetterPlugin === plugin ? property === "scale" ? $77ec02c321bf14d7$var$_setterScale : $77ec02c321bf14d7$var$_setterTransform : ($77ec02c321bf14d7$var$_recentSetterPlugin = plugin || {}, property === "scale" ? $77ec02c321bf14d7$var$_setterScaleWithRender : $77ec02c321bf14d7$var$_setterTransformWithRender) : target.style && !(0, $3e8f3adb9623a584$export$a8178c063a9fd3a1)(target.style[property]) ? $77ec02c321bf14d7$var$_setterCSSStyle : ~property.indexOf("-") ? $77ec02c321bf14d7$var$_setterCSSProp : (0, $3e8f3adb9623a584$export$d60fbc1e0278aaf0)(target, property);
    },
    core: {
        _removeProperty: $77ec02c321bf14d7$var$_removeProperty,
        _getMatrix: $77ec02c321bf14d7$var$_getMatrix
    }
};
(0, $3e8f3adb9623a584$export$99ee26438460406a).utils.checkPrefix = $77ec02c321bf14d7$export$8cbef5dd49a09c8b;
(0, $3e8f3adb9623a584$export$99ee26438460406a).core.getStyleSaver = $77ec02c321bf14d7$var$_getStyleSaver;
(function(positionAndScale, rotation, others, aliases) {
    var all = (0, $3e8f3adb9623a584$export$f9000b814859f126)(positionAndScale + "," + rotation + "," + others, function(name) {
        $77ec02c321bf14d7$var$_transformProps[name] = 1;
    });
    (0, $3e8f3adb9623a584$export$f9000b814859f126)(rotation, function(name) {
        (0, $3e8f3adb9623a584$export$4922bee768729a77).units[name] = "deg";
        $77ec02c321bf14d7$var$_rotationalProperties[name] = 1;
    });
    $77ec02c321bf14d7$var$_propertyAliases[all[13]] = positionAndScale + "," + rotation;
    (0, $3e8f3adb9623a584$export$f9000b814859f126)(aliases, function(name) {
        var split = name.split(":");
        $77ec02c321bf14d7$var$_propertyAliases[split[1]] = all[split[0]];
    });
})("x,y,z,scale,scaleX,scaleY,xPercent,yPercent", "rotation,rotationX,rotationY,skewX,skewY", "transform,transformOrigin,svgOrigin,force3D,smoothOrigin,transformPerspective", "0:translateX,1:translateY,2:translateZ,8:rotate,8:rotationZ,8:rotateZ,9:rotateX,10:rotateY");
(0, $3e8f3adb9623a584$export$f9000b814859f126)("x,y,z,top,right,bottom,left,width,height,fontSize,padding,margin,perspective", function(name) {
    (0, $3e8f3adb9623a584$export$4922bee768729a77).units[name] = "px";
});
(0, $3e8f3adb9623a584$export$99ee26438460406a).registerPlugin($77ec02c321bf14d7$export$855822f522f18eef);


var $856d27e31089eddd$export$99ee26438460406a = (0, $3e8f3adb9623a584$export$99ee26438460406a).registerPlugin((0, $77ec02c321bf14d7$export$855822f522f18eef)) || (0, $3e8f3adb9623a584$export$99ee26438460406a), // to protect from tree shaking
$856d27e31089eddd$export$7b23975ad686bf91 = $856d27e31089eddd$export$99ee26438460406a.core.Tween;


document.addEventListener("DOMContentLoaded", function() {
    const elements = document.querySelectorAll("[data-marquee]");
    elements.forEach((el)=>{
        const items = el.children;
        const speed = el.dataset.marqueeSpeed || 1;
        const repeat = el.dataset.marqueeRepeat || -1;
        const reversed = [
            "true",
            "1",
            "yes",
            "on"
        ].includes(el.dataset.marqueeReversed) || false;
        $03145b8667ef6a64$var$horizontalLoop(items, {
            repeat: repeat,
            speed: speed,
            reversed: reversed
        });
    });
});
/*
This helper function makes a group of elements animate along the x-axis in a seamless, responsive loop.

Source: https://greensock.com/docs/v3/HelperFunctions#loop

Features:
- Uses xPercent so that even if the widths change (like if the window gets resized), it should still work in most cases.
- When each item animates to the left or right enough, it will loop back to the other side
- Optionally pass in a config object with values like "speed" (default: 1, which travels at roughly 100 pixels per
  second), paused (boolean),  repeat, reversed, and paddingRight.
- The returned timeline will have the following methods added to it:
    - next() - animates to the next element using a timeline.tweenTo() which it returns. You can pass in a vars object to
      control duration, easing, etc.
    - previous() - animates to the previous element using a timeline.tweenTo() which it returns. You can pass in a vars
      object to control duration, easing, etc.
    - toIndex() - pass in a zero-based index value of the element that it should animate to, and optionally pass in a vars
      object to control duration, easing, etc. Always goes in the shortest direction
    - current() - returns the current index (if an animation is in-progress, it reflects the final index)
    - times - an Array of the times on the timeline where each element hits the "starting" spot. There's also a label added
      accordingly, so "label1" is when the 2nd element reaches the start.
*/ function $03145b8667ef6a64$var$horizontalLoop(items, config) {
    items = (0, $856d27e31089eddd$export$99ee26438460406a).utils.toArray(items);
    config = config || {};
    let tl = (0, $856d27e31089eddd$export$99ee26438460406a).timeline({
        repeat: config.repeat,
        paused: config.paused,
        defaults: {
            ease: "none"
        },
        onReverseComplete: ()=>tl.totalTime(tl.rawTime() + tl.duration() * 100)
    }), length = items.length, startX = items[0].offsetLeft, times = [], widths = [], xPercents = [], curIndex = 0, pixelsPerSecond = (config.speed || 1) * 100, snap = config.snap === false ? (v)=>v : (0, $856d27e31089eddd$export$99ee26438460406a).utils.snap(config.snap || 1), totalWidth, curX, distanceToStart, distanceToLoop, item, i;
    (0, $856d27e31089eddd$export$99ee26438460406a).set(items, {
        xPercent: (i, el)=>{
            let w = widths[i] = parseFloat((0, $856d27e31089eddd$export$99ee26438460406a).getProperty(el, "width", "px"));
            xPercents[i] = snap(parseFloat((0, $856d27e31089eddd$export$99ee26438460406a).getProperty(el, "x", "px")) / w * 100 + (0, $856d27e31089eddd$export$99ee26438460406a).getProperty(el, "xPercent"));
            return xPercents[i];
        }
    });
    (0, $856d27e31089eddd$export$99ee26438460406a).set(items, {
        x: 0
    });
    totalWidth = items[length - 1].offsetLeft + xPercents[length - 1] / 100 * widths[length - 1] - startX + items[length - 1].offsetWidth * (0, $856d27e31089eddd$export$99ee26438460406a).getProperty(items[length - 1], "scaleX") + (parseFloat(config.paddingRight) || 0);
    for(i = 0; i < length; i++){
        item = items[i];
        curX = xPercents[i] / 100 * widths[i];
        distanceToStart = item.offsetLeft + curX - startX;
        distanceToLoop = distanceToStart + widths[i] * (0, $856d27e31089eddd$export$99ee26438460406a).getProperty(item, "scaleX");
        tl.to(item, {
            xPercent: snap((curX - distanceToLoop) / widths[i] * 100),
            duration: distanceToLoop / pixelsPerSecond
        }, 0).fromTo(item, {
            xPercent: snap((curX - distanceToLoop + totalWidth) / widths[i] * 100)
        }, {
            xPercent: xPercents[i],
            duration: (curX - distanceToLoop + totalWidth - curX) / pixelsPerSecond,
            immediateRender: false
        }, distanceToLoop / pixelsPerSecond).add("label" + i, distanceToStart / pixelsPerSecond);
        times[i] = distanceToStart / pixelsPerSecond;
    }
    function toIndex(index, vars) {
        vars = vars || {};
        Math.abs(index - curIndex) > length / 2 && (index += index > curIndex ? -length : length); // always go in the shortest direction
        let newIndex = (0, $856d27e31089eddd$export$99ee26438460406a).utils.wrap(0, length, index), time = times[newIndex];
        if (time > tl.time() !== index > curIndex) {
            vars.modifiers = {
                time: (0, $856d27e31089eddd$export$99ee26438460406a).utils.wrap(0, tl.duration())
            };
            time += tl.duration() * (index > curIndex ? 1 : -1);
        }
        curIndex = newIndex;
        vars.overwrite = true;
        return tl.tweenTo(time, vars);
    }
    tl.next = (vars)=>toIndex(curIndex + 1, vars);
    tl.previous = (vars)=>toIndex(curIndex - 1, vars);
    tl.current = ()=>curIndex;
    tl.toIndex = (index, vars)=>toIndex(index, vars);
    tl.times = times;
    tl.progress(1, true).progress(0, true); // pre-render for performance
    if (config.reversed) {
        tl.vars.onReverseComplete();
        tl.reverse();
    }
    return tl;
}


// Toggles a fullscreen menu to be "open", with support for transitions.
//
// It does this by adding the "open" class to the element, and removing it when closed. It will also add the
// "transitioning" class when the menu is toggled, and remove it after the animation is completed.
//
// Additionally, the body will have its overflow set to "hidden" when the menu is open, and "visible" when closed to
// prevent phantom scrolling behind the menu and cause the scrollbar to appear/disappear.
//
// Usage:
//
//     <button data-toggler-target="#id-of-element-to-toggle" />
//
// data-toggler-target: The selector of the element to toggle, which must work with `document.querySelector()`. e.g.
//
//     #id-of-element-to-toggle
//     .class-of-element-to-toggle
//     [data-attribute-of-element-to-toggle]
//
document.addEventListener("DOMContentLoaded", function() {
    const elements = document.querySelectorAll("[data-menu-toggler-target]");
    [
        ...elements
    ].forEach(function(element) {
        const target = document.querySelector(element.dataset.menuTogglerTarget);
        if (!target) {
            console.error(`No element found with selector ${element.dataset.menuTogglerTarget}`);
            return;
        }
        // console.debug("Menu toggler on", element, "toggling", target);
        element.addEventListener("click", function() {
            // Add the 'transitioning' class to animate it.
            target.classList.add("transitioning");
            // Toggle us either open or not
            target.classList.toggle("open");
            // If we're open, set the body to not scroll
            if (target.classList.contains("open")) document.body.style.overflow = "hidden";
            else document.body.style.overflow = "visible";
            // Remove the 'transitioning' class once the animation completes
            const duration = window.getComputedStyle(target).transitionDuration;
            const factor = duration.indexOf("ms") !== -1 ? 1 : 1000;
            const duration_ms = parseInt(parseFloat(duration) * factor, 10);
            setTimeout(function() {
                target.classList.remove("transitioning");
            }, duration_ms);
        });
    });
});


"use strict";
document.addEventListener("DOMContentLoaded", function() {
    const pronouns = document.querySelector("#id_pronouns, #id_user-pronouns, #id_profile-pronouns");
    const pronounsOtherWrapper = document.getElementById("pronouns-other");
    const pronounsOtherInput = document.querySelector("#id_pronouns_other, #id_user-pronouns_other, #id_profile-pronouns_other");
    const pronounsOtherLabel = document.querySelector("label[for=id_pronouns_other], label[for=id_user-pronouns_other], label[for=id_profile-pronouns_other]");
    if (pronouns && pronounsOtherWrapper && pronounsOtherInput && pronounsOtherLabel) {
        function togglePronounsOtherVisibility() {
            if (pronouns.value === "other") {
                pronounsOtherWrapper.style.display = "block";
                pronounsOtherInput.required = true;
                pronounsOtherLabel.innerHTML = "My preferred pronouns";
            } else {
                pronounsOtherWrapper.style.display = "none";
                pronounsOtherInput.required = false;
            }
        }
        pronouns.addEventListener("change", togglePronounsOtherVisibility);
        togglePronounsOtherVisibility();
    }
});


"use strict";
const $cad157996e70f357$var$questionnaire = document.getElementById("id_questionnaire");
const $cad157996e70f357$var$questionnaireReferralWrapper = document.getElementById("questionnaire-referral");
const $cad157996e70f357$var$questionnaireReferralInput = document.getElementById("id_referred_by_code");
const $cad157996e70f357$var$questionnaireOtherWrapper = document.getElementById("questionnaire-other");
const $cad157996e70f357$var$questionnaireOtherInput = document.getElementById("id_questionnaire_other");
if ($cad157996e70f357$var$questionnaire && $cad157996e70f357$var$questionnaireReferralWrapper && $cad157996e70f357$var$questionnaireReferralInput && $cad157996e70f357$var$questionnaireOtherWrapper && $cad157996e70f357$var$questionnaireOtherInput) {
    function toggleQuestionnaireReferralVisibility() {
        if ($cad157996e70f357$var$questionnaire.value === "referral") $cad157996e70f357$var$questionnaireReferralWrapper.style.display = "block";
        else {
            $cad157996e70f357$var$questionnaireReferralWrapper.style.display = "none";
            $cad157996e70f357$var$questionnaireReferralInput.value = "";
        }
    }
    $cad157996e70f357$var$questionnaire.addEventListener("change", toggleQuestionnaireReferralVisibility);
    document.addEventListener("DOMContentLoaded", toggleQuestionnaireReferralVisibility);
    function toggleQuestionnaireOtherVisibility() {
        if ($cad157996e70f357$var$questionnaire.value === "other" || $cad157996e70f357$var$questionnaire.value === "ambassador") {
            $cad157996e70f357$var$questionnaireOtherWrapper.style.display = "block";
            $cad157996e70f357$var$questionnaireOtherInput.required = true;
            if ($cad157996e70f357$var$questionnaire.value === "other") $cad157996e70f357$var$questionnaireOtherInput.placeholder = "Please tell us more...";
            else if ($cad157996e70f357$var$questionnaire.value === "ambassador") $cad157996e70f357$var$questionnaireOtherInput.placeholder = "Please enter Ambassador's name...";
        } else {
            $cad157996e70f357$var$questionnaireOtherWrapper.style.display = "none";
            $cad157996e70f357$var$questionnaireOtherInput.required = false;
        }
    }
    $cad157996e70f357$var$questionnaire.addEventListener("change", toggleQuestionnaireOtherVisibility);
    document.addEventListener("DOMContentLoaded", toggleQuestionnaireOtherVisibility);
}


// Password validation helpers using the account API
document.addEventListener("DOMContentLoaded", function() {
    const password1 = document.getElementById("id_password1");
    const password2 = document.getElementById("id_password2");
    const feedback = document.getElementById("password-validation-feedback");
    if (password1 && password2 && feedback) {
        let last_password1 = password1.value;
        let last_password2 = password2.value;
        let errors = [];
        function clearErrors() {
            errors = [];
            feedback.innerHTML = "";
            feedback.classList.add("field-errors");
            password1.classList.remove("is-invalid");
            password2.classList.remove("is-invalid");
            document.querySelectorAll(".passwordfield .field-errors").forEach((element)=>{
                element.remove();
            });
        }
        function addError(error) {
            errors.push(error);
            updateErrors();
        }
        function addErrors(new_errors) {
            errors = errors.concat(new_errors);
            updateErrors();
        }
        function updateErrors() {
            if (errors.length > 0) {
                password1.classList.add("is-invalid");
                password2.classList.add("is-invalid");
                let list_html = "";
                for (let error of errors)list_html += `<li><img class="img-fluid" src="/static/icons/x.svg" alt="X" />${error}</li>`;
                feedback.innerHTML = list_html;
            }
        }
        async function validatePasswords() {
            // Don't proceed if no password1
            if (!password1.value) return;
            // Don't proceed if the passwords didn't change
            if (password1.value === last_password1 && password2.value === last_password2) return;
            // Clear existing errors
            clearErrors();
            // Check if the passwords match
            if (password2.value && password1.value !== password2.value) addError("The passwords do not match");
            // Get all of the data filled out so far on the form
            const data = {
                password: password1.value,
                first_name: document.getElementById("id_first_name").value,
                last_name: document.getElementById("id_last_name").value,
                email: document.getElementById("id_email").value
            };
            try {
                const response = await fetch(API_URLS["account-api:validate_password"], {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json"
                    },
                    body: JSON.stringify(data)
                });
                if (!response.ok) throw new Error("Network response was not ok");
                const responseData = await response.json();
                if (responseData.status === "invalid") addErrors(responseData.messages);
            } catch (error) {
                console.error("There was an error validating password", error);
            }
            // Update the last records
            last_password1 = password1.value;
            last_password2 = password2.value;
        }
        // Validate when field changes
        password1.addEventListener("change", validatePasswords);
        password2.addEventListener("change", validatePasswords);
    }
});


// Detects when the user scrolls and adds a class to the element.
//
// Usage:
//
//      <div data-scroll-detect-px="x,y" data-scroll-detect-class="scrolled,scrolled-far" />
//
//  data-scroll-detect-px:    comma separated list of distances (in pixels) that the user needs to scroll before adding
//                            the corresponding class to the element
//  data-scroll-detect-class: comma separated list of classes to add to the element which correspond to the distances
//                            in data-scroll-detect-px
document.addEventListener("DOMContentLoaded", function() {
    const elements = document.querySelectorAll("[data-scroll-detect-px]");
    [
        ...elements
    ].forEach(function(element) {
        const distances = element.dataset.scrollDetectPx.split(",").map((x)=>parseInt(x, 10));
        const classes = element.dataset.scrollDetectClass.split(",");
        if (distances.length !== classes.length) {
            console.error("data-scroll-detect-px and data-scroll-detect-class must have the same number of values");
            return;
        }
        // console.debug("Scroll detect on", element, `with distances ${distances} and classes ${classes}`);
        let lastScrollPosition = 0;
        let busy = false;
        function updateScrollClasses() {
            const scrollPosition = window.scrollY;
            for(let i = 0; i < distances.length; i++){
                const distance = distances[i];
                const className = classes[i];
                if (scrollPosition > distance) element.classList.add(className);
                else element.classList.remove(className);
            }
        }
        function scrollCallback() {
            lastScrollPosition = window.scrollY;
            if (!busy) {
                window.requestAnimationFrame(function() {
                    updateScrollClasses();
                    busy = false;
                });
                busy = true;
            }
        }
        document.addEventListener("scroll", scrollCallback);
        scrollCallback();
    });
});


document.addEventListener("DOMContentLoaded", function() {
    const inputLabels = document.querySelectorAll("[data-service-box]");
    if (inputLabels.length == 0) return;
    function removeAllSelectedPlanClass() {
        inputLabels.forEach((label)=>{
            label.classList.remove("selected-plan");
        });
    }
    inputLabels.forEach((label)=>{
        label.addEventListener("click", ()=>{
            removeAllSelectedPlanClass();
            label.classList.add("selected-plan");
        });
    });
});


// Reveal text word-by-word
//
// Usage:
//
//      <div data-text-reveal="words" data-text-reveal-start="top 80%" data-text-reveal-end="top 40%">
//
// data-text-reveal: The type of reveal: 'lines, 'words' or 'chars'.
// data-text-reveal-start: When to trigger the reveal. Default: top 80%
// data-text-reveal-end: When to end the reveal. Default: top 50%
// data-text-reveal-debug: Paint debug markers to help with positioning. Default: false
//
// start/end: https://greensock.com/docs/v3/Plugins/ScrollTrigger

/*!
 * ScrollTrigger 3.12.2
 * https://greensock.com
 *
 * @license Copyright 2008-2023, GreenSock. All rights reserved.
 * Subject to the terms at https://greensock.com/standard-license or for
 * Club GreenSock members, the agreement issued with that membership.
 * @author: Jack Doyle, jack@greensock.com
*/ /* eslint-disable */ function $a52c0798f59d4093$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $a52c0798f59d4093$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $a52c0798f59d4093$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $a52c0798f59d4093$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
/*!
 * Observer 3.12.2
 * https://greensock.com
 *
 * @license Copyright 2008-2023, GreenSock. All rights reserved.
 * Subject to the terms at https://greensock.com/standard-license or for
 * Club GreenSock members, the agreement issued with that membership.
 * @author: Jack Doyle, jack@greensock.com
*/ /* eslint-disable */ var $a52c0798f59d4093$var$gsap, $a52c0798f59d4093$var$_coreInitted, $a52c0798f59d4093$var$_clamp, $a52c0798f59d4093$var$_win, $a52c0798f59d4093$var$_doc, $a52c0798f59d4093$var$_docEl, $a52c0798f59d4093$var$_body, $a52c0798f59d4093$var$_isTouch, $a52c0798f59d4093$var$_pointerType, $a52c0798f59d4093$var$ScrollTrigger, $a52c0798f59d4093$var$_root, $a52c0798f59d4093$var$_normalizer, $a52c0798f59d4093$var$_eventTypes, $a52c0798f59d4093$var$_context, $a52c0798f59d4093$var$_getGSAP = function _getGSAP() {
    return $a52c0798f59d4093$var$gsap || typeof window !== "undefined" && ($a52c0798f59d4093$var$gsap = window.gsap) && $a52c0798f59d4093$var$gsap.registerPlugin && $a52c0798f59d4093$var$gsap;
}, $a52c0798f59d4093$var$_startup = 1, $a52c0798f59d4093$var$_observers = [], $a52c0798f59d4093$export$3cd1cee43d19b683 = [], $a52c0798f59d4093$export$d8e56d510a804d0a = [], $a52c0798f59d4093$var$_getTime = Date.now, $a52c0798f59d4093$var$_bridge = function _bridge(name, value) {
    return value;
}, $a52c0798f59d4093$var$_integrate = function _integrate() {
    var core = $a52c0798f59d4093$var$ScrollTrigger.core, data = core.bridge || {}, scrollers = core._scrollers, proxies = core._proxies;
    scrollers.push.apply(scrollers, $a52c0798f59d4093$export$3cd1cee43d19b683);
    proxies.push.apply(proxies, $a52c0798f59d4093$export$d8e56d510a804d0a);
    $a52c0798f59d4093$export$3cd1cee43d19b683 = scrollers;
    $a52c0798f59d4093$export$d8e56d510a804d0a = proxies;
    $a52c0798f59d4093$var$_bridge = function _bridge(name, value) {
        return data[name](value);
    };
}, $a52c0798f59d4093$export$6078f1ef08b38af9 = function _getProxyProp(element, property) {
    return ~$a52c0798f59d4093$export$d8e56d510a804d0a.indexOf(element) && $a52c0798f59d4093$export$d8e56d510a804d0a[$a52c0798f59d4093$export$d8e56d510a804d0a.indexOf(element) + 1][property];
}, $a52c0798f59d4093$export$4330f3a92e5d2e94 = function _isViewport(el) {
    return !!~$a52c0798f59d4093$var$_root.indexOf(el);
}, $a52c0798f59d4093$var$_addListener = function _addListener(element, type, func, nonPassive, capture) {
    return element.addEventListener(type, func, {
        passive: !nonPassive,
        capture: !!capture
    });
}, $a52c0798f59d4093$var$_removeListener = function _removeListener(element, type, func, capture) {
    return element.removeEventListener(type, func, !!capture);
}, $a52c0798f59d4093$var$_scrollLeft = "scrollLeft", $a52c0798f59d4093$var$_scrollTop = "scrollTop", $a52c0798f59d4093$var$_onScroll = function _onScroll() {
    return $a52c0798f59d4093$var$_normalizer && $a52c0798f59d4093$var$_normalizer.isPressed || $a52c0798f59d4093$export$3cd1cee43d19b683.cache++;
}, $a52c0798f59d4093$var$_scrollCacheFunc = function _scrollCacheFunc(f, doNotCache) {
    var cachingFunc = function cachingFunc(value) {
        // since reading the scrollTop/scrollLeft/pageOffsetY/pageOffsetX can trigger a layout, this function allows us to cache the value so it only gets read fresh after a "scroll" event fires (or while we're refreshing because that can lengthen the page and alter the scroll position). when "soft" is true, that means don't actually set the scroll, but cache the new value instead (useful in ScrollSmoother)
        if (value || value === 0) {
            $a52c0798f59d4093$var$_startup && ($a52c0798f59d4093$var$_win.history.scrollRestoration = "manual"); // otherwise the new position will get overwritten by the browser onload.
            var isNormalizing = $a52c0798f59d4093$var$_normalizer && $a52c0798f59d4093$var$_normalizer.isPressed;
            value = cachingFunc.v = Math.round(value) || ($a52c0798f59d4093$var$_normalizer && $a52c0798f59d4093$var$_normalizer.iOS ? 1 : 0); //TODO: iOS Bug: if you allow it to go to 0, Safari can start to report super strange (wildly inaccurate) touch positions!
            f(value);
            cachingFunc.cacheID = $a52c0798f59d4093$export$3cd1cee43d19b683.cache;
            isNormalizing && $a52c0798f59d4093$var$_bridge("ss", value); // set scroll (notify ScrollTrigger so it can dispatch a "scrollStart" event if necessary
        } else if (doNotCache || $a52c0798f59d4093$export$3cd1cee43d19b683.cache !== cachingFunc.cacheID || $a52c0798f59d4093$var$_bridge("ref")) {
            cachingFunc.cacheID = $a52c0798f59d4093$export$3cd1cee43d19b683.cache;
            cachingFunc.v = f();
        }
        return cachingFunc.v + cachingFunc.offset;
    };
    cachingFunc.offset = 0;
    return f && cachingFunc;
}, $a52c0798f59d4093$export$b2cabb342cb0ebe1 = {
    s: $a52c0798f59d4093$var$_scrollLeft,
    p: "left",
    p2: "Left",
    os: "right",
    os2: "Right",
    d: "width",
    d2: "Width",
    a: "x",
    sc: $a52c0798f59d4093$var$_scrollCacheFunc(function(value) {
        return arguments.length ? $a52c0798f59d4093$var$_win.scrollTo(value, $a52c0798f59d4093$export$8e40fc98ff518e9d.sc()) : $a52c0798f59d4093$var$_win.pageXOffset || $a52c0798f59d4093$var$_doc[$a52c0798f59d4093$var$_scrollLeft] || $a52c0798f59d4093$var$_docEl[$a52c0798f59d4093$var$_scrollLeft] || $a52c0798f59d4093$var$_body[$a52c0798f59d4093$var$_scrollLeft] || 0;
    })
}, $a52c0798f59d4093$export$8e40fc98ff518e9d = {
    s: $a52c0798f59d4093$var$_scrollTop,
    p: "top",
    p2: "Top",
    os: "bottom",
    os2: "Bottom",
    d: "height",
    d2: "Height",
    a: "y",
    op: $a52c0798f59d4093$export$b2cabb342cb0ebe1,
    sc: $a52c0798f59d4093$var$_scrollCacheFunc(function(value) {
        return arguments.length ? $a52c0798f59d4093$var$_win.scrollTo($a52c0798f59d4093$export$b2cabb342cb0ebe1.sc(), value) : $a52c0798f59d4093$var$_win.pageYOffset || $a52c0798f59d4093$var$_doc[$a52c0798f59d4093$var$_scrollTop] || $a52c0798f59d4093$var$_docEl[$a52c0798f59d4093$var$_scrollTop] || $a52c0798f59d4093$var$_body[$a52c0798f59d4093$var$_scrollTop] || 0;
    })
}, $a52c0798f59d4093$export$937374fea3f88711 = function _getTarget(t, self) {
    return (self && self._ctx && self._ctx.selector || $a52c0798f59d4093$var$gsap.utils.toArray)(t)[0] || (typeof t === "string" && $a52c0798f59d4093$var$gsap.config().nullTargetWarn !== false ? console.warn("Element not found:", t) : null);
}, $a52c0798f59d4093$export$8665aac53dad5647 = function _getScrollFunc(element, _ref) {
    var s = _ref.s, sc = _ref.sc;
    // we store the scroller functions in an alternating sequenced Array like [element, verticalScrollFunc, horizontalScrollFunc, ...] so that we can minimize memory, maximize performance, and we also record the last position as a ".rec" property in order to revert to that after refreshing to ensure things don't shift around.
    $a52c0798f59d4093$export$4330f3a92e5d2e94(element) && (element = $a52c0798f59d4093$var$_doc.scrollingElement || $a52c0798f59d4093$var$_docEl);
    var i = $a52c0798f59d4093$export$3cd1cee43d19b683.indexOf(element), offset = sc === $a52c0798f59d4093$export$8e40fc98ff518e9d.sc ? 1 : 2;
    !~i && (i = $a52c0798f59d4093$export$3cd1cee43d19b683.push(element) - 1);
    $a52c0798f59d4093$export$3cd1cee43d19b683[i + offset] || $a52c0798f59d4093$var$_addListener(element, "scroll", $a52c0798f59d4093$var$_onScroll); // clear the cache when a scroll occurs
    var prev = $a52c0798f59d4093$export$3cd1cee43d19b683[i + offset], func = prev || ($a52c0798f59d4093$export$3cd1cee43d19b683[i + offset] = $a52c0798f59d4093$var$_scrollCacheFunc($a52c0798f59d4093$export$6078f1ef08b38af9(element, s), true) || ($a52c0798f59d4093$export$4330f3a92e5d2e94(element) ? sc : $a52c0798f59d4093$var$_scrollCacheFunc(function(value) {
        return arguments.length ? element[s] = value : element[s];
    })));
    func.target = element;
    prev || (func.smooth = $a52c0798f59d4093$var$gsap.getProperty(element, "scrollBehavior") === "smooth"); // only set it the first time (don't reset every time a scrollFunc is requested because perhaps it happens during a refresh() when it's disabled in ScrollTrigger.
    return func;
}, $a52c0798f59d4093$export$5de019f4480f0f8d = function _getVelocityProp(value, minTimeRefresh, useDelta) {
    var v1 = value, v2 = value, t1 = $a52c0798f59d4093$var$_getTime(), t2 = t1, min = minTimeRefresh || 50, dropToZeroTime = Math.max(500, min * 3), update = function update(value, force) {
        var t = $a52c0798f59d4093$var$_getTime();
        if (force || t - t1 > min) {
            v2 = v1;
            v1 = value;
            t2 = t1;
            t1 = t;
        } else if (useDelta) v1 += value;
        else // not totally necessary, but makes it a bit more accurate by adjusting the v1 value according to the new slope. This way we're not just ignoring the incoming data. Removing for now because it doesn't seem to make much practical difference and it's probably not worth the kb.
        v1 = v2 + (value - v2) / (t - t2) * (t1 - t2);
    }, reset = function reset() {
        v2 = v1 = useDelta ? 0 : v1;
        t2 = t1 = 0;
    }, getVelocity = function getVelocity(latestValue) {
        var tOld = t2, vOld = v2, t = $a52c0798f59d4093$var$_getTime();
        (latestValue || latestValue === 0) && latestValue !== v1 && update(latestValue);
        return t1 === t2 || t - t2 > dropToZeroTime ? 0 : (v1 + (useDelta ? vOld : -vOld)) / ((useDelta ? t : t1) - tOld) * 1000;
    };
    return {
        update: update,
        reset: reset,
        getVelocity: getVelocity
    };
}, $a52c0798f59d4093$var$_getEvent = function _getEvent(e, preventDefault) {
    preventDefault && !e._gsapAllow && e.preventDefault();
    return e.changedTouches ? e.changedTouches[0] : e;
}, $a52c0798f59d4093$var$_getAbsoluteMax = function _getAbsoluteMax(a) {
    var max = Math.max.apply(Math, a), min = Math.min.apply(Math, a);
    return Math.abs(max) >= Math.abs(min) ? max : min;
}, $a52c0798f59d4093$var$_setScrollTrigger = function _setScrollTrigger() {
    $a52c0798f59d4093$var$ScrollTrigger = $a52c0798f59d4093$var$gsap.core.globals().ScrollTrigger;
    $a52c0798f59d4093$var$ScrollTrigger && $a52c0798f59d4093$var$ScrollTrigger.core && $a52c0798f59d4093$var$_integrate();
}, $a52c0798f59d4093$var$_initCore = function _initCore(core) {
    $a52c0798f59d4093$var$gsap = core || $a52c0798f59d4093$var$_getGSAP();
    if ($a52c0798f59d4093$var$gsap && typeof document !== "undefined" && document.body) {
        $a52c0798f59d4093$var$_win = window;
        $a52c0798f59d4093$var$_doc = document;
        $a52c0798f59d4093$var$_docEl = $a52c0798f59d4093$var$_doc.documentElement;
        $a52c0798f59d4093$var$_body = $a52c0798f59d4093$var$_doc.body;
        $a52c0798f59d4093$var$_root = [
            $a52c0798f59d4093$var$_win,
            $a52c0798f59d4093$var$_doc,
            $a52c0798f59d4093$var$_docEl,
            $a52c0798f59d4093$var$_body
        ];
        $a52c0798f59d4093$var$_clamp = $a52c0798f59d4093$var$gsap.utils.clamp;
        $a52c0798f59d4093$var$_context = $a52c0798f59d4093$var$gsap.core.context || function() {};
        $a52c0798f59d4093$var$_pointerType = "onpointerenter" in $a52c0798f59d4093$var$_body ? "pointer" : "mouse"; // isTouch is 0 if no touch, 1 if ONLY touch, and 2 if it can accommodate touch but also other types like mouse/pointer.
        $a52c0798f59d4093$var$_isTouch = $a52c0798f59d4093$export$c1cbdee04e18ea8b.isTouch = $a52c0798f59d4093$var$_win.matchMedia && $a52c0798f59d4093$var$_win.matchMedia("(hover: none), (pointer: coarse)").matches ? 1 : "ontouchstart" in $a52c0798f59d4093$var$_win || navigator.maxTouchPoints > 0 || navigator.msMaxTouchPoints > 0 ? 2 : 0;
        $a52c0798f59d4093$var$_eventTypes = $a52c0798f59d4093$export$c1cbdee04e18ea8b.eventTypes = ("ontouchstart" in $a52c0798f59d4093$var$_docEl ? "touchstart,touchmove,touchcancel,touchend" : !("onpointerdown" in $a52c0798f59d4093$var$_docEl) ? "mousedown,mousemove,mouseup,mouseup" : "pointerdown,pointermove,pointercancel,pointerup").split(",");
        setTimeout(function() {
            return $a52c0798f59d4093$var$_startup = 0;
        }, 500);
        $a52c0798f59d4093$var$_setScrollTrigger();
        $a52c0798f59d4093$var$_coreInitted = 1;
    }
    return $a52c0798f59d4093$var$_coreInitted;
};
$a52c0798f59d4093$export$b2cabb342cb0ebe1.op = $a52c0798f59d4093$export$8e40fc98ff518e9d;
$a52c0798f59d4093$export$3cd1cee43d19b683.cache = 0;
var $a52c0798f59d4093$export$c1cbdee04e18ea8b = /*#__PURE__*/ function() {
    function Observer(vars) {
        this.init(vars);
    }
    var _proto = Observer.prototype;
    _proto.init = function init(vars) {
        $a52c0798f59d4093$var$_coreInitted || $a52c0798f59d4093$var$_initCore($a52c0798f59d4093$var$gsap) || console.warn("Please gsap.registerPlugin(Observer)");
        $a52c0798f59d4093$var$ScrollTrigger || $a52c0798f59d4093$var$_setScrollTrigger();
        var tolerance = vars.tolerance, dragMinimum = vars.dragMinimum, type = vars.type, target = vars.target, lineHeight = vars.lineHeight, debounce = vars.debounce, preventDefault = vars.preventDefault, onStop = vars.onStop, onStopDelay = vars.onStopDelay, ignore = vars.ignore, wheelSpeed = vars.wheelSpeed, event = vars.event, onDragStart = vars.onDragStart, onDragEnd = vars.onDragEnd, onDrag = vars.onDrag, onPress = vars.onPress, onRelease = vars.onRelease, onRight = vars.onRight, onLeft = vars.onLeft, onUp = vars.onUp, onDown = vars.onDown, onChangeX = vars.onChangeX, onChangeY = vars.onChangeY, onChange = vars.onChange, onToggleX = vars.onToggleX, onToggleY = vars.onToggleY, onHover = vars.onHover, onHoverEnd = vars.onHoverEnd, onMove = vars.onMove, ignoreCheck = vars.ignoreCheck, isNormalizer = vars.isNormalizer, onGestureStart = vars.onGestureStart, onGestureEnd = vars.onGestureEnd, onWheel = vars.onWheel, onEnable = vars.onEnable, onDisable = vars.onDisable, onClick = vars.onClick, scrollSpeed = vars.scrollSpeed, capture = vars.capture, allowClicks = vars.allowClicks, lockAxis = vars.lockAxis, onLockAxis = vars.onLockAxis;
        this.target = target = $a52c0798f59d4093$export$937374fea3f88711(target) || $a52c0798f59d4093$var$_docEl;
        this.vars = vars;
        ignore && (ignore = $a52c0798f59d4093$var$gsap.utils.toArray(ignore));
        tolerance = tolerance || 1e-9;
        dragMinimum = dragMinimum || 0;
        wheelSpeed = wheelSpeed || 1;
        scrollSpeed = scrollSpeed || 1;
        type = type || "wheel,touch,pointer";
        debounce = debounce !== false;
        lineHeight || (lineHeight = parseFloat($a52c0798f59d4093$var$_win.getComputedStyle($a52c0798f59d4093$var$_body).lineHeight) || 22); // note: browser may report "normal", so default to 22.
        var id, onStopDelayedCall, dragged, moved, wheeled, locked, axis, self = this, prevDeltaX = 0, prevDeltaY = 0, scrollFuncX = $a52c0798f59d4093$export$8665aac53dad5647(target, $a52c0798f59d4093$export$b2cabb342cb0ebe1), scrollFuncY = $a52c0798f59d4093$export$8665aac53dad5647(target, $a52c0798f59d4093$export$8e40fc98ff518e9d), scrollX = scrollFuncX(), scrollY = scrollFuncY(), limitToTouch = ~type.indexOf("touch") && !~type.indexOf("pointer") && $a52c0798f59d4093$var$_eventTypes[0] === "pointerdown", // for devices that accommodate mouse events and touch events, we need to distinguish.
        isViewport = $a52c0798f59d4093$export$4330f3a92e5d2e94(target), ownerDoc = target.ownerDocument || $a52c0798f59d4093$var$_doc, deltaX = [
            0,
            0,
            0
        ], // wheel, scroll, pointer/touch
        deltaY = [
            0,
            0,
            0
        ], onClickTime = 0, clickCapture = function clickCapture() {
            return onClickTime = $a52c0798f59d4093$var$_getTime();
        }, _ignoreCheck = function _ignoreCheck(e, isPointerOrTouch) {
            return (self.event = e) && ignore && ~ignore.indexOf(e.target) || isPointerOrTouch && limitToTouch && e.pointerType !== "touch" || ignoreCheck && ignoreCheck(e, isPointerOrTouch);
        }, onStopFunc = function onStopFunc() {
            self._vx.reset();
            self._vy.reset();
            onStopDelayedCall.pause();
            onStop && onStop(self);
        }, update = function update() {
            var dx = self.deltaX = $a52c0798f59d4093$var$_getAbsoluteMax(deltaX), dy = self.deltaY = $a52c0798f59d4093$var$_getAbsoluteMax(deltaY), changedX = Math.abs(dx) >= tolerance, changedY = Math.abs(dy) >= tolerance;
            onChange && (changedX || changedY) && onChange(self, dx, dy, deltaX, deltaY); // in ScrollTrigger.normalizeScroll(), we need to know if it was touch/pointer so we need access to the deltaX/deltaY Arrays before we clear them out.
            if (changedX) {
                onRight && self.deltaX > 0 && onRight(self);
                onLeft && self.deltaX < 0 && onLeft(self);
                onChangeX && onChangeX(self);
                onToggleX && self.deltaX < 0 !== prevDeltaX < 0 && onToggleX(self);
                prevDeltaX = self.deltaX;
                deltaX[0] = deltaX[1] = deltaX[2] = 0;
            }
            if (changedY) {
                onDown && self.deltaY > 0 && onDown(self);
                onUp && self.deltaY < 0 && onUp(self);
                onChangeY && onChangeY(self);
                onToggleY && self.deltaY < 0 !== prevDeltaY < 0 && onToggleY(self);
                prevDeltaY = self.deltaY;
                deltaY[0] = deltaY[1] = deltaY[2] = 0;
            }
            if (moved || dragged) {
                onMove && onMove(self);
                if (dragged) {
                    onDrag(self);
                    dragged = false;
                }
                moved = false;
            }
            locked && (locked = false, true) && onLockAxis && onLockAxis(self);
            if (wheeled) {
                onWheel(self);
                wheeled = false;
            }
            id = 0;
        }, onDelta = function onDelta(x, y, index) {
            deltaX[index] += x;
            deltaY[index] += y;
            self._vx.update(x);
            self._vy.update(y);
            debounce ? id || (id = requestAnimationFrame(update)) : update();
        }, onTouchOrPointerDelta = function onTouchOrPointerDelta(x, y) {
            if (lockAxis && !axis) {
                self.axis = axis = Math.abs(x) > Math.abs(y) ? "x" : "y";
                locked = true;
            }
            if (axis !== "y") {
                deltaX[2] += x;
                self._vx.update(x, true); // update the velocity as frequently as possible instead of in the debounced function so that very quick touch-scrolls (flicks) feel natural. If it's the mouse/touch/pointer, force it so that we get snappy/accurate momentum scroll.
            }
            if (axis !== "x") {
                deltaY[2] += y;
                self._vy.update(y, true);
            }
            debounce ? id || (id = requestAnimationFrame(update)) : update();
        }, _onDrag = function _onDrag(e) {
            if (_ignoreCheck(e, 1)) return;
            e = $a52c0798f59d4093$var$_getEvent(e, preventDefault);
            var x = e.clientX, y = e.clientY, dx = x - self.x, dy = y - self.y, isDragging = self.isDragging;
            self.x = x;
            self.y = y;
            if (isDragging || Math.abs(self.startX - x) >= dragMinimum || Math.abs(self.startY - y) >= dragMinimum) {
                onDrag && (dragged = true);
                isDragging || (self.isDragging = true);
                onTouchOrPointerDelta(dx, dy);
                isDragging || onDragStart && onDragStart(self);
            }
        }, _onPress = self.onPress = function(e) {
            if (_ignoreCheck(e, 1) || e && e.button) return;
            self.axis = axis = null;
            onStopDelayedCall.pause();
            self.isPressed = true;
            e = $a52c0798f59d4093$var$_getEvent(e); // note: may need to preventDefault(?) Won't side-scroll on iOS Safari if we do, though.
            prevDeltaX = prevDeltaY = 0;
            self.startX = self.x = e.clientX;
            self.startY = self.y = e.clientY;
            self._vx.reset(); // otherwise the t2 may be stale if the user touches and flicks super fast and releases in less than 2 requestAnimationFrame ticks, causing velocity to be 0.
            self._vy.reset();
            $a52c0798f59d4093$var$_addListener(isNormalizer ? target : ownerDoc, $a52c0798f59d4093$var$_eventTypes[1], _onDrag, preventDefault, true);
            self.deltaX = self.deltaY = 0;
            onPress && onPress(self);
        }, _onRelease = self.onRelease = function(e) {
            if (_ignoreCheck(e, 1)) return;
            $a52c0798f59d4093$var$_removeListener(isNormalizer ? target : ownerDoc, $a52c0798f59d4093$var$_eventTypes[1], _onDrag, true);
            var isTrackingDrag = !isNaN(self.y - self.startY), wasDragging = self.isDragging && (Math.abs(self.x - self.startX) > 3 || Math.abs(self.y - self.startY) > 3), // some touch devices need some wiggle room in terms of sensing clicks - the finger may move a few pixels.
            eventData = $a52c0798f59d4093$var$_getEvent(e);
            if (!wasDragging && isTrackingDrag) {
                self._vx.reset();
                self._vy.reset();
                if (preventDefault && allowClicks) $a52c0798f59d4093$var$gsap.delayedCall(0.08, function() {
                    // some browsers (like Firefox) won't trust script-generated clicks, so if the user tries to click on a video to play it, for example, it simply won't work. Since a regular "click" event will most likely be generated anyway (one that has its isTrusted flag set to true), we must slightly delay our script-generated click so that the "real"/trusted one is prioritized. Remember, when there are duplicate events in quick succession, we suppress all but the first one. Some browsers don't even trigger the "real" one at all, so our synthetic one is a safety valve that ensures that no matter what, a click event does get dispatched.
                    if ($a52c0798f59d4093$var$_getTime() - onClickTime > 300 && !e.defaultPrevented) {
                        if (e.target.click) //some browsers (like mobile Safari) don't properly trigger the click event
                        e.target.click();
                        else if (ownerDoc.createEvent) {
                            var syntheticEvent = ownerDoc.createEvent("MouseEvents");
                            syntheticEvent.initMouseEvent("click", true, true, $a52c0798f59d4093$var$_win, 1, eventData.screenX, eventData.screenY, eventData.clientX, eventData.clientY, false, false, false, false, 0, null);
                            e.target.dispatchEvent(syntheticEvent);
                        }
                    }
                });
            }
            self.isDragging = self.isGesturing = self.isPressed = false;
            onStop && !isNormalizer && onStopDelayedCall.restart(true);
            onDragEnd && wasDragging && onDragEnd(self);
            onRelease && onRelease(self, wasDragging);
        }, _onGestureStart = function _onGestureStart(e) {
            return e.touches && e.touches.length > 1 && (self.isGesturing = true) && onGestureStart(e, self.isDragging);
        }, _onGestureEnd = function _onGestureEnd() {
            return self.isGesturing = false, onGestureEnd(self);
        }, onScroll = function onScroll(e) {
            if (_ignoreCheck(e)) return;
            var x = scrollFuncX(), y = scrollFuncY();
            onDelta((x - scrollX) * scrollSpeed, (y - scrollY) * scrollSpeed, 1);
            scrollX = x;
            scrollY = y;
            onStop && onStopDelayedCall.restart(true);
        }, _onWheel = function _onWheel(e) {
            if (_ignoreCheck(e)) return;
            e = $a52c0798f59d4093$var$_getEvent(e, preventDefault);
            onWheel && (wheeled = true);
            var multiplier = (e.deltaMode === 1 ? lineHeight : e.deltaMode === 2 ? $a52c0798f59d4093$var$_win.innerHeight : 1) * wheelSpeed;
            onDelta(e.deltaX * multiplier, e.deltaY * multiplier, 0);
            onStop && !isNormalizer && onStopDelayedCall.restart(true);
        }, _onMove = function _onMove(e) {
            if (_ignoreCheck(e)) return;
            var x = e.clientX, y = e.clientY, dx = x - self.x, dy = y - self.y;
            self.x = x;
            self.y = y;
            moved = true;
            (dx || dy) && onTouchOrPointerDelta(dx, dy);
        }, _onHover = function _onHover(e) {
            self.event = e;
            onHover(self);
        }, _onHoverEnd = function _onHoverEnd(e) {
            self.event = e;
            onHoverEnd(self);
        }, _onClick = function _onClick(e) {
            return _ignoreCheck(e) || $a52c0798f59d4093$var$_getEvent(e, preventDefault) && onClick(self);
        };
        onStopDelayedCall = self._dc = $a52c0798f59d4093$var$gsap.delayedCall(onStopDelay || 0.25, onStopFunc).pause();
        self.deltaX = self.deltaY = 0;
        self._vx = $a52c0798f59d4093$export$5de019f4480f0f8d(0, 50, true);
        self._vy = $a52c0798f59d4093$export$5de019f4480f0f8d(0, 50, true);
        self.scrollX = scrollFuncX;
        self.scrollY = scrollFuncY;
        self.isDragging = self.isGesturing = self.isPressed = false;
        $a52c0798f59d4093$var$_context(this);
        self.enable = function(e) {
            if (!self.isEnabled) {
                $a52c0798f59d4093$var$_addListener(isViewport ? ownerDoc : target, "scroll", $a52c0798f59d4093$var$_onScroll);
                type.indexOf("scroll") >= 0 && $a52c0798f59d4093$var$_addListener(isViewport ? ownerDoc : target, "scroll", onScroll, preventDefault, capture);
                type.indexOf("wheel") >= 0 && $a52c0798f59d4093$var$_addListener(target, "wheel", _onWheel, preventDefault, capture);
                if (type.indexOf("touch") >= 0 && $a52c0798f59d4093$var$_isTouch || type.indexOf("pointer") >= 0) {
                    $a52c0798f59d4093$var$_addListener(target, $a52c0798f59d4093$var$_eventTypes[0], _onPress, preventDefault, capture);
                    $a52c0798f59d4093$var$_addListener(ownerDoc, $a52c0798f59d4093$var$_eventTypes[2], _onRelease);
                    $a52c0798f59d4093$var$_addListener(ownerDoc, $a52c0798f59d4093$var$_eventTypes[3], _onRelease);
                    allowClicks && $a52c0798f59d4093$var$_addListener(target, "click", clickCapture, false, true);
                    onClick && $a52c0798f59d4093$var$_addListener(target, "click", _onClick);
                    onGestureStart && $a52c0798f59d4093$var$_addListener(ownerDoc, "gesturestart", _onGestureStart);
                    onGestureEnd && $a52c0798f59d4093$var$_addListener(ownerDoc, "gestureend", _onGestureEnd);
                    onHover && $a52c0798f59d4093$var$_addListener(target, $a52c0798f59d4093$var$_pointerType + "enter", _onHover);
                    onHoverEnd && $a52c0798f59d4093$var$_addListener(target, $a52c0798f59d4093$var$_pointerType + "leave", _onHoverEnd);
                    onMove && $a52c0798f59d4093$var$_addListener(target, $a52c0798f59d4093$var$_pointerType + "move", _onMove);
                }
                self.isEnabled = true;
                e && e.type && _onPress(e);
                onEnable && onEnable(self);
            }
            return self;
        };
        self.disable = function() {
            if (self.isEnabled) {
                // only remove the _onScroll listener if there aren't any others that rely on the functionality.
                $a52c0798f59d4093$var$_observers.filter(function(o) {
                    return o !== self && $a52c0798f59d4093$export$4330f3a92e5d2e94(o.target);
                }).length || $a52c0798f59d4093$var$_removeListener(isViewport ? ownerDoc : target, "scroll", $a52c0798f59d4093$var$_onScroll);
                if (self.isPressed) {
                    self._vx.reset();
                    self._vy.reset();
                    $a52c0798f59d4093$var$_removeListener(isNormalizer ? target : ownerDoc, $a52c0798f59d4093$var$_eventTypes[1], _onDrag, true);
                }
                $a52c0798f59d4093$var$_removeListener(isViewport ? ownerDoc : target, "scroll", onScroll, capture);
                $a52c0798f59d4093$var$_removeListener(target, "wheel", _onWheel, capture);
                $a52c0798f59d4093$var$_removeListener(target, $a52c0798f59d4093$var$_eventTypes[0], _onPress, capture);
                $a52c0798f59d4093$var$_removeListener(ownerDoc, $a52c0798f59d4093$var$_eventTypes[2], _onRelease);
                $a52c0798f59d4093$var$_removeListener(ownerDoc, $a52c0798f59d4093$var$_eventTypes[3], _onRelease);
                $a52c0798f59d4093$var$_removeListener(target, "click", clickCapture, true);
                $a52c0798f59d4093$var$_removeListener(target, "click", _onClick);
                $a52c0798f59d4093$var$_removeListener(ownerDoc, "gesturestart", _onGestureStart);
                $a52c0798f59d4093$var$_removeListener(ownerDoc, "gestureend", _onGestureEnd);
                $a52c0798f59d4093$var$_removeListener(target, $a52c0798f59d4093$var$_pointerType + "enter", _onHover);
                $a52c0798f59d4093$var$_removeListener(target, $a52c0798f59d4093$var$_pointerType + "leave", _onHoverEnd);
                $a52c0798f59d4093$var$_removeListener(target, $a52c0798f59d4093$var$_pointerType + "move", _onMove);
                self.isEnabled = self.isPressed = self.isDragging = false;
                onDisable && onDisable(self);
            }
        };
        self.kill = self.revert = function() {
            self.disable();
            var i = $a52c0798f59d4093$var$_observers.indexOf(self);
            i >= 0 && $a52c0798f59d4093$var$_observers.splice(i, 1);
            $a52c0798f59d4093$var$_normalizer === self && ($a52c0798f59d4093$var$_normalizer = 0);
        };
        $a52c0798f59d4093$var$_observers.push(self);
        isNormalizer && $a52c0798f59d4093$export$4330f3a92e5d2e94(target) && ($a52c0798f59d4093$var$_normalizer = self);
        self.enable(event);
    };
    $a52c0798f59d4093$var$_createClass(Observer, [
        {
            key: "velocityX",
            get: function get() {
                return this._vx.getVelocity();
            }
        },
        {
            key: "velocityY",
            get: function get() {
                return this._vy.getVelocity();
            }
        }
    ]);
    return Observer;
}();
$a52c0798f59d4093$export$c1cbdee04e18ea8b.version = "3.12.2";
$a52c0798f59d4093$export$c1cbdee04e18ea8b.create = function(vars) {
    return new $a52c0798f59d4093$export$c1cbdee04e18ea8b(vars);
};
$a52c0798f59d4093$export$c1cbdee04e18ea8b.register = $a52c0798f59d4093$var$_initCore;
$a52c0798f59d4093$export$c1cbdee04e18ea8b.getAll = function() {
    return $a52c0798f59d4093$var$_observers.slice();
};
$a52c0798f59d4093$export$c1cbdee04e18ea8b.getById = function(id) {
    return $a52c0798f59d4093$var$_observers.filter(function(o) {
        return o.vars.id === id;
    })[0];
};
$a52c0798f59d4093$var$_getGSAP() && $a52c0798f59d4093$var$gsap.registerPlugin($a52c0798f59d4093$export$c1cbdee04e18ea8b);


var $f075d17102cf2205$var$gsap, $f075d17102cf2205$var$_coreInitted, $f075d17102cf2205$var$_win, $f075d17102cf2205$var$_doc, $f075d17102cf2205$var$_docEl, $f075d17102cf2205$var$_body, $f075d17102cf2205$var$_root, $f075d17102cf2205$var$_resizeDelay, $f075d17102cf2205$var$_toArray, $f075d17102cf2205$var$_clamp, $f075d17102cf2205$var$_time2, $f075d17102cf2205$var$_syncInterval, $f075d17102cf2205$var$_refreshing, $f075d17102cf2205$var$_pointerIsDown, $f075d17102cf2205$var$_transformProp, $f075d17102cf2205$var$_i, $f075d17102cf2205$var$_prevWidth, $f075d17102cf2205$var$_prevHeight, $f075d17102cf2205$var$_autoRefresh, $f075d17102cf2205$var$_sort, $f075d17102cf2205$var$_suppressOverwrites, $f075d17102cf2205$var$_ignoreResize, $f075d17102cf2205$var$_normalizer, $f075d17102cf2205$var$_ignoreMobileResize, $f075d17102cf2205$var$_baseScreenHeight, $f075d17102cf2205$var$_baseScreenWidth, $f075d17102cf2205$var$_fixIOSBug, $f075d17102cf2205$var$_context, $f075d17102cf2205$var$_scrollRestoration, $f075d17102cf2205$var$_div100vh, $f075d17102cf2205$var$_100vh, $f075d17102cf2205$var$_limitCallbacks, // if true, we'll only trigger callbacks if the active state toggles, so if you scroll immediately past both the start and end positions of a ScrollTrigger (thus inactive to inactive), neither its onEnter nor onLeave will be called. This is useful during startup.
$f075d17102cf2205$var$_startup = 1, $f075d17102cf2205$var$_getTime = Date.now, $f075d17102cf2205$var$_time1 = $f075d17102cf2205$var$_getTime(), $f075d17102cf2205$var$_lastScrollTime = 0, $f075d17102cf2205$var$_enabled = 0, $f075d17102cf2205$var$_parseClamp = function _parseClamp(value, type, self) {
    var clamp = $f075d17102cf2205$var$_isString(value) && (value.substr(0, 6) === "clamp(" || value.indexOf("max") > -1);
    self["_" + type + "Clamp"] = clamp;
    return clamp ? value.substr(6, value.length - 7) : value;
}, $f075d17102cf2205$var$_keepClamp = function _keepClamp(value, clamp) {
    return clamp && (!$f075d17102cf2205$var$_isString(value) || value.substr(0, 6) !== "clamp(") ? "clamp(" + value + ")" : value;
}, $f075d17102cf2205$var$_rafBugFix = function _rafBugFix() {
    return $f075d17102cf2205$var$_enabled && requestAnimationFrame(_rafBugFix);
}, // in some browsers (like Firefox), screen repaints weren't consistent unless we had SOMETHING queued up in requestAnimationFrame()! So this just creates a super simple loop to keep it alive and smooth out repaints.
$f075d17102cf2205$var$_pointerDownHandler = function _pointerDownHandler() {
    return $f075d17102cf2205$var$_pointerIsDown = 1;
}, $f075d17102cf2205$var$_pointerUpHandler = function _pointerUpHandler() {
    return $f075d17102cf2205$var$_pointerIsDown = 0;
}, $f075d17102cf2205$var$_passThrough = function _passThrough(v) {
    return v;
}, $f075d17102cf2205$var$_round = function _round(value) {
    return Math.round(value * 100000) / 100000 || 0;
}, $f075d17102cf2205$var$_windowExists = function _windowExists() {
    return typeof window !== "undefined";
}, $f075d17102cf2205$var$_getGSAP = function _getGSAP() {
    return $f075d17102cf2205$var$gsap || $f075d17102cf2205$var$_windowExists() && ($f075d17102cf2205$var$gsap = window.gsap) && $f075d17102cf2205$var$gsap.registerPlugin && $f075d17102cf2205$var$gsap;
}, $f075d17102cf2205$var$_isViewport = function _isViewport(e) {
    return !!~$f075d17102cf2205$var$_root.indexOf(e);
}, $f075d17102cf2205$var$_getViewportDimension = function _getViewportDimension(dimensionProperty) {
    return (dimensionProperty === "Height" ? $f075d17102cf2205$var$_100vh : $f075d17102cf2205$var$_win["inner" + dimensionProperty]) || $f075d17102cf2205$var$_docEl["client" + dimensionProperty] || $f075d17102cf2205$var$_body["client" + dimensionProperty];
}, $f075d17102cf2205$var$_getBoundsFunc = function _getBoundsFunc(element) {
    return (0, $a52c0798f59d4093$export$6078f1ef08b38af9)(element, "getBoundingClientRect") || ($f075d17102cf2205$var$_isViewport(element) ? function() {
        $f075d17102cf2205$var$_winOffsets.width = $f075d17102cf2205$var$_win.innerWidth;
        $f075d17102cf2205$var$_winOffsets.height = $f075d17102cf2205$var$_100vh;
        return $f075d17102cf2205$var$_winOffsets;
    } : function() {
        return $f075d17102cf2205$var$_getBounds(element);
    });
}, $f075d17102cf2205$var$_getSizeFunc = function _getSizeFunc(scroller, isViewport, _ref) {
    var d = _ref.d, d2 = _ref.d2, a = _ref.a;
    return (a = (0, $a52c0798f59d4093$export$6078f1ef08b38af9)(scroller, "getBoundingClientRect")) ? function() {
        return a()[d];
    } : function() {
        return (isViewport ? $f075d17102cf2205$var$_getViewportDimension(d2) : scroller["client" + d2]) || 0;
    };
}, $f075d17102cf2205$var$_getOffsetsFunc = function _getOffsetsFunc(element, isViewport) {
    return !isViewport || ~(0, $a52c0798f59d4093$export$d8e56d510a804d0a).indexOf(element) ? $f075d17102cf2205$var$_getBoundsFunc(element) : function() {
        return $f075d17102cf2205$var$_winOffsets;
    };
}, $f075d17102cf2205$var$_maxScroll = function _maxScroll(element, _ref2) {
    var s = _ref2.s, d2 = _ref2.d2, d = _ref2.d, a = _ref2.a;
    return Math.max(0, (s = "scroll" + d2, a = (0, $a52c0798f59d4093$export$6078f1ef08b38af9)(element, s)) ? a() - $f075d17102cf2205$var$_getBoundsFunc(element)()[d] : $f075d17102cf2205$var$_isViewport(element) ? ($f075d17102cf2205$var$_docEl[s] || $f075d17102cf2205$var$_body[s]) - $f075d17102cf2205$var$_getViewportDimension(d2) : element[s] - element["offset" + d2]);
}, $f075d17102cf2205$var$_iterateAutoRefresh = function _iterateAutoRefresh(func, events) {
    for(var i = 0; i < $f075d17102cf2205$var$_autoRefresh.length; i += 3)(!events || ~events.indexOf($f075d17102cf2205$var$_autoRefresh[i + 1])) && func($f075d17102cf2205$var$_autoRefresh[i], $f075d17102cf2205$var$_autoRefresh[i + 1], $f075d17102cf2205$var$_autoRefresh[i + 2]);
}, $f075d17102cf2205$var$_isString = function _isString(value) {
    return typeof value === "string";
}, $f075d17102cf2205$var$_isFunction = function _isFunction(value) {
    return typeof value === "function";
}, $f075d17102cf2205$var$_isNumber = function _isNumber(value) {
    return typeof value === "number";
}, $f075d17102cf2205$var$_isObject = function _isObject(value) {
    return typeof value === "object";
}, $f075d17102cf2205$var$_endAnimation = function _endAnimation(animation, reversed, pause) {
    return animation && animation.progress(reversed ? 0 : 1) && pause && animation.pause();
}, $f075d17102cf2205$var$_callback = function _callback(self, func) {
    if (self.enabled) {
        var result = func(self);
        result && result.totalTime && (self.callbackAnimation = result);
    }
}, $f075d17102cf2205$var$_abs = Math.abs, $f075d17102cf2205$var$_left = "left", $f075d17102cf2205$var$_top = "top", $f075d17102cf2205$var$_right = "right", $f075d17102cf2205$var$_bottom = "bottom", $f075d17102cf2205$var$_width = "width", $f075d17102cf2205$var$_height = "height", $f075d17102cf2205$var$_Right = "Right", $f075d17102cf2205$var$_Left = "Left", $f075d17102cf2205$var$_Top = "Top", $f075d17102cf2205$var$_Bottom = "Bottom", $f075d17102cf2205$var$_padding = "padding", $f075d17102cf2205$var$_margin = "margin", $f075d17102cf2205$var$_Width = "Width", $f075d17102cf2205$var$_Height = "Height", $f075d17102cf2205$var$_px = "px", $f075d17102cf2205$var$_getComputedStyle = function _getComputedStyle(element) {
    return $f075d17102cf2205$var$_win.getComputedStyle(element);
}, $f075d17102cf2205$var$_makePositionable = function _makePositionable(element) {
    // if the element already has position: absolute or fixed, leave that, otherwise make it position: relative
    var position = $f075d17102cf2205$var$_getComputedStyle(element).position;
    element.style.position = position === "absolute" || position === "fixed" ? position : "relative";
}, $f075d17102cf2205$var$_setDefaults = function _setDefaults(obj, defaults) {
    for(var p in defaults)p in obj || (obj[p] = defaults[p]);
    return obj;
}, $f075d17102cf2205$var$_getBounds = function _getBounds(element, withoutTransforms) {
    var tween = withoutTransforms && $f075d17102cf2205$var$_getComputedStyle(element)[$f075d17102cf2205$var$_transformProp] !== "matrix(1, 0, 0, 1, 0, 0)" && $f075d17102cf2205$var$gsap.to(element, {
        x: 0,
        y: 0,
        xPercent: 0,
        yPercent: 0,
        rotation: 0,
        rotationX: 0,
        rotationY: 0,
        scale: 1,
        skewX: 0,
        skewY: 0
    }).progress(1), bounds = element.getBoundingClientRect();
    tween && tween.progress(0).kill();
    return bounds;
}, $f075d17102cf2205$var$_getSize = function _getSize(element, _ref3) {
    var d2 = _ref3.d2;
    return element["offset" + d2] || element["client" + d2] || 0;
}, $f075d17102cf2205$var$_getLabelRatioArray = function _getLabelRatioArray(timeline) {
    var a = [], labels = timeline.labels, duration = timeline.duration(), p;
    for(p in labels)a.push(labels[p] / duration);
    return a;
}, $f075d17102cf2205$var$_getClosestLabel = function _getClosestLabel(animation) {
    return function(value) {
        return $f075d17102cf2205$var$gsap.utils.snap($f075d17102cf2205$var$_getLabelRatioArray(animation), value);
    };
}, $f075d17102cf2205$var$_snapDirectional = function _snapDirectional(snapIncrementOrArray) {
    var snap = $f075d17102cf2205$var$gsap.utils.snap(snapIncrementOrArray), a = Array.isArray(snapIncrementOrArray) && snapIncrementOrArray.slice(0).sort(function(a, b) {
        return a - b;
    });
    return a ? function(value, direction, threshold) {
        if (threshold === void 0) threshold = 1e-3;
        var i;
        if (!direction) return snap(value);
        if (direction > 0) {
            value -= threshold; // to avoid rounding errors. If we're too strict, it might snap forward, then immediately again, and again.
            for(i = 0; i < a.length; i++){
                if (a[i] >= value) return a[i];
            }
            return a[i - 1];
        } else {
            i = a.length;
            value += threshold;
            while(i--){
                if (a[i] <= value) return a[i];
            }
        }
        return a[0];
    } : function(value, direction, threshold) {
        if (threshold === void 0) threshold = 1e-3;
        var snapped = snap(value);
        return !direction || Math.abs(snapped - value) < threshold || snapped - value < 0 === direction < 0 ? snapped : snap(direction < 0 ? value - snapIncrementOrArray : value + snapIncrementOrArray);
    };
}, $f075d17102cf2205$var$_getLabelAtDirection = function _getLabelAtDirection(timeline) {
    return function(value, st) {
        return $f075d17102cf2205$var$_snapDirectional($f075d17102cf2205$var$_getLabelRatioArray(timeline))(value, st.direction);
    };
}, $f075d17102cf2205$var$_multiListener = function _multiListener(func, element, types, callback) {
    return types.split(",").forEach(function(type) {
        return func(element, type, callback);
    });
}, $f075d17102cf2205$var$_addListener = function _addListener(element, type, func, nonPassive, capture) {
    return element.addEventListener(type, func, {
        passive: !nonPassive,
        capture: !!capture
    });
}, $f075d17102cf2205$var$_removeListener = function _removeListener(element, type, func, capture) {
    return element.removeEventListener(type, func, !!capture);
}, $f075d17102cf2205$var$_wheelListener = function _wheelListener(func, el, scrollFunc) {
    scrollFunc = scrollFunc && scrollFunc.wheelHandler;
    if (scrollFunc) {
        func(el, "wheel", scrollFunc);
        func(el, "touchmove", scrollFunc);
    }
}, $f075d17102cf2205$var$_markerDefaults = {
    startColor: "green",
    endColor: "red",
    indent: 0,
    fontSize: "16px",
    fontWeight: "normal"
}, $f075d17102cf2205$var$_defaults = {
    toggleActions: "play",
    anticipatePin: 0
}, $f075d17102cf2205$var$_keywords = {
    top: 0,
    left: 0,
    center: 0.5,
    bottom: 1,
    right: 1
}, $f075d17102cf2205$var$_offsetToPx = function _offsetToPx(value, size) {
    if ($f075d17102cf2205$var$_isString(value)) {
        var eqIndex = value.indexOf("="), relative = ~eqIndex ? +(value.charAt(eqIndex - 1) + 1) * parseFloat(value.substr(eqIndex + 1)) : 0;
        if (~eqIndex) {
            value.indexOf("%") > eqIndex && (relative *= size / 100);
            value = value.substr(0, eqIndex - 1);
        }
        value = relative + (value in $f075d17102cf2205$var$_keywords ? $f075d17102cf2205$var$_keywords[value] * size : ~value.indexOf("%") ? parseFloat(value) * size / 100 : parseFloat(value) || 0);
    }
    return value;
}, $f075d17102cf2205$var$_createMarker = function _createMarker(type, name, container, direction, _ref4, offset, matchWidthEl, containerAnimation) {
    var startColor = _ref4.startColor, endColor = _ref4.endColor, fontSize = _ref4.fontSize, indent = _ref4.indent, fontWeight = _ref4.fontWeight;
    var e = $f075d17102cf2205$var$_doc.createElement("div"), useFixedPosition = $f075d17102cf2205$var$_isViewport(container) || (0, $a52c0798f59d4093$export$6078f1ef08b38af9)(container, "pinType") === "fixed", isScroller = type.indexOf("scroller") !== -1, parent = useFixedPosition ? $f075d17102cf2205$var$_body : container, isStart = type.indexOf("start") !== -1, color = isStart ? startColor : endColor, css = "border-color:" + color + ";font-size:" + fontSize + ";color:" + color + ";font-weight:" + fontWeight + ";pointer-events:none;white-space:nowrap;font-family:sans-serif,Arial;z-index:1000;padding:4px 8px;border-width:0;border-style:solid;";
    css += "position:" + ((isScroller || containerAnimation) && useFixedPosition ? "fixed;" : "absolute;");
    (isScroller || containerAnimation || !useFixedPosition) && (css += (direction === (0, $a52c0798f59d4093$export$8e40fc98ff518e9d) ? $f075d17102cf2205$var$_right : $f075d17102cf2205$var$_bottom) + ":" + (offset + parseFloat(indent)) + "px;");
    matchWidthEl && (css += "box-sizing:border-box;text-align:left;width:" + matchWidthEl.offsetWidth + "px;");
    e._isStart = isStart;
    e.setAttribute("class", "gsap-marker-" + type + (name ? " marker-" + name : ""));
    e.style.cssText = css;
    e.innerText = name || name === 0 ? type + "-" + name : type;
    parent.children[0] ? parent.insertBefore(e, parent.children[0]) : parent.appendChild(e);
    e._offset = e["offset" + direction.op.d2];
    $f075d17102cf2205$var$_positionMarker(e, 0, direction, isStart);
    return e;
}, $f075d17102cf2205$var$_positionMarker = function _positionMarker(marker, start, direction, flipped) {
    var vars = {
        display: "block"
    }, side = direction[flipped ? "os2" : "p2"], oppositeSide = direction[flipped ? "p2" : "os2"];
    marker._isFlipped = flipped;
    vars[direction.a + "Percent"] = flipped ? -100 : 0;
    vars[direction.a] = flipped ? "1px" : 0;
    vars["border" + side + $f075d17102cf2205$var$_Width] = 1;
    vars["border" + oppositeSide + $f075d17102cf2205$var$_Width] = 0;
    vars[direction.p] = start + "px";
    $f075d17102cf2205$var$gsap.set(marker, vars);
}, $f075d17102cf2205$var$_triggers = [], $f075d17102cf2205$var$_ids = {}, $f075d17102cf2205$var$_rafID, $f075d17102cf2205$var$_sync = function _sync() {
    return $f075d17102cf2205$var$_getTime() - $f075d17102cf2205$var$_lastScrollTime > 34 && ($f075d17102cf2205$var$_rafID || ($f075d17102cf2205$var$_rafID = requestAnimationFrame($f075d17102cf2205$var$_updateAll)));
}, $f075d17102cf2205$var$_onScroll = function _onScroll() {
    // previously, we tried to optimize performance by batching/deferring to the next requestAnimationFrame(), but discovered that Safari has a few bugs that make this unworkable (especially on iOS). See https://codepen.io/GreenSock/pen/16c435b12ef09c38125204818e7b45fc?editors=0010 and https://codepen.io/GreenSock/pen/JjOxYpQ/3dd65ccec5a60f1d862c355d84d14562?editors=0010 and https://codepen.io/GreenSock/pen/ExbrPNa/087cef197dc35445a0951e8935c41503?editors=0010
    if (!$f075d17102cf2205$var$_normalizer || !$f075d17102cf2205$var$_normalizer.isPressed || $f075d17102cf2205$var$_normalizer.startX > $f075d17102cf2205$var$_body.clientWidth) {
        // if the user is dragging the scrollbar, allow it.
        (0, $a52c0798f59d4093$export$3cd1cee43d19b683).cache++;
        if ($f075d17102cf2205$var$_normalizer) $f075d17102cf2205$var$_rafID || ($f075d17102cf2205$var$_rafID = requestAnimationFrame($f075d17102cf2205$var$_updateAll));
        else $f075d17102cf2205$var$_updateAll(); // Safari in particular (on desktop) NEEDS the immediate update rather than waiting for a requestAnimationFrame() whereas iOS seems to benefit from waiting for the requestAnimationFrame() tick, at least when normalizing. See https://codepen.io/GreenSock/pen/qBYozqO?editors=0110
        $f075d17102cf2205$var$_lastScrollTime || $f075d17102cf2205$var$_dispatch("scrollStart");
        $f075d17102cf2205$var$_lastScrollTime = $f075d17102cf2205$var$_getTime();
    }
}, $f075d17102cf2205$var$_setBaseDimensions = function _setBaseDimensions() {
    $f075d17102cf2205$var$_baseScreenWidth = $f075d17102cf2205$var$_win.innerWidth;
    $f075d17102cf2205$var$_baseScreenHeight = $f075d17102cf2205$var$_win.innerHeight;
}, $f075d17102cf2205$var$_onResize = function _onResize() {
    (0, $a52c0798f59d4093$export$3cd1cee43d19b683).cache++;
    !$f075d17102cf2205$var$_refreshing && !$f075d17102cf2205$var$_ignoreResize && !$f075d17102cf2205$var$_doc.fullscreenElement && !$f075d17102cf2205$var$_doc.webkitFullscreenElement && (!$f075d17102cf2205$var$_ignoreMobileResize || $f075d17102cf2205$var$_baseScreenWidth !== $f075d17102cf2205$var$_win.innerWidth || Math.abs($f075d17102cf2205$var$_win.innerHeight - $f075d17102cf2205$var$_baseScreenHeight) > $f075d17102cf2205$var$_win.innerHeight * 0.25) && $f075d17102cf2205$var$_resizeDelay.restart(true);
}, // ignore resizes triggered by refresh()
$f075d17102cf2205$var$_listeners = {}, $f075d17102cf2205$var$_emptyArray = [], $f075d17102cf2205$var$_softRefresh = function _softRefresh() {
    return $f075d17102cf2205$var$_removeListener($f075d17102cf2205$export$875bcbe48555930, "scrollEnd", _softRefresh) || $f075d17102cf2205$var$_refreshAll(true);
}, $f075d17102cf2205$var$_dispatch = function _dispatch(type) {
    return $f075d17102cf2205$var$_listeners[type] && $f075d17102cf2205$var$_listeners[type].map(function(f) {
        return f();
    }) || $f075d17102cf2205$var$_emptyArray;
}, $f075d17102cf2205$var$_savedStyles = [], // when ScrollTrigger.saveStyles() is called, the inline styles are recorded in this Array in a sequential format like [element, cssText, gsCache, media]. This keeps it very memory-efficient and fast to iterate through.
$f075d17102cf2205$var$_revertRecorded = function _revertRecorded(media) {
    for(var i = 0; i < $f075d17102cf2205$var$_savedStyles.length; i += 5)if (!media || $f075d17102cf2205$var$_savedStyles[i + 4] && $f075d17102cf2205$var$_savedStyles[i + 4].query === media) {
        $f075d17102cf2205$var$_savedStyles[i].style.cssText = $f075d17102cf2205$var$_savedStyles[i + 1];
        $f075d17102cf2205$var$_savedStyles[i].getBBox && $f075d17102cf2205$var$_savedStyles[i].setAttribute("transform", $f075d17102cf2205$var$_savedStyles[i + 2] || "");
        $f075d17102cf2205$var$_savedStyles[i + 3].uncache = 1;
    }
}, $f075d17102cf2205$var$_revertAll = function _revertAll(kill, media) {
    var trigger;
    for($f075d17102cf2205$var$_i = 0; $f075d17102cf2205$var$_i < $f075d17102cf2205$var$_triggers.length; $f075d17102cf2205$var$_i++){
        trigger = $f075d17102cf2205$var$_triggers[$f075d17102cf2205$var$_i];
        if (trigger && (!media || trigger._ctx === media)) {
            if (kill) trigger.kill(1);
            else trigger.revert(true, true);
        }
    }
    media && $f075d17102cf2205$var$_revertRecorded(media);
    media || $f075d17102cf2205$var$_dispatch("revert");
}, $f075d17102cf2205$var$_clearScrollMemory = function _clearScrollMemory(scrollRestoration, force) {
    // zero-out all the recorded scroll positions. Don't use _triggers because if, for example, .matchMedia() is used to create some ScrollTriggers and then the user resizes and it removes ALL ScrollTriggers, and then go back to a size where there are ScrollTriggers, it would have kept the position(s) saved from the initial state.
    (0, $a52c0798f59d4093$export$3cd1cee43d19b683).cache++;
    (force || !$f075d17102cf2205$var$_refreshingAll) && (0, $a52c0798f59d4093$export$3cd1cee43d19b683).forEach(function(obj) {
        return $f075d17102cf2205$var$_isFunction(obj) && obj.cacheID++ && (obj.rec = 0);
    });
    $f075d17102cf2205$var$_isString(scrollRestoration) && ($f075d17102cf2205$var$_win.history.scrollRestoration = $f075d17102cf2205$var$_scrollRestoration = scrollRestoration);
}, $f075d17102cf2205$var$_refreshingAll, $f075d17102cf2205$var$_refreshID = 0, $f075d17102cf2205$var$_queueRefreshID, $f075d17102cf2205$var$_queueRefreshAll = function _queueRefreshAll() {
    // we don't want to call _refreshAll() every time we create a new ScrollTrigger (for performance reasons) - it's better to batch them. Some frameworks dynamically load content and we can't rely on the window's "load" or "DOMContentLoaded" events to trigger it.
    if ($f075d17102cf2205$var$_queueRefreshID !== $f075d17102cf2205$var$_refreshID) {
        var id = $f075d17102cf2205$var$_queueRefreshID = $f075d17102cf2205$var$_refreshID;
        requestAnimationFrame(function() {
            return id === $f075d17102cf2205$var$_refreshID && $f075d17102cf2205$var$_refreshAll(true);
        });
    }
}, $f075d17102cf2205$var$_refresh100vh = function _refresh100vh() {
    $f075d17102cf2205$var$_body.appendChild($f075d17102cf2205$var$_div100vh);
    $f075d17102cf2205$var$_100vh = $f075d17102cf2205$var$_div100vh.offsetHeight || $f075d17102cf2205$var$_win.innerHeight;
    $f075d17102cf2205$var$_body.removeChild($f075d17102cf2205$var$_div100vh);
}, $f075d17102cf2205$var$_refreshAll = function _refreshAll(force, skipRevert) {
    if ($f075d17102cf2205$var$_lastScrollTime && !force) {
        $f075d17102cf2205$var$_addListener($f075d17102cf2205$export$875bcbe48555930, "scrollEnd", $f075d17102cf2205$var$_softRefresh);
        return;
    }
    $f075d17102cf2205$var$_refresh100vh();
    $f075d17102cf2205$var$_refreshingAll = $f075d17102cf2205$export$875bcbe48555930.isRefreshing = true;
    (0, $a52c0798f59d4093$export$3cd1cee43d19b683).forEach(function(obj) {
        return $f075d17102cf2205$var$_isFunction(obj) && ++obj.cacheID && (obj.rec = obj());
    }); // force the clearing of the cache because some browsers take a little while to dispatch the "scroll" event and the user may have changed the scroll position and then called ScrollTrigger.refresh() right away
    var refreshInits = $f075d17102cf2205$var$_dispatch("refreshInit");
    $f075d17102cf2205$var$_sort && $f075d17102cf2205$export$875bcbe48555930.sort();
    skipRevert || $f075d17102cf2205$var$_revertAll();
    (0, $a52c0798f59d4093$export$3cd1cee43d19b683).forEach(function(obj) {
        if ($f075d17102cf2205$var$_isFunction(obj)) {
            obj.smooth && (obj.target.style.scrollBehavior = "auto"); // smooth scrolling interferes
            obj(0);
        }
    });
    $f075d17102cf2205$var$_triggers.slice(0).forEach(function(t) {
        return t.refresh();
    }); // don't loop with _i because during a refresh() someone could call ScrollTrigger.update() which would iterate through _i resulting in a skip.
    $f075d17102cf2205$var$_triggers.forEach(function(t, i) {
        // nested pins (pinnedContainer) with pinSpacing may expand the container, so we must accommodate that here.
        if (t._subPinOffset && t.pin) {
            var prop = t.vars.horizontal ? "offsetWidth" : "offsetHeight", original = t.pin[prop];
            t.revert(true, 1);
            t.adjustPinSpacing(t.pin[prop] - original);
            t.refresh();
        }
    });
    $f075d17102cf2205$var$_triggers.forEach(function(t) {
        // the scroller's max scroll position may change after all the ScrollTriggers refreshed (like pinning could push it down), so we need to loop back and correct any with end: "max". Same for anything with a clamped end
        var max = $f075d17102cf2205$var$_maxScroll(t.scroller, t._dir);
        (t.vars.end === "max" || t._endClamp && t.end > max) && t.setPositions(t.start, Math.max(t.start + 1, max), true);
    });
    refreshInits.forEach(function(result) {
        return result && result.render && result.render(-1);
    }); // if the onRefreshInit() returns an animation (typically a gsap.set()), revert it. This makes it easy to put things in a certain spot before refreshing for measurement purposes, and then put things back.
    (0, $a52c0798f59d4093$export$3cd1cee43d19b683).forEach(function(obj) {
        if ($f075d17102cf2205$var$_isFunction(obj)) {
            obj.smooth && requestAnimationFrame(function() {
                return obj.target.style.scrollBehavior = "smooth";
            });
            obj.rec && obj(obj.rec);
        }
    });
    $f075d17102cf2205$var$_clearScrollMemory($f075d17102cf2205$var$_scrollRestoration, 1);
    $f075d17102cf2205$var$_resizeDelay.pause();
    $f075d17102cf2205$var$_refreshID++;
    $f075d17102cf2205$var$_refreshingAll = 2;
    $f075d17102cf2205$var$_updateAll(2);
    $f075d17102cf2205$var$_triggers.forEach(function(t) {
        return $f075d17102cf2205$var$_isFunction(t.vars.onRefresh) && t.vars.onRefresh(t);
    });
    $f075d17102cf2205$var$_refreshingAll = $f075d17102cf2205$export$875bcbe48555930.isRefreshing = false;
    $f075d17102cf2205$var$_dispatch("refresh");
}, $f075d17102cf2205$var$_lastScroll = 0, $f075d17102cf2205$var$_direction = 1, $f075d17102cf2205$var$_primary, $f075d17102cf2205$var$_updateAll = function _updateAll(force) {
    if (!$f075d17102cf2205$var$_refreshingAll || force === 2) {
        $f075d17102cf2205$export$875bcbe48555930.isUpdating = true;
        $f075d17102cf2205$var$_primary && $f075d17102cf2205$var$_primary.update(0); // ScrollSmoother uses refreshPriority -9999 to become the primary that gets updated before all others because it affects the scroll position.
        var l = $f075d17102cf2205$var$_triggers.length, time = $f075d17102cf2205$var$_getTime(), recordVelocity = time - $f075d17102cf2205$var$_time1 >= 50, scroll = l && $f075d17102cf2205$var$_triggers[0].scroll();
        $f075d17102cf2205$var$_direction = $f075d17102cf2205$var$_lastScroll > scroll ? -1 : 1;
        $f075d17102cf2205$var$_refreshingAll || ($f075d17102cf2205$var$_lastScroll = scroll);
        if (recordVelocity) {
            if ($f075d17102cf2205$var$_lastScrollTime && !$f075d17102cf2205$var$_pointerIsDown && time - $f075d17102cf2205$var$_lastScrollTime > 200) {
                $f075d17102cf2205$var$_lastScrollTime = 0;
                $f075d17102cf2205$var$_dispatch("scrollEnd");
            }
            $f075d17102cf2205$var$_time2 = $f075d17102cf2205$var$_time1;
            $f075d17102cf2205$var$_time1 = time;
        }
        if ($f075d17102cf2205$var$_direction < 0) {
            $f075d17102cf2205$var$_i = l;
            while($f075d17102cf2205$var$_i-- > 0)$f075d17102cf2205$var$_triggers[$f075d17102cf2205$var$_i] && $f075d17102cf2205$var$_triggers[$f075d17102cf2205$var$_i].update(0, recordVelocity);
            $f075d17102cf2205$var$_direction = 1;
        } else for($f075d17102cf2205$var$_i = 0; $f075d17102cf2205$var$_i < l; $f075d17102cf2205$var$_i++)$f075d17102cf2205$var$_triggers[$f075d17102cf2205$var$_i] && $f075d17102cf2205$var$_triggers[$f075d17102cf2205$var$_i].update(0, recordVelocity);
        $f075d17102cf2205$export$875bcbe48555930.isUpdating = false;
    }
    $f075d17102cf2205$var$_rafID = 0;
}, $f075d17102cf2205$var$_propNamesToCopy = [
    $f075d17102cf2205$var$_left,
    $f075d17102cf2205$var$_top,
    $f075d17102cf2205$var$_bottom,
    $f075d17102cf2205$var$_right,
    $f075d17102cf2205$var$_margin + $f075d17102cf2205$var$_Bottom,
    $f075d17102cf2205$var$_margin + $f075d17102cf2205$var$_Right,
    $f075d17102cf2205$var$_margin + $f075d17102cf2205$var$_Top,
    $f075d17102cf2205$var$_margin + $f075d17102cf2205$var$_Left,
    "display",
    "flexShrink",
    "float",
    "zIndex",
    "gridColumnStart",
    "gridColumnEnd",
    "gridRowStart",
    "gridRowEnd",
    "gridArea",
    "justifySelf",
    "alignSelf",
    "placeSelf",
    "order"
], $f075d17102cf2205$var$_stateProps = $f075d17102cf2205$var$_propNamesToCopy.concat([
    $f075d17102cf2205$var$_width,
    $f075d17102cf2205$var$_height,
    "boxSizing",
    "max" + $f075d17102cf2205$var$_Width,
    "max" + $f075d17102cf2205$var$_Height,
    "position",
    $f075d17102cf2205$var$_margin,
    $f075d17102cf2205$var$_padding,
    $f075d17102cf2205$var$_padding + $f075d17102cf2205$var$_Top,
    $f075d17102cf2205$var$_padding + $f075d17102cf2205$var$_Right,
    $f075d17102cf2205$var$_padding + $f075d17102cf2205$var$_Bottom,
    $f075d17102cf2205$var$_padding + $f075d17102cf2205$var$_Left
]), $f075d17102cf2205$var$_swapPinOut = function _swapPinOut(pin, spacer, state) {
    $f075d17102cf2205$var$_setState(state);
    var cache = pin._gsap;
    if (cache.spacerIsNative) $f075d17102cf2205$var$_setState(cache.spacerState);
    else if (pin._gsap.swappedIn) {
        var parent = spacer.parentNode;
        if (parent) {
            parent.insertBefore(pin, spacer);
            parent.removeChild(spacer);
        }
    }
    pin._gsap.swappedIn = false;
}, $f075d17102cf2205$var$_swapPinIn = function _swapPinIn(pin, spacer, cs, spacerState) {
    if (!pin._gsap.swappedIn) {
        var i = $f075d17102cf2205$var$_propNamesToCopy.length, spacerStyle = spacer.style, pinStyle = pin.style, p;
        while(i--){
            p = $f075d17102cf2205$var$_propNamesToCopy[i];
            spacerStyle[p] = cs[p];
        }
        spacerStyle.position = cs.position === "absolute" ? "absolute" : "relative";
        cs.display === "inline" && (spacerStyle.display = "inline-block");
        pinStyle[$f075d17102cf2205$var$_bottom] = pinStyle[$f075d17102cf2205$var$_right] = "auto";
        spacerStyle.flexBasis = cs.flexBasis || "auto";
        spacerStyle.overflow = "visible";
        spacerStyle.boxSizing = "border-box";
        spacerStyle[$f075d17102cf2205$var$_width] = $f075d17102cf2205$var$_getSize(pin, (0, $a52c0798f59d4093$export$b2cabb342cb0ebe1)) + $f075d17102cf2205$var$_px;
        spacerStyle[$f075d17102cf2205$var$_height] = $f075d17102cf2205$var$_getSize(pin, (0, $a52c0798f59d4093$export$8e40fc98ff518e9d)) + $f075d17102cf2205$var$_px;
        spacerStyle[$f075d17102cf2205$var$_padding] = pinStyle[$f075d17102cf2205$var$_margin] = pinStyle[$f075d17102cf2205$var$_top] = pinStyle[$f075d17102cf2205$var$_left] = "0";
        $f075d17102cf2205$var$_setState(spacerState);
        pinStyle[$f075d17102cf2205$var$_width] = pinStyle["max" + $f075d17102cf2205$var$_Width] = cs[$f075d17102cf2205$var$_width];
        pinStyle[$f075d17102cf2205$var$_height] = pinStyle["max" + $f075d17102cf2205$var$_Height] = cs[$f075d17102cf2205$var$_height];
        pinStyle[$f075d17102cf2205$var$_padding] = cs[$f075d17102cf2205$var$_padding];
        if (pin.parentNode !== spacer) {
            pin.parentNode.insertBefore(spacer, pin);
            spacer.appendChild(pin);
        }
        pin._gsap.swappedIn = true;
    }
}, $f075d17102cf2205$var$_capsExp = /([A-Z])/g, $f075d17102cf2205$var$_setState = function _setState(state) {
    if (state) {
        var style = state.t.style, l = state.length, i = 0, p, value;
        (state.t._gsap || $f075d17102cf2205$var$gsap.core.getCache(state.t)).uncache = 1; // otherwise transforms may be off
        for(; i < l; i += 2){
            value = state[i + 1];
            p = state[i];
            if (value) style[p] = value;
            else if (style[p]) style.removeProperty(p.replace($f075d17102cf2205$var$_capsExp, "-$1").toLowerCase());
        }
    }
}, $f075d17102cf2205$var$_getState = function _getState(element) {
    // returns an Array with alternating values like [property, value, property, value] and a "t" property pointing to the target (element). Makes it fast and cheap.
    var l = $f075d17102cf2205$var$_stateProps.length, style = element.style, state = [], i = 0;
    for(; i < l; i++)state.push($f075d17102cf2205$var$_stateProps[i], style[$f075d17102cf2205$var$_stateProps[i]]);
    state.t = element;
    return state;
}, $f075d17102cf2205$var$_copyState = function _copyState(state, override, omitOffsets) {
    var result = [], l = state.length, i = omitOffsets ? 8 : 0, // skip top, left, right, bottom if omitOffsets is true
    p;
    for(; i < l; i += 2){
        p = state[i];
        result.push(p, p in override ? override[p] : state[i + 1]);
    }
    result.t = state.t;
    return result;
}, $f075d17102cf2205$var$_winOffsets = {
    left: 0,
    top: 0
}, // // potential future feature (?) Allow users to calculate where a trigger hits (scroll position) like getScrollPosition("#id", "top bottom")
// _getScrollPosition = (trigger, position, {scroller, containerAnimation, horizontal}) => {
// 	scroller = _getTarget(scroller || _win);
// 	let direction = horizontal ? _horizontal : _vertical,
// 		isViewport = _isViewport(scroller);
// 	_getSizeFunc(scroller, isViewport, direction);
// 	return _parsePosition(position, _getTarget(trigger), _getSizeFunc(scroller, isViewport, direction)(), direction, _getScrollFunc(scroller, direction)(), 0, 0, 0, _getOffsetsFunc(scroller, isViewport)(), isViewport ? 0 : parseFloat(_getComputedStyle(scroller)["border" + direction.p2 + _Width]) || 0, 0, containerAnimation ? containerAnimation.duration() : _maxScroll(scroller), containerAnimation);
// },
$f075d17102cf2205$var$_parsePosition = function _parsePosition(value, trigger, scrollerSize, direction, scroll, marker, markerScroller, self, scrollerBounds, borderWidth, useFixedPosition, scrollerMax, containerAnimation, clampZeroProp) {
    $f075d17102cf2205$var$_isFunction(value) && (value = value(self));
    if ($f075d17102cf2205$var$_isString(value) && value.substr(0, 3) === "max") value = scrollerMax + (value.charAt(4) === "=" ? $f075d17102cf2205$var$_offsetToPx("0" + value.substr(3), scrollerSize) : 0);
    var time = containerAnimation ? containerAnimation.time() : 0, p1, p2, element;
    containerAnimation && containerAnimation.seek(0);
    isNaN(value) || (value = +value); // convert a string number like "45" to an actual number
    if (!$f075d17102cf2205$var$_isNumber(value)) {
        $f075d17102cf2205$var$_isFunction(trigger) && (trigger = trigger(self));
        var offsets = (value || "0").split(" "), bounds, localOffset, globalOffset, display;
        element = (0, $a52c0798f59d4093$export$937374fea3f88711)(trigger, self) || $f075d17102cf2205$var$_body;
        bounds = $f075d17102cf2205$var$_getBounds(element) || {};
        if ((!bounds || !bounds.left && !bounds.top) && $f075d17102cf2205$var$_getComputedStyle(element).display === "none") {
            // if display is "none", it won't report getBoundingClientRect() properly
            display = element.style.display;
            element.style.display = "block";
            bounds = $f075d17102cf2205$var$_getBounds(element);
            display ? element.style.display = display : element.style.removeProperty("display");
        }
        localOffset = $f075d17102cf2205$var$_offsetToPx(offsets[0], bounds[direction.d]);
        globalOffset = $f075d17102cf2205$var$_offsetToPx(offsets[1] || "0", scrollerSize);
        value = bounds[direction.p] - scrollerBounds[direction.p] - borderWidth + localOffset + scroll - globalOffset;
        markerScroller && $f075d17102cf2205$var$_positionMarker(markerScroller, globalOffset, direction, scrollerSize - globalOffset < 20 || markerScroller._isStart && globalOffset > 20);
        scrollerSize -= scrollerSize - globalOffset; // adjust for the marker
    } else {
        containerAnimation && (value = $f075d17102cf2205$var$gsap.utils.mapRange(containerAnimation.scrollTrigger.start, containerAnimation.scrollTrigger.end, 0, scrollerMax, value));
        markerScroller && $f075d17102cf2205$var$_positionMarker(markerScroller, scrollerSize, direction, true);
    }
    if (clampZeroProp) {
        self[clampZeroProp] = value || -0.001;
        value < 0 && (value = 0);
    }
    if (marker) {
        var position = value + scrollerSize, isStart = marker._isStart;
        p1 = "scroll" + direction.d2;
        $f075d17102cf2205$var$_positionMarker(marker, position, direction, isStart && position > 20 || !isStart && (useFixedPosition ? Math.max($f075d17102cf2205$var$_body[p1], $f075d17102cf2205$var$_docEl[p1]) : marker.parentNode[p1]) <= position + 1);
        if (useFixedPosition) {
            scrollerBounds = $f075d17102cf2205$var$_getBounds(markerScroller);
            useFixedPosition && (marker.style[direction.op.p] = scrollerBounds[direction.op.p] - direction.op.m - marker._offset + $f075d17102cf2205$var$_px);
        }
    }
    if (containerAnimation && element) {
        p1 = $f075d17102cf2205$var$_getBounds(element);
        containerAnimation.seek(scrollerMax);
        p2 = $f075d17102cf2205$var$_getBounds(element);
        containerAnimation._caScrollDist = p1[direction.p] - p2[direction.p];
        value = value / containerAnimation._caScrollDist * scrollerMax;
    }
    containerAnimation && containerAnimation.seek(time);
    return containerAnimation ? value : Math.round(value);
}, $f075d17102cf2205$var$_prefixExp = /(webkit|moz|length|cssText|inset)/i, $f075d17102cf2205$var$_reparent = function _reparent(element, parent, top, left) {
    if (element.parentNode !== parent) {
        var style = element.style, p, cs;
        if (parent === $f075d17102cf2205$var$_body) {
            element._stOrig = style.cssText; // record original inline styles so we can revert them later
            cs = $f075d17102cf2205$var$_getComputedStyle(element);
            for(p in cs)// must copy all relevant styles to ensure that nothing changes visually when we reparent to the <body>. Skip the vendor prefixed ones.
            if (!+p && !$f075d17102cf2205$var$_prefixExp.test(p) && cs[p] && typeof style[p] === "string" && p !== "0") style[p] = cs[p];
            style.top = top;
            style.left = left;
        } else style.cssText = element._stOrig;
        $f075d17102cf2205$var$gsap.core.getCache(element).uncache = 1;
        parent.appendChild(element);
    }
}, $f075d17102cf2205$var$_interruptionTracker = function _interruptionTracker(getValueFunc, initialValue, onInterrupt) {
    var last1 = initialValue, last2 = last1;
    return function(value) {
        var current = Math.round(getValueFunc()); // round because in some [very uncommon] Windows environments, scroll can get reported with decimals even though it was set without.
        if (current !== last1 && current !== last2 && Math.abs(current - last1) > 3 && Math.abs(current - last2) > 3) {
            // if the user scrolls, kill the tween. iOS Safari intermittently misreports the scroll position, it may be the most recently-set one or the one before that! When Safari is zoomed (CMD-+), it often misreports as 1 pixel off too! So if we set the scroll position to 125, for example, it'll actually report it as 124.
            value = current;
            onInterrupt && onInterrupt();
        }
        last2 = last1;
        last1 = value;
        return value;
    };
}, $f075d17102cf2205$var$_shiftMarker = function _shiftMarker(marker, direction, value) {
    var vars = {};
    vars[direction.p] = "+=" + value;
    $f075d17102cf2205$var$gsap.set(marker, vars);
}, // _mergeAnimations = animations => {
// 	let tl = gsap.timeline({smoothChildTiming: true}).startTime(Math.min(...animations.map(a => a.globalTime(0))));
// 	animations.forEach(a => {let time = a.totalTime(); tl.add(a); a.totalTime(time); });
// 	tl.smoothChildTiming = false;
// 	return tl;
// },
// returns a function that can be used to tween the scroll position in the direction provided, and when doing so it'll add a .tween property to the FUNCTION itself, and remove it when the tween completes or gets killed. This gives us a way to have multiple ScrollTriggers use a central function for any given scroller and see if there's a scroll tween running (which would affect if/how things get updated)
$f075d17102cf2205$var$_getTweenCreator = function _getTweenCreator(scroller, direction) {
    var getScroll = (0, $a52c0798f59d4093$export$8665aac53dad5647)(scroller, direction), prop = "_scroll" + direction.p2, // add a tweenable property to the scroller that's a getter/setter function, like _scrollTop or _scrollLeft. This way, if someone does gsap.killTweensOf(scroller) it'll kill the scroll tween.
    getTween = function getTween(scrollTo, vars, initialValue, change1, change2) {
        var tween = getTween.tween, onComplete = vars.onComplete, modifiers = {};
        initialValue = initialValue || getScroll();
        var checkForInterruption = $f075d17102cf2205$var$_interruptionTracker(getScroll, initialValue, function() {
            tween.kill();
            getTween.tween = 0;
        });
        change2 = change1 && change2 || 0; // if change1 is 0, we set that to the difference and ignore change2. Otherwise, there would be a compound effect.
        change1 = change1 || scrollTo - initialValue;
        tween && tween.kill();
        vars[prop] = scrollTo;
        vars.modifiers = modifiers;
        modifiers[prop] = function() {
            return checkForInterruption(initialValue + change1 * tween.ratio + change2 * tween.ratio * tween.ratio);
        };
        vars.onUpdate = function() {
            (0, $a52c0798f59d4093$export$3cd1cee43d19b683).cache++;
            $f075d17102cf2205$var$_updateAll();
        };
        vars.onComplete = function() {
            getTween.tween = 0;
            onComplete && onComplete.call(tween);
        };
        tween = getTween.tween = $f075d17102cf2205$var$gsap.to(scroller, vars);
        return tween;
    };
    scroller[prop] = getScroll;
    getScroll.wheelHandler = function() {
        return getTween.tween && getTween.tween.kill() && (getTween.tween = 0);
    };
    $f075d17102cf2205$var$_addListener(scroller, "wheel", getScroll.wheelHandler); // Windows machines handle mousewheel scrolling in chunks (like "3 lines per scroll") meaning the typical strategy for cancelling the scroll isn't as sensitive. It's much more likely to match one of the previous 2 scroll event positions. So we kill any snapping as soon as there's a wheel event.
    $f075d17102cf2205$export$875bcbe48555930.isTouch && $f075d17102cf2205$var$_addListener(scroller, "touchmove", getScroll.wheelHandler);
    return getTween;
};
var $f075d17102cf2205$export$875bcbe48555930 = /*#__PURE__*/ function() {
    function ScrollTrigger(vars, animation) {
        $f075d17102cf2205$var$_coreInitted || ScrollTrigger.register($f075d17102cf2205$var$gsap) || console.warn("Please gsap.registerPlugin(ScrollTrigger)");
        $f075d17102cf2205$var$_context(this);
        this.init(vars, animation);
    }
    var _proto = ScrollTrigger.prototype;
    _proto.init = function init(vars, animation) {
        this.progress = this.start = 0;
        this.vars && this.kill(true, true); // in case it's being initted again
        if (!$f075d17102cf2205$var$_enabled) {
            this.update = this.refresh = this.kill = $f075d17102cf2205$var$_passThrough;
            return;
        }
        vars = $f075d17102cf2205$var$_setDefaults($f075d17102cf2205$var$_isString(vars) || $f075d17102cf2205$var$_isNumber(vars) || vars.nodeType ? {
            trigger: vars
        } : vars, $f075d17102cf2205$var$_defaults);
        var _vars = vars, onUpdate = _vars.onUpdate, toggleClass = _vars.toggleClass, id = _vars.id, onToggle = _vars.onToggle, onRefresh = _vars.onRefresh, scrub = _vars.scrub, trigger = _vars.trigger, pin = _vars.pin, pinSpacing = _vars.pinSpacing, invalidateOnRefresh = _vars.invalidateOnRefresh, anticipatePin = _vars.anticipatePin, onScrubComplete = _vars.onScrubComplete, onSnapComplete = _vars.onSnapComplete, once = _vars.once, snap = _vars.snap, pinReparent = _vars.pinReparent, pinSpacer = _vars.pinSpacer, containerAnimation = _vars.containerAnimation, fastScrollEnd = _vars.fastScrollEnd, preventOverlaps = _vars.preventOverlaps, direction = vars.horizontal || vars.containerAnimation && vars.horizontal !== false ? (0, $a52c0798f59d4093$export$b2cabb342cb0ebe1) : (0, $a52c0798f59d4093$export$8e40fc98ff518e9d), isToggle = !scrub && scrub !== 0, scroller = (0, $a52c0798f59d4093$export$937374fea3f88711)(vars.scroller || $f075d17102cf2205$var$_win), scrollerCache = $f075d17102cf2205$var$gsap.core.getCache(scroller), isViewport = $f075d17102cf2205$var$_isViewport(scroller), useFixedPosition = ("pinType" in vars ? vars.pinType : (0, $a52c0798f59d4093$export$6078f1ef08b38af9)(scroller, "pinType") || isViewport && "fixed") === "fixed", callbacks = [
            vars.onEnter,
            vars.onLeave,
            vars.onEnterBack,
            vars.onLeaveBack
        ], toggleActions = isToggle && vars.toggleActions.split(" "), markers = "markers" in vars ? vars.markers : $f075d17102cf2205$var$_defaults.markers, borderWidth = isViewport ? 0 : parseFloat($f075d17102cf2205$var$_getComputedStyle(scroller)["border" + direction.p2 + $f075d17102cf2205$var$_Width]) || 0, self = this, onRefreshInit = vars.onRefreshInit && function() {
            return vars.onRefreshInit(self);
        }, getScrollerSize = $f075d17102cf2205$var$_getSizeFunc(scroller, isViewport, direction), getScrollerOffsets = $f075d17102cf2205$var$_getOffsetsFunc(scroller, isViewport), lastSnap = 0, lastRefresh = 0, prevProgress = 0, scrollFunc = (0, $a52c0798f59d4093$export$8665aac53dad5647)(scroller, direction), tweenTo, pinCache, snapFunc, scroll1, scroll2, start, end, markerStart, markerEnd, markerStartTrigger, markerEndTrigger, markerVars, executingOnRefresh, change, pinOriginalState, pinActiveState, pinState, spacer, offset, pinGetter, pinSetter, pinStart, pinChange, spacingStart, spacerState, markerStartSetter, pinMoves, markerEndSetter, cs, snap1, snap2, scrubTween, scrubSmooth, snapDurClamp, snapDelayedCall, prevScroll, prevAnimProgress, caMarkerSetter, customRevertReturn; // for the sake of efficiency, _startClamp/_endClamp serve like a truthy value indicating that clamping was enabled on the start/end, and ALSO store the actual pre-clamped numeric value. We tap into that in ScrollSmoother for speed effects. So for example, if start="clamp(top bottom)" results in a start of -100 naturally, it would get clamped to 0 but -100 would be stored in _startClamp.
        self._startClamp = self._endClamp = false;
        self._dir = direction;
        anticipatePin *= 45;
        self.scroller = scroller;
        self.scroll = containerAnimation ? containerAnimation.time.bind(containerAnimation) : scrollFunc;
        scroll1 = scrollFunc();
        self.vars = vars;
        animation = animation || vars.animation;
        if ("refreshPriority" in vars) {
            $f075d17102cf2205$var$_sort = 1;
            vars.refreshPriority === -9999 && ($f075d17102cf2205$var$_primary = self); // used by ScrollSmoother
        }
        scrollerCache.tweenScroll = scrollerCache.tweenScroll || {
            top: $f075d17102cf2205$var$_getTweenCreator(scroller, (0, $a52c0798f59d4093$export$8e40fc98ff518e9d)),
            left: $f075d17102cf2205$var$_getTweenCreator(scroller, (0, $a52c0798f59d4093$export$b2cabb342cb0ebe1))
        };
        self.tweenTo = tweenTo = scrollerCache.tweenScroll[direction.p];
        self.scrubDuration = function(value) {
            scrubSmooth = $f075d17102cf2205$var$_isNumber(value) && value;
            if (!scrubSmooth) {
                scrubTween && scrubTween.progress(1).kill();
                scrubTween = 0;
            } else scrubTween ? scrubTween.duration(value) : scrubTween = $f075d17102cf2205$var$gsap.to(animation, {
                ease: "expo",
                totalProgress: "+=0",
                duration: scrubSmooth,
                paused: true,
                onComplete: function onComplete() {
                    return onScrubComplete && onScrubComplete(self);
                }
            });
        };
        if (animation) {
            animation.vars.lazy = false;
            animation._initted && !self.isReverted || animation.vars.immediateRender !== false && vars.immediateRender !== false && animation.duration() && animation.render(0, true, true); // special case: if this ScrollTrigger gets re-initted, a from() tween with a stagger could get initted initially and then reverted on the re-init which means it'll need to get rendered again here to properly display things. Otherwise, See https://greensock.com/forums/topic/36777-scrollsmoother-splittext-nextjs/ and https://codepen.io/GreenSock/pen/eYPyPpd?editors=0010
            self.animation = animation.pause();
            animation.scrollTrigger = self;
            self.scrubDuration(scrub);
            snap1 = 0;
            id || (id = animation.vars.id);
        }
        if (snap) {
            // TODO: potential idea: use legitimate CSS scroll snapping by pushing invisible elements into the DOM that serve as snap positions, and toggle the document.scrollingElement.style.scrollSnapType onToggle. See https://codepen.io/GreenSock/pen/JjLrgWM for a quick proof of concept.
            if (!$f075d17102cf2205$var$_isObject(snap) || snap.push) snap = {
                snapTo: snap
            };
            "scrollBehavior" in $f075d17102cf2205$var$_body.style && $f075d17102cf2205$var$gsap.set(isViewport ? [
                $f075d17102cf2205$var$_body,
                $f075d17102cf2205$var$_docEl
            ] : scroller, {
                scrollBehavior: "auto"
            }); // smooth scrolling doesn't work with snap.
            (0, $a52c0798f59d4093$export$3cd1cee43d19b683).forEach(function(o) {
                return $f075d17102cf2205$var$_isFunction(o) && o.target === (isViewport ? $f075d17102cf2205$var$_doc.scrollingElement || $f075d17102cf2205$var$_docEl : scroller) && (o.smooth = false);
            }); // note: set smooth to false on both the vertical and horizontal scroll getters/setters
            snapFunc = $f075d17102cf2205$var$_isFunction(snap.snapTo) ? snap.snapTo : snap.snapTo === "labels" ? $f075d17102cf2205$var$_getClosestLabel(animation) : snap.snapTo === "labelsDirectional" ? $f075d17102cf2205$var$_getLabelAtDirection(animation) : snap.directional !== false ? function(value, st) {
                return $f075d17102cf2205$var$_snapDirectional(snap.snapTo)(value, $f075d17102cf2205$var$_getTime() - lastRefresh < 500 ? 0 : st.direction);
            } : $f075d17102cf2205$var$gsap.utils.snap(snap.snapTo);
            snapDurClamp = snap.duration || {
                min: 0.1,
                max: 2
            };
            snapDurClamp = $f075d17102cf2205$var$_isObject(snapDurClamp) ? $f075d17102cf2205$var$_clamp(snapDurClamp.min, snapDurClamp.max) : $f075d17102cf2205$var$_clamp(snapDurClamp, snapDurClamp);
            snapDelayedCall = $f075d17102cf2205$var$gsap.delayedCall(snap.delay || scrubSmooth / 2 || 0.1, function() {
                var scroll = scrollFunc(), refreshedRecently = $f075d17102cf2205$var$_getTime() - lastRefresh < 500, tween = tweenTo.tween;
                if ((refreshedRecently || Math.abs(self.getVelocity()) < 10) && !tween && !$f075d17102cf2205$var$_pointerIsDown && lastSnap !== scroll) {
                    var progress = (scroll - start) / change, totalProgress = animation && !isToggle ? animation.totalProgress() : progress, velocity = refreshedRecently ? 0 : (totalProgress - snap2) / ($f075d17102cf2205$var$_getTime() - $f075d17102cf2205$var$_time2) * 1000 || 0, change1 = $f075d17102cf2205$var$gsap.utils.clamp(-progress, 1 - progress, $f075d17102cf2205$var$_abs(velocity / 2) * velocity / 0.185), naturalEnd = progress + (snap.inertia === false ? 0 : change1), endValue = $f075d17102cf2205$var$_clamp(0, 1, snapFunc(naturalEnd, self)), endScroll = Math.round(start + endValue * change), _snap = snap, onStart = _snap.onStart, _onInterrupt = _snap.onInterrupt, _onComplete = _snap.onComplete;
                    if (scroll <= end && scroll >= start && endScroll !== scroll) {
                        if (tween && !tween._initted && tween.data <= $f075d17102cf2205$var$_abs(endScroll - scroll)) // there's an overlapping snap! So we must figure out which one is closer and let that tween live.
                        return;
                        if (snap.inertia === false) change1 = endValue - progress;
                        tweenTo(endScroll, {
                            duration: snapDurClamp($f075d17102cf2205$var$_abs(Math.max($f075d17102cf2205$var$_abs(naturalEnd - totalProgress), $f075d17102cf2205$var$_abs(endValue - totalProgress)) * 0.185 / velocity / 0.05 || 0)),
                            ease: snap.ease || "power3",
                            data: $f075d17102cf2205$var$_abs(endScroll - scroll),
                            // record the distance so that if another snap tween occurs (conflict) we can prioritize the closest snap.
                            onInterrupt: function onInterrupt() {
                                return snapDelayedCall.restart(true) && _onInterrupt && _onInterrupt(self);
                            },
                            onComplete: function onComplete() {
                                self.update();
                                lastSnap = scrollFunc();
                                snap1 = snap2 = animation && !isToggle ? animation.totalProgress() : self.progress;
                                onSnapComplete && onSnapComplete(self);
                                _onComplete && _onComplete(self);
                            }
                        }, scroll, change1 * change, endScroll - scroll - change1 * change);
                        onStart && onStart(self, tweenTo.tween);
                    }
                } else if (self.isActive && lastSnap !== scroll) snapDelayedCall.restart(true);
            }).pause();
        }
        id && ($f075d17102cf2205$var$_ids[id] = self);
        trigger = self.trigger = (0, $a52c0798f59d4093$export$937374fea3f88711)(trigger || pin !== true && pin); // if a trigger has some kind of scroll-related effect applied that could contaminate the "y" or "x" position (like a ScrollSmoother effect), we needed a way to temporarily revert it, so we use the stRevert property of the gsCache. It can return another function that we'll call at the end so it can return to its normal state.
        customRevertReturn = trigger && trigger._gsap && trigger._gsap.stRevert;
        customRevertReturn && (customRevertReturn = customRevertReturn(self));
        pin = pin === true ? trigger : (0, $a52c0798f59d4093$export$937374fea3f88711)(pin);
        $f075d17102cf2205$var$_isString(toggleClass) && (toggleClass = {
            targets: trigger,
            className: toggleClass
        });
        if (pin) {
            pinSpacing === false || pinSpacing === $f075d17102cf2205$var$_margin || (pinSpacing = !pinSpacing && pin.parentNode && pin.parentNode.style && $f075d17102cf2205$var$_getComputedStyle(pin.parentNode).display === "flex" ? false : $f075d17102cf2205$var$_padding); // if the parent is display: flex, don't apply pinSpacing by default. We should check that pin.parentNode is an element (not shadow dom window)
            self.pin = pin;
            pinCache = $f075d17102cf2205$var$gsap.core.getCache(pin);
            if (!pinCache.spacer) {
                // record the spacer and pinOriginalState on the cache in case someone tries pinning the same element with MULTIPLE ScrollTriggers - we don't want to have multiple spacers or record the "original" pin state after it has already been affected by another ScrollTrigger.
                if (pinSpacer) {
                    pinSpacer = (0, $a52c0798f59d4093$export$937374fea3f88711)(pinSpacer);
                    pinSpacer && !pinSpacer.nodeType && (pinSpacer = pinSpacer.current || pinSpacer.nativeElement); // for React & Angular
                    pinCache.spacerIsNative = !!pinSpacer;
                    pinSpacer && (pinCache.spacerState = $f075d17102cf2205$var$_getState(pinSpacer));
                }
                pinCache.spacer = spacer = pinSpacer || $f075d17102cf2205$var$_doc.createElement("div");
                spacer.classList.add("pin-spacer");
                id && spacer.classList.add("pin-spacer-" + id);
                pinCache.pinState = pinOriginalState = $f075d17102cf2205$var$_getState(pin);
            } else pinOriginalState = pinCache.pinState;
            vars.force3D !== false && $f075d17102cf2205$var$gsap.set(pin, {
                force3D: true
            });
            self.spacer = spacer = pinCache.spacer;
            cs = $f075d17102cf2205$var$_getComputedStyle(pin);
            spacingStart = cs[pinSpacing + direction.os2];
            pinGetter = $f075d17102cf2205$var$gsap.getProperty(pin);
            pinSetter = $f075d17102cf2205$var$gsap.quickSetter(pin, direction.a, $f075d17102cf2205$var$_px); // pin.firstChild && !_maxScroll(pin, direction) && (pin.style.overflow = "hidden"); // protects from collapsing margins, but can have unintended consequences as demonstrated here: https://codepen.io/GreenSock/pen/1e42c7a73bfa409d2cf1e184e7a4248d so it was removed in favor of just telling people to set up their CSS to avoid the collapsing margins (overflow: hidden | auto is just one option. Another is border-top: 1px solid transparent).
            $f075d17102cf2205$var$_swapPinIn(pin, spacer, cs);
            pinState = $f075d17102cf2205$var$_getState(pin);
        }
        if (markers) {
            markerVars = $f075d17102cf2205$var$_isObject(markers) ? $f075d17102cf2205$var$_setDefaults(markers, $f075d17102cf2205$var$_markerDefaults) : $f075d17102cf2205$var$_markerDefaults;
            markerStartTrigger = $f075d17102cf2205$var$_createMarker("scroller-start", id, scroller, direction, markerVars, 0);
            markerEndTrigger = $f075d17102cf2205$var$_createMarker("scroller-end", id, scroller, direction, markerVars, 0, markerStartTrigger);
            offset = markerStartTrigger["offset" + direction.op.d2];
            var content = (0, $a52c0798f59d4093$export$937374fea3f88711)((0, $a52c0798f59d4093$export$6078f1ef08b38af9)(scroller, "content") || scroller);
            markerStart = this.markerStart = $f075d17102cf2205$var$_createMarker("start", id, content, direction, markerVars, offset, 0, containerAnimation);
            markerEnd = this.markerEnd = $f075d17102cf2205$var$_createMarker("end", id, content, direction, markerVars, offset, 0, containerAnimation);
            containerAnimation && (caMarkerSetter = $f075d17102cf2205$var$gsap.quickSetter([
                markerStart,
                markerEnd
            ], direction.a, $f075d17102cf2205$var$_px));
            if (!useFixedPosition && !((0, $a52c0798f59d4093$export$d8e56d510a804d0a).length && (0, $a52c0798f59d4093$export$6078f1ef08b38af9)(scroller, "fixedMarkers") === true)) {
                $f075d17102cf2205$var$_makePositionable(isViewport ? $f075d17102cf2205$var$_body : scroller);
                $f075d17102cf2205$var$gsap.set([
                    markerStartTrigger,
                    markerEndTrigger
                ], {
                    force3D: true
                });
                markerStartSetter = $f075d17102cf2205$var$gsap.quickSetter(markerStartTrigger, direction.a, $f075d17102cf2205$var$_px);
                markerEndSetter = $f075d17102cf2205$var$gsap.quickSetter(markerEndTrigger, direction.a, $f075d17102cf2205$var$_px);
            }
        }
        if (containerAnimation) {
            var oldOnUpdate = containerAnimation.vars.onUpdate, oldParams = containerAnimation.vars.onUpdateParams;
            containerAnimation.eventCallback("onUpdate", function() {
                self.update(0, 0, 1);
                oldOnUpdate && oldOnUpdate.apply(containerAnimation, oldParams || []);
            });
        }
        self.previous = function() {
            return $f075d17102cf2205$var$_triggers[$f075d17102cf2205$var$_triggers.indexOf(self) - 1];
        };
        self.next = function() {
            return $f075d17102cf2205$var$_triggers[$f075d17102cf2205$var$_triggers.indexOf(self) + 1];
        };
        self.revert = function(revert, temp) {
            if (!temp) return self.kill(true);
             // for compatibility with gsap.context() and gsap.matchMedia() which call revert()
            var r = revert !== false || !self.enabled, prevRefreshing = $f075d17102cf2205$var$_refreshing;
            if (r !== self.isReverted) {
                if (r) {
                    prevScroll = Math.max(scrollFunc(), self.scroll.rec || 0); // record the scroll so we can revert later (repositioning/pinning things can affect scroll position). In the static refresh() method, we first record all the scroll positions as a reference.
                    prevProgress = self.progress;
                    prevAnimProgress = animation && animation.progress();
                }
                markerStart && [
                    markerStart,
                    markerEnd,
                    markerStartTrigger,
                    markerEndTrigger
                ].forEach(function(m) {
                    return m.style.display = r ? "none" : "block";
                });
                if (r) {
                    $f075d17102cf2205$var$_refreshing = self;
                    self.update(r); // make sure the pin is back in its original position so that all the measurements are correct. do this BEFORE swapping the pin out
                }
                if (pin && (!pinReparent || !self.isActive)) {
                    if (r) $f075d17102cf2205$var$_swapPinOut(pin, spacer, pinOriginalState);
                    else $f075d17102cf2205$var$_swapPinIn(pin, spacer, $f075d17102cf2205$var$_getComputedStyle(pin), spacerState);
                }
                r || self.update(r); // when we're restoring, the update should run AFTER swapping the pin into its pin-spacer.
                $f075d17102cf2205$var$_refreshing = prevRefreshing; // restore. We set it to true during the update() so that things fire properly in there.
                self.isReverted = r;
            }
        };
        self.refresh = function(soft, force, position, pinOffset) {
            // position is typically only defined if it's coming from setPositions() - it's a way to skip the normal parsing. pinOffset is also only from setPositions() and is mostly related to fancy stuff we need to do in ScrollSmoother with effects
            if (($f075d17102cf2205$var$_refreshing || !self.enabled) && !force) return;
            if (pin && soft && $f075d17102cf2205$var$_lastScrollTime) {
                $f075d17102cf2205$var$_addListener(ScrollTrigger, "scrollEnd", $f075d17102cf2205$var$_softRefresh);
                return;
            }
            !$f075d17102cf2205$var$_refreshingAll && onRefreshInit && onRefreshInit(self);
            $f075d17102cf2205$var$_refreshing = self;
            if (tweenTo.tween && !position) {
                // we skip this if a position is passed in because typically that's from .setPositions() and it's best to allow in-progress snapping to continue.
                tweenTo.tween.kill();
                tweenTo.tween = 0;
            }
            scrubTween && scrubTween.pause();
            invalidateOnRefresh && animation && animation.revert({
                kill: false
            }).invalidate();
            self.isReverted || self.revert(true, true);
            self._subPinOffset = false; // we'll set this to true in the sub-pins if we find any
            var size = getScrollerSize(), scrollerBounds = getScrollerOffsets(), max = containerAnimation ? containerAnimation.duration() : $f075d17102cf2205$var$_maxScroll(scroller, direction), isFirstRefresh = change <= 0.01, offset = 0, otherPinOffset = pinOffset || 0, parsedEnd = $f075d17102cf2205$var$_isObject(position) ? position.end : vars.end, parsedEndTrigger = vars.endTrigger || trigger, parsedStart = $f075d17102cf2205$var$_isObject(position) ? position.start : vars.start || (vars.start === 0 || !trigger ? 0 : pin ? "0 0" : "0 100%"), pinnedContainer = self.pinnedContainer = vars.pinnedContainer && (0, $a52c0798f59d4093$export$937374fea3f88711)(vars.pinnedContainer, self), triggerIndex = trigger && Math.max(0, $f075d17102cf2205$var$_triggers.indexOf(self)) || 0, i = triggerIndex, cs, bounds, scroll, isVertical, override, curTrigger, curPin, oppositeScroll, initted, revertedPins, forcedOverflow, markerStartOffset, markerEndOffset;
            if (markers && $f075d17102cf2205$var$_isObject(position)) {
                // if we alter the start/end positions with .setPositions(), it generally feeds in absolute NUMBERS which don't convey information about where to line up the markers, so to keep it intuitive, we record how far the trigger positions shift after applying the new numbers and then offset by that much in the opposite direction. We do the same to the associated trigger markers too of course.
                markerStartOffset = $f075d17102cf2205$var$gsap.getProperty(markerStartTrigger, direction.p);
                markerEndOffset = $f075d17102cf2205$var$gsap.getProperty(markerEndTrigger, direction.p);
            }
            while(i--){
                // user might try to pin the same element more than once, so we must find any prior triggers with the same pin, revert them, and determine how long they're pinning so that we can offset things appropriately. Make sure we revert from last to first so that things "rewind" properly.
                curTrigger = $f075d17102cf2205$var$_triggers[i];
                curTrigger.end || curTrigger.refresh(0, 1) || ($f075d17102cf2205$var$_refreshing = self); // if it's a timeline-based trigger that hasn't been fully initialized yet because it's waiting for 1 tick, just force the refresh() here, otherwise if it contains a pin that's supposed to affect other ScrollTriggers further down the page, they won't be adjusted properly.
                curPin = curTrigger.pin;
                if (curPin && (curPin === trigger || curPin === pin || curPin === pinnedContainer) && !curTrigger.isReverted) {
                    revertedPins || (revertedPins = []);
                    revertedPins.unshift(curTrigger); // we'll revert from first to last to make sure things reach their end state properly
                    curTrigger.revert(true, true);
                }
                if (curTrigger !== $f075d17102cf2205$var$_triggers[i]) {
                    // in case it got removed.
                    triggerIndex--;
                    i--;
                }
            }
            $f075d17102cf2205$var$_isFunction(parsedStart) && (parsedStart = parsedStart(self));
            parsedStart = $f075d17102cf2205$var$_parseClamp(parsedStart, "start", self);
            start = $f075d17102cf2205$var$_parsePosition(parsedStart, trigger, size, direction, scrollFunc(), markerStart, markerStartTrigger, self, scrollerBounds, borderWidth, useFixedPosition, max, containerAnimation, self._startClamp && "_startClamp") || (pin ? -0.001 : 0);
            $f075d17102cf2205$var$_isFunction(parsedEnd) && (parsedEnd = parsedEnd(self));
            if ($f075d17102cf2205$var$_isString(parsedEnd) && !parsedEnd.indexOf("+=")) {
                if (~parsedEnd.indexOf(" ")) parsedEnd = ($f075d17102cf2205$var$_isString(parsedStart) ? parsedStart.split(" ")[0] : "") + parsedEnd;
                else {
                    offset = $f075d17102cf2205$var$_offsetToPx(parsedEnd.substr(2), size);
                    parsedEnd = $f075d17102cf2205$var$_isString(parsedStart) ? parsedStart : (containerAnimation ? $f075d17102cf2205$var$gsap.utils.mapRange(0, containerAnimation.duration(), containerAnimation.scrollTrigger.start, containerAnimation.scrollTrigger.end, start) : start) + offset; // _parsePosition won't factor in the offset if the start is a number, so do it here.
                    parsedEndTrigger = trigger;
                }
            }
            parsedEnd = $f075d17102cf2205$var$_parseClamp(parsedEnd, "end", self);
            end = Math.max(start, $f075d17102cf2205$var$_parsePosition(parsedEnd || (parsedEndTrigger ? "100% 0" : max), parsedEndTrigger, size, direction, scrollFunc() + offset, markerEnd, markerEndTrigger, self, scrollerBounds, borderWidth, useFixedPosition, max, containerAnimation, self._endClamp && "_endClamp")) || -0.001;
            offset = 0;
            i = triggerIndex;
            while(i--){
                curTrigger = $f075d17102cf2205$var$_triggers[i];
                curPin = curTrigger.pin;
                if (curPin && curTrigger.start - curTrigger._pinPush <= start && !containerAnimation && curTrigger.end > 0) {
                    cs = curTrigger.end - (self._startClamp ? Math.max(0, curTrigger.start) : curTrigger.start);
                    if ((curPin === trigger && curTrigger.start - curTrigger._pinPush < start || curPin === pinnedContainer) && isNaN(parsedStart)) // numeric start values shouldn't be offset at all - treat them as absolute
                    offset += cs * (1 - curTrigger.progress);
                    curPin === pin && (otherPinOffset += cs);
                }
            }
            start += offset;
            end += offset;
            self._startClamp && (self._startClamp += offset);
            if (self._endClamp && !$f075d17102cf2205$var$_refreshingAll) {
                self._endClamp = end || -0.001;
                end = Math.min(end, $f075d17102cf2205$var$_maxScroll(scroller, direction));
            }
            change = end - start || (start -= 0.01) && 0.001;
            if (isFirstRefresh) // on the very first refresh(), the prevProgress couldn't have been accurate yet because the start/end were never calculated, so we set it here. Before 3.11.5, it could lead to an inaccurate scroll position restoration with snapping.
            prevProgress = $f075d17102cf2205$var$gsap.utils.clamp(0, 1, $f075d17102cf2205$var$gsap.utils.normalize(start, end, prevScroll));
            self._pinPush = otherPinOffset;
            if (markerStart && offset) {
                // offset the markers if necessary
                cs = {};
                cs[direction.a] = "+=" + offset;
                pinnedContainer && (cs[direction.p] = "-=" + scrollFunc());
                $f075d17102cf2205$var$gsap.set([
                    markerStart,
                    markerEnd
                ], cs);
            }
            if (pin) {
                cs = $f075d17102cf2205$var$_getComputedStyle(pin);
                isVertical = direction === (0, $a52c0798f59d4093$export$8e40fc98ff518e9d);
                scroll = scrollFunc(); // recalculate because the triggers can affect the scroll
                pinStart = parseFloat(pinGetter(direction.a)) + otherPinOffset;
                if (!max && end > 1) {
                    // makes sure the scroller has a scrollbar, otherwise if something has width: 100%, for example, it would be too big (exclude the scrollbar). See https://greensock.com/forums/topic/25182-scrolltrigger-width-of-page-increase-where-markers-are-set-to-false/
                    forcedOverflow = (isViewport ? $f075d17102cf2205$var$_doc.scrollingElement || $f075d17102cf2205$var$_docEl : scroller).style;
                    forcedOverflow = {
                        style: forcedOverflow,
                        value: forcedOverflow["overflow" + direction.a.toUpperCase()]
                    };
                    if (isViewport && $f075d17102cf2205$var$_getComputedStyle($f075d17102cf2205$var$_body)["overflow" + direction.a.toUpperCase()] !== "scroll") // avoid an extra scrollbar if BOTH <html> and <body> have overflow set to "scroll"
                    forcedOverflow.style["overflow" + direction.a.toUpperCase()] = "scroll";
                }
                $f075d17102cf2205$var$_swapPinIn(pin, spacer, cs);
                pinState = $f075d17102cf2205$var$_getState(pin); // transforms will interfere with the top/left/right/bottom placement, so remove them temporarily. getBoundingClientRect() factors in transforms.
                bounds = $f075d17102cf2205$var$_getBounds(pin, true);
                oppositeScroll = useFixedPosition && (0, $a52c0798f59d4093$export$8665aac53dad5647)(scroller, isVertical ? (0, $a52c0798f59d4093$export$b2cabb342cb0ebe1) : (0, $a52c0798f59d4093$export$8e40fc98ff518e9d))();
                if (pinSpacing) {
                    spacerState = [
                        pinSpacing + direction.os2,
                        change + otherPinOffset + $f075d17102cf2205$var$_px
                    ];
                    spacerState.t = spacer;
                    i = pinSpacing === $f075d17102cf2205$var$_padding ? $f075d17102cf2205$var$_getSize(pin, direction) + change + otherPinOffset : 0;
                    i && spacerState.push(direction.d, i + $f075d17102cf2205$var$_px); // for box-sizing: border-box (must include padding).
                    $f075d17102cf2205$var$_setState(spacerState);
                    if (pinnedContainer) // in ScrollTrigger.refresh(), we need to re-evaluate the pinContainer's size because this pinSpacing may stretch it out, but we can't just add the exact distance because depending on layout, it may not push things down or it may only do so partially.
                    $f075d17102cf2205$var$_triggers.forEach(function(t) {
                        if (t.pin === pinnedContainer && t.vars.pinSpacing !== false) t._subPinOffset = true;
                    });
                    useFixedPosition && scrollFunc(prevScroll);
                }
                if (useFixedPosition) {
                    override = {
                        top: bounds.top + (isVertical ? scroll - start : oppositeScroll) + $f075d17102cf2205$var$_px,
                        left: bounds.left + (isVertical ? oppositeScroll : scroll - start) + $f075d17102cf2205$var$_px,
                        boxSizing: "border-box",
                        position: "fixed"
                    };
                    override[$f075d17102cf2205$var$_width] = override["max" + $f075d17102cf2205$var$_Width] = Math.ceil(bounds.width) + $f075d17102cf2205$var$_px;
                    override[$f075d17102cf2205$var$_height] = override["max" + $f075d17102cf2205$var$_Height] = Math.ceil(bounds.height) + $f075d17102cf2205$var$_px;
                    override[$f075d17102cf2205$var$_margin] = override[$f075d17102cf2205$var$_margin + $f075d17102cf2205$var$_Top] = override[$f075d17102cf2205$var$_margin + $f075d17102cf2205$var$_Right] = override[$f075d17102cf2205$var$_margin + $f075d17102cf2205$var$_Bottom] = override[$f075d17102cf2205$var$_margin + $f075d17102cf2205$var$_Left] = "0";
                    override[$f075d17102cf2205$var$_padding] = cs[$f075d17102cf2205$var$_padding];
                    override[$f075d17102cf2205$var$_padding + $f075d17102cf2205$var$_Top] = cs[$f075d17102cf2205$var$_padding + $f075d17102cf2205$var$_Top];
                    override[$f075d17102cf2205$var$_padding + $f075d17102cf2205$var$_Right] = cs[$f075d17102cf2205$var$_padding + $f075d17102cf2205$var$_Right];
                    override[$f075d17102cf2205$var$_padding + $f075d17102cf2205$var$_Bottom] = cs[$f075d17102cf2205$var$_padding + $f075d17102cf2205$var$_Bottom];
                    override[$f075d17102cf2205$var$_padding + $f075d17102cf2205$var$_Left] = cs[$f075d17102cf2205$var$_padding + $f075d17102cf2205$var$_Left];
                    pinActiveState = $f075d17102cf2205$var$_copyState(pinOriginalState, override, pinReparent);
                    $f075d17102cf2205$var$_refreshingAll && scrollFunc(0);
                }
                if (animation) {
                    // the animation might be affecting the transform, so we must jump to the end, check the value, and compensate accordingly. Otherwise, when it becomes unpinned, the pinSetter() will get set to a value that doesn't include whatever the animation did.
                    initted = animation._initted; // if not, we must invalidate() after this step, otherwise it could lock in starting values prematurely.
                    $f075d17102cf2205$var$_suppressOverwrites(1);
                    animation.render(animation.duration(), true, true);
                    pinChange = pinGetter(direction.a) - pinStart + change + otherPinOffset;
                    pinMoves = Math.abs(change - pinChange) > 1;
                    useFixedPosition && pinMoves && pinActiveState.splice(pinActiveState.length - 2, 2); // transform is the last property/value set in the state Array. Since the animation is controlling that, we should omit it.
                    animation.render(0, true, true);
                    initted || animation.invalidate(true);
                    animation.parent || animation.totalTime(animation.totalTime()); // if, for example, a toggleAction called play() and then refresh() happens and when we render(1) above, it would cause the animation to complete and get removed from its parent, so this makes sure it gets put back in.
                    $f075d17102cf2205$var$_suppressOverwrites(0);
                } else pinChange = change;
                forcedOverflow && (forcedOverflow.value ? forcedOverflow.style["overflow" + direction.a.toUpperCase()] = forcedOverflow.value : forcedOverflow.style.removeProperty("overflow-" + direction.a));
            } else if (trigger && scrollFunc() && !containerAnimation) {
                // it may be INSIDE a pinned element, so walk up the tree and look for any elements with _pinOffset to compensate because anything with pinSpacing that's already scrolled would throw off the measurements in getBoundingClientRect()
                bounds = trigger.parentNode;
                while(bounds && bounds !== $f075d17102cf2205$var$_body){
                    if (bounds._pinOffset) {
                        start -= bounds._pinOffset;
                        end -= bounds._pinOffset;
                    }
                    bounds = bounds.parentNode;
                }
            }
            revertedPins && revertedPins.forEach(function(t) {
                return t.revert(false, true);
            });
            self.start = start;
            self.end = end;
            scroll1 = scroll2 = $f075d17102cf2205$var$_refreshingAll ? prevScroll : scrollFunc(); // reset velocity
            if (!containerAnimation && !$f075d17102cf2205$var$_refreshingAll) {
                scroll1 < prevScroll && scrollFunc(prevScroll);
                self.scroll.rec = 0;
            }
            self.revert(false, true);
            lastRefresh = $f075d17102cf2205$var$_getTime();
            if (snapDelayedCall) {
                lastSnap = -1; // just so snapping gets re-enabled, clear out any recorded last value
                // self.isActive && scrollFunc(start + change * prevProgress); // previously this line was here to ensure that when snapping kicks in, it's from the previous progress but in some cases that's not desirable, like an all-page ScrollTrigger when new content gets added to the page, that'd totally change the progress.
                snapDelayedCall.restart(true);
            }
            $f075d17102cf2205$var$_refreshing = 0;
            animation && isToggle && (animation._initted || prevAnimProgress) && animation.progress() !== prevAnimProgress && animation.progress(prevAnimProgress || 0, true).render(animation.time(), true, true); // must force a re-render because if saveStyles() was used on the target(s), the styles could have been wiped out during the refresh().
            if (isFirstRefresh || prevProgress !== self.progress || containerAnimation) {
                // ensures that the direction is set properly (when refreshing, progress is set back to 0 initially, then back again to wherever it needs to be) and that callbacks are triggered.
                animation && !isToggle && animation.totalProgress(containerAnimation && start < -0.001 && !prevProgress ? $f075d17102cf2205$var$gsap.utils.normalize(start, end, 0) : prevProgress, true); // to avoid issues where animation callbacks like onStart aren't triggered.
                self.progress = isFirstRefresh || (scroll1 - start) / change === prevProgress ? 0 : prevProgress;
            }
            pin && pinSpacing && (spacer._pinOffset = Math.round(self.progress * pinChange));
            scrubTween && scrubTween.invalidate();
            if (!isNaN(markerStartOffset)) {
                // numbers were passed in for the position which are absolute, so instead of just putting the markers at the very bottom of the viewport, we figure out how far they shifted down (it's safe to assume they were originally positioned in closer relation to the trigger element with values like "top", "center", a percentage or whatever, so we offset that much in the opposite direction to basically revert them to the relative position thy were at previously.
                markerStartOffset -= $f075d17102cf2205$var$gsap.getProperty(markerStartTrigger, direction.p);
                markerEndOffset -= $f075d17102cf2205$var$gsap.getProperty(markerEndTrigger, direction.p);
                $f075d17102cf2205$var$_shiftMarker(markerStartTrigger, direction, markerStartOffset);
                $f075d17102cf2205$var$_shiftMarker(markerStart, direction, markerStartOffset - (pinOffset || 0));
                $f075d17102cf2205$var$_shiftMarker(markerEndTrigger, direction, markerEndOffset);
                $f075d17102cf2205$var$_shiftMarker(markerEnd, direction, markerEndOffset - (pinOffset || 0));
            }
            isFirstRefresh && !$f075d17102cf2205$var$_refreshingAll && self.update(); // edge case - when you reload a page when it's already scrolled down, some browsers fire a "scroll" event before DOMContentLoaded, triggering an updateAll(). If we don't update the self.progress as part of refresh(), then when it happens next, it may record prevProgress as 0 when it really shouldn't, potentially causing a callback in an animation to fire again.
            if (onRefresh && !$f075d17102cf2205$var$_refreshingAll && !executingOnRefresh) {
                // when refreshing all, we do extra work to correct pinnedContainer sizes and ensure things don't exceed the maxScroll, so we should do all the refreshes at the end after all that work so that the start/end values are corrected.
                executingOnRefresh = true;
                onRefresh(self);
                executingOnRefresh = false;
            }
        };
        self.getVelocity = function() {
            return (scrollFunc() - scroll2) / ($f075d17102cf2205$var$_getTime() - $f075d17102cf2205$var$_time2) * 1000 || 0;
        };
        self.endAnimation = function() {
            $f075d17102cf2205$var$_endAnimation(self.callbackAnimation);
            if (animation) scrubTween ? scrubTween.progress(1) : !animation.paused() ? $f075d17102cf2205$var$_endAnimation(animation, animation.reversed()) : isToggle || $f075d17102cf2205$var$_endAnimation(animation, self.direction < 0, 1);
        };
        self.labelToScroll = function(label) {
            return animation && animation.labels && (start || self.refresh() || start) + animation.labels[label] / animation.duration() * change || 0;
        };
        self.getTrailing = function(name) {
            var i = $f075d17102cf2205$var$_triggers.indexOf(self), a = self.direction > 0 ? $f075d17102cf2205$var$_triggers.slice(0, i).reverse() : $f075d17102cf2205$var$_triggers.slice(i + 1);
            return ($f075d17102cf2205$var$_isString(name) ? a.filter(function(t) {
                return t.vars.preventOverlaps === name;
            }) : a).filter(function(t) {
                return self.direction > 0 ? t.end <= start : t.start >= end;
            });
        };
        self.update = function(reset, recordVelocity, forceFake) {
            if (containerAnimation && !forceFake && !reset) return;
            var scroll = $f075d17102cf2205$var$_refreshingAll === true ? prevScroll : self.scroll(), p = reset ? 0 : (scroll - start) / change, clipped = p < 0 ? 0 : p > 1 ? 1 : p || 0, prevProgress = self.progress, isActive, wasActive, toggleState, action, stateChanged, toggled, isAtMax, isTakingAction;
            if (recordVelocity) {
                scroll2 = scroll1;
                scroll1 = containerAnimation ? scrollFunc() : scroll;
                if (snap) {
                    snap2 = snap1;
                    snap1 = animation && !isToggle ? animation.totalProgress() : clipped;
                }
            } // anticipate the pinning a few ticks ahead of time based on velocity to avoid a visual glitch due to the fact that most browsers do scrolling on a separate thread (not synced with requestAnimationFrame).
            anticipatePin && !clipped && pin && !$f075d17102cf2205$var$_refreshing && !$f075d17102cf2205$var$_startup && $f075d17102cf2205$var$_lastScrollTime && start < scroll + (scroll - scroll2) / ($f075d17102cf2205$var$_getTime() - $f075d17102cf2205$var$_time2) * anticipatePin && (clipped = 0.0001);
            if (clipped !== prevProgress && self.enabled) {
                isActive = self.isActive = !!clipped && clipped < 1;
                wasActive = !!prevProgress && prevProgress < 1;
                toggled = isActive !== wasActive;
                stateChanged = toggled || !!clipped !== !!prevProgress; // could go from start all the way to end, thus it didn't toggle but it did change state in a sense (may need to fire a callback)
                self.direction = clipped > prevProgress ? 1 : -1;
                self.progress = clipped;
                if (stateChanged && !$f075d17102cf2205$var$_refreshing) {
                    toggleState = clipped && !prevProgress ? 0 : clipped === 1 ? 1 : prevProgress === 1 ? 2 : 3; // 0 = enter, 1 = leave, 2 = enterBack, 3 = leaveBack (we prioritize the FIRST encounter, thus if you scroll really fast past the onEnter and onLeave in one tick, it'd prioritize onEnter.
                    if (isToggle) {
                        action = !toggled && toggleActions[toggleState + 1] !== "none" && toggleActions[toggleState + 1] || toggleActions[toggleState]; // if it didn't toggle, that means it shot right past and since we prioritize the "enter" action, we should switch to the "leave" in this case (but only if one is defined)
                        isTakingAction = animation && (action === "complete" || action === "reset" || action in animation);
                    }
                }
                preventOverlaps && (toggled || isTakingAction) && (isTakingAction || scrub || !animation) && ($f075d17102cf2205$var$_isFunction(preventOverlaps) ? preventOverlaps(self) : self.getTrailing(preventOverlaps).forEach(function(t) {
                    return t.endAnimation();
                }));
                if (!isToggle) {
                    if (scrubTween && !$f075d17102cf2205$var$_refreshing && !$f075d17102cf2205$var$_startup) {
                        scrubTween._dp._time - scrubTween._start !== scrubTween._time && scrubTween.render(scrubTween._dp._time - scrubTween._start); // if there's a scrub on both the container animation and this one (or a ScrollSmoother), the update order would cause this one not to have rendered yet, so it wouldn't make any progress before we .restart() it heading toward the new progress so it'd appear stuck thus we force a render here.
                        if (scrubTween.resetTo) scrubTween.resetTo("totalProgress", clipped, animation._tTime / animation._tDur);
                        else {
                            // legacy support (courtesy), before 3.10.0
                            scrubTween.vars.totalProgress = clipped;
                            scrubTween.invalidate().restart();
                        }
                    } else if (animation) animation.totalProgress(clipped, !!($f075d17102cf2205$var$_refreshing && (lastRefresh || reset)));
                }
                if (pin) {
                    reset && pinSpacing && (spacer.style[pinSpacing + direction.os2] = spacingStart);
                    if (!useFixedPosition) pinSetter($f075d17102cf2205$var$_round(pinStart + pinChange * clipped));
                    else if (stateChanged) {
                        isAtMax = !reset && clipped > prevProgress && end + 1 > scroll && scroll + 1 >= $f075d17102cf2205$var$_maxScroll(scroller, direction); // if it's at the VERY end of the page, don't switch away from position: fixed because it's pointless and it could cause a brief flash when the user scrolls back up (when it gets pinned again)
                        if (pinReparent) {
                            if (!reset && (isActive || isAtMax)) {
                                var bounds = $f075d17102cf2205$var$_getBounds(pin, true), _offset = scroll - start;
                                $f075d17102cf2205$var$_reparent(pin, $f075d17102cf2205$var$_body, bounds.top + (direction === (0, $a52c0798f59d4093$export$8e40fc98ff518e9d) ? _offset : 0) + $f075d17102cf2205$var$_px, bounds.left + (direction === (0, $a52c0798f59d4093$export$8e40fc98ff518e9d) ? 0 : _offset) + $f075d17102cf2205$var$_px);
                            } else $f075d17102cf2205$var$_reparent(pin, spacer);
                        }
                        $f075d17102cf2205$var$_setState(isActive || isAtMax ? pinActiveState : pinState);
                        pinMoves && clipped < 1 && isActive || pinSetter(pinStart + (clipped === 1 && !isAtMax ? pinChange : 0));
                    }
                }
                snap && !tweenTo.tween && !$f075d17102cf2205$var$_refreshing && !$f075d17102cf2205$var$_startup && snapDelayedCall.restart(true);
                toggleClass && (toggled || once && clipped && (clipped < 1 || !$f075d17102cf2205$var$_limitCallbacks)) && $f075d17102cf2205$var$_toArray(toggleClass.targets).forEach(function(el) {
                    return el.classList[isActive || once ? "add" : "remove"](toggleClass.className);
                }); // classes could affect positioning, so do it even if reset or refreshing is true.
                onUpdate && !isToggle && !reset && onUpdate(self);
                if (stateChanged && !$f075d17102cf2205$var$_refreshing) {
                    if (isToggle) {
                        if (isTakingAction) {
                            if (action === "complete") animation.pause().totalProgress(1);
                            else if (action === "reset") animation.restart(true).pause();
                            else if (action === "restart") animation.restart(true);
                            else animation[action]();
                        }
                        onUpdate && onUpdate(self);
                    }
                    if (toggled || !$f075d17102cf2205$var$_limitCallbacks) {
                        // on startup, the page could be scrolled and we don't want to fire callbacks that didn't toggle. For example onEnter shouldn't fire if the ScrollTrigger isn't actually entered.
                        onToggle && toggled && $f075d17102cf2205$var$_callback(self, onToggle);
                        callbacks[toggleState] && $f075d17102cf2205$var$_callback(self, callbacks[toggleState]);
                        once && (clipped === 1 ? self.kill(false, 1) : callbacks[toggleState] = 0); // a callback shouldn't be called again if once is true.
                        if (!toggled) {
                            // it's possible to go completely past, like from before the start to after the end (or vice-versa) in which case BOTH callbacks should be fired in that order
                            toggleState = clipped === 1 ? 1 : 3;
                            callbacks[toggleState] && $f075d17102cf2205$var$_callback(self, callbacks[toggleState]);
                        }
                    }
                    if (fastScrollEnd && !isActive && Math.abs(self.getVelocity()) > ($f075d17102cf2205$var$_isNumber(fastScrollEnd) ? fastScrollEnd : 2500)) {
                        $f075d17102cf2205$var$_endAnimation(self.callbackAnimation);
                        scrubTween ? scrubTween.progress(1) : $f075d17102cf2205$var$_endAnimation(animation, action === "reverse" ? 1 : !clipped, 1);
                    }
                } else if (isToggle && onUpdate && !$f075d17102cf2205$var$_refreshing) onUpdate(self);
            } // update absolutely-positioned markers (only if the scroller isn't the viewport)
            if (markerEndSetter) {
                var n = containerAnimation ? scroll / containerAnimation.duration() * (containerAnimation._caScrollDist || 0) : scroll;
                markerStartSetter(n + (markerStartTrigger._isFlipped ? 1 : 0));
                markerEndSetter(n);
            }
            caMarkerSetter && caMarkerSetter(-scroll / containerAnimation.duration() * (containerAnimation._caScrollDist || 0));
        };
        self.enable = function(reset, refresh) {
            if (!self.enabled) {
                self.enabled = true;
                $f075d17102cf2205$var$_addListener(scroller, "resize", $f075d17102cf2205$var$_onResize);
                isViewport || $f075d17102cf2205$var$_addListener(scroller, "scroll", $f075d17102cf2205$var$_onScroll);
                onRefreshInit && $f075d17102cf2205$var$_addListener(ScrollTrigger, "refreshInit", onRefreshInit);
                if (reset !== false) {
                    self.progress = prevProgress = 0;
                    scroll1 = scroll2 = lastSnap = scrollFunc();
                }
                refresh !== false && self.refresh();
            }
        };
        self.getTween = function(snap) {
            return snap && tweenTo ? tweenTo.tween : scrubTween;
        };
        self.setPositions = function(newStart, newEnd, keepClamp, pinOffset) {
            // doesn't persist after refresh()! Intended to be a way to override values that were set during refresh(), like you could set it in onRefresh()
            if (containerAnimation) {
                // convert ratios into scroll positions. Remember, start/end values on ScrollTriggers that have a containerAnimation refer to the time (in seconds), NOT scroll positions.
                var st = containerAnimation.scrollTrigger, duration = containerAnimation.duration(), _change = st.end - st.start;
                newStart = st.start + _change * newStart / duration;
                newEnd = st.start + _change * newEnd / duration;
            }
            self.refresh(false, false, {
                start: $f075d17102cf2205$var$_keepClamp(newStart, keepClamp && !!self._startClamp),
                end: $f075d17102cf2205$var$_keepClamp(newEnd, keepClamp && !!self._endClamp)
            }, pinOffset);
            self.update();
        };
        self.adjustPinSpacing = function(amount) {
            if (spacerState && amount) {
                var i = spacerState.indexOf(direction.d) + 1;
                spacerState[i] = parseFloat(spacerState[i]) + amount + $f075d17102cf2205$var$_px;
                spacerState[1] = parseFloat(spacerState[1]) + amount + $f075d17102cf2205$var$_px;
                $f075d17102cf2205$var$_setState(spacerState);
            }
        };
        self.disable = function(reset, allowAnimation) {
            if (self.enabled) {
                reset !== false && self.revert(true, true);
                self.enabled = self.isActive = false;
                allowAnimation || scrubTween && scrubTween.pause();
                prevScroll = 0;
                pinCache && (pinCache.uncache = 1);
                onRefreshInit && $f075d17102cf2205$var$_removeListener(ScrollTrigger, "refreshInit", onRefreshInit);
                if (snapDelayedCall) {
                    snapDelayedCall.pause();
                    tweenTo.tween && tweenTo.tween.kill() && (tweenTo.tween = 0);
                }
                if (!isViewport) {
                    var i = $f075d17102cf2205$var$_triggers.length;
                    while(i--){
                        if ($f075d17102cf2205$var$_triggers[i].scroller === scroller && $f075d17102cf2205$var$_triggers[i] !== self) return; //don't remove the listeners if there are still other triggers referencing it.
                    }
                    $f075d17102cf2205$var$_removeListener(scroller, "resize", $f075d17102cf2205$var$_onResize);
                    isViewport || $f075d17102cf2205$var$_removeListener(scroller, "scroll", $f075d17102cf2205$var$_onScroll);
                }
            }
        };
        self.kill = function(revert, allowAnimation) {
            self.disable(revert, allowAnimation);
            scrubTween && !allowAnimation && scrubTween.kill();
            id && delete $f075d17102cf2205$var$_ids[id];
            var i = $f075d17102cf2205$var$_triggers.indexOf(self);
            i >= 0 && $f075d17102cf2205$var$_triggers.splice(i, 1);
            i === $f075d17102cf2205$var$_i && $f075d17102cf2205$var$_direction > 0 && $f075d17102cf2205$var$_i--; // if we're in the middle of a refresh() or update(), splicing would cause skips in the index, so adjust...
            // if no other ScrollTrigger instances of the same scroller are found, wipe out any recorded scroll position. Otherwise, in a single page application, for example, it could maintain scroll position when it really shouldn't.
            i = 0;
            $f075d17102cf2205$var$_triggers.forEach(function(t) {
                return t.scroller === self.scroller && (i = 1);
            });
            i || $f075d17102cf2205$var$_refreshingAll || (self.scroll.rec = 0);
            if (animation) {
                animation.scrollTrigger = null;
                revert && animation.revert({
                    kill: false
                });
                allowAnimation || animation.kill();
            }
            markerStart && [
                markerStart,
                markerEnd,
                markerStartTrigger,
                markerEndTrigger
            ].forEach(function(m) {
                return m.parentNode && m.parentNode.removeChild(m);
            });
            $f075d17102cf2205$var$_primary === self && ($f075d17102cf2205$var$_primary = 0);
            if (pin) {
                pinCache && (pinCache.uncache = 1);
                i = 0;
                $f075d17102cf2205$var$_triggers.forEach(function(t) {
                    return t.pin === pin && i++;
                });
                i || (pinCache.spacer = 0); // if there aren't any more ScrollTriggers with the same pin, remove the spacer, otherwise it could be contaminated with old/stale values if the user re-creates a ScrollTrigger for the same element.
            }
            vars.onKill && vars.onKill(self);
        };
        $f075d17102cf2205$var$_triggers.push(self);
        self.enable(false, false);
        customRevertReturn && customRevertReturn(self);
        if (animation && animation.add && !change) {
            // if the animation is a timeline, it may not have been populated yet, so it wouldn't render at the proper place on the first refresh(), thus we should schedule one for the next tick. If "change" is defined, we know it must be re-enabling, thus we can refresh() right away.
            var updateFunc = self.update; // some browsers may fire a scroll event BEFORE a tick elapses and/or the DOMContentLoaded fires. So there's a chance update() will be called BEFORE a refresh() has happened on a Timeline-attached ScrollTrigger which means the start/end won't be calculated yet. We don't want to add conditional logic inside the update() method (like check to see if end is defined and if not, force a refresh()) because that's a function that gets hit a LOT (performance). So we swap out the real update() method for this one that'll re-attach it the first time it gets called and of course forces a refresh().
            self.update = function() {
                self.update = updateFunc;
                start || end || self.refresh();
            };
            $f075d17102cf2205$var$gsap.delayedCall(0.01, self.update);
            change = 0.01;
            start = end = 0;
        } else self.refresh();
        pin && $f075d17102cf2205$var$_queueRefreshAll(); // pinning could affect the positions of other things, so make sure we queue a full refresh()
    };
    ScrollTrigger.register = function register(core) {
        if (!$f075d17102cf2205$var$_coreInitted) {
            $f075d17102cf2205$var$gsap = core || $f075d17102cf2205$var$_getGSAP();
            $f075d17102cf2205$var$_windowExists() && window.document && ScrollTrigger.enable();
            $f075d17102cf2205$var$_coreInitted = $f075d17102cf2205$var$_enabled;
        }
        return $f075d17102cf2205$var$_coreInitted;
    };
    ScrollTrigger.defaults = function defaults(config) {
        if (config) for(var p in config)$f075d17102cf2205$var$_defaults[p] = config[p];
        return $f075d17102cf2205$var$_defaults;
    };
    ScrollTrigger.disable = function disable(reset, kill) {
        $f075d17102cf2205$var$_enabled = 0;
        $f075d17102cf2205$var$_triggers.forEach(function(trigger) {
            return trigger[kill ? "kill" : "disable"](reset);
        });
        $f075d17102cf2205$var$_removeListener($f075d17102cf2205$var$_win, "wheel", $f075d17102cf2205$var$_onScroll);
        $f075d17102cf2205$var$_removeListener($f075d17102cf2205$var$_doc, "scroll", $f075d17102cf2205$var$_onScroll);
        clearInterval($f075d17102cf2205$var$_syncInterval);
        $f075d17102cf2205$var$_removeListener($f075d17102cf2205$var$_doc, "touchcancel", $f075d17102cf2205$var$_passThrough);
        $f075d17102cf2205$var$_removeListener($f075d17102cf2205$var$_body, "touchstart", $f075d17102cf2205$var$_passThrough);
        $f075d17102cf2205$var$_multiListener($f075d17102cf2205$var$_removeListener, $f075d17102cf2205$var$_doc, "pointerdown,touchstart,mousedown", $f075d17102cf2205$var$_pointerDownHandler);
        $f075d17102cf2205$var$_multiListener($f075d17102cf2205$var$_removeListener, $f075d17102cf2205$var$_doc, "pointerup,touchend,mouseup", $f075d17102cf2205$var$_pointerUpHandler);
        $f075d17102cf2205$var$_resizeDelay.kill();
        $f075d17102cf2205$var$_iterateAutoRefresh($f075d17102cf2205$var$_removeListener);
        for(var i = 0; i < (0, $a52c0798f59d4093$export$3cd1cee43d19b683).length; i += 3){
            $f075d17102cf2205$var$_wheelListener($f075d17102cf2205$var$_removeListener, (0, $a52c0798f59d4093$export$3cd1cee43d19b683)[i], (0, $a52c0798f59d4093$export$3cd1cee43d19b683)[i + 1]);
            $f075d17102cf2205$var$_wheelListener($f075d17102cf2205$var$_removeListener, (0, $a52c0798f59d4093$export$3cd1cee43d19b683)[i], (0, $a52c0798f59d4093$export$3cd1cee43d19b683)[i + 2]);
        }
    };
    ScrollTrigger.enable = function enable() {
        $f075d17102cf2205$var$_win = window;
        $f075d17102cf2205$var$_doc = document;
        $f075d17102cf2205$var$_docEl = $f075d17102cf2205$var$_doc.documentElement;
        $f075d17102cf2205$var$_body = $f075d17102cf2205$var$_doc.body;
        if ($f075d17102cf2205$var$gsap) {
            $f075d17102cf2205$var$_toArray = $f075d17102cf2205$var$gsap.utils.toArray;
            $f075d17102cf2205$var$_clamp = $f075d17102cf2205$var$gsap.utils.clamp;
            $f075d17102cf2205$var$_context = $f075d17102cf2205$var$gsap.core.context || $f075d17102cf2205$var$_passThrough;
            $f075d17102cf2205$var$_suppressOverwrites = $f075d17102cf2205$var$gsap.core.suppressOverwrites || $f075d17102cf2205$var$_passThrough;
            $f075d17102cf2205$var$_scrollRestoration = $f075d17102cf2205$var$_win.history.scrollRestoration || "auto";
            $f075d17102cf2205$var$_lastScroll = $f075d17102cf2205$var$_win.pageYOffset;
            $f075d17102cf2205$var$gsap.core.globals("ScrollTrigger", ScrollTrigger); // must register the global manually because in Internet Explorer, functions (classes) don't have a "name" property.
            if ($f075d17102cf2205$var$_body) {
                $f075d17102cf2205$var$_enabled = 1;
                $f075d17102cf2205$var$_div100vh = document.createElement("div"); // to solve mobile browser address bar show/hide resizing, we shouldn't rely on window.innerHeight. Instead, use a <div> with its height set to 100vh and measure that since that's what the scrolling is based on anyway and it's not affected by address bar showing/hiding.
                $f075d17102cf2205$var$_div100vh.style.height = "100vh";
                $f075d17102cf2205$var$_div100vh.style.position = "absolute";
                $f075d17102cf2205$var$_refresh100vh();
                $f075d17102cf2205$var$_rafBugFix();
                (0, $a52c0798f59d4093$export$c1cbdee04e18ea8b).register($f075d17102cf2205$var$gsap); // isTouch is 0 if no touch, 1 if ONLY touch, and 2 if it can accommodate touch but also other types like mouse/pointer.
                ScrollTrigger.isTouch = (0, $a52c0798f59d4093$export$c1cbdee04e18ea8b).isTouch;
                $f075d17102cf2205$var$_fixIOSBug = (0, $a52c0798f59d4093$export$c1cbdee04e18ea8b).isTouch && /(iPad|iPhone|iPod|Mac)/g.test(navigator.userAgent); // since 2017, iOS has had a bug that causes event.clientX/Y to be inaccurate when a scroll occurs, thus we must alternate ignoring every other touchmove event to work around it. See https://bugs.webkit.org/show_bug.cgi?id=181954 and https://codepen.io/GreenSock/pen/ExbrPNa/087cef197dc35445a0951e8935c41503
                $f075d17102cf2205$var$_addListener($f075d17102cf2205$var$_win, "wheel", $f075d17102cf2205$var$_onScroll); // mostly for 3rd party smooth scrolling libraries.
                $f075d17102cf2205$var$_root = [
                    $f075d17102cf2205$var$_win,
                    $f075d17102cf2205$var$_doc,
                    $f075d17102cf2205$var$_docEl,
                    $f075d17102cf2205$var$_body
                ];
                if ($f075d17102cf2205$var$gsap.matchMedia) {
                    ScrollTrigger.matchMedia = function(vars) {
                        var mm = $f075d17102cf2205$var$gsap.matchMedia(), p;
                        for(p in vars)mm.add(p, vars[p]);
                        return mm;
                    };
                    $f075d17102cf2205$var$gsap.addEventListener("matchMediaInit", function() {
                        return $f075d17102cf2205$var$_revertAll();
                    });
                    $f075d17102cf2205$var$gsap.addEventListener("matchMediaRevert", function() {
                        return $f075d17102cf2205$var$_revertRecorded();
                    });
                    $f075d17102cf2205$var$gsap.addEventListener("matchMedia", function() {
                        $f075d17102cf2205$var$_refreshAll(0, 1);
                        $f075d17102cf2205$var$_dispatch("matchMedia");
                    });
                    $f075d17102cf2205$var$gsap.matchMedia("(orientation: portrait)", function() {
                        // when orientation changes, we should take new base measurements for the ignoreMobileResize feature.
                        $f075d17102cf2205$var$_setBaseDimensions();
                        return $f075d17102cf2205$var$_setBaseDimensions;
                    });
                } else console.warn("Requires GSAP 3.11.0 or later");
                $f075d17102cf2205$var$_setBaseDimensions();
                $f075d17102cf2205$var$_addListener($f075d17102cf2205$var$_doc, "scroll", $f075d17102cf2205$var$_onScroll); // some browsers (like Chrome), the window stops dispatching scroll events on the window if you scroll really fast, but it's consistent on the document!
                var bodyStyle = $f075d17102cf2205$var$_body.style, border = bodyStyle.borderTopStyle, AnimationProto = $f075d17102cf2205$var$gsap.core.Animation.prototype, bounds, i;
                AnimationProto.revert || Object.defineProperty(AnimationProto, "revert", {
                    value: function value() {
                        return this.time(-0.01, true);
                    }
                }); // only for backwards compatibility (Animation.revert() was added after 3.10.4)
                bodyStyle.borderTopStyle = "solid"; // works around an issue where a margin of a child element could throw off the bounds of the _body, making it seem like there's a margin when there actually isn't. The border ensures that the bounds are accurate.
                bounds = $f075d17102cf2205$var$_getBounds($f075d17102cf2205$var$_body);
                (0, $a52c0798f59d4093$export$8e40fc98ff518e9d).m = Math.round(bounds.top + (0, $a52c0798f59d4093$export$8e40fc98ff518e9d).sc()) || 0; // accommodate the offset of the <body> caused by margins and/or padding
                (0, $a52c0798f59d4093$export$b2cabb342cb0ebe1).m = Math.round(bounds.left + (0, $a52c0798f59d4093$export$b2cabb342cb0ebe1).sc()) || 0;
                border ? bodyStyle.borderTopStyle = border : bodyStyle.removeProperty("border-top-style"); // TODO: (?) maybe move to leveraging the velocity mechanism in Observer and skip intervals.
                $f075d17102cf2205$var$_syncInterval = setInterval($f075d17102cf2205$var$_sync, 250);
                $f075d17102cf2205$var$gsap.delayedCall(0.5, function() {
                    return $f075d17102cf2205$var$_startup = 0;
                });
                $f075d17102cf2205$var$_addListener($f075d17102cf2205$var$_doc, "touchcancel", $f075d17102cf2205$var$_passThrough); // some older Android devices intermittently stop dispatching "touchmove" events if we don't listen for "touchcancel" on the document.
                $f075d17102cf2205$var$_addListener($f075d17102cf2205$var$_body, "touchstart", $f075d17102cf2205$var$_passThrough); //works around Safari bug: https://greensock.com/forums/topic/21450-draggable-in-iframe-on-mobile-is-buggy/
                $f075d17102cf2205$var$_multiListener($f075d17102cf2205$var$_addListener, $f075d17102cf2205$var$_doc, "pointerdown,touchstart,mousedown", $f075d17102cf2205$var$_pointerDownHandler);
                $f075d17102cf2205$var$_multiListener($f075d17102cf2205$var$_addListener, $f075d17102cf2205$var$_doc, "pointerup,touchend,mouseup", $f075d17102cf2205$var$_pointerUpHandler);
                $f075d17102cf2205$var$_transformProp = $f075d17102cf2205$var$gsap.utils.checkPrefix("transform");
                $f075d17102cf2205$var$_stateProps.push($f075d17102cf2205$var$_transformProp);
                $f075d17102cf2205$var$_coreInitted = $f075d17102cf2205$var$_getTime();
                $f075d17102cf2205$var$_resizeDelay = $f075d17102cf2205$var$gsap.delayedCall(0.2, $f075d17102cf2205$var$_refreshAll).pause();
                $f075d17102cf2205$var$_autoRefresh = [
                    $f075d17102cf2205$var$_doc,
                    "visibilitychange",
                    function() {
                        var w = $f075d17102cf2205$var$_win.innerWidth, h = $f075d17102cf2205$var$_win.innerHeight;
                        if ($f075d17102cf2205$var$_doc.hidden) {
                            $f075d17102cf2205$var$_prevWidth = w;
                            $f075d17102cf2205$var$_prevHeight = h;
                        } else if ($f075d17102cf2205$var$_prevWidth !== w || $f075d17102cf2205$var$_prevHeight !== h) $f075d17102cf2205$var$_onResize();
                    },
                    $f075d17102cf2205$var$_doc,
                    "DOMContentLoaded",
                    $f075d17102cf2205$var$_refreshAll,
                    $f075d17102cf2205$var$_win,
                    "load",
                    $f075d17102cf2205$var$_refreshAll,
                    $f075d17102cf2205$var$_win,
                    "resize",
                    $f075d17102cf2205$var$_onResize
                ];
                $f075d17102cf2205$var$_iterateAutoRefresh($f075d17102cf2205$var$_addListener);
                $f075d17102cf2205$var$_triggers.forEach(function(trigger) {
                    return trigger.enable(0, 1);
                });
                for(i = 0; i < (0, $a52c0798f59d4093$export$3cd1cee43d19b683).length; i += 3){
                    $f075d17102cf2205$var$_wheelListener($f075d17102cf2205$var$_removeListener, (0, $a52c0798f59d4093$export$3cd1cee43d19b683)[i], (0, $a52c0798f59d4093$export$3cd1cee43d19b683)[i + 1]);
                    $f075d17102cf2205$var$_wheelListener($f075d17102cf2205$var$_removeListener, (0, $a52c0798f59d4093$export$3cd1cee43d19b683)[i], (0, $a52c0798f59d4093$export$3cd1cee43d19b683)[i + 2]);
                }
            }
        }
    };
    ScrollTrigger.config = function config(vars) {
        "limitCallbacks" in vars && ($f075d17102cf2205$var$_limitCallbacks = !!vars.limitCallbacks);
        var ms = vars.syncInterval;
        ms && clearInterval($f075d17102cf2205$var$_syncInterval) || ($f075d17102cf2205$var$_syncInterval = ms) && setInterval($f075d17102cf2205$var$_sync, ms);
        "ignoreMobileResize" in vars && ($f075d17102cf2205$var$_ignoreMobileResize = ScrollTrigger.isTouch === 1 && vars.ignoreMobileResize);
        if ("autoRefreshEvents" in vars) {
            $f075d17102cf2205$var$_iterateAutoRefresh($f075d17102cf2205$var$_removeListener) || $f075d17102cf2205$var$_iterateAutoRefresh($f075d17102cf2205$var$_addListener, vars.autoRefreshEvents || "none");
            $f075d17102cf2205$var$_ignoreResize = (vars.autoRefreshEvents + "").indexOf("resize") === -1;
        }
    };
    ScrollTrigger.scrollerProxy = function scrollerProxy(target, vars) {
        var t = (0, $a52c0798f59d4093$export$937374fea3f88711)(target), i = (0, $a52c0798f59d4093$export$3cd1cee43d19b683).indexOf(t), isViewport = $f075d17102cf2205$var$_isViewport(t);
        if (~i) (0, $a52c0798f59d4093$export$3cd1cee43d19b683).splice(i, isViewport ? 6 : 2);
        if (vars) isViewport ? (0, $a52c0798f59d4093$export$d8e56d510a804d0a).unshift($f075d17102cf2205$var$_win, vars, $f075d17102cf2205$var$_body, vars, $f075d17102cf2205$var$_docEl, vars) : (0, $a52c0798f59d4093$export$d8e56d510a804d0a).unshift(t, vars);
    };
    ScrollTrigger.clearMatchMedia = function clearMatchMedia(query) {
        $f075d17102cf2205$var$_triggers.forEach(function(t) {
            return t._ctx && t._ctx.query === query && t._ctx.kill(true, true);
        });
    };
    ScrollTrigger.isInViewport = function isInViewport(element, ratio, horizontal) {
        var bounds = ($f075d17102cf2205$var$_isString(element) ? (0, $a52c0798f59d4093$export$937374fea3f88711)(element) : element).getBoundingClientRect(), offset = bounds[horizontal ? $f075d17102cf2205$var$_width : $f075d17102cf2205$var$_height] * ratio || 0;
        return horizontal ? bounds.right - offset > 0 && bounds.left + offset < $f075d17102cf2205$var$_win.innerWidth : bounds.bottom - offset > 0 && bounds.top + offset < $f075d17102cf2205$var$_win.innerHeight;
    };
    ScrollTrigger.positionInViewport = function positionInViewport(element, referencePoint, horizontal) {
        $f075d17102cf2205$var$_isString(element) && (element = (0, $a52c0798f59d4093$export$937374fea3f88711)(element));
        var bounds = element.getBoundingClientRect(), size = bounds[horizontal ? $f075d17102cf2205$var$_width : $f075d17102cf2205$var$_height], offset = referencePoint == null ? size / 2 : referencePoint in $f075d17102cf2205$var$_keywords ? $f075d17102cf2205$var$_keywords[referencePoint] * size : ~referencePoint.indexOf("%") ? parseFloat(referencePoint) * size / 100 : parseFloat(referencePoint) || 0;
        return horizontal ? (bounds.left + offset) / $f075d17102cf2205$var$_win.innerWidth : (bounds.top + offset) / $f075d17102cf2205$var$_win.innerHeight;
    };
    ScrollTrigger.killAll = function killAll(allowListeners) {
        $f075d17102cf2205$var$_triggers.slice(0).forEach(function(t) {
            return t.vars.id !== "ScrollSmoother" && t.kill();
        });
        if (allowListeners !== true) {
            var listeners = $f075d17102cf2205$var$_listeners.killAll || [];
            $f075d17102cf2205$var$_listeners = {};
            listeners.forEach(function(f) {
                return f();
            });
        }
    };
    return ScrollTrigger;
}();
$f075d17102cf2205$export$875bcbe48555930.version = "3.12.2";
$f075d17102cf2205$export$875bcbe48555930.saveStyles = function(targets) {
    return targets ? $f075d17102cf2205$var$_toArray(targets).forEach(function(target) {
        // saved styles are recorded in a consecutive alternating Array, like [element, cssText, transform attribute, cache, matchMedia, ...]
        if (target && target.style) {
            var i = $f075d17102cf2205$var$_savedStyles.indexOf(target);
            i >= 0 && $f075d17102cf2205$var$_savedStyles.splice(i, 5);
            $f075d17102cf2205$var$_savedStyles.push(target, target.style.cssText, target.getBBox && target.getAttribute("transform"), $f075d17102cf2205$var$gsap.core.getCache(target), $f075d17102cf2205$var$_context());
        }
    }) : $f075d17102cf2205$var$_savedStyles;
};
$f075d17102cf2205$export$875bcbe48555930.revert = function(soft, media) {
    return $f075d17102cf2205$var$_revertAll(!soft, media);
};
$f075d17102cf2205$export$875bcbe48555930.create = function(vars, animation) {
    return new $f075d17102cf2205$export$875bcbe48555930(vars, animation);
};
$f075d17102cf2205$export$875bcbe48555930.refresh = function(safe) {
    return safe ? $f075d17102cf2205$var$_onResize() : ($f075d17102cf2205$var$_coreInitted || $f075d17102cf2205$export$875bcbe48555930.register()) && $f075d17102cf2205$var$_refreshAll(true);
};
$f075d17102cf2205$export$875bcbe48555930.update = function(force) {
    return ++(0, $a52c0798f59d4093$export$3cd1cee43d19b683).cache && $f075d17102cf2205$var$_updateAll(force === true ? 2 : 0);
};
$f075d17102cf2205$export$875bcbe48555930.clearScrollMemory = $f075d17102cf2205$var$_clearScrollMemory;
$f075d17102cf2205$export$875bcbe48555930.maxScroll = function(element, horizontal) {
    return $f075d17102cf2205$var$_maxScroll(element, horizontal ? (0, $a52c0798f59d4093$export$b2cabb342cb0ebe1) : (0, $a52c0798f59d4093$export$8e40fc98ff518e9d));
};
$f075d17102cf2205$export$875bcbe48555930.getScrollFunc = function(element, horizontal) {
    return (0, $a52c0798f59d4093$export$8665aac53dad5647)((0, $a52c0798f59d4093$export$937374fea3f88711)(element), horizontal ? (0, $a52c0798f59d4093$export$b2cabb342cb0ebe1) : (0, $a52c0798f59d4093$export$8e40fc98ff518e9d));
};
$f075d17102cf2205$export$875bcbe48555930.getById = function(id) {
    return $f075d17102cf2205$var$_ids[id];
};
$f075d17102cf2205$export$875bcbe48555930.getAll = function() {
    return $f075d17102cf2205$var$_triggers.filter(function(t) {
        return t.vars.id !== "ScrollSmoother";
    });
}; // it's common for people to ScrollTrigger.getAll(t => t.kill()) on page routes, for example, and we don't want it to ruin smooth scrolling by killing the main ScrollSmoother one.
$f075d17102cf2205$export$875bcbe48555930.isScrolling = function() {
    return !!$f075d17102cf2205$var$_lastScrollTime;
};
$f075d17102cf2205$export$875bcbe48555930.snapDirectional = $f075d17102cf2205$var$_snapDirectional;
$f075d17102cf2205$export$875bcbe48555930.addEventListener = function(type, callback) {
    var a = $f075d17102cf2205$var$_listeners[type] || ($f075d17102cf2205$var$_listeners[type] = []);
    ~a.indexOf(callback) || a.push(callback);
};
$f075d17102cf2205$export$875bcbe48555930.removeEventListener = function(type, callback) {
    var a = $f075d17102cf2205$var$_listeners[type], i = a && a.indexOf(callback);
    i >= 0 && a.splice(i, 1);
};
$f075d17102cf2205$export$875bcbe48555930.batch = function(targets, vars) {
    var result = [], varsCopy = {}, interval = vars.interval || 0.016, batchMax = vars.batchMax || 1e9, proxyCallback = function proxyCallback(type, callback) {
        var elements = [], triggers = [], delay = $f075d17102cf2205$var$gsap.delayedCall(interval, function() {
            callback(elements, triggers);
            elements = [];
            triggers = [];
        }).pause();
        return function(self) {
            elements.length || delay.restart(true);
            elements.push(self.trigger);
            triggers.push(self);
            batchMax <= elements.length && delay.progress(1);
        };
    }, p;
    for(p in vars)varsCopy[p] = p.substr(0, 2) === "on" && $f075d17102cf2205$var$_isFunction(vars[p]) && p !== "onRefreshInit" ? proxyCallback(p, vars[p]) : vars[p];
    if ($f075d17102cf2205$var$_isFunction(batchMax)) {
        batchMax = batchMax();
        $f075d17102cf2205$var$_addListener($f075d17102cf2205$export$875bcbe48555930, "refresh", function() {
            return batchMax = vars.batchMax();
        });
    }
    $f075d17102cf2205$var$_toArray(targets).forEach(function(target) {
        var config = {};
        for(p in varsCopy)config[p] = varsCopy[p];
        config.trigger = target;
        result.push($f075d17102cf2205$export$875bcbe48555930.create(config));
    });
    return result;
}; // to reduce file size. clamps the scroll and also returns a duration multiplier so that if the scroll gets chopped shorter, the duration gets curtailed as well (otherwise if you're very close to the top of the page, for example, and swipe up really fast, it'll suddenly slow down and take a long time to reach the top).
var $f075d17102cf2205$var$_clampScrollAndGetDurationMultiplier = function _clampScrollAndGetDurationMultiplier(scrollFunc, current, end, max) {
    current > max ? scrollFunc(max) : current < 0 && scrollFunc(0);
    return end > max ? (max - current) / (end - current) : end < 0 ? current / (current - end) : 1;
}, $f075d17102cf2205$var$_allowNativePanning = function _allowNativePanning(target, direction) {
    if (direction === true) target.style.removeProperty("touch-action");
    else target.style.touchAction = direction === true ? "auto" : direction ? "pan-" + direction + ((0, $a52c0798f59d4093$export$c1cbdee04e18ea8b).isTouch ? " pinch-zoom" : "") : "none"; // note: Firefox doesn't support it pinch-zoom properly, at least in addition to a pan-x or pan-y.
    target === $f075d17102cf2205$var$_docEl && _allowNativePanning($f075d17102cf2205$var$_body, direction);
}, $f075d17102cf2205$var$_overflow = {
    auto: 1,
    scroll: 1
}, $f075d17102cf2205$var$_nestedScroll = function _nestedScroll(_ref5) {
    var event = _ref5.event, target = _ref5.target, axis = _ref5.axis;
    var node = (event.changedTouches ? event.changedTouches[0] : event).target, cache = node._gsap || $f075d17102cf2205$var$gsap.core.getCache(node), time = $f075d17102cf2205$var$_getTime(), cs;
    if (!cache._isScrollT || time - cache._isScrollT > 2000) {
        // cache for 2 seconds to improve performance.
        while(node && node !== $f075d17102cf2205$var$_body && (node.scrollHeight <= node.clientHeight && node.scrollWidth <= node.clientWidth || !($f075d17102cf2205$var$_overflow[(cs = $f075d17102cf2205$var$_getComputedStyle(node)).overflowY] || $f075d17102cf2205$var$_overflow[cs.overflowX])))node = node.parentNode;
        cache._isScroll = node && node !== target && !$f075d17102cf2205$var$_isViewport(node) && ($f075d17102cf2205$var$_overflow[(cs = $f075d17102cf2205$var$_getComputedStyle(node)).overflowY] || $f075d17102cf2205$var$_overflow[cs.overflowX]);
        cache._isScrollT = time;
    }
    if (cache._isScroll || axis === "x") {
        event.stopPropagation();
        event._gsapAllow = true;
    }
}, // capture events on scrollable elements INSIDE the <body> and allow those by calling stopPropagation() when we find a scrollable ancestor
$f075d17102cf2205$var$_inputObserver = function _inputObserver(target, type, inputs, nested) {
    return (0, $a52c0798f59d4093$export$c1cbdee04e18ea8b).create({
        target: target,
        capture: true,
        debounce: false,
        lockAxis: true,
        type: type,
        onWheel: nested = nested && $f075d17102cf2205$var$_nestedScroll,
        onPress: nested,
        onDrag: nested,
        onScroll: nested,
        onEnable: function onEnable() {
            return inputs && $f075d17102cf2205$var$_addListener($f075d17102cf2205$var$_doc, (0, $a52c0798f59d4093$export$c1cbdee04e18ea8b).eventTypes[0], $f075d17102cf2205$var$_captureInputs, false, true);
        },
        onDisable: function onDisable() {
            return $f075d17102cf2205$var$_removeListener($f075d17102cf2205$var$_doc, (0, $a52c0798f59d4093$export$c1cbdee04e18ea8b).eventTypes[0], $f075d17102cf2205$var$_captureInputs, true);
        }
    });
}, $f075d17102cf2205$var$_inputExp = /(input|label|select|textarea)/i, $f075d17102cf2205$var$_inputIsFocused, $f075d17102cf2205$var$_captureInputs = function _captureInputs(e) {
    var isInput = $f075d17102cf2205$var$_inputExp.test(e.target.tagName);
    if (isInput || $f075d17102cf2205$var$_inputIsFocused) {
        e._gsapAllow = true;
        $f075d17102cf2205$var$_inputIsFocused = isInput;
    }
}, $f075d17102cf2205$var$_getScrollNormalizer = function _getScrollNormalizer(vars) {
    $f075d17102cf2205$var$_isObject(vars) || (vars = {});
    vars.preventDefault = vars.isNormalizer = vars.allowClicks = true;
    vars.type || (vars.type = "wheel,touch");
    vars.debounce = !!vars.debounce;
    vars.id = vars.id || "normalizer";
    var _vars2 = vars, normalizeScrollX = _vars2.normalizeScrollX, momentum = _vars2.momentum, allowNestedScroll = _vars2.allowNestedScroll, onRelease = _vars2.onRelease, self, maxY, target = (0, $a52c0798f59d4093$export$937374fea3f88711)(vars.target) || $f075d17102cf2205$var$_docEl, smoother = $f075d17102cf2205$var$gsap.core.globals().ScrollSmoother, smootherInstance = smoother && smoother.get(), content = $f075d17102cf2205$var$_fixIOSBug && (vars.content && (0, $a52c0798f59d4093$export$937374fea3f88711)(vars.content) || smootherInstance && vars.content !== false && !smootherInstance.smooth() && smootherInstance.content()), scrollFuncY = (0, $a52c0798f59d4093$export$8665aac53dad5647)(target, (0, $a52c0798f59d4093$export$8e40fc98ff518e9d)), scrollFuncX = (0, $a52c0798f59d4093$export$8665aac53dad5647)(target, (0, $a52c0798f59d4093$export$b2cabb342cb0ebe1)), scale = 1, initialScale = ((0, $a52c0798f59d4093$export$c1cbdee04e18ea8b).isTouch && $f075d17102cf2205$var$_win.visualViewport ? $f075d17102cf2205$var$_win.visualViewport.scale * $f075d17102cf2205$var$_win.visualViewport.width : $f075d17102cf2205$var$_win.outerWidth) / $f075d17102cf2205$var$_win.innerWidth, wheelRefresh = 0, resolveMomentumDuration = $f075d17102cf2205$var$_isFunction(momentum) ? function() {
        return momentum(self);
    } : function() {
        return momentum || 2.8;
    }, lastRefreshID, skipTouchMove, inputObserver = $f075d17102cf2205$var$_inputObserver(target, vars.type, true, allowNestedScroll), resumeTouchMove = function resumeTouchMove() {
        return skipTouchMove = false;
    }, scrollClampX = $f075d17102cf2205$var$_passThrough, scrollClampY = $f075d17102cf2205$var$_passThrough, updateClamps = function updateClamps() {
        maxY = $f075d17102cf2205$var$_maxScroll(target, (0, $a52c0798f59d4093$export$8e40fc98ff518e9d));
        scrollClampY = $f075d17102cf2205$var$_clamp($f075d17102cf2205$var$_fixIOSBug ? 1 : 0, maxY);
        normalizeScrollX && (scrollClampX = $f075d17102cf2205$var$_clamp(0, $f075d17102cf2205$var$_maxScroll(target, (0, $a52c0798f59d4093$export$b2cabb342cb0ebe1))));
        lastRefreshID = $f075d17102cf2205$var$_refreshID;
    }, removeContentOffset = function removeContentOffset() {
        content._gsap.y = $f075d17102cf2205$var$_round(parseFloat(content._gsap.y) + scrollFuncY.offset) + "px";
        content.style.transform = "matrix3d(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, " + parseFloat(content._gsap.y) + ", 0, 1)";
        scrollFuncY.offset = scrollFuncY.cacheID = 0;
    }, ignoreDrag = function ignoreDrag() {
        if (skipTouchMove) {
            requestAnimationFrame(resumeTouchMove);
            var offset = $f075d17102cf2205$var$_round(self.deltaY / 2), scroll = scrollClampY(scrollFuncY.v - offset);
            if (content && scroll !== scrollFuncY.v + scrollFuncY.offset) {
                scrollFuncY.offset = scroll - scrollFuncY.v;
                var y = $f075d17102cf2205$var$_round((parseFloat(content && content._gsap.y) || 0) - scrollFuncY.offset);
                content.style.transform = "matrix3d(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, " + y + ", 0, 1)";
                content._gsap.y = y + "px";
                scrollFuncY.cacheID = (0, $a52c0798f59d4093$export$3cd1cee43d19b683).cache;
                $f075d17102cf2205$var$_updateAll();
            }
            return true;
        }
        scrollFuncY.offset && removeContentOffset();
        skipTouchMove = true;
    }, tween, startScrollX, startScrollY, onStopDelayedCall, onResize = function onResize() {
        // if the window resizes, like on an iPhone which Apple FORCES the address bar to show/hide even if we event.preventDefault(), it may be scrolling too far now that the address bar is showing, so we must dynamically adjust the momentum tween.
        updateClamps();
        if (tween.isActive() && tween.vars.scrollY > maxY) scrollFuncY() > maxY ? tween.progress(1) && scrollFuncY(maxY) : tween.resetTo("scrollY", maxY);
    };
    content && $f075d17102cf2205$var$gsap.set(content, {
        y: "+=0"
    }); // to ensure there's a cache (element._gsap)
    vars.ignoreCheck = function(e) {
        return $f075d17102cf2205$var$_fixIOSBug && e.type === "touchmove" && ignoreDrag(e) || scale > 1.05 && e.type !== "touchstart" || self.isGesturing || e.touches && e.touches.length > 1;
    };
    vars.onPress = function() {
        skipTouchMove = false;
        var prevScale = scale;
        scale = $f075d17102cf2205$var$_round(($f075d17102cf2205$var$_win.visualViewport && $f075d17102cf2205$var$_win.visualViewport.scale || 1) / initialScale);
        tween.pause();
        prevScale !== scale && $f075d17102cf2205$var$_allowNativePanning(target, scale > 1.01 ? true : normalizeScrollX ? false : "x");
        startScrollX = scrollFuncX();
        startScrollY = scrollFuncY();
        updateClamps();
        lastRefreshID = $f075d17102cf2205$var$_refreshID;
    };
    vars.onRelease = vars.onGestureStart = function(self, wasDragging) {
        scrollFuncY.offset && removeContentOffset();
        if (!wasDragging) onStopDelayedCall.restart(true);
        else {
            (0, $a52c0798f59d4093$export$3cd1cee43d19b683).cache++; // make sure we're pulling the non-cached value
            // alternate algorithm: durX = Math.min(6, Math.abs(self.velocityX / 800)),	dur = Math.max(durX, Math.min(6, Math.abs(self.velocityY / 800))); dur = dur * (0.4 + (1 - _power4In(dur / 6)) * 0.6)) * (momentumSpeed || 1)
            var dur = resolveMomentumDuration(), currentScroll, endScroll;
            if (normalizeScrollX) {
                currentScroll = scrollFuncX();
                endScroll = currentScroll + dur * 0.05 * -self.velocityX / 0.227; // the constant .227 is from power4(0.05). velocity is inverted because scrolling goes in the opposite direction.
                dur *= $f075d17102cf2205$var$_clampScrollAndGetDurationMultiplier(scrollFuncX, currentScroll, endScroll, $f075d17102cf2205$var$_maxScroll(target, (0, $a52c0798f59d4093$export$b2cabb342cb0ebe1)));
                tween.vars.scrollX = scrollClampX(endScroll);
            }
            currentScroll = scrollFuncY();
            endScroll = currentScroll + dur * 0.05 * -self.velocityY / 0.227; // the constant .227 is from power4(0.05)
            dur *= $f075d17102cf2205$var$_clampScrollAndGetDurationMultiplier(scrollFuncY, currentScroll, endScroll, $f075d17102cf2205$var$_maxScroll(target, (0, $a52c0798f59d4093$export$8e40fc98ff518e9d)));
            tween.vars.scrollY = scrollClampY(endScroll);
            tween.invalidate().duration(dur).play(0.01);
            if ($f075d17102cf2205$var$_fixIOSBug && tween.vars.scrollY >= maxY || currentScroll >= maxY - 1) // iOS bug: it'll show the address bar but NOT fire the window "resize" event until the animation is done but we must protect against overshoot so we leverage an onUpdate to do so.
            $f075d17102cf2205$var$gsap.to({}, {
                onUpdate: onResize,
                duration: dur
            });
        }
        onRelease && onRelease(self);
    };
    vars.onWheel = function() {
        tween._ts && tween.pause();
        if ($f075d17102cf2205$var$_getTime() - wheelRefresh > 1000) {
            // after 1 second, refresh the clamps otherwise that'll only happen when ScrollTrigger.refresh() is called or for touch-scrolling.
            lastRefreshID = 0;
            wheelRefresh = $f075d17102cf2205$var$_getTime();
        }
    };
    vars.onChange = function(self, dx, dy, xArray, yArray) {
        $f075d17102cf2205$var$_refreshID !== lastRefreshID && updateClamps();
        dx && normalizeScrollX && scrollFuncX(scrollClampX(xArray[2] === dx ? startScrollX + (self.startX - self.x) : scrollFuncX() + dx - xArray[1])); // for more precision, we track pointer/touch movement from the start, otherwise it'll drift.
        if (dy) {
            scrollFuncY.offset && removeContentOffset();
            var isTouch = yArray[2] === dy, y = isTouch ? startScrollY + self.startY - self.y : scrollFuncY() + dy - yArray[1], yClamped = scrollClampY(y);
            isTouch && y !== yClamped && (startScrollY += yClamped - y);
            scrollFuncY(yClamped);
        }
        (dy || dx) && $f075d17102cf2205$var$_updateAll();
    };
    vars.onEnable = function() {
        $f075d17102cf2205$var$_allowNativePanning(target, normalizeScrollX ? false : "x");
        $f075d17102cf2205$export$875bcbe48555930.addEventListener("refresh", onResize);
        $f075d17102cf2205$var$_addListener($f075d17102cf2205$var$_win, "resize", onResize);
        if (scrollFuncY.smooth) {
            scrollFuncY.target.style.scrollBehavior = "auto";
            scrollFuncY.smooth = scrollFuncX.smooth = false;
        }
        inputObserver.enable();
    };
    vars.onDisable = function() {
        $f075d17102cf2205$var$_allowNativePanning(target, true);
        $f075d17102cf2205$var$_removeListener($f075d17102cf2205$var$_win, "resize", onResize);
        $f075d17102cf2205$export$875bcbe48555930.removeEventListener("refresh", onResize);
        inputObserver.kill();
    };
    vars.lockAxis = vars.lockAxis !== false;
    self = new (0, $a52c0798f59d4093$export$c1cbdee04e18ea8b)(vars);
    self.iOS = $f075d17102cf2205$var$_fixIOSBug; // used in the Observer getCachedScroll() function to work around an iOS bug that wreaks havoc with TouchEvent.clientY if we allow scroll to go all the way back to 0.
    $f075d17102cf2205$var$_fixIOSBug && !scrollFuncY() && scrollFuncY(1); // iOS bug causes event.clientY values to freak out (wildly inaccurate) if the scroll position is exactly 0.
    $f075d17102cf2205$var$_fixIOSBug && $f075d17102cf2205$var$gsap.ticker.add($f075d17102cf2205$var$_passThrough); // prevent the ticker from sleeping
    onStopDelayedCall = self._dc;
    tween = $f075d17102cf2205$var$gsap.to(self, {
        ease: "power4",
        paused: true,
        scrollX: normalizeScrollX ? "+=0.1" : "+=0",
        scrollY: "+=0.1",
        modifiers: {
            scrollY: $f075d17102cf2205$var$_interruptionTracker(scrollFuncY, scrollFuncY(), function() {
                return tween.pause();
            })
        },
        onUpdate: $f075d17102cf2205$var$_updateAll,
        onComplete: onStopDelayedCall.vars.onComplete
    }); // we need the modifier to sense if the scroll position is altered outside of the momentum tween (like with a scrollTo tween) so we can pause() it to prevent conflicts.
    return self;
};
$f075d17102cf2205$export$875bcbe48555930.sort = function(func) {
    return $f075d17102cf2205$var$_triggers.sort(func || function(a, b) {
        return (a.vars.refreshPriority || 0) * -1000000 + a.start - (b.start + (b.vars.refreshPriority || 0) * -1000000);
    });
};
$f075d17102cf2205$export$875bcbe48555930.observe = function(vars) {
    return new (0, $a52c0798f59d4093$export$c1cbdee04e18ea8b)(vars);
};
$f075d17102cf2205$export$875bcbe48555930.normalizeScroll = function(vars) {
    if (typeof vars === "undefined") return $f075d17102cf2205$var$_normalizer;
    if (vars === true && $f075d17102cf2205$var$_normalizer) return $f075d17102cf2205$var$_normalizer.enable();
    if (vars === false) return $f075d17102cf2205$var$_normalizer && $f075d17102cf2205$var$_normalizer.kill();
    var normalizer = vars instanceof (0, $a52c0798f59d4093$export$c1cbdee04e18ea8b) ? vars : $f075d17102cf2205$var$_getScrollNormalizer(vars);
    $f075d17102cf2205$var$_normalizer && $f075d17102cf2205$var$_normalizer.target === normalizer.target && $f075d17102cf2205$var$_normalizer.kill();
    $f075d17102cf2205$var$_isViewport(normalizer.target) && ($f075d17102cf2205$var$_normalizer = normalizer);
    return normalizer;
};
$f075d17102cf2205$export$875bcbe48555930.core = {
    // smaller file size way to leverage in ScrollSmoother and Observer
    _getVelocityProp: (0, $a52c0798f59d4093$export$5de019f4480f0f8d),
    _inputObserver: $f075d17102cf2205$var$_inputObserver,
    _scrollers: (0, $a52c0798f59d4093$export$3cd1cee43d19b683),
    _proxies: (0, $a52c0798f59d4093$export$d8e56d510a804d0a),
    bridge: {
        // when normalizeScroll sets the scroll position (ss = setScroll)
        ss: function ss() {
            $f075d17102cf2205$var$_lastScrollTime || $f075d17102cf2205$var$_dispatch("scrollStart");
            $f075d17102cf2205$var$_lastScrollTime = $f075d17102cf2205$var$_getTime();
        },
        // a way to get the _refreshing value in Observer
        ref: function ref() {
            return $f075d17102cf2205$var$_refreshing;
        }
    }
};
$f075d17102cf2205$var$_getGSAP() && $f075d17102cf2205$var$gsap.registerPlugin($f075d17102cf2205$export$875bcbe48555930);


/**
 * SplitType
 * https://github.com/lukePeavey/SplitType
 * @version 0.3.3
 * @author Luke Peavey <lwpeavey@gmail.com>
 */ // Polyfill the following DOM methods that are not supported in IE 11.
(()=>{
    function append(...nodes) {
        const length = nodes.length;
        for(let i = 0; i < length; i++){
            const node = nodes[i];
            if (node.nodeType === 1 || node.nodeType === 11) this.appendChild(node);
            else this.appendChild(document.createTextNode(String(node)));
        }
    }
    function replaceChildren(...nodes) {
        while(this.lastChild)this.removeChild(this.lastChild);
        if (nodes.length) this.append(...nodes);
    }
    function replaceWith(...nodes) {
        const parent = this.parentNode;
        let i = nodes.length;
        if (!parent) return;
        if (!i) parent.removeChild(this);
        while(i--){
            let node = nodes[i];
            if (typeof node !== "object") node = this.ownerDocument.createTextNode(node);
            else if (node.parentNode) node.parentNode.removeChild(node);
            if (!i) parent.replaceChild(node, this);
            else parent.insertBefore(this.previousSibling, node);
        }
    }
    if (typeof Element !== "undefined") {
        if (!Element.prototype.append) {
            Element.prototype.append = append;
            DocumentFragment.prototype.append = append;
        }
        if (!Element.prototype.replaceChildren) {
            Element.prototype.replaceChildren = replaceChildren;
            DocumentFragment.prototype.replaceChildren = replaceChildren;
        }
        if (!Element.prototype.replaceWith) {
            Element.prototype.replaceWith = replaceWith;
            DocumentFragment.prototype.replaceWith = replaceWith;
        }
    }
})();
/**
 * Shallow merges the properties of an object with the target object. Only
 * includes properties that exist on the target object. Non-writable properties
 * on the target object will not be over-written.
 *
 * @param {Object} target
 * @param {Object} object
 */ function $954fd737020e73f8$var$extend(target, object) {
    return Object.getOwnPropertyNames(Object(target)).reduce((extended, key)=>{
        const currentValue = Object.getOwnPropertyDescriptor(Object(target), key);
        const newValue = Object.getOwnPropertyDescriptor(Object(object), key);
        return Object.defineProperty(extended, key, newValue || currentValue);
    }, {});
}
/**
 * Checks if given value is a string
 *
 * @param {any} value
 * @return {boolean} `true` if `value` is a string, else `false`
 */ function $954fd737020e73f8$var$isString(value) {
    return typeof value === "string";
}
function $954fd737020e73f8$var$isArray(value) {
    return Array.isArray(value);
}
/**
 * Parses user supplied settings objects.
 */ function $954fd737020e73f8$var$parseSettings(settings = {}) {
    const object = $954fd737020e73f8$var$extend(settings); // `split` may be used as an alias for the `types` option
    // Parse the `types` settings into an array of valid split types.
    // If `types` is explicitly set to an empty string or array, text will not be
    // split at all.
    let types;
    if (object.types !== undefined) types = object.types;
    else if (object.split !== undefined) types = object.split;
    if (types !== undefined) object.types = ($954fd737020e73f8$var$isString(types) || $954fd737020e73f8$var$isArray(types) ? String(types) : "").split(",").map((type)=>String(type).trim()).filter((type)=>/((line)|(word)|(char))/i.test(type));
     // Support `position: absolute` as an alias for `absolute: true`
    if (object.absolute || object.position) object.absolute = object.absolute || /absolute/.test(settings.position);
    return object;
}
/**
 * Takes a list of `types` and returns an object
 *
 * @param {string | string[]} value a comma separated list of split types
 * @return {{lines: boolean, words: boolean, chars: boolean}}
 */ function $954fd737020e73f8$var$parseTypes(value) {
    const types = $954fd737020e73f8$var$isString(value) || $954fd737020e73f8$var$isArray(value) ? String(value) : "";
    return {
        none: !types,
        lines: /line/i.test(types),
        words: /word/i.test(types),
        chars: /char/i.test(types)
    };
}
/**
 * Returns true if `value` is a non-null object.
 * @param {any} value
 * @return {boolean}
 */ function $954fd737020e73f8$var$isObject(value) {
    return value !== null && typeof value === "object";
}
/**
 * Returns true if `input` is one of the following:
 * - `Element`
 * - `Text`
 * - `DocumentFragment`
 */ function $954fd737020e73f8$var$isNode(input) {
    return $954fd737020e73f8$var$isObject(input) && /^(1|3|11)$/.test(input.nodeType);
}
/**
 * Checks if `value` is a valid array-like length.
 * Original source: Lodash
 *
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3)
 * // => true
 *
 * _.isLength(Number.MIN_VALUE)
 * // => false
 *
 * _.isLength(Infinity)
 * // => false
 *
 * _.isLength('3')
 * // => false
 */ function $954fd737020e73f8$var$isLength(value) {
    return typeof value === "number" && value > -1 && value % 1 === 0;
}
/**
 * Checks if `value` is an array-like object
 * @param {any} value
 * @return {boolean} true if `value` is array-like`, else `false`
 * @example
 * isArrayLike(new Array())
 * // => true
 *
 * isArrayLike(document.querySelectorAll('div'))
 * // => true
 *
 * isArrayLike(document.getElementsByTagName('div'))
 * // => true
 *
 * isArrayLike(() => {})
 * // => false
 *
 * isArrayLike({foo: 'bar'})
 * // => false
 *
 * * isArrayLike(null)
 * // => false
 */ function $954fd737020e73f8$var$isArrayLike(value) {
    return $954fd737020e73f8$var$isObject(value) && $954fd737020e73f8$var$isLength(value.length);
}
/**
 * Coerces `value` to an `Array`.
 *
 * @param {any} value
 * @return {any[]}
 * @example
 * // If `value` is any `Array`, returns original `Array`
 * let arr = [1, 2]
 * toArray(arr)
 * // => arr
 *
 * // If `value` is an `ArrayLike`, its equivalent to `Array.from(value)`
 * let nodeList = document.querySelectorAll('div')
 * toArray(nodeList)
 * // => HTMLElement[] s
 *
 * // If value is falsy, returns empty array
 * toArray(null)
 * // => []
 *
 * // For any other type of value, its equivalent to `Array.of(value)`
 * let element = document.createElement('div')
 * toArray(element)
 * // => [element]
 *
 */ function $954fd737020e73f8$var$toArray(value) {
    if ($954fd737020e73f8$var$isArray(value)) return value;
    if (value == null) return [];
    return $954fd737020e73f8$var$isArrayLike(value) ? Array.prototype.slice.call(value) : [
        value
    ];
}
/**
 * Processes target elements for the splitType function.
 *
 * @param {any} target Can be one of the following:
 * 1. `string` - A css selector
 * 2. `HTMLElement` - A single element
 * 3. `NodeList` - A nodeList
 * 4. `Element[]` - An array of elements
 * 5. `Array<NodeList|Element[]>` - An nested array of elements
 * @returns {Element[]} A flat array HTML elements
 * @return A flat array of elements or empty array if no elements are found
 */ function $954fd737020e73f8$var$getTargetElements(target) {
    let elements = target; // If `target` is a selector string...
    if ($954fd737020e73f8$var$isString(target)) {
        if (/^(#[a-z]\w+)$/.test(target.trim())) // If `target` is an ID, use `getElementById`
        elements = document.getElementById(target.trim().slice(1));
        else // Else use `querySelectorAll`
        elements = document.querySelectorAll(target);
    } // Return a flattened array of elements
    return $954fd737020e73f8$var$toArray(elements).reduce((result, element)=>{
        return [
            ...result,
            ...$954fd737020e73f8$var$toArray(element).filter($954fd737020e73f8$var$isNode)
        ];
    }, []);
}
const { entries: $954fd737020e73f8$var$entries, keys: $954fd737020e73f8$var$keys, values: $954fd737020e73f8$var$values } = Object;
const $954fd737020e73f8$var$expando = `_splittype`;
const $954fd737020e73f8$var$cache = {};
let $954fd737020e73f8$var$uid = 0;
/**
 * Stores data associated with DOM elements or other objects. This is a
 * simplified version of jQuery's data method.
 *
 * @signature Data(owner)
 * @description Get the data store object for the given owner.
 * @param {Object} owner the object that data will be associated with.
 * @return {Object} the data object for given `owner`. If no data exists
 *     for the given object, creates a new data store and returns it.
 *
 * @signature Data(owner, key)
 * @description Get the value
 * @param {Object} owner
 * @param {string} key
 * @return {any} the value of the provided key. If key does not exist, returns
 *     undefined.
 *
 * @signature Data(owner, key, value)
 * @description Sets the given key/value pair in data store
 * @param {Object} owner
 * @param {string} key
 * @param {any} value
 */ function $954fd737020e73f8$var$set(owner, key, value) {
    if (!$954fd737020e73f8$var$isObject(owner)) {
        console.warn("[data.set] owner is not an object");
        return null;
    }
    const id = owner[$954fd737020e73f8$var$expando] || (owner[$954fd737020e73f8$var$expando] = ++$954fd737020e73f8$var$uid);
    const data = $954fd737020e73f8$var$cache[id] || ($954fd737020e73f8$var$cache[id] = {});
    if (value === undefined) {
        if (!!key && Object.getPrototypeOf(key) === Object.prototype) $954fd737020e73f8$var$cache[id] = {
            ...data,
            ...key
        };
    } else if (key !== undefined) data[key] = value;
    return value;
}
function $954fd737020e73f8$var$get(owner, key) {
    const id = $954fd737020e73f8$var$isObject(owner) ? owner[$954fd737020e73f8$var$expando] : null;
    const data = id && $954fd737020e73f8$var$cache[id] || {};
    if (key === undefined) return data;
    return data[key];
}
/**
 * Remove all data associated with the given element
 */ function $954fd737020e73f8$var$remove(element) {
    const id = element && element[$954fd737020e73f8$var$expando];
    if (id) {
        delete element[id];
        delete $954fd737020e73f8$var$cache[id];
    }
}
/**
 * Remove all temporary data from the store.
 */ function $954fd737020e73f8$var$cleanup() {
    $954fd737020e73f8$var$entries($954fd737020e73f8$var$cache).forEach(([id, { isRoot: isRoot, isSplit: isSplit }])=>{
        if (!isRoot || !isSplit) {
            $954fd737020e73f8$var$cache[id] = null;
            delete $954fd737020e73f8$var$cache[id];
        }
    });
}
/**
 * Splits a string into an array of words.
 *
 * @param {string} string
 * @param {string | RegExp} [separator = ' ']
 * @return {string[]} Array of words
 */ function $954fd737020e73f8$var$toWords(value, separator = " ") {
    const string = value ? String(value) : "";
    return string.trim().replace(/\s+/g, " ").split(separator);
}
/**
 * Based on lodash#split <https://lodash.com/license>
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters &
 * Editors
 */ const $954fd737020e73f8$var$rsAstralRange = "\ud800-\udfff";
const $954fd737020e73f8$var$rsComboMarksRange = "\\u0300-\\u036f\\ufe20-\\ufe23";
const $954fd737020e73f8$var$rsComboSymbolsRange = "\\u20d0-\\u20f0";
const $954fd737020e73f8$var$rsVarRange = "\\ufe0e\\ufe0f";
/** Used to compose unicode capture groups. */ const $954fd737020e73f8$var$rsAstral = `[${$954fd737020e73f8$var$rsAstralRange}]`;
const $954fd737020e73f8$var$rsCombo = `[${$954fd737020e73f8$var$rsComboMarksRange}${$954fd737020e73f8$var$rsComboSymbolsRange}]`;
const $954fd737020e73f8$var$rsFitz = "\ud83c[\udffb-\udfff]";
const $954fd737020e73f8$var$rsModifier = `(?:${$954fd737020e73f8$var$rsCombo}|${$954fd737020e73f8$var$rsFitz})`;
const $954fd737020e73f8$var$rsNonAstral = `[^${$954fd737020e73f8$var$rsAstralRange}]`;
const $954fd737020e73f8$var$rsRegional = "(?:\ud83c[\udde6-\uddff]){2}";
const $954fd737020e73f8$var$rsSurrPair = "[\ud800-\udbff][\udc00-\udfff]";
const $954fd737020e73f8$var$rsZWJ = "\\u200d";
/** Used to compose unicode regexes. */ const $954fd737020e73f8$var$reOptMod = `${$954fd737020e73f8$var$rsModifier}?`;
const $954fd737020e73f8$var$rsOptVar = `[${$954fd737020e73f8$var$rsVarRange}]?`;
const $954fd737020e73f8$var$rsOptJoin = "(?:" + $954fd737020e73f8$var$rsZWJ + "(?:" + [
    $954fd737020e73f8$var$rsNonAstral,
    $954fd737020e73f8$var$rsRegional,
    $954fd737020e73f8$var$rsSurrPair
].join("|") + ")" + $954fd737020e73f8$var$rsOptVar + $954fd737020e73f8$var$reOptMod + ")*";
const $954fd737020e73f8$var$rsSeq = $954fd737020e73f8$var$rsOptVar + $954fd737020e73f8$var$reOptMod + $954fd737020e73f8$var$rsOptJoin;
const $954fd737020e73f8$var$rsSymbol = `(?:${[
    `${$954fd737020e73f8$var$rsNonAstral}${$954fd737020e73f8$var$rsCombo}?`,
    $954fd737020e73f8$var$rsCombo,
    $954fd737020e73f8$var$rsRegional,
    $954fd737020e73f8$var$rsSurrPair,
    $954fd737020e73f8$var$rsAstral
].join("|")}
)`;
/** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */ const $954fd737020e73f8$var$reUnicode = RegExp(`${$954fd737020e73f8$var$rsFitz}(?=${$954fd737020e73f8$var$rsFitz})|${$954fd737020e73f8$var$rsSymbol}${$954fd737020e73f8$var$rsSeq}`, "g");
/** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */ const $954fd737020e73f8$var$unicodeRange = [
    $954fd737020e73f8$var$rsZWJ,
    $954fd737020e73f8$var$rsAstralRange,
    $954fd737020e73f8$var$rsComboMarksRange,
    $954fd737020e73f8$var$rsComboSymbolsRange,
    $954fd737020e73f8$var$rsVarRange
];
const $954fd737020e73f8$var$reHasUnicode = RegExp(`[${$954fd737020e73f8$var$unicodeRange.join("")}]`);
/**
 * Converts an ASCII `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */ function $954fd737020e73f8$var$asciiToArray(string) {
    return string.split("");
}
/**
 * Checks if `string` contains Unicode symbols.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {boolean} Returns `true` if a symbol is found, else `false`.
 */ function $954fd737020e73f8$var$hasUnicode(string) {
    return $954fd737020e73f8$var$reHasUnicode.test(string);
}
/**
 * Converts a Unicode `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */ function $954fd737020e73f8$var$unicodeToArray(string) {
    return string.match($954fd737020e73f8$var$reUnicode) || [];
}
/**
 * Converts `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */ function $954fd737020e73f8$var$stringToArray(string) {
    return $954fd737020e73f8$var$hasUnicode(string) ? $954fd737020e73f8$var$unicodeToArray(string) : $954fd737020e73f8$var$asciiToArray(string);
}
/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values.
 *
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */ function $954fd737020e73f8$var$toString(value) {
    return value == null ? "" : String(value);
}
/**
 * Splits `string` into an array of characters. If `separator` is omitted,
 * it behaves likes split.split('').
 *
 * Unlike native string.split(''), it can split strings that contain unicode
 * characters like emojis and symbols.
 *
 * @param {string} [string=''] The string to split.
 * @param {RegExp|string} [separator=''] The separator pattern to split by.
 * @returns {Array} Returns the string segments.
 * @example
 * toChars('foo');
 * // => ['f', 'o', 'o']
 *
 * toChars('foo bar');
 * // => ["f", "o", "o", " ", "b", "a", "r"]
 *
 * toChars('f😀o');
 * // => ['f', '😀', 'o']
 *
 * toChars('f-😀-o', /-/);
 * // => ['f', '😀', 'o']
 *
 */ function $954fd737020e73f8$var$toChars(string, separator = "") {
    string = $954fd737020e73f8$var$toString(string);
    if (string && $954fd737020e73f8$var$isString(string)) {
        if (!separator && $954fd737020e73f8$var$hasUnicode(string)) return $954fd737020e73f8$var$stringToArray(string);
    }
    return string.split(separator);
}
/**
 * Create an HTML element with the the given attributes
 *
 * attributes can include standard HTML attribute, as well as the following
 * "special" properties:
 *   - children: HTMLElement | ArrayLike<HTMLElement>
 *   - textContent: string
 *   - innerHTML: string
 *
 * @param {string} name
 * @param  {Object} [attributes]
 * @returns {HTMLElement}
 */ function $954fd737020e73f8$var$createElement(name, attributes) {
    const element = document.createElement(name);
    if (!attributes) // When called without the second argument, its just return the result
    // of `document.createElement`
    return element;
    Object.keys(attributes).forEach((attribute)=>{
        const rawValue = attributes[attribute];
        const value = $954fd737020e73f8$var$isString(rawValue) ? rawValue.trim() : rawValue; // Ignore attribute if the value is `null` or an empty string
        if (value === null || value === "") return;
        if (attribute === "children") // Children can be one or more Elements or DOM strings
        element.append(...$954fd737020e73f8$var$toArray(value));
        else // Handle standard HTML attributes
        element.setAttribute(attribute, value);
    });
    return element;
}
var $954fd737020e73f8$var$defaults = {
    splitClass: "",
    lineClass: "line",
    wordClass: "word",
    charClass: "char",
    types: [
        "lines",
        "words",
        "chars"
    ],
    absolute: false,
    tagName: "div"
};
/**
 * Splits the text content of a single TextNode into words and/or characters.
 *
 * This functions gets called for every text node inside the target element. It
 * replaces the text node with a document fragment containing the split text.
 * Returns an array of the split word and character elements from this node.
 *
 * @param {TextNode} textNode
 * @param {Object} settings
 * @return {{words: Element[], chars: Element[]}}
 */ function $954fd737020e73f8$var$splitWordsAndChars(textNode, settings) {
    settings = $954fd737020e73f8$var$extend($954fd737020e73f8$var$defaults, settings); // The split types
    const types = $954fd737020e73f8$var$parseTypes(settings.types); // the tag name for split text nodes
    const TAG_NAME = settings.tagName; // value of the text node
    const VALUE = textNode.nodeValue; // `splitText` is a wrapper to hold the HTML structure
    const splitText = document.createDocumentFragment(); // Arrays of split word and character elements
    let words = [];
    let chars = [];
    if (/^\s/.test(VALUE)) splitText.append(" ");
     // Create an array of wrapped word elements.
    words = $954fd737020e73f8$var$toWords(VALUE).reduce((result, WORD, idx, arr)=>{
        // Let `wordElement` be the wrapped element for the current word
        let wordElement;
        let characterElementsForCurrentWord; // -> If splitting text into characters...
        if (types.chars) // Iterate through the characters in the current word
        characterElementsForCurrentWord = $954fd737020e73f8$var$toChars(WORD).map((CHAR)=>{
            const characterElement = $954fd737020e73f8$var$createElement(TAG_NAME, {
                class: `${settings.splitClass} ${settings.charClass}`,
                style: "display: inline-block;",
                children: CHAR
            });
            $954fd737020e73f8$var$set(characterElement, "isChar", true);
            chars = [
                ...chars,
                characterElement
            ];
            return characterElement;
        });
         // END IF;
        if (types.words || types.lines) {
            // -> If Splitting Text Into Words...
            //    Create an element to wrap the current word. If we are also
            //    splitting text into characters, the word element will contain the
            //    wrapped character nodes for this word. If not, it will contain the
            //    plain text content (WORD)
            wordElement = $954fd737020e73f8$var$createElement(TAG_NAME, {
                class: `${settings.wordClass} ${settings.splitClass}`,
                style: `display: inline-block; ${types.words && settings.absolute ? `position: relative;` : ""}`,
                children: types.chars ? characterElementsForCurrentWord : WORD
            });
            $954fd737020e73f8$var$set(wordElement, {
                isWord: true,
                isWordStart: true,
                isWordEnd: true
            });
            splitText.appendChild(wordElement);
        } else // -> If NOT splitting into words OR lines...
        //    Append the characters elements directly to splitText.
        characterElementsForCurrentWord.forEach((characterElement)=>{
            splitText.appendChild(characterElement);
        });
        if (idx < arr.length - 1) // Add a space after the word.
        splitText.append(" ");
         // If not splitting text into words, we return an empty array
        return types.words ? result.concat(wordElement) : result;
    }, []); // END LOOP;
    // Add a trailing white space to maintain word spacing
    if (/\s$/.test(VALUE)) splitText.append(" ");
    textNode.replaceWith(splitText);
    return {
        words: words,
        chars: chars
    };
}
/**
 * Splits the text content of a target element into words and/or characters.
 * The function is recursive, it will also split the text content of any child
 * elements into words/characters, while preserving the nested elements.
 *
 * @param {Node} node an HTML Element or Text Node
 * @param {Object} setting splitType settings
 */ function $954fd737020e73f8$var$split(node, settings) {
    const type = node.nodeType; // Arrays of split words and characters
    const wordsAndChars = {
        words: [],
        chars: []
    }; // Only proceed if `node` is an `Element`, `Fragment`, or `Text`
    if (!/(1|3|11)/.test(type)) return wordsAndChars;
     // A) IF `node` is TextNode that contains characters other than white space...
    //    Split the text content of the node into words and/or characters
    //    return an object containing the split word and character elements
    if (type === 3 && /\S/.test(node.nodeValue)) return $954fd737020e73f8$var$splitWordsAndChars(node, settings);
     // B) ELSE `node` is an 'Element'
    //    Iterate through its child nodes, calling the `split` function
    //    recursively for each child node.
    const childNodes = $954fd737020e73f8$var$toArray(node.childNodes);
    if (childNodes.length) {
        $954fd737020e73f8$var$set(node, "isSplit", true); // we need to set a few styles on nested html elements
        if (!$954fd737020e73f8$var$get(node).isRoot) {
            node.style.display = "inline-block";
            node.style.position = "relative"; // To maintain original spacing around nested elements when we are
            // splitting text into lines, we need to check if the element should
            // have a space before and after, and store that value for later.
            // Note: this was necessary to maintain the correct spacing when nested
            // elements do not align with word boundaries. For example, a nested
            // element only wraps part of a word.
            const nextSibling = node.nextSibling;
            const prevSibling = node.previousSibling;
            const text = node.textContent || "";
            const textAfter = nextSibling ? nextSibling.textContent : " ";
            const textBefore = prevSibling ? prevSibling.textContent : " ";
            $954fd737020e73f8$var$set(node, {
                isWordEnd: /\s$/.test(text) || /^\s/.test(textAfter),
                isWordStart: /^\s/.test(text) || /\s$/.test(textBefore)
            });
        }
    } // Iterate through child nodes, calling `split` recursively
    // Returns an object containing all split words and chars
    return childNodes.reduce((result, child)=>{
        const { words: words, chars: chars } = $954fd737020e73f8$var$split(child, settings);
        return {
            words: [
                ...result.words,
                ...words
            ],
            chars: [
                ...result.chars,
                ...chars
            ]
        };
    }, wordsAndChars);
}
/**
 * Gets the height and position of an element relative to offset parent.
 * Should be equivalent to offsetTop and offsetHeight, but with sub-pixel
 * precision.
 *
 * TODO needs work
 */ function $954fd737020e73f8$var$getPosition(node, isWord, settings, scrollPos) {
    if (!settings.absolute) return {
        top: isWord ? node.offsetTop : null
    };
    const parent = node.offsetParent;
    const [scrollX, scrollY] = scrollPos;
    let parentX = 0;
    let parentY = 0;
    if (parent && parent !== document.body) {
        const parentRect = parent.getBoundingClientRect();
        parentX = parentRect.x + scrollX;
        parentY = parentRect.y + scrollY;
    }
    const { width: width, height: height, x: x, y: y } = node.getBoundingClientRect();
    const top = y + scrollY - parentY;
    const left = x + scrollX - parentX;
    return {
        width: width,
        height: height,
        top: top,
        left: left
    };
}
/**
 * Recursively "un-splits" text into words.
 * This is used when splitting text into lines but not words.
 * We initially split the text into words so we can maintain the correct line
 * breaks. Once text has been split into lines, we "un-split" the words...
 * @param {Element}
 * @return {void}
 */ function $954fd737020e73f8$var$unSplitWords(element) {
    if (!$954fd737020e73f8$var$get(element).isWord) $954fd737020e73f8$var$toArray(element.children).forEach((child)=>$954fd737020e73f8$var$unSplitWords(child));
    else {
        $954fd737020e73f8$var$remove(element);
        element.replaceWith(...element.childNodes);
    }
}
const $954fd737020e73f8$var$createFragment = ()=>document.createDocumentFragment();
function $954fd737020e73f8$var$repositionAfterSplit(element, settings, scrollPos) {
    const types = $954fd737020e73f8$var$parseTypes(settings.types);
    const TAG_NAME = settings.tagName;
    const nodes = element.getElementsByTagName("*");
    const wordsInEachLine = [];
    let wordsInCurrentLine = [];
    let lineOffsetY = null;
    let elementHeight;
    let elementWidth;
    let contentBox;
    let lines = [];
    /**------------------------------------------------
   ** GET STYLES AND POSITIONS
   **-----------------------------------------------*/ // There is no built-in way to detect natural line breaks in text (when a
    // block of text wraps to fit its container). To split text into lines, we
    // have to detect line breaks by checking the top offset of words. This is
    // why text was split into words first. To apply absolute
    // positioning, its also necessary to record the size and position of every
    // split node (lines, words, characters).
    // To consolidate DOM getting/settings, this is all done at the same time,
    // before actually splitting text into lines, which involves restructuring
    // the DOM again.
    // Cache the element's parent and next sibling (for DOM removal).
    const parent = element.parentElement;
    const nextSibling = element.nextElementSibling; // a wrapper for the new HTML structure
    const splitText = $954fd737020e73f8$var$createFragment(); // get the computed style object for the element
    const cs = window.getComputedStyle(element);
    const align = cs.textAlign;
    const fontSize = parseFloat(cs.fontSize);
    const lineThreshold = fontSize * 0.2; // IF using absolute position...
    if (settings.absolute) {
        // Let contentBox be an object containing the width and offset position of
        // the element's content box (the area inside padding box). This is needed
        // (for absolute positioning) to set the width and position of line
        // elements, which have not been created yet.
        contentBox = {
            left: element.offsetLeft,
            top: element.offsetTop,
            width: element.offsetWidth
        }; // Let elementWidth and elementHeight be the actual width/height of the
        // element. Also check if the element has inline height or width styles
        // already set. If it does, cache those values for later.
        elementWidth = element.offsetWidth;
        elementHeight = element.offsetHeight; // Store the original inline height and width of the element
        $954fd737020e73f8$var$set(element, {
            cssWidth: element.style.width,
            cssHeight: element.style.height
        });
    } // Iterate over every node in the target element
    $954fd737020e73f8$var$toArray(nodes).forEach((node)=>{
        // node is a word element or custom html element
        const isWordLike = node.parentElement === element; // TODO needs work
        // Get te size and position of split text nodes
        const { width: width, height: height, top: top, left: left } = $954fd737020e73f8$var$getPosition(node, isWordLike, settings, scrollPos); // If element is a `<br>` tag return here
        if (/^br$/i.test(node.nodeName)) return;
        if (types.lines && isWordLike) {
            // We compare the top offset of the current word to the top offset of
            // previous words on the current line. If the difference is greater than
            // our defined threshold (20%), we assume this word is on a new line.
            if (lineOffsetY === null || top - lineOffsetY >= lineThreshold) {
                lineOffsetY = top;
                wordsInEachLine.push(wordsInCurrentLine = []);
            } // Add the current word node to the line array
            wordsInCurrentLine.push(node);
        } // END IF
        if (settings.absolute) // Store the size and position split text nodes
        $954fd737020e73f8$var$set(node, {
            top: top,
            left: left,
            width: width,
            height: height
        });
    }); // END LOOP
    // Remove the element from the DOM
    if (parent) parent.removeChild(element);
    /**------------------------------------------------
   ** SPLIT LINES
   **-----------------------------------------------*/ if (types.lines) {
        // Iterate over lines of text (see 11 b)
        // Let `line` be the array of words in the current line.
        // Return an array of the wrapped line elements (lineElements)
        lines = wordsInEachLine.map((wordsInThisLine)=>{
            // Create an element to wrap the current line.
            const lineElement = $954fd737020e73f8$var$createElement(TAG_NAME, {
                class: `${settings.splitClass} ${settings.lineClass}`,
                style: `display: block; text-align: ${align}; width: 100%;`
            });
            $954fd737020e73f8$var$set(lineElement, "isLine", true);
            const lineDimensions = {
                height: 0,
                top: 1e4
            }; // Append the `lineElement` to `container`
            splitText.appendChild(lineElement); // Iterate over the word-level elements in the current line.
            // Note: wordOrElement can either be a word node or nested element
            wordsInThisLine.forEach((wordOrElement, idx, arr)=>{
                const { isWordEnd: isWordEnd, top: top, height: height } = $954fd737020e73f8$var$get(wordOrElement);
                const next = arr[idx + 1]; // Determine line height / y-position
                // we use the height and offsetTop of the words which we already
                // recorded. Because custom nested elements could have their own
                // styles, the words on a line may not all be the same height or
                // y position. So we take the greatest height / y - offset of the
                // words on this line.
                lineDimensions.height = Math.max(lineDimensions.height, height);
                lineDimensions.top = Math.min(lineDimensions.top, top); // append the current word/element
                lineElement.appendChild(wordOrElement); // Determine if there should space after the current element...
                // If this is not the last word on the current line.
                // TODO - logic for handing spacing can be improved
                if (isWordEnd && $954fd737020e73f8$var$get(next).isWordStart) lineElement.append(" ");
            }); // END LOOP
            if (settings.absolute) $954fd737020e73f8$var$set(lineElement, {
                height: lineDimensions.height,
                top: lineDimensions.top
            });
            return lineElement;
        }); // END LOOP
        if (!types.words) $954fd737020e73f8$var$unSplitWords(splitText);
         // 10. Insert the new container
        element.replaceChildren(splitText);
    }
    /**------------------------------------------------
   **  SET ABSOLUTE POSITION
   **-----------------------------------------------*/ // Apply absolute positioning to all child elements of the target element.
    // This includes split lines, words, chars, and custom HTML elements that were
    // included by the user. The size and position of child elements has already
    // been recorded before splitting text into lines.
    if (settings.absolute) {
        // Set the width/height of the parent element so it does not collapse
        // when its children are set to absolute position.
        element.style.width = `${element.style.width || elementWidth}px`;
        element.style.height = `${elementHeight}px`; // Iterate over all child elements
        $954fd737020e73f8$var$toArray(nodes).forEach((node)=>{
            const { isLine: isLine, top: top, left: left, width: width, height: height } = $954fd737020e73f8$var$get(node);
            const parentData = $954fd737020e73f8$var$get(node.parentElement);
            const isChildOfLineNode = !isLine && parentData.isLine; // Set the top position of the current node.
            // -> If `node` a line element, we use the top offset of its first child
            // -> If `node` the child of line element, then its top offset is zero
            node.style.top = `${isChildOfLineNode ? top - parentData.top : top}px`; // Set the left position of the current node.
            // -> IF `node` is a line element, this is equal to the position left of
            //    the content box of the parent element
            // -> IF `node` is the child of a line element, the value has to adjusted
            //    so its relative to the line element
            node.style.left = isLine ? `${contentBox.left}px` : `${left - (isChildOfLineNode ? contentBox.left : 0)}px`; // Set the height of the current node to the cached value.
            node.style.height = `${height}px`; //  Set the width of the current node.
            //  If its a line element, width is equal to the width of the contentBox.
            node.style.width = isLine ? `${contentBox.width}px` : `${width}px`; // Finally, set the node's position to absolute.
            node.style.position = "absolute";
        });
    } // end if;
    // 14. Re-attach the element to the DOM
    if (parent) {
        if (nextSibling) parent.insertBefore(element, nextSibling);
        else parent.appendChild(element);
    }
    return lines;
}
let $954fd737020e73f8$var$_defaults = $954fd737020e73f8$var$extend($954fd737020e73f8$var$defaults, {});
class $954fd737020e73f8$export$2e2bcd8739ae039 {
    /**
   * The internal data store
   */ static get data() {
        return $954fd737020e73f8$var$cache;
    }
    /**
   * The default settings for all splitType instances
   * @static
   */ static get defaults() {
        return $954fd737020e73f8$var$_defaults;
    }
    /**
   * Sets the default settings for all SplitType instances.
   *
   * Setting `SplitType.defaults` to an object will merge that object with the
   * existing defaults.
   *
   * @param {Object} settings an object containing the settings to override
   * @deprecated
   * @static
   * @example
   * SplitType.defaults = { "position": "absolute" }
   */ static set defaults(options) {
        $954fd737020e73f8$var$_defaults = $954fd737020e73f8$var$extend($954fd737020e73f8$var$_defaults, $954fd737020e73f8$var$parseSettings(options));
    }
    /**
   * Sets the default settings for all SplitType instances.
   * The provided object will be merged with the existing defaults objects.
   *
   * @param {Object} settings an object containing the settings to override
   * @returns {Object} the new default settings
   * @public
   * @static
   * @example
   * SplitType.setDefaults({ "position": "absolute" })
   */ static setDefaults(options) {
        $954fd737020e73f8$var$_defaults = $954fd737020e73f8$var$extend($954fd737020e73f8$var$_defaults, $954fd737020e73f8$var$parseSettings(options));
        return $954fd737020e73f8$var$defaults;
    }
    /**
   * Revert target elements to their original html content
   * Has no effect on that
   *
   * @param {any} elements The target elements to revert. One of:
   *  - {string} A css selector
   *  - {HTMLElement} A single element
   * -  {NodeList} A NodeList or collection
   *  - {HTMLElement[]} An array of Elements
   * -  {Array<HTMLElement|NodeList|HTMLElement[]>} A nested array of elements
   * @static
   */ static revert(elements) {
        $954fd737020e73f8$var$getTargetElements(elements).forEach((element)=>{
            const { isSplit: isSplit, html: html, cssWidth: cssWidth, cssHeight: cssHeight } = $954fd737020e73f8$var$get(element);
            if (isSplit) {
                element.innerHTML = html;
                element.style.width = cssWidth || "";
                element.style.height = cssHeight || "";
                $954fd737020e73f8$var$remove(element);
            }
        });
    }
    /**
   * Creates a new SplitType instance
   * This static method provides a way to create a `SplitType` instance without
   * using the `new` keyword.
   *
   * @param {any} target The target elements to split. One of:
   *  - {string} A css selector
   *  - {HTMLElement} A single element
   * -  {NodeList} A NodeList or collection
   *  - {HTMLElement[]} An array of Elements
   * -  {Array<HTMLElement|NodeList|HTMLElement[]>} A nested array of elements
   * @param {Object} [options] Settings for the SplitType instance
   * @return {SplitType} the SplitType instance
   * @static
   */ static create(target, options) {
        return new $954fd737020e73f8$export$2e2bcd8739ae039(target, options);
    }
    /**
   * Creates a new `SplitType` instance
   *
   * @param {any} elements The target elements to split. One of:
   *  - {string} A css selector
   *  - {HTMLElement} A single element
   * -  {NodeList} A NodeList or collection
   *  - {HTMLElement[]} An array of Elements
   * -  {Array<HTMLElement|NodeList|HTMLElement[]>} A nested array of elements
   * @param {Object} [options] Settings for the SplitType instance
   */ constructor(elements, options){
        this.isSplit = false;
        this.settings = $954fd737020e73f8$var$extend($954fd737020e73f8$var$_defaults, $954fd737020e73f8$var$parseSettings(options));
        this.elements = $954fd737020e73f8$var$getTargetElements(elements); // Start the split process
        this.split();
    }
    /**
   * Splits the text in all target elements. This method is called
   * automatically when a new SplitType instance is created. It can also be
   * called manually to re-split text with new options.
   * @param {Object} options
   * @public
   */ split(options) {
        // Revert target elements (if they are already split)
        // Note: revert was already called once in the constructor. However, we
        // need to call it again here so text is reverted when the user manually
        // calls the `split` method to re-split text.
        this.revert(); // Store the original html content of each target element
        this.elements.forEach((element)=>{
            $954fd737020e73f8$var$set(element, "html", element.innerHTML);
        }); // Create arrays to hold the split lines, words, and characters
        this.lines = [];
        this.words = [];
        this.chars = []; // cache vertical scroll position before splitting
        const scrollPos = [
            window.pageXOffset,
            window.pageYOffset
        ]; // If new options were passed into the `split()` method, update settings
        if (options !== undefined) this.settings = $954fd737020e73f8$var$extend(this.settings, $954fd737020e73f8$var$parseSettings(options));
        const types = $954fd737020e73f8$var$parseTypes(this.settings.types); // If the `types` option is set to an empty array, text will not be split.
        // @example new SplitType('#target', { types: [] })
        if (types.none) return;
         // Split text in each target element
        this.elements.forEach((element)=>{
            // Add the split text nodes from this element to the arrays of all split
            // text nodes for this instance.
            $954fd737020e73f8$var$set(element, "isRoot", true);
            const { words: words, chars: chars } = $954fd737020e73f8$var$split(element, this.settings);
            this.words = [
                ...this.words,
                ...words
            ];
            this.chars = [
                ...this.chars,
                ...chars
            ];
        });
        this.elements.forEach((element)=>{
            if (types.lines || this.settings.absolute) {
                const lines = $954fd737020e73f8$var$repositionAfterSplit(element, this.settings, scrollPos);
                this.lines = [
                    ...this.lines,
                    ...lines
                ];
            }
        }); // Set isSplit to true for the SplitType instance
        this.isSplit = true; // Set scroll position to cached value.
        window.scrollTo(scrollPos[0], scrollPos[1]); // Clean up stored data
        $954fd737020e73f8$var$cleanup();
    }
    /**
   * Reverts target element(s) back to their original html content
   * Deletes all stored data associated with the target elements
   * Resets the properties on the splitType instance
   *
   * @public
   */ revert() {
        if (this.isSplit) {
            // Reset instance properties if necessary
            this.lines = null;
            this.words = null;
            this.chars = null;
            this.isSplit = false;
        }
        $954fd737020e73f8$export$2e2bcd8739ae039.revert(this.elements);
    }
}


(0, $856d27e31089eddd$export$99ee26438460406a).registerPlugin((0, $f075d17102cf2205$export$875bcbe48555930));
document.addEventListener("DOMContentLoaded", function() {
    const elements = document.querySelectorAll("[data-text-reveal]");
    for (const element of elements){
        const types = element.dataset.textReveal;
        const start = element.dataset.textRevealStart || "top 80%";
        const end = element.dataset.textRevealEnd || "top 40%";
        const debug = [
            "true",
            "1",
            "yes",
            "on"
        ].includes(element.dataset.textRevealDebug) || false;
        if (![
            "lines",
            "words",
            "chars"
        ].includes(types)) {
            console.error(`data-text-reveal must be one of 'lines', 'words' or 'chars'.`);
            continue;
        }
        // Break the text into individual word elements
        const text = new (0, $954fd737020e73f8$export$2e2bcd8739ae039)(element, {
            types: types
        });
        let splitElements;
        switch(types){
            case "lines":
                splitElements = text.lines;
                break;
            case "words":
                splitElements = text.words;
                break;
            case "chars":
                splitElements = text.chars;
                break;
        }
        // Create a timeline tied to the scroll position
        const tl = (0, $856d27e31089eddd$export$99ee26438460406a).timeline({
            scrollTrigger: {
                trigger: element,
                start: start,
                end: end,
                markers: debug,
                scrub: true
            }
        });
        // Add each split element to the timeline to animate from 0.2 to 1 opacity. Duration and stagger don't matter
        // since the timeline is tied to the scroll position, but without them the animation is instant.
        tl.fromTo(splitElements, {
            opacity: 0.2
        }, {
            opacity: 1,
            duration: 1,
            stagger: 1
        });
    }
});


// Scheduling related JS
const $c2ff0f2fbabf3566$var$activate_now_choice = document.getElementById("id_installation-activate_now_0");
const $c2ff0f2fbabf3566$var$activate_later_choice = document.getElementById("id_installation-activate_now_1");
const $c2ff0f2fbabf3566$var$auto_activation_date_wrapper = document.getElementById("auto_activation_date");
const $c2ff0f2fbabf3566$var$auto_activation_date_input = document.getElementById("id_auto_activation_date") || document.getElementById("id_installation-auto_activation_date");
if ($c2ff0f2fbabf3566$var$activate_now_choice && $c2ff0f2fbabf3566$var$activate_later_choice && $c2ff0f2fbabf3566$var$auto_activation_date_wrapper && $c2ff0f2fbabf3566$var$auto_activation_date_input) {
    function toggleAutoActivationDateChooserVisibility() {
        if ($c2ff0f2fbabf3566$var$activate_later_choice.checked) {
            $c2ff0f2fbabf3566$var$auto_activation_date_wrapper.classList.add("show");
            $c2ff0f2fbabf3566$var$auto_activation_date_input.required = true;
        } else {
            $c2ff0f2fbabf3566$var$auto_activation_date_wrapper.classList.remove("show");
            $c2ff0f2fbabf3566$var$auto_activation_date_input.required = false;
        }
    }
    $c2ff0f2fbabf3566$var$activate_now_choice.addEventListener("change", toggleAutoActivationDateChooserVisibility);
    $c2ff0f2fbabf3566$var$activate_later_choice.addEventListener("change", toggleAutoActivationDateChooserVisibility);
    document.addEventListener("DOMContentLoaded", toggleAutoActivationDateChooserVisibility);
}



var $cNQM9 = parcelRequire("cNQM9");
var $c3496a40a394bf09$exports = {};

$parcel$export($c3496a40a394bf09$exports, "default", function () { return $c3496a40a394bf09$export$2e2bcd8739ae039; });
var $739195af95cf03b2$export$c34bb18505e1e253 = [
    "onChange",
    "onClose",
    "onDayCreate",
    "onDestroy",
    "onKeyDown",
    "onMonthChange",
    "onOpen",
    "onParseConfig",
    "onReady",
    "onValueUpdate",
    "onYearChange",
    "onPreCalendarPosition"
];
var $739195af95cf03b2$export$ebe90cb607ad99e = {
    _disable: [],
    allowInput: false,
    allowInvalidPreload: false,
    altFormat: "F j, Y",
    altInput: false,
    altInputClass: "form-control input",
    animate: typeof window === "object" && window.navigator.userAgent.indexOf("MSIE") === -1,
    ariaDateFormat: "F j, Y",
    autoFillDefaultTime: true,
    clickOpens: true,
    closeOnSelect: true,
    conjunction: ", ",
    dateFormat: "Y-m-d",
    defaultHour: 12,
    defaultMinute: 0,
    defaultSeconds: 0,
    disable: [],
    disableMobile: false,
    enableSeconds: false,
    enableTime: false,
    errorHandler: function(err) {
        return typeof console !== "undefined" && console.warn(err);
    },
    getWeek: function(givenDate) {
        var date = new Date(givenDate.getTime());
        date.setHours(0, 0, 0, 0);
        date.setDate(date.getDate() + 3 - (date.getDay() + 6) % 7);
        var week1 = new Date(date.getFullYear(), 0, 4);
        return 1 + Math.round(((date.getTime() - week1.getTime()) / 86400000 - 3 + (week1.getDay() + 6) % 7) / 7);
    },
    hourIncrement: 1,
    ignoredFocusElements: [],
    inline: false,
    locale: "default",
    minuteIncrement: 5,
    mode: "single",
    monthSelectorType: "dropdown",
    nextArrow: "<svg version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 17 17'><g></g><path d='M13.207 8.472l-7.854 7.854-0.707-0.707 7.146-7.146-7.146-7.148 0.707-0.707 7.854 7.854z' /></svg>",
    noCalendar: false,
    now: new Date(),
    onChange: [],
    onClose: [],
    onDayCreate: [],
    onDestroy: [],
    onKeyDown: [],
    onMonthChange: [],
    onOpen: [],
    onParseConfig: [],
    onReady: [],
    onValueUpdate: [],
    onYearChange: [],
    onPreCalendarPosition: [],
    plugins: [],
    position: "auto",
    positionElement: undefined,
    prevArrow: "<svg version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 17 17'><g></g><path d='M5.207 8.471l7.146 7.147-0.707 0.707-7.853-7.854 7.854-7.853 0.707 0.707-7.147 7.146z' /></svg>",
    shorthandCurrentMonth: false,
    showMonths: 1,
    static: false,
    time_24hr: false,
    weekNumbers: false,
    wrap: false
};


var $dd09c7bf58d1d2e9$export$33e6c23ebe2ee669 = {
    weekdays: {
        shorthand: [
            "Sun",
            "Mon",
            "Tue",
            "Wed",
            "Thu",
            "Fri",
            "Sat"
        ],
        longhand: [
            "Sunday",
            "Monday",
            "Tuesday",
            "Wednesday",
            "Thursday",
            "Friday",
            "Saturday"
        ]
    },
    months: {
        shorthand: [
            "Jan",
            "Feb",
            "Mar",
            "Apr",
            "May",
            "Jun",
            "Jul",
            "Aug",
            "Sep",
            "Oct",
            "Nov",
            "Dec"
        ],
        longhand: [
            "January",
            "February",
            "March",
            "April",
            "May",
            "June",
            "July",
            "August",
            "September",
            "October",
            "November",
            "December"
        ]
    },
    daysInMonth: [
        31,
        28,
        31,
        30,
        31,
        30,
        31,
        31,
        30,
        31,
        30,
        31
    ],
    firstDayOfWeek: 0,
    ordinal: function(nth) {
        var s = nth % 100;
        if (s > 3 && s < 21) return "th";
        switch(s % 10){
            case 1:
                return "st";
            case 2:
                return "nd";
            case 3:
                return "rd";
            default:
                return "th";
        }
    },
    rangeSeparator: " to ",
    weekAbbreviation: "Wk",
    scrollTitle: "Scroll to increment",
    toggleTitle: "Click to toggle",
    amPM: [
        "AM",
        "PM"
    ],
    yearAriaLabel: "Year",
    monthAriaLabel: "Month",
    hourAriaLabel: "Hour",
    minuteAriaLabel: "Minute",
    time_24hr: false
};
var $dd09c7bf58d1d2e9$export$2e2bcd8739ae039 = $dd09c7bf58d1d2e9$export$33e6c23ebe2ee669;


var $f89ac564820ae2aa$export$5d04458e2a6c373e = function(number, length) {
    if (length === void 0) length = 2;
    return ("000" + number).slice(length * -1);
};
var $f89ac564820ae2aa$export$7d260a2a5f8bc19e = function(bool) {
    return bool === true ? 1 : 0;
};
function $f89ac564820ae2aa$export$61fc7d43ac8f84b0(fn, wait) {
    var t;
    return function() {
        var _this = this;
        var args = arguments;
        clearTimeout(t);
        t = setTimeout(function() {
            return fn.apply(_this, args);
        }, wait);
    };
}
var $f89ac564820ae2aa$export$3131421a7d01b4fb = function(obj) {
    return obj instanceof Array ? obj : [
        obj
    ];
};


function $da40c9ef6edf896a$export$4a80062ca50b57c7(elem, className, bool) {
    if (bool === true) return elem.classList.add(className);
    elem.classList.remove(className);
}
function $da40c9ef6edf896a$export$c8a8987d4410bf2d(tag, className, content) {
    var e = window.document.createElement(tag);
    className = className || "";
    content = content || "";
    e.className = className;
    if (content !== undefined) e.textContent = content;
    return e;
}
function $da40c9ef6edf896a$export$51cfe97d637c237c(node) {
    while(node.firstChild)node.removeChild(node.firstChild);
}
function $da40c9ef6edf896a$export$25245567f53f158f(node, condition) {
    if (condition(node)) return node;
    else if (node.parentNode) return $da40c9ef6edf896a$export$25245567f53f158f(node.parentNode, condition);
    return undefined;
}
function $da40c9ef6edf896a$export$afe9d610a3284048(inputClassName, opts) {
    var wrapper = $da40c9ef6edf896a$export$c8a8987d4410bf2d("div", "numInputWrapper"), numInput = $da40c9ef6edf896a$export$c8a8987d4410bf2d("input", "numInput " + inputClassName), arrowUp = $da40c9ef6edf896a$export$c8a8987d4410bf2d("span", "arrowUp"), arrowDown = $da40c9ef6edf896a$export$c8a8987d4410bf2d("span", "arrowDown");
    if (navigator.userAgent.indexOf("MSIE 9.0") === -1) numInput.type = "number";
    else {
        numInput.type = "text";
        numInput.pattern = "\\d*";
    }
    if (opts !== undefined) for(var key in opts)numInput.setAttribute(key, opts[key]);
    wrapper.appendChild(numInput);
    wrapper.appendChild(arrowUp);
    wrapper.appendChild(arrowDown);
    return wrapper;
}
function $da40c9ef6edf896a$export$e58f029f0fbfdb29(event) {
    try {
        if (typeof event.composedPath === "function") {
            var path = event.composedPath();
            return path[0];
        }
        return event.target;
    } catch (error) {
        return event.target;
    }
}



var $9816dab19e3bd8be$var$doNothing = function() {
    return undefined;
};
var $9816dab19e3bd8be$export$27a2dd9af757e89c = function(monthNumber, shorthand, locale) {
    return locale.months[shorthand ? "shorthand" : "longhand"][monthNumber];
};
var $9816dab19e3bd8be$export$9490b78b888a863f = {
    D: $9816dab19e3bd8be$var$doNothing,
    F: function(dateObj, monthName, locale) {
        dateObj.setMonth(locale.months.longhand.indexOf(monthName));
    },
    G: function(dateObj, hour) {
        dateObj.setHours((dateObj.getHours() >= 12 ? 12 : 0) + parseFloat(hour));
    },
    H: function(dateObj, hour) {
        dateObj.setHours(parseFloat(hour));
    },
    J: function(dateObj, day) {
        dateObj.setDate(parseFloat(day));
    },
    K: function(dateObj, amPM, locale) {
        dateObj.setHours(dateObj.getHours() % 12 + 12 * (0, $f89ac564820ae2aa$export$7d260a2a5f8bc19e)(new RegExp(locale.amPM[1], "i").test(amPM)));
    },
    M: function(dateObj, shortMonth, locale) {
        dateObj.setMonth(locale.months.shorthand.indexOf(shortMonth));
    },
    S: function(dateObj, seconds) {
        dateObj.setSeconds(parseFloat(seconds));
    },
    U: function(_, unixSeconds) {
        return new Date(parseFloat(unixSeconds) * 1000);
    },
    W: function(dateObj, weekNum, locale) {
        var weekNumber = parseInt(weekNum);
        var date = new Date(dateObj.getFullYear(), 0, 2 + (weekNumber - 1) * 7, 0, 0, 0, 0);
        date.setDate(date.getDate() - date.getDay() + locale.firstDayOfWeek);
        return date;
    },
    Y: function(dateObj, year) {
        dateObj.setFullYear(parseFloat(year));
    },
    Z: function(_, ISODate) {
        return new Date(ISODate);
    },
    d: function(dateObj, day) {
        dateObj.setDate(parseFloat(day));
    },
    h: function(dateObj, hour) {
        dateObj.setHours((dateObj.getHours() >= 12 ? 12 : 0) + parseFloat(hour));
    },
    i: function(dateObj, minutes) {
        dateObj.setMinutes(parseFloat(minutes));
    },
    j: function(dateObj, day) {
        dateObj.setDate(parseFloat(day));
    },
    l: $9816dab19e3bd8be$var$doNothing,
    m: function(dateObj, month) {
        dateObj.setMonth(parseFloat(month) - 1);
    },
    n: function(dateObj, month) {
        dateObj.setMonth(parseFloat(month) - 1);
    },
    s: function(dateObj, seconds) {
        dateObj.setSeconds(parseFloat(seconds));
    },
    u: function(_, unixMillSeconds) {
        return new Date(parseFloat(unixMillSeconds));
    },
    w: $9816dab19e3bd8be$var$doNothing,
    y: function(dateObj, year) {
        dateObj.setFullYear(2000 + parseFloat(year));
    }
};
var $9816dab19e3bd8be$export$f5a8dc72fbf63af5 = {
    D: "",
    F: "",
    G: "(\\d\\d|\\d)",
    H: "(\\d\\d|\\d)",
    J: "(\\d\\d|\\d)\\w+",
    K: "",
    M: "",
    S: "(\\d\\d|\\d)",
    U: "(.+)",
    W: "(\\d\\d|\\d)",
    Y: "(\\d{4})",
    Z: "(.+)",
    d: "(\\d\\d|\\d)",
    h: "(\\d\\d|\\d)",
    i: "(\\d\\d|\\d)",
    j: "(\\d\\d|\\d)",
    l: "",
    m: "(\\d\\d|\\d)",
    n: "(\\d\\d|\\d)",
    s: "(\\d\\d|\\d)",
    u: "(.+)",
    w: "(\\d\\d|\\d)",
    y: "(\\d{2})"
};
var $9816dab19e3bd8be$export$55069460464ca7a9 = {
    Z: function(date) {
        return date.toISOString();
    },
    D: function(date, locale, options) {
        return locale.weekdays.shorthand[$9816dab19e3bd8be$export$55069460464ca7a9.w(date, locale, options)];
    },
    F: function(date, locale, options) {
        return $9816dab19e3bd8be$export$27a2dd9af757e89c($9816dab19e3bd8be$export$55069460464ca7a9.n(date, locale, options) - 1, false, locale);
    },
    G: function(date, locale, options) {
        return (0, $f89ac564820ae2aa$export$5d04458e2a6c373e)($9816dab19e3bd8be$export$55069460464ca7a9.h(date, locale, options));
    },
    H: function(date) {
        return (0, $f89ac564820ae2aa$export$5d04458e2a6c373e)(date.getHours());
    },
    J: function(date, locale) {
        return locale.ordinal !== undefined ? date.getDate() + locale.ordinal(date.getDate()) : date.getDate();
    },
    K: function(date, locale) {
        return locale.amPM[(0, $f89ac564820ae2aa$export$7d260a2a5f8bc19e)(date.getHours() > 11)];
    },
    M: function(date, locale) {
        return $9816dab19e3bd8be$export$27a2dd9af757e89c(date.getMonth(), true, locale);
    },
    S: function(date) {
        return (0, $f89ac564820ae2aa$export$5d04458e2a6c373e)(date.getSeconds());
    },
    U: function(date) {
        return date.getTime() / 1000;
    },
    W: function(date, _, options) {
        return options.getWeek(date);
    },
    Y: function(date) {
        return (0, $f89ac564820ae2aa$export$5d04458e2a6c373e)(date.getFullYear(), 4);
    },
    d: function(date) {
        return (0, $f89ac564820ae2aa$export$5d04458e2a6c373e)(date.getDate());
    },
    h: function(date) {
        return date.getHours() % 12 ? date.getHours() % 12 : 12;
    },
    i: function(date) {
        return (0, $f89ac564820ae2aa$export$5d04458e2a6c373e)(date.getMinutes());
    },
    j: function(date) {
        return date.getDate();
    },
    l: function(date, locale) {
        return locale.weekdays.longhand[date.getDay()];
    },
    m: function(date) {
        return (0, $f89ac564820ae2aa$export$5d04458e2a6c373e)(date.getMonth() + 1);
    },
    n: function(date) {
        return date.getMonth() + 1;
    },
    s: function(date) {
        return date.getSeconds();
    },
    u: function(date) {
        return date.getTime();
    },
    w: function(date) {
        return date.getDay();
    },
    y: function(date) {
        return String(date.getFullYear()).substring(2);
    }
};




var $eeeb315f1c4d591c$export$ff1a0b75284ac636 = function(_a) {
    var _b = _a.config, config = _b === void 0 ? (0, $739195af95cf03b2$export$ebe90cb607ad99e) : _b, _c = _a.l10n, l10n = _c === void 0 ? (0, $dd09c7bf58d1d2e9$export$33e6c23ebe2ee669) : _c, _d = _a.isMobile, isMobile = _d === void 0 ? false : _d;
    return function(dateObj, frmt, overrideLocale) {
        var locale = overrideLocale || l10n;
        if (config.formatDate !== undefined && !isMobile) return config.formatDate(dateObj, frmt, locale);
        return frmt.split("").map(function(c, i, arr) {
            return (0, $9816dab19e3bd8be$export$55069460464ca7a9)[c] && arr[i - 1] !== "\\" ? (0, $9816dab19e3bd8be$export$55069460464ca7a9)[c](dateObj, locale, config) : c !== "\\" ? c : "";
        }).join("");
    };
};
var $eeeb315f1c4d591c$export$cfa2ef2687faeda2 = function(_a) {
    var _b = _a.config, config = _b === void 0 ? (0, $739195af95cf03b2$export$ebe90cb607ad99e) : _b, _c = _a.l10n, l10n = _c === void 0 ? (0, $dd09c7bf58d1d2e9$export$33e6c23ebe2ee669) : _c;
    return function(date, givenFormat, timeless, customLocale) {
        if (date !== 0 && !date) return undefined;
        var locale = customLocale || l10n;
        var parsedDate;
        var dateOrig = date;
        if (date instanceof Date) parsedDate = new Date(date.getTime());
        else if (typeof date !== "string" && date.toFixed !== undefined) parsedDate = new Date(date);
        else if (typeof date === "string") {
            var format = givenFormat || (config || (0, $739195af95cf03b2$export$ebe90cb607ad99e)).dateFormat;
            var datestr = String(date).trim();
            if (datestr === "today") {
                parsedDate = new Date();
                timeless = true;
            } else if (config && config.parseDate) parsedDate = config.parseDate(date, format);
            else if (/Z$/.test(datestr) || /GMT$/.test(datestr)) parsedDate = new Date(date);
            else {
                var matched = void 0, ops = [];
                for(var i = 0, matchIndex = 0, regexStr = ""; i < format.length; i++){
                    var token = format[i];
                    var isBackSlash = token === "\\";
                    var escaped = format[i - 1] === "\\" || isBackSlash;
                    if ((0, $9816dab19e3bd8be$export$f5a8dc72fbf63af5)[token] && !escaped) {
                        regexStr += (0, $9816dab19e3bd8be$export$f5a8dc72fbf63af5)[token];
                        var match = new RegExp(regexStr).exec(date);
                        if (match && (matched = true)) ops[token !== "Y" ? "push" : "unshift"]({
                            fn: (0, $9816dab19e3bd8be$export$9490b78b888a863f)[token],
                            val: match[++matchIndex]
                        });
                    } else if (!isBackSlash) regexStr += ".";
                }
                parsedDate = !config || !config.noCalendar ? new Date(new Date().getFullYear(), 0, 1, 0, 0, 0, 0) : new Date(new Date().setHours(0, 0, 0, 0));
                ops.forEach(function(_a) {
                    var fn = _a.fn, val = _a.val;
                    return parsedDate = fn(parsedDate, val, locale) || parsedDate;
                });
                parsedDate = matched ? parsedDate : undefined;
            }
        }
        if (!(parsedDate instanceof Date && !isNaN(parsedDate.getTime()))) {
            config.errorHandler(new Error("Invalid date provided: " + dateOrig));
            return undefined;
        }
        if (timeless === true) parsedDate.setHours(0, 0, 0, 0);
        return parsedDate;
    };
};
function $eeeb315f1c4d591c$export$c4c806e061935577(date1, date2, timeless) {
    if (timeless === void 0) timeless = true;
    if (timeless !== false) return new Date(date1.getTime()).setHours(0, 0, 0, 0) - new Date(date2.getTime()).setHours(0, 0, 0, 0);
    return date1.getTime() - date2.getTime();
}
function $eeeb315f1c4d591c$export$15d252ed5f5f8636(date1, date2) {
    return 3600 * (date1.getHours() - date2.getHours()) + 60 * (date1.getMinutes() - date2.getMinutes()) + date1.getSeconds() - date2.getSeconds();
}
var $eeeb315f1c4d591c$export$a4d69fb5f2026c35 = function(ts, ts1, ts2) {
    return ts > Math.min(ts1, ts2) && ts < Math.max(ts1, ts2);
};
var $eeeb315f1c4d591c$export$9fafc166baa96839 = function(hours, minutes, seconds) {
    return hours * 3600 + minutes * 60 + seconds;
};
var $eeeb315f1c4d591c$export$a4ce0def660bfe9e = function(secondsSinceMidnight) {
    var hours = Math.floor(secondsSinceMidnight / 3600), minutes = (secondsSinceMidnight - hours * 3600) / 60;
    return [
        hours,
        minutes,
        secondsSinceMidnight - hours * 3600 - minutes * 60
    ];
};
var $eeeb315f1c4d591c$export$1f34108aa9eb96ab = {
    DAY: 86400000
};
function $eeeb315f1c4d591c$export$6df0e87d3fffbd14(config) {
    var hours = config.defaultHour;
    var minutes = config.defaultMinute;
    var seconds = config.defaultSeconds;
    if (config.minDate !== undefined) {
        var minHour = config.minDate.getHours();
        var minMinutes = config.minDate.getMinutes();
        var minSeconds = config.minDate.getSeconds();
        if (hours < minHour) hours = minHour;
        if (hours === minHour && minutes < minMinutes) minutes = minMinutes;
        if (hours === minHour && minutes === minMinutes && seconds < minSeconds) seconds = config.minDate.getSeconds();
    }
    if (config.maxDate !== undefined) {
        var maxHr = config.maxDate.getHours();
        var maxMinutes = config.maxDate.getMinutes();
        hours = Math.min(hours, maxHr);
        if (hours === maxHr) minutes = Math.min(maxMinutes, minutes);
        if (hours === maxHr && minutes === maxMinutes) seconds = config.maxDate.getSeconds();
    }
    return {
        hours: hours,
        minutes: minutes,
        seconds: seconds
    };
}



"use strict";
if (typeof Object.assign !== "function") Object.assign = function(target) {
    var args = [];
    for(var _i = 1; _i < arguments.length; _i++)args[_i - 1] = arguments[_i];
    if (!target) throw TypeError("Cannot convert undefined or null to object");
    var _loop_1 = function(source) {
        if (source) Object.keys(source).forEach(function(key) {
            return target[key] = source[key];
        });
    };
    for(var _a = 0, args_1 = args; _a < args_1.length; _a++){
        var source = args_1[_a];
        _loop_1(source);
    }
    return target;
};


var $c3496a40a394bf09$var$__assign = undefined && undefined.__assign || function() {
    $c3496a40a394bf09$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $c3496a40a394bf09$var$__assign.apply(this, arguments);
};
var $c3496a40a394bf09$var$__spreadArrays = undefined && undefined.__spreadArrays || function() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
};
var $c3496a40a394bf09$var$DEBOUNCED_CHANGE_MS = 300;
function $c3496a40a394bf09$var$FlatpickrInstance(element, instanceConfig) {
    var self = {
        config: $c3496a40a394bf09$var$__assign($c3496a40a394bf09$var$__assign({}, (0, $739195af95cf03b2$export$ebe90cb607ad99e)), $c3496a40a394bf09$var$flatpickr.defaultConfig),
        l10n: (0, $dd09c7bf58d1d2e9$export$2e2bcd8739ae039)
    };
    self.parseDate = (0, $eeeb315f1c4d591c$export$cfa2ef2687faeda2)({
        config: self.config,
        l10n: self.l10n
    });
    self._handlers = [];
    self.pluginElements = [];
    self.loadedPlugins = [];
    self._bind = bind;
    self._setHoursFromDate = setHoursFromDate;
    self._positionCalendar = positionCalendar;
    self.changeMonth = changeMonth;
    self.changeYear = changeYear;
    self.clear = clear;
    self.close = close;
    self.onMouseOver = onMouseOver;
    self._createElement = (0, $da40c9ef6edf896a$export$c8a8987d4410bf2d);
    self.createDay = createDay;
    self.destroy = destroy;
    self.isEnabled = isEnabled;
    self.jumpToDate = jumpToDate;
    self.updateValue = updateValue;
    self.open = open;
    self.redraw = redraw;
    self.set = set;
    self.setDate = setDate;
    self.toggle = toggle;
    function setupHelperFunctions() {
        self.utils = {
            getDaysInMonth: function(month, yr) {
                if (month === void 0) month = self.currentMonth;
                if (yr === void 0) yr = self.currentYear;
                if (month === 1 && (yr % 4 === 0 && yr % 100 !== 0 || yr % 400 === 0)) return 29;
                return self.l10n.daysInMonth[month];
            }
        };
    }
    function init() {
        self.element = self.input = element;
        self.isOpen = false;
        parseConfig();
        setupLocale();
        setupInputs();
        setupDates();
        setupHelperFunctions();
        if (!self.isMobile) build();
        bindEvents();
        if (self.selectedDates.length || self.config.noCalendar) {
            if (self.config.enableTime) setHoursFromDate(self.config.noCalendar ? self.latestSelectedDateObj : undefined);
            updateValue(false);
        }
        setCalendarWidth();
        var isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
        if (!self.isMobile && isSafari) positionCalendar();
        triggerEvent("onReady");
    }
    function getClosestActiveElement() {
        var _a;
        return ((_a = self.calendarContainer) === null || _a === void 0 ? void 0 : _a.getRootNode()).activeElement || document.activeElement;
    }
    function bindToInstance(fn) {
        return fn.bind(self);
    }
    function setCalendarWidth() {
        var config = self.config;
        if (config.weekNumbers === false && config.showMonths === 1) return;
        else if (config.noCalendar !== true) window.requestAnimationFrame(function() {
            if (self.calendarContainer !== undefined) {
                self.calendarContainer.style.visibility = "hidden";
                self.calendarContainer.style.display = "block";
            }
            if (self.daysContainer !== undefined) {
                var daysWidth = (self.days.offsetWidth + 1) * config.showMonths;
                self.daysContainer.style.width = daysWidth + "px";
                self.calendarContainer.style.width = daysWidth + (self.weekWrapper !== undefined ? self.weekWrapper.offsetWidth : 0) + "px";
                self.calendarContainer.style.removeProperty("visibility");
                self.calendarContainer.style.removeProperty("display");
            }
        });
    }
    function updateTime(e) {
        if (self.selectedDates.length === 0) {
            var defaultDate = self.config.minDate === undefined || (0, $eeeb315f1c4d591c$export$c4c806e061935577)(new Date(), self.config.minDate) >= 0 ? new Date() : new Date(self.config.minDate.getTime());
            var defaults = (0, $eeeb315f1c4d591c$export$6df0e87d3fffbd14)(self.config);
            defaultDate.setHours(defaults.hours, defaults.minutes, defaults.seconds, defaultDate.getMilliseconds());
            self.selectedDates = [
                defaultDate
            ];
            self.latestSelectedDateObj = defaultDate;
        }
        if (e !== undefined && e.type !== "blur") timeWrapper(e);
        var prevValue = self._input.value;
        setHoursFromInputs();
        updateValue();
        if (self._input.value !== prevValue) self._debouncedChange();
    }
    function ampm2military(hour, amPM) {
        return hour % 12 + 12 * (0, $f89ac564820ae2aa$export$7d260a2a5f8bc19e)(amPM === self.l10n.amPM[1]);
    }
    function military2ampm(hour) {
        switch(hour % 24){
            case 0:
            case 12:
                return 12;
            default:
                return hour % 12;
        }
    }
    function setHoursFromInputs() {
        if (self.hourElement === undefined || self.minuteElement === undefined) return;
        var hours = (parseInt(self.hourElement.value.slice(-2), 10) || 0) % 24, minutes = (parseInt(self.minuteElement.value, 10) || 0) % 60, seconds = self.secondElement !== undefined ? (parseInt(self.secondElement.value, 10) || 0) % 60 : 0;
        if (self.amPM !== undefined) hours = ampm2military(hours, self.amPM.textContent);
        var limitMinHours = self.config.minTime !== undefined || self.config.minDate && self.minDateHasTime && self.latestSelectedDateObj && (0, $eeeb315f1c4d591c$export$c4c806e061935577)(self.latestSelectedDateObj, self.config.minDate, true) === 0;
        var limitMaxHours = self.config.maxTime !== undefined || self.config.maxDate && self.maxDateHasTime && self.latestSelectedDateObj && (0, $eeeb315f1c4d591c$export$c4c806e061935577)(self.latestSelectedDateObj, self.config.maxDate, true) === 0;
        if (self.config.maxTime !== undefined && self.config.minTime !== undefined && self.config.minTime > self.config.maxTime) {
            var minBound = (0, $eeeb315f1c4d591c$export$9fafc166baa96839)(self.config.minTime.getHours(), self.config.minTime.getMinutes(), self.config.minTime.getSeconds());
            var maxBound = (0, $eeeb315f1c4d591c$export$9fafc166baa96839)(self.config.maxTime.getHours(), self.config.maxTime.getMinutes(), self.config.maxTime.getSeconds());
            var currentTime = (0, $eeeb315f1c4d591c$export$9fafc166baa96839)(hours, minutes, seconds);
            if (currentTime > maxBound && currentTime < minBound) {
                var result = (0, $eeeb315f1c4d591c$export$a4ce0def660bfe9e)(minBound);
                hours = result[0];
                minutes = result[1];
                seconds = result[2];
            }
        } else {
            if (limitMaxHours) {
                var maxTime = self.config.maxTime !== undefined ? self.config.maxTime : self.config.maxDate;
                hours = Math.min(hours, maxTime.getHours());
                if (hours === maxTime.getHours()) minutes = Math.min(minutes, maxTime.getMinutes());
                if (minutes === maxTime.getMinutes()) seconds = Math.min(seconds, maxTime.getSeconds());
            }
            if (limitMinHours) {
                var minTime = self.config.minTime !== undefined ? self.config.minTime : self.config.minDate;
                hours = Math.max(hours, minTime.getHours());
                if (hours === minTime.getHours() && minutes < minTime.getMinutes()) minutes = minTime.getMinutes();
                if (minutes === minTime.getMinutes()) seconds = Math.max(seconds, minTime.getSeconds());
            }
        }
        setHours(hours, minutes, seconds);
    }
    function setHoursFromDate(dateObj) {
        var date = dateObj || self.latestSelectedDateObj;
        if (date && date instanceof Date) setHours(date.getHours(), date.getMinutes(), date.getSeconds());
    }
    function setHours(hours, minutes, seconds) {
        if (self.latestSelectedDateObj !== undefined) self.latestSelectedDateObj.setHours(hours % 24, minutes, seconds || 0, 0);
        if (!self.hourElement || !self.minuteElement || self.isMobile) return;
        self.hourElement.value = (0, $f89ac564820ae2aa$export$5d04458e2a6c373e)(!self.config.time_24hr ? (12 + hours) % 12 + 12 * (0, $f89ac564820ae2aa$export$7d260a2a5f8bc19e)(hours % 12 === 0) : hours);
        self.minuteElement.value = (0, $f89ac564820ae2aa$export$5d04458e2a6c373e)(minutes);
        if (self.amPM !== undefined) self.amPM.textContent = self.l10n.amPM[(0, $f89ac564820ae2aa$export$7d260a2a5f8bc19e)(hours >= 12)];
        if (self.secondElement !== undefined) self.secondElement.value = (0, $f89ac564820ae2aa$export$5d04458e2a6c373e)(seconds);
    }
    function onYearInput(event) {
        var eventTarget = (0, $da40c9ef6edf896a$export$e58f029f0fbfdb29)(event);
        var year = parseInt(eventTarget.value) + (event.delta || 0);
        if (year / 1000 > 1 || event.key === "Enter" && !/[^\d]/.test(year.toString())) changeYear(year);
    }
    function bind(element, event, handler, options) {
        if (event instanceof Array) return event.forEach(function(ev) {
            return bind(element, ev, handler, options);
        });
        if (element instanceof Array) return element.forEach(function(el) {
            return bind(el, event, handler, options);
        });
        element.addEventListener(event, handler, options);
        self._handlers.push({
            remove: function() {
                return element.removeEventListener(event, handler, options);
            }
        });
    }
    function triggerChange() {
        triggerEvent("onChange");
    }
    function bindEvents() {
        if (self.config.wrap) [
            "open",
            "close",
            "toggle",
            "clear"
        ].forEach(function(evt) {
            Array.prototype.forEach.call(self.element.querySelectorAll("[data-" + evt + "]"), function(el) {
                return bind(el, "click", self[evt]);
            });
        });
        if (self.isMobile) {
            setupMobile();
            return;
        }
        var debouncedResize = (0, $f89ac564820ae2aa$export$61fc7d43ac8f84b0)(onResize, 50);
        self._debouncedChange = (0, $f89ac564820ae2aa$export$61fc7d43ac8f84b0)(triggerChange, $c3496a40a394bf09$var$DEBOUNCED_CHANGE_MS);
        if (self.daysContainer && !/iPhone|iPad|iPod/i.test(navigator.userAgent)) bind(self.daysContainer, "mouseover", function(e) {
            if (self.config.mode === "range") onMouseOver((0, $da40c9ef6edf896a$export$e58f029f0fbfdb29)(e));
        });
        bind(self._input, "keydown", onKeyDown);
        if (self.calendarContainer !== undefined) bind(self.calendarContainer, "keydown", onKeyDown);
        if (!self.config.inline && !self.config.static) bind(window, "resize", debouncedResize);
        if (window.ontouchstart !== undefined) bind(window.document, "touchstart", documentClick);
        else bind(window.document, "mousedown", documentClick);
        bind(window.document, "focus", documentClick, {
            capture: true
        });
        if (self.config.clickOpens === true) {
            bind(self._input, "focus", self.open);
            bind(self._input, "click", self.open);
        }
        if (self.daysContainer !== undefined) {
            bind(self.monthNav, "click", onMonthNavClick);
            bind(self.monthNav, [
                "keyup",
                "increment"
            ], onYearInput);
            bind(self.daysContainer, "click", selectDate);
        }
        if (self.timeContainer !== undefined && self.minuteElement !== undefined && self.hourElement !== undefined) {
            var selText = function(e) {
                return (0, $da40c9ef6edf896a$export$e58f029f0fbfdb29)(e).select();
            };
            bind(self.timeContainer, [
                "increment"
            ], updateTime);
            bind(self.timeContainer, "blur", updateTime, {
                capture: true
            });
            bind(self.timeContainer, "click", timeIncrement);
            bind([
                self.hourElement,
                self.minuteElement
            ], [
                "focus",
                "click"
            ], selText);
            if (self.secondElement !== undefined) bind(self.secondElement, "focus", function() {
                return self.secondElement && self.secondElement.select();
            });
            if (self.amPM !== undefined) bind(self.amPM, "click", function(e) {
                updateTime(e);
            });
        }
        if (self.config.allowInput) bind(self._input, "blur", onBlur);
    }
    function jumpToDate(jumpDate, triggerChange) {
        var jumpTo = jumpDate !== undefined ? self.parseDate(jumpDate) : self.latestSelectedDateObj || (self.config.minDate && self.config.minDate > self.now ? self.config.minDate : self.config.maxDate && self.config.maxDate < self.now ? self.config.maxDate : self.now);
        var oldYear = self.currentYear;
        var oldMonth = self.currentMonth;
        try {
            if (jumpTo !== undefined) {
                self.currentYear = jumpTo.getFullYear();
                self.currentMonth = jumpTo.getMonth();
            }
        } catch (e) {
            e.message = "Invalid date supplied: " + jumpTo;
            self.config.errorHandler(e);
        }
        if (triggerChange && self.currentYear !== oldYear) {
            triggerEvent("onYearChange");
            buildMonthSwitch();
        }
        if (triggerChange && (self.currentYear !== oldYear || self.currentMonth !== oldMonth)) triggerEvent("onMonthChange");
        self.redraw();
    }
    function timeIncrement(e) {
        var eventTarget = (0, $da40c9ef6edf896a$export$e58f029f0fbfdb29)(e);
        if (~eventTarget.className.indexOf("arrow")) incrementNumInput(e, eventTarget.classList.contains("arrowUp") ? 1 : -1);
    }
    function incrementNumInput(e, delta, inputElem) {
        var target = e && (0, $da40c9ef6edf896a$export$e58f029f0fbfdb29)(e);
        var input = inputElem || target && target.parentNode && target.parentNode.firstChild;
        var event = createEvent("increment");
        event.delta = delta;
        input && input.dispatchEvent(event);
    }
    function build() {
        var fragment = window.document.createDocumentFragment();
        self.calendarContainer = (0, $da40c9ef6edf896a$export$c8a8987d4410bf2d)("div", "flatpickr-calendar");
        self.calendarContainer.tabIndex = -1;
        if (!self.config.noCalendar) {
            fragment.appendChild(buildMonthNav());
            self.innerContainer = (0, $da40c9ef6edf896a$export$c8a8987d4410bf2d)("div", "flatpickr-innerContainer");
            if (self.config.weekNumbers) {
                var _a = buildWeeks(), weekWrapper = _a.weekWrapper, weekNumbers = _a.weekNumbers;
                self.innerContainer.appendChild(weekWrapper);
                self.weekNumbers = weekNumbers;
                self.weekWrapper = weekWrapper;
            }
            self.rContainer = (0, $da40c9ef6edf896a$export$c8a8987d4410bf2d)("div", "flatpickr-rContainer");
            self.rContainer.appendChild(buildWeekdays());
            if (!self.daysContainer) {
                self.daysContainer = (0, $da40c9ef6edf896a$export$c8a8987d4410bf2d)("div", "flatpickr-days");
                self.daysContainer.tabIndex = -1;
            }
            buildDays();
            self.rContainer.appendChild(self.daysContainer);
            self.innerContainer.appendChild(self.rContainer);
            fragment.appendChild(self.innerContainer);
        }
        if (self.config.enableTime) fragment.appendChild(buildTime());
        (0, $da40c9ef6edf896a$export$4a80062ca50b57c7)(self.calendarContainer, "rangeMode", self.config.mode === "range");
        (0, $da40c9ef6edf896a$export$4a80062ca50b57c7)(self.calendarContainer, "animate", self.config.animate === true);
        (0, $da40c9ef6edf896a$export$4a80062ca50b57c7)(self.calendarContainer, "multiMonth", self.config.showMonths > 1);
        self.calendarContainer.appendChild(fragment);
        var customAppend = self.config.appendTo !== undefined && self.config.appendTo.nodeType !== undefined;
        if (self.config.inline || self.config.static) {
            self.calendarContainer.classList.add(self.config.inline ? "inline" : "static");
            if (self.config.inline) {
                if (!customAppend && self.element.parentNode) self.element.parentNode.insertBefore(self.calendarContainer, self._input.nextSibling);
                else if (self.config.appendTo !== undefined) self.config.appendTo.appendChild(self.calendarContainer);
            }
            if (self.config.static) {
                var wrapper = (0, $da40c9ef6edf896a$export$c8a8987d4410bf2d)("div", "flatpickr-wrapper");
                if (self.element.parentNode) self.element.parentNode.insertBefore(wrapper, self.element);
                wrapper.appendChild(self.element);
                if (self.altInput) wrapper.appendChild(self.altInput);
                wrapper.appendChild(self.calendarContainer);
            }
        }
        if (!self.config.static && !self.config.inline) (self.config.appendTo !== undefined ? self.config.appendTo : window.document.body).appendChild(self.calendarContainer);
    }
    function createDay(className, date, _dayNumber, i) {
        var dateIsEnabled = isEnabled(date, true), dayElement = (0, $da40c9ef6edf896a$export$c8a8987d4410bf2d)("span", className, date.getDate().toString());
        dayElement.dateObj = date;
        dayElement.$i = i;
        dayElement.setAttribute("aria-label", self.formatDate(date, self.config.ariaDateFormat));
        if (className.indexOf("hidden") === -1 && (0, $eeeb315f1c4d591c$export$c4c806e061935577)(date, self.now) === 0) {
            self.todayDateElem = dayElement;
            dayElement.classList.add("today");
            dayElement.setAttribute("aria-current", "date");
        }
        if (dateIsEnabled) {
            dayElement.tabIndex = -1;
            if (isDateSelected(date)) {
                dayElement.classList.add("selected");
                self.selectedDateElem = dayElement;
                if (self.config.mode === "range") {
                    (0, $da40c9ef6edf896a$export$4a80062ca50b57c7)(dayElement, "startRange", self.selectedDates[0] && (0, $eeeb315f1c4d591c$export$c4c806e061935577)(date, self.selectedDates[0], true) === 0);
                    (0, $da40c9ef6edf896a$export$4a80062ca50b57c7)(dayElement, "endRange", self.selectedDates[1] && (0, $eeeb315f1c4d591c$export$c4c806e061935577)(date, self.selectedDates[1], true) === 0);
                    if (className === "nextMonthDay") dayElement.classList.add("inRange");
                }
            }
        } else dayElement.classList.add("flatpickr-disabled");
        if (self.config.mode === "range") {
            if (isDateInRange(date) && !isDateSelected(date)) dayElement.classList.add("inRange");
        }
        if (self.weekNumbers && self.config.showMonths === 1 && className !== "prevMonthDay" && i % 7 === 6) self.weekNumbers.insertAdjacentHTML("beforeend", "<span class='flatpickr-day'>" + self.config.getWeek(date) + "</span>");
        triggerEvent("onDayCreate", dayElement);
        return dayElement;
    }
    function focusOnDayElem(targetNode) {
        targetNode.focus();
        if (self.config.mode === "range") onMouseOver(targetNode);
    }
    function getFirstAvailableDay(delta) {
        var startMonth = delta > 0 ? 0 : self.config.showMonths - 1;
        var endMonth = delta > 0 ? self.config.showMonths : -1;
        for(var m = startMonth; m != endMonth; m += delta){
            var month = self.daysContainer.children[m];
            var startIndex = delta > 0 ? 0 : month.children.length - 1;
            var endIndex = delta > 0 ? month.children.length : -1;
            for(var i = startIndex; i != endIndex; i += delta){
                var c = month.children[i];
                if (c.className.indexOf("hidden") === -1 && isEnabled(c.dateObj)) return c;
            }
        }
        return undefined;
    }
    function getNextAvailableDay(current, delta) {
        var givenMonth = current.className.indexOf("Month") === -1 ? current.dateObj.getMonth() : self.currentMonth;
        var endMonth = delta > 0 ? self.config.showMonths : -1;
        var loopDelta = delta > 0 ? 1 : -1;
        for(var m = givenMonth - self.currentMonth; m != endMonth; m += loopDelta){
            var month = self.daysContainer.children[m];
            var startIndex = givenMonth - self.currentMonth === m ? current.$i + delta : delta < 0 ? month.children.length - 1 : 0;
            var numMonthDays = month.children.length;
            for(var i = startIndex; i >= 0 && i < numMonthDays && i != (delta > 0 ? numMonthDays : -1); i += loopDelta){
                var c = month.children[i];
                if (c.className.indexOf("hidden") === -1 && isEnabled(c.dateObj) && Math.abs(current.$i - i) >= Math.abs(delta)) return focusOnDayElem(c);
            }
        }
        self.changeMonth(loopDelta);
        focusOnDay(getFirstAvailableDay(loopDelta), 0);
        return undefined;
    }
    function focusOnDay(current, offset) {
        var activeElement = getClosestActiveElement();
        var dayFocused = isInView(activeElement || document.body);
        var startElem = current !== undefined ? current : dayFocused ? activeElement : self.selectedDateElem !== undefined && isInView(self.selectedDateElem) ? self.selectedDateElem : self.todayDateElem !== undefined && isInView(self.todayDateElem) ? self.todayDateElem : getFirstAvailableDay(offset > 0 ? 1 : -1);
        if (startElem === undefined) self._input.focus();
        else if (!dayFocused) focusOnDayElem(startElem);
        else getNextAvailableDay(startElem, offset);
    }
    function buildMonthDays(year, month) {
        var firstOfMonth = (new Date(year, month, 1).getDay() - self.l10n.firstDayOfWeek + 7) % 7;
        var prevMonthDays = self.utils.getDaysInMonth((month - 1 + 12) % 12, year);
        var daysInMonth = self.utils.getDaysInMonth(month, year), days = window.document.createDocumentFragment(), isMultiMonth = self.config.showMonths > 1, prevMonthDayClass = isMultiMonth ? "prevMonthDay hidden" : "prevMonthDay", nextMonthDayClass = isMultiMonth ? "nextMonthDay hidden" : "nextMonthDay";
        var dayNumber = prevMonthDays + 1 - firstOfMonth, dayIndex = 0;
        for(; dayNumber <= prevMonthDays; dayNumber++, dayIndex++)days.appendChild(createDay("flatpickr-day " + prevMonthDayClass, new Date(year, month - 1, dayNumber), dayNumber, dayIndex));
        for(dayNumber = 1; dayNumber <= daysInMonth; dayNumber++, dayIndex++)days.appendChild(createDay("flatpickr-day", new Date(year, month, dayNumber), dayNumber, dayIndex));
        for(var dayNum = daysInMonth + 1; dayNum <= 42 - firstOfMonth && (self.config.showMonths === 1 || dayIndex % 7 !== 0); dayNum++, dayIndex++)days.appendChild(createDay("flatpickr-day " + nextMonthDayClass, new Date(year, month + 1, dayNum % daysInMonth), dayNum, dayIndex));
        var dayContainer = (0, $da40c9ef6edf896a$export$c8a8987d4410bf2d)("div", "dayContainer");
        dayContainer.appendChild(days);
        return dayContainer;
    }
    function buildDays() {
        if (self.daysContainer === undefined) return;
        (0, $da40c9ef6edf896a$export$51cfe97d637c237c)(self.daysContainer);
        if (self.weekNumbers) (0, $da40c9ef6edf896a$export$51cfe97d637c237c)(self.weekNumbers);
        var frag = document.createDocumentFragment();
        for(var i = 0; i < self.config.showMonths; i++){
            var d = new Date(self.currentYear, self.currentMonth, 1);
            d.setMonth(self.currentMonth + i);
            frag.appendChild(buildMonthDays(d.getFullYear(), d.getMonth()));
        }
        self.daysContainer.appendChild(frag);
        self.days = self.daysContainer.firstChild;
        if (self.config.mode === "range" && self.selectedDates.length === 1) onMouseOver();
    }
    function buildMonthSwitch() {
        if (self.config.showMonths > 1 || self.config.monthSelectorType !== "dropdown") return;
        var shouldBuildMonth = function(month) {
            if (self.config.minDate !== undefined && self.currentYear === self.config.minDate.getFullYear() && month < self.config.minDate.getMonth()) return false;
            return !(self.config.maxDate !== undefined && self.currentYear === self.config.maxDate.getFullYear() && month > self.config.maxDate.getMonth());
        };
        self.monthsDropdownContainer.tabIndex = -1;
        self.monthsDropdownContainer.innerHTML = "";
        for(var i = 0; i < 12; i++){
            if (!shouldBuildMonth(i)) continue;
            var month = (0, $da40c9ef6edf896a$export$c8a8987d4410bf2d)("option", "flatpickr-monthDropdown-month");
            month.value = new Date(self.currentYear, i).getMonth().toString();
            month.textContent = (0, $9816dab19e3bd8be$export$27a2dd9af757e89c)(i, self.config.shorthandCurrentMonth, self.l10n);
            month.tabIndex = -1;
            if (self.currentMonth === i) month.selected = true;
            self.monthsDropdownContainer.appendChild(month);
        }
    }
    function buildMonth() {
        var container = (0, $da40c9ef6edf896a$export$c8a8987d4410bf2d)("div", "flatpickr-month");
        var monthNavFragment = window.document.createDocumentFragment();
        var monthElement;
        if (self.config.showMonths > 1 || self.config.monthSelectorType === "static") monthElement = (0, $da40c9ef6edf896a$export$c8a8987d4410bf2d)("span", "cur-month");
        else {
            self.monthsDropdownContainer = (0, $da40c9ef6edf896a$export$c8a8987d4410bf2d)("select", "flatpickr-monthDropdown-months");
            self.monthsDropdownContainer.setAttribute("aria-label", self.l10n.monthAriaLabel);
            bind(self.monthsDropdownContainer, "change", function(e) {
                var target = (0, $da40c9ef6edf896a$export$e58f029f0fbfdb29)(e);
                var selectedMonth = parseInt(target.value, 10);
                self.changeMonth(selectedMonth - self.currentMonth);
                triggerEvent("onMonthChange");
            });
            buildMonthSwitch();
            monthElement = self.monthsDropdownContainer;
        }
        var yearInput = (0, $da40c9ef6edf896a$export$afe9d610a3284048)("cur-year", {
            tabindex: "-1"
        });
        var yearElement = yearInput.getElementsByTagName("input")[0];
        yearElement.setAttribute("aria-label", self.l10n.yearAriaLabel);
        if (self.config.minDate) yearElement.setAttribute("min", self.config.minDate.getFullYear().toString());
        if (self.config.maxDate) {
            yearElement.setAttribute("max", self.config.maxDate.getFullYear().toString());
            yearElement.disabled = !!self.config.minDate && self.config.minDate.getFullYear() === self.config.maxDate.getFullYear();
        }
        var currentMonth = (0, $da40c9ef6edf896a$export$c8a8987d4410bf2d)("div", "flatpickr-current-month");
        currentMonth.appendChild(monthElement);
        currentMonth.appendChild(yearInput);
        monthNavFragment.appendChild(currentMonth);
        container.appendChild(monthNavFragment);
        return {
            container: container,
            yearElement: yearElement,
            monthElement: monthElement
        };
    }
    function buildMonths() {
        (0, $da40c9ef6edf896a$export$51cfe97d637c237c)(self.monthNav);
        self.monthNav.appendChild(self.prevMonthNav);
        if (self.config.showMonths) {
            self.yearElements = [];
            self.monthElements = [];
        }
        for(var m = self.config.showMonths; m--;){
            var month = buildMonth();
            self.yearElements.push(month.yearElement);
            self.monthElements.push(month.monthElement);
            self.monthNav.appendChild(month.container);
        }
        self.monthNav.appendChild(self.nextMonthNav);
    }
    function buildMonthNav() {
        self.monthNav = (0, $da40c9ef6edf896a$export$c8a8987d4410bf2d)("div", "flatpickr-months");
        self.yearElements = [];
        self.monthElements = [];
        self.prevMonthNav = (0, $da40c9ef6edf896a$export$c8a8987d4410bf2d)("span", "flatpickr-prev-month");
        self.prevMonthNav.innerHTML = self.config.prevArrow;
        self.nextMonthNav = (0, $da40c9ef6edf896a$export$c8a8987d4410bf2d)("span", "flatpickr-next-month");
        self.nextMonthNav.innerHTML = self.config.nextArrow;
        buildMonths();
        Object.defineProperty(self, "_hidePrevMonthArrow", {
            get: function() {
                return self.__hidePrevMonthArrow;
            },
            set: function(bool) {
                if (self.__hidePrevMonthArrow !== bool) {
                    (0, $da40c9ef6edf896a$export$4a80062ca50b57c7)(self.prevMonthNav, "flatpickr-disabled", bool);
                    self.__hidePrevMonthArrow = bool;
                }
            }
        });
        Object.defineProperty(self, "_hideNextMonthArrow", {
            get: function() {
                return self.__hideNextMonthArrow;
            },
            set: function(bool) {
                if (self.__hideNextMonthArrow !== bool) {
                    (0, $da40c9ef6edf896a$export$4a80062ca50b57c7)(self.nextMonthNav, "flatpickr-disabled", bool);
                    self.__hideNextMonthArrow = bool;
                }
            }
        });
        self.currentYearElement = self.yearElements[0];
        updateNavigationCurrentMonth();
        return self.monthNav;
    }
    function buildTime() {
        self.calendarContainer.classList.add("hasTime");
        if (self.config.noCalendar) self.calendarContainer.classList.add("noCalendar");
        var defaults = (0, $eeeb315f1c4d591c$export$6df0e87d3fffbd14)(self.config);
        self.timeContainer = (0, $da40c9ef6edf896a$export$c8a8987d4410bf2d)("div", "flatpickr-time");
        self.timeContainer.tabIndex = -1;
        var separator = (0, $da40c9ef6edf896a$export$c8a8987d4410bf2d)("span", "flatpickr-time-separator", ":");
        var hourInput = (0, $da40c9ef6edf896a$export$afe9d610a3284048)("flatpickr-hour", {
            "aria-label": self.l10n.hourAriaLabel
        });
        self.hourElement = hourInput.getElementsByTagName("input")[0];
        var minuteInput = (0, $da40c9ef6edf896a$export$afe9d610a3284048)("flatpickr-minute", {
            "aria-label": self.l10n.minuteAriaLabel
        });
        self.minuteElement = minuteInput.getElementsByTagName("input")[0];
        self.hourElement.tabIndex = self.minuteElement.tabIndex = -1;
        self.hourElement.value = (0, $f89ac564820ae2aa$export$5d04458e2a6c373e)(self.latestSelectedDateObj ? self.latestSelectedDateObj.getHours() : self.config.time_24hr ? defaults.hours : military2ampm(defaults.hours));
        self.minuteElement.value = (0, $f89ac564820ae2aa$export$5d04458e2a6c373e)(self.latestSelectedDateObj ? self.latestSelectedDateObj.getMinutes() : defaults.minutes);
        self.hourElement.setAttribute("step", self.config.hourIncrement.toString());
        self.minuteElement.setAttribute("step", self.config.minuteIncrement.toString());
        self.hourElement.setAttribute("min", self.config.time_24hr ? "0" : "1");
        self.hourElement.setAttribute("max", self.config.time_24hr ? "23" : "12");
        self.hourElement.setAttribute("maxlength", "2");
        self.minuteElement.setAttribute("min", "0");
        self.minuteElement.setAttribute("max", "59");
        self.minuteElement.setAttribute("maxlength", "2");
        self.timeContainer.appendChild(hourInput);
        self.timeContainer.appendChild(separator);
        self.timeContainer.appendChild(minuteInput);
        if (self.config.time_24hr) self.timeContainer.classList.add("time24hr");
        if (self.config.enableSeconds) {
            self.timeContainer.classList.add("hasSeconds");
            var secondInput = (0, $da40c9ef6edf896a$export$afe9d610a3284048)("flatpickr-second");
            self.secondElement = secondInput.getElementsByTagName("input")[0];
            self.secondElement.value = (0, $f89ac564820ae2aa$export$5d04458e2a6c373e)(self.latestSelectedDateObj ? self.latestSelectedDateObj.getSeconds() : defaults.seconds);
            self.secondElement.setAttribute("step", self.minuteElement.getAttribute("step"));
            self.secondElement.setAttribute("min", "0");
            self.secondElement.setAttribute("max", "59");
            self.secondElement.setAttribute("maxlength", "2");
            self.timeContainer.appendChild((0, $da40c9ef6edf896a$export$c8a8987d4410bf2d)("span", "flatpickr-time-separator", ":"));
            self.timeContainer.appendChild(secondInput);
        }
        if (!self.config.time_24hr) {
            self.amPM = (0, $da40c9ef6edf896a$export$c8a8987d4410bf2d)("span", "flatpickr-am-pm", self.l10n.amPM[(0, $f89ac564820ae2aa$export$7d260a2a5f8bc19e)((self.latestSelectedDateObj ? self.hourElement.value : self.config.defaultHour) > 11)]);
            self.amPM.title = self.l10n.toggleTitle;
            self.amPM.tabIndex = -1;
            self.timeContainer.appendChild(self.amPM);
        }
        return self.timeContainer;
    }
    function buildWeekdays() {
        if (!self.weekdayContainer) self.weekdayContainer = (0, $da40c9ef6edf896a$export$c8a8987d4410bf2d)("div", "flatpickr-weekdays");
        else (0, $da40c9ef6edf896a$export$51cfe97d637c237c)(self.weekdayContainer);
        for(var i = self.config.showMonths; i--;){
            var container = (0, $da40c9ef6edf896a$export$c8a8987d4410bf2d)("div", "flatpickr-weekdaycontainer");
            self.weekdayContainer.appendChild(container);
        }
        updateWeekdays();
        return self.weekdayContainer;
    }
    function updateWeekdays() {
        if (!self.weekdayContainer) return;
        var firstDayOfWeek = self.l10n.firstDayOfWeek;
        var weekdays = $c3496a40a394bf09$var$__spreadArrays(self.l10n.weekdays.shorthand);
        if (firstDayOfWeek > 0 && firstDayOfWeek < weekdays.length) weekdays = $c3496a40a394bf09$var$__spreadArrays(weekdays.splice(firstDayOfWeek, weekdays.length), weekdays.splice(0, firstDayOfWeek));
        for(var i = self.config.showMonths; i--;)self.weekdayContainer.children[i].innerHTML = "\n      <span class='flatpickr-weekday'>\n        " + weekdays.join("</span><span class='flatpickr-weekday'>") + "\n      </span>\n      ";
    }
    function buildWeeks() {
        self.calendarContainer.classList.add("hasWeeks");
        var weekWrapper = (0, $da40c9ef6edf896a$export$c8a8987d4410bf2d)("div", "flatpickr-weekwrapper");
        weekWrapper.appendChild((0, $da40c9ef6edf896a$export$c8a8987d4410bf2d)("span", "flatpickr-weekday", self.l10n.weekAbbreviation));
        var weekNumbers = (0, $da40c9ef6edf896a$export$c8a8987d4410bf2d)("div", "flatpickr-weeks");
        weekWrapper.appendChild(weekNumbers);
        return {
            weekWrapper: weekWrapper,
            weekNumbers: weekNumbers
        };
    }
    function changeMonth(value, isOffset) {
        if (isOffset === void 0) isOffset = true;
        var delta = isOffset ? value : value - self.currentMonth;
        if (delta < 0 && self._hidePrevMonthArrow === true || delta > 0 && self._hideNextMonthArrow === true) return;
        self.currentMonth += delta;
        if (self.currentMonth < 0 || self.currentMonth > 11) {
            self.currentYear += self.currentMonth > 11 ? 1 : -1;
            self.currentMonth = (self.currentMonth + 12) % 12;
            triggerEvent("onYearChange");
            buildMonthSwitch();
        }
        buildDays();
        triggerEvent("onMonthChange");
        updateNavigationCurrentMonth();
    }
    function clear(triggerChangeEvent, toInitial) {
        if (triggerChangeEvent === void 0) triggerChangeEvent = true;
        if (toInitial === void 0) toInitial = true;
        self.input.value = "";
        if (self.altInput !== undefined) self.altInput.value = "";
        if (self.mobileInput !== undefined) self.mobileInput.value = "";
        self.selectedDates = [];
        self.latestSelectedDateObj = undefined;
        if (toInitial === true) {
            self.currentYear = self._initialDate.getFullYear();
            self.currentMonth = self._initialDate.getMonth();
        }
        if (self.config.enableTime === true) {
            var _a = (0, $eeeb315f1c4d591c$export$6df0e87d3fffbd14)(self.config), hours = _a.hours, minutes = _a.minutes, seconds = _a.seconds;
            setHours(hours, minutes, seconds);
        }
        self.redraw();
        if (triggerChangeEvent) triggerEvent("onChange");
    }
    function close() {
        self.isOpen = false;
        if (!self.isMobile) {
            if (self.calendarContainer !== undefined) self.calendarContainer.classList.remove("open");
            if (self._input !== undefined) self._input.classList.remove("active");
        }
        triggerEvent("onClose");
    }
    function destroy() {
        if (self.config !== undefined) triggerEvent("onDestroy");
        for(var i = self._handlers.length; i--;)self._handlers[i].remove();
        self._handlers = [];
        if (self.mobileInput) {
            if (self.mobileInput.parentNode) self.mobileInput.parentNode.removeChild(self.mobileInput);
            self.mobileInput = undefined;
        } else if (self.calendarContainer && self.calendarContainer.parentNode) {
            if (self.config.static && self.calendarContainer.parentNode) {
                var wrapper = self.calendarContainer.parentNode;
                wrapper.lastChild && wrapper.removeChild(wrapper.lastChild);
                if (wrapper.parentNode) {
                    while(wrapper.firstChild)wrapper.parentNode.insertBefore(wrapper.firstChild, wrapper);
                    wrapper.parentNode.removeChild(wrapper);
                }
            } else self.calendarContainer.parentNode.removeChild(self.calendarContainer);
        }
        if (self.altInput) {
            self.input.type = "text";
            if (self.altInput.parentNode) self.altInput.parentNode.removeChild(self.altInput);
            delete self.altInput;
        }
        if (self.input) {
            self.input.type = self.input._type;
            self.input.classList.remove("flatpickr-input");
            self.input.removeAttribute("readonly");
        }
        [
            "_showTimeInput",
            "latestSelectedDateObj",
            "_hideNextMonthArrow",
            "_hidePrevMonthArrow",
            "__hideNextMonthArrow",
            "__hidePrevMonthArrow",
            "isMobile",
            "isOpen",
            "selectedDateElem",
            "minDateHasTime",
            "maxDateHasTime",
            "days",
            "daysContainer",
            "_input",
            "_positionElement",
            "innerContainer",
            "rContainer",
            "monthNav",
            "todayDateElem",
            "calendarContainer",
            "weekdayContainer",
            "prevMonthNav",
            "nextMonthNav",
            "monthsDropdownContainer",
            "currentMonthElement",
            "currentYearElement",
            "navigationCurrentMonth",
            "selectedDateElem",
            "config"
        ].forEach(function(k) {
            try {
                delete self[k];
            } catch (_) {}
        });
    }
    function isCalendarElem(elem) {
        return self.calendarContainer.contains(elem);
    }
    function documentClick(e) {
        if (self.isOpen && !self.config.inline) {
            var eventTarget_1 = (0, $da40c9ef6edf896a$export$e58f029f0fbfdb29)(e);
            var isCalendarElement = isCalendarElem(eventTarget_1);
            var isInput = eventTarget_1 === self.input || eventTarget_1 === self.altInput || self.element.contains(eventTarget_1) || e.path && e.path.indexOf && (~e.path.indexOf(self.input) || ~e.path.indexOf(self.altInput));
            var lostFocus = !isInput && !isCalendarElement && !isCalendarElem(e.relatedTarget);
            var isIgnored = !self.config.ignoredFocusElements.some(function(elem) {
                return elem.contains(eventTarget_1);
            });
            if (lostFocus && isIgnored) {
                if (self.config.allowInput) self.setDate(self._input.value, false, self.config.altInput ? self.config.altFormat : self.config.dateFormat);
                if (self.timeContainer !== undefined && self.minuteElement !== undefined && self.hourElement !== undefined && self.input.value !== "" && self.input.value !== undefined) updateTime();
                self.close();
                if (self.config && self.config.mode === "range" && self.selectedDates.length === 1) self.clear(false);
            }
        }
    }
    function changeYear(newYear) {
        if (!newYear || self.config.minDate && newYear < self.config.minDate.getFullYear() || self.config.maxDate && newYear > self.config.maxDate.getFullYear()) return;
        var newYearNum = newYear, isNewYear = self.currentYear !== newYearNum;
        self.currentYear = newYearNum || self.currentYear;
        if (self.config.maxDate && self.currentYear === self.config.maxDate.getFullYear()) self.currentMonth = Math.min(self.config.maxDate.getMonth(), self.currentMonth);
        else if (self.config.minDate && self.currentYear === self.config.minDate.getFullYear()) self.currentMonth = Math.max(self.config.minDate.getMonth(), self.currentMonth);
        if (isNewYear) {
            self.redraw();
            triggerEvent("onYearChange");
            buildMonthSwitch();
        }
    }
    function isEnabled(date, timeless) {
        var _a;
        if (timeless === void 0) timeless = true;
        var dateToCheck = self.parseDate(date, undefined, timeless);
        if (self.config.minDate && dateToCheck && (0, $eeeb315f1c4d591c$export$c4c806e061935577)(dateToCheck, self.config.minDate, timeless !== undefined ? timeless : !self.minDateHasTime) < 0 || self.config.maxDate && dateToCheck && (0, $eeeb315f1c4d591c$export$c4c806e061935577)(dateToCheck, self.config.maxDate, timeless !== undefined ? timeless : !self.maxDateHasTime) > 0) return false;
        if (!self.config.enable && self.config.disable.length === 0) return true;
        if (dateToCheck === undefined) return false;
        var bool = !!self.config.enable, array = (_a = self.config.enable) !== null && _a !== void 0 ? _a : self.config.disable;
        for(var i = 0, d = void 0; i < array.length; i++){
            d = array[i];
            if (typeof d === "function" && d(dateToCheck)) return bool;
            else if (d instanceof Date && dateToCheck !== undefined && d.getTime() === dateToCheck.getTime()) return bool;
            else if (typeof d === "string") {
                var parsed = self.parseDate(d, undefined, true);
                return parsed && parsed.getTime() === dateToCheck.getTime() ? bool : !bool;
            } else if (typeof d === "object" && dateToCheck !== undefined && d.from && d.to && dateToCheck.getTime() >= d.from.getTime() && dateToCheck.getTime() <= d.to.getTime()) return bool;
        }
        return !bool;
    }
    function isInView(elem) {
        if (self.daysContainer !== undefined) return elem.className.indexOf("hidden") === -1 && elem.className.indexOf("flatpickr-disabled") === -1 && self.daysContainer.contains(elem);
        return false;
    }
    function onBlur(e) {
        var isInput = e.target === self._input;
        var valueChanged = self._input.value.trimEnd() !== getDateStr();
        if (isInput && valueChanged && !(e.relatedTarget && isCalendarElem(e.relatedTarget))) self.setDate(self._input.value, true, e.target === self.altInput ? self.config.altFormat : self.config.dateFormat);
    }
    function onKeyDown(e) {
        var eventTarget = (0, $da40c9ef6edf896a$export$e58f029f0fbfdb29)(e);
        var isInput = self.config.wrap ? element.contains(eventTarget) : eventTarget === self._input;
        var allowInput = self.config.allowInput;
        var allowKeydown = self.isOpen && (!allowInput || !isInput);
        var allowInlineKeydown = self.config.inline && isInput && !allowInput;
        if (e.keyCode === 13 && isInput) {
            if (allowInput) {
                self.setDate(self._input.value, true, eventTarget === self.altInput ? self.config.altFormat : self.config.dateFormat);
                self.close();
                return eventTarget.blur();
            } else self.open();
        } else if (isCalendarElem(eventTarget) || allowKeydown || allowInlineKeydown) {
            var isTimeObj = !!self.timeContainer && self.timeContainer.contains(eventTarget);
            switch(e.keyCode){
                case 13:
                    if (isTimeObj) {
                        e.preventDefault();
                        updateTime();
                        focusAndClose();
                    } else selectDate(e);
                    break;
                case 27:
                    e.preventDefault();
                    focusAndClose();
                    break;
                case 8:
                case 46:
                    if (isInput && !self.config.allowInput) {
                        e.preventDefault();
                        self.clear();
                    }
                    break;
                case 37:
                case 39:
                    if (!isTimeObj && !isInput) {
                        e.preventDefault();
                        var activeElement = getClosestActiveElement();
                        if (self.daysContainer !== undefined && (allowInput === false || activeElement && isInView(activeElement))) {
                            var delta_1 = e.keyCode === 39 ? 1 : -1;
                            if (!e.ctrlKey) focusOnDay(undefined, delta_1);
                            else {
                                e.stopPropagation();
                                changeMonth(delta_1);
                                focusOnDay(getFirstAvailableDay(1), 0);
                            }
                        }
                    } else if (self.hourElement) self.hourElement.focus();
                    break;
                case 38:
                case 40:
                    e.preventDefault();
                    var delta = e.keyCode === 40 ? 1 : -1;
                    if (self.daysContainer && eventTarget.$i !== undefined || eventTarget === self.input || eventTarget === self.altInput) {
                        if (e.ctrlKey) {
                            e.stopPropagation();
                            changeYear(self.currentYear - delta);
                            focusOnDay(getFirstAvailableDay(1), 0);
                        } else if (!isTimeObj) focusOnDay(undefined, delta * 7);
                    } else if (eventTarget === self.currentYearElement) changeYear(self.currentYear - delta);
                    else if (self.config.enableTime) {
                        if (!isTimeObj && self.hourElement) self.hourElement.focus();
                        updateTime(e);
                        self._debouncedChange();
                    }
                    break;
                case 9:
                    if (isTimeObj) {
                        var elems = [
                            self.hourElement,
                            self.minuteElement,
                            self.secondElement,
                            self.amPM
                        ].concat(self.pluginElements).filter(function(x) {
                            return x;
                        });
                        var i = elems.indexOf(eventTarget);
                        if (i !== -1) {
                            var target = elems[i + (e.shiftKey ? -1 : 1)];
                            e.preventDefault();
                            (target || self._input).focus();
                        }
                    } else if (!self.config.noCalendar && self.daysContainer && self.daysContainer.contains(eventTarget) && e.shiftKey) {
                        e.preventDefault();
                        self._input.focus();
                    }
                    break;
                default:
                    break;
            }
        }
        if (self.amPM !== undefined && eventTarget === self.amPM) switch(e.key){
            case self.l10n.amPM[0].charAt(0):
            case self.l10n.amPM[0].charAt(0).toLowerCase():
                self.amPM.textContent = self.l10n.amPM[0];
                setHoursFromInputs();
                updateValue();
                break;
            case self.l10n.amPM[1].charAt(0):
            case self.l10n.amPM[1].charAt(0).toLowerCase():
                self.amPM.textContent = self.l10n.amPM[1];
                setHoursFromInputs();
                updateValue();
                break;
        }
        if (isInput || isCalendarElem(eventTarget)) triggerEvent("onKeyDown", e);
    }
    function onMouseOver(elem, cellClass) {
        if (cellClass === void 0) cellClass = "flatpickr-day";
        if (self.selectedDates.length !== 1 || elem && (!elem.classList.contains(cellClass) || elem.classList.contains("flatpickr-disabled"))) return;
        var hoverDate = elem ? elem.dateObj.getTime() : self.days.firstElementChild.dateObj.getTime(), initialDate = self.parseDate(self.selectedDates[0], undefined, true).getTime(), rangeStartDate = Math.min(hoverDate, self.selectedDates[0].getTime()), rangeEndDate = Math.max(hoverDate, self.selectedDates[0].getTime());
        var containsDisabled = false;
        var minRange = 0, maxRange = 0;
        for(var t = rangeStartDate; t < rangeEndDate; t += (0, $eeeb315f1c4d591c$export$1f34108aa9eb96ab).DAY)if (!isEnabled(new Date(t), true)) {
            containsDisabled = containsDisabled || t > rangeStartDate && t < rangeEndDate;
            if (t < initialDate && (!minRange || t > minRange)) minRange = t;
            else if (t > initialDate && (!maxRange || t < maxRange)) maxRange = t;
        }
        var hoverableCells = Array.from(self.rContainer.querySelectorAll("*:nth-child(-n+" + self.config.showMonths + ") > ." + cellClass));
        hoverableCells.forEach(function(dayElem) {
            var date = dayElem.dateObj;
            var timestamp = date.getTime();
            var outOfRange = minRange > 0 && timestamp < minRange || maxRange > 0 && timestamp > maxRange;
            if (outOfRange) {
                dayElem.classList.add("notAllowed");
                [
                    "inRange",
                    "startRange",
                    "endRange"
                ].forEach(function(c) {
                    dayElem.classList.remove(c);
                });
                return;
            } else if (containsDisabled && !outOfRange) return;
            [
                "startRange",
                "inRange",
                "endRange",
                "notAllowed"
            ].forEach(function(c) {
                dayElem.classList.remove(c);
            });
            if (elem !== undefined) {
                elem.classList.add(hoverDate <= self.selectedDates[0].getTime() ? "startRange" : "endRange");
                if (initialDate < hoverDate && timestamp === initialDate) dayElem.classList.add("startRange");
                else if (initialDate > hoverDate && timestamp === initialDate) dayElem.classList.add("endRange");
                if (timestamp >= minRange && (maxRange === 0 || timestamp <= maxRange) && (0, $eeeb315f1c4d591c$export$a4d69fb5f2026c35)(timestamp, initialDate, hoverDate)) dayElem.classList.add("inRange");
            }
        });
    }
    function onResize() {
        if (self.isOpen && !self.config.static && !self.config.inline) positionCalendar();
    }
    function open(e, positionElement) {
        if (positionElement === void 0) positionElement = self._positionElement;
        if (self.isMobile === true) {
            if (e) {
                e.preventDefault();
                var eventTarget = (0, $da40c9ef6edf896a$export$e58f029f0fbfdb29)(e);
                if (eventTarget) eventTarget.blur();
            }
            if (self.mobileInput !== undefined) {
                self.mobileInput.focus();
                self.mobileInput.click();
            }
            triggerEvent("onOpen");
            return;
        } else if (self._input.disabled || self.config.inline) return;
        var wasOpen = self.isOpen;
        self.isOpen = true;
        if (!wasOpen) {
            self.calendarContainer.classList.add("open");
            self._input.classList.add("active");
            triggerEvent("onOpen");
            positionCalendar(positionElement);
        }
        if (self.config.enableTime === true && self.config.noCalendar === true) {
            if (self.config.allowInput === false && (e === undefined || !self.timeContainer.contains(e.relatedTarget))) setTimeout(function() {
                return self.hourElement.select();
            }, 50);
        }
    }
    function minMaxDateSetter(type) {
        return function(date) {
            var dateObj = self.config["_" + type + "Date"] = self.parseDate(date, self.config.dateFormat);
            var inverseDateObj = self.config["_" + (type === "min" ? "max" : "min") + "Date"];
            if (dateObj !== undefined) self[type === "min" ? "minDateHasTime" : "maxDateHasTime"] = dateObj.getHours() > 0 || dateObj.getMinutes() > 0 || dateObj.getSeconds() > 0;
            if (self.selectedDates) {
                self.selectedDates = self.selectedDates.filter(function(d) {
                    return isEnabled(d);
                });
                if (!self.selectedDates.length && type === "min") setHoursFromDate(dateObj);
                updateValue();
            }
            if (self.daysContainer) {
                redraw();
                if (dateObj !== undefined) self.currentYearElement[type] = dateObj.getFullYear().toString();
                else self.currentYearElement.removeAttribute(type);
                self.currentYearElement.disabled = !!inverseDateObj && dateObj !== undefined && inverseDateObj.getFullYear() === dateObj.getFullYear();
            }
        };
    }
    function parseConfig() {
        var boolOpts = [
            "wrap",
            "weekNumbers",
            "allowInput",
            "allowInvalidPreload",
            "clickOpens",
            "time_24hr",
            "enableTime",
            "noCalendar",
            "altInput",
            "shorthandCurrentMonth",
            "inline",
            "static",
            "enableSeconds",
            "disableMobile"
        ];
        var userConfig = $c3496a40a394bf09$var$__assign($c3496a40a394bf09$var$__assign({}, JSON.parse(JSON.stringify(element.dataset || {}))), instanceConfig);
        var formats = {};
        self.config.parseDate = userConfig.parseDate;
        self.config.formatDate = userConfig.formatDate;
        Object.defineProperty(self.config, "enable", {
            get: function() {
                return self.config._enable;
            },
            set: function(dates) {
                self.config._enable = parseDateRules(dates);
            }
        });
        Object.defineProperty(self.config, "disable", {
            get: function() {
                return self.config._disable;
            },
            set: function(dates) {
                self.config._disable = parseDateRules(dates);
            }
        });
        var timeMode = userConfig.mode === "time";
        if (!userConfig.dateFormat && (userConfig.enableTime || timeMode)) {
            var defaultDateFormat = $c3496a40a394bf09$var$flatpickr.defaultConfig.dateFormat || (0, $739195af95cf03b2$export$ebe90cb607ad99e).dateFormat;
            formats.dateFormat = userConfig.noCalendar || timeMode ? "H:i" + (userConfig.enableSeconds ? ":S" : "") : defaultDateFormat + " H:i" + (userConfig.enableSeconds ? ":S" : "");
        }
        if (userConfig.altInput && (userConfig.enableTime || timeMode) && !userConfig.altFormat) {
            var defaultAltFormat = $c3496a40a394bf09$var$flatpickr.defaultConfig.altFormat || (0, $739195af95cf03b2$export$ebe90cb607ad99e).altFormat;
            formats.altFormat = userConfig.noCalendar || timeMode ? "h:i" + (userConfig.enableSeconds ? ":S K" : " K") : defaultAltFormat + (" h:i" + (userConfig.enableSeconds ? ":S" : "") + " K");
        }
        Object.defineProperty(self.config, "minDate", {
            get: function() {
                return self.config._minDate;
            },
            set: minMaxDateSetter("min")
        });
        Object.defineProperty(self.config, "maxDate", {
            get: function() {
                return self.config._maxDate;
            },
            set: minMaxDateSetter("max")
        });
        var minMaxTimeSetter = function(type) {
            return function(val) {
                self.config[type === "min" ? "_minTime" : "_maxTime"] = self.parseDate(val, "H:i:S");
            };
        };
        Object.defineProperty(self.config, "minTime", {
            get: function() {
                return self.config._minTime;
            },
            set: minMaxTimeSetter("min")
        });
        Object.defineProperty(self.config, "maxTime", {
            get: function() {
                return self.config._maxTime;
            },
            set: minMaxTimeSetter("max")
        });
        if (userConfig.mode === "time") {
            self.config.noCalendar = true;
            self.config.enableTime = true;
        }
        Object.assign(self.config, formats, userConfig);
        for(var i = 0; i < boolOpts.length; i++)self.config[boolOpts[i]] = self.config[boolOpts[i]] === true || self.config[boolOpts[i]] === "true";
        (0, $739195af95cf03b2$export$c34bb18505e1e253).filter(function(hook) {
            return self.config[hook] !== undefined;
        }).forEach(function(hook) {
            self.config[hook] = (0, $f89ac564820ae2aa$export$3131421a7d01b4fb)(self.config[hook] || []).map(bindToInstance);
        });
        self.isMobile = !self.config.disableMobile && !self.config.inline && self.config.mode === "single" && !self.config.disable.length && !self.config.enable && !self.config.weekNumbers && /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
        for(var i = 0; i < self.config.plugins.length; i++){
            var pluginConf = self.config.plugins[i](self) || {};
            for(var key in pluginConf){
                if ((0, $739195af95cf03b2$export$c34bb18505e1e253).indexOf(key) > -1) self.config[key] = (0, $f89ac564820ae2aa$export$3131421a7d01b4fb)(pluginConf[key]).map(bindToInstance).concat(self.config[key]);
                else if (typeof userConfig[key] === "undefined") self.config[key] = pluginConf[key];
            }
        }
        if (!userConfig.altInputClass) self.config.altInputClass = getInputElem().className + " " + self.config.altInputClass;
        triggerEvent("onParseConfig");
    }
    function getInputElem() {
        return self.config.wrap ? element.querySelector("[data-input]") : element;
    }
    function setupLocale() {
        if (typeof self.config.locale !== "object" && typeof $c3496a40a394bf09$var$flatpickr.l10ns[self.config.locale] === "undefined") self.config.errorHandler(new Error("flatpickr: invalid locale " + self.config.locale));
        self.l10n = $c3496a40a394bf09$var$__assign($c3496a40a394bf09$var$__assign({}, $c3496a40a394bf09$var$flatpickr.l10ns.default), typeof self.config.locale === "object" ? self.config.locale : self.config.locale !== "default" ? $c3496a40a394bf09$var$flatpickr.l10ns[self.config.locale] : undefined);
        (0, $9816dab19e3bd8be$export$f5a8dc72fbf63af5).D = "(" + self.l10n.weekdays.shorthand.join("|") + ")";
        (0, $9816dab19e3bd8be$export$f5a8dc72fbf63af5).l = "(" + self.l10n.weekdays.longhand.join("|") + ")";
        (0, $9816dab19e3bd8be$export$f5a8dc72fbf63af5).M = "(" + self.l10n.months.shorthand.join("|") + ")";
        (0, $9816dab19e3bd8be$export$f5a8dc72fbf63af5).F = "(" + self.l10n.months.longhand.join("|") + ")";
        (0, $9816dab19e3bd8be$export$f5a8dc72fbf63af5).K = "(" + self.l10n.amPM[0] + "|" + self.l10n.amPM[1] + "|" + self.l10n.amPM[0].toLowerCase() + "|" + self.l10n.amPM[1].toLowerCase() + ")";
        var userConfig = $c3496a40a394bf09$var$__assign($c3496a40a394bf09$var$__assign({}, instanceConfig), JSON.parse(JSON.stringify(element.dataset || {})));
        if (userConfig.time_24hr === undefined && $c3496a40a394bf09$var$flatpickr.defaultConfig.time_24hr === undefined) self.config.time_24hr = self.l10n.time_24hr;
        self.formatDate = (0, $eeeb315f1c4d591c$export$ff1a0b75284ac636)(self);
        self.parseDate = (0, $eeeb315f1c4d591c$export$cfa2ef2687faeda2)({
            config: self.config,
            l10n: self.l10n
        });
    }
    function positionCalendar(customPositionElement) {
        if (typeof self.config.position === "function") return void self.config.position(self, customPositionElement);
        if (self.calendarContainer === undefined) return;
        triggerEvent("onPreCalendarPosition");
        var positionElement = customPositionElement || self._positionElement;
        var calendarHeight = Array.prototype.reduce.call(self.calendarContainer.children, function(acc, child) {
            return acc + child.offsetHeight;
        }, 0), calendarWidth = self.calendarContainer.offsetWidth, configPos = self.config.position.split(" "), configPosVertical = configPos[0], configPosHorizontal = configPos.length > 1 ? configPos[1] : null, inputBounds = positionElement.getBoundingClientRect(), distanceFromBottom = window.innerHeight - inputBounds.bottom, showOnTop = configPosVertical === "above" || configPosVertical !== "below" && distanceFromBottom < calendarHeight && inputBounds.top > calendarHeight;
        var top = window.pageYOffset + inputBounds.top + (!showOnTop ? positionElement.offsetHeight + 2 : -calendarHeight - 2);
        (0, $da40c9ef6edf896a$export$4a80062ca50b57c7)(self.calendarContainer, "arrowTop", !showOnTop);
        (0, $da40c9ef6edf896a$export$4a80062ca50b57c7)(self.calendarContainer, "arrowBottom", showOnTop);
        if (self.config.inline) return;
        var left = window.pageXOffset + inputBounds.left;
        var isCenter = false;
        var isRight = false;
        if (configPosHorizontal === "center") {
            left -= (calendarWidth - inputBounds.width) / 2;
            isCenter = true;
        } else if (configPosHorizontal === "right") {
            left -= calendarWidth - inputBounds.width;
            isRight = true;
        }
        (0, $da40c9ef6edf896a$export$4a80062ca50b57c7)(self.calendarContainer, "arrowLeft", !isCenter && !isRight);
        (0, $da40c9ef6edf896a$export$4a80062ca50b57c7)(self.calendarContainer, "arrowCenter", isCenter);
        (0, $da40c9ef6edf896a$export$4a80062ca50b57c7)(self.calendarContainer, "arrowRight", isRight);
        var right = window.document.body.offsetWidth - (window.pageXOffset + inputBounds.right);
        var rightMost = left + calendarWidth > window.document.body.offsetWidth;
        var centerMost = right + calendarWidth > window.document.body.offsetWidth;
        (0, $da40c9ef6edf896a$export$4a80062ca50b57c7)(self.calendarContainer, "rightMost", rightMost);
        if (self.config.static) return;
        self.calendarContainer.style.top = top + "px";
        if (!rightMost) {
            self.calendarContainer.style.left = left + "px";
            self.calendarContainer.style.right = "auto";
        } else if (!centerMost) {
            self.calendarContainer.style.left = "auto";
            self.calendarContainer.style.right = right + "px";
        } else {
            var doc = getDocumentStyleSheet();
            if (doc === undefined) return;
            var bodyWidth = window.document.body.offsetWidth;
            var centerLeft = Math.max(0, bodyWidth / 2 - calendarWidth / 2);
            var centerBefore = ".flatpickr-calendar.centerMost:before";
            var centerAfter = ".flatpickr-calendar.centerMost:after";
            var centerIndex = doc.cssRules.length;
            var centerStyle = "{left:" + inputBounds.left + "px;right:auto;}";
            (0, $da40c9ef6edf896a$export$4a80062ca50b57c7)(self.calendarContainer, "rightMost", false);
            (0, $da40c9ef6edf896a$export$4a80062ca50b57c7)(self.calendarContainer, "centerMost", true);
            doc.insertRule(centerBefore + "," + centerAfter + centerStyle, centerIndex);
            self.calendarContainer.style.left = centerLeft + "px";
            self.calendarContainer.style.right = "auto";
        }
    }
    function getDocumentStyleSheet() {
        var editableSheet = null;
        for(var i = 0; i < document.styleSheets.length; i++){
            var sheet = document.styleSheets[i];
            if (!sheet.cssRules) continue;
            try {
                sheet.cssRules;
            } catch (err) {
                continue;
            }
            editableSheet = sheet;
            break;
        }
        return editableSheet != null ? editableSheet : createStyleSheet();
    }
    function createStyleSheet() {
        var style = document.createElement("style");
        document.head.appendChild(style);
        return style.sheet;
    }
    function redraw() {
        if (self.config.noCalendar || self.isMobile) return;
        buildMonthSwitch();
        updateNavigationCurrentMonth();
        buildDays();
    }
    function focusAndClose() {
        self._input.focus();
        if (window.navigator.userAgent.indexOf("MSIE") !== -1 || navigator.msMaxTouchPoints !== undefined) setTimeout(self.close, 0);
        else self.close();
    }
    function selectDate(e) {
        e.preventDefault();
        e.stopPropagation();
        var isSelectable = function(day) {
            return day.classList && day.classList.contains("flatpickr-day") && !day.classList.contains("flatpickr-disabled") && !day.classList.contains("notAllowed");
        };
        var t = (0, $da40c9ef6edf896a$export$25245567f53f158f)((0, $da40c9ef6edf896a$export$e58f029f0fbfdb29)(e), isSelectable);
        if (t === undefined) return;
        var target = t;
        var selectedDate = self.latestSelectedDateObj = new Date(target.dateObj.getTime());
        var shouldChangeMonth = (selectedDate.getMonth() < self.currentMonth || selectedDate.getMonth() > self.currentMonth + self.config.showMonths - 1) && self.config.mode !== "range";
        self.selectedDateElem = target;
        if (self.config.mode === "single") self.selectedDates = [
            selectedDate
        ];
        else if (self.config.mode === "multiple") {
            var selectedIndex = isDateSelected(selectedDate);
            if (selectedIndex) self.selectedDates.splice(parseInt(selectedIndex), 1);
            else self.selectedDates.push(selectedDate);
        } else if (self.config.mode === "range") {
            if (self.selectedDates.length === 2) self.clear(false, false);
            self.latestSelectedDateObj = selectedDate;
            self.selectedDates.push(selectedDate);
            if ((0, $eeeb315f1c4d591c$export$c4c806e061935577)(selectedDate, self.selectedDates[0], true) !== 0) self.selectedDates.sort(function(a, b) {
                return a.getTime() - b.getTime();
            });
        }
        setHoursFromInputs();
        if (shouldChangeMonth) {
            var isNewYear = self.currentYear !== selectedDate.getFullYear();
            self.currentYear = selectedDate.getFullYear();
            self.currentMonth = selectedDate.getMonth();
            if (isNewYear) {
                triggerEvent("onYearChange");
                buildMonthSwitch();
            }
            triggerEvent("onMonthChange");
        }
        updateNavigationCurrentMonth();
        buildDays();
        updateValue();
        if (!shouldChangeMonth && self.config.mode !== "range" && self.config.showMonths === 1) focusOnDayElem(target);
        else if (self.selectedDateElem !== undefined && self.hourElement === undefined) self.selectedDateElem && self.selectedDateElem.focus();
        if (self.hourElement !== undefined) self.hourElement !== undefined && self.hourElement.focus();
        if (self.config.closeOnSelect) {
            var single = self.config.mode === "single" && !self.config.enableTime;
            var range = self.config.mode === "range" && self.selectedDates.length === 2 && !self.config.enableTime;
            if (single || range) focusAndClose();
        }
        triggerChange();
    }
    var CALLBACKS = {
        locale: [
            setupLocale,
            updateWeekdays
        ],
        showMonths: [
            buildMonths,
            setCalendarWidth,
            buildWeekdays
        ],
        minDate: [
            jumpToDate
        ],
        maxDate: [
            jumpToDate
        ],
        positionElement: [
            updatePositionElement
        ],
        clickOpens: [
            function() {
                if (self.config.clickOpens === true) {
                    bind(self._input, "focus", self.open);
                    bind(self._input, "click", self.open);
                } else {
                    self._input.removeEventListener("focus", self.open);
                    self._input.removeEventListener("click", self.open);
                }
            }
        ]
    };
    function set(option, value) {
        if (option !== null && typeof option === "object") {
            Object.assign(self.config, option);
            for(var key in option)if (CALLBACKS[key] !== undefined) CALLBACKS[key].forEach(function(x) {
                return x();
            });
        } else {
            self.config[option] = value;
            if (CALLBACKS[option] !== undefined) CALLBACKS[option].forEach(function(x) {
                return x();
            });
            else if ((0, $739195af95cf03b2$export$c34bb18505e1e253).indexOf(option) > -1) self.config[option] = (0, $f89ac564820ae2aa$export$3131421a7d01b4fb)(value);
        }
        self.redraw();
        updateValue(true);
    }
    function setSelectedDate(inputDate, format) {
        var dates = [];
        if (inputDate instanceof Array) dates = inputDate.map(function(d) {
            return self.parseDate(d, format);
        });
        else if (inputDate instanceof Date || typeof inputDate === "number") dates = [
            self.parseDate(inputDate, format)
        ];
        else if (typeof inputDate === "string") switch(self.config.mode){
            case "single":
            case "time":
                dates = [
                    self.parseDate(inputDate, format)
                ];
                break;
            case "multiple":
                dates = inputDate.split(self.config.conjunction).map(function(date) {
                    return self.parseDate(date, format);
                });
                break;
            case "range":
                dates = inputDate.split(self.l10n.rangeSeparator).map(function(date) {
                    return self.parseDate(date, format);
                });
                break;
            default:
                break;
        }
        else self.config.errorHandler(new Error("Invalid date supplied: " + JSON.stringify(inputDate)));
        self.selectedDates = self.config.allowInvalidPreload ? dates : dates.filter(function(d) {
            return d instanceof Date && isEnabled(d, false);
        });
        if (self.config.mode === "range") self.selectedDates.sort(function(a, b) {
            return a.getTime() - b.getTime();
        });
    }
    function setDate(date, triggerChange, format) {
        if (triggerChange === void 0) triggerChange = false;
        if (format === void 0) format = self.config.dateFormat;
        if (date !== 0 && !date || date instanceof Array && date.length === 0) return self.clear(triggerChange);
        setSelectedDate(date, format);
        self.latestSelectedDateObj = self.selectedDates[self.selectedDates.length - 1];
        self.redraw();
        jumpToDate(undefined, triggerChange);
        setHoursFromDate();
        if (self.selectedDates.length === 0) self.clear(false);
        updateValue(triggerChange);
        if (triggerChange) triggerEvent("onChange");
    }
    function parseDateRules(arr) {
        return arr.slice().map(function(rule) {
            if (typeof rule === "string" || typeof rule === "number" || rule instanceof Date) return self.parseDate(rule, undefined, true);
            else if (rule && typeof rule === "object" && rule.from && rule.to) return {
                from: self.parseDate(rule.from, undefined),
                to: self.parseDate(rule.to, undefined)
            };
            return rule;
        }).filter(function(x) {
            return x;
        });
    }
    function setupDates() {
        self.selectedDates = [];
        self.now = self.parseDate(self.config.now) || new Date();
        var preloadedDate = self.config.defaultDate || ((self.input.nodeName === "INPUT" || self.input.nodeName === "TEXTAREA") && self.input.placeholder && self.input.value === self.input.placeholder ? null : self.input.value);
        if (preloadedDate) setSelectedDate(preloadedDate, self.config.dateFormat);
        self._initialDate = self.selectedDates.length > 0 ? self.selectedDates[0] : self.config.minDate && self.config.minDate.getTime() > self.now.getTime() ? self.config.minDate : self.config.maxDate && self.config.maxDate.getTime() < self.now.getTime() ? self.config.maxDate : self.now;
        self.currentYear = self._initialDate.getFullYear();
        self.currentMonth = self._initialDate.getMonth();
        if (self.selectedDates.length > 0) self.latestSelectedDateObj = self.selectedDates[0];
        if (self.config.minTime !== undefined) self.config.minTime = self.parseDate(self.config.minTime, "H:i");
        if (self.config.maxTime !== undefined) self.config.maxTime = self.parseDate(self.config.maxTime, "H:i");
        self.minDateHasTime = !!self.config.minDate && (self.config.minDate.getHours() > 0 || self.config.minDate.getMinutes() > 0 || self.config.minDate.getSeconds() > 0);
        self.maxDateHasTime = !!self.config.maxDate && (self.config.maxDate.getHours() > 0 || self.config.maxDate.getMinutes() > 0 || self.config.maxDate.getSeconds() > 0);
    }
    function setupInputs() {
        self.input = getInputElem();
        if (!self.input) {
            self.config.errorHandler(new Error("Invalid input element specified"));
            return;
        }
        self.input._type = self.input.type;
        self.input.type = "text";
        self.input.classList.add("flatpickr-input");
        self._input = self.input;
        if (self.config.altInput) {
            self.altInput = (0, $da40c9ef6edf896a$export$c8a8987d4410bf2d)(self.input.nodeName, self.config.altInputClass);
            self._input = self.altInput;
            self.altInput.placeholder = self.input.placeholder;
            self.altInput.disabled = self.input.disabled;
            self.altInput.required = self.input.required;
            self.altInput.tabIndex = self.input.tabIndex;
            self.altInput.type = "text";
            self.input.setAttribute("type", "hidden");
            if (!self.config.static && self.input.parentNode) self.input.parentNode.insertBefore(self.altInput, self.input.nextSibling);
        }
        if (!self.config.allowInput) self._input.setAttribute("readonly", "readonly");
        updatePositionElement();
    }
    function updatePositionElement() {
        self._positionElement = self.config.positionElement || self._input;
    }
    function setupMobile() {
        var inputType = self.config.enableTime ? self.config.noCalendar ? "time" : "datetime-local" : "date";
        self.mobileInput = (0, $da40c9ef6edf896a$export$c8a8987d4410bf2d)("input", self.input.className + " flatpickr-mobile");
        self.mobileInput.tabIndex = 1;
        self.mobileInput.type = inputType;
        self.mobileInput.disabled = self.input.disabled;
        self.mobileInput.required = self.input.required;
        self.mobileInput.placeholder = self.input.placeholder;
        self.mobileFormatStr = inputType === "datetime-local" ? "Y-m-d\\TH:i:S" : inputType === "date" ? "Y-m-d" : "H:i:S";
        if (self.selectedDates.length > 0) self.mobileInput.defaultValue = self.mobileInput.value = self.formatDate(self.selectedDates[0], self.mobileFormatStr);
        if (self.config.minDate) self.mobileInput.min = self.formatDate(self.config.minDate, "Y-m-d");
        if (self.config.maxDate) self.mobileInput.max = self.formatDate(self.config.maxDate, "Y-m-d");
        if (self.input.getAttribute("step")) self.mobileInput.step = String(self.input.getAttribute("step"));
        self.input.type = "hidden";
        if (self.altInput !== undefined) self.altInput.type = "hidden";
        try {
            if (self.input.parentNode) self.input.parentNode.insertBefore(self.mobileInput, self.input.nextSibling);
        } catch (_a) {}
        bind(self.mobileInput, "change", function(e) {
            self.setDate((0, $da40c9ef6edf896a$export$e58f029f0fbfdb29)(e).value, false, self.mobileFormatStr);
            triggerEvent("onChange");
            triggerEvent("onClose");
        });
    }
    function toggle(e) {
        if (self.isOpen === true) return self.close();
        self.open(e);
    }
    function triggerEvent(event, data) {
        if (self.config === undefined) return;
        var hooks = self.config[event];
        if (hooks !== undefined && hooks.length > 0) for(var i = 0; hooks[i] && i < hooks.length; i++)hooks[i](self.selectedDates, self.input.value, self, data);
        if (event === "onChange") {
            self.input.dispatchEvent(createEvent("change"));
            self.input.dispatchEvent(createEvent("input"));
        }
    }
    function createEvent(name) {
        var e = document.createEvent("Event");
        e.initEvent(name, true, true);
        return e;
    }
    function isDateSelected(date) {
        for(var i = 0; i < self.selectedDates.length; i++){
            var selectedDate = self.selectedDates[i];
            if (selectedDate instanceof Date && (0, $eeeb315f1c4d591c$export$c4c806e061935577)(selectedDate, date) === 0) return "" + i;
        }
        return false;
    }
    function isDateInRange(date) {
        if (self.config.mode !== "range" || self.selectedDates.length < 2) return false;
        return (0, $eeeb315f1c4d591c$export$c4c806e061935577)(date, self.selectedDates[0]) >= 0 && (0, $eeeb315f1c4d591c$export$c4c806e061935577)(date, self.selectedDates[1]) <= 0;
    }
    function updateNavigationCurrentMonth() {
        if (self.config.noCalendar || self.isMobile || !self.monthNav) return;
        self.yearElements.forEach(function(yearElement, i) {
            var d = new Date(self.currentYear, self.currentMonth, 1);
            d.setMonth(self.currentMonth + i);
            if (self.config.showMonths > 1 || self.config.monthSelectorType === "static") self.monthElements[i].textContent = (0, $9816dab19e3bd8be$export$27a2dd9af757e89c)(d.getMonth(), self.config.shorthandCurrentMonth, self.l10n) + " ";
            else self.monthsDropdownContainer.value = d.getMonth().toString();
            yearElement.value = d.getFullYear().toString();
        });
        self._hidePrevMonthArrow = self.config.minDate !== undefined && (self.currentYear === self.config.minDate.getFullYear() ? self.currentMonth <= self.config.minDate.getMonth() : self.currentYear < self.config.minDate.getFullYear());
        self._hideNextMonthArrow = self.config.maxDate !== undefined && (self.currentYear === self.config.maxDate.getFullYear() ? self.currentMonth + 1 > self.config.maxDate.getMonth() : self.currentYear > self.config.maxDate.getFullYear());
    }
    function getDateStr(specificFormat) {
        var format = specificFormat || (self.config.altInput ? self.config.altFormat : self.config.dateFormat);
        return self.selectedDates.map(function(dObj) {
            return self.formatDate(dObj, format);
        }).filter(function(d, i, arr) {
            return self.config.mode !== "range" || self.config.enableTime || arr.indexOf(d) === i;
        }).join(self.config.mode !== "range" ? self.config.conjunction : self.l10n.rangeSeparator);
    }
    function updateValue(triggerChange) {
        if (triggerChange === void 0) triggerChange = true;
        if (self.mobileInput !== undefined && self.mobileFormatStr) self.mobileInput.value = self.latestSelectedDateObj !== undefined ? self.formatDate(self.latestSelectedDateObj, self.mobileFormatStr) : "";
        self.input.value = getDateStr(self.config.dateFormat);
        if (self.altInput !== undefined) self.altInput.value = getDateStr(self.config.altFormat);
        if (triggerChange !== false) triggerEvent("onValueUpdate");
    }
    function onMonthNavClick(e) {
        var eventTarget = (0, $da40c9ef6edf896a$export$e58f029f0fbfdb29)(e);
        var isPrevMonth = self.prevMonthNav.contains(eventTarget);
        var isNextMonth = self.nextMonthNav.contains(eventTarget);
        if (isPrevMonth || isNextMonth) changeMonth(isPrevMonth ? -1 : 1);
        else if (self.yearElements.indexOf(eventTarget) >= 0) eventTarget.select();
        else if (eventTarget.classList.contains("arrowUp")) self.changeYear(self.currentYear + 1);
        else if (eventTarget.classList.contains("arrowDown")) self.changeYear(self.currentYear - 1);
    }
    function timeWrapper(e) {
        e.preventDefault();
        var isKeyDown = e.type === "keydown", eventTarget = (0, $da40c9ef6edf896a$export$e58f029f0fbfdb29)(e), input = eventTarget;
        if (self.amPM !== undefined && eventTarget === self.amPM) self.amPM.textContent = self.l10n.amPM[(0, $f89ac564820ae2aa$export$7d260a2a5f8bc19e)(self.amPM.textContent === self.l10n.amPM[0])];
        var min = parseFloat(input.getAttribute("min")), max = parseFloat(input.getAttribute("max")), step = parseFloat(input.getAttribute("step")), curValue = parseInt(input.value, 10), delta = e.delta || (isKeyDown ? e.which === 38 ? 1 : -1 : 0);
        var newValue = curValue + step * delta;
        if (typeof input.value !== "undefined" && input.value.length === 2) {
            var isHourElem = input === self.hourElement, isMinuteElem = input === self.minuteElement;
            if (newValue < min) {
                newValue = max + newValue + (0, $f89ac564820ae2aa$export$7d260a2a5f8bc19e)(!isHourElem) + ((0, $f89ac564820ae2aa$export$7d260a2a5f8bc19e)(isHourElem) && (0, $f89ac564820ae2aa$export$7d260a2a5f8bc19e)(!self.amPM));
                if (isMinuteElem) incrementNumInput(undefined, -1, self.hourElement);
            } else if (newValue > max) {
                newValue = input === self.hourElement ? newValue - max - (0, $f89ac564820ae2aa$export$7d260a2a5f8bc19e)(!self.amPM) : min;
                if (isMinuteElem) incrementNumInput(undefined, 1, self.hourElement);
            }
            if (self.amPM && isHourElem && (step === 1 ? newValue + curValue === 23 : Math.abs(newValue - curValue) > step)) self.amPM.textContent = self.l10n.amPM[(0, $f89ac564820ae2aa$export$7d260a2a5f8bc19e)(self.amPM.textContent === self.l10n.amPM[0])];
            input.value = (0, $f89ac564820ae2aa$export$5d04458e2a6c373e)(newValue);
        }
    }
    init();
    return self;
}
function $c3496a40a394bf09$var$_flatpickr(nodeList, config) {
    var nodes = Array.prototype.slice.call(nodeList).filter(function(x) {
        return x instanceof HTMLElement;
    });
    var instances = [];
    for(var i = 0; i < nodes.length; i++){
        var node = nodes[i];
        try {
            if (node.getAttribute("data-fp-omit") !== null) continue;
            if (node._flatpickr !== undefined) {
                node._flatpickr.destroy();
                node._flatpickr = undefined;
            }
            node._flatpickr = $c3496a40a394bf09$var$FlatpickrInstance(node, config || {});
            instances.push(node._flatpickr);
        } catch (e) {
            console.error(e);
        }
    }
    return instances.length === 1 ? instances[0] : instances;
}
if (typeof HTMLElement !== "undefined" && typeof HTMLCollection !== "undefined" && typeof NodeList !== "undefined") {
    HTMLCollection.prototype.flatpickr = NodeList.prototype.flatpickr = function(config) {
        return $c3496a40a394bf09$var$_flatpickr(this, config);
    };
    HTMLElement.prototype.flatpickr = function(config) {
        return $c3496a40a394bf09$var$_flatpickr([
            this
        ], config);
    };
}
var $c3496a40a394bf09$var$flatpickr = function(selector, config) {
    if (typeof selector === "string") return $c3496a40a394bf09$var$_flatpickr(window.document.querySelectorAll(selector), config);
    else if (selector instanceof Node) return $c3496a40a394bf09$var$_flatpickr([
        selector
    ], config);
    else return $c3496a40a394bf09$var$_flatpickr(selector, config);
};
$c3496a40a394bf09$var$flatpickr.defaultConfig = {};
$c3496a40a394bf09$var$flatpickr.l10ns = {
    en: $c3496a40a394bf09$var$__assign({}, (0, $dd09c7bf58d1d2e9$export$2e2bcd8739ae039)),
    default: $c3496a40a394bf09$var$__assign({}, (0, $dd09c7bf58d1d2e9$export$2e2bcd8739ae039))
};
$c3496a40a394bf09$var$flatpickr.localize = function(l10n) {
    $c3496a40a394bf09$var$flatpickr.l10ns.default = $c3496a40a394bf09$var$__assign($c3496a40a394bf09$var$__assign({}, $c3496a40a394bf09$var$flatpickr.l10ns.default), l10n);
};
$c3496a40a394bf09$var$flatpickr.setDefaults = function(config) {
    $c3496a40a394bf09$var$flatpickr.defaultConfig = $c3496a40a394bf09$var$__assign($c3496a40a394bf09$var$__assign({}, $c3496a40a394bf09$var$flatpickr.defaultConfig), config);
};
$c3496a40a394bf09$var$flatpickr.parseDate = (0, $eeeb315f1c4d591c$export$cfa2ef2687faeda2)({});
$c3496a40a394bf09$var$flatpickr.formatDate = (0, $eeeb315f1c4d591c$export$ff1a0b75284ac636)({});
$c3496a40a394bf09$var$flatpickr.compareDates = (0, $eeeb315f1c4d591c$export$c4c806e061935577);
if (typeof jQuery !== "undefined" && typeof jQuery.fn !== "undefined") jQuery.fn.flatpickr = function(config) {
    return $c3496a40a394bf09$var$_flatpickr(this, config);
};
Date.prototype.fp_incr = function(days) {
    return new Date(this.getFullYear(), this.getMonth(), this.getDate() + (typeof days === "string" ? parseInt(days, 10) : days));
};
if (typeof window !== "undefined") window.flatpickr = $c3496a40a394bf09$var$flatpickr;
var $c3496a40a394bf09$export$2e2bcd8739ae039 = $c3496a40a394bf09$var$flatpickr;


const $ae585f609aba6b82$var$auto_activation_date_input = document.getElementById("id_auto_activation_date") || document.getElementById("id_installation-auto_activation_date");
if ($ae585f609aba6b82$var$auto_activation_date_input) {
    const today = (0, (/*@__PURE__*/$parcel$interopDefault($cNQM9))).utc().hour(0).minute(0).second(0);
    let min = $ae585f609aba6b82$var$auto_activation_date_input.min || today.add(1, "days").format("YYYY-MM-DD");
    let max = $ae585f609aba6b82$var$auto_activation_date_input.max || today.add(120, "days").format("YYYY-MM-DD");
    (0, $c3496a40a394bf09$exports.default)($ae585f609aba6b82$var$auto_activation_date_input, {
        dateFormat: "Y-m-d",
        altInput: true,
        altFormat: "F j, Y",
        minDate: min,
        maxDate: max,
        disableMobile: true
    });
    window.auto_activation_date_input = $ae585f609aba6b82$var$auto_activation_date_input;
}


parcelRequire("766BF");
var $6LocX = parcelRequire("6LocX");
let $e588ddb538bc24bf$var$script;



let $e588ddb538bc24bf$var$initialize = ()=>{
    $e588ddb538bc24bf$var$script = (parcelRequire("88BPR"));
    if ($e588ddb538bc24bf$var$script.__esModule) $e588ddb538bc24bf$var$script = $e588ddb538bc24bf$var$script.default;
    $e588ddb538bc24bf$var$script.render = (parcelRequire("cvMgx")).render;
    (parcelRequire("lSY2z")).default($e588ddb538bc24bf$var$script);
    $e588ddb538bc24bf$var$script.__scopeId = "data-v-755150";
    $e588ddb538bc24bf$var$script.__file = "appointment-scheduler.vue";
};
$e588ddb538bc24bf$var$initialize();
var $e588ddb538bc24bf$export$2e2bcd8739ae039 = $e588ddb538bc24bf$var$script;


"use strict";
const $1528c5c722d6e5e2$var$el = document.getElementById("appointment-scheduler");
if ($1528c5c722d6e5e2$var$el) {
    // Get the data from the element
    const input_name = $1528c5c722d6e5e2$var$el.dataset.inputName;
    let raw_blocks;
    try {
        raw_blocks = JSON.parse($1528c5c722d6e5e2$var$el.dataset.blocks);
    } catch (e) {
        console.error("Could not parse blocks JSON", e);
    }
    const selected = $1528c5c722d6e5e2$var$el.dataset.selected;
    // Create the Vue app, passing the parsed data as props
    const app = (0, $6LocX.createApp)((0, $e588ddb538bc24bf$export$2e2bcd8739ae039), {
        input_name: input_name,
        raw_blocks: raw_blocks,
        selected: selected
    });
    app.mount($1528c5c722d6e5e2$var$el);
}




// Slide between elements in sets with options for animated or scrubbed via scroll bar. This allows you to create any
// number of sets of elements that will slide between each other. The sets can contain any number of elements, but must
// be the same number in each set. The slider type can be animated or controlled by the scroll position, and there are
// several options for each type of slider. The minimum number of children in every set is 2.
//
// Animated Slider:
//
// This will animate forward between each element in all sets. Reverse direction is not supported.
//
// Animated Usage:
//
//     <div data-slider="animate" data-slider-delay="0.5" data-slider-repeat="-1" data-slider-interval="5"
//          data-slider-duration="0.2" data-slider-trigger="top bottom">
//         <div data-slider-set data-slider-prev-direction="right" data-slider-next-direction="right">
//             <div>Some text</div>
//             <div>Some text</div>
//             <div>Some text</div>
//         </div>
//         <div data-slider-progress></div>
//     </div>
//
// data-slider:          The type of slider: 'animate' or 'scroll'. 'animate' in this case.
// data-slider-delay:    How long to wait before starting the animation.
//                       Default: 0
// data-slider-repeat:   How many times to repeat the animation.
//                       Default: -1 (forever)
// data-slider-interval: How long to wait between each slide.
//                       Default: 5
// data-slider-duration: How long to animate each slide transition. Best if kept short.
//                       Default: 0.2
// data-slider-trigger:  If set, the animation will be triggered when the element is scrolled to the given position
//                       Must be "<trigger> <scroller>" such as "top bottom" to trigger when the top of the element
//                       meets the bottom of the scroll bar.
//
// Scroll Slider:
//
// This will tie the animation to the scroll bar. By default, it will not pin the element (so that it stays in place),
// and instead will just play the animation once the element is fully visible at the bottom of the viewport, then finish
// it when the element touches the top of the viewport. The other option is to "pin" the element so that it stays in
// one place while the animation plays. This requires some careful set up of elements around the slider so that large
// blank areas don't become visible during the scroll. (See GSAP docs on pinning, specifically the pin spacer.)
//
// Scroll Usage:
//
//     <div data-slider="scroll" data-slider-pin="true" data-slider-trigger="center center" data-slider-length="500"
//          data-slider-duration="0.2">
//         <section class="something-else-to-stay-on-screen"></section>
//         <section class="my-sliding-section">
//             <div data-slider-set data-slider-next-direction="none">
//                 <div>Some text</div>
//                 <div>Some text</div>
//                 <div>Some text</div>
//             </div>
//             <div data-slider-progress></div>
//         </section>
//         <section class="something-else-to-stay-on-screen"></section>
//     </div>
//
// data-slider:          The type of slider: 'animate' or 'scroll'. 'scroll' in this case.
// data-slider-pin:      If set, the element will be pinned in place while the animation plays.
//                       Default: false
// data-slider-trigger:  If set, the animation will be triggered when the element is scrolled to the given position
//                       Must be "<trigger> <scroller>" such as "bottom bottom" to trigger when the bottom of the
//                       element touches the bottom of the scroll bar.
//                       Default if not pinned: "bottom bottom".
//                       Default if pinned: "center center".
// data-slider-length:   The length of the animation in pixels scrolled, per set item. No effect if not pinned.
//                       Default: 500
// data-slider-duration: How long to animate each slide transition. Best if kept short.
//                       Default: 0.2
// data-slider-debug:    If set, will show markers for the element and scroller.
//                       Default: false
//
// Slider set options:
//
// Each `data-slider-set` element can have the following options. It works best to have them match, or 'prev' set to a
// direction and 'next 'set to "none" so that it is just revealed behind the previous item.
//
// data-slider-prev-direction: The direction to slide the prev element ("up", "down", "left", "right", "none")
//                             Default: "up"
// data-slider-next-direction: The direction to slide the next element ("up", "down", "left", "right", "none")
//                             Default: "up"
//
// Progress indicator
//
// You must place a div with `data-slider-progress` inside the slider element to create a progress indicator,
// which will visually show the current progress of slides in all the sets. This works for both animated and scrolled
// sliders.
//
//     <div className="slider-progress-group" data-slider-progress></div>
//
// Notes on styling:
//
// Each pertinent element will have the following classes added to it upon initialization. To prevent layout reflows,
// it is suggested that you prime these classes in the HTML.
//
//     "slider-set": applied to each element with `data-slider-set`
//     "slider-set-item": applied to each child of `data-slider-set`
//     "active": applied to the active slider-set-item (usually the first)
//     "slider-progress-group": applied to the element with 'data-slider-progress'
//     "slider-progress-indicator": applied to each created child element of the slider-progress-group
//
// Each set will be set to `overflow: hidden` so that animating elements will not be visible outside the parent.
// The slider will maintain the document flow by always having the active set item set to "position: relative". Other
// items will be set to "position: absolute" with a negative z-index and opacity set to 0.
//
// So the stack will always resemble:
//
//     <div data-slider="animate">
//         <div class="slider-set" data-slider-set>
//             <div class="slider-set-item active">...</div>   (position: relative; opacity: 1; z-index: 1)
//             <div class="slider-set-item">...</div>          (position: absolute; opacity: 0; z-index: -1)
//             <div class="slider-set-item">...</div>          (position: absolute; opacity: 0; z-index: -1)
//             <div class="slider-set-item">...</div>          (position: absolute; opacity: 0; z-index: -1)
//         </div>
//     </div>
//
// It's important that each set item be the same height. `slider-set-item` will apply `white-space: nowrap` to each
// item, but that may not be enough to control the height. If there are strange layout issues, then you may need to
// explicitly set the height of each item.


(0, $856d27e31089eddd$export$99ee26438460406a).registerPlugin((0, $f075d17102cf2205$export$875bcbe48555930));
document.addEventListener("DOMContentLoaded", function() {
    const elements = document.querySelectorAll("[data-slider]");
    for (const element of elements)$0bbc33a81d9d5ea7$var$slider(element);
});
function $0bbc33a81d9d5ea7$var$slider(element) {
    const type = element.dataset.slider || "scroll";
    const delay = element.dataset.sliderDelay || 0;
    const repeat = element.dataset.sliderRepeat !== undefined ? parseInt(element.dataset.sliderRepeat) : -1;
    const interval = parseFloat(element.dataset.sliderInterval) || 5;
    const duration = parseFloat(element.dataset.sliderDuration) || 0.2;
    const trigger = element.dataset.sliderTrigger || null;
    const pin = [
        "true",
        "1",
        "yes",
        "on"
    ].includes(element.dataset.sliderPin) || false;
    const length = parseInt(element.dataset.sliderLength) || 500;
    const debug = [
        "true",
        "1",
        "yes",
        "on"
    ].includes(element.dataset.sliderDebug) || false;
    // Sanity check options
    if (interval < duration) {
        console.error(`data-slider-interval must be greater than data-slider-duration.`);
        return;
    }
    // Find all sets
    const sets = $0bbc33a81d9d5ea7$var$findSets(element);
    // console.log("sets", sets);
    // Make sure there's at least 1 set
    if (sets.length === 0) {
        console.error(`Slider must have at least 1 set marked with 'data-slider-set'`);
        return;
    }
    // Check that all sets have the same number of children
    let lastCount = null;
    for (const set of sets){
        if (lastCount === null) lastCount = set.children.length;
        else if (lastCount !== set.children.length) {
            console.error(`Slider sets must have the same number of children`);
            return [];
        }
    }
    // Create the main timeline
    let masterTimeline;
    if (type === "animate") {
        const vars = {
            delay: delay,
            repeat: repeat
        };
        if (trigger) vars.scrollTrigger = {
            trigger: element,
            start: trigger
        };
        masterTimeline = (0, $856d27e31089eddd$export$99ee26438460406a).timeline(vars);
    } else if (type === "scroll") {
        let start = trigger;
        if (!start) {
            if (pin) start = "center center";
            else start = "bottom bottom";
        }
        let end;
        if (pin) end = `+=${length * sets[0].children.length}`;
        else end = `+=${window.innerHeight - element.offsetHeight}`;
        masterTimeline = (0, $856d27e31089eddd$export$99ee26438460406a).timeline({
            scrollTrigger: {
                trigger: element,
                start: start,
                end: end,
                scrub: true,
                pin: pin,
                markers: debug
            }
        });
    } else {
        console.error(`Unknown slider type: ${type}`);
        return;
    }
    // Create the progress indicators, if there's a `data-slider-progress` element
    const progressElement = element.querySelector("[data-slider-progress]");
    if (progressElement) {
        progressElement.classList.add("slider-progress");
        for(let i = 0; i < sets[0].children.length; i++){
            const indicator = document.createElement("div");
            indicator.classList.add("slider-progress-indicator");
            progressElement.appendChild(indicator);
            // Add it to the timeline
            masterTimeline.to(indicator, {
                "--progress": "100%",
                ease: "none",
                duration: interval
            });
        }
    }
    // Look for a kinetoscope
    const kinetoscope = element.querySelector("[data-slider-kinetoscope]");
    let kinetoscopeCallback = null;
    if (kinetoscope) {
        const fileTemplate = kinetoscope.dataset.sliderKinetoscope;
        const frameMin = parseInt(kinetoscope.dataset.sliderKinetoscopeMin) || 0;
        const frameMax = parseInt(kinetoscope.dataset.sliderKinetoscopeMax) || 0;
        const context = kinetoscope.getContext("2d");
        if (!fileTemplate) {
            console.error(`data-slider-kinetoscope requires a file template`);
            return;
        }
        const fileTemplateDecoded = fileTemplate.replace(/%23/g, "#");
        // Sanity check
        if (frameMin >= frameMax) {
            console.error(`data-slider-kinetoscope-min must be less than data-slider-kinetoscope-max`);
            return;
        }
        const frameCount = frameMax - frameMin + 1;
        // Deconstruct the file template
        const frameDigits = fileTemplateDecoded.lastIndexOf("#") - fileTemplateDecoded.indexOf("#") + 1;
        if (frameDigits <= 0) {
            console.error(`data-slider-kinetoscope must contain at least 1 '#' character`);
            return;
        }
        const fileTemplateParts = fileTemplateDecoded.split("#".repeat(frameDigits));
        if (fileTemplateParts.length !== 2) {
            console.error(`data-slider-kinetoscope must contain only one section of '#' characters`);
            return;
        }
        const frameFilePrefix = fileTemplateParts[0];
        const frameFileSuffix = fileTemplateParts[1];
        // Preload the frames
        const images = [];
        for(let i = 0; i < frameCount; i++){
            const frameNumber = frameMin + i;
            const frameNumberPadded = frameNumber.toString().padStart(frameDigits, "0");
            const frameFile = `${frameFilePrefix}${frameNumberPadded}${frameFileSuffix}`;
            const img = new Image();
            img.src = frameFile;
            images.push(img);
        }
        // Update the kinetoscope to the appropriate frame on every update of the master timeline.
        // The frame shown should be proportional to the progress of the master timeline.
        const render = (i)=>{
            context.clearRect(0, 0, kinetoscope.width, kinetoscope.height);
            context.drawImage(images[i], 0, 0, kinetoscope.width, kinetoscope.height);
        };
        images[0].onload = ()=>{
            render(0);
        };
        kinetoscopeCallback = ()=>{
            const timelineProgress = masterTimeline.progress();
            const frameIndex = Math.floor(timelineProgress * images.length);
            // Ignore if the animation goes past the last frame
            if (frameIndex < 0 || frameIndex >= images.length) return;
            // Draw the frame
            render(frameIndex);
        };
    }
    // Animate each set change when we reach the appropriate time in the timeline
    let prevSetItemIndex = 0;
    masterTimeline.eventCallback("onUpdate", ()=>{
        const timelineProgress = masterTimeline.progress();
        const snapInterval = 1 / sets[0].children.length;
        const setItemIndex = Math.floor(timelineProgress / snapInterval); // The current set item index
        // const setItemProgress = (timelineProgress % snapInterval) / snapInterval;  // The progress of the set item
        // console.log("progress", timelineProgress, setItemIndex, setItemProgress);
        // Ignore if the animation goes past the last set item
        if (setItemIndex >= sets[0].children.length) return;
        if (setItemIndex !== prevSetItemIndex) {
            // console.log("Set Item change", prevSetItemIndex, setItemIndex);
            $0bbc33a81d9d5ea7$var$animateSetChange(sets, prevSetItemIndex, setItemIndex, duration);
            prevSetItemIndex = setItemIndex;
        }
        if (kinetoscopeCallback) kinetoscopeCallback();
    });
}
function $0bbc33a81d9d5ea7$var$animateSetChange(sets, prevIdx, nextIdx, duration) {
    // Temporarily set the height of each set element so we don't reflow while swapping classes around
    for (const set of sets)set.element.style.height = `${set.element.offsetHeight}px`;
    // Animate the previous children out, remove the active class
    for (const set of sets){
        const prev = set.children[prevIdx];
        // Since we will remove the 'active' class, we need to override z-index and opacity during the animation
        (0, $856d27e31089eddd$export$99ee26438460406a).set(prev, {
            zIndex: 10,
            opacity: 1
        });
        // Remove active class
        prev.classList.remove("active");
        // Animate the previous child out then reset the direct styles
        (0, $856d27e31089eddd$export$99ee26438460406a).to(prev, {
            ...$0bbc33a81d9d5ea7$var$directionToPropertyTo(set.prevDirection),
            duration: duration,
            onComplete: ()=>{
                (0, $856d27e31089eddd$export$99ee26438460406a).set(prev, {
                    zIndex: null,
                    yPercent: null,
                    opacity: null
                });
            }
        });
    }
    // Animate the next children in, add the active class
    for (const set of sets){
        const next = set.children[nextIdx];
        next.classList.add("active");
        (0, $856d27e31089eddd$export$99ee26438460406a).from(next, {
            ...$0bbc33a81d9d5ea7$var$directionToPropertyFrom(set.nextDirection),
            duration: duration,
            onComplete: ()=>{
                (0, $856d27e31089eddd$export$99ee26438460406a).set(next, {
                    yPercent: null
                });
            }
        });
    }
    // Reset the set element heights
    for (const set of sets)set.element.style.height = null;
}
function $0bbc33a81d9d5ea7$var$findSets(element) {
    // Keep track of all sets and their individual options
    const sets = [];
    // Find all sets defined with `data-slider-set` attribute
    const setElements = element.querySelectorAll("[data-slider-set]");
    for (const setElement of setElements){
        const prevDirection = setElement.dataset.sliderPrevDirection || "up";
        const nextDirection = setElement.dataset.sliderNextDirection || "up";
        // Make sure this element is relative positioned and overflow is hidden
        setElement.classList.add("slider-set");
        // Make sure there are at least 2 elements
        const children = setElement.children;
        if (children.length < 2) {
            console.error(`Slider sets must have at least 2 children`);
            continue;
        }
        // Make sure the children have the proper classes. Set the first as 'active'.
        for(let i = 0; i < children.length; i++){
            const child = children[i];
            child.classList.add("slider-set-item");
            if (i === 0) child.classList.add("active");
        }
        // Add this set to the list of sets
        sets.push({
            "element": setElement,
            "children": setElement.children,
            "prevDirection": prevDirection,
            "nextDirection": nextDirection
        });
    }
    return sets;
}
function $0bbc33a81d9d5ea7$var$directionToPropertyTo(direction) {
    switch(direction){
        case "up":
            return {
                yPercent: -100
            };
        case "down":
            return {
                yPercent: 100
            };
        case "left":
            return {
                xPercent: -100
            };
        case "right":
            return {
                xPercent: 100
            };
        default:
            return {};
    }
}
function $0bbc33a81d9d5ea7$var$directionToPropertyFrom(direction) {
    switch(direction){
        case "up":
            return {
                yPercent: 100
            };
        case "down":
            return {
                yPercent: -100
            };
        case "left":
            return {
                xPercent: 100
            };
        case "right":
            return {
                xPercent: -100
            };
        default:
            return {};
    }
}


function $2b0fd52ca7af0f11$var$setFaviconForTheme() {
    let link = document.querySelector("link[rel*='shortcut icon']") || document.createElement("link");
    link.type = "image/x-icon";
    link.rel = "shortcut icon";
    if (window.matchMedia && window.matchMedia("(prefers-color-scheme: dark)").matches) link.href = "/static/logos/wordmark_micro_light.svg";
    else link.href = "/static/logos/wordmark_micro_dark.svg";
    document.getElementsByTagName("head")[0].appendChild(link);
}
$2b0fd52ca7af0f11$var$setFaviconForTheme();


var $e8f91857512aeffe$exports = {};
/*!
 * clipboard.js v2.0.11
 * https://clipboardjs.com/
 *
 * Licensed MIT © Zeno Rocha
 */ (function webpackUniversalModuleDefinition(root, factory) {
    $e8f91857512aeffe$exports = factory();
})($e8f91857512aeffe$exports, function() {
    return /******/ function() {
        /******/ var __webpack_modules__ = {
            /***/ 686: /***/ function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {
                "use strict";
                // EXPORTS
                __webpack_require__.d(__webpack_exports__, {
                    "default": function() {
                        return /* binding */ clipboard;
                    }
                });
                // EXTERNAL MODULE: ./node_modules/tiny-emitter/index.js
                var tiny_emitter = __webpack_require__(279);
                var tiny_emitter_default = /*#__PURE__*/ __webpack_require__.n(tiny_emitter);
                // EXTERNAL MODULE: ./node_modules/good-listener/src/listen.js
                var listen = __webpack_require__(370);
                var listen_default = /*#__PURE__*/ __webpack_require__.n(listen);
                // EXTERNAL MODULE: ./node_modules/select/src/select.js
                var src_select = __webpack_require__(817);
                var select_default = /*#__PURE__*/ __webpack_require__.n(src_select);
                /**
 * Executes a given operation type.
 * @param {String} type
 * @return {Boolean}
 */ function command(type) {
                    try {
                        return document.execCommand(type);
                    } catch (err) {
                        return false;
                    }
                }
                /**
 * Cut action wrapper.
 * @param {String|HTMLElement} target
 * @return {String}
 */ var ClipboardActionCut = function ClipboardActionCut(target) {
                    var selectedText = select_default()(target);
                    command("cut");
                    return selectedText;
                };
                /* harmony default export */ var actions_cut = ClipboardActionCut;
                /**
 * Creates a fake textarea element with a value.
 * @param {String} value
 * @return {HTMLElement}
 */ function createFakeElement(value) {
                    var isRTL = document.documentElement.getAttribute("dir") === "rtl";
                    var fakeElement = document.createElement("textarea"); // Prevent zooming on iOS
                    fakeElement.style.fontSize = "12pt"; // Reset box model
                    fakeElement.style.border = "0";
                    fakeElement.style.padding = "0";
                    fakeElement.style.margin = "0"; // Move element out of screen horizontally
                    fakeElement.style.position = "absolute";
                    fakeElement.style[isRTL ? "right" : "left"] = "-9999px"; // Move element to the same position vertically
                    var yPosition = window.pageYOffset || document.documentElement.scrollTop;
                    fakeElement.style.top = "".concat(yPosition, "px");
                    fakeElement.setAttribute("readonly", "");
                    fakeElement.value = value;
                    return fakeElement;
                }
                /**
 * Create fake copy action wrapper using a fake element.
 * @param {String} target
 * @param {Object} options
 * @return {String}
 */ var fakeCopyAction = function fakeCopyAction(value, options) {
                    var fakeElement = createFakeElement(value);
                    options.container.appendChild(fakeElement);
                    var selectedText = select_default()(fakeElement);
                    command("copy");
                    fakeElement.remove();
                    return selectedText;
                };
                /**
 * Copy action wrapper.
 * @param {String|HTMLElement} target
 * @param {Object} options
 * @return {String}
 */ var ClipboardActionCopy = function ClipboardActionCopy(target) {
                    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
                        container: document.body
                    };
                    var selectedText = "";
                    if (typeof target === "string") selectedText = fakeCopyAction(target, options);
                    else if (target instanceof HTMLInputElement && ![
                        "text",
                        "search",
                        "url",
                        "tel",
                        "password"
                    ].includes(target === null || target === void 0 ? void 0 : target.type)) // If input type doesn't support `setSelectionRange`. Simulate it. https://developer.mozilla.org/en-US/docs/Web/API/HTMLInputElement/setSelectionRange
                    selectedText = fakeCopyAction(target.value, options);
                    else {
                        selectedText = select_default()(target);
                        command("copy");
                    }
                    return selectedText;
                };
                /* harmony default export */ var actions_copy = ClipboardActionCopy;
                function _typeof(obj) {
                    "@babel/helpers - typeof";
                    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") _typeof = function _typeof(obj) {
                        return typeof obj;
                    };
                    else _typeof = function _typeof(obj) {
                        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
                    };
                    return _typeof(obj);
                }
                /**
 * Inner function which performs selection from either `text` or `target`
 * properties and then executes copy or cut operations.
 * @param {Object} options
 */ var ClipboardActionDefault = function ClipboardActionDefault() {
                    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                    // Defines base properties passed from constructor.
                    var _options$action = options.action, action = _options$action === void 0 ? "copy" : _options$action, container = options.container, target = options.target, text = options.text; // Sets the `action` to be performed which can be either 'copy' or 'cut'.
                    if (action !== "copy" && action !== "cut") throw new Error('Invalid "action" value, use either "copy" or "cut"');
                     // Sets the `target` property using an element that will be have its content copied.
                    if (target !== undefined) {
                        if (target && _typeof(target) === "object" && target.nodeType === 1) {
                            if (action === "copy" && target.hasAttribute("disabled")) throw new Error('Invalid "target" attribute. Please use "readonly" instead of "disabled" attribute');
                            if (action === "cut" && (target.hasAttribute("readonly") || target.hasAttribute("disabled"))) throw new Error('Invalid "target" attribute. You can\'t cut text from elements with "readonly" or "disabled" attributes');
                        } else throw new Error('Invalid "target" value, use a valid Element');
                    } // Define selection strategy based on `text` property.
                    if (text) return actions_copy(text, {
                        container: container
                    });
                     // Defines which selection strategy based on `target` property.
                    if (target) return action === "cut" ? actions_cut(target) : actions_copy(target, {
                        container: container
                    });
                };
                /* harmony default export */ var actions_default = ClipboardActionDefault;
                function clipboard_typeof(obj) {
                    "@babel/helpers - typeof";
                    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") clipboard_typeof = function _typeof(obj) {
                        return typeof obj;
                    };
                    else clipboard_typeof = function _typeof(obj) {
                        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
                    };
                    return clipboard_typeof(obj);
                }
                function _classCallCheck(instance, Constructor) {
                    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
                }
                function _defineProperties(target, props) {
                    for(var i = 0; i < props.length; i++){
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || false;
                        descriptor.configurable = true;
                        if ("value" in descriptor) descriptor.writable = true;
                        Object.defineProperty(target, descriptor.key, descriptor);
                    }
                }
                function _createClass(Constructor, protoProps, staticProps) {
                    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
                    if (staticProps) _defineProperties(Constructor, staticProps);
                    return Constructor;
                }
                function _inherits(subClass, superClass) {
                    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
                    subClass.prototype = Object.create(superClass && superClass.prototype, {
                        constructor: {
                            value: subClass,
                            writable: true,
                            configurable: true
                        }
                    });
                    if (superClass) _setPrototypeOf(subClass, superClass);
                }
                function _setPrototypeOf(o, p) {
                    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
                        o.__proto__ = p;
                        return o;
                    };
                    return _setPrototypeOf(o, p);
                }
                function _createSuper(Derived) {
                    var hasNativeReflectConstruct = _isNativeReflectConstruct();
                    return function _createSuperInternal() {
                        var Super = _getPrototypeOf(Derived), result;
                        if (hasNativeReflectConstruct) {
                            var NewTarget = _getPrototypeOf(this).constructor;
                            result = Reflect.construct(Super, arguments, NewTarget);
                        } else result = Super.apply(this, arguments);
                        return _possibleConstructorReturn(this, result);
                    };
                }
                function _possibleConstructorReturn(self, call) {
                    if (call && (clipboard_typeof(call) === "object" || typeof call === "function")) return call;
                    return _assertThisInitialized(self);
                }
                function _assertThisInitialized(self) {
                    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                    return self;
                }
                function _isNativeReflectConstruct() {
                    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
                    if (Reflect.construct.sham) return false;
                    if (typeof Proxy === "function") return true;
                    try {
                        Date.prototype.toString.call(Reflect.construct(Date, [], function() {}));
                        return true;
                    } catch (e) {
                        return false;
                    }
                }
                function _getPrototypeOf(o) {
                    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
                        return o.__proto__ || Object.getPrototypeOf(o);
                    };
                    return _getPrototypeOf(o);
                }
                /**
 * Helper function to retrieve attribute value.
 * @param {String} suffix
 * @param {Element} element
 */ function getAttributeValue(suffix, element) {
                    var attribute = "data-clipboard-".concat(suffix);
                    if (!element.hasAttribute(attribute)) return;
                    return element.getAttribute(attribute);
                }
                /**
 * Base class which takes one or more elements, adds event listeners to them,
 * and instantiates a new `ClipboardAction` on each click.
 */ var Clipboard = /*#__PURE__*/ function(_Emitter) {
                    _inherits(Clipboard, _Emitter);
                    var _super = _createSuper(Clipboard);
                    /**
   * @param {String|HTMLElement|HTMLCollection|NodeList} trigger
   * @param {Object} options
   */ function Clipboard(trigger, options) {
                        var _this;
                        _classCallCheck(this, Clipboard);
                        _this = _super.call(this);
                        _this.resolveOptions(options);
                        _this.listenClick(trigger);
                        return _this;
                    }
                    /**
   * Defines if attributes would be resolved using internal setter functions
   * or custom functions that were passed in the constructor.
   * @param {Object} options
   */ _createClass(Clipboard, [
                        {
                            key: "resolveOptions",
                            value: function resolveOptions() {
                                var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                                this.action = typeof options.action === "function" ? options.action : this.defaultAction;
                                this.target = typeof options.target === "function" ? options.target : this.defaultTarget;
                                this.text = typeof options.text === "function" ? options.text : this.defaultText;
                                this.container = clipboard_typeof(options.container) === "object" ? options.container : document.body;
                            }
                        },
                        {
                            key: "listenClick",
                            value: function listenClick(trigger) {
                                var _this2 = this;
                                this.listener = listen_default()(trigger, "click", function(e) {
                                    return _this2.onClick(e);
                                });
                            }
                        },
                        {
                            key: "onClick",
                            value: function onClick(e) {
                                var trigger = e.delegateTarget || e.currentTarget;
                                var action = this.action(trigger) || "copy";
                                var text = actions_default({
                                    action: action,
                                    container: this.container,
                                    target: this.target(trigger),
                                    text: this.text(trigger)
                                }); // Fires an event based on the copy operation result.
                                this.emit(text ? "success" : "error", {
                                    action: action,
                                    text: text,
                                    trigger: trigger,
                                    clearSelection: function clearSelection() {
                                        if (trigger) trigger.focus();
                                        window.getSelection().removeAllRanges();
                                    }
                                });
                            }
                        },
                        {
                            key: "defaultAction",
                            value: function defaultAction(trigger) {
                                return getAttributeValue("action", trigger);
                            }
                        },
                        {
                            key: "defaultTarget",
                            value: function defaultTarget(trigger) {
                                var selector = getAttributeValue("target", trigger);
                                if (selector) return document.querySelector(selector);
                            }
                        },
                        {
                            key: "defaultText",
                            /**
     * Default `text` lookup function.
     * @param {Element} trigger
     */ value: function defaultText(trigger) {
                                return getAttributeValue("text", trigger);
                            }
                        },
                        {
                            key: "destroy",
                            value: function destroy() {
                                this.listener.destroy();
                            }
                        }
                    ], [
                        {
                            key: "copy",
                            value: function copy(target) {
                                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
                                    container: document.body
                                };
                                return actions_copy(target, options);
                            }
                        },
                        {
                            key: "cut",
                            value: function cut(target) {
                                return actions_cut(target);
                            }
                        },
                        {
                            key: "isSupported",
                            value: function isSupported() {
                                var action = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [
                                    "copy",
                                    "cut"
                                ];
                                var actions = typeof action === "string" ? [
                                    action
                                ] : action;
                                var support = !!document.queryCommandSupported;
                                actions.forEach(function(action) {
                                    support = support && !!document.queryCommandSupported(action);
                                });
                                return support;
                            }
                        }
                    ]);
                    return Clipboard;
                }(tiny_emitter_default());
                /* harmony default export */ var clipboard = Clipboard;
            /***/ },
            /***/ 828: /***/ function(module1) {
                var DOCUMENT_NODE_TYPE = 9;
                /**
 * A polyfill for Element.matches()
 */ if (typeof Element !== "undefined" && !Element.prototype.matches) {
                    var proto = Element.prototype;
                    proto.matches = proto.matchesSelector || proto.mozMatchesSelector || proto.msMatchesSelector || proto.oMatchesSelector || proto.webkitMatchesSelector;
                }
                /**
 * Finds the closest parent that matches a selector.
 *
 * @param {Element} element
 * @param {String} selector
 * @return {Function}
 */ function closest(element, selector) {
                    while(element && element.nodeType !== DOCUMENT_NODE_TYPE){
                        if (typeof element.matches === "function" && element.matches(selector)) return element;
                        element = element.parentNode;
                    }
                }
                module1.exports = closest;
            /***/ },
            /***/ 438: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                var closest = __webpack_require__(828);
                /**
 * Delegates event to a selector.
 *
 * @param {Element} element
 * @param {String} selector
 * @param {String} type
 * @param {Function} callback
 * @param {Boolean} useCapture
 * @return {Object}
 */ function _delegate(element, selector, type, callback, useCapture) {
                    var listenerFn = listener.apply(this, arguments);
                    element.addEventListener(type, listenerFn, useCapture);
                    return {
                        destroy: function() {
                            element.removeEventListener(type, listenerFn, useCapture);
                        }
                    };
                }
                /**
 * Delegates event to a selector.
 *
 * @param {Element|String|Array} [elements]
 * @param {String} selector
 * @param {String} type
 * @param {Function} callback
 * @param {Boolean} useCapture
 * @return {Object}
 */ function delegate(elements, selector, type, callback, useCapture) {
                    // Handle the regular Element usage
                    if (typeof elements.addEventListener === "function") return _delegate.apply(null, arguments);
                    // Handle Element-less usage, it defaults to global delegation
                    if (typeof type === "function") // Use `document` as the first parameter, then apply arguments
                    // This is a short way to .unshift `arguments` without running into deoptimizations
                    return _delegate.bind(null, document).apply(null, arguments);
                    // Handle Selector-based usage
                    if (typeof elements === "string") elements = document.querySelectorAll(elements);
                    // Handle Array-like based usage
                    return Array.prototype.map.call(elements, function(element) {
                        return _delegate(element, selector, type, callback, useCapture);
                    });
                }
                /**
 * Finds closest match and invokes callback.
 *
 * @param {Element} element
 * @param {String} selector
 * @param {String} type
 * @param {Function} callback
 * @return {Function}
 */ function listener(element, selector, type, callback) {
                    return function(e) {
                        e.delegateTarget = closest(e.target, selector);
                        if (e.delegateTarget) callback.call(element, e);
                    };
                }
                module1.exports = delegate;
            /***/ },
            /***/ 879: /***/ function(__unused_webpack_module, exports) {
                /**
 * Check if argument is a HTML element.
 *
 * @param {Object} value
 * @return {Boolean}
 */ exports.node = function(value) {
                    return value !== undefined && value instanceof HTMLElement && value.nodeType === 1;
                };
                /**
 * Check if argument is a list of HTML elements.
 *
 * @param {Object} value
 * @return {Boolean}
 */ exports.nodeList = function(value) {
                    var type = Object.prototype.toString.call(value);
                    return value !== undefined && (type === "[object NodeList]" || type === "[object HTMLCollection]") && "length" in value && (value.length === 0 || exports.node(value[0]));
                };
                /**
 * Check if argument is a string.
 *
 * @param {Object} value
 * @return {Boolean}
 */ exports.string = function(value) {
                    return typeof value === "string" || value instanceof String;
                };
                /**
 * Check if argument is a function.
 *
 * @param {Object} value
 * @return {Boolean}
 */ exports.fn = function(value) {
                    var type = Object.prototype.toString.call(value);
                    return type === "[object Function]";
                };
            /***/ },
            /***/ 370: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                var is = __webpack_require__(879);
                var delegate = __webpack_require__(438);
                /**
 * Validates all params and calls the right
 * listener function based on its target type.
 *
 * @param {String|HTMLElement|HTMLCollection|NodeList} target
 * @param {String} type
 * @param {Function} callback
 * @return {Object}
 */ function listen(target, type, callback) {
                    if (!target && !type && !callback) throw new Error("Missing required arguments");
                    if (!is.string(type)) throw new TypeError("Second argument must be a String");
                    if (!is.fn(callback)) throw new TypeError("Third argument must be a Function");
                    if (is.node(target)) return listenNode(target, type, callback);
                    else if (is.nodeList(target)) return listenNodeList(target, type, callback);
                    else if (is.string(target)) return listenSelector(target, type, callback);
                    else throw new TypeError("First argument must be a String, HTMLElement, HTMLCollection, or NodeList");
                }
                /**
 * Adds an event listener to a HTML element
 * and returns a remove listener function.
 *
 * @param {HTMLElement} node
 * @param {String} type
 * @param {Function} callback
 * @return {Object}
 */ function listenNode(node, type, callback) {
                    node.addEventListener(type, callback);
                    return {
                        destroy: function() {
                            node.removeEventListener(type, callback);
                        }
                    };
                }
                /**
 * Add an event listener to a list of HTML elements
 * and returns a remove listener function.
 *
 * @param {NodeList|HTMLCollection} nodeList
 * @param {String} type
 * @param {Function} callback
 * @return {Object}
 */ function listenNodeList(nodeList, type, callback) {
                    Array.prototype.forEach.call(nodeList, function(node) {
                        node.addEventListener(type, callback);
                    });
                    return {
                        destroy: function() {
                            Array.prototype.forEach.call(nodeList, function(node) {
                                node.removeEventListener(type, callback);
                            });
                        }
                    };
                }
                /**
 * Add an event listener to a selector
 * and returns a remove listener function.
 *
 * @param {String} selector
 * @param {String} type
 * @param {Function} callback
 * @return {Object}
 */ function listenSelector(selector, type, callback) {
                    return delegate(document.body, selector, type, callback);
                }
                module1.exports = listen;
            /***/ },
            /***/ 817: /***/ function(module1) {
                function select(element) {
                    var selectedText;
                    if (element.nodeName === "SELECT") {
                        element.focus();
                        selectedText = element.value;
                    } else if (element.nodeName === "INPUT" || element.nodeName === "TEXTAREA") {
                        var isReadOnly = element.hasAttribute("readonly");
                        if (!isReadOnly) element.setAttribute("readonly", "");
                        element.select();
                        element.setSelectionRange(0, element.value.length);
                        if (!isReadOnly) element.removeAttribute("readonly");
                        selectedText = element.value;
                    } else {
                        if (element.hasAttribute("contenteditable")) element.focus();
                        var selection = window.getSelection();
                        var range = document.createRange();
                        range.selectNodeContents(element);
                        selection.removeAllRanges();
                        selection.addRange(range);
                        selectedText = selection.toString();
                    }
                    return selectedText;
                }
                module1.exports = select;
            /***/ },
            /***/ 279: /***/ function(module1) {
                function E() {
                // Keep this empty so it's easier to inherit from
                // (via https://github.com/lipsmack from https://github.com/scottcorgan/tiny-emitter/issues/3)
                }
                E.prototype = {
                    on: function(name, callback, ctx) {
                        var e = this.e || (this.e = {});
                        (e[name] || (e[name] = [])).push({
                            fn: callback,
                            ctx: ctx
                        });
                        return this;
                    },
                    once: function(name, callback, ctx) {
                        var self = this;
                        function listener() {
                            self.off(name, listener);
                            callback.apply(ctx, arguments);
                        }
                        listener._ = callback;
                        return this.on(name, listener, ctx);
                    },
                    emit: function(name) {
                        var data = [].slice.call(arguments, 1);
                        var evtArr = ((this.e || (this.e = {}))[name] || []).slice();
                        var i = 0;
                        var len = evtArr.length;
                        for(i; i < len; i++)evtArr[i].fn.apply(evtArr[i].ctx, data);
                        return this;
                    },
                    off: function(name, callback) {
                        var e = this.e || (this.e = {});
                        var evts = e[name];
                        var liveEvents = [];
                        if (evts && callback) {
                            for(var i = 0, len = evts.length; i < len; i++)if (evts[i].fn !== callback && evts[i].fn._ !== callback) liveEvents.push(evts[i]);
                        }
                        // Remove event from queue to prevent memory leak
                        // Suggested by https://github.com/lazd
                        // Ref: https://github.com/scottcorgan/tiny-emitter/commit/c6ebfaa9bc973b33d110a84a307742b7cf94c953#commitcomment-5024910
                        liveEvents.length ? e[name] = liveEvents : delete e[name];
                        return this;
                    }
                };
                module1.exports = E;
                module1.exports.TinyEmitter = E;
            /***/ }
        };
        /************************************************************************/ /******/ // The module cache
        /******/ var __webpack_module_cache__ = {};
        /******/ /******/ // The require function
        /******/ function __webpack_require__(moduleId) {
            /******/ // Check if module is in cache
            /******/ if (__webpack_module_cache__[moduleId]) /******/ return __webpack_module_cache__[moduleId].exports;
            /******/ // Create a new module (and put it into the cache)
            /******/ var module1 = __webpack_module_cache__[moduleId] = {
                /******/ // no module.id needed
                /******/ // no module.loaded needed
                /******/ exports: {}
            };
            /******/ /******/ // Execute the module function
            /******/ __webpack_modules__[moduleId](module1, module1.exports, __webpack_require__);
            /******/ /******/ // Return the exports of the module
            /******/ return module1.exports;
        /******/ }
        /******/ /************************************************************************/ /******/ /* webpack/runtime/compat get default export */ /******/ !function() {
            /******/ // getDefaultExport function for compatibility with non-harmony modules
            /******/ __webpack_require__.n = function(module1) {
                /******/ var getter = module1 && module1.__esModule ? /******/ function() {
                    return module1["default"];
                } : /******/ function() {
                    return module1;
                };
                /******/ __webpack_require__.d(getter, {
                    a: getter
                });
                /******/ return getter;
            /******/ };
        /******/ }();
        /******/ /******/ /* webpack/runtime/define property getters */ /******/ !function() {
            /******/ // define getter functions for harmony exports
            /******/ __webpack_require__.d = function(exports, definition) {
                /******/ for(var key in definition)/******/ if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) /******/ Object.defineProperty(exports, key, {
                    enumerable: true,
                    get: definition[key]
                });
            /******/ };
        /******/ }();
        /******/ /******/ /* webpack/runtime/hasOwnProperty shorthand */ /******/ !function() {
            /******/ __webpack_require__.o = function(obj, prop) {
                return Object.prototype.hasOwnProperty.call(obj, prop);
            };
        /******/ }();
        /******/ /************************************************************************/ /******/ // module exports must be returned from runtime so entry inlining is disabled
        /******/ // startup
        /******/ // Load entry module and return exports
        /******/ return __webpack_require__(686);
    /******/ }().default;
});


/* Add copy/paste support to all buttons with class .btn-clipboard */ new (0, (/*@__PURE__*/$parcel$interopDefault($e8f91857512aeffe$exports)))(".btn-copypasta");


document.addEventListener("DOMContentLoaded", ()=>{
    const phoneInput = document.getElementById("id_phone");
    const phoneNumberInput = document.getElementById("id_phone_number");
    const userPhoneInput = document.getElementById("id_user-phone");
    const userProfilePhoneInput = document.getElementById("id_profile-0-phone");
    // Function to add event listener to an input field
    const addInputEventListener = (inputField)=>{
        if (inputField) inputField.addEventListener("input", function(input) {
            // Use a regular expression to remove all non-digit characters from the input
            // Then, separate the string into groups for a phone number format
            const match = input.target.value.replace(/\D/g, "").match(/(\d{0,3})(\d{0,3})(\d{0,4})/);
            // Format the value of the input field based on the captured groups
            // If the second group is not present, only use the first group
            // Otherwise, format the string as a phone number "(XXX) XXX-XXXX"
            input.target.value = !match[2] ? match[1] : "(" + match[1] + ") " + match[2] + (match[3] ? "-" + match[3] : "");
        });
    };
    // Add event listener to both input fields
    addInputEventListener(phoneInput);
    addInputEventListener(phoneNumberInput);
    addInputEventListener(userPhoneInput);
    addInputEventListener(userProfilePhoneInput);
});
document.addEventListener("DOMContentLoaded", ()=>{
    const inputField = document.getElementById("id_email_or_phone");
    const phoneFormat = "(###) ###-####";
    const applyPhoneMask = (input)=>{
        const digits = input.replace(/\D/g, "");
        if (digits.length > 10) return input;
        let formatted = "";
        let digitIndex = 0;
        for(let i = 0; i < phoneFormat.length && digitIndex < digits.length; i++)if (phoneFormat[i] === "#") formatted += digits[digitIndex++];
        else formatted += phoneFormat[i];
        return formatted;
    };
    const detectInputTypeAndFormatAccordingly = (input)=>{
        // Check for a clear indication of an email
        if (input.includes("@") || /[a-zA-Z+]/.test(input)) // Likely an email, remove phone formatting
        return input.replace(/[^\d\w@.+]/g, "");
        else // Otherwise, attempt to apply phone mask
        return applyPhoneMask(input);
    };
    if (inputField) inputField.addEventListener("input", (event)=>{
        event.target.value = detectInputTypeAndFormatAccordingly(event.target.value);
    });
});


/* Address Auto-complete functions */ let $df2658283cd482a6$var$autocomplete;
let $df2658283cd482a6$var$ac_form, $df2658283cd482a6$var$address_line1, $df2658283cd482a6$var$unit, $df2658283cd482a6$var$city, $df2658283cd482a6$var$state, $df2658283cd482a6$var$zip_code, $df2658283cd482a6$var$email, $df2658283cd482a6$var$email_or_phone, $df2658283cd482a6$var$cn_name, $df2658283cd482a6$var$cn_passphrase;
let $df2658283cd482a6$var$ac_trans = {
    "street_number": {
        part: "short_name",
        target: "number"
    },
    "route": {
        part: "long_name",
        target: "address"
    },
    "locality": {
        part: "long_name",
        target: "city"
    },
    "sublocality_level_1": {
        part: "long_name",
        target: "sublocality"
    },
    "neighborhood": {
        part: "long_name",
        target: "neighborhood"
    },
    "administrative_area_level_1": {
        part: "long_name",
        target: "state"
    },
    "postal_code": {
        part: "short_name",
        target: "zip_code"
    }
};
function $df2658283cd482a6$var$addressChanged(e) {
    // e.preventDefault();
    const place = $df2658283cd482a6$var$autocomplete.getPlace();
    console.debug("address_components", place.address_components);
    const parts = {};
    for (let address_component of place.address_components){
        const type = address_component.types[0];
        const trans = $df2658283cd482a6$var$ac_trans[type];
        if (trans) parts[trans.target] = address_component[trans.part];
    }
    $df2658283cd482a6$var$updateForm(parts);
}
function $df2658283cd482a6$var$interceptEnterKey(e) {
    if (e.which === 13 || event.keyCode === 13) e.preventDefault();
}
function $df2658283cd482a6$var$updateForm(parts) {
    if (parts.number && parts.address) $df2658283cd482a6$var$address_line1.value = `${parts.number} ${parts.address}`;
    if (parts.city) $df2658283cd482a6$var$city.value = parts.city;
    else if (parts.sublocality) $df2658283cd482a6$var$city.value = parts.sublocality;
    else if (parts.neighborhood) $df2658283cd482a6$var$city.value = parts.neighborhood;
    if (parts.state) {
        for(let i = 0; i < $df2658283cd482a6$var$state.options.length; i++)if ($df2658283cd482a6$var$state.options[i].text === parts.state) {
            $df2658283cd482a6$var$state.selectedIndex = i;
            break;
        }
    }
    if (parts.zip_code) $df2658283cd482a6$var$zip_code.value = parts.zip_code;
    $df2658283cd482a6$var$setFormFocus();
}
function $df2658283cd482a6$var$setFormFocus() {
    if ($df2658283cd482a6$var$address_line1 && !$df2658283cd482a6$var$address_line1.value) $df2658283cd482a6$var$address_line1.focus();
    else if ($df2658283cd482a6$var$unit && !$df2658283cd482a6$var$unit.value) $df2658283cd482a6$var$unit.focus();
    else if ($df2658283cd482a6$var$city && !$df2658283cd482a6$var$city.value) $df2658283cd482a6$var$city.focus();
    else if ($df2658283cd482a6$var$state && !$df2658283cd482a6$var$state.value) $df2658283cd482a6$var$state.focus();
    else if ($df2658283cd482a6$var$zip_code && !$df2658283cd482a6$var$zip_code.value) $df2658283cd482a6$var$zip_code.focus();
    else if ($df2658283cd482a6$var$email && !$df2658283cd482a6$var$email.value) $df2658283cd482a6$var$email.focus();
    else if ($df2658283cd482a6$var$email_or_phone && !$df2658283cd482a6$var$email_or_phone.value) $df2658283cd482a6$var$email_or_phone.focus();
    else if ($df2658283cd482a6$var$cn_name && !$df2658283cd482a6$var$cn_name.value) $df2658283cd482a6$var$cn_name.focus();
    else if ($df2658283cd482a6$var$cn_passphrase && !$df2658283cd482a6$var$cn_passphrase.value) $df2658283cd482a6$var$cn_passphrase.focus();
}
async function $df2658283cd482a6$export$8bec08f96a08c394() {
    const { Autocomplete: Autocomplete } = await google.maps.importLibrary("places");
    // Fetch references to form elements
    $df2658283cd482a6$var$ac_form = document.getElementById("availability_check_form");
    $df2658283cd482a6$var$address_line1 = document.getElementById("id_address_line1");
    $df2658283cd482a6$var$unit = document.getElementById("id_unit");
    $df2658283cd482a6$var$city = document.getElementById("id_city");
    $df2658283cd482a6$var$state = document.getElementById("id_state");
    $df2658283cd482a6$var$zip_code = document.getElementById("id_zip_code");
    $df2658283cd482a6$var$email = document.getElementById("id_email");
    $df2658283cd482a6$var$email_or_phone = document.getElementById("id_email_or_phone");
    $df2658283cd482a6$var$cn_name = document.getElementById("id_customer_network_name");
    $df2658283cd482a6$var$cn_passphrase = document.getElementById("id_customer_network_passphrase");
    if ($df2658283cd482a6$var$address_line1) {
        // Set up the autocomplete
        $df2658283cd482a6$var$autocomplete = new Autocomplete($df2658283cd482a6$var$address_line1, {
            "types": [
                "address"
            ],
            "fields": [
                "address_components"
            ],
            componentRestrictions: {
                country: "us"
            }
        });
        $df2658283cd482a6$var$autocomplete.addListener("place_changed", $df2658283cd482a6$var$addressChanged);
        // Override enter key
        $df2658283cd482a6$var$address_line1.addEventListener("keypress", $df2658283cd482a6$var$interceptEnterKey);
    }
    // Set focus on first empty field
    $df2658283cd482a6$var$setFormFocus();
}
/* Auto-generate Customer Network name suggestion based on selected Unit */ function $df2658283cd482a6$var$generate_customer_network_name_suggestion(postfix) {
    // We have just a few characters max for a CN.name, so let's be a little intelligent about the pre-filled suggestion
    const postfix_length = postfix.length;
    const field_length = 29; // This must match CustomerNetwork.name's max_length in the Django Model
    for (let suggestion of [
        "Andrena Internet Unit ",
        "Andrena Internet: ",
        "Andrena: "
    ]){
        if (postfix_length <= field_length - suggestion.length) return suggestion + postfix;
    }
    return postfix.substring(0, field_length);
}
document.addEventListener("DOMContentLoaded", function() {
    $df2658283cd482a6$export$8bec08f96a08c394();
    const unit_input = document.querySelector("#id_unit, #id_cn-unit, #id_customer_network-unit");
    const cn_input = document.querySelector("#id_customer_network_name, #id_cn-name, #id_customer_network-name");
    if (unit_input && cn_input) {
        let last_value = cn_input.value;
        unit_input.addEventListener("change", function(event1) {
            if (unit_input.value) {
                let selected = unit_input.options[unit_input.selectedIndex];
                if (!cn_input.value || cn_input.value === last_value) {
                    cn_input.value = $df2658283cd482a6$var$generate_customer_network_name_suggestion(selected.text);
                    last_value = cn_input.value;
                }
            } else if (cn_input.value === last_value) {
                cn_input.value = "";
                last_value = cn_input.value;
            }
        });
    }
});


// Support for the Signup Form
//
// This is a single-input address-matching form using Google Places API. It makes a best effort to be additive... in
// other words it should work fine even if the JS or autocomplete fail completely. It submits to the
// CheckAvailabilityView with "prefill" set to true, which will prefill the form with the address instead of actually
// searching for it. User needs to verify the information then click submit.
//
// The main goal of this is to allow a single address field with autocomplete submit to the CheckAvailabilityView form
// so the user can verify that all of the information is correct before submitting.
//
// TODO: replace with Place Autocomplete (new) when it's generally available and not experimental
//       https://developers.google.com/maps/documentation/javascript/place-autocomplete-new
async function $a8ce0145dec4b858$export$31a71afd1aadbc9d() {
    const { Autocomplete: Autocomplete } = await google.maps.importLibrary("places");
    const elements = document.querySelectorAll("[data-signup-form]");
    for (const form of elements){
        const input = form.querySelector("[data-signup-form-input]");
        if (!input) {
            console.error("No input found for Signup Form, create a child <input data-signup-form-input>", form);
            continue;
        }
        const options = {
            types: [
                "address"
            ],
            fields: [
                "address_components"
            ],
            componentRestrictions: {
                country: "us"
            }
        };
        const ac = new Autocomplete(input, options);
        ac.addListener("place_changed", ()=>$a8ce0145dec4b858$var$onPlaceChanged(form, input, ac));
        // Override enter key
        input.addEventListener("keypress", (e)=>$a8ce0145dec4b858$var$interceptEnterKey(e, form, input, ac));
    // console.log('Signup form initialized', form);
    }
}
function $a8ce0145dec4b858$var$interceptEnterKey(e, form, input, ac) {
    if (e.key === "Enter") e.preventDefault();
}
const $a8ce0145dec4b858$var$ac_trans = {
    "street_number": {
        part: "short_name",
        target: "number"
    },
    "route": {
        part: "long_name",
        target: "address"
    },
    "locality": {
        part: "long_name",
        target: "city"
    },
    "sublocality_level_1": {
        part: "long_name",
        target: "sublocality"
    },
    "neighborhood": {
        part: "long_name",
        target: "neighborhood"
    },
    "administrative_area_level_1": {
        part: "long_name",
        target: "state"
    },
    "postal_code": {
        part: "short_name",
        target: "zip_code"
    }
};
function $a8ce0145dec4b858$var$onPlaceChanged(form, input, ac) {
    const place = ac.getPlace();
    console.log("onPlaceChanged", place);
    // Make sure we got a place and it has address_components, otherwise just submit with just the address_line1 field
    if (!place || !place.address_components) {
        console.warn("No place or address_components", place);
        $a8ce0145dec4b858$var$submitForm(form, input, {
            address_line1: input.value
        });
        return;
    }
    // Iterate through all address components and pull out components based on the ac_trans configuration
    const translated = {};
    for (let address_component of place.address_components){
        const type = address_component.types[0];
        const trans = $a8ce0145dec4b858$var$ac_trans[type];
        if (trans) translated[trans.target] = address_component[trans.part];
    }
    // Now look at what translated parts we got and whittle that down to just the address parts we care about
    const parts = {};
    if (translated.number && translated.address) parts.address_line1 = `${translated.number} ${translated.address}`;
    else if (translated.address) parts.address_line1 = translated.address;
    else parts.address_line1 = input.value;
    if (translated.city) parts.city = translated.city;
    else if (translated.sublocality) parts.city = translated.sublocality;
    else if (translated.neighborhood) parts.city = translated.neighborhood;
    if (translated.state) parts.state = translated.state;
    if (translated.zip_code) parts.zip_code = translated.zip_code;
    $a8ce0145dec4b858$var$submitForm(form, input, parts);
}
function $a8ce0145dec4b858$var$submitForm(form, input, parts) {
    // Add all the other parts of the address to the form and submit it.
    if (!parts.address_line1) {
        console.error("No address_line1", parts);
        return;
    }
    if (input) input.value = parts.address_line1;
    for(const key in parts){
        if (key === "address_line1") continue;
        const input = document.createElement("input");
        input.setAttribute("type", "hidden");
        input.setAttribute("name", key);
        input.setAttribute("value", parts[key]);
        form.appendChild(input);
    }
    form.submit();
}
window.addEventListener("DOMContentLoaded", $a8ce0145dec4b858$export$31a71afd1aadbc9d);


async function $e0dea5a3a2016e9d$export$fa81e4b55dbd12df() {
    const { Autocomplete: Autocomplete } = await google.maps.importLibrary("places");
    const locationInput = document.querySelector('[name="location"]');
    if (!locationInput) return;
    const autocomplete = new Autocomplete(locationInput, {
        types: [
            "address"
        ],
        fields: [
            "address_components"
        ],
        componentRestrictions: {
            country: "us"
        }
    });
    autocomplete.addListener("place_changed", ()=>{
        const place = autocomplete.getPlace();
        if (!place || !place.address_components) return;
        // Format the address components into a clean address string
        const addressComponents = place.address_components;
        const streetNumber = addressComponents.find((component)=>component.types.includes("street_number"))?.long_name || "";
        const route = addressComponents.find((component)=>component.types.includes("route"))?.long_name || "";
        const city = addressComponents.find((component)=>component.types.includes("locality"))?.long_name || "";
        const state = addressComponents.find((component)=>component.types.includes("administrative_area_level_1"))?.short_name || "";
        const zipCode = addressComponents.find((component)=>component.types.includes("postal_code"))?.long_name || "";
        // Combine street number and route
        const streetAddress = [
            streetNumber,
            route
        ].filter(Boolean).join(" ");
        // Combine components into a formatted address
        const formattedAddress = [
            streetAddress,
            city,
            state,
            zipCode
        ].filter(Boolean).join(", ");
        // Update the input with the formatted address
        locationInput.value = formattedAddress;
    });
}
// Initialize when the DOM is loaded
document.addEventListener("DOMContentLoaded", $e0dea5a3a2016e9d$export$fa81e4b55dbd12df);


// Helpers for billing pages
var $51005a8fd43152a2$var$V3_URL = "https://js.stripe.com/v3";
var $51005a8fd43152a2$var$V3_URL_REGEX = /^https:\/\/js\.stripe\.com\/v3\/?(\?.*)?$/;
var $51005a8fd43152a2$var$EXISTING_SCRIPT_MESSAGE = "loadStripe.setLoadParameters was called but an existing Stripe.js script already exists in the document; existing script parameters will be used";
var $51005a8fd43152a2$var$findScript = function findScript() {
    var scripts = document.querySelectorAll('script[src^="'.concat($51005a8fd43152a2$var$V3_URL, '"]'));
    for(var i = 0; i < scripts.length; i++){
        var script = scripts[i];
        if (!$51005a8fd43152a2$var$V3_URL_REGEX.test(script.src)) continue;
        return script;
    }
    return null;
};
var $51005a8fd43152a2$var$injectScript = function injectScript(params) {
    var queryString = params && !params.advancedFraudSignals ? "?advancedFraudSignals=false" : "";
    var script = document.createElement("script");
    script.src = "".concat($51005a8fd43152a2$var$V3_URL).concat(queryString);
    var headOrBody = document.head || document.body;
    if (!headOrBody) throw new Error("Expected document.body not to be null. Stripe.js requires a <body> element.");
    headOrBody.appendChild(script);
    return script;
};
var $51005a8fd43152a2$var$registerWrapper = function registerWrapper(stripe, startTime) {
    if (!stripe || !stripe._registerWrapper) return;
    stripe._registerWrapper({
        name: "stripe-js",
        version: "1.54.1",
        startTime: startTime
    });
};
var $51005a8fd43152a2$var$stripePromise = null;
var $51005a8fd43152a2$var$loadScript = function loadScript(params) {
    // Ensure that we only attempt to load Stripe.js at most once
    if ($51005a8fd43152a2$var$stripePromise !== null) return $51005a8fd43152a2$var$stripePromise;
    $51005a8fd43152a2$var$stripePromise = new Promise(function(resolve, reject) {
        if (typeof window === "undefined" || typeof document === "undefined") {
            // Resolve to null when imported server side. This makes the module
            // safe to import in an isomorphic code base.
            resolve(null);
            return;
        }
        if (window.Stripe && params) console.warn($51005a8fd43152a2$var$EXISTING_SCRIPT_MESSAGE);
        if (window.Stripe) {
            resolve(window.Stripe);
            return;
        }
        try {
            var script = $51005a8fd43152a2$var$findScript();
            if (script && params) console.warn($51005a8fd43152a2$var$EXISTING_SCRIPT_MESSAGE);
            else if (!script) script = $51005a8fd43152a2$var$injectScript(params);
            script.addEventListener("load", function() {
                if (window.Stripe) resolve(window.Stripe);
                else reject(new Error("Stripe.js not available"));
            });
            script.addEventListener("error", function() {
                reject(new Error("Failed to load Stripe.js"));
            });
        } catch (error) {
            reject(error);
            return;
        }
    });
    return $51005a8fd43152a2$var$stripePromise;
};
var $51005a8fd43152a2$var$initStripe = function initStripe(maybeStripe, args, startTime) {
    if (maybeStripe === null) return null;
    var stripe = maybeStripe.apply(undefined, args);
    $51005a8fd43152a2$var$registerWrapper(stripe, startTime);
    return stripe;
}; // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
// own script injection.
var $51005a8fd43152a2$var$stripePromise$1 = Promise.resolve().then(function() {
    return $51005a8fd43152a2$var$loadScript(null);
});
var $51005a8fd43152a2$var$loadCalled = false;
$51005a8fd43152a2$var$stripePromise$1["catch"](function(err) {
    if (!$51005a8fd43152a2$var$loadCalled) console.warn(err);
});
var $51005a8fd43152a2$export$de80f7562c3fd6b1 = function loadStripe() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    $51005a8fd43152a2$var$loadCalled = true;
    var startTime = Date.now();
    return $51005a8fd43152a2$var$stripePromise$1.then(function(maybeStripe) {
        return $51005a8fd43152a2$var$initStripe(maybeStripe, args, startTime);
    });
};


function $782c4cc69839f243$var$disable_billing_buttons(status = true) {
    const buttons = document.querySelectorAll(".js-billing-button");
    for (const button of buttons)button.disabled = status;
}
async function $782c4cc69839f243$export$783a4c138d7d6f65() {
    const stripe = await (0, $51005a8fd43152a2$export$de80f7562c3fd6b1)(STRIPE_PUBLIC_KEY);
    const elements = stripe.elements();
    const style = {
        base: {
            fontSize: "1.1em",
            color: "#495057"
        }
    };
    const card = elements.create("card", {
        style: style
    });
    card.mount("#card-element");
    // Get elements
    const form = document.getElementById("payment-form");
    const cardErrors = document.getElementById("card-errors");
    // Communicate errors
    card.addEventListener("change", function(e) {
        if (e.error) cardErrors.textContent = e.error.message;
        else cardErrors.textContent = "";
    });
    form.addEventListener("submit", async function(e) {
        e.preventDefault();
        $782c4cc69839f243$var$disable_billing_buttons(true);
        const name = document.getElementById("id_card_name").value;
        const cardData = {
            name: name
        };
        try {
            const result = await stripe.createToken(card, cardData);
            if (result.error) {
                cardErrors.textContent = result.error.message;
                $782c4cc69839f243$var$disable_billing_buttons(false);
            } else {
                // Insert the token ID into the form so it gets submitted to the server
                const hiddenInput = document.createElement("input");
                hiddenInput.setAttribute("type", "hidden");
                hiddenInput.setAttribute("name", "stripe_token");
                hiddenInput.setAttribute("value", result.token.id);
                form.appendChild(hiddenInput);
                // Submit the form
                form.submit();
            }
        } catch (error) {
            console.error("Error creating token:", error);
            cardErrors.textContent = "An error occurred while processing your payment.";
            $782c4cc69839f243$var$disable_billing_buttons(false);
        }
    });
    // Handle the billing address same checkbox
    const same_element = document.querySelector("#id_billing_address_same, #id_pm-billing_address_same");
    const billing_address_form = document.getElementById("billing-address-form");
    function update_billing_address_fields_required(value) {
        for (let prefix of [
            "",
            "pm-"
        ])for (let selector of [
            "address_line1",
            "city",
            "state",
            "zip_code"
        ]){
            const fullName = `id_${prefix}${selector}`;
            const element = document.getElementById(fullName);
            if (element) element.required = value;
        }
    }
    function update_billing_address_form() {
        if (same_element.checked) {
            billing_address_form.classList.remove("show");
            billing_address_form.classList.add("hide");
            update_billing_address_fields_required(false);
        } else {
            billing_address_form.classList.remove("hide");
            billing_address_form.classList.add("show");
            update_billing_address_fields_required(true);
        }
    }
    if (same_element) {
        update_billing_address_form();
        same_element.addEventListener("change", update_billing_address_form);
    } else billing_address_form.classList.remove("collapse");
}
function $782c4cc69839f243$export$50eacbde0f9f8ee(id) {
    // Check the Billing API periodically to see if we're still waiting for Stripe, reloads the page once we're not.
    console.debug("Waiting for Stripe", id);
    let invocations = 0;
    let still_waiting = true;
    let url;
    if (id) url = API_URLS["billing-api:waitforstripe_by_id"].replace("__ID__", id);
    else url = API_URLS["billing-api:waitforstripe"];
    function checkStripe() {
        invocations++;
        console.debug(`Calling WaitForStripe API. Invocations: ${invocations}`);
        fetch(url).then((response)=>response.json()).then((data)=>{
            if (data.waiting_for_stripe === false) {
                window.location.reload();
                still_waiting = false;
            }
        }).catch((error)=>{
            console.error("Got an error checking stripe status: " + error);
        }).finally(()=>{
            if (still_waiting) {
                // Backoff .25 seconds each iteration, maximum of 5 second timeout
                const timeout = Math.min(5000, 1000 + 1000 * ((invocations - 1) / 4));
                console.debug(`Waiting ${timeout} milliseconds`);
                setTimeout(checkStripe, timeout);
            }
        });
    }
    checkStripe();
}


function $ab1e1adbb66267e3$var$servicePrice(price) {
    const servicePriceElement = document.querySelector("#service_price");
    if (price === "0.00") {
        servicePriceElement.classList.add("bbl-price-notice");
        return "Contact Property Management";
    }
    servicePriceElement.classList.remove("bbl-price-notice");
    return `$ ${price}`;
}
function $ab1e1adbb66267e3$var$updateBroadbandLabel(service, broadbandLabel) {
    const serviceBillingPeriodType = service.billing_period_type.charAt(0).toUpperCase() + service.billing_period_type.slice(1);
    if (broadbandLabel.hidden) broadbandLabel.hidden = false;
    document.querySelector("#service_name").textContent = service.name;
    document.querySelectorAll("#service_billing_period_type").forEach((el)=>el.textContent = serviceBillingPeriodType);
    document.querySelector("#service_price").textContent = $ab1e1adbb66267e3$var$servicePrice(service.price);
    document.querySelectorAll("#service_speed").forEach((el)=>el.textContent = `${service.max_bandwidth} Mbps`);
    document.querySelector("#service_id").textContent = service.fcc_id;
}
async function $ab1e1adbb66267e3$export$35fe01753b1ef231(selectedService, availableServices, eventName) {
    const broadbandLabel = document.querySelector("#broadband-label");
    const handleEvent = (e)=>{
        const serviceId = e.target.value;
        const service = availableServices.find((s)=>s.id == serviceId);
        if (service) $ab1e1adbb66267e3$var$updateBroadbandLabel(service, broadbandLabel);
        else broadbandLabel.hidden = true;
    };
    if (eventName === "click") selectedService.addEventListener("click", (e)=>{
        if (e.target.tagName === "INPUT") handleEvent(e);
    });
    else if (eventName === "change") selectedService.addEventListener("change", handleEvent);
}
async function $ab1e1adbb66267e3$export$f09396fb34f76f4e(availableServices) {
    const selectedService = document.querySelector("#id_selected_service");
    const broadbandLabel = document.querySelector("#broadband-label");
    const updateLabel = (serviceId)=>{
        const service = availableServices.find((s)=>s.id == serviceId);
        if (service) $ab1e1adbb66267e3$var$updateBroadbandLabel(service, broadbandLabel);
        else broadbandLabel.hidden = true;
    };
    updateLabel(selectedService.value);
    selectedService.addEventListener("change", (e)=>{
        updateLabel(e.target.value);
    });
}


async function $a916dea359165564$export$2ca99734f105e22a(selectedService, availableServices) {
    selectedService.addEventListener("click", (e)=>{
        if (e.target.tagName === "INPUT") {
            var serviceId = e.target.value;
            var service = availableServices.find((s)=>s.id == serviceId);
            if (![
                "every 3 months",
                "every 6 months"
            ].includes(service.billing_period_type)) document.querySelectorAll("#service_billing_period_type_display").forEach((el)=>el.textContent = `${service.billing_period_type_display}-to-${service.billing_period_type_display}`);
            else document.querySelectorAll("#service_billing_period_type_display").forEach((el)=>el.textContent = service.billing_period_type);
        }
    });
}



var $cNQM9 = parcelRequire("cNQM9");

// DOM Elements
const $93a41231d14aa5ad$var$elements = {
    cancelReasonSelect: document.querySelector("#id_cancel_reason, #id_cancel-cancel_reason"),
    cancelExtraInput: document.querySelector("#id_cancel_extra, #id_cancel-cancel_extra"),
    cancelWhenSelect: document.querySelector("#id_cancel_when, #id_cancel-cancel_when"),
    cancelDateInput: document.querySelector("#id_cancel_date, #id_cancel-cancel_date"),
    cancelDateWrapper: document.querySelector("#cancel_date, #cancel_cancel-date"),
    cancelSummary: document.querySelector("#cancel_summary, #cancel_cancel-summary"),
    subReasonSelect: document.querySelector("#id_cancel_sub_reason, #id_cancel-cancel_sub_reason"),
    subReasonLabel: document.querySelector('label[for="id_cancel_sub_reason"], label[for="id_cancel-cancel_sub_reason"]'),
    subReasonContainer: document.querySelector("#id_cancel_sub_reason, #id_cancel-cancel_sub_reason") ? document.querySelector("#id_cancel_sub_reason, #id_cancel-cancel_sub_reason").closest(".form-group") : null,
    subReasonOptions: document.querySelectorAll("#id_cancel_sub_reason option, #id_cancel-cancel_sub_reason option")
};
const $93a41231d14aa5ad$export$39c619ebf007cb1c = (validSubReasons)=>{
    const updateSubReasonOptions = ()=>{
        if (!$93a41231d14aa5ad$var$elements.cancelReasonSelect || !$93a41231d14aa5ad$var$elements.subReasonSelect) return;
        const selected = $93a41231d14aa5ad$var$elements.cancelReasonSelect.value;
        const subReasons = validSubReasons[selected] || [];
        const isValidReason = subReasons.length > 0;
        if ($93a41231d14aa5ad$var$elements.subReasonContainer) $93a41231d14aa5ad$var$elements.subReasonContainer.classList.toggle("d-none", !isValidReason);
        if ($93a41231d14aa5ad$var$elements.subReasonSelect) $93a41231d14aa5ad$var$elements.subReasonSelect.required = isValidReason;
        if ($93a41231d14aa5ad$var$elements.subReasonLabel) $93a41231d14aa5ad$var$elements.subReasonLabel.textContent = ({
            "performance": "Performance issue",
            "missing": "Missing services",
            "price": "Reason"
        })[selected] || "Sub-reason (optional)";
        $93a41231d14aa5ad$var$elements.subReasonOptions.forEach((option)=>{
            option.hidden = !subReasons.includes(option.value);
        });
    };
    const updateLabel = (isOther, reason)=>{
        if (!$93a41231d14aa5ad$var$elements.cancelExtraInput) return;
        const label = $93a41231d14aa5ad$var$elements.cancelExtraInput.parentElement?.querySelector('[for="id_cancel-cancel_extra"]');
        if (!label) return;
        const smallTag = label.querySelector(".text-muted");
        label.textContent = isOther ? ({
            "other": "Please share more information",
            "performance": "What performance issue did you experience?",
            "missing": "What services were missing?",
            "price": "Please share more information"
        })[reason] || "Please share more information" : "Additional information";
        if (smallTag) label.appendChild(smallTag);
        const helpText = $93a41231d14aa5ad$var$elements.cancelExtraInput.parentElement?.querySelector(".text-muted");
        if (helpText) helpText.hidden = isOther;
    };
    const updateAdditionalInfoRequirement = ()=>{
        if (!$93a41231d14aa5ad$var$elements.cancelExtraInput || !$93a41231d14aa5ad$var$elements.cancelReasonSelect || !$93a41231d14aa5ad$var$elements.subReasonSelect) return;
        const isReasonOther = $93a41231d14aa5ad$var$elements.cancelReasonSelect.value === "other";
        const isSubReasonOther = $93a41231d14aa5ad$var$elements.subReasonSelect.value === "other";
        $93a41231d14aa5ad$var$elements.cancelExtraInput.required = isReasonOther || isSubReasonOther;
    };
    const handleCancelReasonChange = ()=>{
        updateSubReasonOptions();
        if (!$93a41231d14aa5ad$var$elements.cancelReasonSelect) return;
        const isOther = $93a41231d14aa5ad$var$elements.cancelReasonSelect.value === "other";
        updateLabel(isOther, $93a41231d14aa5ad$var$elements.cancelReasonSelect.value);
        updateAdditionalInfoRequirement();
    };
    const handleSubReasonChange = ()=>{
        if (!$93a41231d14aa5ad$var$elements.subReasonSelect || !$93a41231d14aa5ad$var$elements.cancelReasonSelect) return;
        const isOther = $93a41231d14aa5ad$var$elements.subReasonSelect.value === "other";
        updateLabel(isOther, $93a41231d14aa5ad$var$elements.cancelReasonSelect.value);
        updateAdditionalInfoRequirement();
    };
    if ($93a41231d14aa5ad$var$elements.cancelReasonSelect) $93a41231d14aa5ad$var$elements.cancelReasonSelect.addEventListener("change", ()=>{
        // Reset all fields to default values
        if ($93a41231d14aa5ad$var$elements.subReasonSelect) $93a41231d14aa5ad$var$elements.subReasonSelect.value = "";
        if ($93a41231d14aa5ad$var$elements.cancelExtraInput) $93a41231d14aa5ad$var$elements.cancelExtraInput.value = "";
        if ($93a41231d14aa5ad$var$elements.cancelWhenSelect) $93a41231d14aa5ad$var$elements.cancelWhenSelect.value = "";
        if ($93a41231d14aa5ad$var$elements.cancelDateInput) $93a41231d14aa5ad$var$elements.cancelDateInput.value = "";
        if ($93a41231d14aa5ad$var$elements.cancelSummary) $93a41231d14aa5ad$var$elements.cancelSummary.innerHTML = "&nbsp;";
        if ($93a41231d14aa5ad$var$elements.cancelDateWrapper) {
            $93a41231d14aa5ad$var$elements.cancelDateWrapper.classList.remove("show");
            $93a41231d14aa5ad$var$elements.cancelDateWrapper.classList.add("hide");
        }
        handleCancelReasonChange();
    });
    if ($93a41231d14aa5ad$var$elements.subReasonSelect) $93a41231d14aa5ad$var$elements.subReasonSelect.addEventListener("change", handleSubReasonChange);
    handleCancelReasonChange();
};
// Force Choose When Moving
const $93a41231d14aa5ad$var$forceChooseWhenMoving = ()=>{
    const isOther = $93a41231d14aa5ad$var$elements.cancelReasonSelect.value === "other";
    $93a41231d14aa5ad$var$elements.cancelWhenSelect.querySelectorAll("option").forEach((option)=>{
        option.disabled = !$93a41231d14aa5ad$var$elements.cancelReasonSelect.value;
    });
    if ($93a41231d14aa5ad$var$elements.cancelExtraInput.parentElement.querySelector(".text-muted")) $93a41231d14aa5ad$var$elements.cancelExtraInput.parentElement.querySelector(".text-muted").hidden = isOther;
    $93a41231d14aa5ad$var$elements.cancelExtraInput.required = isOther;
};
// Toggle Cancel Date Chooser Visibility
const $93a41231d14aa5ad$var$toggleCancelDateChooserVisibility = ()=>{
    const isChoose = $93a41231d14aa5ad$var$elements.cancelWhenSelect.value === "choose";
    $93a41231d14aa5ad$var$elements.cancelDateWrapper.classList.toggle("show", isChoose);
    $93a41231d14aa5ad$var$elements.cancelDateWrapper.classList.toggle("hide", !isChoose);
    $93a41231d14aa5ad$var$elements.cancelDateInput.parentElement.querySelector(".text-muted").hidden = isChoose;
};
// Update Cancel Summary
const $93a41231d14aa5ad$var$updateCancelSummary = ()=>{
    let summary = "";
    if ($93a41231d14aa5ad$var$elements.cancelWhenSelect.value === "now") summary = "Cancellation will take effect <b>immediately.</b> This cannot be undone.";
    else if ($93a41231d14aa5ad$var$elements.cancelWhenSelect.value === "choose" && $93a41231d14aa5ad$var$elements.cancelDateInput.value) {
        const date = (0, (/*@__PURE__*/$parcel$interopDefault($cNQM9)))($93a41231d14aa5ad$var$elements.cancelDateInput.value).format("MMM Do, YYYY");
        summary = `Cancellation will take effect the morning of <b>${date}</b>`;
    } else if ($93a41231d14aa5ad$var$elements.cancelWhenSelect.value === "end_of_period") {
        const periodEndDate = $93a41231d14aa5ad$var$elements.cancelSummary.dataset.billingPeriodEnd;
        if (periodEndDate) summary = `Cancellation will take effect at the end of the billing period which is <b>${periodEndDate}</b>`;
    }
    $93a41231d14aa5ad$var$elements.cancelSummary.innerHTML = summary;
};
// Event Listeners
if ($93a41231d14aa5ad$var$elements.cancelReasonSelect && $93a41231d14aa5ad$var$elements.cancelWhenSelect) {
    $93a41231d14aa5ad$var$elements.cancelReasonSelect.addEventListener("change", $93a41231d14aa5ad$var$forceChooseWhenMoving);
    document.addEventListener("DOMContentLoaded", $93a41231d14aa5ad$var$forceChooseWhenMoving);
}
if ($93a41231d14aa5ad$var$elements.cancelWhenSelect && $93a41231d14aa5ad$var$elements.cancelDateInput && $93a41231d14aa5ad$var$elements.cancelDateWrapper) {
    $93a41231d14aa5ad$var$elements.cancelWhenSelect.addEventListener("change", $93a41231d14aa5ad$var$toggleCancelDateChooserVisibility);
    document.addEventListener("DOMContentLoaded", $93a41231d14aa5ad$var$toggleCancelDateChooserVisibility);
}
if ($93a41231d14aa5ad$var$elements.cancelDateInput) {
    const today = (0, (/*@__PURE__*/$parcel$interopDefault($cNQM9))).utc().hour(0).minute(0).second(0);
    const min = $93a41231d14aa5ad$var$elements.cancelDateInput.min || today.add(1, "days").format("YYYY-MM-DD");
    const max = $93a41231d14aa5ad$var$elements.cancelDateInput.max || today.add(120, "days").format("YYYY-MM-DD");
    (0, $c3496a40a394bf09$exports.default)($93a41231d14aa5ad$var$elements.cancelDateInput, {
        dateFormat: "Y-m-d",
        altInput: true,
        altFormat: "F j, Y",
        minDate: min,
        maxDate: max,
        disableMobile: true
    });
}
if ($93a41231d14aa5ad$var$elements.cancelReasonSelect && $93a41231d14aa5ad$var$elements.cancelWhenSelect && $93a41231d14aa5ad$var$elements.cancelDateInput && $93a41231d14aa5ad$var$elements.cancelSummary) {
    $93a41231d14aa5ad$var$elements.cancelReasonSelect.addEventListener("change", $93a41231d14aa5ad$var$updateCancelSummary);
    $93a41231d14aa5ad$var$elements.cancelWhenSelect.addEventListener("change", $93a41231d14aa5ad$var$updateCancelSummary);
    $93a41231d14aa5ad$var$elements.cancelDateInput.addEventListener("change", $93a41231d14aa5ad$var$updateCancelSummary);
}



var $cNQM9 = parcelRequire("cNQM9");

const $e6c08e94f0416d84$export$a3e811935c8264d9 = ()=>{
    const pauseUntilInput = document.getElementById("id_pause_until");
    const today = (0, (/*@__PURE__*/$parcel$interopDefault($cNQM9))).utc().hour(0).minute(0).second(0);
    const min = pauseUntilInput.min || today.add(1, "days").format("YYYY-MM-DD");
    const max = pauseUntilInput.max || today.add(90, "days").format("YYYY-MM-DD");
    (0, $c3496a40a394bf09$exports.default)(pauseUntilInput, {
        dateFormat: "Y-m-d",
        altInput: true,
        altFormat: "F j, Y",
        minDate: min,
        maxDate: max,
        disableMobile: true
    });
};
const $e6c08e94f0416d84$export$e9cfba693e0df518 = ()=>{
    const pauseReasonSelect = document.getElementById("id_pause_reason");
    const additionalInfoInput = document.getElementById("id_pause_extra");
    pauseReasonSelect.addEventListener("change", (event)=>{
        const isOther = event.target.value === "other";
        additionalInfoInput.required = isOther;
        additionalInfoInput.parentElement.querySelector(".text-muted").hidden = isOther;
        console.log(isOther);
    });
};


function $b3b1cd870b856442$var$filterServices(availableServices, building_id, unit_id) {
    let filteredServices = [];
    if (unit_id) filteredServices = availableServices.filter((service)=>service.unit_id === unit_id);
    if (filteredServices.length === 0 && building_id) filteredServices = availableServices.filter((service)=>service.building_id === building_id);
    if (filteredServices.length === 0) filteredServices = availableServices.filter((service)=>!service.building_id && !service.unit_id);
    return filteredServices;
}
function $b3b1cd870b856442$export$62ae45b00ba5483a(availableServices, building_id, unit_id) {
    const filteredServices = $b3b1cd870b856442$var$filterServices(availableServices, building_id, unit_id);
    return filteredServices.map((service, index)=>`
            <div class="service-box-container service-box-container-hover relative" data-service-box="">
                <input type="radio" name="selected_service" value="${service.id}" required="" id="id_selected_service_${index}">
                <div class="background-container"></div>
                <label for="id_selected_service_${index}" class="service-box-label">
                    <div class="service-box__upto">
                        <span>Up to</span>
                    </div>
                    <div class="service-box-price">
                        <div>
                            <span>${service.max_bandwidth}</span>
                            <span class="service-box-bandwidth-unit">Mbps</span>
                        </div>
                        <div class="service-box-price__container">
                            <span class="service-box-price-currency">$</span>
                            <span>${parseInt(service.price)}</span>
                            <small>/ ${service.billing_period_type_display.charAt(0).toUpperCase() + service.billing_period_type_display.slice(1)}</small>
                        </div>
                    </div>
                </label>
            </div>
        `).join("");
}
function $b3b1cd870b856442$export$ed5ce65c44c3644e(availableServices, building_id, unit_id) {
    const filteredServices = $b3b1cd870b856442$var$filterServices(availableServices, building_id, unit_id);
    const options = filteredServices.map((service, index)=>`
            <option value="${service.id}">$${parseInt(service.price)} per ${service.billing_period_type_display}, up to ${service.max_bandwidth} Mbps</option>
        `).join("");
    return `<option value selected>---------</option>${options}`;
}
function $b3b1cd870b856442$export$596d78d6dc977c6f(availableUnits, building_id) {
    const options = availableUnits.filter((unit)=>unit.building_id === building_id).map((unit)=>`
            <option value="${unit.id}">${unit.name}</option>
        `).join("");
    return `<option value selected>---------</option>${options}`;
}


window.waitForStripe = (0, $782c4cc69839f243$export$50eacbde0f9f8ee);
window.initBilling = (0, $782c4cc69839f243$export$783a4c138d7d6f65);
window.initBroadbandLabel = (0, $ab1e1adbb66267e3$export$f09396fb34f76f4e);
window.displayBroadbandLabel = (0, $ab1e1adbb66267e3$export$35fe01753b1ef231);
window.updateServiceSummary = (0, $a916dea359165564$export$2ca99734f105e22a);
window.initializeSubReasonOptions = (0, $93a41231d14aa5ad$export$39c619ebf007cb1c);
window.formatPauseUntilInput = (0, $e6c08e94f0416d84$export$a3e811935c8264d9);
window.handlePauseReasonChange = (0, $e6c08e94f0416d84$export$e9cfba693e0df518);
window.generateServiceOptions = (0, $b3b1cd870b856442$export$62ae45b00ba5483a);
window.generateServiceSelectOptions = (0, $b3b1cd870b856442$export$ed5ce65c44c3644e);
window.generateUnitSelectOptions = (0, $b3b1cd870b856442$export$596d78d6dc977c6f);

})();
//# sourceMappingURL=base.js.map
